"use strict";

//***Modal Dialog for Application Updates - non angular **/
var modalUpdates;
var isDownloanding = false;
var isCheckForUpdate = false;
(function () {
  if ('applicationCache' in window && !('serviceWorker' in navigator)) {
    modalUpdates = $('.modal-updating').modal({
      backdrop: 'static',
      keyboard: true,
      show: false
    });
    modalUpdates.show = function () {
      modalUpdates.removeClass('update-success');
      modalUpdates.find('.progress').show();
      modalUpdates.find('.message-success').hide();
      modalUpdates.find('.message-danger').hide();
      modalUpdates.find('.message-no-update').hide();
      modalUpdates.find('.btn-update-retry').hide();
      modalUpdates.find('.btn-update-close').hide();
      modalUpdates.find('.btn-update-ok').hide();
      modalUpdates.modal('show');
    };
    modalUpdates.hide = function () {
      modalUpdates.modal('hide');
    };
    modalUpdates.success = function () {
      modalUpdates.find('.progress').hide();
      modalUpdates.find('.message-success').show();
      modalUpdates.find('.message-no-update').hide();
      modalUpdates.find('.message-danger').hide();
      modalUpdates.find('.btn-update-close').hide();
      modalUpdates.find('.btn-update-ok').show();
      modalUpdates.addClass('update-success');
      setTimeout(function () {
        modalUpdates.modal('hide');
      }, 2000);
    };
    modalUpdates.noUpdate = function () {
      modalUpdates.show();
      modalUpdates.find('.progress').hide();
      modalUpdates.find('.message-success').hide();
      modalUpdates.find('.message-danger').hide();
      modalUpdates.find('.message-no-update').show();
      modalUpdates.find('.btn-update-retry').hide();
      modalUpdates.find('.btn-update-close').hide();
      modalUpdates.find('.btn-update-ok').show();
      isCheckForUpdate = false;
    };
    modalUpdates.failure = function (errorMessage) {
      modalUpdates.show();
      modalUpdates.find('.progress').hide();
      modalUpdates.find('.message-success').hide();
      modalUpdates.find('.message-danger').show();
      modalUpdates.find('.message-no-update').hide();
      modalUpdates.find('.btn-update-close').show();
      modalUpdates.find('.btn-update-ok').hide();
      if (errorMessage && errorMessage != '') {
        modalUpdates.find('.update-error').text(errorMessage);
      } else {
        modalUpdates.find('.update-error').text('');
      }
    };
    modalUpdates.on('hidden.bs.modal', function (e) {
      var b = modalUpdates.hasClass('update-success');
      if (b) location.reload(true);
    });
  }
}).call(void 0);

//** ApplicationCache Events & Actions **//
(function () {
  ////////////////////////////////////////////////////index scripts (cache)////////////////////////////////////////////////////
  if ('applicationCache' in window && !('serviceWorker' in navigator)) {
    // Convenience array of status values

    var cacheHandler = function cacheHandler() {};
    cacheHandler.cacheStatusValues = [];
    cacheHandler.cacheStatusValues[0] = 'uncached';
    cacheHandler.cacheStatusValues[1] = 'idle';
    cacheHandler.cacheStatusValues[2] = 'checking';
    cacheHandler.cacheStatusValues[3] = 'downloading';
    cacheHandler.cacheStatusValues[4] = 'updateready';
    cacheHandler.cacheStatusValues[5] = 'obsolete';
    cacheHandler.onDownloading = function (e) {
      isDownloanding = true;
      modalUpdates.show();
      cacheHandler.logEvent(e);
    };
    cacheHandler.onCached = function (e) {
      modalUpdates.hide();
      cacheHandler.logEvent(e);
    };
    cacheHandler.onChecking = function (e) {
      //ShowWaitDialog();
      cacheHandler.logEvent(e);
    };
    cacheHandler.onProgress = function (e) {};
    cacheHandler.onObsolete = function (e) {};
    cacheHandler.onError = function (e) {
      // 
      var message = "Could not download application updates due to an unexpected error.\n" + "make sure that cache.manifest is being served with MIME type: text/cache-manifest";
      //actual error message if any
      if (e.message) message = e.message;
      console.error(message);
      //hide update dialog if visible
      if (isDownloanding) {
        modalUpdates.failure(message);
      } else {
        modalUpdates.hide();
      }
    };
    cacheHandler.onNoUpdate = function (e) {
      if (isCheckForUpdate) {
        modalUpdates.noUpdate();
      } else {
        modalUpdates.hide();
      }
      isDownloanding = false;
      cacheHandler.logEvent(e);
    };
    cacheHandler.onUpdateReady = function (e) {
      try {
        cache.swapCache();
      } catch (e) {}
      cacheHandler.logEvent(e);
      isDownloanding = false;
      modalUpdates.success();
      //location.reload(true);
    };
    // Log every event to the console
    cacheHandler.logEvent = function (e) {
      /*
      var status, type, message; //online, 
      //online = (navigator.online) ? 'yes' : 'no';
      status = cacheHandler.cacheStatusValues[cache.status];
      type = e.type;
      message = '';//'online: ' + online;
      message += 'CACHE: event: ' + type;
      message += ', status: ' + status;
      if (type == 'error' && navigator.online) {
      	message += ' (prolly a syntax error in manifest)';
      }
      console.log(message);
      */
    };
    var cache = window.applicationCache;
    cache.addEventListener('cached', cacheHandler.onCached, false);
    cache.addEventListener('checking', cacheHandler.onChecking, false);
    cache.addEventListener('downloading', cacheHandler.onDownloading, false);
    cache.addEventListener('error', cacheHandler.onError, false);
    //cache.addEventListener('error', cacheHandler.logEvent, false);
    cache.addEventListener('noupdate', cacheHandler.onNoUpdate, false);
    cache.addEventListener('obsolete', cacheHandler.onObsolete, false);
    cache.addEventListener('progress', cacheHandler.onProgress, false);
    cache.addEventListener('updateready', cacheHandler.onUpdateReady, false);
  }
  $('#update-error-btn').click(function () {
    var alert = $('.hidden-update-error');
    if (alert.hasClass('hidden')) {
      alert.removeClass('hidden');
      $('#update-error-btn').text("show less");
    } else {
      alert.addClass('hidden');
      $('#update-error-btn').text("show more");
    }
  });
  $('body').on('click', '#update-check-btn', function () {
    isCheckForUpdate = true;
    var url = location.origin;
    $.ajax({
      type: "GET",
      url: url,
      cache: false,
      success: function success() {
        //get cache
        var cache = window.applicationCache;
        // Update the user's cache
        if (cache) {
          cache.update();
        }
      } /*,
        error: function(){ 
           console.log('error');
        }*/
    });
  });
}).call(void 0);
"use strict";

$(function () {
  angular.bootstrap(document, ['a3.pilot.reports']);
});
var a3_pilot_reports = angular.module('a3.pilot.reports', [
//angular modules
'ngSanitize', 'ngRoute', 'ngTouch',
//3rd party modules
'angular-md5', 'LocalStorageModule', 'ui.bootstrap', 'nya.bootstrap.select', 'ui.toggle', 'ui.sortable',
//Our modules
'LocalStorageMD5Module', 'MyDirectives']);
"use strict";

(function () {
  'use strict';

  // setup routing
  a3_pilot_reports.config(routeConfig);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name routeConfig
  * @description 
  *   Route configuration
  * @ngInject
  */
  function routeConfig($routeProvider) {
    $routeProvider.when('/', {
      controller: 'CalendarCtrl',
      templateUrl: './views/calendar.html'
    }).when('/login', {
      controller: 'LoginCtrl',
      templateUrl: './views/login.html'
    }).when('/flightinfo/:flightId', {
      controller: 'FlightInfoCtrl',
      templateUrl: 'views/flight-info.html',
      reloadOnSearch: false
    }).when('/selectedflightinfo/:flightId/:flightDate/:flightNo/:departure', {
      controller: 'SelectedFlightCtrl',
      templateUrl: 'views/SearchFlights/selected-flight-info.html',
      reloadOnSearch: false
    }).when('/report/:reportId', {
      controller: 'ReportCtrl',
      templateUrl: './views/report.html'
    }).when('/report/:reportId/:flightId', {
      controller: 'ReportCtrl',
      templateUrl: './views/report.html'
    }).when('/pdf/:reportId', {
      controller: 'ReportCtrl',
      templateUrl: './views/report.html'
    }).when('/pax/:flightId', {
      controller: 'PaxCtrl',
      templateUrl: 'views/pax.html'
    }).when('/addflight', {
      controller: 'AddFlightCtrl',
      templateUrl: './views/addflight.html'
    }).when('/reset', {
      controller: 'ResetDeviceCtrl',
      templateUrl: './views/reset.html'
    }).when('/messages/:flightId', {
      controller: 'MessageCtrl',
      templateUrl: 'views/messages.html'
    }).when('/messages/', {
      controller: 'MessageCtrl',
      templateUrl: 'views/messages.html'
    }).when('/debug', {
      controller: 'DebugCtrl',
      templateUrl: './views/debug.html'
    }).when('/rosterRequests', {
      controller: 'RequestsCtrl',
      templateUrl: 'views/RosterRequests/requests.html'
    }).when('/memos/:filter', {
      controller: 'MemosCtrl',
      templateUrl: 'views/Memos/memos.html'
    }).when('/memos', {
      controller: 'MemosCtrl',
      templateUrl: 'views/Memos/memos.html'
    }).when('/ticket', {
      controller: 'TicketCtrl',
      templateUrl: 'views/ticket.html'
    }).when('/bucket', {
      controller: 'BucketCtrl',
      templateUrl: 'views/Bucket/bucketCalendar.html'
    }).when('/bucketDay/:dutyId', {
      controller: 'BucketDayCtrl',
      templateUrl: 'views/Bucket/bucketDay.html'
    }).when('/leaverequest', {
      controller: 'LeaveRequestCtrl',
      templateUrl: 'views/LeaveRequest/leaveRequest.html'
    }).when('/groundDuty/:groundDutyId', {
      controller: 'GroundDutyCtrl',
      templateUrl: 'views/GroundDuty/groundDuty-info.html'
    }).when('/crewRoute/:dutyNo/:dutyDay', {
      controller: 'CrewRouteCtrl',
      templateUrl: 'views/CrewRoute/crew-route-info.html'
    }).when('/reportsHistory/:reportId/:flightId?/:reportType', {
      controller: 'ReportsHistoryCtrl',
      templateUrl: 'views/reportsHistory.html'
    }).when('/flightcourse/:courseId/:dutyNo/:dutyDay/:date', {
      controller: 'FlightCourseCtrl',
      templateUrl: 'views/Training/flightCourse.html'
    }).when('/flightcourse/:courseId/:dutyNo/:dutyDay/:date/:flightId', {
      controller: 'FlightCourseCtrl',
      templateUrl: 'views/Training/flightCourse.html'
    }).when('/flightcourse/:courseId/:dutyNo/:dutyDay/:date/:flightId/:phaseId', {
      controller: 'FlightCourseCtrl',
      templateUrl: 'views/Training/flightCourse.html'
    }).when('/groundcourse/:courseId/:dutyId/:date', {
      controller: 'GroundCourseCtrl',
      templateUrl: 'views/Training/groundCourse.html'
    }).when('/groundcourse/:courseId/:dutyId/:date/:phaseId', {
      controller: 'GroundCourseCtrl',
      templateUrl: 'views/Training/groundCourse.html'
    }).when('/groundHistory/:courseId/:dutyId/:date/:phaseId', {
      controller: 'ModuleHistoryCtrl',
      templateUrl: 'views/Training/moduleHistory.html'
    })
    //  .when('/flightHistory/:courseId/:dutyNo/:dutyDay/:date/:phaseId',{
    //     controller: 'ModuleHistoryCtrl',
    // 	templateUrl: 'views/Training/moduleHistory.html'
    //  })
    .when('/flightHistory/:courseId/:dutyNo/:dutyDay/:date/:flightId/:phaseId', {
      controller: 'ModuleHistoryCtrl',
      templateUrl: 'views/Training/moduleHistory.html'
    }).when('/flightHistory/:combinedId/:dutyNo/:dutyDay/:date', {
      controller: 'ModuleHistoryCtrl',
      templateUrl: 'views/Training/moduleHistory.html'
    }).when('/safetyreport/flightcrewreport/:flightId', {
      controller: 'SafetyCtrl',
      templateUrl: 'views/Safety/flightCrewReport.html'
    }).when('/safetyreport/fatiguereport/:flightId', {
      controller: 'FatigueCtrl',
      templateUrl: 'views/Safety/fatigueReport.html'
    }).when('/traineecourse/:traineeCourseId/:dutyId/:date', {
      controller: 'TraineeCourseCtrl',
      templateUrl: 'views/TraineeCourse/trainee-course.tpl.html'
    }).when('/crewExpiries', {
      controller: 'CrewExpiriesCtrl',
      templateUrl: 'views/CrewExpiries/crewExpiries.html'
    }).otherwise({
      redirectTo: '/'
    });
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.run(runBlock);

  /* @ngInject */
  function runBlock($rootScope, $timeout, $location, UserFactory, UserTokenFactory, PilotReportLocalEditFactory, SettingsMain, $anchorScroll, SWUpdateService, LogService) {
    //make sure that each route change validates that the user is still logged in
    var valid = ['/login', '/reset', '/debug', '/ticket'];
    $rootScope.$on('$routeChangeStart', function (event, next, current) {
      if (valid.indexOf($location.$$path) < 0 && !UserFactory.isLoggedIn()) {
        event.preventDefault();
        $location.path('/login');
      }

      //START - SERVICE WORKERS
      if ('serviceWorker' in navigator) {
        SWUpdateService.initialize();
        navigator.serviceWorker.getRegistration().then(function (registration) {
          $rootScope.SWRegistration = registration;
        });
        SWUpdateService.checkUpdates($rootScope.SWRegistration);
      }
      //END - SERVICE WORKERS

      $anchorScroll.yOffset = 100;
      if (valid.indexOf($location.$$path) < 0 && (!current || !current.$$route || !next.$$route || current.$$route.controller != next.$$route.controller)) {
        //Check if temp report of any kind exists
        var editingPage = SettingsMain.getEditingPage();
        SettingsMain.setEditingPage(null);
        if (editingPage == 'report') {
          // check if a temp report exists in local storage
          if (PilotReportLocalEditFactory.getPilotReportLocalEditFromTemp() != null) {
            $location.path("report/temp");
          }
        }
      }
    });
    $("body").on("click", ".memo-body a", function () {
      var link = $(this).attr("href");
      if (link && link.indexOf("surveymonkey") > 0) {
        LogService.debug(link);
      }
    });
    $rootScope.idbSupported = "indexedDB" in window;
    $rootScope.isOffline = !window.navigator.onLine;
    window.addEventListener('offline', function (e) {
      $timeout($rootScope.isOffline = !window.navigator.onLine);
    });
    window.addEventListener('online', function (e) {
      $timeout($rootScope.isOffline = !window.navigator.onLine);
    });

    //maintain the user token, outside the localStorage, needed for submitting js errors
    var user = UserFactory.getUser();
    if (user && user.token) UserTokenFactory.setToken(user.token);else UserTokenFactory.setToken('');
  }
  ;
})();
"use strict";

(function () {
  // Warning!!! This an auto generated file. Any Changes will be lost. If u want to add or edit go to config.json 

  a3_pilot_reports.constant("liveVersion", true);
  a3_pilot_reports.constant("defaultCalendarDate", null);
  a3_pilot_reports.constant("defaultBucketDate", null);
  a3_pilot_reports.constant("aircraftLateArrivalReportId", 169);
  a3_pilot_reports.constant("inadequateGroundTimeReportId", 170);
  a3_pilot_reports.constant("apiUrl", "https://flightloguat.aegeanair.com/api/v1.9");
  a3_pilot_reports.constant("azureADAuth", {
    "clientId": "6dac8675-e0b7-48f3-b8d0-2e12539b8f28",
    "tenantId": "00ab5264-f7ed-4d89-9011-19bf33ed8169",
    "authority": "https://login.microsoftonline.com/aegeancloud.onmicrosoft.com"
  });
  a3_pilot_reports.constant("ssrCodes", [{
    "code": "AOXY",
    "description": "Airline Supplied Oxygen"
  }, {
    "code": "AVIH",
    "description": "Animal in Hold"
  }, {
    "code": "AVML",
    "description": "Vegetarian Hindu meal"
  }, {
    "code": "BBNL",
    "description": "Baby meal request"
  }, {
    "code": "BIKE",
    "description": "Request for carriage of bicycle"
  }, {
    "code": "BLML",
    "description": "Bland meal request"
  }, {
    "code": "BLND",
    "description": "Blind passenger information"
  }, {
    "code": "CBBG",
    "description": "Bulky cabin baggage request"
  }, {
    "code": "CHLD",
    "description": "Child information"
  }, {
    "code": "CHML",
    "description": "Child Meal Request"
  }, {
    "code": "DBML",
    "description": "Diabetic meal request"
  }, {
    "code": "DEAF",
    "description": "Deaf passenger information"
  }, {
    "code": "DEPA",
    "description": "Accompanied Deportee Information"
  }, {
    "code": "DEPU",
    "description": "Deportee unaccompanied"
  }, {
    "code": "DHCS",
    "description": "Deadhead crew seating"
  }, {
    "code": "DPNA",
    "description": "Disabled passenger needing assistance"
  }, {
    "code": "EMIG",
    "description": "Emigrant"
  }, {
    "code": "ESAN",
    "description": "Passenger with emotional support/psychiatric"
  }, {
    "code": "ESCD",
    "description": "Passenger escorting deportee"
  }, {
    "code": "EXST",
    "description": "Request for extra seat"
  }, {
    "code": "FAMS",
    "description": "Family seating"
  }, {
    "code": "FPML",
    "description": "Fruit platter meal request"
  }, {
    "code": "FRED",
    "description": "Meal and assist request"
  }, {
    "code": "GFML",
    "description": "Gluten intolerant meal request"
  }, {
    "code": "GPST",
    "description": "Group seating request"
  }, {
    "code": "HAJJ",
    "description": "HAJJ Passengers"
  }, {
    "code": "HNML",
    "description": "Hindu meal request"
  }, {
    "code": "INAD",
    "description": "Inadmissable"
  }, {
    "code": "INFT",
    "description": "Infant information"
  }, {
    "code": "KSML",
    "description": "Kosher meal request"
  }, {
    "code": "LCML",
    "description": "Low calorie meal request"
  }, {
    "code": "LFML",
    "description": "Low fat meal request"
  }, {
    "code": "LSML",
    "description": "Low salt meal request"
  }, {
    "code": "MAAS",
    "description": "Meet and assist request"
  }, {
    "code": "MEDA",
    "description": "Medical assistance information"
  }, {
    "code": "MEQT",
    "description": "Medical equipment"
  }, {
    "code": "MOML",
    "description": "Halaal meal request"
  }, {
    "code": "NFML",
    "description": "No fish meal request"
  }, {
    "code": "NLML",
    "description": "Low lactose meal request"
  }, {
    "code": "NOML",
    "description": "Meal on board not required"
  }, {
    "code": "PETC",
    "description": "Pet in cabin request"
  }, {
    "code": "POXY",
    "description": "Passenger own oxygen"
  }, {
    "code": "RVML",
    "description": "Vegetarian raw meal request"
  }, {
    "code": "SEML",
    "description": "Seafood meal request"
  }, {
    "code": "SFML",
    "description": "Seafood meal request"
  }, {
    "code": "SPML",
    "description": "Special meal request"
  }, {
    "code": "SVAN",
    "description": "Passenger with service animal in cabin"
  }, {
    "code": "UMNR",
    "description": "Unaccompanied minor information"
  }, {
    "code": "VGML",
    "description": "Vegetarian vegan meal request"
  }, {
    "code": "VJML",
    "description": "Vegetarian Jain meal request"
  }, {
    "code": "VLML",
    "description": "Vegetarian Lacto-Ovo meal request"
  }, {
    "code": "VOML",
    "description": "Vegetarian Oriental meal request"
  }, {
    "code": "WCBD",
    "description": "Wheelchair Dry-cell battery request"
  }, {
    "code": "WCBW",
    "description": "Wheelchair Wet-cell battery request"
  }, {
    "code": "WCHC",
    "description": "Wheelchair To seat request"
  }, {
    "code": "WCHR",
    "description": "Wheelchair To aircraft door request"
  }, {
    "code": "WCHS",
    "description": "Wheelchair Up/down stairs request"
  }, {
    "code": "WCLB",
    "description": "Wheelchair - Lithium ion Battery"
  }, {
    "code": "WCMP",
    "description": "Wheelchair Manual powered request"
  }, {
    "code": "WCOB",
    "description": "Wheelchair On board request"
  }, {
    "code": "WEAP",
    "description": "WEAP Firearms or ammunition booked & carried as checked"
  }, {
    "code": "XBGS",
    "description": "DCS Excess Baggage Request"
  }, {
    "code": "FAML",
    "description": "BC HB choice A"
  }, {
    "code": "FBML",
    "description": "BC HB choice B"
  }, {
    "code": "BFML",
    "description": "BC HML beef choice"
  }, {
    "code": "CKML",
    "description": "BC HML chicken choice"
  }, {
    "code": "FSML",
    "description": "BC HML fish choice"
  }, {
    "code": "COML",
    "description": "Cold cut platter"
  }, {
    "code": "DEML",
    "description": "Dessert choice"
  }]);
  a3_pilot_reports.constant("bookmarkThreshold", 15);
  a3_pilot_reports.constant("autolandSupportingAcTypes", ["319", "320", "321", "32Q", "32N"]);
  a3_pilot_reports.constant("turnAroundTimesSupportingAcTypes", ["319", "320", "321", "32Q", "32N"]);
  a3_pilot_reports.constant("showRecomendedWaterAcTypes", ["319", "320", "321", "32Q", "32N"]);
  a3_pilot_reports.constant("showCatIIApprachAcTypes", ["DH4", "DH8", "AT4", "AT7"]);
  a3_pilot_reports.constant("showGroundInfoAcTypes", ["DH4", "DH8", "AT4", "AT7"]);
  a3_pilot_reports.constant("showHotelsAcTypes", ["DH4", "DH8", "AT4", "AT7"]);
  a3_pilot_reports.constant("acuSupportingAcTypes", ["AT4", "AT7"]);
  a3_pilot_reports.constant("operationalPhases", [{
    "key": "3287",
    "value": "On Stand"
  }, {
    "key": "3288",
    "value": "Towing"
  }, {
    "key": "9242",
    "value": "Towing - Stand to Stand"
  }, {
    "key": "9243",
    "value": "Towing - to/from maint"
  }, {
    "key": "3289",
    "value": "Parked"
  }, {
    "key": "3290",
    "value": "Pushback"
  }, {
    "key": "3291",
    "value": "Taxi-out"
  }, {
    "key": "3292",
    "value": "Take-off"
  }, {
    "key": "3293",
    "value": "Initial Climb"
  }, {
    "key": "3294",
    "value": "Climb"
  }, {
    "key": "3295",
    "value": "Cruise"
  }, {
    "key": "3296",
    "value": "Descent"
  }, {
    "key": "3297",
    "value": "Holding"
  }, {
    "key": "3298",
    "value": "Approach"
  }, {
    "key": "3299",
    "value": "Landing"
  }, {
    "key": "3300",
    "value": "Taxi-in"
  }, {
    "key": "3301",
    "value": "Maintenance"
  }, {
    "key": "3302",
    "value": "All"
  }, {
    "key": "3303",
    "value": "In Aircraft"
  }, {
    "key": "3304",
    "value": "In Position at Aircraft"
  }, {
    "key": "3305",
    "value": "In Transit To / From Stand"
  }, {
    "key": "3306",
    "value": "Moving on Stand"
  }, {
    "key": "3307",
    "value": "Positioning to Aircraft"
  }, {
    "key": "3308",
    "value": "Removing from Aircraft"
  }, {
    "key": "3309",
    "value": "Other"
  }, {
    "key": "3310",
    "value": "Hover"
  }, {
    "key": "3311",
    "value": "In Flight"
  }, {
    "key": "3312",
    "value": "Multiple"
  }, {
    "key": "3313",
    "value": "Parked On / By Stand"
  }, {
    "key": "9241",
    "value": "Arrival"
  }, {
    "key": "9244",
    "value": "Arrival - Marshaling"
  }, {
    "key": "9245",
    "value": "Arrival - Guidance"
  }, {
    "key": "9246",
    "value": "Servicing"
  }, {
    "key": "9247",
    "value": "Servicing - De-icing"
  }, {
    "key": "9248",
    "value": "Servicing - Fueling"
  }, {
    "key": "9249",
    "value": "Servicing - Catering"
  }, {
    "key": "9250",
    "value": "Servicing - Lavatory"
  }, {
    "key": "9251",
    "value": "Servicing - Water"
  }, {
    "key": "9252",
    "value": "Servicing - Cleaning"
  }, {
    "key": "9253",
    "value": "Servicing - Line Maint"
  }, {
    "key": "9254",
    "value": "Servicing - Coning"
  }, {
    "key": "9255",
    "value": "Servicing - GPU"
  }, {
    "key": "9256",
    "value": "Servicing - PCA"
  }, {
    "key": "9257",
    "value": "Servicing - Bridging"
  }, {
    "key": "9258",
    "value": "Servicing - Chocking"
  }, {
    "key": "9259",
    "value": "Loading"
  }, {
    "key": "9260",
    "value": "Loading - Passenger"
  }, {
    "key": "9261",
    "value": "Loading - Baggage"
  }, {
    "key": "9262",
    "value": "Loading - Cargo"
  }, {
    "key": "9263",
    "value": "Unloading"
  }, {
    "key": "9264",
    "value": "Unloading - Passenger"
  }, {
    "key": "9265",
    "value": "Unloading - Baggage"
  }, {
    "key": "9266",
    "value": "Unloading - Cargo"
  }]);
})();
"use strict";

(function () {
  // Warning!!! This an auto generated file. Any Changes will be lost. If u want to add or edit go to config.json 

  a3_pilot_reports.constant("version", "appVersion_20250522234114");
})();
"use strict";

(function () {
  'use strict';

  //Default Configuration For Charts
  a3_pilot_reports.constant('barOptions', barOptions);
  a3_pilot_reports.constant('pieDoughnutOptions', pieDoughnutOptions);

  //Default Configuration For Charts
  var pieDoughnutOptions = {
    //Boolean - Whether we should show a stroke on each segment
    segmentShowStroke: true,
    //String - The colour of each segment stroke
    segmentStrokeColor: "#fff",
    //Number - The width of each segment stroke
    segmentStrokeWidth: 2,
    //Number - The percentage of the chart that we cut out of the middle
    percentageInnerCutout: 50,
    // This is 0 for Pie charts
    //Number - Amount of animation steps
    animationSteps: 100,
    //String - Animation easing effect
    animationEasing: "easeOutBounce",
    //Boolean - Whether we animate the rotation of the Doughnut
    animateRotate: true,
    //Boolean - Whether we animate scaling the Doughnut from the centre
    animateScale: false,
    //String - A legend template
    legendTemplate: "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<segments.length; i++){%><li><span style=\"background-color:<%=segments[i].fillColor%>\"></span><%if(segments[i].label){%><%=segments[i].label%><%}%></li><%}%></ul>",
    onAnimationComplete: function onAnimationComplete() {
      this.showTooltip(this.segments, true);
    },
    tooltipEvents: [],
    showTooltips: true
  };
  var barOptions = {
    ///Boolean - Whether grid lines are shown across the chart
    scaleShowGridLines: true,
    //String - Colour of the grid lines
    scaleGridLineColor: "rgba(0,0,0,.05)",
    //Number - Width of the grid lines
    scaleGridLineWidth: 1,
    //Boolean - Whether to show horizontal lines (except X axis)
    scaleShowHorizontalLines: true,
    //Boolean - Whether to show vertical lines (except Y axis)
    scaleShowVerticalLines: true,
    //Boolean - Whether the line is curved between points
    bezierCurve: true,
    //Number - Tension of the bezier curve between points
    bezierCurveTension: 0.4,
    //Boolean - Whether to show a dot for each point
    pointDot: true,
    //Number - Radius of each point dot in pixels
    pointDotRadius: 4,
    //Number - Pixel width of point dot stroke
    pointDotStrokeWidth: 1,
    //Number - amount extra to add to the radius to cater for hit detection outside the drawn point
    pointHitDetectionRadius: 20,
    //Boolean - Whether to show a stroke for datasets
    datasetStroke: true,
    //Number - Pixel width of dataset stroke
    datasetStrokeWidth: 2,
    //Boolean - Whether to fill the dataset with a colour
    datasetFill: true,
    //String - A legend template
    legendTemplate: "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<datasets.length; i++){%><li><span style=\"background-color:<%=datasets[i].strokeColor%>\"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>"
  };
})();
"use strict";

(function () {
  'use strict';

  angular.module('MyDirectives', [])

  /* Used to capture images from the device's camera
  * and resize them using given dimensions and quality
  * <input type="file" capture="camera" accept="image/*"
  	id="photoAddFile" image="imageBrowsed"
  onfilechange="imageChanged(data)"
  maxwidth="{{width}}" maxheight="{{height}}" quality="{{quality}}"
  imagetype="image/jpeg" >
  */.directive('image', function ($q) {
    'use strict';

    var URL = window.URL || window.webkitURL;
    return {
      restrict: 'A',
      scope: {
        /*image: '=',*/
        maxwidth: '@?',
        maxheight: '@?',
        quality: '@?',
        imagetype: '@?',
        onfilechange: '&'
      },
      link: function postLink(scope, element, attrs, ctrl) {
        var onFileChangeCallback = scope.onfilechange;
        var onFileFailureCallback = scope.onfileerror;
        var filename = "";
        var options;
        var getOptions = function getOptions() {
          var options = {
            maxWidth: parseFloat(scope.maxwidth) || 1024,
            maxHeight: parseFloat(scope.maxheight) || 768,
            quality: parseFloat(scope.quality) || 0.8,
            imageType: scope.imagetype || 'image/jpeg',
            canvas: true
          };
          return options;
        };
        var whenError = function whenError(errorMessage) {
          scope.$apply(function () {
            if (typeof onFileFailureCallback == 'function') {
              //to pass data in the message, we need to have an object with attrs named as in
              //the html part, eg  onfilechange="imageChanged(data)"
              onFileFailureCallback({
                err: errorMessage
              });
            }
          });
        };
        var whenReady = function whenReady(img) {
          if (!(img.src || img instanceof HTMLCanvasElement)) {
            whenError('Loading image file failed');
          } else {
            var data = img.src || img.toDataURL(options.imageType, options.quality);
            var imageResult = {
              dataURL: data,
              fileName: filename,
              fileType: options.imageType
            };
            scope.$apply(function () {
              if (typeof onFileChangeCallback == 'function') {
                //to pass data in the message, we need to have an object with attrs named as in
                //the html part, eg  onfilechange="imageChanged(data)"
                onFileChangeCallback({
                  data: imageResult
                });
              }
            });
          }
        };
        element.bind('change', function (evt) {
          evt.preventDefault();
          //e = e.originalEvent;
          var target = evt.dataTransfer || evt.target;
          var files = target && target.files;
          if (files) {
            var file;
            options = getOptions(); //read latest settings
            for (var i = 0; i < files.length; i++) {
              file = files[i];
              filename = file.name;
              //start by get metadata, to autoset the orientation of the image
              loadImage.parseMetaData(file,
              //when metadata are ready, use them and then load image
              function (data) {
                if (data.exif) {
                  options.orientation = data.exif.get('Orientation');
                }
                if (!loadImage(file, whenReady, options)) {
                  whenError('Your browser does not support capturing images.');
                }
              });
            }
          }
        });
      }
    };
  });
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('AirportContactFactory', AirportContactFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name AirportContactFactory
  * @description 
  *   Add, Update, Delete and Get Airport Contacts.
  * @ngInject
  */
  function AirportContactFactory(GenericService) {
    /**
    * Initialize the AirportContact
    * @memberof AirportContactFactory
    */
    function Airport() {
      this.Iata = null;
      this.Contacts = null;
    }
    var objType = 'airportContacts';
    var objCallback = Airport;
    var service = {
      fromObjectList: fromObjectList,
      getAirportContactsFromStorage: getAirportContactsFromStorage,
      setAirportContactsToStorage: setAirportContactsToStorage,
      clearAirportContactsFromStorage: clearAirportContactsFromStorage,
      getAirportContacts: getAirportContacts,
      upsertAirportContacts: upsertAirportContacts
    };

    /**
     * Extend an array of Objects from the default airportContact Object
     * @memberof AirportContactFactory
     * @param {Array} objList  an Array Of airportContact
     * @returns {Array} airportContact
     */
    function fromObjectList(objList) {
      return GenericService.fromObjectList(objList, objCallback);
    }

    /**
     * Get airportContacts
     * @memberof AirportContactFactory
     * @returns {Array} airportContacts
     */
    function getAirportContactsFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    /**
     * Save airportContacts to storage
     * @memberof AirportContactFactory
     * @param {Array} airportContacts A list of AirportContacts
     */
    function setAirportContactsToStorage(airportContacts) {
      GenericService.saveAll(airportContacts, objType, objCallback);
    }

    /**
     * Remove the airportContacts of  the local storage
     * @memberof AirportContactFactory
     */
    function clearAirportContactsFromStorage() {
      GenericService.removeAll(objType, objCallback);
    }

    /**
     * Get the contacts for a given airport
     * @memberof AirportContactFactory
     */
    function getAirportContacts(airportIata) {
      var all = this.getAirportContactsFromStorage();
      if (!all) return null;
      var airport = all.filter(function (item) {
        return item.Iata == airportIata;
      });
      if (!airport || airport.length == 0) return null;
      //we expect a single airport item per iata
      return airport[0];
      //return GenericService.fromObjectList(airport[0].Contacts, Contact);
    }

    /**
    * Upsert airport contacts
    * @memberof AirportContactFactory
    */
    function upsertAirportContacts(airportContacts) {
      var newStations = airportContacts.map(function (x) {
        return x.Iata;
      });
      var contactsLS = this.getAirportContactsFromStorage();
      contactsLS = contactsLS.filter(function (x) {
        return !newStations.includes(x.Iata);
      });
      var updatedContactList = contactsLS.concat(airportContacts);
      setAirportContactsToStorage(updatedContactList);
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('BucketCtrl', BucketCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name BucketCtrl
  * @description 
  *   View bucket
  * @ngInject
  */
  function BucketCtrl($scope, $location, BucketFactory, UserFactory, MessageFactory, $timeout, SettingsMain, defaultCalendarDate) {
    var ownDuties = [];
    var sharedDuties = [];
    var approvedDuties = [];
    $scope.state = 'bucketCalendar';
    var user = UserFactory.getUser();
    $scope.isSecure = UserFactory.isSecure();
    $scope.isUserSA = user.position == 'SA' ? true : false;
    $scope.logged_user_info = user.aimsId + ' - ' + user.name;
    $scope.getCalendarData = getCalendarData;
    $scope.showErrorMessage = false;
    var selectedDate = SettingsMain.getCalendarSelectedDate(); //Redirect to month that was previously selected
    SettingsMain.setCalendarSelectedDate(null); //Then reinitialize to current month

    getCalendarData();
    function getCalendarData() {
      progressBarBox(true);
      BucketFactory.getDutyObject(function (responseData) {
        ownDuties = responseData.data.data.Duties;
        sharedDuties = responseData.data.data.SharedDuties;
        approvedDuties = responseData.data.data.ApprovedDuties;
        setupView();
        progressBarBox(false);
      })["catch"](function (error) {
        progressBarBox(false);
        $scope.showErrorMessage = true;
        console.error('Load duties error', error.status, error.statusText);
      });
    }
    function setupView() {
      if (!UserFactory.isLoggedIn()) {
        $location.path("/login");
      }
      $scope.number_of_messages = MessageFactory.getMessagesFromStorage().length;
      $scope.number_of_messages_not_readen = MessageFactory.getCountOfUnreadMessages();

      /*var ownEvents = formatDuties(ownDuties, true, false);
      if (sharedDuties.length > 0) {
          var sharedEvents = formatDuties(sharedDuties, false, false);
          var events = ownEvents.concat(sharedEvents);
      } else {
          var events = ownEvents;
      }*/
      $scope.notification = createNotification(ownDuties);
      var ownEvents = formatDuties(ownDuties, true, false);
      var events = ownEvents;
      if (approvedDuties != null || approvedDuties != undefined) {
        if (approvedDuties.length > 0) {
          var appvovedEvents = formatDuties(approvedDuties, true, true);
          var events = events.concat(appvovedEvents);
        }
      }
      calendar(events);
    }

    /**
     * Transform routes in calendar events
     * @memberof BucketCtrl
     * @param {array} routes - The Scheduled Routes 
     * @return {array} events 
     */
    function formatDuties(duties, isOwnDuty, isApproved) {
      var dutiesEvents = [];
      for (var i = 0; i < duties.length; i++) {
        if (duties[i].IsUpdated) {
          console.log(duties[i]);
        }
        /*************** Add main event for duty *********************/

        // var eType = (isOwnDuty ? 'own-' : 'shared-') + duties[i].DutyType.toLowerCase();
        var eClassName = getEventClassName(duties[i], isOwnDuty, isApproved);
        var eIcons = getEventIcons(duties[i], isOwnDuty, isApproved);
        var eTitle = getEventTitle(duties[i], isOwnDuty) + (duties[i].TotalSharedDuties == undefined ? "" : duties[i].TotalSharedDuties);
        var eOtherInfos = getOtherInfos(duties[i], isOwnDuty);
        var event = {
          _id: duties[i].Id,
          // type: eType,
          icons: eIcons,
          className: eClassName["class"],
          title: eTitle,
          start: duties[i].DutyBegin == duties[i].DutyEnd ? duties[i].DutyDateS : duties[i].DutyBegin,
          end: duties[i].DutyBegin == duties[i].DutyEnd ? null : duties[i].DutyEnd,
          sortOrder: isOwnDuty ? 1 : -1,
          otherInfos: eOtherInfos,
          shareable: duties[i].Shareable,
          isOwnDuty: isOwnDuty,
          isApproved: isApproved,
          isOwnApproved: duties[i].HasApprovedProposals,
          listViewColor: eClassName.color
        };
        dutiesEvents.push(event);
      }
      return dutiesEvents;
    }
    function createNotification(duties) {
      var NewPendingProposalsCount = 0;
      var NewApprovedProposalsCount = 0;
      var NewRejectedProposalsCount = 0;
      var notificationText = null;
      for (var i = 0; i < duties.length; i++) {
        if (duties[i].IsUpdated) {
          if (duties[i].HasApprovedProposals) {
            NewApprovedProposalsCount++;
          } else {
            NewPendingProposalsCount += duties[i].NewPendingProposalsCount;
            NewRejectedProposalsCount += duties[i].NewRejectedProposalsCount;
          }
        }
      }

      /* var notification = {
                   NewPendingProposalsCount : NewPendingProposalsCount,
                   NewApprovedProposalsCount : NewApprovedProposalsCount,
                   NewRejectedProposalsCount : NewRejectedProposalsCount
               }*/

      if (NewPendingProposalsCount + NewApprovedProposalsCount + NewRejectedProposalsCount > 0) {
        notificationText = "You have ";
        var hasPrevious = false;
        if (NewPendingProposalsCount) {
          notificationText = notificationText + NewPendingProposalsCount + " pending";
          hasPrevious = true;
        }
        if (NewRejectedProposalsCount) {
          var conjuction = hasPrevious ? NewApprovedProposalsCount ? ", " : " and " : "";
          notificationText = notificationText + conjuction + NewRejectedProposalsCount + " rejected";
          hasPrevious = true;
        }
        if (NewApprovedProposalsCount) {
          var conjuction = hasPrevious ? " and " : "";
          notificationText = notificationText + conjuction + NewApprovedProposalsCount + " accepted";
        }
        notificationText = notificationText + " proposals.";
      }
      return notificationText;
    }

    /**
     * Returns an array of strings for icons to display in the event tile
     * @memberof BucketCtrl
     * @param {object} duty - The Scheduled duty 
     * @param {boolean} ownDuty - Is set to true when the duty is current user's duty, otherwise is set to false
     * @return {array} icons - The array of strings for icons to display in the event tile.
     */
    function getEventIcons(duty, isOwnDuty, isApproved) {
      var icons = [];
      if (!isOwnDuty) icons.push('fa-sing-in');else {
        if (duty.IsUpdated) icons.push('fa-star text-orange');

        /*  if (duty.PendingProposalsCount > 0 && !isApproved) icons.push('fa-info-circle');*/
        if (!duty.Shareable || isApproved) icons.push('fa-lock');
        if (duty.Shared && !isApproved) icons.push('fa-bitbucket');
      }
      return icons;
    }

    /**
     * Returns the title for the event tile
     * @memberof BucketCtrl
     * @param {object} duty - The Scheduled duty 
     * @param {boolean} ownDuty - Is set to true when the duty is current user's duty, otherwise is set to false
     * @return {string} title - The title to display in the event tile.
     */
    function getEventTitle(duty, isOwnDuty) {
      var title = '';
      if (isOwnDuty) title += duty.Title;else title += 'Shared duties: ';
      return title;
    }

    /**
     * Returns the class for the event tile
     * @memberof BucketCtrl
     * @param {object} duty - The Scheduled duty 
     * @param {boolean} ownDuty - Is set to true when the duty is current user's duty, otherwise is set to false
     * @return {string} className - The class(es) to use for displaying the event tile.
     */
    function getEventClassName(duty, isOwnDuty, isApproved) {
      var eventClass = {
        "class": 'fc-bucket ',
        color: ''
      };
      if (isOwnDuty) {
        eventClass["class"] += 'fc-own ';
        var hasApprovedTrade = duty.HasApprovedProposals;
        if (isApproved == true) {
          eventClass["class"] += 'fc-green-inverted ';
          eventClass.color = 'lv-green-inverted';
        } else if (hasApprovedTrade) {
          eventClass["class"] += 'fc-green ';
          eventClass.color = 'lv-green';
        } else if (duty.Shared) {
          eventClass["class"] += 'fc-primary-inverted ';
          eventClass.color = 'lv-blue';
        }
        /*     else if (duty.Shareable && duty.PendingProposalsCount == 0) {
                eventClass.class += 'fc-blue ';
                eventClass.color = 'lv-blue';
            } else if (duty.PendingProposalsCount > 0) {
                eventClass.class += 'fc-orange ';
                eventClass.color = 'lv-orange';
            } else if (duty.Bookmarks != undefined && duty.Bookmarks.length > 0) {
                eventClass.class += 'fc-purple-inverted ';
                eventClass.color = 'lv-purple-inverted';
            } */else {
          eventClass["class"] += 'fc-white ';
          eventClass.color = 'lv-white';
        }
      } else {
        eventClass["class"] += 'fc-aluminum ';
        eventClass.color = 'lv-aluminum';
      }
      return eventClass;
    }

    /**
     * Returns an array of objects for infos (label, number) to display in the event tile
     * @memberof BucketCtrl
     * @param {object} duty - The Scheduled duty 
     * @param {boolean} ownDuty - Is set to true when the duty is current user's duty, otherwise is set to false
     * @return {array} infos - The array of objects for infos (label, number) to display in the event tile.
     */
    function getOtherInfos(duty, isOwnDuty) {
      var infos = [];
      if (isOwnDuty) {
        var hasApprovedTrade = duty.HasApprovedProposals;
        if (!hasApprovedTrade) {
          if (duty.PendingProposalsCount > 0) infos.push({
            label: 'Proposals',
            num: duty.PendingProposalsCount
          });
          if (duty.BookmarksCount > 0) infos.push({
            label: 'Bookmarks',
            num: duty.BookmarksCount
          });

          // var totalBookmarks = (duty.bookmarks == undefined ? 0 : duty.bookmarks.length);
          // if (totalBookmarks > 0) infos.push({ label: 'Bookmarks', num: totalBookmarks.toString() });
        }
      }
      //  else {
      //     if (duty.TotalSharedDuties > 0) infos.push({ label: 'Total', num: duty.TotalSharedDuties.toString() });
      //     //if (duty.unclaimedShared > 0) infos.push({ label: 'Unclaimed', num: duty.unclaimedShared.toString() });
      // }
      return infos;
    }
    function calendar(events) {
      $('#calendar').fullCalendar('destroy');
      $("#calendar").fullCalendar({
        defaultView: getDefaultView(),
        defaultDate: defaultCalendarDate,
        firstDay: 1,
        lang: 'en',
        editable: false,
        draggable: false,
        selectable: false,
        selectHelper: false,
        unselectAuto: false,
        disableResizing: false,
        droppable: false,
        fixedWeekCount: false,
        nextDayThreshold: "00:00:00",
        header: {
          left: 'title',
          center: '',
          right: 'month,listMonth today prev,next'
        },
        timeFormat: 'HH:mm',
        displayEventEnd: true,
        events: events,
        eventOrder: "sortOrder",
        eventRender: function eventRender(event, element, icon) {
          element.find('.fc-title').prepend("<br/>");
          if ($('#calendar').fullCalendar('getView').type === 'listMonth') {
            element.find('.fc-list-item-title').addClass('listview-icon');
            $.each(event.className, function (index, icon) {
              element.addClass(event.listViewColor);
            });
            $.each(event.icons, function (index, icon) {
              element.find('.listview-icon').prepend("<i style='padding-right:5px;' class='fa " + icon + " '></i> ");
            });
            if (event.otherInfos != null && event.otherInfos.length > 0) {
              $.each(event.otherInfos, function (index, info) {
                if (info.label == 'Proposals') element.find('.fc-list-item-title').append("<span class='badge badge-primary pull-right'>" + info.num + "</span>");
              });
            }
          } else {
            if (event.icons != null && event.icons.length > 0) {
              element.find('.fc-title').prepend("<span class='calendar-icon'></span>");
              $.each(event.icons, function (index, icon) {
                element.find('.calendar-icon').append("<i class='fa " + icon + " '></i> ");
              });
            }
            if (event.otherInfos != null && event.otherInfos.length > 0) {
              $.each(event.otherInfos, function (index, info) {
                element.find('.fc-title').append("<div class='small text-right'><strong>" + info.label + ": " + info.num + "</strong></div>");
                element.find('.fc-list-item-title').add("<span class='badge badge-primary pull-right'>" + info.num + "</span>");
              });
            }
          }
        },
        eventResize: function eventResize(event, delta, revertFunc) {
          changeView(detectMobile(), '#calendar');
        },
        dayRender: function dayRender(date, cell) {},
        // dayClick: function(date, jsEvent, view) {
        //     $timeout(function(){ gotoDayBucketView(date); })
        // },
        eventClick: function eventClick(calEvent, jsEvent, view) {
          if (calEvent.shareable == true && calEvent.isOwnDuty && (!calEvent.isApproved || calEvent.isOwnApproved)) {
            $timeout(function () {
              gotoDayBucketView(calEvent._id);
            });
          } else if (calEvent.shareable == false && calEvent.isOwnDuty) {
            if (!calEvent.isApproved) {
              //don't allow click for approved duty
              $timeout(function () {
                unableShare();
              });
            }
          }
        },
        height: 'auto'
      });
      $('.fc-listMonth-button').click(function () {
        SettingsMain.setCalendarViewStyle('listMonth');
      });
      $('.fc-month-button').click(function () {
        SettingsMain.setCalendarViewStyle('month');
      });
      if (selectedDate != null && selectedDate != undefined) {
        $("#calendar").fullCalendar('gotoDate', selectedDate);
      }
    }
    function getDefaultView() {
      var calendarStyle = SettingsMain.getCalendarViewStyle();
      if (calendarStyle == null) {
        calendarStyle = detectMobile() ? "listMonth" : "month";
      }
      return calendarStyle;
    }
    function detectMobile() {
      var isMobile = window.innerWidth <= 800 && window.innerHeight <= 735;
      return isMobile;
    }

    /**
     * Redirects to bucket calendar day 
     * @memberof BucketCtrl
     */
    function gotoDayBucketView(dutyId) {
      $location.path('/bucketDay/' + dutyId);
    }
  }
  function unableShare() {
    bootbox.dialog({
      message: "<div class='alert alert-warning'>You can't share this duty, please try another shareable duty.</div>",
      title: "Warning",
      buttons: {
        cancel: {
          label: "Close",
          className: "btn-default",
          callback: function callback() {}
        }
      }
    });
  }
  function progressBarBox(isOpen) {
    if (isOpen) {
      bootbox.dialog({
        closeButton: false,
        message: '<div class="text-center"><i class="fa fa-spin fa-spinner"></i> Please wait...</div>'
        //title: "Please wait..."
      });
    } else {
      bootbox.hideAll();
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('BucketFactory', BucketFactory);

  /**
   * @memberof PilotReports
   * @ngdoc factory
   * @name BucketFactory
   * @description 
   * Get Duties from API 
   * @ngInject
   */
  function BucketFactory(GenericService, $http, $q, apiUrl, LogService) {
    /**
     * Initialize Bucket
     * @memberof BucketFactory
     */

    var service = {
      getDutyObject: getDutyObject,
      getDutyById: getDutyById,
      shareDuty: shareDuty,
      acknowledgeProposal: acknowledgeProposal,
      fetchProposal: fetchProposal,
      createProposal: createProposal,
      evaluateProposal: evaluateProposal,
      undoProposalStatus: undoProposalStatus,
      fetchSharedProposal: fetchSharedProposal
    };

    /**
     * Gets Bucket Calendar object
     * @memberof BucketFactory
     * @param {function} callback 
     */
    function getDutyObject(callback) {
      return $http.get(apiUrl + '/bucket/', {
        'Content-Type': 'application/json'
      }).then(callback);
    }

    /**
     * Gets duty object and shared duties object for the BucketDay View
     * @memberof BucketFactory
     * @param {number} dutyId 
     * @param {function} callback 
     */
    function getDutyById(dutyId, callback) {
      return $http.get(apiUrl + '/bucket/GetBucketDuty/' + dutyId, {
        'Content-Type': 'application/json'
      }).then(callback);
    }

    /**
     * Shares/Unshares duty
     * @memberof BucketFactory
     * @param {object} duty 
     * @param {function} callback 
     * @param {function} errorCallback 
     */
    function shareDuty(duty, callback, errorCallback) {
      var dutyMinified = {
        Id: duty.Id,
        Shareable: duty.Shareable,
        Shared: duty.Shared,
        Comments: duty.Comments,
        CrewInformation: {
          Email: null,
          Phone: null,
          Comments: null
        }
      };
      return $http.post(apiUrl + '/bucket/ShareDuty/', dutyMinified, {
        'Content-Type': 'application/json'
      }).then(callback)["catch"](errorCallback);
    }

    /**
     * Makes proposal acknowledged 
     * @memberof BucketFactory
     * @param {number} proposalId 
     * @param {function} callback 
     */
    function acknowledgeProposal(proposalId, callback) {
      return $http.get(apiUrl + '/bucket/AcknowledgeProposal?proposalId=' + proposalId, {
        'Content-Type': 'application/json'
      }).then(callback);
    }

    /**
     * Fetches proposal info 
     * @memberof BucketFactory
     * @param {number} dutyId 
     * @param {function} callback 
     * @returns {object} - Promise containing Proposed and Requested duties alongside Crew and Route details for each one
     */
    function fetchProposal(dutyId, callback) {
      return $http.get(apiUrl + '/bucket/FetchProposal?id=' + dutyId, {
        'Content-Type': 'application/json'
      }).then(callback);
    }

    /**
     * Fetches shared proposal info
     * @param {number} dutyId 
     * @param {number} sharedDutyId 
     * @param {function} callback
     * @returns {object} - Promise containing Proposed and Requested duties alongside Crew and Route details for each one
     */
    function fetchSharedProposal(dutyId, sharedDutyId, callback) {
      return $http.get(apiUrl + '/bucket/FetchSharedProposal?dutyId=' + dutyId + '&sharedDutyId=' + sharedDutyId, {
        'Content-Type': 'application/json'
      }).then(callback);
    }

    /**
     * Creates/Sends Proposal
     * @memberof BucketFactory
     * @param {object} proposal - Containing proposedDutiesIdList and requestedDutiesIdList
     * @param {function} callback
     * @returns {object} - Promise containing updated proposal 
     */
    function createProposal(proposal, callback) {
      return $http.post(apiUrl + '/bucket/CreateProposal', proposal, {
        'Content-Type': 'application/json'
      }).then(callback);
    }

    /**
     * Approves/Rejects proposal
     * @memberof BucketFactory
     * @param {object} proposal - Containing Id and isApproved
     * @param {function} callback
     * @returns {object} - Promise containing updated proposal 
     */
    function evaluateProposal(proposal, callback) {
      return $http.put(apiUrl + '/bucket/EvaluateProposal/' + proposal.Id, proposal.isApproved, {
        'Content-Type': 'application/json'
      }).then(callback);
    }

    /**
     * Reverts proposal to previous status
     * @memberof BucketFactory
     * @param {number} proposalId 
     * @param {function} callback 
     * @returns {object} - Promise containing updated proposal
     */
    function undoProposalStatus(proposalId, callback) {
      return $http.put(apiUrl + '/bucket/UndoProposalStatus/' + proposalId, {
        'Content-Type': 'application/json'
      }).then(callback);
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('BucketDayCtrl', BucketDayCtrl);
  /**
   * @memberof PilotReports
   * @ngdoc controller
   * @name BucketDayCtrl
   * @description 
   *   Shows the Bucket Day informations
   * @ngInject
   */

  function BucketDayCtrl($scope, BucketFactory, $routeParams, $location, $uibModal, UserFactory, SettingsMain, $timeout) {
    var dutyId = $routeParams.dutyId;
    $scope.isSharedLate = false;

    /**
     * Checks if duty wont be approved in time because of the weekend  
     * @memberof BucketDayCtrl
     */
    function checkLateShare() {
      var today = new Date();
      var dutyDay = new Date($scope.duty.DutyBegin);

      // how many days until duty date
      var trimmedToday = new Date(today);
      var trimmedDutyDay = new Date(dutyDay);
      var diffDays = Date.DifferenceInDays(trimmedToday.trimTime(), trimmedDutyDay.trimTime());

      //friday saturday sunday
      var fss = [5, 6, 0];
      //saturday sunday monday
      var ssm = [6, 0, 1];

      // today is Fr,Sa,Su   AND   duty on Sa,Su,Mo   AND   same weekend
      if (fss.contains(today.getDay()) && ssm.contains(dutyDay.getDay()) && diffDays < 4) {
        //friday before 14:00 is not a late share
        if (!(today.getDay() == 5 && today.getUTCHours() < 14)) $scope.isSharedLate = true;
      }
    }
    $scope.currentDutyId = dutyId;
    $scope.initialized = false;
    $scope.displayMessage = displayMessage;
    $scope.confirmUnshare = confirmUnshare;
    $scope.shareDuty = shareDuty;
    $scope.isLoading = false;
    var dutyId = $routeParams.dutyId;
    $scope.currentDutyId = dutyId;
    var user = UserFactory.getUser();
    $scope.activeTab = 0;
    $scope.duty = null;
    $scope.Duties = [];
    $scope.proposals = [];
    $scope.toggle = {
      Accepted: true,
      Rejected: false,
      Pending: true,
      Bookmarks: true
    };
    $scope.getProposalBorderStyle = getProposalBorderStyle;
    function getProposalBorderStyle(proposal) {
      var textclass = "";
      if (proposal.Status == "Bookmarked" && proposal.State == 'Out') {
        textclass = "border-left-amber";
      } else if (proposal.Status == "Pending" && proposal.State == 'Out') {
        textclass = "border-left-light-blue";
      } else if (proposal.Status == "Rejected" || proposal.Status == "RejectedBySTP") {
        textclass = "border-left-red";
      } else if (proposal.Status == "Pending" && proposal.State == 'In') {
        textclass = "border-left-orange";
      } else if (proposal.Status == "Approved" || proposal.Status == "ApprovedBySTP") {
        textclass = "border-left-green";
      } else if (proposal.Status == "Shared") {
        textclass = "border-left-blue-gray";
      }
      return textclass;
    }
    $scope.logged_user_info = user.aimsId + ' - ' + user.name;
    $scope.hasTimeChange = false;
    $scope.approvedDuty = null;
    $scope.showMobileProposalCriteria = false;
    $scope.filterProposal = filterProposal;
    $scope.hasProposals = hasProposals;
    function hasProposals() {
      var value = false;
      if ($scope.duty && $scope.duty.Duties) {
        for (var i = 0; i < $scope.duty.Duties.length; i++) {
          if ($scope.duty.Duties[i].Id > 0) {
            value = true;
            break;
          }
        }
        if (!value && $scope.activeTab != 1) {
          $scope.activeTab = 1;
        }
      }
      return value;
    }
    function filterProposal(proposal) {
      var isShown = false;
      if (proposal.Id > 0) {
        if (proposal.Status == "Approved" || proposal.Status == "ApprovedBySTP") {
          $scope.approvedDuty = true;
          if ($scope.toggle.Accepted) isShown = true;
        } else if (proposal.Status == "Pending" && $scope.toggle.Pending) {
          isShown = true;
        } else if ((proposal.Status == "Rejected" || proposal.Status == "RejectedBySTP") && ($scope.toggle.Rejected || !proposal.isAcknowledged)) {
          console.log($scope.toggle.Rejected);
          console.log(proposal);
          isShown = true;
        } else if (proposal.Status == "Bookmarked" && $scope.toggle.Bookmarks) {
          isShown = true;
        }
      }
      return isShown;
    }
    $scope.returnToBucket = returnToBucket;
    $scope.refresh = getData;
    getData();
    function getData() {
      $scope.isLoading = true;
      BucketFactory.getDutyById(dutyId, function (responseData) {
        $scope.initialized = true;
        $scope.isLoading = false;
        $scope.duty = responseData.data.data.duty;
        $scope.currentDutyDate = $scope.duty.DutyDateS;
        $scope.Duties = responseData.data.data.duty.Duties;
        $scope.totalItems = $scope.Duties.length;
        $scope.currentPage = 1;
        SettingsMain.setCalendarSelectedDate($scope.currentDutyDate);
        checkLateShare();
        initProposalsView();
      })["catch"](function (error) {
        $scope.isLoading = false;
        console.error('Wrong AimsId', error.status, error.statusText);
        returnToBucket();
      });
    }
    function initProposalsView() {
      $scope.approvedDuty = false;
      for (var i = 0; i < $scope.duty.Duties.length; i++) {
        if ($scope.duty.Duties[i].Status == "Approved" || $scope.duty.Duties[i].Status == "ApprovedBySTP") {
          $scope.approvedDuty = true;
        }
      }
    }

    /**
     * Opens a dialog with information on a duty, 
     * Depending on the duty type (in proposal, out proposal or shared by other in bucket) different options are displayed:
     * 1. In proposal
     *      - Approve (available when in proposal not reviewed, will set status to Approved)
     *      - Reject (available when in proposal not reviewed, will set status to Rejected)
     *      - Reset (available when in proposal has been reviewed, will set status to Pending)
     *      - Close (available always, just closes dialog, no action performed)
     * 2. Out proposal
     *      - Remove (available when out proposal not reviewed, will remove request from duty)
     *      - Close (available always, just closes dialog, no action performed)
     * 3. Shared in bucket
     *      - Request (available always, will send a request for duty, will be added in out proposals)
     *      - Close (available always, just closes dialog, no action performed)
     * @memberof BucketCtrl
     */

    /**
     * Prompts user to confirm sharing duty, if user agrees then the duty dialog will open  
     * @memberof BucketCtrl
     */
    function shareDuty(_duty) {
      //if (confirm('You are about to share into global bucket the selected duty. Do you wish to continue?')) {
      _duty.fromShareBtn = true;
      var modalInstance = $uibModal.open({
        templateUrl: 'views/Dialogs/dlgDuty.html',
        controller: 'BucketModalCtrl',
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          duty: function duty() {
            return _duty;
          },
          currentDutyId: function currentDutyId() {
            return dutyId;
          }
        }
      });
      modalInstance.result.then(function (refresh) {
        if (refresh) {
          getData();
        }
      });
      //}
    }

    /**
     * Prompts user to confirm removing duty from shared bucket, if user agrees then all proposal for the duty will be removed (will be displayed as N/A to other users)  
     * @memberof BucketCtrl
     */

    function confirmUnshare() {
      bootbox.dialog({
        message: "<strong>Please confirm that you wish to Un-share your duty.</strong><br/><br/>",
        title: "Unshare",
        buttons: {
          confirm: {
            label: '<i class="fa fa-trash-o widget-icon text-white"></i> Confirm',
            className: "btn-warning",
            callback: function callback() {
              BucketFactory.shareDuty($scope.duty, function (responseData) {
                $scope.responseText = responseData.data.data;
                getData();
              });
            }
          },
          cancel: {
            label: "Cancel",
            className: "btn-default",
            callback: function callback() {}
          }
        }
      });
    }

    /**
     * Redirects to bucket' calendar
     * @memberof BucketCtrl
     */
    function returnToBucket() {
      SettingsMain.setEditingPage(null);
      $location.path("/bucket/");
    }
    /**
     * Redirects to flights' calendar
     * @memberof BucketCtrl
     */
    function gotoFlightsCalendar() {
      SettingsMain.setEditingPage(null);
      $location.path("/");
    }

    //Pagination
    $scope.pageOptions = [{
      name: '5',
      value: '5'
    }, {
      name: '8',
      value: '8'
    }, {
      name: '15',
      value: '15'
    }, {
      name: '30',
      value: '30'
    }, {
      name: '50',
      value: '50'
    }];
    $scope.viewby = $scope.pageOptions[1].value;
    $scope.currentPage = 1;
    $scope.itemsPerPage = $scope.viewby;
    $scope.maxSize = 5; //Number of pager buttons to show
    $scope.setPage = setPage;
    $scope.setItemsPerPage = setItemsPerPage;

    /**
    * Set pagination page number
    * @memberof BucketDayCtrl
    * @param {number} pageNo list page number
    */
    function setPage(pageNo) {
      $scope.currentPage = pageNo;
    }
    /**
     * Set items per  page 
     * @memberof BucketDayCtrl
     * @param {number} num the Number of items to show per page
     */
    function setItemsPerPage(num) {
      $scope.itemsPerPage = num;
      $scope.currentPage = 1; //reset to first page
    }

    function displayMessage(message, hasErrors) {
      $scope.showResponse = true;
      $scope.responseText = message;
      $scope.responseHasErrors = hasErrors;
      $timeout(function () {
        if (!hasErrors) {
          $scope.showResponse = false;
        }
      }, 1000);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('BucketModalCtrl', BucketModalCtrl);
  /**
   * @memberof PilotReports
   * @ngdoc controller
   * @name BucketModalCtrl
   * @description 
   * Shows a Share/Unshare Modal 
   * @ngInject
   */

  function BucketModalCtrl($scope, $timeout, $uibModalInstance, duty, currentDutyId, BucketFactory) {
    $scope.duty = duty;
    $scope.currentDutyId = currentDutyId;
    $scope.closeDuty = closeDuty;
    $scope.shareDuty = shareDuty;
    $scope.responseText = null;
    $scope.responseHasErrors = null;
    $scope.submitted = false;

    /**
     * Close the modal
     * @memberof BucketModalCtrl
     */
    function closeDuty(refresh) {
      $uibModalInstance.close(refresh);
    }

    /**
     * Adds/Removes duty to/from global bucket
     * @memberof BucketModalCtrl
     */
    function shareDuty() {
      $scope.submitted = true;
      duty.Comments = $scope.duty.Comments;
      BucketFactory.shareDuty(duty, function (responseData) {
        displayMessage("Duty shared.", false);
        $timeout(function () {
          closeDuty(true);
        }, 5000);
      }, function () {
        displayMessage("Failed to share duty.", true);
      });
    }

    /**
     * Displays message when share/unshare 
     * @memberof BucketModalCtrl
     * @param {string} message 
     * @param {boolean} hasErrors 
     */
    function displayMessage(message, hasErrors) {
      $scope.responseText = message;
      $scope.responseHasErrors = hasErrors;
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('proposal', proposal);
  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name proposal
  * @restrict E
  * @description
  *   Implementation of proposal
  *   Initialize the proposal element of bucket
  * @example
  *   Usage:
  *   <proposal    proposal="proposal"  
  *                current-duty-id="currentDutyId"  
  *                current-duty-date="currentDutyDate" 
  *                onDisplay="functionCallback" 
  *                onRefresh="functionCallback"
  *                action-disabled="approvedDuty" 
  *                shared-count="duty.Duties.length"
  *    </proposal>
  * @ngInject
  */
  function proposal(BucketFactory, $uibModal, $filter) {
    function link(scope, element, attrs) {
      scope.isOpen = false;
      scope.successful = false;
      scope.error = false;
      scope.proposal.createDisabled = false;
      scope.duty = scope.proposal.Duty;
      scope.loading = false;
      scope.errorMessage = null;
      scope.ProposedDuties = new Array();
      scope.RequestedDuties = new Array();
      scope.AllDuties = new Array();
      scope.fetch = fetchInformation;
      scope.viewInfoModal = viewInfoModal;
      scope.createProposal = createProposal;
      scope.evaluateProposal = evaluateProposal;
      scope.undoProposalStatus = undoProposalStatus;
      scope.acknowledgeProposal = acknowledgeProposal;
      scope.confirmCreateProposal = confirmCreateProposal;
      scope.getFirstInfoIcon = getFirstInfoIcon;
      scope.getSecondInfoIcon = getSecondInfoIcon;
      scope.hasSecondInfoIcon = hasSecondInfoIcon;
      scope.getTextColor = getTextColor;
      scope.getFirstActionIcon = getFirstActionIcon;
      scope.hasFirstActionIcon = hasFirstActionIcon;
      scope.getSecondActionIcon = getSecondActionIcon;
      scope.hasSecondActionIcon = hasSecondActionIcon;
      scope.getFetchIcon = getFetchIcon;
      scope.getInfoMessage = getInfoMessage;
      scope.firstAction = firstAction;
      scope.secondaryAction = secondaryAction;
      scope.showEndDate = showEndDate;
      scope.showTime = showTime;
      if (scope.duty.Comments && scope.duty.Comments != "") {
        scope.dutyCommentElipsis = dutyCommentElipsis(110);
        scope.showFullComment = false;
      }
      scope.toggleFullCommentVisibility = toggleFullCommentVisibility;

      /**
       * Toggles proposal comment
       * @memberof proposal
       */
      function toggleFullCommentVisibility() {
        scope.showFullComment = !scope.showFullComment;
      }

      /**
       * Shows only the first charNo characters of the comment
       * @memberof proposal
       * @param {number} charNo 
       */
      function dutyCommentElipsis(charNo) {
        var comments = scope.duty.Comments;
        if (scope.duty.Comments.length > charNo) {
          comments = scope.duty.Comments.substring(0, charNo) + "...";
        }
        return comments;
      }

      /**
      * Updates proposal when a change occurs (create, evaluate or undo)
      * @memberof proposal
      * @param {object} newProp - The updated proposal 
      */
      function updateProposal(newProp) {
        if (newProp) {
          scope.proposal.Status = newProp.Status;
          scope.proposal.State = newProp.State;
          scope.proposal.Id = newProp.Id;
          scope.proposal.isAcknowledged = newProp.isAcknowledged;
        }
      }

      /**
       * Fetches proposal info (Proposed and Requested duties alongside Crew and Route details for each one)  
       * @memberof proposal
       */
      function fetchInformation() {
        if (!(scope.actionDisabled && scope.proposal.Status == 'Shared')) {
          //only fetch the first time
          if (!(scope.proposal.AllDuties && scope.proposal.AllDuties.length > 0)) {
            scope.loading = true;
            if (scope.proposal.Status == "Shared" && !scope.actionDisabled) {
              BucketFactory.fetchSharedProposal(scope.currentDutyId, scope.duty.Id, insertInformation)["catch"](errorCall);
            } else {
              BucketFactory.fetchProposal(scope.proposal.Id, insertInformation)["catch"](errorCall);
            }
          } else {
            scope.isOpen = !scope.isOpen; //collapse
          }
        }
      }

      /**
       * Handles error from fetchSharedProposal() and fetchProposal()  
       * @memberof proposal
       */
      function errorCall() {
        scope.isOpen = false;
        scope.loading = false;
        displayMessage("Failed to fetch information.", true);
      }

      /**
       * Callback for handling the successful response of fetchSharedProposal() and fetchProposal()
       * @memberof proposal
       * @param {object} data 
       */
      function insertInformation(data) {
        var success = data.data.success;
        var errorMessage = data.data.errorMessage;
        //always show duties even if success is false
        if (data.data.data.duty) {
          var ProposedDuties = data.data.data.duty.ProposedDuties;
          var RequestedDuties = data.data.data.duty.RequestedDuties;
          scope.proposal.HasMultiDuties = data.data.data.duty.HasMultiDuties;
          ProposedDuties = $filter('orderBy')(ProposedDuties, 'DutyDate');
          RequestedDuties = $filter('orderBy')(RequestedDuties, 'DutyDate');
          if (ProposedDuties && RequestedDuties) {
            scope.proposal.AllDuties = [];
            var tableMaxRowLength = ProposedDuties.length > RequestedDuties.length ? ProposedDuties.length : RequestedDuties.length;
            for (var i = 0; i < tableMaxRowLength; i++) {
              if (scope.proposal.Status == "Shared" || scope.proposal.State == "Out") {
                var matchedDuty = {
                  Proposed: ProposedDuties[i],
                  //you give
                  Requested: RequestedDuties[i] //you take
                };
              } else {
                //scope.proposal.State == "In"
                var matchedDuty = {
                  Proposed: RequestedDuties[i],
                  //you give
                  Requested: ProposedDuties[i] //you take
                };
              }

              scope.proposal.AllDuties.push(matchedDuty);
            }
            scope.proposal.ProposedDuties = ProposedDuties;
            scope.proposal.RequestedDuties = RequestedDuties;
            scope.isOpen = true;
          }
        }
        if (!success) {
          //if not enough rest time
          //if no available combinations
          scope.proposal.createDisabled = true;
        } else {
          scope.proposal.createDisabled = false;
        }

        //always show errorMessage even if success is true
        if (errorMessage && errorMessage.length > 0) {
          displayMessage(errorMessage, true);
        } else {
          scope.errorMessage = null;
        }
        scope.loading = false;
      }

      /**
       * Opens modal for a specific duty in the table - Shows route and crew info 
       * @memberof proposal
       * @param {number} id 
       */
      function viewInfoModal(id) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Bucket/dlgProposalInfo.html',
          controller: 'ProposalInfoModalCtr',
          size: 'lg',
          resolve: {
            ProposedDuties: function ProposedDuties() {
              return scope.proposal.ProposedDuties;
            },
            RequestedDuties: function RequestedDuties() {
              return scope.proposal.RequestedDuties;
            },
            Id: function Id() {
              return id;
            },
            Status: function Status() {
              return scope.proposal.Status;
            },
            State: function State() {
              return scope.proposal.State;
            }
          }
        });
      }

      /**
       * Creates/Sends proposal
       * @memberof proposal
       */
      function createProposal() {
        var proposedDutiesIdList = [];
        var requestedDutiesIdList = [];
        angular.forEach(scope.proposal.ProposedDuties, function (duty) {
          proposedDutiesIdList.push(duty.Id);
        });
        angular.forEach(scope.proposal.RequestedDuties, function (duty) {
          requestedDutiesIdList.push(duty.Id);
        });

        //request body
        var proposal = {
          'proposedDutiesIdList': proposedDutiesIdList,
          'requestedDutiesIdList': requestedDutiesIdList
        };
        scope.loading = true;
        BucketFactory.createProposal(proposal, function (responseData) {
          displayMessage("Proposal has been sent", false);
          scope.loading = false;
          updateProposal(responseData.data.data);
          if (scope.proposal.HasMultiDuties) {
            scope.refresh(); //needed in order to hide other duty from same proposal
          }
        })["catch"](function () {
          displayMessage("Failed to sent proposal.", true);
          scope.loading = false;
        });
      }

      /**
       * Approves/Rejects proposal
       * @memberof proposal
       * @param {boolean} isApproved
       */
      function evaluateProposal(isApproved) {
        var proposal = {};
        proposal.Id = scope.proposal.Id;
        proposal.isApproved = isApproved;
        var onSuccessMessage, onFailureMessage;
        if (isApproved) {
          proposal.Status = "Approved";
          var onSuccessMessage = "Approved proposal.";
          var onFailureMessage = "Failed to approve proposal.";
        } else {
          proposal.Status = "Rejected";
          var onSuccessMessage = "Rejected proposal.";
          var onFailureMessage = "Failed to reject proposal.";
        }
        scope.loading = true;
        BucketFactory.evaluateProposal(proposal).then(function (responseData) {
          var success = responseData.data.success;
          if (success) {
            var newProp = responseData.data.data;
            updateProposal(newProp);
            if (isApproved) {
              scope.refresh(); //needed in order to disable other proposals
            }

            displayMessage(onSuccessMessage, false);
          } else {
            displayMessage(onFailureMessage, true);
          }
        })["catch"](function () {
          displayMessage(onFailureMessage, true);
        });
        scope.loading = false;
      }

      /**
       * Reverts proposal to previous status
       * @memberof proposal
       */
      function undoProposalStatus() {
        scope.loading = true;
        var proposal = {};
        proposal.Id = scope.proposal.Id;
        var onSuccessMessage, onFailureMessage;
        if (scope.proposal.Status == "Approved" || scope.proposal.Status == "Rejected" && scope.proposal.State == 'In') {
          var onSuccessMessage = "Proposal has been reset.";
          var onFailureMessage = "Failed to reset proposal.";
        } else {
          //(scope.proposal.Status == "Pending" && scope.proposal.State=='Out')
          var onSuccessMessage = "Withdrew proposal.";
          var onFailureMessage = "Failed to withraw proposal.";
        }
        BucketFactory.undoProposalStatus(proposal.Id).then(function (responseData) {
          var previousStatus = scope.proposal.Status;
          var HasMultiDuties = scope.proposal.HasMultiDuties;
          var newProp = responseData.data.data;
          displayMessage(onSuccessMessage, false);
          scope.loading = false;
          updateProposal(newProp);
          if (previousStatus == "Approved") {
            scope.refresh(); //needed in order to enable other proposals again        
          } else if (previousStatus == "Pending" && HasMultiDuties) {
            scope.refresh(); //needed in order to show other duties from same proposal       
          }
        })["catch"](function () {
          scope.loading = false;
          displayMessage(onFailureMessage, true);
        });
      }

      /**
       * Displays error or success message
       * @memberof proposal
       * @param {string} message 
       * @param {boolean} hasErrors 
       */
      function displayMessage(message, hasErrors) {
        if (hasErrors) {
          scope.errorMessage = message;
        } else {
          scope.errorMessage = null;
        }
      }

      /**
       * Makes proposal acknowledged 
       * Available when status is 'RejectedBySTP' or status is 'Rejected' and state  is 'Out'
       * @memberof proposal
       */
      function acknowledgeProposal() {
        scope.loading = true;
        var proposalId = scope.proposal.Id;
        var onFailureMessage = "Failed to acknowledge proposal.";
        BucketFactory.acknowledgeProposal(proposalId).then(function (responseData) {
          scope.proposal.isAcknowledged = true;
          scope.loading = false;
        })["catch"](function () {
          scope.loading = false;
          displayMessage(onFailureMessage, true);
        });
      }

      /**
       * Changes proposal's first info icon depending on its state and status
       * @memberof proposal
       * @returns {string} - Icon name
       */
      function getFirstInfoIcon() {
        var icon = "";
        if (scope.proposal.Status == "Pending" && scope.proposal.State == 'Out') {
          icon = "fa-thumbs-up";
        } else if (scope.proposal.Status == "Rejected") {
          icon = "fa-thumbs-down";
        } else if (scope.proposal.Status == "Pending" && scope.proposal.State == 'In') {
          icon = "fa-thumbs-o-up";
        } else if (scope.proposal.Status == "Shared") {
          icon = "fa-bitbucket";
        } else if (scope.proposal.Status == "Approved") {
          icon = "fa fa-handshake-o";
        } else if (scope.proposal.Status == "ApprovedBySTP") {
          icon = "fa-thumbs-up";
        } else if (scope.proposal.Status == "RejectedBySTP") {
          icon = "fa-thumbs-o-down";
        }
        return icon;
      }

      /**
      * Changes proposal's second info icon depending on its state and status
      * @memberof proposal
      * @returns {string} - Icon name
      */
      function getSecondInfoIcon() {
        var icon = "";
        if (scope.proposal.Status == "Pending" && scope.proposal.State == 'Out') {
          icon = "fa-clock-o text-gray";
        } else if (scope.proposal.Status == "Pending" && scope.proposal.State == 'In') {
          icon = "fa-question-circle-o";
        }
        return icon;
      }

      /**
       * Determines second info icon's visibility
       * @memberof proposal
       * @returns {boolean}
       */
      function hasSecondInfoIcon() {
        return scope.proposal.Status == "Pending" && scope.proposal.State == 'In' || scope.proposal.Status == "Pending" && scope.proposal.State == 'Out';
      }

      /**
       * Changes column color depending on proposal's state and status
       * @memberof proposal
       * @returns {string} - Color's class
       */
      function getTextColor() {
        var textclass = "";
        if (scope.proposal.Status == "Pending" && scope.proposal.State == 'Out') {
          textclass = "text-light-blue";
        } else if (scope.proposal.Status == "Rejected") {
          textclass = "text-red";
        } else if (scope.proposal.Status == "Pending" && scope.proposal.State == 'In') {
          textclass = "text-orange";
        } else if (scope.proposal.Status == "Approved") {
          textclass = "text-green";
        } else if (scope.proposal.Status == "Shared") {
          textclass = "text-blue-gray";
        } else if (scope.proposal.Status == "ApprovedBySTP") {
          textclass = "text-green";
        } else if (scope.proposal.Status == "RejectedBySTP") {
          textclass = "text-red";
        }
        return textclass;
      }

      /**
       * Changes proposal's first action icon depending on its state and status
       * @memberof proposal
       * @returns {string} - Icon name
       */
      function getFirstActionIcon() {
        var icon = "";
        if (scope.proposal.createDisabled) {
          icon = "fa-ban text-red"; //no action permitted
        } else if (scope.proposal.Status == "Pending" && scope.proposal.State == 'Out' || scope.proposal.Status == "Approved") {
          icon = " fa-times text-gray "; //undo
        } else if (scope.proposal.Status == "Rejected" && scope.proposal.State == "In") {
          icon = " fa-times text-gray "; //undo
        } else if (scope.proposal.Status == "Pending" && scope.proposal.State == 'In' && !scope.actionDisabled) {
          icon = "fa-thumbs-o-up text-green"; //approve
        } else if (scope.proposal.Status == "Shared" && !scope.actionDisabled) {
          icon = "fa-thumbs-o-up text-light-blue"; //create
        }

        return icon;
      }

      /**
       * Changes proposal's fetch icon if create action is disabled  
       * @memberof proposal
       * @returns {string} - Icon name
       */
      function getFetchIcon() {
        var icon = "";
        if (scope.proposal.createDisabled) {
          icon = "fa-ban text-red";
        } else {
          icon = "fa-search";
        }
        return icon;
      }

      /**
       * Changes proposal's second action icon depending on its state and status
       * @memberof proposal
       * @returns {string} - Icon name
       */
      function getSecondActionIcon() {
        var icon = "";
        if (scope.proposal.Status == "Pending" && scope.proposal.State == 'In') {
          icon = "fa-thumbs-o-down text-red"; //reject
        }

        return icon;
      }

      /**
      * Determines first action icon's visibility
      * @memberof proposal
      * @returns {boolean}
      */
      function hasFirstActionIcon() {
        return !(scope.proposal.Status == "ApprovedBySTP" || scope.proposal.Status == "RejectedBySTP");
      }

      /**
       * Determines second action icon's visibility
       * @memberof proposal
       * @returns {boolean}
       */
      function hasSecondActionIcon() {
        return scope.proposal.Status == "Pending" && scope.proposal.State == 'In' || scope.proposal.Status == "Shared";
      }

      /**
       * Returns info message depending on proposal's state and status
       * @memberof proposal
       * @returns {string} - Message
       */
      function getInfoMessage() {
        var text = "";
        if (scope.proposal.Status == "Pending" && scope.proposal.State == 'Out') {
          text = "your proposal is pending";
        } else if (scope.proposal.Status == "Rejected" && scope.proposal.State == 'Out') {
          text = "your proposal has been rejected";
        } else if (scope.proposal.Status == "Rejected" && scope.proposal.State == 'In') {
          text = "you have rejected the proposal";
        } else if (scope.proposal.Status == "Pending" && scope.proposal.State == 'In') {
          text = "your response is pending";
        } else if (scope.proposal.Status == "Approved" && scope.proposal.State == 'In') {
          text = "you have accepted the proposal. Your request is sent for approval";
        } else if (scope.proposal.Status == "Approved" && scope.proposal.State == 'Out') {
          text = "your proposal has been accepted! Your request is sent for approval";
        } else if (scope.proposal.Status == "ApprovedBySTP") {
          text = "your request has been approved!";
        } else if (scope.proposal.Status == "RejectedBySTP") {
          text = "your request has been rejected by STP";
        }
        return text;
      }

      /**
       * Determines duty's endDate visibility
       * @memberof proposal
       * @returns {boolean}
       */
      function showEndDate(duty) {
        var show = false;
        var diffMin = Date.DifferenceInMinutes(duty.DutyBegin, duty.DutyEnd);
        var diffHours = diffMin / 60;
        if (diffHours >= 24) {
          //endDate will show if duty exceeds 24 hours
          show = true;
        }
        return show;
      }

      /**
       * Hides duty begin and end time if needed
       * @param {object} duty 
       */
      function showTime(duty) {
        var show = true;
        var diffMin = Date.DifferenceInMinutes(duty.DutyBegin, duty.DutyEnd);
        if (!diffMin) {
          //Time will not show if duty lasts all day (ex. Day Off: 00:00 - 00:00)
          show = false;
        }
        return show;
      }

      /**
       * Chooses first icon's action depending on proposal's state and status
       * @memberof proposal
       */
      function firstAction() {
        if (scope.proposal.Status == "Pending" && scope.proposal.State == 'Out') {
          undoProposalStatus();
        } else if (scope.proposal.Status == "Approved") {
          confirmUndoApproved();
        } else if (scope.proposal.Status == "Rejected" && scope.proposal.State == 'In') {
          undoProposalStatus();
        } else if (scope.proposal.Status == "Pending" && scope.proposal.State == 'In') {
          evaluateProposal(true); //approve
        } else if (scope.proposal.Status == "Shared" && !scope.proposal.createDisabled) {
          if (scope.errorMessage && scope.errorMessage.length > 0) {
            confirmCreateProposal(); //fetch success with errorMessage
          } else {
            createProposal();
          }
        }
      }

      /**
       * Chooses second icon's action depending on proposal's state and status
       * @memberof proposal
       */
      function secondaryAction() {
        if (scope.proposal.Status == "Pending" && scope.proposal.State == 'In') {
          evaluateProposal(false); // reject proposal
        }
      }

      /**
      * Opens confirmation modal when undo is requested on an approved proposal
      * @memberof proposal
      */
      function confirmUndoApproved() {
        bootbox.dialog({
          message: "<strong>You are about to cancel your accepted proposal.</strong><br/><br/>",
          title: "Caution!",
          buttons: {
            confirm: {
              label: 'Confirm',
              className: "btn-danger",
              callback: function callback() {
                undoProposalStatus();
              }
            },
            cancel: {
              label: "Cancel",
              className: "btn-default",
              callback: function callback() {}
            }
          }
        });
      }

      /**
       * Opens confirmation modal when create is requested on an alternate proposal
       * @memberof proposal
       */
      function confirmCreateProposal() {
        bootbox.dialog({
          message: "<strong>Would you like to proceed with the alternate proposal?</strong><br/><br/>",
          title: "Send request",
          buttons: {
            confirm: {
              label: 'Confirm',
              className: "btn-success",
              callback: function callback() {
                createProposal();
              }
            },
            cancel: {
              label: "Cancel",
              className: "btn-default",
              callback: function callback() {}
            }
          }
        });
      }
    }
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/bucket/proposal.tpl.html',
      scope: {
        proposal: '=',
        displayMessage: '&onDisplay',
        refresh: '&onRefresh',
        actionDisabled: '=',
        currentDutyDate: '=',
        currentDutyId: '=',
        sharedCount: '='
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('ProposalInfoModalCtr', ProposalInfoModalCtr);
  /**
   * @memberof PilotReports
   * @ngdoc controller
   * @name ProposalInfoModalCtr
   * @description 
   * Shows duty crew and route info
   * @ngInject
   */

  function ProposalInfoModalCtr($scope, $uibModalInstance, ProposedDuties, RequestedDuties, Id, Status, State) {
    $scope.RequestedDuties = RequestedDuties;
    $scope.ProposedDuties = ProposedDuties;
    $scope.cancel = cancel;
    $scope.next = next;
    $scope.previous = previous;
    var allDuties = [];

    //"You give" items are put first in list
    if (Status == "Shared" || State == "Out") {
      allDuties = ProposedDuties.concat(RequestedDuties);
    } else {
      //State == "In"
      allDuties = RequestedDuties.concat(ProposedDuties);
    }
    for (var i = 0; i < allDuties.length; i++) {
      if (allDuties[i].Id == Id) {
        $scope.currentPage = i + 1;
        break;
      }
    }
    $scope.allDuties = allDuties;

    /**
     * Moves to next duty
     * @memberof ProposalInfoModalCtr
     */
    function next() {
      if ($scope.currentPage != allDuties.length) $scope.currentPage++;
    }

    /**
     * Moves to previous duty
     * @memberof ProposalInfoModalCtr
     */
    function previous() {
      if ($scope.currentPage != 1) $scope.currentPage--;
    }

    /**
     * Closes modal
     * @memberof ProposalInfoModalCtr
     */
    function cancel() {
      $uibModalInstance.close('cancel');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('AirportHotelFactory', AirportHotelFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name AirportHotelFactory
  * @description 
  *   Add, Update, Delete and Get Airport Hotels.
  * @ngInject
  */
  function AirportHotelFactory(GenericService) {
    /**
    * Initialize the AirportHotel
    * @memberof AirportHotelFactory
    */
    function Airport() {
      this.Iata = null;
      this.Hotels = null;
    }
    var objType = 'airportHotels';
    var objCallback = Airport;
    var service = {
      fromObjectList: fromObjectList,
      getAirportHotelsFromStorage: getAirportHotelsFromStorage,
      setAirportHotelsToStorage: setAirportHotelsToStorage,
      clearAirportHotelsFromStorage: clearAirportHotelsFromStorage,
      getAirportHotels: getAirportHotels,
      upsertAirportHotels: upsertAirportHotels
    };

    /**
     * Extend an array of Objects from the default airportHotel Object
     * @memberof AirportHotelFactory
     * @param {Array} objList  an Array Of airportHotel
     * @returns {Array} airportHotel
     */
    function fromObjectList(objList) {
      return GenericService.fromObjectList(objList, objCallback);
    }

    /**
     * Get airportHotels
     * @memberof AirportHotelFactory
     * @returns {Array} airportHotels
     */
    function getAirportHotelsFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    /**
     * Save airportHotels to storage
     * @memberof AirportHotelFactory
     * @param {Array} airportHotels A list of AirportHotels
     */
    function setAirportHotelsToStorage(airportHotels) {
      GenericService.saveAll(airportHotels, objType, objCallback);
    }

    /**
     * Remove the airportHotels of  the local storage
     * @memberof AirportHotelFactory
     */
    function clearAirportHotelsFromStorage() {
      GenericService.removeAll(objType, objCallback);
    }

    /**
     * Get the Hotels for a given airport
     * @memberof AirportHotelFactory
     */
    function getAirportHotels(airportIata, fltDate) {
      var all = this.getAirportHotelsFromStorage();
      if (!all) return null;
      var airport = all.filter(function (item) {
        return item.Iata == airportIata;
      });
      if (!airport || airport.length == 0) return null;

      //for each airport hotel
      //from all available hotel priorities, find the one matching the active period 
      angular.forEach(airport[0].Hotels, function (hotel) {
        var fltActiveHotels = hotel && hotel.HotelPriorities ? hotel.HotelPriorities.filter(function (item) {
          return fltDate >= item.ActiveBegin && fltDate <= item.ActiveEnd;
        }) : [];
        if (!fltActiveHotels || fltActiveHotels.length == 0) return; //hotel inactive in FltDate - ActivePriority will be undefined for this hotel
        hotel.ActivePriority = fltActiveHotels[0].PriorityNo; //set the ActivePriority field for the hotel to be displayed in UI
      });

      //we expect a single airport item per iata
      return airport[0];
      //return GenericService.fromObjectList(airport[0].Hotels, Hotel);
    }

    /**
    *  Upsert aircraft hotels
    * @memberof AirportHotelFactory
    */
    function upsertAirportHotels(airportHotels) {
      var newHotels = airportHotels.map(function (x) {
        return x.Iata;
      });
      var hotelsLS = this.getAirportHotelsFromStorage();
      hotelsLS = hotelsLS.filter(function (x) {
        return !newHotels.includes(x.Iata);
      });
      var updatedHotelsList = hotelsLS.concat(airportHotels);
      setAirportHotelsToStorage(updatedHotelsList);
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('AutolandFactory', AutolandFactory);
  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name AutolandFactory
  * @description 
  * Get and Update Crew Meals 
  * @ngInject
  */
  function AutolandFactory(GenericService, autolandSupportingAcTypes) {
    /**
     * Initialize the Autoland
     * @memberof AutolandFactory
     */
    function Autoland() {
      this.autolandCount = null;
      this.flightsLeft = 0;
      this.totalAEFlights = 0;
      this.showAutolandModal = false;
    }
    var objType = 'autoland';
    var objCallback = Autoland;
    var service = {
      getAutolandFromStorage: getAutolandFromStorage,
      setAutolandToStorage: setAutolandToStorage,
      showAutolandModal: showAutolandModal,
      canShowAutolandModal: canShowAutolandModal
    };

    /**
     * Get Autoland object from storage
     * @memberof AutolandFactory
     */
    function getAutolandFromStorage() {
      return GenericService.getOne(objType, objCallback);
    }

    /**
     * Save autolandRelated Data to storage
     * @memberof AutolandFactory
     * @param {number} AutolandOperations the number of autoland operations of current month
     * @param {object} flights the flight object of sync response
     */
    function setAutolandToStorage(AutolandOperations, flights) {
      var flightsLeft = 0;
      var totalAegeanFlights = 0;
      if (flights.length > 0) {
        var aegeanFlights = getAEFlightsForCurrentMonth(flights);
        flightsLeft = getFlightsLeftForCurrentMonth(aegeanFlights);
        totalAegeanFlights = aegeanFlights.length;
      }
      var autoland = {
        autolandCount: AutolandOperations,
        totalAEFlights: totalAegeanFlights,
        flightsLeft: flightsLeft,
        showAutolandModal: true
      };
      GenericService.saveOne(autoland, objType, objCallback);
    }
    /**
     * Update autoland object to storage
     * @memberof AutolandFactory
     * @param {bool} canShowModal whether the modal can be display
     */
    function showAutolandModal(canShowModal) {
      var autoland = GenericService.getOne(objType, objCallback);
      autoland.showAutolandModal = canShowModal;
      GenericService.saveOne(autoland, objType, objCallback);
    }
    /**
     * Gets the value of showAutolandModal property
     * @memberof AutolandFactory
     * @returns {bool} returns the value of showAutolandModal property
     */
    function canShowAutolandModal() {
      var autoland = GenericService.getOne(objType, objCallback);
      return autoland && autoland.showAutolandModal;
    }

    /**
     * Get the count of fligths after the current time
     * @memberof AutolandFactory
     * @param {object} flights the flight object of sync response
     * @returns {number} returns the count of fligths after the current time
     */
    function getFlightsLeftForCurrentMonth(flights) {
      var flightDates = flights.map(function (a) {
        return a.ScheduledArrival;
      });
      var date = new Date();
      //uncomment for testig purposes
      //var date = new Date(2016, 1, 8);
      var filteredDays = flightDates.filter(function (x) {
        return moment.utc(x) >= moment.utc(date);
      });
      return filteredDays.length;
    }

    /**
     * Get Aegean Flights For Current Month
     * @memberof AutolandFactory
     * @param {object} flights the flight object of sync response
     * @returns {Array} returns array of fligths that the user is not DHC the flight is for aegean and the userposition is CP
     */
    function getAEFlightsForCurrentMonth(flights) {
      var date = new Date();
      var firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
      var lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

      //Uncomment for testing purposes
      // var firstDayOfMonth = new Date(2016, 1, 1);
      // var lastDayOfMonth = new Date(2016, 1, 30);
      return flights.filter(function (x) {
        return x.Position == "CP" && x.IsDHC == false && autolandSupportingAcTypes.includes(x.AcType) && moment.utc(x.DutyDate) >= moment.utc(firstDayOfMonth) && moment.utc(x.DutyDate) <= moment.utc(lastDayOfMonth);
      });
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('calendarNotifications', calendarNotifications);

  /**
     * @memberof PilotReports
     * @ngdoc directive
     * @name calendarNotifications
     * @restrict E
     * @description
     *   Implementation of crew meals
     *
     *   Display the notifications
     * @attr {String} draftReport 
     * @attr {String} completedReports  
     * @example
     *   Usage:
     *   <calendar-notifications draft-reports="0" completed-reports="0"></calendar-notifications>
     *   
     * @ngInject
     */
  function calendarNotifications($location, $uibModal, $route, MessageFactory, MemoFactory, AutolandFactory, ScheduleAcknowledgeFactory, LeaveRequestFactory, CheckInFactory, GroundDutyFactory, ExpiriesFactory, CrewRouteFactory, CatIIFactory, UserFactory, RequestFactory) {
    function link($scope, attrs) {
      $scope.gotoUnreadMemos = gotoUnreadMemos;
      $scope.gotoMessages = gotoMessages;
      $scope.gotoLeaves = gotoLeaves;
      $scope.reportsCounter = getReportsCounter();
      $scope.acknowledge = acknowledge;
      $scope.showPanel = false;
      $scope.showAutolandReminder = false;
      $scope.showAutolandAlert = false;
      $scope.showScheduleChangesReminder = false;
      $scope.hasScheduleChanges = false;
      $scope.openCheckIn = openCheckInModal;
      $scope.showCheckInAction = false;
      $scope.showExpiriesAlertCalendar = false;
      $scope.showPasswordExpiryAlert = false;
      $scope.expiryList = [];
      $scope.expiredExpiriesList = [];
      $scope.getBorderClass = getBorderClass;
      $scope.showSubmissionDeadlineAlertCalendar = false;
      $scope.submissionDeadline = null;
      $scope.hasManualEntry = false;
      $scope.gotoGroundDutyInfo = gotoGroundDutyInfo;
      $scope.removeManualEntry = removeManualEntry;
      $scope.daysDiff = daysDiff;
      $scope.removeFlightTrainingManualEntry = removeFlightTrainingManualEntry;
      $scope.gotoCrewRouteInfo = gotoCrewRouteInfo;
      $scope.pastTrainingsViewSummary = pastTrainingsViewSummary;
      $scope.viewPastTrainings = false;
      $scope.removePendingGDEntry = removePendingGDEntry;
      $scope.removePendingFlightEntry = removePendingFlightEntry;
      $scope.gotoFlightInfo = gotoFlightInfo;
      $scope.showExpiredExpiriesAlertCalendar = false;
      function pastTrainingsViewSummary() {
        $scope.viewPastTrainings = !$scope.viewPastTrainings;
      }
      $scope.catII = {
        showCatIIReminder: false,
        autolandCount: 0,
        flightsLeft: 0,
        totalOAFlights: 0,
        hasOAFlights: false
      };
      $scope.passwordExpiry = {
        showAlert: false,
        lastChange: null,
        daysLeft: null
      };
      function daysDiff(date) {
        var now = moment();
        var expiryDate = moment(date);
        return expiryDate.diff(now, 'days');
      }
      function getBorderClass() {
        var classStyle = '';
        if ($scope.catII.catIICount >= 2) {
          classStyle = 'border-left-green';
        } else {
          classStyle = 'border-left-orange';
        }
        return classStyle;
      }
      setupView();
      function setupView() {
        $scope.number_of_messages = MessageFactory.getMessagesFromStorage().length;
        $scope.number_of_messages_not_readen = MessageFactory.getCountOfUnreadMessages();
        $scope.leaveRequest = LeaveRequestFactory.getLeaveRequestInformation();
        $scope.leaveRequestCloseDate = $scope.leaveRequest ? moment($scope.leaveRequest.CloseDate).format('Do of MMMM') : null;

        //Get count of unread memos but remove the ones that belong in 'Training Surveys' Category
        var unreadMemosCount = 0;
        MemoFactory.getUnreadMemos(function (memos) {
          //remove memos that belong in "Training Surveys" category
          for (var i = 0; i < memos.length; i++) {
            if (memos[i].Category != "Training Surveys") {
              unreadMemosCount++;
            }
          }
          $scope.unreadMemosCount = unreadMemosCount;
          $scope.hasScheduleChanges = ScheduleAcknowledgeFactory.hasScheduleChanges();
          $scope.showCheckInAction = showCheckInAction();
          $scope.showScheduleChangesReminder = showScheduleChangesReminder();
          $scope.expiryList = ExpiriesFactory.getCrewExpiriesFromStorage();
          prepareAutolandData();
          prepareCatIIData();
          preparePasswordExpiryData();
          $scope.showExpiriesAlertCalendar = showExpiriesAlertCalendar();
          $scope.showSubmissionDeadlineAlertCalendar = showSubmissionDeadlineAlertCalendar();
          $scope.submissionDeadline = RequestFactory.getSubmissionDeadlineDateFromStorage();

          // Expiried Expiries
          $scope.showExpiredExpiriesAlertCalendar = showExpiredExpiriesAlertCalendar().then(function (result) {
            $scope.showExpiredExpiriesAlertCalendar = result;
          });
          $scope.expiredExpiriesList = ExpiriesFactory.getExpiredExpiries().then(function (list) {
            $scope.expiredExpiriesList = list;
          });
          $scope.showPanel = showNotificationPanel();
          showReminderModal();
        });

        // Used for pending trainings notification        
        $scope.manualGroundDuties = GroundDutyFactory.getManualGroundDutiesFromStorage();
        findManualEntries($scope.manualGroundDuties);
        $scope.manualFlightTrainings = CrewRouteFactory.getManualFlightTrainingsFromStorage();
        findManualFlightTrainingEntries($scope.manualFlightTrainings);

        // Get incomplete past duties
        // Ground duties            
        $scope.totalIncompleteGD = [];
        var groundDuties = GroundDutyFactory.getGroundDutiesFromStorage();
        $scope.totalIncompleteGD = groundDuties.filter(function (x) {
          return x.isManualEntry == true && !x.hasPendingCourse;
        });

        // Flight duties
        $scope.totalIncompleteFlightDuties = [];
        var crewRoutes = CrewRouteFactory.getCrewRoutesFromStorage();
        $scope.totalIncompleteFlightDuties = crewRoutes.filter(function (x) {
          return x.isManualEntry && !x.hasPendingCourse;
        });
        if ($scope.totalIncompleteGD.length > 0 || $scope.totalIncompleteFlightDuties.length > 0) {
          $scope.showPastTrainingsSummary = true;
        }
      }
      function prepareAutolandData() {
        //Get autoland procedures
        var autoland = AutolandFactory.getAutolandFromStorage();
        $scope.autolandCount = 0;
        $scope.flightsLeft = 0;
        $scope.hasAEFlights = false;
        var totalAEFlights = 0;
        if (autoland != null) {
          $scope.autolandCount = autoland.autolandCount;
          $scope.flightsLeft = autoland.flightsLeft;
          totalAEFlights = autoland.totalAEFlights;
          $scope.hasAEFlights = autoland.totalAEFlights > 0;
        }
        if ($scope.autolandCount == 0 && $scope.hasAEFlights && totalAEFlights > 4 && $scope.flightsLeft > 0 && $scope.flightsLeft < 10) {
          $scope.showAutolandAlert = true;
        }
        if (AutolandFactory.canShowAutolandModal() && $scope.autolandCount == 0 && $scope.hasAEFlights && totalAEFlights > 4 && $scope.flightsLeft > 0 && $scope.flightsLeft < 10) {
          $scope.showAutolandReminder = true;
        } else {
          $scope.showAutolandReminder = false;
        }
      }
      function preparePasswordExpiryData() {
        //update PasswordExpiry scope:
        var user = UserFactory.getUser();
        if (user && user.passwordLastChangeDate) {
          var today = new Date();
          var lastChangeDate = new Date(user.passwordLastChangeDate);
          var expirationDate = lastChangeDate.AddDays(90);
          // how many days until duty date
          // var trimmedToday = new Date(today);
          // var trimmedLastChangeDate = new Date(lastChangeDate);
          var diffDays = Date.DifferenceInDays(today.trimTime(), expirationDate.trimTime());
          $scope.passwordExpiry = {
            showAlert: diffDays && diffDays <= 14,
            lastChange: lastChangeDate,
            daysLeft: diffDays
          };
        }
      }
      function prepareCatIIData() {
        //update catII scope:
        var catII = CatIIFactory.getCatIIFromStorage();
        if (catII != null) {
          $scope.catII.catIICount = catII.catIICount;
          $scope.catII.flightsLeft = catII.flightsLeft;
          $scope.catII.totalOAFlights = catII.totalOAFlights;
          $scope.catII.hasOAFlights = catII.totalOAFlights > 0;
        }
        if (CatIIFactory.canShowCatIIModal() && $scope.catII.catIICount < 2 && $scope.catII.hasOAFlights && $scope.catII.totalOAFlights > 4 && $scope.catII.flightsLeft < 10) {
          $scope.catII.showCatIIReminder = true;
        } else {
          $scope.catII.showCatIIReminder = false;
        }
      }
      function showScheduleChangesReminder() {
        return ScheduleAcknowledgeFactory.showScheduleChangesModal();
      }
      function showCheckInAction() {
        var retVal = false;
        var checkInInfo = CheckInFactory.getCheckInInfoFromStorage();
        if (checkInInfo && checkInInfo.AimsId > 0) {
          var now = moment.utc();

          //Fetch FROM
          //Convert from Date UTC to Moment UTC

          var std = moment.utc(checkInInfo.STD);
          var minFetchTime = moment(std).add(-2, 'hours');

          //Fetch UNTIL    
          var maxFetchTime = moment(std).add(10, 'minutes');
          var isAfter = now.isAfter(minFetchTime);
          var isBefore = now.isBefore(maxFetchTime);
          if (isAfter && isBefore) {
            retVal = true;
          }

          //console.log({"isAfter":isAfter, "isBefore": isBefore, "now":now, "std":std, "minFetchTime":minFetchTime,"maxFetchTime":maxFetchTime});
        }

        return retVal;
      }
      function showNotificationPanel() {
        var showPanel = false;
        if ($scope.draftReports + $scope.completedReports > 9 || !$scope.$root.idbSupported || $scope.unreadMemosCount > 0 || $scope.number_of_messages_not_readen > 0 || $scope.hasAEFlights || $scope.catII.hasOAFlights || $scope.leaveRequest && $scope.leaveRequest.GroupStatus == 'OPEN' || $scope.hasScheduleChanges || $scope.showCheckInAction || $scope.hasManualEntry || $scope.showPastTrainingsSummary || $scope.passwordExpiry.showAlert || $scope.showSubmissionDeadlineAlertCalendar || $scope.showAutolandAlert) {
          showPanel = true;
        }
        return showPanel;
      }

      /**
      * Finds the dates with manual pending training entries on their schedule
      * @memberof CalendarCtrl        
      */
      function findManualEntries(manualDuties) {
        for (var i = 0; i < manualDuties.length; i++) {
          if (manualDuties[i].hasPendingCourse) {
            $scope.hasManualEntry = true;
            break;
          }
        }
      }
      function findManualFlightTrainingEntries(manualFlightTrainings) {
        for (var i = 0; i < manualFlightTrainings.length; i++) {
          if (manualFlightTrainings[i].hasPendingCourse) {
            $scope.hasManualEntry = true;
            break;
          }
        }
      }
      function removePendingGDEntry(groundDuty) {
        $scope.totalIncompleteGD.find(function (x) {
          return x.Id == groundDuty;
        }).isManualEntry = false;
        GroundDutyFactory.removeGroundDuty(groundDuty);
        return $scope.totalIncompleteGD;
      }
      function removePendingFlightEntry(dutyNo, dutyDay) {
        $scope.totalIncompleteFlightDuties.find(function (x) {
          return x.FlightId == dutyNo;
        }).isManualEntry = false;
        return $scope.totalIncompleteFlightDuties;
      }
      function getReportsCounter() {
        return parseInt($scope.draftReports) + parseInt($scope.completedReports);
      }
      /**
       * Redirect to Library Info with filter enabled
       * @memberof calendarNotifications
       */
      function gotoUnreadMemos() {
        $location.path('/memos/unread');
      }

      /**
      * Redirect to messages
      * @memberof calendarNotifications
      */
      function gotoMessages() {
        $location.path('/messages/');
      }

      /**
       * Redirect to leaves
       * @memberof CalendarCtrl
       */
      function gotoLeaves() {
        $location.path('/leaverequest/');
      }

      /**
      * Redirect to crewRoute Info
      * @memberof CalendarCtrl
      */
      function gotoCrewRouteInfo(dutyNo, dutyDay) {
        $location.path('/crewRoute/' + dutyNo + '/' + dutyDay);
      }

      /**
      * Redirect to groundDuty Info
      * @memberof CalendarCtrl
      */
      function gotoGroundDutyInfo(GroundDutyId) {
        $location.path('/groundDuty/' + GroundDutyId);
      }
      function gotoFlightInfo(FlightId) {
        $location.path('/flightinfo/' + FlightId);
      }

      /** Removes manual training entry */
      function removeManualEntry(groundDuty) {
        GroundDutyFactory.removeGroundDuty(groundDuty);
        $route.reload();
      }
      function removeFlightTrainingManualEntry(dutyNo, dutyDay) {
        CrewRouteFactory.removeFlightTraining(dutyNo, dutyDay);
        setupView();
        $route.reload();
      }

      /**
      * Gets showSubmissionDeadlineAlert value
      * @memberof calendarNotifications
      */
      function showSubmissionDeadlineAlertCalendar() {
        return RequestFactory.showSubmissionDeadlineAlert();
      }

      /**
       * Shows the bootbox for autoland and schedule acknowledge reminder
       * @memberof calendarNotifications
       */
      function showReminderModal() {
        var _showExpiriesReminder = ExpiriesFactory.showExpiriesModal();
        var _showSubmissionDeadlineReminder = RequestFactory.showSubmissionDeadlineModal();
        if ($scope.showAutolandReminder || $scope.catII.showCatIIReminder || $scope.showScheduleChangesReminder || _showExpiriesReminder || _showSubmissionDeadlineReminder) {
          var _submissionEndDate = null;
          if ($scope.submissionDeadline) {
            _submissionEndDate = $scope.submissionDeadline.submissionEndDate;
          }
          var modalInstance = $uibModal.open({
            templateUrl: 'views/CalendarNotifications/dlgReminderModal.html',
            controller: 'ReminderModalCtrl',
            size: 'md',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              showAutolandReminder: function showAutolandReminder() {
                return $scope.showAutolandReminder;
              },
              showCatIIReminder: function showCatIIReminder() {
                return $scope.catII.showCatIIReminder;
              },
              showScheduleChangesReminder: function showScheduleChangesReminder() {
                return $scope.showScheduleChangesReminder;
              },
              showExpiriesReminder: function showExpiriesReminder() {
                return _showExpiriesReminder;
              },
              showSubmissionDeadlineReminder: function showSubmissionDeadlineReminder() {
                return _showSubmissionDeadlineReminder;
              },
              submissionEndDate: function submissionEndDate() {
                return _submissionEndDate;
              }
            }
          });
        }
      }

      /**
      * Open the "Acknowledge schedule changes" Modal
      * @memberof CalendarCtrl
      */
      function acknowledge() {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/CalendarNotifications/dlgAcknowledgeChanges.html',
          controller: 'AcknowledgeModalCtrl',
          size: 'lg',
          backdrop: 'static',
          keyboard: false
        });
      }
      function showExpiriesAlertCalendar() {
        return ExpiriesFactory.showExpiriesAlert();
      }

      /**
      * Open Check in Modal
      * @memberof CalendarCtrl
      */
      function openCheckInModal() {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Dialogs/dlgCheckIn.html',
          controller: 'CheckInModalCtrl',
          size: 'lg',
          backdrop: 'static',
          keyboard: false
        });
      }
      function showExpiredExpiriesAlertCalendar() {
        return ExpiriesFactory.showExpiredExpiriesAlert();
      }
    }
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/CalendarNotifications/calendarNotifications.tpl.html',
      scope: {
        draftReports: '@',
        completedReports: '@',
        hasUnsetTraining: '@'
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('CatIIFactory', CatIIFactory);
  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name CatIIFactory
  * @description 
  * Get and Update Crew Meals 
  * @ngInject
  */
  function CatIIFactory(GenericService, showCatIIApprachAcTypes) {
    /**
     * Initialize the CatII
     * @memberof CatIIFactory
     */
    function CatII() {
      this.catIICount = null;
      this.flightsLeft = 0;
      this.totalOAFlights = 0;
      this.showCatIIModal = false;
    }
    var objType = 'catII';
    var objCallback = CatII;
    var service = {
      getCatIIFromStorage: getCatIIFromStorage,
      setCatIIToStorage: setCatIIToStorage,
      showCatIIModal: showCatIIModal,
      canShowCatIIModal: canShowCatIIModal
    };

    /**
     * Get CatII object from storage
     * @memberof CatIIFactory
     */
    function getCatIIFromStorage() {
      return GenericService.getOne(objType, objCallback);
    }

    /**
     * Save catIIRelated Data to storage
     * @memberof CatIIFactory
     * @param {number} CatIIOperations the number of catII operations of current month
     * @param {object} flights the flight object of sync response
     */
    function setCatIIToStorage(CatIIOperations, flights) {
      var flightsLeft = 0;
      var totalOlympicFlights = 0;
      if (flights.length > 0) {
        var oaFlights = getOAFlightsForCurrentMonth(flights);
        flightsLeft = getFlightsLeftForCurrentMonth(oaFlights);
        totalOlympicFlights = oaFlights.length;
      }
      var catII = {
        catIICount: CatIIOperations,
        totalOAFlights: totalOlympicFlights,
        flightsLeft: flightsLeft,
        showCatIIModal: true
      };
      GenericService.saveOne(catII, objType, objCallback);
    }
    /**
     * Update catII object to storage
     * @memberof CatIIFactory
     * @param {bool} canShowModal whether the modal can be display
     */
    function showCatIIModal(canShowModal) {
      var catII = GenericService.getOne(objType, objCallback);
      catII.showCatIIModal = canShowModal;
      GenericService.saveOne(catII, objType, objCallback);
    }
    /**
     * Gets the value of showCatIIModal property
     * @memberof CatIIFactory
     * @returns {bool} returns the value of showCatIIModal property
     */
    function canShowCatIIModal() {
      var catII = GenericService.getOne(objType, objCallback);
      return catII && catII.showCatIIModal;
    }

    /**
     * Get the count of fligths after the current time
     * @memberof CatIIFactory
     * @param {object} flights the flight object of sync response
     * @returns {number} returns the count of fligths after the current time
     */
    function getFlightsLeftForCurrentMonth(flights) {
      var flightDates = flights.map(function (a) {
        return a.ScheduledArrival;
      });
      var date = new Date();
      //uncomment for testig purposes
      //var date = new Date(2016, 1, 8);
      var filteredDays = flightDates.filter(function (x) {
        return moment.utc(x) >= moment.utc(date);
      });
      return filteredDays.length;
    }

    /**
     * Get Olympic air Flights For Current Month
     * @memberof CatIIFactory
     * @param {object} flights the flight object of sync response
     * @returns {Array} returns array of fligths that the user is not DHC the flight is for olympic and the userposition is CP
     */
    function getOAFlightsForCurrentMonth(flights) {
      var date = new Date();
      var firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
      var lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

      // //Uncomment for testing purposes
      //  var firstDayOfMonth = new Date(2016, 1, 1);
      //  var lastDayOfMonth = new Date(2016, 1, 30);

      return flights.filter(function (x) {
        return x.Position == "CP" && x.IsDHC == false && showCatIIApprachAcTypes.includes(x.AcType) && moment.utc(x.DutyDate) >= moment.utc(firstDayOfMonth) && moment.utc(x.DutyDate) <= moment.utc(lastDayOfMonth);
      });
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('ReminderModalCtrl', ReminderModalCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name ReminderModalCtrl
  * @description 
  * Warning Modal about autoland, medical & passport expiries and acknowledge schedule changes
  * @ngInject
  */
  function ReminderModalCtrl(submissionEndDate, showSubmissionDeadlineReminder, showAutolandReminder, showCatIIReminder, showScheduleChangesReminder, showExpiriesReminder, ExpiriesFactory, AutolandFactory, CatIIFactory, ScheduleAcknowledgeFactory, $scope, $uibModalInstance, RequestFactory) {
    $scope.cancel = cancel;
    $scope.showAutolandReminder = showAutolandReminder;
    $scope.showCatIIReminder = showCatIIReminder;
    $scope.showScheduleChangesReminder = showScheduleChangesReminder;
    $scope.showExpiriesReminder = showExpiriesReminder;
    $scope.expiryList = ExpiriesFactory.getCrewExpiriesFromStorage();
    $scope.daysDiff = daysDiff;
    $scope.showSubmissionDeadlineReminder = showSubmissionDeadlineReminder;
    $scope.submissionEndDate = submissionEndDate;

    /**
     * Calculates days left
     * @return {string} usage
     */
    function daysDiff(date) {
      var now = moment();
      var expiryDate = moment(date);
      return expiryDate.diff(now, 'days');
    }

    /**
    * Closes modal
    * @memberof ProposalInfoModalCtr
    */
    function cancel() {
      if ($scope.showAutolandReminder) {
        AutolandFactory.showAutolandModal(false);
      }
      if ($scope.showCatIIReminder) {
        CatIIFactory.showCatIIModal(false);
      }
      if ($scope.showScheduleChangesReminder) {
        ScheduleAcknowledgeFactory.updateShowScheduleChangesModal(false);
      }
      if ($scope.showExpiriesReminder) {
        ExpiriesFactory.updateShowExpiriesModal(false);
      }
      if ($scope.showSubmissionDeadlineReminder) {
        RequestFactory.updateShowSubmissionDeadlineModal(false);
      }
      $uibModalInstance.close('cancel');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('CheckInFactory', CheckInFactory);
  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name CheckInFactory
  * @description 
  *   Get list, Update list & Acknowledge schedule changes
  * @ngInject
  */
  function CheckInFactory(GenericService, $http, apiUrl) {
    /**
     * Initialize the ScheduleChanges
     * @memberof CheckInFactory
     */
    function CheckIn() {}
    var objType = 'CheckIn';
    var objCallback = CheckIn;
    var response = {
      success: false,
      message: '',
      checkInInfo: null
    };
    var service = {
      setCheckInInfoToStorage: setCheckInInfoToStorage,
      getCheckInInfoFromStorage: getCheckInInfoFromStorage,
      checkIn: checkIn,
      saveCheckInDelay: saveCheckInDelay
    };

    /**
     * Save check in info
     * @param {array} checkInInfo 
     */
    function setCheckInInfoToStorage(checkInInfo) {
      if (checkInInfo == undefined || checkInInfo == null) {
        GenericService.removeAll(objType);
      } else {
        GenericService.saveOne(checkInInfo, objType, objCallback);
      }
    }

    /**
     * Get check in info
     */
    function getCheckInInfoFromStorage() {
      return GenericService.getOne(objType, objCallback);
      ;
    }

    /**
     * Check In
     * @returns {promise} response
     */
    function checkIn(confirmed) {
      return $http.get(apiUrl + '/CrewCheckIn/CheckIn?confirmed=' + confirmed, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return updateCheckInCallBack(res);
      })["catch"](function (res) {
        return checkInFailedCallBack(res);
      });
    }

    /**
     * Update Schedule changes dates
     * @param {object} res 
     * @param {object} objectToAdd 
     * @returns {object} response
     */
    function updateCheckInCallBack(res) {
      response.success = res.data.success;
      if (res.data.success) {
        //update local storage
        setCheckInInfoToStorage(res.data.data);
        response.checkInInfo = res.data.data;
        if (response.checkInInfo && response.checkInInfo.Confirmed && response.checkInInfo.ErrorExplanation === "") {
          response.message = "Success! Check In Confirmed.";
        } else if (response.checkInInfo && !response.checkInInfo.Confirmed && response.checkInInfo.ErrorExplanation === "") {
          response.message = "Ready for Check In.";
        } else if (response.checkInInfo) {
          response.message = response.checkInInfo.ErrorExplanation;
        } else {
          response.message = "You have not pending Check In.";
        }
      } else {
        response.message = res.data.errorMessage;
      }
      return response;
    }

    /**
    * The callback function upon failure on submit
    * @returns {object} response
    */
    function checkInFailedCallBack(res) {
      response.success = false;
      response.message = "Oops! Something went wrong";

      //TODO::Check status=500 error: returns res = {data: {…}, status: 500, config: {…}, statusText: "Internal Server Error", headers: ƒ}
      // res.data.data is null
      if (res.data.data) {
        response.checkInInfo = res.data.data;
      } else {
        //log results
        console.log(res);
      }
      return response;
    }

    /**
     * Save Check In Delay
     * @returns {promise} response
     */
    function saveCheckInDelay(delayMinutes) {
      var checkInInfo = getCheckInInfoFromStorage();
      checkInInfo.DelayMinutes = +delayMinutes;
      return $http.post(apiUrl + '/CrewCheckIn/SaveCheckInDelay', checkInInfo, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return updateCheckInDelayCallBack(res);
      })["catch"](function (res) {
        return checkInFailedCallBack(res);
      });
    }
    function updateCheckInDelayCallBack(res) {
      response.success = res.data.success;
      if (res.data.success) {
        response.message = "Success! Delay message was sent.";
      } else {
        response.message = res.data.errorMessage;
      }
      return response;
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('CheckInModalCtrl', CheckInModalCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name CheckInModalCtrl
  * @description 
  * Check in Modal
  * @ngInject
  */
  function CheckInModalCtrl($scope, CheckInFactory, $route, $uibModalInstance) {
    $scope.showContent = 'actions';
    $scope.cancel = cancel;
    $scope.checkInInfo = null;
    $scope.CheckInAction = CheckInAction;
    $scope.BackToActions = BackToActions;
    $scope.ConfirmCheckIn = ConfirmCheckIn;
    $scope.SendDelayMessage = SendDelayMessage;
    $scope.GetCheckInInfoFromServer = GetCheckInInfoFromServer;
    $scope.responseObj = {
      success: false,
      message: '',
      checkInInfo: null
    };
    $scope.results = [];
    $scope.selectedDelayMinutes = 10;
    $scope.onMinutesChange = onMinutesChange;
    $scope.numberDown = numberDown;
    $scope.numberUp = numberUp;
    GetCheckInInfoFromServer();
    function GetCheckInInfoFromServer() {
      $scope.showContent = 'loading';
      var confirmCheckIn = false;
      CheckInFactory.checkIn(confirmCheckIn).then(function (res) {
        return handleRefreshResponse(res);
      })["catch"](function (res) {
        return handleRefreshResponse(res);
      });
    }
    function handleRefreshResponse(res) {
      $scope.showContent = 'actions';
      $scope.responseObj = res;
    }
    function CheckInAction() {
      $scope.showContent = 'confirm';
    }
    function BackToActions() {
      $scope.showContent = 'actions';
    }
    function ConfirmCheckIn() {
      $scope.showContent = 'loading';
      var confirmCheckIn = true;
      CheckInFactory.checkIn(confirmCheckIn).then(function (res) {
        return handleSubmitResponse(res);
      })["catch"](function (res) {
        return handleSubmitResponse(res);
      });
    }
    function handleSubmitResponse(res) {
      $scope.showContent = 'results';
      $scope.responseObj = res;
    }
    function onMinutesChange(minutes) {
      $scope.selectedDelayMinutes = minutes;
    }
    function SendDelayMessage() {
      $scope.showContent = 'loading';
      CheckInFactory.saveCheckInDelay($scope.selectedDelayMinutes).then(function (res) {
        return handleDelayMessageResponse(res);
      })["catch"](function (res) {
        return handleDelayMessageResponse(res);
      });
    }
    function handleDelayMessageResponse(res) {
      $scope.showContent = 'results';
      $scope.responseObj.success = res.success;
      $scope.responseObj.message = res.message;
    }

    /**
     * Decrease field value by 5
     */
    function numberDown(selectedDelayMinutes) {
      if (selectedDelayMinutes > 0) {
        $scope.selectedDelayMinutes = selectedDelayMinutes - 5;
      }
    }

    /**
     * Increase field value by 5
     */
    function numberUp(selectedDelayMinutes) {
      $scope.selectedDelayMinutes = selectedDelayMinutes + 5;
    }

    /**
    * Closes modal
    */
    function cancel() {
      $uibModalInstance.close('cancel');

      // if($scope.responseObj.success){
      //     $route.reload();
      // }
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('CrewExpiriesCtrl', CrewExpiriesCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name CrewExpiriesCtrl
  * @description 
  *   Set/Get the crew expiries
  * @ngInject
  */
  function CrewExpiriesCtrl($scope, ExpiriesFactory) {
    ExpiriesFactory.getAllExpiriesFromStorage().then(function (allExpiries) {
      $scope.allExpiries = (allExpiries || []).sort(function (a, b) {
        return new Date(a.ExpiryDate) - new Date(b.ExpiryDate);
      });
    });
    $scope.getHighlight = function (expiryDate) {
      //    var today = new Date('2016,07,01');
      var today = new Date();
      var expDate = new Date(expiryDate);
      var diffDays = Math.ceil((expDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
      if (diffDays < 30) {
        return '#D43F3A';
      } else if (diffDays < 90) {
        return '#FFaB5E';
      }
    };
    $scope.isNeverExpiry = function (date) {
      return date && new Date(date).getFullYear() === 9999;
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('ExpiriesFactory', ExpiriesFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name ExpiriesFactory
  * @description 
  *   Get medical & passport expiries.
  * @ngInject
  */
  function ExpiriesFactory(GenericService, IndexedDBService) {
    var objType = 'CrewExpiries';
    var objCallback = CrewExpiries;

    /**
     * Initialize the ScheduleChanges
     * @memberof ScheduleAcknowledgeFactory
     */
    function CrewExpiries() {
      this.expiries = [];
      this.showExpiriesModal = false;
    }
    var service = {
      setCrewExpiriesToStorage: setCrewExpiriesToStorage,
      getCrewExpiriesFromStorage: getCrewExpiriesFromStorage,
      showExpiriesModal: showExpiriesModal,
      showExpiriesAlert: showExpiriesAlert,
      updateShowExpiriesModal: updateShowExpiriesModal,
      setAllExpiriesToStorage: setAllExpiriesToStorage,
      getAllExpiriesFromStorage: getAllExpiriesFromStorage,
      showExpiredExpiriesAlert: showExpiredExpiriesAlert,
      getExpiredExpiries: getExpiredExpiries
    };

    /**
     * Save expiries info to storage
     * @param {array} objList A list of Crew Expiries
     */
    function setCrewExpiriesToStorage(objList) {
      if (objList != null) {
        var crewExpiries = {
          expiries: objList,
          showExpiriesModal: true
        };
        GenericService.saveOne(crewExpiries, objType, objCallback);
      }
    }

    /**
     * Get expiries info from storage
     */
    function getCrewExpiriesFromStorage() {
      return GenericService.getOne(objType, objCallback);
    }
    function setAllExpiriesToStorage(objList) {
      if (objList && Array.isArray(objList)) {
        var allExpiries = {
          expiries: objList,
          showExpiriesModal: false
        };
        IndexedDBService.removeAll("AllExpiries").then(function () {
          return IndexedDBService.addAll("AllExpiries", objList);
        })["catch"](function (error) {
          console.error("Failed to store non-medical/passport expiries:", error);
        });
      }
    }
    function getAllExpiriesFromStorage() {
      return IndexedDBService.getAll("AllExpiries");
    }

    /**
     * Shows expiries modal
     * @memberof ExpiriesFactory
     * @returns {bool} returns the value of showExpiriesModal property
     */
    function showExpiriesModal() {
      var crewExpiries = getCrewExpiriesFromStorage();
      var needsReminder = false;
      if (crewExpiries && crewExpiries.expiries && crewExpiries.showExpiriesModal) {
        needsReminder = crewExpiries.expiries.some(function (item) {
          return (item.ExpiryTypeId == 1 || item.ExpiryTypeId == 2 || item.ExpiryTypeId == 66) && item.NeedsHardAlert;
        });
      }
      return needsReminder;
    }

    /**
     * Shows expiries alert
     * @memberof ExpiriesFactory
     * @returns {bool} returns the value of showExpiriesAlert property
     */
    function showExpiriesAlert() {
      var crewExpiries = getCrewExpiriesFromStorage();
      var needsAlert = false;
      if (crewExpiries && crewExpiries.expiries) {
        needsAlert = crewExpiries.expiries.some(function (item) {
          return (item.ExpiryTypeId == 1 || item.ExpiryTypeId == 2 || item.ExpiryTypeId == 66) && item.NeedsSoftAlert;
        });
      }
      return needsAlert;
    }

    /* Update expiries modal object to storage
    * @memberof ExpiriesFactory
    * @param {bool} canShowModal whether the modal can be displayed
    */
    function updateShowExpiriesModal(canShowModal) {
      var crewExpiries = getCrewExpiriesFromStorage();
      crewExpiries.showExpiriesModal = canShowModal;
      GenericService.saveOne(crewExpiries, objType, objCallback);
    }
    function showExpiredExpiriesAlert() {
      return getExpiredExpiries().then(function (expiredItems) {
        return expiredItems.length > 0;
      });
    }
    function getExpiredExpiries() {
      return getAllExpiriesFromStorage().then(function (crewExpiries) {
        //    var today = new Date('2016,07,01');
        var today = new Date();
        var expiredItems = crewExpiries.filter(function (item) {
          var expiryDate = new Date(item.ExpiryDate);
          var isExpired = expiryDate < today;
          var isNotMedicalOrPassport = item.ExpiryTypeId != 1 && item.ExpiryTypeId != 2 && item.ExpiryTypeId != 66;
          return isExpired && isNotMedicalOrPassport;
        });
        return expiredItems;
      });
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('DataCleanerFactory', DataCleanerFactory);

  /**
   * @memberof PilotReports
   * @ngdoc factory
   * @name DataCleanerFactory
   * @description 
   *   Cleans the Data of the application
   * @ngInject
   */
  function DataCleanerFactory(localStorageMD5Service, IndexedDBService, GenericService) {
    var objCallbackRatings = objCallbackRatings;
    var service = {
      deleteAllReports: deleteAllReports,
      deleteAllServerData: deleteAllServerData,
      deleteAllData: deleteAllData,
      deleteOrphanedLocalFlights: deleteOrphanedLocalFlights,
      deleteOrphanedLocalReports: deleteOrphanedLocalReports,
      deleteSynchedLocalPilotReports: deleteSynchedLocalPilotReports,
      deleteOldCrewMealsRatings: deleteOldCrewMealsRatings
    };
    /**
     * Delete All Pilot Reports
     * @memberof DataCleanerFactory
     */
    function deleteAllReports() {
      localStorageMD5Service.remove('pilotReportLocalEdits');
      localStorageMD5Service.remove('pilotReportLocalEdit_TEMP');
      deleteOrphanedLocalFlights();
    }
    ;

    /**
     * Delete Basic Server data
     * @memberof DataCleanerFactory
     */
    function deleteAllServerData() {
      localStorageMD5Service.remove('flights');
      localStorageMD5Service.remove('reportGuids');
      localStorageMD5Service.remove('aircraftTypes');
      localStorageMD5Service.remove('pilotReportTemplate');
      localStorageMD5Service.remove('syncLog');
      localStorageMD5Service.remove('pilotReportSyncResults');
      localStorageMD5Service.remove('FAQItem');
      localStorageMD5Service.remove('PaxInfo');
      localStorageMD5Service.remove('scheduleChanges');
      localStorageMD5Service.remove('CheckIn');
      localStorageMD5Service.remove('flightCheckIns');
      deleteOrphanedLocalFlights();
    }
    ;

    /**
     * Delete All Server data
     * @memberof DataCleanerFactory
     */
    function deleteAllData() {
      localStorageMD5Service.clearAll();
      IndexedDBService.deleteDatabase();
    }
    ;

    /**
     * Delete local flights that have no stored local reports
     * @memberof DataCleanerFactory
     */
    function deleteOrphanedLocalFlights() {
      var existingLocalFlights = localStorageMD5Service.get('localFlights');
      if (existingLocalFlights == null) return;
      var finalLocalFlights = new Array();
      var pilotReportLocalEdits = localStorageMD5Service.get('pilotReportLocalEdits');
      if (pilotReportLocalEdits == null) pilotReportLocalEdits = new Array();

      // check every local flight that has a saved pilot report
      for (var i = 0; i < existingLocalFlights.length; i++) {
        var hasPilotReport = false;
        for (var j = 0; j < pilotReportLocalEdits.length; j++) {
          if (pilotReportLocalEdits[j].FlightId != null && pilotReportLocalEdits[j].FlightId == existingLocalFlights[i].FlightId || pilotReportLocalEdits[j].FlightAimsId != null && pilotReportLocalEdits[j].FlightAimsId == existingLocalFlights[i].FlightAimsId) {
            hasPilotReport = true;
            break;
          }
        }

        // if it has a pilot report, add it to the flights to save
        if (hasPilotReport) finalLocalFlights.push(existingLocalFlights[i]);
      }

      // save the resulting local flights
      localStorageMD5Service.set('localFlights', finalLocalFlights);
    }

    /**
     * Delete local reports that have no stored local flights
     * @memberof DataCleanerFactory
     */
    function deleteOrphanedLocalReports() {
      var existingLocalPilotReports = localStorageMD5Service.get('pilotReportLocalEdits');
      var flights = localStorageMD5Service.get('flights');
      if (existingLocalPilotReports == null || flights == null || existingLocalPilotReports.length == 0 || flights.length == 0) return 0;
      var finalLocalPilotReports = new Array();
      for (var i = 0; i < existingLocalPilotReports.length; i++) {
        var remove = false;
        if (existingLocalPilotReports[i].Status == 'synched') {
          remove = true;
          if (existingLocalPilotReports[i].FlightId != null || existingLocalPilotReports[i].FlightAimsId != null) {
            for (var j = 0; j < flights.length; j++) {
              if (existingLocalPilotReports[i].FlightId != null && existingLocalPilotReports[i].FlightId == flights[j].FlightId || existingLocalPilotReports[i].FlightAimsId != null && existingLocalPilotReports[i].FlightAimsId == flights[j].FlightAimsId) {
                remove = false;
              }
            }
          }
        }
        if (!remove) finalLocalPilotReports.push(existingLocalPilotReports[i]);
      }

      // save the resulting local reports
      localStorageMD5Service.set('pilotReportLocalEdits', finalLocalPilotReports);
    }

    /**
     * Delete  Synched Local PilotReports
     * @memberof DataCleanerFactory
     */
    function deleteSynchedLocalPilotReports() {
      var existingLocalPilotReports = localStorageMD5Service.get('pilotReportLocalEdits');
      var flights = localStorageMD5Service.get('flights');
      if (existingLocalPilotReports == null || flights == null || existingLocalPilotReports.length == 0 || flights.length == 0) return 0;
      var finalLocalPilotReports = new Array();
      var deleted = 0;
      var flight = null;
      var user = localStorageMD5Service.get('user');
      ;
      // check every saved pilot report
      for (var i = 0; i < existingLocalPilotReports.length; i++) {
        var remove = false;
        if (existingLocalPilotReports[i].Status == 'synched') {
          if (existingLocalPilotReports[i].FlightId != null || existingLocalPilotReports[i].FlightAimsId != null) {
            for (var j = 0; j < flights.length; j++) {
              if (existingLocalPilotReports[i].FlightId != null && existingLocalPilotReports[i].FlightId == flights[j].FlightId || existingLocalPilotReports[i].FlightAimsId != null && existingLocalPilotReports[i].FlightAimsId == flights[j].FlightAimsId) {
                for (var h = 0; h < flights[j].pilotReports.length; h++) {
                  if (flights[j].pilotReports[h].AuthorAimsId == user.aimsId) {
                    remove = true;
                    deleted++;
                  }
                }
              }
            }
          }
        }
        if (!remove) finalLocalPilotReports.push(existingLocalPilotReports[i]);
      }

      // save the resulting local reports
      localStorageMD5Service.set('pilotReportLocalEdits', finalLocalPilotReports);
      return deleted;
    }

    /**
    * Deletes CrewMealRatings that are older than 20 days
    * @memberof DataCleanerFactory
    */
    function deleteOldCrewMealsRatings() {
      var res = GenericService.list("CrewMealRatings", objCallbackRatings);
      var lastDate = new Date();
      lastDate.setDate(lastDate.getDate() - 20);
      var crewMealIdsFiltered = res.filter(function (r) {
        return new Date(r.TimeStamp) >= lastDate;
      });
      GenericService.saveOne(crewMealIdsFiltered, "CrewMealRatings");
    }
    function objCallbackRatings() {
      this.CrewMealId = null, this.TimeStamp = null;
    }
    return service;
  }
  ;
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.filter('fltSplit', fltSplit);

  /**
  * @memberof PilotReports
  * @ngdoc filter
  * @name messageFilter
  * @description 
  *   Filters messages in order to show only the unread.
  * @ngInject
  */
  function fltSplit() {
    return function (fltSplit) {
      var formattedFltNo = fltSplit;
      if (typeof fltSplit === 'string' || fltSplit instanceof String) {
        formattedFltNo = fltSplit.replace(/(\w{2})/, '$1 ');
      }
      return formattedFltNo;
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('GenericService', GenericService);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name GenericService
  * @description 
  *    Generic add, edit or remove
  * @ngInject
  */
  function GenericService(localStorageMD5Service) {
    var objectType = null;
    var objectCallback = null;
    var service = {
      initiate: initiate,
      get: get,
      getOne: getOne,
      list: list,
      save: save,
      saveOne: saveOne,
      saveAll: saveAll,
      remove: remove,
      removeAll: removeAll,
      add: add,
      constructor: constructor,
      fromObject: fromObject,
      fromObjectList: fromObjectList
    };

    /**
     * initiate type and callback
     * @param {string} type A string which identifies the local storage name
     * @param {function} callback A callback function that behaves as a constructor
     * @memberof GenericService
     */
    function initiate(type, callback) {
      objectType = type;
      objectCallback = callback;
    }

    /**
     * Get the requested object
     * @memberof GenericService
     * @param {number} id The unique identifier
     * @param {string} type A string which identifies the local storage name
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {object} result
     */
    function get(id, type, callback) {
      initiate(type, callback);
      var objects = list(type, callback);
      if (objects == null) return null;
      var result = null;
      var arrayLength = objects.length;
      for (var i = 0; i < arrayLength; i++) {
        if (objects[i].GetId() == id) {
          result = objects[i];
          break;
        }
      }
      return result;
    }

    /**
     * Get all the objects
     * @memberof GenericService
     * @param {string} type A string which identifies the local storage name
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {array} objectList
     */
    function list(type, callback) {
      initiate(type, callback);
      var objects = localStorageMD5Service.get(objectType);
      return fromObjectList(objects, callback);
    }

    /**
     * Get the unique object of this storage
     * @memberof GenericService
     * @param {string} type A string which identifies the local storage name
     * @param {function} callback A callback function that behaves as a constructor
     * @return {object} object
     */
    function getOne(type, callback) {
      initiate(type, callback);
      var object = localStorageMD5Service.get(objectType);
      return fromObject(object, callback);
    }
    function saveOne(obj, type, callback) {
      localStorageMD5Service.set(type, obj);
    }
    function save(object, type, callback) {
      initiate(type, callback);
      var objects = list(type, callback);
      var updatedobject = fromObject(object, callback);
      var arrayLength = objects.length;
      for (var i = 0; i < arrayLength; i++) {
        if (objects[i].GetId() == updatedobject.GetId()) {
          objects[i] = updatedobject;
          break;
        }
      }
      saveAll(objects, type, callback);
    }
    function saveAll(objects, type, callback) {
      initiate(type, callback);
      localStorageMD5Service.set(objectType, objects);
    }
    function remove(Id, type, callback) {
      initiate(type, callback);
      var objects = list(type, callback);
      var newObjects = [];
      var arrayLength = objects.length;
      for (var i = 0; i < arrayLength; i++) {
        if (objects[i].GetId() != Id) {
          newObjects.push(objects[i]);
        }
      }
      saveAll(newObjects, type, callback);
    }
    function removeAll(type, callback) {
      initiate(type, callback);
      localStorageMD5Service.remove(objectType);
    }
    function add(obj, type, callback) {
      var objects = list(type, callback);
      objects.push(obj);
      saveAll(objects, type, callback);
    }
    function constructor(callback) {
      var object = new callback();
      return object;
    }
    function fromObject(obj, callback) {
      if (obj == null) return null;
      var object = new callback();
      angular.extend(object, obj);
      return object;
    }
    function fromObjectList(objList, callback) {
      if (objList == null) return [];
      var arrayLength = objList.length;
      var objects = new Array();
      for (var i = 0; i < arrayLength; i++) {
        objects.push(fromObject(objList[i], callback));
      }
      return objects;
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('GenericModalFactory', GenericModalFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name GenericModalFactory
  * @description 
  *    Initialize generic Modals
  * @ngInject
  */
  function GenericModalFactory() {
    var service = {
      createNew: createNew,
      fromObject: fromObject,
      deleteFromList: deleteFromList,
      fromObjectList: fromObjectList
    };

    /**
     * Greate new Object  based on given constructor
     * @memberof GenericModalFactory
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {object} result
     */
    function createNew(callback) {
      var result = new callback();
      result.Id = guid();
      return result;
    }

    /**
     * Extend given object 
     * @memberof GenericModalFactory
     * @param {object} obj The object that will be extended
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {object} object
     */
    function fromObject(obj, callback) {
      if (obj == null) return null;
      var object = new callback();
      angular.extend(object, obj);
      return object;
    }

    /**
     * Delete an object from given List
     * @memberof GenericModalFactory
     * @param {object} obj The object that will be removed
     * @param {array} objList A list that will be modified
     * @returns {array} objList
     */
    function deleteFromList(obj, objList) {
      // find the current item in the array (if present)
      var arrayLength = objList.length;
      var itemIndex = -1;
      for (var i = 0; i < arrayLength; i++) {
        if (objList[i].Id == obj.Id) {
          itemIndex = i;
          break;
        }
      }
      if (itemIndex >= 0) objList.splice(itemIndex, 1);
      return objList;
    }

    /**
     * Extend given object list
     * @memberof GenericModalFactory
     * @param {array} objList The list of objects that will be extended
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {object} objList
     */
    function fromObjectList(objList, callback) {
      if (objList == null) return [];
      var arrayLength = objList.length;
      var newobjList = [];
      for (var i = 0; i < arrayLength; i++) {
        var obj = new callback();
        angular.extend(obj, objList[i]);
        newobjList.push(obj);
      }
      return newobjList;
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('GenericValuesFactory', GenericValuesFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name GenericValuesFactory
  * @description 
  *    Generic add, edit or remove for list of values
  * @ngInject
  */
  function GenericValuesFactory(localStorageMD5Service) {
    var service = {
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      objList: objList,
      getValuesFromStorage: getValuesFromStorage,
      setValuesToStorage: setValuesToStorage,
      clearValuesFromStorage: clearValuesFromStorage,
      getValuesFromStorageAsStrings: getValuesFromStorageAsStrings
    };

    /**
     * Extend given object 
     * @memberof GenericValuesFactory
     * @param {object} obj The object that will be extended
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {object} object
     */
    function fromObject(obj, callback) {
      if (obj == null) return null;
      var newObj = new callback();
      newObj.Code = obj;
      return newObj;
    }

    /**
     * Extend given object list
     * @memberof GenericValuesFactory
     * @param {array} objList The list of objects that will be extended
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {object} objList
     */
    function fromObjectList(objList, callback) {
      if (objList == null) return null;
      var arrayLength = objList.length;
      var newObjList = [];
      for (var i = 0; i < arrayLength; i++) {
        var newObj = new callback();
        newObj.Code = objList[i];
        newObjList.push(newObj);
      }
      return newObjList;
    }

    /**
     * Get all the object's Code from given list
     * @memberof GenericValuesFactory
     * @param {array} objectList An object list
     * @returns {array} objectList
     */
    function objList(objList) {
      if (objList == null) return [];
      var arrayLength = objList.length;
      var newObjList = [];
      for (var i = 0; i < arrayLength; i++) {
        newObjList.push(objList[i].Code);
      }
      return newObjList;
    }

    /**
     * Get all the objects
     * @memberof GenericValuesFactory
     * @param {string} type A string which identifies the local storage name
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {array} objectList
     */
    function getValuesFromStorage(callback, type) {
      var objects = localStorageMD5Service.get(type);
      return fromObjectList(objects, callback);
    }

    /**
     * Set all the objects
     * @memberof GenericValuesFactory
     * @param {array} objects A list of objects.
     * @param {string} type A string which identifies the local storage name
     */
    function setValuesToStorage(objects, type) {
      localStorageMD5Service.set(type, objects);
    }

    /**
     * Remove all the objects
     * @memberof GenericValuesFactory
     * @param {string} type A string which identifies the local storage name
     */
    function clearValuesFromStorage(type) {
      localStorageMD5Service.remove(type);
    }

    /**
     * Get all the objects codes from local storage
     * @memberof GenericValuesFactory
     * @param {string} type A string which identifies the local storage name
     * @param {function} callback A callback function that behaves as a constructor
     * @returns {array} objectList
     */
    function getValuesFromStorageAsStrings(callback, type) {
      var result = [];
      var objs = getValuesFromStorage(callback, type);
      if (objs != null || objs != undefined) {
        for (var i = 0; i < objs.length; i++) {
          result.push(objs[i].Code);
        }
      }
      return result;
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('IndexedDBService', IndexedDBService);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name IndexedDBService
  * @description 
  *    Generic add, edit or remove for IndexedDB
  * @ngInject
  */
  function IndexedDBService($q, LogService) {
    var idbSupported = ("indexedDB" in window);
    if (!idbSupported) {
      LogService.debug("No IndexedDb is supported for this browser's version");
    }
    return {
      /**
       * initiate or update indexedDB storage
       * @memberof IndexedDBService
       * @returns {object} promise
       */
      init: function init() {
        var deferred = $q.defer();
        var request = indexedDB.open("a3.pilot.reports", 6);
        request.onupgradeneeded = function (e) {
          // The database did not previously exist, so create object stores and indexes.
          var db = request.result;
          if (e.oldVersion < 1) {
            var gameStore = db.createObjectStore("Memos", {
              keyPath: "Id"
            });
            gameStore.createIndex("id_idx", "Id", {
              unique: true
            });
          }
          if (e.oldVersion < 2) {
            var gameStore1 = db.createObjectStore("MemoImages", {
              keyPath: "imageId"
            });
            gameStore1.createIndex("id_idx", "imageId", {
              unique: true
            });
            gameStore1.createIndex("memoId", "memoId", {
              unique: false
            });
          }
          if (e.oldVersion <= 3 && !db.objectStoreNames.contains('Courses')) {
            var gameStore3 = db.createObjectStore("Courses", {
              keyPath: "Id"
            });
            gameStore3.createIndex("id_idx", "Id", {
              unique: true
            });

            // var gameStore3 = db.createObjectStore("Courses", {
            //     keyPath: ["Id", 'phaseId']
            // });
            // gameStore3.createIndex("id_idx", ["Id", 'phaseId'],{
            //     unique: true
            // });     

            // // Index on 'Id' to ensure uniqueness for each course
            // gameStore3.createIndex("id_idx", "Id", { unique: true });

            // // Index for 'Phases.PhaseId' to allow querying phases
            // gameStore3.createIndex("phaseId_idx", "CrewCoursePhases.PhaseId", { unique: false });

            var store4 = db.createObjectStore("TrainingSessions", {
              keyPath: ['day', 'courseId', 'dutyId']
            });
            store4.createIndex("id_idx", ['day', 'courseId', 'dutyId'], {
              unique: true
            });
            store4.createIndex("day_idx", "day", {
              unique: false
            });
            store4.createIndex("courseId_idx", "courseId", {
              unique: false
            });
          }
          if (e.oldVersion <= 4 && !db.objectStoreNames.contains('FlightSessions')) {
            var store = db.createObjectStore("FlightSessions", {
              keyPath: ['day', 'courseId', 'dutyNo', 'dutyDay']
            });
            store.createIndex("id_idx", ['day', 'courseId', 'dutyNo', 'dutyDay'], {
              unique: true
            });
            store.createIndex("day_idx", "day", {
              unique: false
            });
            store.createIndex("courseId_idx", "courseId", {
              unique: false
            });
          }
          if (e.oldVersion <= 5 && !db.objectStoreNames.contains('AllExpiries')) {
            var store = db.createObjectStore("AllExpiries", {
              keyPath: "ExpiryTypeId"
            });
            store.createIndex("id_idx", "ExpiryTypeId", {
              unique: true
            });
          }
        };
        request.onsuccess = function () {
          deferred.resolve(request.result);
        };
        request.onerror = function () {
          deferred.reject(request.error);
        };
        return deferred.promise;
      },
      deleteDatabase: function deleteDatabase() {
        indexedDB.deleteDatabase("a3.pilot.reports");
      },
      /**
       * Add  the  object
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @param {object} entity The object to add
       * @returns {object} promise
       */
      add: function add(storeName, entity) {
        var deferred = $q.defer();
        var add = function add(db) {
          var tx = db.transaction([storeName], "readwrite");
          var store = tx.objectStore(storeName);
          store.add(entity);
          tx.oncomplete = function (e) {
            // All requests have succeeded and the transaction has committed.
            deferred.resolve(entity.id);
          };
          tx.onerror = function (ex) {
            deferred.reject(ex);
          };
          tx.onabort = function (ex) {
            deferred.reject(ex);
          };
        };
        if (idbSupported) {
          this.init().then(add);
        } else {
          deferred.resolve();
        }
        return deferred.promise;
      },
      /**
       * Add all the  objects
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @param {array} entity The objects to add
       * @returns {object} promise
       */
      addAll: function addAll(storeName, entity) {
        var deferred = $q.defer();
        var add = function add(db) {
          var tx = db.transaction([storeName], "readwrite");
          var store = tx.objectStore(storeName);
          var count = 0;
          //Insert several objects: [{obj},{obj},{obj}]
          for (var i = 0; i < entity.length; i++) {
            store.add(entity[i]);
            count++;
          }
          tx.oncomplete = function (e) {
            // All requests have succeeded and the transaction has committed.
            deferred.resolve(count);
          };
          tx.onerror = function (ex) {
            deferred.reject(ex);
          };
          tx.onabort = function (ex) {
            deferred.reject(ex);
          };

          //db.close();
        };

        if (idbSupported) {
          this.init().then(add);
        } else {
          deferred.resolve();
        }
        return deferred.promise;
      },
      /**
       * update object
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @param {array} entity The object to update
       * @returns {object} promise
       */
      put: function put(storeName, entity) {
        var deferred = $q.defer();
        var put = function put(db) {
          var tx = db.transaction([storeName], "readwrite");
          var store = tx.objectStore(storeName);
          store.put(entity);
          tx.oncomplete = function () {
            // All requests have succeeded and the transaction has committed.
            deferred.resolve(tx.result);
          };
          tx.onerror = function () {
            deferred.reject(tx);
          };
          tx.onabort = function () {
            deferred.reject(tx);
          };
        };
        if (idbSupported) {
          this.init().then(put);
        } else {
          deferred.resolve();
        }
        return deferred.promise;
      },
      /**
       * Get the requested object by the default index
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @param {number} id The unique identifier
       * @returns {object} promise
       */
      getById: function getById(storeName, id) {
        var deferred = $q.defer();
        var getById = function getById(db) {
          var tx = db.transaction([storeName], "readonly");
          var store = tx.objectStore(storeName);
          var index = store.index("id_idx");
          var request = index.get(id);
          request.onsuccess = function () {
            deferred.resolve(request.result);
          };
          request.onerror = function () {
            deferred.reject(request.error);
          };
          tx.onabort = function () {
            deferred.reject(tx.error);
          };
        };
        if (idbSupported) {
          this.init().then(getById);
        } else {
          deferred.resolve(null);
        }
        return deferred.promise;
      },
      /**
       * Get the requested object by the selected index
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @param {string} indexName A string which identifies the index name
       * @param {number} id The unique identifier
       * @returns {object} promise
       */
      getByIndex: function getByIndex(storeName, indexName, value) {
        var deferred = $q.defer();
        var getByIndex = function getByIndex(db) {
          var tx = db.transaction([storeName], "readonly");
          var store = tx.objectStore(storeName);
          var index = store.index(indexName);
          var request = index.openCursor(IDBKeyRange.only(value)); //IDBKeyRange.only(value)
          var results = [];
          request.onsuccess = function () {
            var cursor = request.result;
            if (cursor) {
              results.push(cursor.value);
              cursor["continue"]();
            } else {
              deferred.resolve(results);
            }
          };
          request.onerror = function (r) {
            deferred.reject(r.error);
          };
          tx.onabort = function (r) {
            deferred.reject(r.error);
          };
        };
        if (idbSupported) {
          this.init().then(getByIndex);
        } else {
          deferred.resolve(null);
        }
        return deferred.promise;
      },
      /**
       * Get the all objects of the selected store
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @param {string} indexName A string which identifies the index name (optional)
       * @returns {object} promise
       */
      getAll: function getAll(storeName, indexName) {
        var deferred = $q.defer();
        if (indexName === undefined) indexName = 'id_idx';
        var all = function all(db) {
          var tx = db.transaction([storeName], "readonly");
          var store = tx.objectStore(storeName);
          //var index = store.index(indexName);

          var request = store.openCursor(); //IDBKeyRange.only("Fred")
          var results = [];
          request.onsuccess = function () {
            var cursor = request.result;
            if (cursor) {
              results.push(cursor.value);
              cursor["continue"]();
            } else {
              deferred.resolve(results);
            }
          };
          request.onerror = function () {
            deferred.reject(request.error);
          };
          tx.onabort = function () {
            deferred.reject(tx.error);
          };
        };
        if (idbSupported) {
          this.init().then(all);
        } else {
          deferred.resolve([]);
        }
        return deferred.promise;
      },
      /**
       * Count  all objects of the selected store
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @param {string} indexName A string which identifies the index name (optional)
       * @returns {object} promise
       */
      count: function count(storeName, indexName) {
        var deferred = $q.defer();
        if (indexName === undefined) indexName = 'id_idx';
        var count = function count(db) {
          var tx = db.transaction([storeName], "readonly");
          var store = tx.objectStore(storeName);
          var index = store.index(indexName);
          var request = index.count();
          request.onsuccess = function () {
            deferred.resolve(request.result);
          };
          request.onerror = function () {
            deferred.reject(request.error);
          };
          tx.onabort = function () {
            deferred.reject(tx.error);
          };
        };
        if (idbSupported) {
          this.init().then(count);
        } else {
          deferred.resolve(0);
        }
        return deferred.promise;
      },
      /**
       * Delete the requested object
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @param {number} id The unique identifier
       * @returns {object} promise
       */
      remove: function remove(storeName, id) {
        var deferred = $q.defer();
        var remove = function remove(db) {
          var tx = db.transaction([storeName], "readwrite");
          var store = tx.objectStore(storeName);
          store["delete"](id);
          tx.oncomplete = function (e) {
            // All requests have succeeded and the transaction has committed.
            deferred.resolve(id);
          };
          tx.onerror = function (r) {
            deferred.reject(r.error);
          };
          tx.onabort = function (r) {
            deferred.reject(r.error);
          };
        };
        if (idbSupported) {
          this.init().then(remove);
        } else {
          deferred.resolve();
        }
        return deferred.promise;
      },
      /**
       * Delete the requested object by the selected index
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @param {string} indexName A string which identifies the index name (optional)
       * @param {number} id The unique identifier
       * @returns {object} promise
       */
      removeByIndex: function removeByIndex(storeName, indexName, value) {
        var deferred = $q.defer();
        var removeByIndex = function removeByIndex(db) {
          var tx = db.transaction([storeName], "readwrite");
          var store = tx.objectStore(storeName);
          var index = store.index(indexName);
          var request = index.openKeyCursor(IDBKeyRange.only(value)); //IDBKeyRange.only(value)
          var results = [];
          request.onsuccess = function () {
            var cursor = request.result;
            if (cursor) {
              store["delete"](cursor.primaryKey);
              cursor["continue"]();
            } else {
              deferred.resolve(results);
            }
          };
          request.onerror = function (r) {
            deferred.reject(r.error);
          };
          tx.onabort = function (r) {
            deferred.reject(r.error);
          };
        };
        if (idbSupported) {
          this.init().then(removeByIndex);
        } else {
          deferred.resolve();
        }
        return deferred.promise;
      },
      /**
       * Delete all the objects
       * @memberof IndexedDBService
       * @param {string} storeName A string which identifies the IndexedDB storage
       * @returns {object} promise
       */
      removeAll: function removeAll(storeName) {
        var deferred = $q.defer();
        var remove = function remove(db) {
          var tx = db.transaction([storeName], "readwrite");
          var store = tx.objectStore(storeName);
          store.clear();
          tx.oncomplete = function (e) {
            // All requests have succeeded and the transaction has committed.
            deferred.resolve('success');
          };
          tx.onerror = function (r) {
            deferred.reject(r.error);
          };
          tx.onabort = function (r) {
            deferred.reject(r.error);
          };

          //db.close();
        };

        if (idbSupported) {
          this.init().then(remove);
        } else {
          deferred.resolve();
        }
        return deferred.promise;
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.service("PushNotifier", PushNotifier);

  /**
  * @memberof PilotReports
  * @ngdoc service
  * @name PushNotifier
  * @description 
  *  Push notification functionality
  * @ngInject
  */
  function PushNotifier($q, FlightFactory, PaxInfoFactory) {
    var service = {
      Generate: Generate,
      formatInfoToCompare: formatInfoToCompare,
      compareAndExtractChanges: compareAndExtractChanges,
      MessageGenerator: BodyGenerator,
      CheckForPermissionsAndSupport: CheckForPermissionsAndSupport
    };
    var browserSupportsNotifications = ("Notification" in window);
    function CheckForPermissionsAndSupport() {
      var deferred = $q.defer();

      // Let's check if the browser supports notifications
      if (!browserSupportsNotifications) {
        console.debug("This browser does not support system notifications");
        deferred.resolve(false);
      }

      // Otherwise, we need to ask the user for permission
      if (browserSupportsNotifications && Notification.permission !== 'denied') {
        var permissionQ = Notification.requestPermission();
        if (permissionQ) {
          permissionQ.then(function (result) {
            var value = result === "granted";
            deferred.resolve(value);
          }), function (reason) {
            LogService.error(reason);
            deferred.reject(reason);
          };
        } else {
          deferred.resolve(false);
        }
      } else {
        deferred.resolve(false);
      }
      return deferred.promise;
    }
    function Generate(title, body) {
      // Let's check whether notification permissions have already been granted
      if (browserSupportsNotifications && Notification.permission === "granted") {
        // If it's okay let's create a notification
        var notification = new Notification(title, {
          body: body,
          icon: './img/a3_logo.png'
        });
        setTimeout(function () {
          notification.close();
        }, 5000);
      }
    }
    function formatInfoToCompare(flightId) {
      var flightInfo = FlightFactory.getFlightFromStorage(flightId);
      var paxinfo = PaxInfoFactory.getPaxInfoFromStorage(flightId);
      var data = {
        CTOT: flightInfo.CTOT,
        ATD: flightInfo.ATD,
        ETA: flightInfo.ETA,
        ETD: flightInfo.ETD
      };
      data['Departure Gate'] = flightInfo.DepartureGate;
      data['Departure Stand'] = flightInfo.DepartureStand;
      data['Scheduled Departure Time UTC'] = flightInfo.ScheduledDepartureTimeUTC;
      data['Passenger Info'] = paxinfo ? new Date(paxinfo.LastRun).toString('dd-MM-yyyy HH:mm') : null;
      return data;
    }
    function compareAndExtractChanges(currentData, updatedData) {
      var changes = [];
      for (var key in currentData) {
        if (currentData[key] != updatedData[key]) {
          var ovalue = currentData[key];
          var nvalue = updatedData[key];
          if (key === "CTOT" || key === "ATD" || key === "ETA" || key === "ETD" || key === "Scheduled Departure Time UTC") {
            if (currentData[key] != null) {
              ovalue = moment.utc(currentData[key]).format('HH:mm');
            }
            if (updatedData[key] != null) {
              nvalue = moment.utc(updatedData[key]).format('HH:mm');
            }
          }
          changes.push({
            type: key,
            oldValue: ovalue,
            newValue: nvalue
          });
        }
      }
      return changes;
    }
    function BodyGenerator(changes) {
      var message = '';
      changes.forEach(function (x) {
        var phrase = null;
        if (x.type == 'Passenger Info') {
          phrase = "Passenger Info have been updated. \n";
        } else if (!x.oldValue) {
          phrase = x.type + ": " + x.newValue + " \n";
        } else if (x.oldValue && x.newValue) {
          phrase = x.type + ": " + x.oldValue + "\u2192" + x.newValue + " \n";
        } else {
          phrase = x.type + " has no value\n";
        }
        message = message + phrase;
      });
      return message;
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('SettingsMain', SettingsMain);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name SettingsMain
  * @description 
  *    Generic add, edit or remove
  * @ngInject
  */
  function SettingsMain(localStorageMD5Service) {
    /**
    * Initialize the PageMainSettings
    * @memberof SettingsMain
    */
    function PageMainSettings() {
      this.EditingPage = null;
      this.selectedDate = null;
    }
    var service = {
      getSettings: getSettings,
      setSettings: setSettings,
      getEditingPage: getEditingPage,
      setEditingPage: setEditingPage,
      setCalendarViewStyle: setCalendarViewStyle,
      getCalendarViewStyle: getCalendarViewStyle,
      getCalendarSelectedDate: getCalendarSelectedDate,
      setCalendarSelectedDate: setCalendarSelectedDate
    };

    /**
    * Get Application Settings
    * @memberof SettingsMain
    * @returns {object} settings 
    */
    function getSettings() {
      var settings = new PageMainSettings();
      var settingsStored = localStorageMD5Service.get('settingsMain');
      if (settingsStored) {
        if (settingsStored.EditingPage) settings.EditingPage = settingsStored.EditingPage;
        settings.calendarViewStyle = settingsStored.calendarViewStyle;
        settings.selectedDate = settingsStored.selectedDate;
      }
      return settings;
    }

    /**
        * Set Application Settings
        * @param {object} settings
        * @memberof SettingsMain
        */
    function setSettings(settings) {
      localStorageMD5Service.set('settingsMain', settings);
    }
    /**
     * Get editing page
     * @memberof SettingsMain
     * @returns {string} EditingPage
     */
    function getEditingPage() {
      var settings = getSettings();
      return settings.EditingPage;
    }
    /**
     * Set editing page
     * @param {string} value
     * @memberof SettingsMain
     */
    function setEditingPage(value) {
      var settings = getSettings();
      settings.EditingPage = value;
      setSettings(settings);
    }

    /**
        * Get prefered calendar view style
        * @memberof SettingsMain
        * @returns {string} viewStyle
        */
    function getCalendarViewStyle() {
      var settings = getSettings();
      var viewStyle = settings.calendarViewStyle;
      return viewStyle;
    }

    /**
     * Set prefered calendar view style
     * @param {string} value
     * @memberof SettingsMain
     */
    function setCalendarViewStyle(value) {
      var settings = getSettings();
      settings.calendarViewStyle = value;
      setSettings(settings);
    }

    /**
           * Get selected calendar date
           * @memberof SettingsMain
           * @returns {string} selectedDate
           */
    function getCalendarSelectedDate() {
      var settings = getSettings();
      var selectedDate = settings.selectedDate;
      return selectedDate;
    }
    /**
     * Set selected calendar date
     * @param {string} value
     * @memberof SettingsMain
     */
    function setCalendarSelectedDate(value) {
      var settings = getSettings();
      settings.selectedDate = value;
      setSettings(settings);
    }
    return service;
  }
  ;
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('TimeLogFactory', TimeLogFactory);
  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name TimeLogFactory
  * @description 
  *   Get list, Update list & Acknowledge schedule changes
  * @ngInject
  */
  function TimeLogFactory(GenericService) {
    /**
     * Initialize the ScheduleChanges
     * @memberof TimeLogFactory
     */
    function TimeLog() {
      this.Date = null;
      this.ClientTimeLog = "";
      this.ApiTimeLog = "";
    }
    var objType = 'timeLogs';
    var objCallback = TimeLog;
    var service = {
      timeLogToStorage: timeLogToStorage,
      cleanOldData: cleanOldData
    };

    /**
     * Save all time logs to storage
     * @memberof TimeLogFactory
     * @param {Array} CrewPhoneNumbers
     */
    function setTimeLogsToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }

    /**
     * get all time logs from storage
     * @memberof TimeLogFactory
     */
    function getTimeLogsFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    /**
     * Save the time log to storage
           * @memberof TimeLogFactory
     * @param  clientTimeLog 
           * @param  apiTimeLog 
     */
    function timeLogToStorage(timeLogStr, apiTimelog) {
      var timeLog = new TimeLog();
      timeLog.Date = moment.utc();
      timeLog.ClientTimeLog = timeLogStr;
      timeLog.ApiTimeLog = apiTimelog;
      GenericService.add(timeLog, objType, objCallback);
    }

    /**
    * Clean old time logs
    */
    function cleanOldData() {
      var now = moment();
      var timeLogs = getTimeLogsFromStorage();
      var latestTimeLogs = [];
      //Filter out crew check-ins of old flights
      timeLogs.forEach(function (x) {
        var date = moment(x.Date);
        if (now.diff(date, 'days') < 2) {
          latestTimeLogs.push(x);
        }
      });
      setTimeLogsToStorage(latestTimeLogs);
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.service("UpdateService", UpdateService);

  /**
  * @memberof PilotReports
  * @ngdoc service
  * @name UpdateService
  * @description 
  *  Update functionality
  * @ngInject
  */
  function UpdateService(SyncLogFactory) {
    /**
     * Version patcher
     * @memberof UpdateService
     * @returns {string} NeedsSync 
     */
    function patcher(version) {
      var NeedsSync = false;
      if (version == "1.0") {
        SyncLogFactory.updateSyncVersion("1.1");
        //patching to next version 
        //  patcher("1.1"); 
        NeedsSync = true;
      }
      return NeedsSync;
    }
    return {
      /**
       * updates application 
       * @memberof UpdateService
       * @returns {string} NeedsSync 
       */
      updater: function updater() {
        var synclog = SyncLogFactory.getSyncLog();
        if (synclog == undefined || synclog == null) {
          return false;
        } else if (synclog.isUpdated) {
          return true;
        } else {
          var NeedsSync = patcher(synclog.version);
          return NeedsSync;
        }
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.service("UtilsService", UtilsService);

  /* @ngInject */
  function UtilsService() {
    return {
      /**
       * Convert content length to fixed string
       * @static
       * @param {Number} n - number of byte kibibyte or mibi..., cannot not be NaN, indefinite or negative
       * @param {Number} [f=0] - max fraction digits in range of 0..20
       * @param {Number} [e=0] - exponent based 1024, Math.pow(1024,e) stands for the unit of n
       * @return {String}
       * @throws {RangeError}
       */
      toSizeString: function toSizeString(n, f, e) {
        n = parseFloat(n);
        f >>>= 0;
        e >>>= 0;
        if (n !== n || 1 / n < 0 || 1 / n === -1 / n || f < 0 || f > 20 || e < 0) {
          throw new RangeError("One of the three argument (number, fraction, exponent) is out of range");
        }
        var kibi = 1024,
          mibi = 1048576,
          gibi = 1073741824,
          tebi = 1099511627776;
        var v, u;
        n *= Math.pow(1024, e);
        if (n < kibi) {
          v = n.toFixed(0);
          u = "B";
        } else if (n < mibi) {
          v = (n / kibi).toFixed(f);
          u = "KB";
        } else if (n < gibi) {
          v = (n / mibi).toFixed(f);
          u = "MB";
        } else if (n < tebi) {
          v = (n / gibi).toFixed(f);
          u = "GB";
        } else {
          v = (n / tebi).toFixed(f);
          u = "TB";
        }
        return v + "" + u;
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('CrewCallCtrl', CrewCallCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name CrewCallCtrl
  * @description 
  *   View confirmation warning when clicking on a crew member's telephone - Monitor call requests
  * @ngInject
  */
  function CrewCallCtrl($scope, $uibModalInstance, crew, flightId, groundDutyId, CrewCallFactory, UserFactory, LogCallFactory) {
    $scope.close = close;
    $scope.call = call;
    $scope.beforeCall = true;
    $scope.crewFixed = null;
    if (crew.id) {
      $scope.crewFixed = crew;
    } else {
      $scope.crewFixed = {
        id: crew.Id,
        name: crew.Name,
        PhoneNumber: crew.PhoneNumber
      };
    }

    /**
     * Close the modal
     */
    function close() {
      $uibModalInstance.close(false);
    }

    /**
     * Confirm Call
     * @param {number} crewId Requested user 
     */
    function call() {
      $scope.beforeCall = false;
      var user = UserFactory.getUser();
      var logData = {
        Requester: user.id,
        Requestee: $scope.crewFixed.id,
        FlightId: flightId,
        GroundDutyId: groundDutyId,
        Date: moment.utc()
      };
      if ($scope.isOffline) {
        //Offline: save audit to local storage, send later on sync
        LogCallFactory.saveLogCall(logData);
      } else {
        //Online : API call to save audit right now
        CrewCallFactory.LogCall(logData, function (responseData) {});
      }
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('CrewCallFactory', CrewCallFactory);

  /**
   * @memberof PilotReports
   * @ngdoc factory
   * @name CrewCallFactory
   * @ngInject
   */
  function CrewCallFactory(GenericService, $http, apiUrl) {
    function CrewCall() {
      this.FlightId = null;
      this.CrewId = null;
      this.phoneNumber = null;
    }
    var objType = 'crewCall';
    var objCallback = CrewCall;
    var service = {
      getCrewCallsFromStorage: getCrewCallsFromStorage,
      setCrewCallsToStorage: setCrewCallsToStorage,
      getCrewCallFromStorage: getCrewCallFromStorage,
      getFlightCrewCallsFromStorage: getFlightCrewCallsFromStorage,
      saveCrewCall: saveCrewCall,
      cleanOldData: cleanOldData,
      LogCall: LogCall,
      cleanFlightCrewNumbers: cleanFlightCrewNumbers,
      saveFlightPhoneNumbers: saveFlightPhoneNumbers
    };

    /**
    * Get Crew Phone Numbers.
    * @memberof CrewCallFactory
    * @returns {Array} CrewPhoneNumbers 
    */
    function getCrewCallsFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    /**
     * Get Crew Phone Numbers for specified flight
     * @memberof CrewCallFactory
     * @param {number} flightId
     * @returns {Array} CrewPhoneNumbers 
     */
    function getFlightCrewCallsFromStorage(flightId) {
      var phoneNumbers = GenericService.list(objType, objCallback);
      return phoneNumbers.filter(function (x) {
        return x.FlightId == flightId;
      });
    }

    /**
     * Save Crew Phone Numbers to storage
     * @memberof CrewCallFactory
     * @param {Array} CrewPhoneNumbers
     */
    function setCrewCallsToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }

    /**
     * Get Crew Phone Number from storage 
     * @memberof CrewCallFactory
     * @param {number} crewId
     * @param {number} flightId
     * @return {object} crew phone number
     */
    function getCrewCallFromStorage(crewId, flightId) {
      var phoneNumbers = getCrewCallsFromStorage();
      return phoneNumbers.find(function (x) {
        return x.FlightId == flightId && x.CrewId == crewId;
      });
    }

    /**
    * Save a fetched crew phone number
     * @memberof CrewCallFactory
    * @param {object} crewCall 
    */
    function saveCrewCall(crewCall) {
      GenericService.add(crewCall, objType, objCallback);
    }

    /**
     * Clean ls from old flight phone numbers
     * @param {array} flights Synced flights
     */
    function cleanOldData(responseFlightIds) {
      var phoneNumbers = getCrewCallsFromStorage();
      //Filter out phone numbers of old flights
      phoneNumbers = phoneNumbers.filter(function (x) {
        return responseFlightIds.includes(x.FlightId);
      });
      var now = moment.utc();
      var keepingPhoneNumbers = [];
      phoneNumbers.forEach(function (item) {
        //Fetch FROM
        //Convert from Date UTC to Moment UTC
        var dateSTD = new Date(item.STD).fromUTC();
        var std = moment(dateSTD).utc();
        var minFetchTime = moment(std).add(-24, 'hours');

        //Fetch UNTIL
        //Convert from Date UTC to Moment UTC
        var dateSTA = new Date(item.STA).fromUTC();
        var sta = moment(dateSTA).utc();
        var maxFetchTime = moment(sta).add(2, 'hours');
        var isAfter = now.isAfter(minFetchTime);
        var isBefore = now.isBefore(maxFetchTime);
        if (isAfter && isBefore) {
          keepingPhoneNumbers.push(item);
        }
      });
      setCrewCallsToStorage(keepingPhoneNumbers);
    }

    /**
     * Log call request
     * @param {string} logData Requester, Requestee, FlightId
     * @param {function} callback 
     * @param {function} errorCallback 
     */
    function LogCall(logData, callback, errorCallback) {
      return $http.post(apiUrl + '/Info/LogCrewMemberCall', logData, {
        'Content-Type': 'application/json'
      }).then(callback)["catch"](errorCallback);
    }

    /**
     * Clean all stored phone numbers for selected flight
     * @param {number} flightId 
     */
    function cleanFlightCrewNumbers(flightId) {
      var phoneNumbers = getCrewCallsFromStorage();
      phoneNumbers = phoneNumbers.filter(function (x) {
        return x.FlightId != flightId;
      });
      setCrewCallsToStorage(phoneNumbers);
    }

    /**
     * Save any found crew phone numbers for specified flight
     * @param {number} flightId 
     * @param {array} crew 
     * @param {datetime} sta 
     * @param {datetime} std 
     */
    function saveFlightPhoneNumbers(flightId, crew, sta, std) {
      crew.forEach(function (user) {
        if (user.PhoneNumber) {
          var crewPhone = {
            FlightId: flightId,
            CrewId: user.id,
            PhoneNumber: user.PhoneNumber,
            STA: sta,
            //sta & std values will be used during sync to check timerange eligibility (-24h sta / +2h std)
            STD: std
          };
          saveCrewCall(crewPhone);
        }
      });
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('FlightCheckInsFactory', FlightCheckInsFactory);

  /**
   * @memberof PilotReports
   * @ngdoc factory
   * @name FlightCheckInsFactory
   * @ngInject
   */
  function FlightCheckInsFactory(GenericService) {
    function FlightCheckIn() {
      this.FlightId = null;
      this.CrewId = null;
      this.CheckIn = null;
      this.WillBeThereAt = null;
    }
    var objType = 'flightCheckIns';
    var objCallback = FlightCheckIn;
    var service = {
      updateFlightCrewCheckInToStorage: updateFlightCrewCheckInToStorage,
      getFlightCrewCheckInFromStorage: getFlightCrewCheckInFromStorage,
      cleanOldData: cleanOldData
    };

    /**
    * Get Crew Check-Ins.
    * @memberof CrewCallFactory
    * @returns {Array} CrewPhoneNumbers 
    */
    function getCrewCheckInFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    /**
     * Save crew checkIns to storage
     * @memberof CrewCallFactory
     * @param {Array} CrewPhoneNumbers
     */
    function setCrewCheckInToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }

    /**
     * Update Crew CheckIns for specified flight
     * @memberof CrewCallFactory
     * @param {} flight duty
     * @returns {Array} CrewFlightCrewCheckIns 
     */
    function updateFlightCrewCheckInToStorage(duty) {
      //Get all checkIns exept current flight from storage
      var storedCheckIns = getCrewCheckInFromStorage();
      var storedCheckInsFiltered = storedCheckIns.filter(function (f) {
        return f.FlightId != duty.FlightInfo.FlightId;
      });
      //Get checkIns from duty and add new crew checkIns to list
      if (duty && duty.FlightInfo && duty.FlightInfo.crew) {
        duty.FlightInfo.crew.forEach(function (item) {
          storedCheckInsFiltered.push({
            FlightId: duty.FlightInfo.FlightId,
            CrewId: item.id,
            CheckIn: item.CheckIn,
            WillBeThereAt: item.WillBeThereAt
          });
        });
        //save checkIns
        setCrewCheckInToStorage(storedCheckInsFiltered);
      }
    }

    /**
     * Get Crew CheckIns for specified flight
     * @memberof CrewCallFactory
     * @param {number} flightId
     * @returns {Array} CrewFlightCrewCheckIns 
     */
    function getFlightCrewCheckInFromStorage(flightId) {
      var storedCheckIns = getCrewCheckInFromStorage();
      return storedCheckIns.filter(function (x) {
        return x.FlightId == flightId;
      });
    }

    /**
    * Clean ls from old flights crew check-ins
    * @param {array} flights Synced flights
    */
    function cleanOldData(responseFlightIds) {
      var storedCheckIns = getCrewCheckInFromStorage();
      //Filter out crew check-ins of old flights
      var previousCheckIns = storedCheckIns.filter(function (x) {
        return responseFlightIds.includes(x.FlightId);
      });
      setCrewCheckInToStorage(previousCheckIns);
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('crewInfo', crewInfo);
  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name crewInfo
  * @restrict E
  * @description
  *   Crew Table with a double row per crew member
  * @example
  *   Usage:
  *   <crew-info></crew-info>
  * @ngInject
  */
  function crewInfo($uibModal, UserFactory, PaxInfoFactory) {
    function link(scope, element, attrs) {
      scope.user = UserFactory.getUser();
      scope.openPhoneConfirmation = openPhoneConfirmation;
      scope.showInfoRow = showInfoRow;
      scope.showArrivalFormat = showArrivalFormat;
      scope.hiddenButtonHistory = scope.aircraftroute;
      if (scope.type == "flight") {
        scope.crewMembers = scope.crew.filter(function (x) {
          return (x.position == 'CP' || x.position == "FO") && !x.isDHC;
        }).sort(function (a, b) {
          var positionOrder = ['CP', 'FO'];
          return positionOrder.indexOf(a.position) - positionOrder.indexOf(b.position);
        });
      } else if (scope.type == "cabin") {
        scope.crewMembers = scope.crew.filter(function (x) {
          return (x.position == 'SA' || x.position == "FA") && !x.isDHC;
        });
      } else {
        scope.crewMembers = scope.crew.filter(function (x) {
          return x.isDHC;
        });
        if (scope.crewMembers.length > 0 && !scope.hiddenButtonHistory) {
          PaxInfoFactory.getPaxInfoList(scope.selectedflightid, function (passengerList) {
            if (passengerList) {
              scope.crewMembers.forEach(function (crewMember) {
                var matchedPassenger = passengerList.filter(function (x) {
                  return x.IsDHC && x.Fullname.toUpperCase().includes(crewMember.name.toUpperCase());
                });
                if (matchedPassenger && matchedPassenger.length > 0) {
                  crewMember.seatNo = matchedPassenger[0].SeatNo;
                }
              });
            }
          });
        }
      }
      function openPhoneConfirmation(_crew) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/CrewInfo/dlgConfirmCrewCall.html',
          controller: 'CrewCallCtrl',
          size: 'md',
          resolve: {
            crew: function crew() {
              return _crew;
            },
            flightId: function flightId() {
              return scope.selectedflightid;
            },
            groundDutyId: function groundDutyId() {
              return null;
            }
          }
        });
        modalInstance.result.then(function (confirm) {});
      }
      function showInfoRow(item) {
        var differentUser = scope.user.aimsId != item.aimsId;
        var phoneAvailable = item.PhoneNumber && item.PhoneNumber != '';
        var previousDutyAvailable = item.PreviousDuty && item.PreviousDuty.isDifferent;
        var phonesAvailable = scope.crew.filter(function (x) {
          return x.PhoneNumber && x.PhoneNumber != '';
        }).length > 0;
        var checkInStatusAvailable = scope.crew.filter(function (x) {
          return x.CheckIn || x.WillBeThereAt;
        }).length > 0;
        return differentUser && (phoneAvailable || previousDutyAvailable || phonesAvailable || checkInStatusAvailable);
      }
      function showArrivalFormat(previousDuty) {
        var formatedArrival = '';
        var dateFormat = 'HH:mm';
        if (previousDuty.showArrivalDate) {
          dateFormat = 'dd/MM HH:mm';
        }
        if (previousDuty.ATA) {
          formatedArrival = '- A ' + moment(previousDuty.ATA).format(dateFormat);
        } else if (previousDuty.ETA) {
          formatedArrival = '- E ' + moment(previousDuty.ETA).format(dateFormat);
        } else {
          formatedArrival = '- S ' + moment(previousDuty.STA).format(dateFormat);
        }
        return formatedArrival;
      }
    }
    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/CrewInfo/crewInfo.tpl.html',
      scope: {
        crew: "=",
        type: "=",
        flightId: "="
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('crewPreviousInfo', crewPreviousInfo);
  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name crewPreviousInfo
  * @restrict E
  * @description
  *   Crew Table with a double row per crew member showing previous duty info
  * @example
  *   Usage:
  *      <crew-previous-info crew="flight.crew" type="'flight'"></crew-previous-info>
  * @ngInject
  */
  function crewPreviousInfo($uibModal, UserFactory) {
    function link(scope, element, attrs) {
      scope.user = UserFactory.getUser();
      scope.filterByPreviousDuty = filterByPreviousDuty;
      if (scope.type == "flight") {
        scope.crewMembers = scope.crew.filter(function (x) {
          return (x.position == 'CP' || x.position == "FO") && !x.isDHC;
        });
      } else if (scope.type == "cabin") {
        scope.crewMembers = scope.crew.filter(function (x) {
          return (x.position == 'SA' || x.position == "FA") && !x.isDHC;
        });
      } else {
        scope.crewMembers = scope.crew.filter(function (x) {
          return x.isDHC;
        });
      }
      function filterByPreviousDuty() {
        return function (crew) {
          return crew.PreviousDuty && crew.PreviousDuty.isDifferent;
        };
      }
    }
    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/CrewInfo/crewPreviousInfo.tpl.html',
      scope: {
        crew: "=",
        type: "="
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('LogCallFactory', LogCallFactory);

  /**
   * @memberof PilotReports
   * @ngdoc factory
   * @name LogCallFactory
   * @ngInject
   */
  function LogCallFactory(GenericService, $http, apiUrl) {
    function LogCall() {
      this.Requester = null;
      this.Requestee = null;
      this.FlightId = null;
      this.GroundDutyId = null;
      this.Date = null;
    }
    var objType = 'logCall';
    var objCallback = LogCall;
    var service = {
      getLogCallsFromStorage: getLogCallsFromStorage,
      cleanLogsFromStorage: cleanLogsFromStorage,
      saveLogCall: saveLogCall
    };

    /**
    * Get Offline Logged Calls.
    * @memberof LogCallFactory
    */
    function getLogCallsFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    /**
    * Clean local storage
    * @memberof CrewCallFactory
    */
    function cleanLogsFromStorage() {
      GenericService.removeAll(objType, objCallback);
    }

    /**
     * Save an offline call request
     * @memberof CrewCallFactory
     * @param {object} logData 
     */
    function saveLogCall(logData) {
      GenericService.add(logData, objType, objCallback);
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('PreviousDutyFactory', PreviousDutyFactory);

  /**
   * @memberof PilotReports
   * @ngdoc factory
   * @name PreviousDutyFactory
   * @ngInject
   */
  function PreviousDutyFactory(GenericService, $http, apiUrl) {
    function PreviousDuty() {
      this.FlightId = null;
      this.CrewId = null;
      this.PreviousDuty = null;
    }
    var objType = 'previousDuty';
    var objCallback = PreviousDuty;
    var service = {
      getPreviousDutiesFromStorage: getPreviousDutiesFromStorage,
      setPreviousDutiesToStorage: setPreviousDutiesToStorage,
      getPreviousDutyFromStorage: getPreviousDutyFromStorage,
      getFlightPreviousDutiesFromStorage: getFlightPreviousDutiesFromStorage,
      savePreviousDuty: savePreviousDuty,
      cleanOldData: cleanOldData,
      cleanFlightPreviousDuties: cleanFlightPreviousDuties,
      saveFlightPreviousDuties: saveFlightPreviousDuties
    };

    /**
    * Get Crew Phone Numbers.
    * @memberof PreviousDutyFactory
    * @returns {Array} PreviousDuties 
    */
    function getPreviousDutiesFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    /**
     * Get Crew Phone Numbers for specified flight
     * @memberof PreviousDutyFactory
     * @param {number} flightId
     * @returns {Array} PreviousDuties 
     */
    function getFlightPreviousDutiesFromStorage(flightId) {
      var previousDuties = GenericService.list(objType, objCallback);
      return previousDuties.filter(function (x) {
        return x.FlightId == flightId;
      });
    }

    /**
     * Save Crew Phone Numbers to storage
     * @memberof PreviousDutyFactory
     * @param {Array} PreviousDuties
     */
    function setPreviousDutiesToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }

    /**
     * Get Previous Duty from storage 
     * @memberof PreviousDutyFactory
     * @param {number} crewId
     * @param {number} flightId
     * @return {object} previous duty info
     */
    function getPreviousDutyFromStorage(crewId, flightId) {
      var previousDuties = getPreviousDutiesFromStorage();
      return previousDuties.find(function (x) {
        return x.FlightId == flightId && x.CrewId == crewId;
      });
    }

    /**
    * Save a fetched previous duty
     * @memberof PreviousDutyFactory
    * @param {object} previousDuty 
    */
    function savePreviousDuty(previousDuty) {
      GenericService.add(previousDuty, objType, objCallback);
    }

    /**
     * Clean ls from old flight previous duties
     * @param {array} flights Synced flights
     */
    function cleanOldData(responseFlightIds) {
      var previousDuties = getPreviousDutiesFromStorage();
      //Filter out previous duties of old flights
      previousDuties = previousDuties.filter(function (x) {
        return responseFlightIds.includes(x.FlightId);
      });
      setPreviousDutiesToStorage(previousDuties);
    }

    /**
     * Clean all stored previous duties for selected flight
     * @param {number} flightId 
     */
    function cleanFlightPreviousDuties(flightId) {
      var previousDuties = getPreviousDutiesFromStorage();
      previousDuties = previousDuties.filter(function (x) {
        return x.FlightId != flightId;
      });
      setPreviousDutiesToStorage(previousDuties);
    }

    /**
     * Save previous duty info for each flight crew member that has one 
     * @param {number} flightId 
     * @param {array} crew 
     */
    function saveFlightPreviousDuties(flightId, crew) {
      crew.forEach(function (user) {
        if (user.PreviousDuty) {
          var previousDuty = {
            FlightId: flightId,
            CrewId: user.id,
            PreviousDuty: user.PreviousDuty
          };
          savePreviousDuty(previousDuty);
        }
      });
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('CrewContactsModalCtrl', CrewContactsModalCtrl);
  /**
   * @memberof PilotReports
   * @ngdoc controller
   * @name CrewContactsModalCtrl
   * @description 
   * Shows crew detais with contacts 
   * @ngInject
   */

  function CrewContactsModalCtrl($scope, $timeout, $uibModalInstance, crewInfo, selectedflightid, selectedFlightNo) {
    $scope.crew = crewInfo;
    $scope.selectedflightid = selectedflightid;
    $scope.closeCrewPanel = closeCrewPanel;
    $scope.selectedFlightNo = selectedFlightNo;
    /**
     * Close the modal 
     * @memberof BucketModalCtrl
     */
    function closeCrewPanel() {
      $uibModalInstance.close();
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('CrewHotelFactory', CrewHotelFactory);
  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name CrewHotelFactory
  * @description 
  * Get hotels
  * @ngInject
  */
  function CrewHotelFactory(GenericService, showHotelsAcTypes) {
    var objType = 'crewHotel';
    var objCallback = CrewHotel;
    var service = {
      getCrewHotelsFromStorage: getCrewHotelsFromStorage,
      setCrewHotelsToStorage: setCrewHotelsToStorage,
      showHotelsInCalendar: showHotelsInCalendar
    };

    /**
    * Initialize the CrewHotel
    * @memberof CrewHotelFactory
    */
    function CrewHotel() {
      this.AimsId = null;
      this.CrewName = null;
      this.DutyDate = null;
      this.Base = null;
      this.Airport = null;
      this.HotelNo = null;
      this.HotelName = null;
      this.GroundTime = null;
    }

    /**
     * Get Crew Hotels
     * @memberof CrewHotelFactory
     * @returns {Array} CrewHotels 
     */
    function getCrewHotelsFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    /**
     * Save Crew Hotels to storage
     * @memberof GroundDutyFactory
     * @param {Array} objList A list of Crew Hotels
     */
    function setCrewHotelsToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }

    /**
     * Get flights for a specific duty date. Show hotels check depend on ac types
     * @memberof AutolandFactory
     * @param {object} flights the flight object of sync response
     * @returns {bool} showHotelsInCalendar
     */
    function showHotelsInCalendar(flights) {
      var oaFlights = flights.filter(function (x) {
        return x.IsDHC == false && showHotelsAcTypes.includes(x.AcType);
      });
      return oaFlights.length > 0;
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('CrewMealFactory', CrewMealFactory);
  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name CrewMealFactory
  * @description 
  * Get and Update Crew Meals 
  * @ngInject
  */
  function CrewMealFactory(GenericService, $http, apiUrl) {
    var objType = 'crewMeal';
    var objCallback = CrewMeal;
    var objCallbackRatings = RatingObj;
    var ratingSubmitResponseObj = {
      success: false,
      message: ''
    };
    var service = {
      getCrewMealsFromStorage: getCrewMealsFromStorage,
      setCrewMealsToStorage: setCrewMealsToStorage,
      getCrewMealFromStorage: getCrewMealFromStorage,
      sendCrewMealsRatingReport: sendCrewMealsRatingReport,
      hasRating: hasRating,
      getCrewMealsDidNotEatReasons: getCrewMealsDidNotEatReasons
    };

    /**
    * Initialize the CrewMeal
    * @memberof CrewMealFactory
    */
    function CrewMeal() {
      this.CateringMealId = null;
      this.Title = null;
      this.Description = null;
    }
    function RatingObj() {
      this.CrewMealId = null, this.TimeStamp = null;
    }

    /**
     * Get Crew Meals
     * @memberof CrewMealFactory
     * @returns {Array} CrewMeals 
     */
    function getCrewMealsFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    /**
     * Save Crew Meals to storage
     * @memberof GroundDutyFactory
     * @param {Array} objList A list of Crew Meals
     */
    function setCrewMealsToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }

    /**
    * Get a specific Crew Meal
    * @memberof CrewMealFactory
    * @returns {object} CrewMeal
    */
    function getCrewMealFromStorage(cateringMealId) {
      var crewMeals = getCrewMealsFromStorage();
      if (crewMeals == null) return [];
      var arrayLength = crewMeals.length;
      for (var i = 0; i < arrayLength; i++) {
        if (crewMeals[i].CateringMealId == cateringMealId) {
          return crewMeals[i];
        }
      }
    }

    /**
    * Checks if the specified crew meal has rating
    * @memberof CrewMealFactory
    * @returns {boolean} response
    */
    function hasRating(crewMealId) {
      var res = GenericService.list("CrewMealRatings", objCallbackRatings);
      return res.some(function (e) {
        return e.CrewMealId === crewMealId.toString();
      });
    }

    /**
    * Sends the crew meals rating report
    * @memberof CrewMealFactory
    * @returns {ratingSubmitResponseObj} ratingSubmitResponseObj
    */
    function sendCrewMealsRatingReport(ratingForm) {
      var objectToAdd = {
        CrewMealId: ratingForm.CrewMealId,
        TimeStamp: new Date()
      };
      return $http.post(apiUrl + '/CrewMealsRating/SaveReport', ratingForm, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return saveReportSuccessCallBack(res, objectToAdd);
      })["catch"](function (res) {
        return saveReportFailedCallBack(res);
      });
    }

    /**
    * The callback function if the seve report succeed
    * @returns {ratingSubmitResponseObj} ratingSubmitResponseObj
    */
    function saveReportSuccessCallBack(res, objectToAdd) {
      ratingSubmitResponseObj.success = res.data.success;
      if (res.data.success) {
        GenericService.add(objectToAdd, "CrewMealRatings", objCallbackRatings);
        ratingSubmitResponseObj.message = "Thank you for your feedback";
      } else {
        ratingSubmitResponseObj.message = res.data.errorMessage;
      }
      return ratingSubmitResponseObj;
    }

    /**
    * Gets the choices for the dropdown if a crew member did not eat their meal
    * @returns {ratingSubmitResponseObj} ratingSubmitResponseObj
    */
    function getCrewMealsDidNotEatReasons() {
      return $http.get(apiUrl + '/CrewMealsRating/GetCrewMealsDidNotEatReasons', {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return res.data;
      });
    }

    /**
    * The callback function if the seve report fail
    * @returns {ratingSubmitResponseObj} ratingSubmitResponseObj
    */
    function saveReportFailedCallBack(res) {
      ratingSubmitResponseObj.success = false;
      ratingSubmitResponseObj.message = "Something went wrong!";
      return ratingSubmitResponseObj;
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('CrewRouteCtrl', CrewRouteCtrl);
  /**
   * @memberof PilotReports
   * @ngdoc controller
   * @name CrewRouteCtrl
   * @description 
   * Shows the crew route information
   * @ngInject
   */
  function CrewRouteCtrl($scope, $filter, $routeParams, $route, FlightFactory, GroundDutyFactory, CrewRouteFactory, $location, $uibModal, SyncLogFactory) {
    var _dutyNo = $routeParams.dutyNo;
    var _dutyDay = $routeParams.dutyDay;
    $scope.crewRouteDuty = CrewRouteFactory.getCrewRouteFromStorage(_dutyNo, _dutyDay);
    var groundDuties = GroundDutyFactory.getGroundDutiesByDutyNo(_dutyNo, _dutyDay);
    if (groundDuties.length > 0) {
      //there are ground duties in this crew route
      angular.forEach(groundDuties, function (groundDuty) {
        groundDuty.DutyType = "Ground";
        groundDuty.Start = groundDuty.DutyBegin;
      });
    }
    var flights = FlightFactory.getFlightsByDutyNo(_dutyNo, _dutyDay);
    if (flights.length > 0) {
      //there are flights in this crew route
      angular.forEach(flights, function (flight) {
        flight.DutyType = "Flight";
        flight.Start = flight.ScheduledDeparture;
      });
    }
    var crewRoute = groundDuties.concat(flights);
    crewRoute = $filter('orderBy')(crewRoute, 'Start', false);
    $scope.crewRoute = crewRoute;
    $scope.currentDutyDay = null;
    $scope.differentDay = differentDay;
    $scope.currentPage = 1;
    $scope.previous = previous;
    $scope.next = next;
    $scope.openRefresh = openRefresh;
    $scope.dutyNo = _dutyNo;
    $scope.dutyDay = _dutyDay;
    $scope.firstFlightId = getFirstFlightId();

    /**
    * Get the flightId from the first leg of the route
    */
    function getFirstFlightId() {
      var flightId = null;
      if (flights.length > 0) {
        flightId = flights[0].FlightId;
      }
      return flightId;
    }

    /**
     * Checks if two dates have the same day
     * @param {string} day1 
     * @param {string} day2 
     */
    function differentDay(day1, day2) {
      day1 = new Date(day1).trimTime().getDay();
      day2 = new Date(day2).trimTime().getDay();
      return !(day1 == day2);
    }

    /**
     * Moves pager to previous page
     */
    function previous() {
      if ($scope.currentPage != 1) $scope.currentPage--;
    }

    /**
     * Moves pager to next page
     */
    function next() {
      if ($scope.currentPage != crewRoute.length) $scope.currentPage++;
    }

    /**
     * Opens refresh modal
     */
    function openRefresh() {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/CrewRoute/dlgCrewRouteRefresh.html',
        controller: 'CrewRouteRefreshModalCtrl',
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          crewroute: function crewroute() {
            return $scope.crewRoute;
          },
          crewRouteDuty: function crewRouteDuty() {
            return $scope.crewRouteDuty;
          },
          dutyNo: function dutyNo() {
            return Number(_dutyNo);
          },
          dutyDay: function dutyDay() {
            return Number(_dutyDay);
          },
          forCurrentDay: function forCurrentDay() {
            return null;
          }
        }
      });
      modalInstance.result.then(function (transferData) {
        if (transferData.sync) {
          SyncLogFactory.forceSync();
          $location.path("/"); //crew route has significantly changed
        } else if (transferData.refresh) {
          $route.reload(); //crew route was updated
        }
      });
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('CrewRouteFactory', CrewRouteFactory);
  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name CrewRouteFactory
  * @description 
  * Get and Update Crew Routes 
  * @ngInject
  */
  function CrewRouteFactory(GenericService, FlightFactory, GroundDutyFactory, $filter, AircaftPositionsFactory, CrewMealFactory, FlightDelaysFactory) {
    var objType = 'crewRoute';
    var objCallback = CrewRoute;
    var service = {
      getCrewRoutesFromStorage: getCrewRoutesFromStorage,
      setCrewRoutesToStorage: setCrewRoutesToStorage,
      setCourseCompleted: setCourseCompleted,
      setCoursePending: setCoursePending,
      updateCrewMealsInRoute: updateCrewMealsInRoute,
      updateRouteLastRefreshDate: updateRouteLastRefreshDate,
      getCrewRouteFromStorage: getCrewRouteFromStorage,
      getCrewRouteDuties: getCrewRouteDuties,
      getCrewRouteInfoPanel: getCrewRouteInfoPanel,
      updateCrewRouteDuty: updateCrewRouteDuty,
      addCrewRouteDuty: addCrewRouteDuty,
      getManualFlightTrainingsFromStorage: getManualFlightTrainingsFromStorage,
      removeFlightTraining: removeFlightTraining,
      getCrewRouteFlights: getCrewRouteFlights,
      insertCrewRoutesWithPendingTrainings: insertCrewRoutesWithPendingTrainings
    };

    /**
    * Initialize the CrewRoute
    * @memberof CrewRouteFactory
    */
    function CrewRoute() {
      this.DutyDay = null;
      this.DutyNo = null;
      this.Route = null;
      this.DutyBegin = null;
      this.DutyEnd = null;
      this.CrewMeals = [];
      this.LastRefreshed = null;
    }

    /**
     * Get Crew Routes
     * @memberof CrewRouteFactory
     * @returns {Array} CrewRoutes 
     */
    function getCrewRoutesFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    /**
     * Save Crew Routes to storage
     * @memberof GroundDutyFactory
     * @param {Array} objList A list of Crew Routes
     */
    function setCrewRoutesToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }

    /**
    * Get a specific Crew Route
    * @memberof CrewRouteFactory
    * @returns {object} CrewRoute
    */
    function getCrewRouteFromStorage(dutyNo, dutyDay) {
      var crewRoutes = getCrewRoutesFromStorage();
      if (crewRoutes == null) return [];
      var arrayLength = crewRoutes.length;
      for (var i = 0; i < arrayLength; i++) {
        if (crewRoutes[i].DutyNo == dutyNo && crewRoutes[i].DutyDay == dutyDay) {
          return crewRoutes[i];
        }
      }
    }
    function setCourseCompleted(dutyNo, dutyDay, courseId, date) {
      var crewRoutes = getCrewRoutesFromStorage();
      var crewRoute = crewRoutes.find(function (cr) {
        return cr.DutyNo == dutyNo && cr.DutyDay == dutyDay;
      });
      var flightIds = crewRoute.FlightIds;
      var flights = FlightFactory.getFlightsFromStorage().filter(function (x) {
        return flightIds.includes(x.FlightId);
      });
      var simpleCourseId = courseId;
      var phaseId = null;
      if (courseId.indexOf('_') > -1) {
        var parts = courseId.split('_');
        simpleCourseId = parts[0];
        phaseId = parts[1];
      }
      var crewRouteCourse;
      if (phaseId) {
        crewRouteCourse = crewRoute.Courses.find(function (x) {
          return x.CourseId == simpleCourseId && x.PhaseId == phaseId && moment(x.Date).isSame(date, 'day');
        });
      } else {
        crewRouteCourse = crewRoute.Courses.find(function (x) {
          return x.CourseId == simpleCourseId && moment(x.Date).isSame(date, 'day');
        });
      }
      if (crewRouteCourse) crewRouteCourse.Status = "Completed";
      flights.forEach(function (flight) {
        var flightCourse;
        if (phaseId) {
          flightCourse = flight.Courses.find(function (x) {
            return x.CourseId == simpleCourseId && x.PhaseId == phaseId && moment(x.Date).isSame(date, 'day');
          });
        } else {
          flightCourse = flight.Courses.find(function (x) {
            return x.CourseId == simpleCourseId && moment(x.Date).isSame(date, 'day');
          });
        }
        if (flightCourse) {
          flightCourse.Status = "Completed";
          FlightFactory.updateFlight(flight);
        }
      });
      GenericService.saveAll(crewRoutes, objType, objCallback);
    }
    function setCoursePending(dutyNo, dutyDay, courseId, date) {
      var crewRoutes = getCrewRoutesFromStorage();
      var crewRoute = crewRoutes.find(function (cr) {
        return cr.DutyNo == dutyNo && cr.DutyDay == dutyDay;
      });
      var crewRouteCourse = crewRoute.Courses.find(function (x) {
        return x.CourseId == courseId && new moment(x.Date).isSame(date);
      });
      if (crewRouteCourse) crewRouteCourse.Status = "Pending";
      GenericService.saveAll(crewRoutes, objType, objCallback);
    }

    /**
     * Get Crew Route Duties
     * @memberof CrewRouteFactory
     * @returns {object} crewRouteDuties
     */
    function getCrewRouteDuties(dutyNo, dutyDay, flightDate) {
      var groundDuties = GroundDutyFactory.getGroundDutiesByDutyNo(dutyNo, dutyDay).filter(function (x) {
        return x.DutyDate == flightDate;
      });
      if (groundDuties.length > 0) {
        //there are ground duties in this crew route
        angular.forEach(groundDuties, function (groundDuty) {
          groundDuty.DutyType = "Ground";
          groundDuty.Start = groundDuty.DutyBegin;
        });
      }
      var flights = getCrewRouteFlights(dutyNo, dutyDay, flightDate);
      if (flights.length > 0) {
        //there are flights in this crew route
        angular.forEach(flights, function (flight) {
          flight.DutyType = "Flight";
          flight.Start = flight.ScheduledDeparture;
          flight.showNextAcPos = false;
          flight.showPreviousAcPos = false;
          flight.hasChangeAircraft = false;
          flight.isFirst = false;
          flight.isLast = false;
          flight.BTime = "";
          flight.Delay = 0;
          flight.ArrDelay = 0;
          flight.crewMeals = "";
          flight.aircaftPositions = null;
          flight.flightDelays = null;
        });
      }
      flights = $filter('orderBy')(flights, 'Start');

      // check if aircraft change exists   
      flights.forEach(function (flight, index, array) {
        flight.isFirst = index == 0;
        flight.isLast = index + 1 == array.length;
        if (flight.isFirst) {
          flight.showPreviousAcPos = true;
        }
        if (flight.isLast) {
          flight.showNextAcPos = true;
        }
        if (!flight.isFirst && flights[index - 1].AcTailNo != flight.AcTailNo) {
          flight.showPreviousAcPos = true;
        }
        if (!flight.isLast && flights[index + 1].AcTailNo != flight.AcTailNo) {
          flight.showNextAcPos = true;
          flight.hasChangeAircraft = true;
        }
        var diffMin = Date.DifferenceInMinutes(flight.ScheduledDeparture, flight.ScheduledArrival);
        flight.BTime = Date.MinutesToStringSimple(diffMin);
        flight.Delay = moment(flight.ATD).diff(moment(flight.ScheduledDeparture), 'minutes') || "";
        flight.ArrDelay = moment(flight.ATA).diff(moment(flight.ScheduledArrival), 'minutes') || "";
        flight.aircaftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId(flight.FlightId);
        if (flight.aircaftPositions) {
          // Previous Flight
          flight.aircaftPositions.PreviousFlightDelay = moment(flight.aircaftPositions.PreviousATD).diff(moment(flight.aircaftPositions.PreviousSTD), 'minutes') || "";
          flight.aircaftPositions.PreviousFlightArrDelay = moment(flight.aircaftPositions.PreviousATA).diff(moment(flight.aircaftPositions.PreviousSTA), 'minutes') || "";
          var diffPreviousFlightMin = Date.DifferenceInMinutes(flight.aircaftPositions.PreviousSTD, flight.aircaftPositions.PreviousSTA);
          flight.aircaftPositions.PreviousFlightBTime = Date.MinutesToStringSimple(diffPreviousFlightMin);
          flight.aircaftPositions.PreviousDelays = FlightDelaysFactory.getFlightDelaysByFlightId(flight.aircaftPositions.PreviousFlightId);

          // Next Flight
          flight.aircaftPositions.NextFlightDelay = moment(flight.aircaftPositions.NextATD).diff(moment(flight.aircaftPositions.NextSTD), 'minutes') || "";
          flight.aircaftPositions.NextFlightArrDelay = moment(flight.aircaftPositions.NextATA).diff(moment(flight.aircaftPositions.NextSTA), 'minutes') || "";
          var diffNextFlightMin = Date.DifferenceInMinutes(flight.aircaftPositions.NextSTD, flight.aircaftPositions.NextSTA);
          flight.aircaftPositions.NextFlightBTime = Date.MinutesToStringSimple(diffNextFlightMin);
          flight.aircaftPositions.NextDelays = FlightDelaysFactory.getFlightDelaysByFlightId(flight.aircaftPositions.NextFlightId);
        }
        flight.flightDelays = FlightDelaysFactory.getFlightDelaysByFlightId(flight.FlightId);
      });
      var crewRouteDuties = groundDuties.concat(flights);
      crewRouteDuties = $filter('orderBy')(crewRouteDuties, 'Start');
      return crewRouteDuties;
    }

    /**
     * Get Crew Route Flights
     * @memberof CrewRouteFactory
     * @returns {object} flights
     */
    function getCrewRouteFlights(dutyNo, dutyDay, flightDate) {
      var crewRoutes = getCrewRoutesFromStorage();
      var crewRoute = crewRoutes.find(function (cr) {
        return cr.DutyNo == dutyNo && cr.DutyDay == dutyDay;
      });
      var flightIds = crewRoute.FlightIds;
      var flights = FlightFactory.getFlightsFromStorage().filter(function (x) {
        return flightIds.includes(x.FlightId) && x.FlightDate == flightDate;
      });
      return flights;
    }
    function updateCrewRouteDuty(flightTraining) {
      GenericService.updateFlight(flightTraining, objType, objCallback);
    }
    function addCrewRouteDuty(flightTraining) {
      var crewRoutes = getCrewRoutesFromStorage();
      var crewRoute = crewRoutes.find(function (cr) {
        return cr.DutyNo == flightTraining.DutyNo && cr.DutyDay == flightTraining.DutyDay;
      });
      if (crewRoute) {
        crewRoute.isManualEntry = true;
        crewRoute.hasPendingCourse = true;
      } else {
        GenericService.add(flightTraining, objType, objCallback);
      }
    }
    function removeFlightTraining(dutyNo, dutyDay) {
      var crewRoutes = getCrewRoutesFromStorage();
      var crewRoute = crewRoutes.find(function (cr) {
        return cr.DutyNo == dutyNo && cr.DutyDay == dutyDay;
      });
      crewRoute.isManualEntry = false;
      crewRoute.hasPendingCourse = false;
      GenericService.saveAll(crewRoutes, objType, objCallback);
    }

    /**Get manual flight trainings from storage*/
    function getManualFlightTrainingsFromStorage() {
      var crewRoutes = getCrewRoutesFromStorage();
      return crewRoutes.filter(function (x) {
        return x.isManualEntry;
      });
    }
    function updateCrewMealsInRoute(dutyNo, dutyDay, newCrewMeals, newFlightIds) {
      var crewRoutes = getCrewRoutesFromStorage();
      var crewRoute = crewRoutes.find(function (cr) {
        return cr.DutyNo == dutyNo && cr.DutyDay == dutyDay;
      });
      var crewMealsInRoute = crewRoute.CrewMeals.filter(function (f) {
        return !newFlightIds.includes(f.FlightId);
      });
      crewMealsInRoute = crewMealsInRoute.concat(newCrewMeals);
      crewRoute.CrewMeals = crewMealsInRoute;
      GenericService.saveAll(crewRoutes, objType, objCallback);
    }
    function insertCrewRoutesWithPendingTrainings(instructorPendingRoutes) {
      if (instructorPendingRoutes.length > 0) {
        var crewRoutes = getCrewRoutesFromStorage();
        var crewRoutesIdsLS = crewRoutes.map(function (x) {
          return x.DutyNo;
        });
        var routesToInsert = instructorPendingRoutes.filter(function (f) {
          return !crewRoutesIdsLS.includes(f.DutyNo);
        });
        if (routesToInsert.length > 0) {
          var updatedCrewRoutesList = crewRoutes.concat(routesToInsert);
          GenericService.saveAll(updatedCrewRoutesList, objType, objCallback);
        }
      }
    }

    /**
     * Update last Refresh date for a specific Crew Route
     * @memberof CrewRouteFactory
     */
    function updateRouteLastRefreshDate(dutyNo, dutyDay) {
      var crewRoutes = getCrewRoutesFromStorage();
      var crewRoute = crewRoutes.find(function (cr) {
        return cr.DutyNo == dutyNo && cr.DutyDay == dutyDay;
      });
      crewRoute.LastRefreshed = moment().toDate().toUTC();
      GenericService.saveAll(crewRoutes, objType, objCallback);
    }

    /**
     * Get Crew Route Info panel information (inside Flight-page)
     * @memberof CrewRouteFactory
     * @returns {object} flights
     */
    function getCrewRouteInfoPanel(flight) {
      var panelInfo = null;
      var crewRouteInfo = getCrewRouteFromStorage(flight.DutyNo, flight.DutyDay);
      var crewRouteDuties = getCrewRouteDuties(flight.DutyNo, flight.DutyDay, flight.FlightDate);
      var crewRouteFlightDuties = crewRouteDuties.filter(function (x) {
        return x.DutyType === "Flight";
      });
      var hasAircraftPositions = crewRouteFlightDuties.length && crewRouteFlightDuties.length > 0 && crewRouteFlightDuties[0].aircaftPositions != null;

      //update crewRouteDuties with the crewMeals
      var crewMealsPerFlightId = [];
      crewRouteInfo.CrewMeals.forEach(function (meals) {
        if (meals.CrewMealsCateringIds) {
          var crewMealsTitles = "";
          for (var j = 0; j < Object.values(meals.CrewMealsCateringIds).length; j++) {
            if (j != 0) {
              crewMealsTitles += " & ";
            }
            var crewMealDetails = CrewMealFactory.getCrewMealFromStorage(Object.values(meals.CrewMealsCateringIds)[j]);
            crewMealsTitles += crewMealDetails.ShortTitle;
          }
          crewMealsPerFlightId.push({
            flightId: meals.FlightId,
            crewMeals: crewMealsTitles
          });
        }
      });
      if (crewMealsPerFlightId.length > 0) {
        crewRouteDuties.forEach(function (duty) {
          if (duty.FlightId == crewMealsPerFlightId[0].flightId) {
            duty.crewMeals = crewMealsPerFlightId[0].crewMeals;
          }
        });
      }
      var routeNeedRefresh = false;
      if (!crewRouteInfo.LastRefreshed) {
        routeNeedRefresh = true;
      }
      return panelInfo = {
        crewRouteDuties: crewRouteDuties,
        routeNeedRefresh: routeNeedRefresh,
        hasAircraftPositions: hasAircraftPositions
      };
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('CrewRouteRefreshModalCtrl', CrewRouteRefreshModalCtrl);
  /**
   * @memberof PilotReports
   * @ngdoc controller
   * @name CrewRouteRefreshModalCtrl
   * @description 
   * 
   * @ngInject
   */

  function CrewRouteRefreshModalCtrl($scope, $filter, $uibModalInstance, crewroute, crewRouteDuty, dutyNo, dutyDay, forCurrentDay, InfoAPIService, FlightSessionFactory, CourseFactory, AirportContactFactory, CrewRouteFactory, GroundServicesFactory, AirportHotelFactory, TimeLogFactory, CrewCallFactory, PreviousDutyFactory, AimsCrewMemosFactory, FlightDelaysFactory) {
    //timer
    var t0 = performance.now();
    var timeLog = "RefreshFlight: ";
    var tFrom = 0;
    var tTo = 0;
    $scope.isRefreshing = true;
    $scope.refreshResultsVisible = false;
    $scope.error = false;
    $scope.sync = false;
    $scope.collapse = collapse;
    $scope.close = close;
    $scope.crewroute = crewroute;
    $scope.crewRouteDuty = crewRouteDuty;
    $scope.crewRouteGeneral = {
      statuses: [],
      isCollapsed: false
    };

    //For refresh Flight page: forCurrentDay is not null
    if (forCurrentDay) {
      //Get only the flights from the current day
      var currentDayDuties = crewroute.filter(function (item) {
        return item.DutyType == 'Flight' && item.FlightDate == forCurrentDay || item.DutyType == 'Ground' && item.DutyDate == forCurrentDay;
      });
      crewroute = currentDayDuties;
      $scope.crewroute = currentDayDuties;
      crewRouteDuty.CurrentDutyDate = forCurrentDay;
      if (currentDayDuties.some(function (s) {
        return s.DutyType == 'Flight';
      })) {
        $scope.crewRouteGeneral.statuses = [{
          datatype: "Meals",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Hotels",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Airport Contacts",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Ground Services",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Aims Memos",
          status: "PENDING",
          text: "Pending..."
        }];
      }
    }

    //add DataStatus to each duty
    for (var i = 0; i < crewroute.length; i++) {
      if (crewroute[i].DutyType == 'Flight') {
        crewroute[i].DataStatus = [{
          datatype: "Flight Status",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Aircraft Movement",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Crew Info",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Crew Contacts",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Pax Info",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Connections",
          status: "PENDING",
          text: "Pending..."
        }, {
          datatype: "Training Info",
          status: "PENDING",
          text: "Pending..."
        }];
      } else if (crewroute[i].DutyType == 'Ground') {
        if (crewroute[i].isTraining) {
          crewroute[i].DataStatus = [{
            datatype: "Duty Info",
            status: "PENDING",
            text: "Pending..."
          }, {
            datatype: "Instructors",
            status: "PENDING",
            text: "Pending..."
          }, {
            datatype: "Trainees",
            status: "PENDING",
            text: "Pending..."
          }];
        } else {
          crewroute[i].DataStatus = [{
            datatype: "Duty Info",
            status: "PENDING",
            text: "Pending..."
          }];
        }
      }
    }

    //separate flights and groundDuties 
    var currentFlights = [];
    var currentGroundDuties = [];
    for (var i = 0; i < crewroute.length; i++) {
      if (crewroute[i].DutyType == 'Flight') currentFlights.push(crewroute[i]);else if (crewroute[i].DutyType == 'Ground') currentGroundDuties.push(crewroute[i]);
      crewroute[i].isCollapsed = false;
    }

    //get latest info
    InfoAPIService.refreshCrewRoute(crewRouteDuty, function (responseData) {
      tTo = performance.now();
      timeLog = timeLog + " | apiResponseTime: " + (tTo - t0);
      $scope.isRefreshing = false;
      var response = responseData.data.data;
      var responseStatuses = {
        meals: false,
        airportContacts: false,
        groundServices: false,
        aircraftDifferences: false,
        airportHotels: false,
        crewAimsMemos: false
      };
      if (forCurrentDay) {
        //Update CrewMeals in the current route // only for refresh flight
        if (response.CrewMeals != undefined && response.CrewMeals != null) {
          var responseFlightIds = response.Flights.map(function (x) {
            return x.FlightInfo.FlightId;
          });
          tFrom = performance.now();
          CrewRouteFactory.updateCrewMealsInRoute(dutyNo, dutyDay, response.CrewMeals, responseFlightIds);
          responseStatuses.meals = true;
          tTo = performance.now();
          timeLog = timeLog + " | updateCrewMealsInRoute: " + (tTo - tFrom);
        }

        // Update Airport Contacts
        if (response.AirportContacts && response.AirportContacts.length > 0) {
          tFrom = performance.now();
          AirportContactFactory.upsertAirportContacts(response.AirportContacts);
          responseStatuses.airportContacts = true;
          tTo = performance.now();
          timeLog = timeLog + " | upsertAirportContacts: " + (tTo - tFrom);
        }

        // Update ground services
        if (response.GroundServices && response.GroundServices.length > 0) {
          tFrom = performance.now();
          GroundServicesFactory.upsertGroundServices(response.GroundServices);
          responseStatuses.groundServices = true;
          tTo = performance.now();
          timeLog = timeLog + " | upsertGroundServices: " + (tTo - tFrom);
        }

        // Update airport hotels
        if (response.AirportHotels && response.AirportHotels.length > 0) {
          tFrom = performance.now();
          AirportHotelFactory.upsertAirportHotels(response.AirportHotels);
          responseStatuses.airportHotels = true;
          tTo = performance.now();
          timeLog = timeLog + " | upsertAirportHotels: " + (tTo - tFrom);
        }

        // Update Aims Crew Memos
        if (response.CrewAimsMemos && response.CrewAimsMemos.length > 0) {
          tFrom = performance.now();
          AimsCrewMemosFactory.upsertAimsCrewMemos(response.CrewAimsMemos);
          responseStatuses.crewAimsMemos = true;
          tTo = performance.now();
          timeLog = timeLog + " | upsertAimsCrewMemos: " + (tTo - tFrom);
        }
      }

      //if there are significant changes in crew route user should sync
      tFrom = performance.now();
      var needsSynchCheck = needsSynch(currentFlights, response.Flights, currentGroundDuties, response.GroundDuties);
      tTo = performance.now();
      timeLog = timeLog + " | needsSynchCheck: " + (tTo - tFrom);
      if (needsSynchCheck) {
        $scope.sync = true;
      } else {
        //Manage details info and Update local storage
        if (response.Flights.length) {
          //Manage crew route statuses
          tFrom = performance.now();
          InfoAPIService.updateCrewRouteStatusSetter($scope.crewRouteGeneral.statuses, responseStatuses);
          tTo = performance.now();
          timeLog = timeLog + " | updateCrewRouteStatusSetter: " + (tTo - tFrom);
          tFrom = performance.now();
          setupFlightInfo(response.Flights);
          tTo = performance.now();
          timeLog = timeLog + " | setupFlightInfo: " + (tTo - tFrom);
          tFrom = performance.now();
          updateFlights(response.Flights);
          tTo = performance.now();
          timeLog = timeLog + " | updateFlights: " + (tTo - tFrom);

          //Save training
          tFrom = performance.now();
          response.Flights.forEach(function (flight) {
            var trainingCourses = flight.TrainingCourses;
            if (trainingCourses && trainingCourses.length && flight.FlightInfo) {
              trainingCourses.forEach(function (trainingCourse) {
                CourseFactory.upsertCourse(trainingCourse, function (course) {
                  FlightSessionFactory.applyTraineeInfoToSession(course, course.Id, new moment(flight.FlightInfo.FlightDate).format("YYYY-MM-DD"), dutyNo, dutyDay, function (session) {});
                });
              });
            }
          });
          tTo = performance.now();
          timeLog = timeLog + " | SaveTraining: " + (tTo - tFrom);
        }
        if (response.GroundDuties.length) {
          tFrom = performance.now();
          setupGroundInfo(response.GroundDuties);
          tTo = performance.now();
          timeLog = timeLog + " | setupGroundInfo: " + (tTo - tFrom);
          tFrom = performance.now();
          updateGroundDuties(response.GroundDuties);
          tTo = performance.now();
          timeLog = timeLog + " | updateGroundDuties: " + (tTo - tFrom);
        }

        // Update Flight Delays
        if (response.FlightDelays && response.FlightDelays.length > 0) {
          tFrom = performance.now();
          FlightDelaysFactory.upsertFlightDelays(response.FlightDelays);
          tTo = performance.now();
          timeLog = timeLog + " | upsertFlightDelays: " + (tTo - tFrom);
        }
        tFrom = performance.now();
        CrewRouteFactory.updateRouteLastRefreshDate(dutyNo, dutyDay);
        tTo = performance.now();
        timeLog = timeLog + " | updateRouteLastRefreshDate: " + (tTo - tFrom);
        $scope.refreshResultsVisible = true;
        tTo = performance.now();
        timeLog = timeLog + " | Start-End: " + (tTo - t0);
        TimeLogFactory.timeLogToStorage(timeLog, response.Timelog);
      }
    })["catch"](function () {
      $scope.error = true;
      $scope.isRefreshing = false;
    });

    /**
     * Checks if crew route has significantly changed and needs sync
     * @memberof CrewRouteRefreshModalCtrl
     * @param {array} currentFlights   Array of current flights
     * @param {array} newFlights       Array of newly fetched flights
     * @param {array} currentGroundDuties  Array of current ground duties
     * @param {array} newGroundDuties      Array of newly fetched ground duties
     */
    function needsSynch(currentFlights, newFlights, currentGroundDuties, newGroundDuties) {
      var sync = false;
      //1.Crew Route may not exist any more
      if (!newFlights.length && !newGroundDuties.length) {
        sync = true;
      }
      //2.Duties may have been added/removed 
      else if (newFlights.length != currentFlights.length || newGroundDuties.length != currentGroundDuties.length) {
        sync = true; //different size arrays
      } else {
        //same size arrays
        if (currentFlights.length && newFlights.length) {
          //compare current with new flights

          currentFlights = $filter('orderBy')(currentFlights, 'FlightId');
          newFlights = $filter('orderBy')(newFlights, 'FlightInfo.FlightId');
          for (var i = 0; i < currentFlights.length; i++) {
            if (newFlights[i].FlightInfo && currentFlights[i].FlightId != newFlights[i].FlightInfo.FlightId) {
              sync = true;
              break;
            }
          }
        }
        if (currentGroundDuties.length && newGroundDuties.length) {
          //compare current with new ground duties
          currentGroundDuties = $filter('orderBy')(currentGroundDuties, 'Id');
          newGroundDuties = $filter('orderBy')(newGroundDuties, 'Id');
          for (var i = 0; i < currentGroundDuties.length; i++) {
            if (currentGroundDuties[i].Id != newGroundDuties[i].Id) {
              sync = true;
              break;
            }
          }
        }
      }
      return sync;
    }

    /**
     * Updates Flight in Local Storage
     * @memberof CrewRouteRefreshModalCtrl
     * @param {array} newFlights 
     */
    function updateFlights(newFlights) {
      for (var i = 0; i < newFlights.length; i++) {
        InfoAPIService.updateFlightLocalStorage(newFlights[i]);
        InfoAPIService.updateCrewCheckIn(newFlights[i]);

        //Update previous Duties & phone calls
        //1. First remove all additional info (phone numbers & previous duties) for this flight
        CrewCallFactory.cleanFlightCrewNumbers(newFlights[i].FlightInfo.FlightId);
        PreviousDutyFactory.cleanFlightPreviousDuties(newFlights[i].FlightInfo.FlightId);
        //2. Then save any fetched info
        if (newFlights[i].FlightInfo) {
          var crew = newFlights[i].FlightInfo.crew;
          CrewCallFactory.saveFlightPhoneNumbers(newFlights[i].FlightInfo.FlightId, crew, newFlights[i].FlightInfo.ScheduledArrival, newFlights[i].FlightInfo.ScheduledDeparture);
          PreviousDutyFactory.saveFlightPreviousDuties(newFlights[i].FlightInfo.FlightId, crew);
        }
      }
    }

    /**
     * Updates Flight's Data Status
     * @memberof CrewRouteRefreshModalCtrl
     * @param {array} newFlights 
     */
    function setupFlightInfo(newFlights) {
      newFlights = $filter('orderBy')(newFlights, 'Start', false);
      currentFlights = $filter('orderBy')(currentFlights, 'Start', false);
      for (var i = 0; i < newFlights.length; i++) {
        InfoAPIService.updateFlightStatusSetter(newFlights[i], currentFlights[i].DataStatus);
      }
    }

    /**
     * Updates Ground Duty's Data Status
     * @memberof CrewRouteRefreshModalCtrl
     * @param {array} newGroundDuties 
     */
    function setupGroundInfo(newGroundDuties) {
      newGroundDuties = $filter('orderBy')(newGroundDuties, 'Start', false);
      currentGroundDuties = $filter('orderBy')(currentGroundDuties, 'Start', false);
      for (var i = 0; i < newGroundDuties.length; i++) {
        InfoAPIService.updateGroundStatusSetter(newGroundDuties[i], currentGroundDuties[i].DataStatus);
      }
    }

    /**
     * Updates Ground Duty in Local Storage
     * @memberof CrewRouteRefreshModalCtrl
     * @param {array} newFlights 
     */
    function updateGroundDuties(newGroundDuties) {
      for (var i = 0; i < newGroundDuties.length; i++) {
        InfoAPIService.updateGroundDutyLocalStorage(newGroundDuties[i]);
      }
    }

    /**
     * Shows Details 
     * @memberof CrewRouteRefreshModalCtrl
     * @param {object} duty 
     */
    function collapse(duty) {
      if (!$scope.isRefreshing && $scope.refreshResultsVisible) duty.isCollapsed = !duty.isCollapsed;
    }

    /**
     * Closes the modal
     * @memberof CrewRouteRefreshModalCtrl
     */
    function close() {
      $uibModalInstance.close({
        sync: $scope.sync,
        refresh: $scope.refreshResultsVisible
      });
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('autorefresh', autorefresh);
  function autorefresh($interval, $timeout, PushNotifier, InfoAPIService, FlightFactory, PaxInfoFactory, AircaftPositionsFactory, CrewCallFactory, PreviousDutyFactory, CrewRouteFactory) {
    function link($scope, element, attrs) {
      //$scope.flight from parent scope

      //Auto refresh functionality start
      var browserNotificationsEnabled = false;
      var autoUpdateInterval = null;
      var autoUpdateIntervalTimeOffset = null;
      $scope.showAlternativeNotifications = false;
      $scope.showAutoUpdatePanel = false;

      //Check if push notification are enabled
      PushNotifier.CheckForPermissionsAndSupport().then(function (res) {
        browserNotificationsEnabled = res;
      });
      var ScheduledDepartureTimeStamp = 0;
      if ($scope.flight) {
        ScheduledDepartureTimeStamp = moment.utc($scope.flight.ScheduledDeparture).valueOf();
      }
      var now = moment().valueOf();
      $scope.showAutoUpdatePanel = ScheduledDepartureTimeStamp - 70 * 60000 <= now && ScheduledDepartureTimeStamp + 30 * 60000 >= now && $scope.flight.DepartureEU;

      //temp - testing
      //$scope.showAutoUpdatePanel = true;

      $scope.radioModel = false;
      $scope.$watch('radioModel', function (value) {
        if (value == true) autoflightInfoInterval();
        if (value == false) {
          $interval.cancel(autoUpdateInterval);
          autoUpdateInterval = null;
        }
      });
      function autoflightInfoInterval() {
        var currentInfo = null;
        currentInfo = PushNotifier.formatInfoToCompare($scope.flight.FlightId);
        var intervalTime = timerDelayGenerator($scope.flight.ScheduledDeparture);
        if (intervalTime > 0) {
          InfoAPIService.getPax($scope.flight.FlightId).then(function (responseData) {
            $scope.flight = FlightFactory.getFlightFromTotalFlights($scope.flight.FlightId);
            $scope.paxInfo = PaxInfoFactory.getPaxInfoFromStorage($scope.flight.FlightId);
            $scope.aircaftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId($scope.flight.FlightId);
            $scope.flightETA = $scope.flight.ETA ? moment($scope.flight.ETA).valueOf() : new Date($scope.flight.ScheduledArrival).getTime();
            var updatedInfo = PushNotifier.formatInfoToCompare($scope.flight.FlightId);
            var changes = PushNotifier.compareAndExtractChanges(currentInfo, updatedInfo);
            var message = PushNotifier.MessageGenerator(changes);

            //UPDATE CREW INFO
            //1. First remove all additional info (phone numbers & previous duties) for this flight
            CrewCallFactory.cleanFlightCrewNumbers($scope.flight.FlightId);
            PreviousDutyFactory.cleanFlightPreviousDuties($scope.flight.FlightId);

            //2. Then save any fetched info
            if (responseData.data.data.FlightInfo) {
              var crew = responseData.data.data.FlightInfo.crew;
              CrewCallFactory.saveFlightPhoneNumbers($scope.flight.FlightId, crew, $scope.flight.ScheduledArrival, $scope.flight.ScheduledDeparture);
              PreviousDutyFactory.saveFlightPreviousDuties($scope.flight.FlightId, crew);
            }

            //Update scopes for the CrewRoutePanel in Flight-page
            $scope.crewRouteInfoPanel = CrewRouteFactory.getCrewRouteInfoPanel($scope.flight);
            if (changes && changes.length > 0) {
              if (browserNotificationsEnabled) {
                try {
                  PushNotifier.Generate('Changes', message);
                } catch (e) {
                  $scope.changes = changes;
                  $scope.showAlternativeNotifications = true;
                }
              } else {
                $scope.changes = changes;
                $scope.showAlternativeNotifications = true;
              }
            }
          }, function (responseData) {
            if (browserNotificationsEnabled && window.navigator.onLine) {
              try {
                PushNotifier.Generate('Changes', 'Update failed');
              } catch (ex) {
                //TODO: add related messagge KVEN,EPAP
              }
            }
          });
          if (intervalTime != autoUpdateIntervalTimeOffset) {
            autoUpdateIntervalTimeOffset = intervalTime;
            $interval.cancel(autoUpdateInterval);
            autoUpdateInterval = $interval(autoflightInfoInterval, autoUpdateIntervalTimeOffset);
          }
        } else {
          $interval.cancel(autoUpdateInterval);
          $scope.showAutoUpdatePanel = false;
        }
      }
      function timerDelayGenerator(departureTime) {
        var intervalTime = -1;
        var depTimestamp = moment.utc(departureTime).valueOf();
        var nowTimeStamp = moment().valueOf();
        var minutes = 60000;
        if (depTimestamp - 70 * minutes <= nowTimeStamp && depTimestamp + 30 * minutes >= nowTimeStamp) {
          var absoluteMinuteDiff = Math.abs(depTimestamp - nowTimeStamp);
          if (absoluteMinuteDiff <= 15 * minutes) {
            intervalTime = 1 * minutes;
          } else {
            intervalTime = 3 * minutes;
          }
        }

        //temp
        //return 3 * minutes; // testing 

        return intervalTime;
      }
    }
    return {
      restrict: 'E',
      templateUrl: 'views/directives/autofresh.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('basicFooter', basicFooter);

  /**
   * @memberof PilotReports
   * @ngdoc directive
   * @name basicFooter
   * @restrict E
   * @description
   *   Implementation of basicFooter (appears in groundDuty-info view)
   *
   *   Initialize a basic Footer Template and its Navigation Functionality
   *   Used in groundDuty and crewRoute view
   * @example
   *   Usage:
   *   <basic-footer></bacic-footer>
   * @ngInject
   */
  function basicFooter($location, SettingsMain, UserFactory, DataCleanerFactory) {
    /**
     * Initialize basicFooter and events
     * @memberof basicFooter
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service} attrs attribute of this element
     */
    function link(scope, element, attrs) {
      if (scope.groundDuty || scope.crewRoute) {
        /**
         * Open a modal from which u can Logout from the application
         * @memberof groundFooter  
         */
        var logout = function logout() {
          var isSecure = UserFactory.isSecure();
          bootbox.dialog({
            message: (isSecure ? "<strong class='text-danger'>Due to the fact that you are working over a public computer, all stored data will be deleted on logout!</strong><br/><br/>" : "You will be able to login again into the same account, even if there is no internet access.<br/><br/>") + "Please confirm that you wish to log out.",
            title: "<strong>User Logout<strong>",
            buttons: {
              cancel: {
                label: "Cancel",
                className: "btn-default",
                callback: function callback() {}
              },
              logout: {
                label: "Logout",
                className: "btn-warning",
                callback: function callback() {
                  UserFactory.clearActiveUser();
                  if (isSecure) DataCleanerFactory.deleteAllData();
                  UserFactory.azSignOut();
                  location.reload(true);
                  // need to reload, in order for the
                  // browser to check the cache.manifest
                  // and discover any changes
                }
              }
            }
          });
        };
        /**
         * Navigate to Calendar View
         * @memberof groundFooter  
         */
        var gotoCalendar = function gotoCalendar() {
          // handleIfReport(state, flightId, report);

          SettingsMain.setEditingPage(null);
          // go to dashboard
          $location.path("/");
        };
        /**
         * Navigate to Bucket Calendar View
         * @memberof groundFooter  
         */
        var gotoBucketCalendar = function gotoBucketCalendar() {
          SettingsMain.setEditingPage(null);
          $location.path('/bucket');
        };
        /**
         * Navigate to FAQs View
         * @memberof groundFooter  
         */
        var gotoFAQs = function gotoFAQs() {
          SettingsMain.setEditingPage(null);
          $location.path('/faqs');
        };
        /**
        * Navigate to Roster Requests View
        * @memberof mainFooter  
        */
        var gotoRequests = function gotoRequests() {
          SettingsMain.setEditingPage(null);
          $location.path("/rosterRequests");
        };
        /**
         * Navigate to Messages View
         * @memberof groundFooter  
         */
        var gotoMessageLibrary = function gotoMessageLibrary() {
          $location.path('/messages');
        };
        var state = scope.state;
        var user = UserFactory.getUser();
        var delay = 60000;
        scope.gotoMessageLibrary = gotoMessageLibrary;
        scope.gotoFAQs = gotoFAQs;
        scope.gotoRequests = gotoRequests;
        scope.gotoBucketCalendar = gotoBucketCalendar;
        scope.gotoCalendar = gotoCalendar;
        scope.logout = logout;
      }
    }
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: "views/Main/basic-footer.tpl.html",
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('chart', chart);
  function chart() {
    var baseWidth = 600;
    var baseHeight = 400;
    return {
      restrict: 'E',
      template: '<canvas></canvas>',
      scope: {
        chartObject: "=value"
      },
      link: function link(scope, element, attrs) {
        var canvas = element.find('canvas')[0];
        var context = canvas.getContext('2d');
        var chart;
        var options = {
          type: attrs.type || "Line",
          width: attrs.width || baseWidth,
          height: attrs.height || baseHeight
        };
        canvas.width = options.width;
        canvas.height = options.height;
        chart = new Chart(context);
        scope.$watch(function () {
          return element.attr('type');
        }, function (value) {
          if (!value) return;
          options.type = value;
          var chartType = options.type;
          if (scope.chartObject) {
            chart[chartType](scope.chartObject.data, scope.chartObject.options);
          }
        });

        //Update when charts data changes
        scope.$watch(function () {
          return scope.chartObject;
        }, function (value) {
          if (!value) return;
          var chartType = options.type;
          chart[chartType](scope.chartObject.data, scope.chartObject.options);
          if (scope.chartInstance) scope.chartInstance.destroy();
          scope.chartInstance = chart[chartType](scope.chartObject.data, scope.chartObject.options);
        }, true);
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('crewMeals', crewMeals);

  /**
     * @memberof PilotReports
     * @ngdoc directive
     * @name crewMeals
     * @restrict E
     * @description
     *   Implementation of crew meals
     *
     *   Display the crew meals
     * @attr {String} dutyNo 
     * @attr {String} dutyDay  
     * @attr {String} flight-id
     * @example
     *   Usage:
     *   <crew-meals duty-no="137979375664" duty-day="13318" flight-id="123"></crew-meals>
     *   
     * @ngInject
     */
  function crewMeals(CrewRouteFactory, CrewMealFactory, FlightFactory, $sce, $timeout) {
    /**
     * Initialize crewMeals
     * @memberof crewMeals
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service} attributes attributes of this element
     */
    function link(scope, element, attributes) {
      scope.togglePanel = togglePanel;
      scope.route = CrewRouteFactory.getCrewRouteFromStorage(scope.dutyNo, scope.dutyDay);
      scope.HasRegChanged = false;
      scope.noClicked = noClicked;
      scope.yesClicked = yesClicked;
      scope.submitRatingClicked = submitRatingClicked;
      scope.canceClicked = canceClicked;
      scope.clearFormData = clearFormData;
      //for flight page
      scope.isFlightPanel = scope.flightId !== "";
      scope.flightCrewMeals = null;
      //for route page
      scope.isRoutePanel = scope.flightId == null || scope.flightId === "";
      scope.routeCrewMeals = [];
      scope.showCrewMealsPanel = false;
      //Rating Form
      scope.ratingForm = {
        CateringMealId: '',
        FlightId: '',
        Rating: '',
        Comments: '',
        DidNotEatReasonId: ''
      };
      scope.submitRatingMessage = '';
      scope.showPanel = "meals";
      scope.DidNotEatReasons = [];
      scope.isOffline = !window.navigator.onLine;
      scope.popoverInfo = {
        title: $sce.trustAsHtml(' Attention'),
        contentHtml: $sce.trustAsHtml('<div style="width:210px;">' + 'There is an aircraft change on your route. Please arrange to take your assigned meal with you.' + '<div/>')
      };
      window.addEventListener('offline', function (e) {
        $timeout(scope.isOffline = !window.navigator.onLine);
      });
      window.addEventListener('online', function (e) {
        $timeout(scope.isOffline = !window.navigator.onLine);
      });

      //Get scope values
      if (scope.isFlightPanel && scope.route) {
        var crewMeals = scope.route.CrewMeals;
        for (var i = 0; i < crewMeals.length; i++) {
          if (crewMeals[i].FlightId == scope.flightId) {
            scope.flightCrewMeals = new FlightCrewMeal(crewMeals[i]);
            scope.showCrewMealsPanel = true;
            break;
          }
        }
        scope.HasRegChanged = hasRegChanged(scope.flightId);
      }
      if (scope.isRoutePanel && scope.route && scope.route.CrewMeals.length > 0) {
        var crewMeals = scope.route.CrewMeals;
        for (var i = 0; i < crewMeals.length; i++) {
          scope.routeCrewMeals.push(new FlightCrewMeal(crewMeals[i]));
          scope.showCrewMealsPanel = true;
        }
        scope.HasRegChanged = hasRegChanged(crewMeals[0].FlightId);
      }
      if (!scope.isOffline && scope.showCrewMealsPanel) {
        CrewMealFactory.getCrewMealsDidNotEatReasons().then(function (res) {
          return scope.DidNotEatReasons = res;
        });
      }

      //FlightCrewMeal Constructor
      function FlightCrewMeal(flight) {
        this.FlightDate = moment(flight.FlightDate).format("DD/MM");
        this.FlightNo = flight.FlightNo;
        this.FlightDeparture = flight.FlightDeparture;
        this.CrewMeals = "";
        this.CrewMealsDescriptions = [];
        for (var i = 0; i < Object.values(flight.CrewMealsCateringIds).length; i++) {
          if (i != 0) {
            this.CrewMeals += " & ";
          }
          var crewMealDetails = CrewMealFactory.getCrewMealFromStorage(Object.values(flight.CrewMealsCateringIds)[i]);
          var hasRating = CrewMealFactory.hasRating(Object.keys(flight.CrewMealsCateringIds)[i]);
          this.CrewMeals += crewMealDetails.Title;
          this.CrewMealsDescriptions.push({
            CrewMealId: Object.keys(flight.CrewMealsCateringIds)[i],
            CateringMealId: crewMealDetails.CateringMealId,
            Title: crewMealDetails.Title,
            Description: crewMealDetails.Description,
            HasRating: hasRating
          });
        }
      }

      //Change Registration check
      function hasRegChanged(flightId) {
        var retVal = false;
        var flights = FlightFactory.getFlightsByFlightId(flightId);
        if (flights.length > 0) {
          var acTailNo = flights[0].AcTailNo;
          for (var i = 0; i < flights.length; i++) {
            if (flights[i].AcTailNo != acTailNo) {
              retVal = true;
              break;
            }
          }
        }
        return retVal;
      }

      /**
       * toggle Panel
       * @memberof crewMeals
       * @param {number} panelId
       */
      function togglePanel(panelId) {
        $('#' + panelId).toggle();
      }
      function noClicked(cateringMealId, crewMealId) {
        clearFormData(cateringMealId, crewMealId);
        scope.showPanel = "didNotEatMeal";
      }
      function yesClicked(cateringMealId, crewMealId) {
        clearFormData(cateringMealId, crewMealId);
        scope.showPanel = "mealRating";
      }

      //function checkConnection

      function clearFormData(cateringMealId, crewMealId) {
        scope.ratingForm.CateringMealId = cateringMealId;
        scope.ratingForm.FlightId = scope.flightId;
        scope.ratingForm.CrewMealId = crewMealId;
        scope.ratingForm.Rating = '';
        scope.ratingForm.DidNotEatReasonId = '';
        scope.ratingForm.Comments = '';
        scope.isOffline = !window.navigator.onLine;
      }
      function canceClicked() {
        scope.showPanel = "meals";
      }
      function submitRatingClicked() {
        scope.showPanel = "loading";
        CrewMealFactory.sendCrewMealsRatingReport(this.ratingForm).then(function (res) {
          return handleSubmitResponse(res);
        });
      }
      function handleSubmitResponse(res) {
        if (res.success) {
          var index = scope.flightCrewMeals.CrewMealsDescriptions.findIndex(function (x) {
            return x.CateringMealId == scope.ratingForm.CateringMealId;
          });
          scope.flightCrewMeals.CrewMealsDescriptions[index].HasRating = true;
          manageResponseMessage("success", res.message);
        } else {
          manageResponseMessage("failure", res.message);
        }
      }
      function manageResponseMessage(panelToShow, message) {
        scope.submitRatingMessage = message;
        scope.showPanel = panelToShow;
        $timeout(function () {
          scope.showPanel = "meals";
        }, 3000);
      }
    }
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/directives/crewMeals.tpl.html',
      scope: {
        dutyNo: '@',
        dutyDay: '@',
        flightId: '@'
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('flightCrew', flightCrew);

  /**
    * @memberof PilotReports
    * @ngdoc directive
    * @name flightCrew
    * @restrict E
    * @description
    *  Initialize Flight Crew Information
    * @example
    *   Usage:
    *   <flight-crew></flight-crew>
    * @ngInject 
    */
  function flightCrew() {
    function link(scope, element, attrs) {}
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: "views/directives/flightCrew.tpl.html",
      scope: {
        flight: '='
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('flightFooter', flightFooter);

  /**
   * @memberof PilotReports
   * @ngdoc directive
   * @name flightFooter
   * @restrict E
   * @description
   *   Implementation of FlightFooter
   *
   *   Initialize The flights Footer Template and its Navigation, Sync, Footer Functionality
   * @example
   *   Usage:
   *   <flight-footer></flight-footer>
   * @ngInject
   */
  function flightFooter(orderByFilter, $location, $sce, $timeout, $interval, $filter, apiUrl, $uibModal, $route, SettingsMain, MemoFactory, MessageFactory, FlightFactory, UserFactory, DataCleanerFactory, ReportGuidFactory, SyncLogFactory, CrewRouteFactory, GroundDutyFactory, PilotReportLocalEditFactory) {
    /**
     * Initialize flightFooter and events
     * @memberof flightFooter
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service}   attrs attribute of this element
     */
    function link(scope, element, attrs) {
      if (scope.flight) {
        /**
        * Opens refresh modal for results
        */
        var RefreshRoute = function RefreshRoute() {
          var _dutyNo = scope.flight.DutyNo;
          var _dutyDay = scope.flight.DutyDay;
          var _crewRouteDuty = CrewRouteFactory.getCrewRouteFromStorage(_dutyNo, _dutyDay);
          var groundDuties = GroundDutyFactory.getGroundDutiesByDutyNo(_dutyNo, _dutyDay);
          if (groundDuties.length > 0) {
            //there are ground duties in this crew route
            angular.forEach(groundDuties, function (groundDuty) {
              groundDuty.DutyType = "Ground";
              groundDuty.Start = groundDuty.DutyBegin;
            });
          }
          var flights = FlightFactory.getFlightsByDutyNo(_dutyNo, _dutyDay);
          if (flights.length > 0) {
            //there are flights in this crew route
            angular.forEach(flights, function (flight) {
              flight.DutyType = "Flight";
              flight.Start = flight.ScheduledDeparture;
            });
          }
          var crewRoute = groundDuties.concat(flights);
          crewRoute = $filter('orderBy')(crewRoute, 'Start', false);
          var modalInstance = $uibModal.open({
            templateUrl: 'views/CrewRoute/dlgCrewRouteRefresh.html',
            controller: 'CrewRouteRefreshModalCtrl',
            backdrop: 'static',
            keyboard: false,
            size: 'md',
            resolve: {
              crewroute: function crewroute() {
                return crewRoute;
              },
              crewRouteDuty: function crewRouteDuty() {
                return _crewRouteDuty;
              },
              dutyNo: function dutyNo() {
                return Number(_dutyNo);
              },
              dutyDay: function dutyDay() {
                return Number(_dutyDay);
              },
              forCurrentDay: function forCurrentDay() {
                return scope.flight.FlightDate;
              }
            }
          });
          modalInstance.result.then(function (transferData) {
            scope.lastSync = new Date().getTime();
            if (transferData.sync) {
              SyncLogFactory.forceSync();
              $location.path("/"); //crew route has significantly changed
            } else if (transferData.refresh) {
              $route.reload(); //crew route was updated
            }
          });
        };
        /**
         * Find previous,next and current flight of the Route of the selected flight
         * @memberof flightFooter
         * @param {number} flightId input the Id of a Flight  
         * @returns {Object} previous,next and current flight
         */
        var getPreviousAndNextFlights = function getPreviousAndNextFlights(flightId) {
          var nextFlight, previousFlight, currentFlight;
          // also load the flights created by the user
          var flights = FlightFactory.getFlightsByRoute(scope.flight.Route, scope.flight.DutyDate);
          flights = orderByFilter(flights, orderByDate, false);
          function orderByDate(item) {
            var date = new Date(item.ScheduledDeparture);
            return date;
          }
          for (var i = 0; i < flights.length; i++) {
            if (flights[i].FlightId == flightId) {
              if (i >= 1) {
                previousFlight = flights[i - 1];
              }
              if (i + 1 < flights.length) {
                nextFlight = flights[i + 1];
              }
              currentFlight = flights[i];
            }
          }
          //alert(flights.currentFlight.flightId + " " + flights.nextFlight.flightId+ " " + flights.previousFlight.flightId);
          return {
            nextFlight: nextFlight,
            previousFlight: previousFlight,
            currentFlight: currentFlight
          };
        };
        /**
         * It handles the pilot report when u want to navigate to another view
         * @memberof flightFooter
         * @param {String} state input the current state (view)  
         * @param {number} flightId input the Id of a Flight  
         * @param {Object} report input the pilot report  
         */
        var handleIfReport = function handleIfReport(state, flightId, report) {
          if (state == 'report') {
            if (report == null) {
              report = PilotReportLocalEditFactory.getPilotReportLocalEditForFlight(flightId);
            }
            var guid = report.ReportGuid;
            var status = report.Status;

            // delete the temp report
            PilotReportLocalEditFactory.deleteTempReport();

            //reuse guid if this was a new report
            if (status == 'pending') ReportGuidFactory.restoreGuid(report.ReportGuid);
          }
        };
        /**
         * Open the pilot Report for the  selected Flight
         * @memberof flightFooter  
         * @param {number} flightId input the Id of a Flight
         */
        var openReport = function openReport(flightId) {
          var user = UserFactory.getUser();
          var token = '';
          if (user != null) {
            token = user.token;
            token = encodeURIComponent(token);
          }

          // load the flight
          var flight = FlightFactory.getFlightFromStorage(flightId);
          if (flight == null) {
            // if not found, also check the local flights
            var flight = FlightFactory.getLocalFlightFromStorage(flightId);
            if (flight == null) return;
          }

          // load the reports
          var serverReportForThisUser = flight.getServerPilotReportForUser(user.aimsId);
          var serverReportsByAnotherUser = flight.getServerPilotReportsByAnotherUser(user.aimsId);
          var localReport = PilotReportLocalEditFactory.getPilotReportLocalEditForFlight(flightId);

          // no stored local report
          if (localReport == null) {
            // has server report from this user and from other users
            if (serverReportForThisUser != null && serverReportsByAnotherUser.length > 0) {
              // show selection dialog
              openReportDialog(flightId);
            }
            // has server report only from this user
            else if (serverReportForThisUser != null && serverReportsByAnotherUser.length == 0) {
              $location.path("reportsHistory/" + serverReportForThisUser.ReportId + "/" + flightId + "/Pilot");
            }
            // has server report only from other users
            else if (serverReportForThisUser == null && serverReportsByAnotherUser.length > 0) {
              // show selection dialog
              openReportDialog(flightId);
            }
            // no server reports, create a new local report directly
            else {
              $location.path("report/new:" + -1 + "/" + flightId);
            }
          }
          // has stored local report
          else {
            // special case: has server report from this user, and not from
            // other users
            if (serverReportForThisUser != null && serverReportsByAnotherUser.length == 0) {
              // open the local report for editing
              $location.path("report/" + localReport.ReportGuid);
            }
            // general case: has server report from this user or from other
            // users
            else if (serverReportForThisUser != null || serverReportsByAnotherUser.length > 0) {
              // show selection dialog
              openReportDialog(flightId);
            }
            // no server reports, open the local report directly
            else {
              // open the existing report for editing
              $location.path("report/" + localReport.ReportGuid);
            }
          }
        };
        /**
         * Open a modal to choose an action when there is already a pilot report from another user
         * @memberof flightFooter  
         * @param {number} flightId input the Id of a Flight
         */
        var openReportDialog = function openReportDialog(_flightId) {
          var modalInstance = $uibModal.open({
            templateUrl: './views/Dialogs/dlgOpenReport.html',
            controller: 'OpenReportDialogCtrl',
            size: 'md',
            resolve: {
              flightId: function flightId() {
                return _flightId;
              }
            }
          });
          modalInstance.result.then(function () {}, function () {});
        };
        /**
         * Open a modal from which u can Logout from the application
         * @memberof flightFooter  
         */
        var logout = function logout() {
          var isSecure = UserFactory.isSecure();
          bootbox.dialog({
            message: (isSecure ? "<strong class='text-danger'>Due to the fact that you are working over a public computer, all stored data will be deleted on logout!</strong><br/><br/>" : "You will be able to login again into the same account, even if there is no internet access.<br/><br/>") + "Please confirm that you wish to log out.",
            title: "<strong>User Logout<strong>",
            buttons: {
              cancel: {
                label: "Cancel",
                className: "btn-default",
                callback: function callback() {}
              },
              logout: {
                label: "Logout",
                className: "btn-warning",
                callback: function callback() {
                  UserFactory.clearActiveUser();
                  if (isSecure) DataCleanerFactory.deleteAllData();
                  UserFactory.azSignOut();
                  location.reload(true);
                  // need to reload, in order for the
                  // browser to check the cache.manifest
                  // and discover any changes
                }
              }
            }
          });
        };
        /**
         * Redirects to Reset Device View
         * @memberof flightFooter  
         */
        var resetDevice = function resetDevice() {
          $location.path("/reset");
        };
        /**
         * Open a modal from which you can delete all available reports
         * @memberof flightFooter  
         * @method
         */
        var deleteAllReports = function deleteAllReports() {
          bootbox.dialog({
            message: "Use this process to clear your device from all locally stored Pilot Reports, in order to save up space, when available storage space is not sufficient for the application to function properly.<br/><br/>" + "<h4>ATTENTION</h4>" + "This action will delete all Pilot Reports from your device, <span style='text-decoration: underline;'>including draft and completed ones not sent to the server</span>.",
            title: "<strong>Application Logs Reset<strong>",
            buttons: {
              cancel: {
                label: "Cancel",
                className: "btn-default",
                callback: function callback() {}
              },
              danger: {
                label: "Delete All Pilot Reports",
                className: "btn-danger",
                callback: function callback() {
                  DataCleanerFactory.deleteAllReports();
                  $route.reload();
                  bootbox.alert("All Pilot Reports have been successfully deleted.", function () {});
                }
              }
            }
          });
        };
        /**
         * Navigate to Calendar View
         * @memberof flightFooter  
         */
        var gotoCalendar = function gotoCalendar() {
          handleIfReport(state, flightId, report);
          SettingsMain.setEditingPage(null);
          // go to dashboard
          $location.path("/");
        };
        /**
         * Navigate to Messages View
         * @memberof flightFooter  
         */
        var gotoMessages = function gotoMessages() {
          handleIfReport(state, flightId, report);
          $location.path('/messages/' + flightId);
        };
        /**
         * Navigate to Roster Requests
         * @memberof flightFooter  
         */
        var gotoRequests = function gotoRequests() {
          SettingsMain.setEditingPage(null);
          $location.path('/rosterRequests');
        };
        /**
         * Navigate to Selected Flight Information View
         * @param {number} flightId input the Id of a Flight
         * @memberof flightFooter  
         */
        var gotoFlight = function gotoFlight(flightId) {
          handleIfReport(state, flightId, report);
          $location.path('/flightinfo/' + flightId);
        };
        /**
         * Navigate to Messages View
         * @memberof flightFooter  
         */
        var gotoMessageLibrary = function gotoMessageLibrary() {
          handleIfReport(state, flightId, report);
          $location.path('/messages');
        };
        /**
         * Navigate to the Current Flight's Information View
         * @memberof flightFooter  
         */
        var gotoFlightInfo = function gotoFlightInfo() {
          gotoFlight(flightId);
        };
        /**
         * Open current's Flight Pilot Report
         * @memberof flightFooter  
         */
        var openPilotReport = function openPilotReport() {
          openReport(flightId);
        };
        /**
         * Navigate to Memos Library
         * @memberof flightFooter  
         */
        var gotoMemosLibrary = function gotoMemosLibrary() {
          handleIfReport(state, flightId, report);
          $location.path('/memos');
        };
        var goToSafetyReport = function goToSafetyReport(flightId) {
          $location.path('/safetyreport/flightcrewreport/' + flightId);
        };
        var goToFatigueReport = function goToFatigueReport(flightId) {
          $location.path('/safetyreport/fatiguereport/' + flightId);
        };
        /**
         * Show Popover that advices User to sync so he can get the latest Pax and Gate Informations
         * @memberof flightFooter  
         */
        var showSyncPopover = function showSyncPopover() {
          var firstSyncWarning = departure - 4500000; //75 mintes before takeoff
          var secondSyncWarning = departure - 600000; //10 minutes before takeoff
          var now = new Date().getTime();
          var lastSync = scope.lastSync;
          if (now > firstSyncWarning && now < secondSyncWarning && (!lastSync || lastSync < firstSyncWarning) || now > secondSyncWarning && now < departure && (!lastSync || lastSync < secondSyncWarning)) {
            scope.enableSyncPopover = true;
          }
        };
        var returnTimeDiff = function returnTimeDiff() {
          //time difference in minutes from: now and pax info list date
          scope.paxTimeDiffInMins = Math.round((new Date().getTime() - new Date(scope.paxInfo.LastRun).getTime()) / 60000);
        };
        /**
         * Navigate to Submit ticket view
         * @memberof filghtFooter  
         */
        var gotoTicket = function gotoTicket() {
          // go to Submit ticket view
          $location.path("/ticket");
        };
        /**
        * Navigate to the Current Flight's Pax Information View
        * @memberof flightFooter  
        */
        var gotoPaxInfo = function gotoPaxInfo() {
          SettingsMain.setEditingPage(null);
          handleIfReport(state, flightId, report);
          $location.path('/pax/' + flightId);
        };
        var flightId = scope.flight.FlightId;
        var state = scope.state;
        var report = scope.report;
        var flights = getPreviousAndNextFlights(flightId);
        var messagesCount = 0;
        var unreadMessagesCount = 0;
        var memosForCurrentFlight = 0;
        var user = UserFactory.getUser();
        var messages = [];
        var memos = [];
        var delay = 60000;
        if (state != "memos" && flights && flights.currentFlight) {
          MemoFactory.getMemosForFlight(flightId, function (results) {
            memos = results;
            scope.memosForCurrentFlight = memos.length;
          });
        }
        if (state != "messages" && flights && flights.currentFlight) {
          messages = MessageFactory.getMessagesFromIds(flights.currentFlight.messages);
          messagesCount = messages.length;
          for (var i = 0; i < messages.length; i++) {
            if (messages[i].ReadDt == null) {
              unreadMessagesCount++;
            }
          }
        }
        if (state == 'pax' || state == 'flight' && scope.paxInfo) {
          var now = new Date().getTime();
          var departure = new Date(scope.flight.ScheduledDeparture).getTime();
          if (departure < now) {
            var openSyncPopover = $interval(showSyncPopover, delay);
          }
        }
        if (state == 'pax' || state == 'flight') {
          if (scope.paxInfo && new Date(scope.flight.ScheduledDeparture).getTime() > new Date().getTime()) {
            returnTimeDiff();
            var showTimeDiff = $interval(returnTimeDiff, delay);
          }
        }
        scope.gotoRequests = gotoRequests;
        scope.gotoFlight = gotoFlight;
        scope.previousFlight = flights.previousFlight;
        scope.nextFlight = flights.nextFlight;
        scope.gotoCalendar = gotoCalendar;
        scope.gotoFlightInfo = gotoFlightInfo;
        scope.openPilotReport = openPilotReport;
        scope.gotoMessages = gotoMessages;
        scope.messagesCount = messagesCount;
        scope.unreadMessagesCount = unreadMessagesCount;
        scope.logout = logout;
        scope.resetDevice = resetDevice;
        scope.deleteAllReports = deleteAllReports;
        scope.gotoMessageLibrary = gotoMessageLibrary;
        scope.gotoMemosLibrary = gotoMemosLibrary;
        scope.gotoPaxInfo = gotoPaxInfo;
        scope.showMobileMenu = false;
        scope.userPosition = user.position;
        scope.RefreshRoute = RefreshRoute;
        scope.gotoTicket = gotoTicket;
        scope.goToSafetyReport = goToSafetyReport;
        scope.goToFatigueReport = goToFatigueReport;
        scope.syncWarning = $sce.trustAsHtml('<div class="border-left-orange" style="padding-left: 0.3em"><i class="text-orange fa fa-exclamation-triangle"></i> You are <strong>strongly</strong> advised to sync your device.</div>');
        scope.enableSyncPopover = false;
        scope.lastSync = null;
        element.on('$destroy', function () {
          $interval.cancel(openSyncPopover);
          $interval.cancel(showTimeDiff);
        });
      }
    }
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: "views/Flight/footer.tpl.html",
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('flightHeader', flightHeader);

  /**
    * @memberof PilotReports
    * @ngdoc directive
    * @name flightHeader
    * @restrict E
    * @description
    *   Implementation of flightHeader
    *    Initialize the template of the header while you are in the Flight Level
    * @example
    *   Usage:
    *   <flight-header></flight-header>
    * @ngInject 
    */
  function flightHeader() {
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: "views/Flight/header.tpl.html",
      scope: false
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('groundCrew', groundCrew);

  /**
    * @memberof PilotReports
    * @ngdoc directive
    * @name groundCrew
    * @restrict E
    * @description
    * Initialize Trainer and Trainee Info
    * @example
    *   Usage:
    *   <ground-crew></ground-crew>
    * @ngInject 
    */
  function groundCrew() {
    function link(scope, element, attrs) {
      scope.groundDuty = scope.duty;
      scope.toggleCrewList = toggleCrewList;
      scope.groundDuty.Trainees.forEach(function (relatedTrainees) {
        relatedTrainees.isCollapsed = false;
        relatedTrainees.dynamicSize = 10;
      });

      /**
       * @memberof GroundDutyCtrl
       * @name toggleCrewList
       * @description 
       * Οnly show the first 10 trainees - if more then toggle
       */
      function toggleCrewList(relatedTrainees) {
        relatedTrainees.isCollapsed = !relatedTrainees.isCollapsed;
        if (relatedTrainees.isCollapsed) relatedTrainees.dynamicSize = relatedTrainees.CrewMembers.length;else relatedTrainees.dynamicSize = 10;
      }
    }
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: "views/directives/groundCrew.tpl.html",
      scope: {
        duty: '='
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('groundHeader', groundHeader);

  /**
    * @memberof PilotReports
    * @ngdoc directive
    * @name groundHeader
    * @restrict E
    * @description
    *   Implementation of groundHeader (appears in groundDuty-info view)
    *    Initialize the template of the header while you are in the Ground Duty Level
    * @example
    *   Usage:
    *   <ground-header></ground-header>
    * @ngInject 
    */
  function groundHeader() {
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: "views/GroundDuty/header.tpl.html",
      scope: false
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('groundServices', groundServices);

  /**
     * @memberof PilotReports
     * @ngdoc directive
     * @name groundServices
     * @restrict E
     * @description
     *   Implementation of ground services 
     *
     *   Display the ground services
     * @attr {String} arrival The flight arrival station.
     * @attr {String} departure The flight departure station.
     * @attr {String} flight-id The flight id.
     * @example
     *   Usage:
     *   <ground-services arrival="ATH" departure="MAD" flight-id="123"></ground-services>
     *   
     * @ngInject
     */
  function groundServices(GroundServicesFactory, PilotReportLocalEditFactory, PilotReportLocalEditCreatorFactory, FlightFactory, $sce) {
    /**
     * Initialize groundServices
     * @memberof groundServices
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service} attributes attributes of this element
     */
    function link(scope, element, attributes) {
      scope.togglePanel = togglePanel;
      scope.flight = FlightFactory.getFlightFromTotalFlights(scope.flightId);
      scope.isInFinalState = isInFinalState;
      scope.saveNewUsedState = saveNewUsedState;
      scope.DepartureGroundServices = [];
      scope.ArrivalGroundServices = [];
      scope.popoverInfo = {
        title: $sce.trustAsHtml(' Info'),
        contentHtml: $sce.trustAsHtml('<div style="width:210px;"><span class="text-blue"><i class="fa fa-square"></i></span> Contracted Services' + '<br /><span class="text-gray"><i class="fa fa-square"></i></span> Non Contracted Services' + '<div/>')
      };
      var report = PilotReportLocalEditFactory.getPilotReportLocalEditForFlight(scope.flightId);
      if (report == null) {
        if (scope.departure) {
          scope.DepartureGroundServices = GroundServicesFactory.getGroundServicesByStation(scope.departure);
        }
        if (scope.arrival) {
          scope.ArrivalGroundServices = GroundServicesFactory.getGroundServicesByStation(scope.arrival);
        }
      } else {
        report = PilotReportLocalEditFactory.checkForNewGroundServices(report);
        if (scope.departure) {
          scope.DepartureGroundServices = report.DepartureGroundServices;
        }
        if (scope.arrival) {
          scope.ArrivalGroundServices = report.ArrivalGroundServices;
        }
      }

      /**
       * Check if the report is in a final state so that we cant edit any more
       * @memberof groundServices
       * @returns {boolean} true if final, false otherwise
       */
      function isInFinalState() {
        var isInFinalState = scope.flight.LineStatus === 'na' || scope.flight.LineStatus === 'stored' || scope.flight.LineStatus === 'storedotheruser' || scope.flight.LineStatus === 'stored+otheruser' || scope.flight.LineStatus === 'synched' || scope.flight.LineStatus === 'synchedotheruser';
        return isInFinalState;
      }

      /**
       * When a ground service usage is toggled on or off,
       * create the report if it doesnt exist
       * or just save the changes
       * @memberof groundServices
       */
      function saveNewUsedState() {
        //if report is pending, it doesnt exist yet. create it
        if (scope.flight.LineStatus === 'pending' || scope.flight.LineStatus === 'pendingoverdue') {
          report = PilotReportLocalEditCreatorFactory.createNewLocalReportForFlight(scope.flightId);
          if (scope.departure) {
            report.DepartureGroundServices = scope.DepartureGroundServices;
          } else {
            report.DepartureGroundServices = [];
          }
          if (scope.arrival) {
            report.ArrivalGroundServices = scope.ArrivalGroundServices;
          } else {
            report.ArrivalGroundServices = [];
          }
          report.Status = 'draft';
          report.saveReport();
          FlightFactory.updateFlightFromReport(report);
        }
        PilotReportLocalEditFactory.setPilotReportToStorage(report);
      }

      //TODO : find a more angular way (EPAP)
      /**
       * toggle Panel
       * @memberof groundServices
       * @param {number} panelId
       */
      function togglePanel(panelId) {
        $('#' + panelId).toggle();
      }
    }
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/directives/groundServices.tpl.html',
      scope: {
        arrival: '@',
        departure: '@',
        flightId: '@'
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('mainFooter', mainFooter);

  /**
    * @memberof PilotReports
    * @ngdoc directive
    * @name mainFooter
    * @restrict E
    * @description
    *   Implementation of mainFooter
    *   Initialize The main Footer Template and its Navigation, Sync, Footer Functionality
    * @example
    *   Usage:
    *   <main-footer></main-footer>
    * @ngInject 
    */
  function mainFooter($location, SettingsMain, UserFactory, $uibModal, MessageFactory, DataCleanerFactory, $route, MemoFactory, $sce, $timeout, LeaveRequestFactory, RequestFactory) {
    /**
     * Initialize mainFooter and events
     * @memberof mainFooter
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service} attrs attribute of this element
     */
    function link(scope, element, attrs) {
      var messagesCount = 0;
      var unreadMessagesCount = 0;
      var memosCount = 0;
      var messages = [];
      var memos = [];

      /**
       * Open a modal from which u can Logout from the application
       * @memberof mainFooter  
       */
      function logout() {
        var isSecure = UserFactory.isSecure();
        bootbox.dialog({
          message: (isSecure ? "<strong class='text-danger'>Due to the fact that you are working over a public computer, all stored data will be deleted on logout!</strong><br/><br/>" : "You will be able to login again into the same account, even if there is no internet access.<br/><br/>") + "Please confirm that you wish to log out.",
          title: "<strong>User Logout<strong>",
          buttons: {
            cancel: {
              label: "Cancel",
              className: "btn-default",
              callback: function callback() {}
            },
            logout: {
              label: "Logout",
              className: "btn-warning",
              callback: function callback() {
                UserFactory.clearActiveUser();
                if (isSecure) DataCleanerFactory.deleteAllData();
                UserFactory.azSignOut();
                location.reload(true);
                // need to reload, in order for the
                // browser to check the cache.manifest
                // and discover any changes
              }
            }
          }
        });
      }

      /**
       * Redirects to Reset Device View
       * @memberof mainFooter  
       */
      function resetDevice() {
        $location.path("/reset");
      }
      /**
       * Open a modal from which you can delete all available reports
       * @memberof mainFooter  
       * @method
       */
      function deleteAllReports() {
        bootbox.dialog({
          message: "Use this process to clear your device from all locally stored Pilot Reports, in order to save up space, when available storage space is not sufficient for the application to function properly.<br/><br/>" + "<h4>ATTENTION</h4>" + "This action will delete all Pilot Reports from your device, <span style='text-decoration: underline;'>including draft and completed ones not sent to the server</span>.",
          title: "<strong>Application Logs Reset<strong>",
          buttons: {
            cancel: {
              label: "Cancel",
              className: "btn-default",
              callback: function callback() {}
            },
            danger: {
              label: "Delete All Pilot Reports",
              className: "btn-danger",
              callback: function callback() {
                DataCleanerFactory.deleteAllReports();
                $route.reload();
                bootbox.alert("All Pilot Reports have been successfully deleted.", function () {});
              }
            }
          }
        });
      }

      /**
       * Navigate to Calendar View
       * @memberof mainFooter  
       */
      function gotoCalendar() {
        SettingsMain.setEditingPage(null);
        // go to dashboard
        $location.path("/");
      }
      /**
       * Navigate to Bucket Calendar View
       * @memberof flightFooter  
       */
      function gotoBucketCalendar() {
        SettingsMain.setEditingPage(null);
        $location.path('/bucket');
      }
      /**
       * Navigate to Messages View
       * @memberof mainFooter  
       */
      function gotoMessageLibrary() {
        $location.path('/messages');
      }

      /**
       * Navigate to Memos Library
       * @memberof mainFooter  
       */
      function gotoMemos() {
        $location.path('/memos');
      }

      /**
       * Navigate to Roster Requests View
       * @memberof mainFooter  
       */
      function gotoRequests() {
        $location.path("/rosterRequests");
      }
      /**
       * Navigate to leave request View
       * @memberof mainFooter  
       */
      function gotoLeaveRequests() {
        $location.path('/leaverequest');
      }

      /**
       * Navigate to Submit ticket view
       * @memberof mainFooter  
       */
      function gotoTicket() {
        // go to Submit ticket view
        $location.path("/ticket");
      }
      function gotoCrewExpiries() {
        $location.path('/crewExpiries');
      }
      messages = MessageFactory.getMessagesFromStorage();
      messagesCount = messages.length;
      for (var i = 0; i < messages.length; i++) {
        if (messages[i].ReadDt == null) {
          unreadMessagesCount++;
        }
      }
      MemoFactory.getMemosFromStorage(function (results) {
        var memosCount = 0;

        //remove memos that belong to "Training Surveys" category
        for (var i = 0; i < results.length; i++) {
          if (results[i].Category != "Training Surveys") {
            memosCount++;
          }
        }
        scope.memosCount = memosCount;
      });

      /**
       * Open the "Search Flight Info" Modal
       * @memberof CalendarCtrl
       */
      function openSearchFlightsModal() {
        var modalInstance = $uibModal.open({
          templateUrl: './views/SearchFlights/dlgSearchFlights.html',
          controller: 'SearchFlightsCtrl',
          size: 'md',
          backdrop: 'static',
          keyboard: false
        });
      }
      scope.messagesCount = messagesCount;
      scope.unreadMessagesCount = unreadMessagesCount;
      scope.logout = logout;
      scope.resetDevice = resetDevice;
      scope.deleteAllReports = deleteAllReports;
      scope.gotoMessageLibrary = gotoMessageLibrary;
      scope.gotoMemos = gotoMemos;
      scope.memosCount = memosCount;
      scope.gotoCalendar = gotoCalendar;
      scope.gotoBucketCalendar = gotoBucketCalendar;
      scope.gotoTicket = gotoTicket;
      scope.leaveRequestInformation = LeaveRequestFactory.getLeaveRequestInformation();
      scope.gotoRequests = gotoRequests;
      scope.gotoLeaveRequests = gotoLeaveRequests;
      scope.openSearchFlightsModal = openSearchFlightsModal;
      scope.gotoCrewExpiries = gotoCrewExpiries;
    }
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: "views/Main/footer.tpl.html",
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  a3_pilot_reports.directive('memosByCategory', memosByCategory);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name memosByCategory
  * @restrict E
  * @description
  *   Implementation of memosByCategory
  *   Initialize the panels with memos group by category.
  * @example
  *   Usage:
  *   <memos-by-category Type="Flight/F , Ground/G, Duty/D" Id="FlightId, GroundId, DutyNo" Day="DutyDay"></memos-by-category>
  * @ngInject
  */
  function memosByCategory(MemoFactory, MemoImagesFactory, $uibModal, DataCleanerFactory, GroundDutyFactory, FlightFactory) {
    function link($scope, attrs) {
      $scope.togglePanel = togglePanel;
      var Id = $scope.id;

      /**
       * toggle Panel
       * @memberof memosByCategory
       * @param {number} panelId
       */
      function togglePanel(panelId) {
        $('#' + panelId).toggle();
      }

      //Initialize Memos
      if ($scope.type == "duty" || $scope.type == "d") {
        MemoFactory.getMemosForCrewRoute(Id, $scope.day, function (results) {
          $scope.memos = filterMemos(results);
        });
      } else if ($scope.type == "ground" || $scope.type == "g") {
        MemoFactory.getMemosForGroundDuty(Id, function (results) {
          $scope.memos = filterMemos(results);
        });
      }
      //(attrs.type == "flight" || attrs.type == "f") default Flight type
      else {
        MemoFactory.getMemosForFlight(Id, function (results) {
          $scope.memos = filterMemos(results);
        });
      }

      /**
       * filter memos
       * @memberof memosByCategory
       * @param {object} data
       */
      function filterMemos(data) {
        //normalize memos
        var distinctMemos = normalizeMemos(data);
        if (distinctMemos.length != data.length) {
          MemoFactory.getMemosFromStorage(function (allMemos) {
            var distinctMemosAll = normalizeMemos(allMemos);
            MemoImagesFactory.getMemoImagesFromStorage(function (allMemoImages) {
              var distinctMemoImagesAll = normalizeMemoImages(allMemoImages);
              recreateIndexedDB(distinctMemosAll, allMemoImages);
            });
          });
        }
        var memosByCategory = [];
        for (var i = 0; i < distinctMemos.length; i++) {
          var memo = distinctMemos[i];
          if (!memosByCategory.filter(function (e) {
            return e.Category == memo.Category;
          }).length > 0 && memo.Category != "None") {
            memosByCategory.push({
              Category: memo.Category,
              memoList: [memo]
            });
          } else if (memosByCategory.filter(function (e) {
            return e.Category == memo.Category;
          }).length > 0 && memo.Category != "None") {
            memosByCategory.filter(function (object) {
              if (object.Category == memo.Category) {
                return object;
              }
              ;
            })[0].memoList.push(memo);
          }
        }
        return memosByCategory;
      }
      function recreateIndexedDB(distinctMemosAll, distinctMemosImagesAll) {
        //delete indexdb
        var q = DataCleanerFactory.deleteIndexedDB();
        q.then(function () {
          MemoFactory.setMemosToStorage(distinctMemosAll);
          MemoImagesFactory.setMemoImagesToStorage(distinctMemosImagesAll);

          //save normalize data to indexedDB
          LogService.debug("Recreated IndexedDB");
        });
        q["catch"](function (ex) {
          console.log(ex);
        });
      }
      function normalizeMemos(data) {
        var distinctData = [];
        if (data && data.length > 1) {
          var sortData = data.dynamicSort("Id");
          for (var i = 0; i < sortData.length - 1; i++) {
            if (sortData[i + 1].Id == sortData[i].Id) {
              //swap rows in  list - check lastUpdated property, latest at the end
              if (sortData[i].LastUpdated && sortData[i + 1].LastUpdated) {
                var memoDateA = new Date(sortData[i].LastUpdated);
                var memoDateB = new Date(sortData[i + 1].LastUpdated);
                if (memoDateA.getTime() > memoDateB.getTime()) {
                  var temp = sortData[i + 1];
                  sortData[i + 1] = sortData[i];
                  sortData[i] = temp;
                }
              }
            } else {
              distinctData.push(sortData[i]);
            }
          }
          distinctData.push(sortData[sortData.length - 1]);
        } else {
          distinctData = data;
        }
        return distinctData;
      }
      function normalizeMemoImages(data) {
        var distinctData = [];
        if (data && data.length > 1) {
          var sortData = data.dynamicSort("imageId");
          for (var i = 0; i < sortData.length - 1; i++) {
            if (!(sortData[i + 1].imageId == sortData[i].imageId)) {
              distinctData.push(sortData[i]);
            }
          }
          distinctData.push(sortData[sortData.length - 1]);
        } else {
          distinctData = data;
        }
        return distinctData;
      }
      $scope.openMemo = openMemo;

      /**
       * Open modal to see information for the selected Memo
       * @memberof memosByCategory
       * @param {object} memo A memo object
       */
      function openMemo(_memo) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Memos/dlgMemo.html',
          controller: 'MemoModalCtrl',
          size: 'lg',
          keyboard: false,
          resolve: {
            memo: function memo() {
              return _memo;
            }
          }
        });
        modalInstance.result.then(function () {
          if (_memo.ReadDt == null) {
            _memo.ReadDt = new Date();
            MemoFactory.saveOneMemoToStorage(_memo);
            if ($scope.type == "ground") {
              MemoFactory.markGroundDutiesUnread();
            }
          }
        });
      }
    }
    return {
      restrict: 'E',
      templateUrl: "views/directives/memosByCategoryPanel.tpl.html",
      scope: {
        type: '@',
        id: '=',
        day: '='
      },
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  a3_pilot_reports.directive('securitySearch', securitySearch);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name securitySearch
  * @restrict E
  * @description
  *   Implementation of securitySearch
  *   Initialize the panel with previous flight info.
  * @example
  *   Usage:
  *   <security-search id="FlightId"></security-search>
  * @ngInject
  */
  function securitySearch(AircaftPositionsFactory, FlightFactory) {
    function link($scope) {
      var showSecurityMsg = false;
      var securitySearchRequired = null;
      var DepartureUK = null;
      var DepartureEU = null;
      var DepartureCDG = null;
      var PreviousEU = null;
      var aircaftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId($scope.id);
      var flightInfo = FlightFactory.getFlightFromStorage($scope.id);
      if (flightInfo) {
        DepartureUK = flightInfo.DepartureCountry == "UNITED KINGDOM";
        DepartureEU = flightInfo.DepartureEU;
        DepartureCDG = flightInfo.Departure == "CDG";

        // RULE 1: Current Departure Airport is UK
        // RULE 2: Current Departure Airport is Non EU
        // RULE 3: Current Departure Airport is CDG Airport
        if (DepartureUK || !DepartureEU || DepartureCDG) {
          securitySearchRequired = true;
        } else {
          securitySearchRequired = false;
        }
      }
      if (aircaftPositions) {
        // RULE 4: Previous Origin Airport is Non EU
        PreviousEU = aircaftPositions.PreviousEU;
        if (!PreviousEU) {
          securitySearchRequired = true;
        } else {
          securitySearchRequired = false;
        }
      }
      if (securitySearchRequired != null) {
        showSecurityMsg = true;
      }
      $scope.showSecurityMsg = showSecurityMsg;
      $scope.securitySearchRequired = securitySearchRequired;
      $scope.aircaftPositions = aircaftPositions;
    }
    return {
      restrict: 'E',
      templateUrl: "views/directives/securitySearch.tpl.html",
      scope: {
        id: '='
      },
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('showerrormessage', showerrormessage);

  /**
  * @ngdoc directive
  * @name showerrormessage
  * @restrict EA
  * @description
  *   Implementation of show error message
  * @attr {String} message: the error message.
  * @example
  *   Usage:
  *   <showerrormessage message="No internet access.."></showerrormessage>
  * @ngInject
  */
  function showerrormessage() {
    function link($scope, element, attrs) {
      $scope.errorMessage = attrs.message;
      $scope.hasMessage = attrs.message != null && attrs.message.length > 0;
    }
    return {
      restrict: 'E',
      template: '<div class="bs-callout border-left-red col-xs-offset-1" ng-if="hasMessage">  <i class="fa fa-warning"</i> {{errorMessage}} </div>',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('updateConfirm', updateConfirm);
  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name updateConfirm
  * @restrict E
  * @description
  *   Implementation of aircraft differences
  *
  *   Display the confirm textto update service workers version
  * @example
  *   Usage:
  *   <update-confirm></update-confirm>
  * @ngInject
  */
  function updateConfirm(SWUpdateService) {
    function link($scope, element, attributes) {
      //if serviceWorker registered
      if ($scope.SWRegistration != null) {
        $scope.needUpdate = null;
        $scope.update = update;

        //get waiting service worker if exists
        $scope.needUpdate = $scope.SWRegistration.waiting;

        //if waiting service woker exists check how long its been waiting
        if ($scope.needUpdate != null) {
          SWUpdateService.checkVersionExpiration($scope.SWRegistration);
        }
      }
      function update() {
        SWUpdateService.update($scope.SWRegistration);
      }
    }
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/directives/updateConfirm.tpl.html',
      scope: true,
      link: link
    };
  }
})();
"use strict";

// array functions
Array.prototype.dynamicSort = function (property, orderByAsc) {
  function dynamicSortComparator(property, orderByAsc) {
    var sortOrder = orderByAsc ? 1 : -1;
    return function (a, b) {
      var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
  var sortedArray = this;
  if (property != null && property != undefined) {
    orderByAsc = orderByAsc == null || orderByAsc == undefined ? true : orderByAsc;
    sortedArray = this.sort(dynamicSortComparator(property, orderByAsc));
  }
  return sortedArray;
};
Array.prototype.unique = function () {
  var arr = [];
  for (var i = 0; i < this.length; i++) {
    if (!arr.contains(this[i])) {
      arr.push(this[i]);
    }
  }
  return arr;
};
Array.prototype.contains = function (v) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] === v) return true;
  }
  return false;
};
"use strict";

// date functions
Date.prototype.toUTC = function () {
  return new Date(this.getTime() + this.getTimezoneOffset() * 60 * 1000);
};
Date.prototype.fromUTC = function () {
  return new Date(this.getTime() - this.getTimezoneOffset() * 60 * 1000);
};
Date.prototype.trimTime = function () {
  this.setHours(0, 0, 0, 0);
  return this;
};
var _DatetoJSON = Date.prototype.toJSON;
Date.prototype.toJSON = function () {
  try {
    return _DatetoJSON.call(this);
  } catch (e) {
    if (e instanceof RangeError) {
      return null;
    }
    throw e;
  }
};
Date.DifferenceInMinutes = function (firstDate, secondDate) {
  var diffInMins = null;
  if (firstDate && secondDate) {
    var _MS_TO_MINUTES = 1000 * 60;
    var date1 = new Date(firstDate);
    var date2 = new Date(secondDate);
    diffInMins = Math.floor((date2.getTime() - date1.getTime()) / _MS_TO_MINUTES);
  }
  return diffInMins;
};
Date.DifferenceInDays = function (firstDate, secondDate) {
  var diffInDays = null;
  if (firstDate && secondDate) {
    var _MS_TO_DAYS = 1000 * 3600 * 24;
    diffInDays = Math.floor((secondDate.getTime() - firstDate.getTime()) / _MS_TO_DAYS);
  }
  return diffInDays;
};
Date.MinutesToString = function (minutes) {
  var hours = Math.floor(minutes / 60);
  var mins = minutes % 60;
  return (hours > 0 ? hours + (hours == 1 ? "hr " : "hrs ") : "") + (mins > 0 ? mins + (mins == 1 ? "min" : "mins") : "");
};
Date.prototype.AddDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};
Date.MinutesToStringSimple = function (minutes) {
  var hours = Math.floor(minutes / 60);
  var mins = minutes % 60;
  return (hours != 0 ? hours + ":" : "00" + ":") + (mins > 9 ? mins : "0" + mins);
};
"use strict";

// generic string functions
String.prototype.endsWith = function (suffix) {
  return this.indexOf(suffix, this.length - suffix.length) !== -1;
};
if (typeof String.prototype.startsWith != 'function') {
  // see below for better implementation!
  String.prototype.startsWith = function (str) {
    return this.indexOf(str) == 0;
  };
}
String.prototype.reverse = function () {
  return this.split("").reverse().join("");
};
String.prototype.getHash = function () {
  var shaObj = new jsSHA("SHA-512", "TEXT");
  shaObj.update(this);
  var hash = shaObj.getHash("HEX");
  return hash;
};
if (typeof String.prototype.isNullOrWhiteSpace != 'function') {
  String.prototype.isNullOrWhiteSpace = function () {
    return this === null || this.match(/^ *$/) !== null || this.match(/^\s*$/) !== null;
  };
}
String.prototype.elipsis = function (charNo) {
  return this.length > charNo ? this.substring(0, charNo) + "..." : this;
};
"use strict";

(function () {
  a3_pilot_reports.directive('aimsCrewMemos', aimsCrewMemos);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name aimsCrewMemos
  * @restrict E
  * @description
  *   Implementation of aimsCrewMemos
  *   Initialize the Aims Crew Memos
  * @example
  *   Usage:
  *   <aims-crew-memos  date="date"></aimsCrewMemos>
  * @ngInject
  */
  function aimsCrewMemos(AimsCrewMemosFactory) {
    function link($scope, element, attrs) {
      $scope.aimsCrewMemos = AimsCrewMemosFactory.getAimsCrewMemosByDate(attrs.date);
    }
    return {
      restrict: 'E',
      templateUrl: "views/directives/aimsCrewMemos.tpl.html",
      scope: true,
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('AimsCrewMemosFactory', AimsCrewMemosFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name AimsCrewMemosFactory
  * @description 
  *   Add, Update, Delete and Get Aims Crew Memos.
  * @ngInject
  */
  function AimsCrewMemosFactory(GenericService) {
    /**
    * Initialize the AircaftPositions
    * @memberof AircaftPositionsFactory
    */
    function AimsCrewMemos() {
      this.Date = null;
      this.Line = null;
      this.OrderNo = null;
      this.GetId = GetId;
    }
    var objType = 'AimsCrewMemos';
    var objCallback = AimsCrewMemos;
    var service = {
      getAimsCrewMemosFromStorage: getAimsCrewMemosFromStorage,
      setAimsCrewMemosToStorage: setAimsCrewMemosToStorage,
      clearAimsCrewMemosFactoryFromStorage: clearAimsCrewMemosFactoryFromStorage,
      getAimsCrewMemosByDate: getAimsCrewMemosByDate,
      cleanOldAimsCrewMemos: cleanOldAimsCrewMemos,
      upsertAimsCrewMemos: upsertAimsCrewMemos
    };

    /**
     * Overide default get Id
     * @memberof AimsCrewMemosFactory
     * @returns {string} Id 
     */
    function GetId() {
      return this.Date;
    }

    /**
     * Get Aims Crew Memos
     * @memberof AimsCrewMemosFactory
     * @returns {Array} Aims Crew Memos
     */
    function getAimsCrewMemosFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    /**
     * Save Aims Crew Memos to storage
     * @memberof AimsCrewMemosFactory
     * @param {Array} A list of Aims Crew Memos
     */
    function setAimsCrewMemosToStorage(aircaftPositions) {
      GenericService.saveAll(aircaftPositions, objType, objCallback);
    }

    /**
     * Remove the  Aims Crew Memos of  the local storage
     * @memberof AimsCrewMemosFactory
     */
    function clearAimsCrewMemosFactoryFromStorage() {
      GenericService.removeAll(objType, objCallback);
    }

    /**
     * Get AimsCrewMemosFactory of this flight by date
     * @memberof AimsCrewMemosFactory
     * @returns {Object} AimsCrewMemosFactory
     */
    function getAimsCrewMemosByDate(date) {
      var crewMemos = getAimsCrewMemosFromStorage();
      var datesMemos = [];
      var arrayLength = crewMemos.length;
      for (var i = 0; i < arrayLength; i++) {
        if (crewMemos[i].GetId() == date) {
          datesMemos.push(crewMemos[i]);
        }
      }
      return datesMemos;
    }

    /**
    *  Upsert Aims Crew Memos
    * @memberof AimsCrewMemosFactory
    */
    function upsertAimsCrewMemos(aimsCrewMemos) {
      var newCrewMemos = aimsCrewMemos.map(function (x) {
        return x.Date;
      });
      var aimsCrewMemosLS = this.getAimsCrewMemosFromStorage();
      aimsCrewMemosLS = aimsCrewMemosLS.filter(function (x) {
        return !newCrewMemos.includes(x.Date);
      });
      var allAimsCrewMemos = aimsCrewMemosLS.concat(aimsCrewMemos);
      setAimsCrewMemosToStorage(allAimsCrewMemos);
    }

    /**
     * Clean Old Data
     * @memberof AimsCrewMemosFactory
     */
    function cleanOldAimsCrewMemos() {
      var now = moment();
      getAimsCrewMemosFromStorage(function (crewMemos) {
        var memosToKeep = crewMemos.filter(function (item) {
          var memoDate = moment(item.Date);
          return now.diff(memoDate, 'days') < 5;
        });
        // keep only the memo with pending reports
        setAimsCrewMemosToStorage(memosToKeep);
      });
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('AircaftPositionsFactory', AircaftPositionsFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name AircaftPositionsFactory
  * @description 
  *   Add, Update, Delete and Get AircaftPositions.
  * @ngInject
  */
  function AircaftPositionsFactory(GenericService) {
    /**
    * Initialize the AircaftPositions
    * @memberof AircaftPositionsFactory
    */
    function AircaftPositions() {
      this.FlightId = null;
      this.PreviousFlightNo = null;
      this.PreviousStation = null;
      this.PreviousSTA = null;
      this.PreviousETA = null;
      this.PreviousATA = null;
      this.PreviousGATE = null;
      this.PreviousSTAND = "";
      this.PreviousSTANDArrival = "";
      this.NextFlightNo = null;
      this.NextStation = null;
      this.NextSTD = null;
      this.NextETD = null;
      this.NextATD = null;
      this.NextGATE = null;
      this.NextSTAND = "";
      this.NextSTANDArrival = "";
      this.GetId = GetId;
    }
    var objType = 'aircaftpositions';
    var objCallback = AircaftPositions;
    var service = {
      getAircaftPositionsFromStorage: getAircaftPositionsFromStorage,
      setAircaftPositionsToStorage: setAircaftPositionsToStorage,
      clearAircaftPositionsFromStorage: clearAircaftPositionsFromStorage,
      getAircaftPositionsByFlightId: getAircaftPositionsByFlightId,
      updateAircraftPositionsToStorage: updateAircraftPositionsToStorage,
      cleanOldData: cleanOldData
    };

    /**
     * Overide default get Id
     * @memberof AircaftPositionsFactory
     * @returns {number} Id 
     */
    function GetId() {
      return this.FlightId;
    }

    /**
     * Get messages
     * @memberof AircaftPositionsFactory
     * @returns {Array} Aircaft Positions 
     */
    function getAircaftPositionsFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    /**
     * Save Aircaft Positions to storage
     * @memberof AircaftPositionsFactory
     * @param {Array} messages A list of Aircaft Positions
     */
    function setAircaftPositionsToStorage(aircaftPositions) {
      GenericService.saveAll(aircaftPositions, objType, objCallback);
    }

    /**
     * Remove the Aircaft Positions of  the local storage
     * @memberof AircaftPositionsFactory
     */
    function clearAircaftPositionsFromStorage() {
      GenericService.removeAll(objType, objCallback);
    }

    /**
     * Get Aircaft Positions of this flight
     * @memberof AircaftPositionsFactory
     * @returns {Object} Aircaft Positions 
     */
    function getAircaftPositionsByFlightId(flightId) {
      return GenericService.get(flightId, objType, objCallback);
    }

    /**
    * Update Aircraft Position to storage
    * @memberof AircaftPositionsFactory
    * @param {object} aircraftPositions  Aircraft Positions
    */
    function updateAircraftPositionsToStorage(aircraftPositions, flightId) {
      if (GenericService.get(flightId, objType, objCallback)) {
        GenericService.save(aircraftPositions, objType, objCallback);
      } else if (aircraftPositions != null) GenericService.add(aircraftPositions, objType, objCallback);
    }

    /**
     * Clean ls from old flights aircraft positions
     * @param {array} flights Synced flights
     */
    function cleanOldData(responseFlightIds) {
      var previousAircaftPositions = getAircaftPositionsFromStorage();
      previousAircaftPositions = previousAircaftPositions.filter(function (x) {
        return responseFlightIds.includes(x.FlightId);
      });
      setAircaftPositionsToStorage(previousAircaftPositions);
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('crewRouteInfoPanel', crewRouteInfoPanel);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name crewRouteInfoPanel
  * @restrict EA
  * @description
  *   Implementation of crewRouteInfoPanel
  *
  *   Initialize the crew Route Info panel 
  * @example
  *   Usage:
  *   <div crew-route-info-panel></div>
  * @ngInject
  */
  function crewRouteInfoPanel($routeParams, $uibModal) {
    function link($scope, element, attrs) {
      $scope.showDefaultView = showDefaultView;
      $scope.showFlightTimes = showFlightTimes;
      $scope.showCommercialView = showCommercialView;
      $scope.showDelaysView = showDelaysView;
      $scope.toggleshowHiddenRows = toggleshowHiddenRows;
      $scope.delaysColumns = false;
      $scope.showDate = showDate;
      $scope.openCrewContactsModal = openCrewContactsModal;
      $scope.showHiddenRows = false;
      $scope.defaultColumns = true;
      $scope.commercialColumns = false;
      $scope.timesColumns = false;
      $scope.crewMeals = '';
      function showDefaultView() {
        $scope.defaultColumns = true;
        $scope.timesColumns = false;
        $scope.commercialColumns = false;
        $scope.delaysColumns = false;
      }
      function showFlightTimes() {
        $scope.defaultColumns = false;
        $scope.timesColumns = true;
        $scope.commercialColumns = false;
        $scope.delaysColumns = false;
      }
      function showCommercialView() {
        $scope.defaultColumns = false;
        $scope.timesColumns = false;
        $scope.commercialColumns = true;
        $scope.delaysColumns = false;
      }
      function showDelaysView() {
        $scope.defaultColumns = false;
        $scope.timesColumns = false;
        $scope.commercialColumns = false;
        $scope.delaysColumns = true;
      }
      function toggleshowHiddenRows() {
        if ($scope.crewRouteInfoPanel.hasAircraftPositions) {
          $scope.showHiddenRows = !$scope.showHiddenRows;
        }
      }
      function showDate(acRouteSTD, flightSTD) {
        var datediff = moment(acRouteSTD).startOf('day').diff(moment(flightSTD).startOf('day'), 'days');
        return datediff != 0;
      }

      /**
       * Open dialog with the crew details
       * @memberof BucketCtrl
       */
      function openCrewContactsModal(_crewInfo, _selectedflightid, _selectedFlightNo) {
        if (_crewInfo && _crewInfo.length > 0) {
          var modalInstance = $uibModal.open({
            templateUrl: 'views/CrewRoute/dlgCrewContacts.html',
            controller: 'CrewContactsModalCtrl',
            backdrop: 'static',
            keyboard: false,
            size: 'md',
            resolve: {
              crewInfo: function crewInfo() {
                return _crewInfo;
              },
              selectedflightid: function selectedflightid() {
                return _selectedflightid;
              },
              selectedFlightNo: function selectedFlightNo() {
                return _selectedFlightNo;
              }
            }
          });
        }
      }
    }
    return {
      restrict: 'EA',
      terminal: true,
      templateUrl: 'views/directives/crewRouteInfoPanel.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('eventHistory', eventHistory);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name eventHistory
  * @restrict E
  * @description
  *   Implementation of eventHistory
  *   Initialize the Event History of report incidents (mockup view).
  * @example
  *   Usage:
  *   <event-history></event-history>
  * @ngInject
  */
  function eventHistory() {
    return {
      restrict: 'E',
      templateUrl: 'views/directives/eventHistory.tpl.html'
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('flightStatus', flightStatus);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name flightStatus
  * @restrict EA
  * @description
  *   Implementation of flightStatus
  *
  *   Initialize the flight Status panel needs to have flight in scope
  * @example
  *   Usage:
  *   <div flight-status></div>
  * @ngInject
  */
  function flightStatus(AircaftPositionsFactory) {
    function needsSecuritySearch() {
      if ($scope.aircaftPositions.PreviousEU) {
        $scope.securitySearch = false;
      }
      if ($scope.aircaftPositions.PreviousCounty == "SWITZERLAND" || $scope.aircaftPositions.PreviousCounty == "NORWAY" || $scope.aircaftPositions.PreviousCounty == "ICELAND" || $scope.aircaftPositions.PreviousCounty == "MONTENEGRO") {
        $scope.securitySearch = false;
      }
      if ($scope.aircaftPositions.PreviousCounty == "UNITED KINGDOM" || $scope.aircaftPositions.PreviousCounty == "FRANCE") {
        $scope.securitySearch = true;
      }
      if ($scope.flight.ArrivalCountry == "TURKEY" || $scope.flight.ArrivalCountry == "EGYPT" || $scope.flight.ArrivalCountry == "ISRAEL" || $scope.flight.ArrivalCountry == "JORDAN" || $scope.flight.ArrivalCountry == "SAUDI ARABIA") {
        $scope.securitySearch = true;
      }
    }
    return {
      restrict: 'EA',
      terminal: true,
      templateUrl: 'views/directives/flightStatus.tpl.html',
      scope: false,
      link: function link($scope, element, attrs) {
        $scope.securitySearch = false;
        if ($scope.flight && $scope.flight.FlightId) {
          $scope.aircaftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId($scope.flight.FlightId);
        }
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('FlightConfigCtrl', FlightConfigCtrl);
  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name FlightConfigCtrl
  * @description 
  *   Set the ETA of the flight
  * @ngInject
  */
  function FlightConfigCtrl($scope, $uibModalInstance, flight, FlightFactory) {
    $scope.cancel = cancel;
    $scope.save = save;
    $scope.flightETA = new Date(flight.ETA ? flight.ETA : flight.ScheduledArrival);

    /**
     * Save the new ETA
     * @memberof FlightConfigCtrl
     */
    function save() {
      if ($scope.flightETA) {
        var ETAdate = $scope.flightETA;
        var STDdate = new Date(flight.ScheduledDeparture);
        var ETAtimestamp = ETAdate.getTime();
        var STDtimestamp = STDdate.getTime();
        ETAdate.setUTCFullYear(STDdate.getUTCFullYear());
        ETAdate.setUTCMonth(STDdate.getUTCMonth());
        ETAdate.setUTCDate(STDdate.getUTCDate());
        if (ETAtimestamp < STDtimestamp) {
          ETAdate.setUTCDate(STDdate.getUTCDate() + 1);
        }
        $scope.flightETA = ETAdate;
      }
      flight.ETA = $scope.flightETA;
      FlightFactory.updateFlight(flight);
      $uibModalInstance.close(flight);
    }

    /**
     * Close the modal
     * @memberof FlightConfigCtrl
     */
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('FlightDelaysFactory', FlightDelaysFactory);
  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name FlightDelaysFactory
  * @description 
  *   Add, Update, Delete and Get FlightDelays.
  * @ngInject
  */
  function FlightDelaysFactory(GenericService) {
    var objType = 'FlightDelays';
    var objCallback = FlightDelays;

    /**
     * Initialize the FlightDelays
     * @memberof FlightDelaysFactory
     */
    function FlightDelays() {
      this.GetId = GetId;
    }
    var service = {
      getFlightDelaysFromStorage: getFlightDelaysFromStorage,
      setFlightDelaysToStorage: setFlightDelaysToStorage,
      getFlightDelaysByFlightId: getFlightDelaysByFlightId,
      addFlightDelays: addFlightDelays,
      upsertFlightDelays: upsertFlightDelays,
      cleanOldFlightDelays: cleanOldFlightDelays
    };

    //Object Functions
    /**
     * Overide default get Id
     * @memberof FlightFactory
     * @returns {number} Id 
     */
    function GetId() {
      return this.FlightId;
    }

    /**
      * Get FlightDelays
      * @memberof FlightDelaysFactory
      * @param {function} callback  
      */
    function getFlightDelaysFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    ;

    /**
    * Save FlightDelays to storage
    * @memberof FlightDelaysFactory
    * @param {Array} FlightDelays A list of FlightDelays
    */
    function setFlightDelaysToStorage(flightDelays) {
      GenericService.saveAll(flightDelays, objType, objCallback);
    }

    /**
    * Get single flight FlightDelays
    * @memberof FlightDelaysFactory
    * @param {function} callback  
    */
    function getFlightDelaysByFlightId(flightId) {
      return GenericService.get(flightId, objType, objCallback);
    }
    ;

    /**
    * Set single flight FlightDelays
    * @memberof FlightDelaysFactory
    * @param {function} callback  
    */
    function addFlightDelays(FlightDelays) {
      return GenericService.add(FlightDelays, objType, objCallback);
    }
    ;

    /**
    *  Upsert Flight Delays
    * @memberof FlightDelaysFactory
    */
    function upsertFlightDelays(newflightDelays) {
      var newFLightIds = newflightDelays.map(function (x) {
        return x.FlightId;
      });
      var flightDelaysLS = this.getFlightDelaysFromStorage();
      flightDelaysLS = flightDelaysLS.filter(function (x) {
        return !newFLightIds.includes(x.FlightId);
      });
      var allFlightDelays = flightDelaysLS.concat(newflightDelays);
      setFlightDelaysToStorage(allFlightDelays);
    }

    /**
           * Clean Old Data
           * @memberof FlightDelaysFactory
           * @param {Array} pendingFlightIds FlightIds with pending reports
           */
    function cleanOldFlightDelays(pendingFlightIds) {
      var now = moment();
      getFlightDelaysFromStorage(function (flightDelays) {
        var pendingFlightDelays = flightDelays.filter(function (item) {
          var date = moment(item.FlightDate);
          return pendingFlightIds.includes(item.FlightId);
        });
        // keep only the FlightDelays with pending reports
        setFlightDelaysToStorage(pendingFlightDelays);
      });
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('FlightGateCtrl', FlightGateCtrl);
  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name FlightGateCtrl
  * @description 
  *   View all flight connections and search for more possible connecting flights
  * @ngInject
  */
  function FlightGateCtrl($scope, $uibModalInstance, flight, FlightGateFactory, SyncLogFactory, FlightFactory, PaxInfoFactory) {
    var paxInfo = PaxInfoFactory.getPaxInfoFromStorage(flight.FlightId);
    var flightId = flight.FlightId;
    var items = [];
    var syncLog = SyncLogFactory.getSyncLog();
    var distinct_gates = [];
    var searchFilters = flight.FlightsFilters;
    var gates = FlightGateFactory.getAfterSTDFromStorage(flight.ScheduledDeparture, flight.Arrival);
    $scope.isConnectedFlightClose = isConnectedFlightClose;
    $scope.TimeDifference = TimeDifference;
    $scope.IsOld = IsOld;
    $scope.searchText = '';
    $scope.addFilter = addFilter;
    $scope.removeFilter = removeFilter;
    $scope.cancel = cancel;
    $scope.filters = searchFilters;
    applyFilter();
    if (paxInfo) {
      items = paxInfo.TotalFlights;
    }
    for (var i = 0; i < gates.length; i++) {
      var exists = false;
      for (var j = 0; j < items.length; j++) {
        if (items[j].FlightNo == gates[i].FlightNo && items[j].Dep == gates[i].Dep) {
          var connectingTime = new Date(items[j].STD_lcl);
          var flightGateTime = new Date(gates[i].STD);
          if (connectingTime.getTime() == flightGateTime.getTime()) {
            if (items[j].Codeshares.length == 0) {
              items[j].Codeshares == gates[i].Codeshares;
            }
            exists = true;
            break;
          }
        }
      }
      if (!exists) {
        var distinct_gate = {
          FlightNo: gates[i].FlightNo,
          Gate: gates[i].DepGate,
          Arr: gates[i].Arrival,
          STD_lcl: gates[i].STD_lcl,
          STD: gates[i].STD,
          pax: null,
          Codeshares: gates[i].Codeshares,
          UpdatedDate: gates[i].lastUpdate
        };
        distinct_gates.push(distinct_gate);
      }
    }
    var flightArrivalTime = new Date(flight.ScheduledArrival).getTime();
    $scope.hasGates = distinct_gates.length > 0;
    $scope.items = items.sort(function (a, b) {
      return new Date(a.STD).getTime() - new Date(b.STD).getTime();
    });
    $scope.flightETA = flight.ETA ? new Date(flight.ETA).getTime() : flightArrivalTime;

    /**
     * Calculates if a connecting flight is departs sort time after fligths arrival 
     * @memberof FlightGateCtrl
     * @param {string} connection Connection STD
     * @return {string} cssClass
     */
    function isConnectedFlightClose(connection) {
      if (!connection) {
        return '';
      }
      var connFlightDate = new Date(connection).getTime();
      if ($scope.flightETA > connFlightDate) return '';
      if (connFlightDate - $scope.flightETA < 3600001) {
        return 'bg-bisque';
      }
      if (connFlightDate - $scope.flightETA < 6480000) {
        return 'bg-cornsilk';
      }
      return '';
    }

    /**
     * Returns the time difference
     * @memberof FlightGateCtrl
     * @param {string} time Connection STD
     * @return {string} timeDifference
     */
    function TimeDifference(time) {
      var timeString = '';
      var sign = '';
      var dayString = null;
      if (time) {
        var connFlightDate = new Date(time);
        var ms = connFlightDate.getTime() - $scope.flightETA; // this is a time in milliseconds
        if (ms < 0) {
          ms = -ms;
          sign = "-";
        }
        var days = Math.floor(ms / (24 * 60 * 60 * 1000));
        days = days < 0 ? days + 1 : days;
        var daysms = ms % (24 * 60 * 60 * 1000);
        var hours = Math.floor(daysms / (60 * 60 * 1000));
        var hoursms = ms % (60 * 60 * 1000);
        var minutes = Math.floor(hoursms / (60 * 1000));
        timeString = '<strong>' + sign + (hours > 0 ? ("0" + hours).substr(-2) + ":" : '') + ("0" + minutes).substr(-2) + '\'' + '<strong>';
        dayString = ' <span class="badge">' + days + 'd</span>';
      }
      return timeString + (days && days != 0 ? dayString : '');
    }

    /**
     * Checks if the data are new
     * @memberof FlightGateCtrl
     * @param {string} time timestamp
     * @return {boolean} IsOld
     */
    function IsOld(time) {
      IsOld = false;
      if (time) {
        var now = new Date();
        var timeDate = new Date(time);
        var diff = now.getTime() - timeDate.getTime();
        if (diff > 3600000) {
          IsOld = true;
        }
      }
      return IsOld;
    }

    /**
    * Apply given filters to show connectings flights
    * @memberof FlightGateCtrl
    */
    function applyFilter() {
      var newFlightgates = [];
      if (searchFilters.length > 0) {
        for (var i = 0; i < distinct_gates.length; i++) {
          for (var j = 0; j < searchFilters.length; j++) {
            var row = distinct_gates[i].FlightNo + "," + distinct_gates[i].Codeshares.toString();
            if (row.indexOf(searchFilters[j].toString()) >= 0) {
              newFlightgates.push(distinct_gates[i]);
              break;
            }
          }
        }
      }
      $scope.gates = newFlightgates.sort(function (a, b) {
        return new Date(a.STD).getTime() - new Date(b.STD).getTime();
      });
    }

    /**
     * Add a filter
     * @memberof FlightGateCtrl
     * @param {string} searchText Search text
     */
    function addFilter(searchText) {
      if (searchText.trim().length > 0) {
        var exists = false;
        for (var i = 0; i < $scope.filters.length; i++) {
          if ($scope.filters[i] == searchText.toString().toUpperCase()) {
            exists = true;
            break;
          }
        }
        if (!exists) {
          var flight = FlightFactory.getFlightFromStorage(flightId);
          searchFilters.push(searchText.toString().toUpperCase());
          flight.FlightsFilters = searchFilters;
          FlightFactory.updateFlight(flight);
          $scope.filters = searchFilters;
        }
        $scope.searchText = "";
        applyFilter();
      }
    }
    /**
     * Remove a filter
     * @memberof FlightGateCtrl
     * @param {item} string filter
     */
    function removeFilter(item) {
      var flight = FlightFactory.getFlightFromStorage(flightId);
      var index = searchFilters.indexOf(item);
      searchFilters.splice(index, 1);
      flight.FlightsFilters = searchFilters;
      FlightFactory.updateFlight(flight);
      $scope.filters = searchFilters;
      applyFilter();
    }

    /**
     * Close the modal
     * @memberof FlightGateCtrl
     */
    function cancel() {
      $uibModalInstance.close($scope.gates);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('FlightGateFactory', FlightGateFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name FlightGateFactory
  * @description 
  *   Add, Update, Delete and Get Flight Gates.
  * @ngInject
  */
  function FlightGateFactory(GenericService) {
    /**
    * Initialize the FlightGate
    * @memberof FlightGateFactory
    */
    function FlightGate() {
      this.FlightDate = null;
      this.Codeshares = [];
      this.FlightNo = null;
      this.Codeshares = [];
      this.Departure = null;
      this.Arrival = null;
      this.STD = null;
      this.STA = null;
      this.ETD = null;
      this.ETA = null;
      this.STD_Diff = null;
      this.STA_Diff = null;
      this.STD_lcl = null;
      this.STA_lcl = null;
      this.ETD_lcl = null;
      this.ETA_lcl = null;
      this.DepGate = null;
      this.DepStand = null;
      this.AcType = null;
      this.lastUpdate = null;
      //net fields used to hold values before latest update
      this.previousUpdate = null;
      this.previousGate = null;
      this.previousSTD = null;
      this.previousSTD_lcl = null;
      this.previousSTD_Diff = null;
      this.previousSTA = null;
      this.previousSTA_lcl = null;
      this.previousSTA_Diff = null;

      //object functions
      this.getRoute = getRoute;
      this.dtSTD = dtSTD;
      this.dtSTA = dtSTA;
      this.dtETD = dtETD;
      this.dtETA = dtETA;
      this.dtSTD_lcl = dtSTD_lcl;
      this.dtSTA_lcl = dtSTA_lcl;
      this.dtETD_lcl = dtETD_lcl;
      this.dtETA_lcl = dtETA_lcl;
      this.dateSTD = dateSTD;
      this.timeSTD = timeSTD;
      this.timeSTA = timeSTA;
      this.timeETD = timeETD;
      this.timeETA = timeETA;
      this.timeSTD_lcl = timeSTD_lcl;
      this.timeSTA_lcl = timeSTA_lcl;
      this.timeETD_lcl = timeETD_lcl;
      this.timeETA_lcl = timeETA_lcl;
      this.hasETD = hasETD;
      this.hasETA = hasETA;
      this.depDelay = depDelay;
      this.arrDelay = arrDelay;
      this.setUpdatedNow = setUpdatedNow;
      this.gateChanged = gateChanged;
      this.stdChanged = stdChanged;
      this.staChanged = staChanged;
      this.stdDiffChanged = stdDiffChanged;
      this.staDiffChanged = staDiffChanged;
      this.toString = toString;
      this.changesToString = changesToString;
      this.getKey = getKey;
    }
    var objType = 'FlightGates';
    var objCallback = FlightGate;
    var service = {
      processUpdatedData: processUpdatedData,
      getFromStorage: getFromStorage,
      getAfterSTDFromStorage: getAfterSTDFromStorage,
      setToStorage: setToStorage
    };

    //Object functions
    function getRoute() {
      if (this.Departure == null && this.Arrival == null) return '-null-';else return (this.Departure || '?') + '-' + (this.Arrival || '?');
    }

    /**
    * Transform STD iso string to datetime
    * @memberof FlightGateFactory
    * @return {object} date
    */
    function dtSTD() {
      return stringIsoToDateTime(this.STD);
    }

    /**
    * Transform STA iso string to datetime
    * @memberof FlightGateFactory
    * @return {object} date
    */
    function dtSTA() {
      return stringIsoToDateTime(this.STA);
    }

    /**
    * Transform ETD iso string to datetime
    * @memberof FlightGateFactory
    * @return {object} date
    */
    function dtETD() {
      return stringIsoToDateTime(this.ETD);
    }

    /**
    * Transform ETA iso string to date
    * @memberof FlightGateFactory
    * @return {object} date
    */
    function dtETA() {
      return stringIsoToDateTime(this.ETA);
    }
    /**
    * Transform local STD iso string to datetime
    * @memberof FlightGateFactory
    * @return {object} date
    */
    function dtSTD_lcl() {
      return stringIsoToDateTime(this.STD_lcl);
    }
    /**
    * Transform local STA iso string to datetime
    * @memberof FlightGateFactory
    * @return {object} date
    */
    function dtSTA_lcl() {
      return stringIsoToDateTime(this.STA_lcl);
    }
    /**
    * Transform local ETD iso string to datetime
    * @memberof FlightGateFactory
    * @return {object} date
    */
    function dtETD_lcl() {
      return stringIsoToDateTime(this.ETD_lcl);
    }
    /**
    * Transform local ETA iso string to datetime
    * @memberof FlightGateFactory
    * @return {object} date
    */
    function dtETA_lcl() {
      return stringIsoToDateTime(this.ETA_lcl);
    }
    /**
    * Transform local ETA iso string to datetime
    * @memberof FlightGateFactory
    * @return {object} date
    */
    function dateSTD() {
      return stringIsoToDateString(this.STD);
    }
    /**
    * Transform STD iso string to time string 
    * @memberof FlightGateFactory
    * @return {string} time
    */
    function timeSTD() {
      return stringIsoToTimeString(this.STD);
    }
    /**
    * Transform STA iso string to time string 
    * @memberof FlightGateFactory
    * @return {string} time
    */
    function timeSTA() {
      return stringIsoToTimeString(this.STA);
    }
    /**
    * Transform ETD iso string to time string
    * @memberof FlightGateFactory
    * @return {object} time
    */
    function timeETD() {
      return stringIsoToTimeString(this.ETD);
    }
    /**
    * Transform ETA iso string to time string
    * @memberof FlightGateFactory
    * @return {string} time
    */
    function timeETA() {
      return stringIsoToTimeString(this.ETA);
    }
    /**
    * Transform STD iso string to local time string
    * @memberof FlightGateFactory
    * @return {string} time
    */
    function timeSTD_lcl() {
      return stringIsoToTimeString(this.STD_lcl);
    }
    /**
    * Transform local STA iso string to string time
    * @memberof FlightGateFactory
    * @return {string} time
    */
    function timeSTA_lcl() {
      return stringIsoToTimeString(this.STA_lcl);
    }
    /**
    * Transform local ETD iso string to time string
    * @memberof FlightGateFactory
    * @return {string} time
    */
    function timeETD_lcl() {
      return stringIsoToTimeString(this.ETD_lcl);
    }
    /**
    * Transform local ETA iso string to time
    * @memberof FlightGateFactory
    * @return {string} time
    */
    function timeETA_lcl() {
      return stringIsoToTimeString(this.ETA_lcl);
    }
    /**
    * Transform local ETA iso string to time
    * @memberof FlightGateFactory
    * @return {string} time
    */
    function hasETD() {
      if (this.ETD && this.STD != this.ETD && this.dtSTD() < this.dtETD()) return true;else return false;
    }
    /**
    * check if gate has ETA
    * @memberof FlightGateFactory
    * @return {boolean} hasETA
    */
    function hasETA() {
      return this.ETA && this.STA != this.ETA && this.dtSTA() < this.dtETA();
    }
    /**
    * check if gate has ETA
    * @memberof FlightGateFactory
    * @return {boolean} hasETA
    */
    function depDelay() {
      if (this.hasETD() && this.STD_Diff && this.STD_Diff > 0) return this.STD_Diff;else return null;
    }
    /**
    * Return arrival delay
    * @memberof FlightGateFactory
    * @return {boolean} STA_Diff
    */
    function arrDelay() {
      if (this.hasETA() && this.STA_Diff && this.STA_Diff > 0) return this.STA_Diff;else return null;
    }

    /**
    * record the current time as the lastUpdate of the object
    * @memberof FlightGateFactory
    */
    function setUpdatedNow() {
      this.lastUpdate = new Date();
      if (this.DepGate == null) this.DepGate = '';
    }

    /**
    * Check if the gate has changed since the last update
    * @memberof FlightGateFactory
    * @return {boolean} gateChanged
    */
    function gateChanged() {
      if (!this.previousGate) return false;else return true;
    }

    /**
    * Check if the STD has changed since the last update
    * @memberof FlightGateFactory
    * @return {boolean} stdChanged
    */
    function stdChanged() {
      if (!this.previousSTD) return false;else return true;
    }

    /**
    * Check if the STA has changed since the last update
    * @memberof FlightGateFactory
    * @return {boolean} staChanged
    */
    function staChanged() {
      if (!this.previousSTA) return false;else return true;
    }

    /**
    * Check if the STD diff has changed since the last update
    * @memberof FlightGateFactory
    * @return {boolean} stdDiffChanged
    */
    function stdDiffChanged() {
      if (!this.previousSTD_Diff) return false;else return true;
    }

    /**
    * Check if the STA diff has changed since the last update
    * @memberof FlightGateFactory
    * @return {boolean} staDiffChanged
    */
    function staDiffChanged() {
      if (!this.previousSTA_Diff) return false;else return true;
    }

    /**
    * Print the flight gate info
    * @memberof FlightGateFactory
    * @return {string} toSting
    */
    function toString() {
      var s = this.dateSTD() + ' ' + this.FlightNo;
      s += ' ' + this.Departure + '-' + this.Arrival;
      s += ' ' + (this.hasETD() ? 'ETD' + this.timeETD_lcl() + (this.depDelay() ? '[+' + this.depDelay() + '\']' : '') : 'STD' + this.timeSTD_lcl());
      s += '->' + (this.hasETA() ? 'ETA' + this.timeETA_lcl() + '[' + (this.STA_Diff > 0 ? '+' : '-') + this.STA_Diff + '\']' : 'STA' + this.timeSTA_lcl());
      s += this.DepGate ? ' Gate: ' + this.DepGate : '';
      return s;
    }

    /**
    * Show all the changes of  the flight gates
    * @memberof FlightGateFactory
    * @return {string} toSting
    */
    function changesToString() {
      var s = '';
      if (this.stdChanged()) s += 'STD: ' + stringIsoToTimeString(this.previousSTD) + ' -> ' + this.timeSTD();
      if (self.stdDiffChanged()) s += (s == '' ? '' : ', ') + 'departure delay: ' + this.previousSTD_Diff + ' -> ' + this.STD_Diff;
      if (self.staChanged()) s += (s == '' ? '' : ', ') + 'STA: ' + stringIsoToTimeString(this.previousSTA) + ' -> ' + this.timeSTA();
      if (self.staDiffChanged()) s += (s == '' ? '' : ', ') + 'arrival delay: ' + this.previousSTA_Diff + ' -> ' + this.STA_Diff;
      if (self.gateChanged()) s += (s == '' ? '' : ', ') + ' gate: ' + this.previousGate + ' -> ' + this.DepGate;
      return s;
    }

    /**
    * returns a string with all the fields uniquely defining a flight, concatenated
    * @memberof FlightGateFactory
    * @return {string} key
    */
    function getKey() {
      var s = this.FlightDate + '|' + this.FlightNo + '|' + this.Departure + '-' + this.Arrival;
      return s;
    }

    /**
    * Transform iso datetime string to date time Object
    * @memberof FlightGateFactory
    * @return {Object} DateTime
    */
    function stringIsoToDateTime(str) {
      var dt = null;
      try {
        if (str) {
          //replace T in order to avoid browser converting datetime to browser's timezone
          //eg 2016-05-17T23:04:00 would be converted to Wed May 18 2016 02:04:00 GMT+0300 (GTB Daylight Time) when we want it to be Tue May 17 2016 23:04:00 GMT+0300 (GTB Daylight Time)
          str = str.replace('T', ' ');
          dt = new Date(str);
        }
      } catch (e) {}
      return dt;
    }

    /**
    * Transform iso datetime string to date string
    * @memberof FlightGateFactory
    * @return {string} date
    */
    function stringIsoToDateString(str) {
      var dt = stringIsoToDateTime(str);
      var s = null;
      if (dt) {
        var year = dt.getFullYear();
        var month = dt.getMonth() + 1;
        var day = dt.getDate();
        s = (day < 10 ? '0' : '') + day + '.' + (month < 10 ? '0' : '') + month + '.' + year;
      }
      return s;
    }

    /**
    * Transform iso datetime string to time string
    * @memberof FlightGateFactory
    * @return {string} time
    */
    function stringIsoToTimeString(str) {
      var dt = stringIsoToDateTime(str);
      var s = null;
      if (dt) {
        var hour = dt.getHours();
        var min = dt.getMinutes();
        s = (hour < 10 ? '0' : '') + hour + ':' + (min < 10 ? '0' : '') + min + '';
      }
      return s;
    }

    /**
    * Process updated list of fligths 'gates' and store them.Before storing them, we need to identify changes in Gates and in ETD/ETA to notify customers when required. 
    * @memberof FlightGateFactory
    */
    function processUpdatedData(data) {
      //Update List
      var list = fromObjectList(data);

      //Original List
      var listPrevious = getFromStorage();

      //Search each "new" flight in the new list, and check if it has been modified since last update
      if (list && list.length > 0) {
        var flight, flightPrevious, hasChanged;
        var previousLength = listPrevious.length;
        for (var i = 0; i < list.length; i++) {
          flight = list[i];
          //mark that this flight was updated now
          flight.setUpdatedNow();
          //check for flight in previous list, and if found, check for changes
          if (listPrevious && previousLength > 0) {
            for (var p = 0; p < previousLength; p++) {
              flightPrevious = listPrevious[p];
              if (flight.getKey() === flightPrevious.getKey()) {
                hasChanged = false;
                if (flight.DepGate != flightPrevious.DepGate) {
                  hasChanged = true;
                  flight.previousGate = flightPrevious.DepGate;
                }
                if (flight.STD != flightPrevious.STD) {
                  hasChanged = true;
                  flight.previousSTD = flightPrevious.STD;
                  flight.previousSTD_lcl = flightPrevious.STD_lcl;
                }
                if (flight.STA != flightPrevious.STA) {
                  hasChanged = true;
                  flight.previousSTA = flightPrevious.STA;
                  flight.previousSTA_lcl = flightPrevious.STA_lcl;
                }
                if (flight.STD_Diff != flightPrevious.STD_Diff) {
                  hasChanged = true;
                  flight.previousSTD_Diff = flightPrevious.STD_Diff;
                }
                if (flight.STA_Diff != flightPrevious.STA_Diff) {
                  hasChanged = true;
                  flight.previousSTA_Diff = flightPrevious.STA_Diff;
                }
                if (hasChanged) {
                  flight.previousUpdate = flightPrevious.lastUpdate;
                }
                break;
              }
            }
          }
        }
      }
      setToStorage(list);
    }
    /**
    * Get flightgates from storage
    * @memberof FlightGateFactory
    * @return {array} flightgates
    */
    function getFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    /**
    * Get flightgates after std and flight gates selected departure
    * @memberof FlightGateFactory
    * @param {string} std  STD iso datetime string   
    * @param {string} dep  Departure
    * @return {array} flightgates
    */
    function getAfterSTDFromStorage(std, dep) {
      var newFlightgates = [];
      var now_utc = new Date(std);
      var date = now_utc.getTime();
      var flightgates = getFromStorage();
      for (var i = 0; i < flightgates.length; i++) {
        var dateSTD = new Date(flightgates[i].STD);
        var dateETD = null;
        if (dateETD) {
          dateETD = new Date(flightgates[i].ETD);
        }
        if ((dateSTD.getTime() >= date || dateETD != null && dateETD.getTime() >= date) && dep == flightgates[i].Departure &&
        //check only for 2 days later
        dateSTD.getTime() <= date + 172800000) {
          newFlightgates.push(flightgates[i]);
        }
      }
      return newFlightgates;
    }

    /**
    * Set flightgates from storage
    * @memberof FlightGateFactory
    * @param {array} data
    */
    function setToStorage(data) {
      GenericService.saveAll(data, objType, objCallback);
    }

    /**
    * Set flightgates from storage
    * @memberof FlightGateFactory
    * @param {array} data
    */
    function fromObjectList(objList) {
      if (objList == null) return [];
      var arrayLength = objList.length;
      var result = [];
      for (var i = 0; i < arrayLength; i++) {
        var item = new FlightGate();
        angular.extend(item, objList[i]);
        result.push(item);
      }
      return result;
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('FlightInfoCtrl', FlightInfoCtrl);

  /**
   * @memberof PilotReports
   * @ngdoc controller
   * @name FlightInfoCtrl
   * @description 
   *   Shows the flight informations
   * @ngInject
   */
  function FlightInfoCtrl($scope, $location, $routeParams, $uibModal, barOptions, FlightFactory, PaxInfoFactory, MessageFactory, $anchorScroll, CrewCallFactory, PreviousDutyFactory, UserFactory, AircaftPositionsFactory, AimsCrewMemosFactory, showCatIIApprachAcTypes, showGroundInfoAcTypes, FlightCheckInsFactory, CrewRouteFactory) {
    var flightId = $routeParams.flightId;
    var flight = FlightFactory.getFlightFromTotalFlights(flightId);
    $scope.user = UserFactory.getUser();
    $scope.flightId = flightId;
    $scope.shownSideMenu = false;
    $scope.sideMenuItems = [];
    $scope.showSidePanel = showSidePanel;
    $scope.hideSidePanel = hideSidePanel;
    $scope.goToPanel = goToPanel;
    function hideSidePanel() {
      $scope.shownSideMenu = false;
    }
    function goToPanel(id) {
      $location.hash(id);
      $anchorScroll();
      hideSidePanel();
    }
    ;
    function showSidePanel() {
      $scope.sideMenuItems = [];
      $('.panel-heading .title').each(function () {
        var menuItem = {};
        menuItem.id = $(this).attr("id");
        menuItem.title = $(this).html();
        menuItem.icon = $(this).data('icon');
        $scope.sideMenuItems.push(menuItem);
      });
      $scope.shownSideMenu = true;
    }
    if (!flight) {
      // go to dashboard
      $location.path("/");
    } else {
      //Initialize Zones
      var onlyUnique = function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
      };
      var RenderFlightZones = function RenderFlightZones(zones) {
        var flightZones = [];
        if (zones != null) {
          var zoneTitles = zones.map(function (item) {
            return item.Title;
          });
          var uniqueZones = zoneTitles.filter(onlyUnique);
          // //or
          // var uniqueZones2 = Array.from(new Set(zoneTitles));

          uniqueZones.forEach(function (element) {
            var getZoneCounter = zoneTitles.filter(function (item) {
              return item == element;
            });
            if (getZoneCounter.length > 1) {
              flightZones.push({
                Title: element.Title,
                Class: null
              });
            } else {
              var zone = zones.filter(function (item) {
                return item.Title == element;
              });
              flightZones.push(zone[0]);
            }
          });
        }
        return flightZones;
      };
      /**
       * Open modal to see information for the selected message
       * @memberof FlightInfoCtrl
       * @param {object} message A message object
       */
      var openMessage = function openMessage(_message) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Dialogs/dlgMessage.html',
          controller: 'MessageModalCtrl',
          size: 'lg',
          keyboard: false,
          backdrop: "static",
          resolve: {
            message: function message() {
              return _message;
            }
          }
        });
        modalInstance.result.then(function () {
          if (_message.ReadDt == null) {
            MessageFactory.markReaden(_message.Id);
            _message.ReadDt = new Date();
          }
        });
      };
      /**
       * Return the text ccs class accoriding to report status
       * @memberof FlightInfoCtrl
       * @returns {string} cssClass
       */
      var getTextClass = function getTextClass() {
        var classname = "";
        if (flight.LineStatus === 'na') classname = "text-gray";else if (flight.LineStatus === 'pending') classname = "text-blue";else if (flight.LineStatus === 'pendingoverdue') classname = "text-blue";else if (flight.LineStatus === 'draft' || flight.LineStatus === 'draftotheruser') {
          classname = "text-orange";
        } else if (flight.LineStatus === 'completed' || flight.LineStatus === 'completedotheruser') {
          classname = "text-purple";
        } else if (flight.LineStatus === 'stored' || flight.LineStatus === 'storedotheruser' || flight.LineStatus === 'stored+otheruser' || flight.LineStatus === 'synched' || flight.LineStatus === 'synchedotheruser') {
          classname = "text-green";
        }
        return classname;
      };
      /**
       * Return the panel border ccs class accoriding to report status
       * @memberof FlightInfoCtrl
       * @returns {string} cssClass
       */
      var getTopClass = function getTopClass() {
        var classname = "";
        if (flight.LineStatus === 'na') classname = "border-top-gray";else if (flight.LineStatus === 'pending') classname = "border-top-blue";else if (flight.LineStatus === 'pendingoverdue') classname = "border-top-blue";else if (flight.LineStatus === 'draft' || flight.LineStatus === 'draftotheruser') {
          classname = "border-top-orange";
        } else if (flight.LineStatus === 'completed' || flight.LineStatus === 'completedotheruser') {
          classname = "border-top-purple";
        } else if (flight.LineStatus === 'stored' || flight.LineStatus === 'storedotheruser' || flight.LineStatus === 'stored+otheruser' || flight.LineStatus === 'synched' || flight.LineStatus === 'synchedotheruser') {
          classname = "border-top-green";
        }
        return classname;
      };
      /**
       * Return the panel border ccs class accoriding to report status
       * @memberof FlightInfoCtrl
       * @returns {string} cssClass
       */
      var getBottomClass = function getBottomClass() {
        var classname = "";
        if (flight.LineStatus === 'na') classname = "border-bottom-gray";else if (flight.LineStatus === 'pending') classname = "border-bottom-blue";else if (flight.LineStatus === 'pendingoverdue') classname = "border-bottom-blue";else if (flight.LineStatus === 'draft' || flight.LineStatus === 'draftotheruser') {
          classname = "border-bottom-orange";
        } else if (flight.LineStatus === 'completed' || flight.LineStatus === 'completedotheruser') {
          classname = "border-bottom-purple";
        } else if (flight.LineStatus === 'stored' || flight.LineStatus === 'storedotheruser' || flight.LineStatus === 'stored+otheruser' || flight.LineStatus === 'synched' || flight.LineStatus === 'synchedotheruser') {
          classname = "border-bottom-green";
        }
        return classname;
      };
      /**
       * If report from another user exists, show icon
       * @memberof FlightInfoCtrl
       * @returns {boolean} hasIcon
       */
      var hasIcon = function hasIcon() {
        var hasIcon = false;
        if (flight.LineStatus === 'draftotheruser' || flight.LineStatus === 'completedotheruser' || flight.LineStatus === 'storedotheruser' || flight.LineStatus === 'stored+otheruser' || flight.LineStatus === 'synchedotheruser') {
          hasIcon = true;
        }
        return hasIcon;
      };
      /**
       * Returns the crew Chart
       * @memberof FlightInfoCtrl
       * @param {object} flight The flight object
       * @return {object} crewChart
       */
      var generateCrewChart = function generateCrewChart(flight) {
        var cp = 0;
        var fo = 0;
        var sa = 0;
        var fa = 0;
        var dhcCp = 0;
        var dhcFo = 0;
        var dhcSa = 0;
        var dhcFa = 0;
        if (flight.crew) {
          for (var i = 0; i < flight.crew.length; i++) {
            if (flight.crew[i].isDHC) {
              switch (flight.crew[i].position) {
                case "CP":
                  dhcCp++;
                  break;
                case "FO":
                  dhcFo++;
                  break;
                case "SA":
                  dhcSa++;
                  break;
                case "FA":
                  dhcFa++;
                  break;
              }
            } else {
              switch (flight.crew[i].position) {
                case "CP":
                  cp++;
                  break;
                case "FO":
                  fo++;
                  break;
                case "SA":
                  sa++;
                  break;
                case "FA":
                  fa++;
                  break;
              }
            }
          }
        }
        var crewData = {
          labels: ["CP", "FO", "SA", "FA"],
          datasets: [{
            label: "Crew",
            fillColor: "rgba(33,150,243,0.5)",
            strokeColor: "rgba(33,150,243,0.8)",
            highlightFill: "rgba(33,150,243,0.75)",
            highlightStroke: "rgba(33,150,243,1)",
            data: [cp, fo, sa, fa]
          }, {
            label: "DHC",
            fillColor: "rgba(99,181,246,0.5)",
            strokeColor: "rgba(99,181,246,0.8)",
            highlightFill: "rgba(99,181,246,0.75)",
            highlightStroke: "rgba(99,181,246,1)",
            data: [dhcCp, dhcFo, dhcSa, dhcFa]
          }]
        };
        var crewChart = {
          "data": crewData,
          "options": barOptions
        };
        return crewChart;
      };
      /**
       * toggle Panel
       * @memberof FlightInfoCtrl
       * @param {number} panelId
       */
      var togglePanel = function togglePanel(panelId) {
        $('#' + panelId).toggle();
        if (panelId == "info-panel") $scope.isPanelOpen = !$scope.isPanelOpen;
      };
      /**
       * toggle View Mode
       * @memberof FlightInfoCtrl
       * @param {string} elem
       * @param {string} className     
       */
      var toggleViewMode = function toggleViewMode(elem, className) {
        $('body').find('div#' + elem + ' > div').not('.tip').hide("slow");
        $('body').find('div#' + elem + ' div.' + className).not('.tip').show("slow");
      };
      /**
       * Checks if the data are new
       * @memberof FlightInfoCtrl
       * @param {string} time timestamp
       * @return {boolean} IsOld
       */
      var _IsOld = function IsOld(time) {
        _IsOld = false;
        if (time) {
          var now = new Date();
          var timeDate = new Date(time);
          var diff = now.getTime() - timeDate.getTime();
          if (diff > 3600000) {
            _IsOld = true;
          }
        }
        return _IsOld;
      };
      /**
       * Open modal to see information for gates and connections
       * @memberof FlightInfoCtrl
       */
      var openGates = function openGates() {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Dialogs/dlgFlightGates.html',
          controller: 'FlightGateCtrl',
          size: 'lg',
          resolve: {
            flight: function flight() {
              return $scope.flight;
            }
          }
        });
        modalInstance.result.then(function (selectedItem) {
          $scope.gates = selectedItem;
        });
      };
      /**
       * Calculates if a connecting flight is departs sort time after fligths arrival 
       * @memberof FlightInfoCtrl
       * @param {string} connection Connection STD
       * @return {string} cssClass
       */
      var isConnectedFlightClose = function isConnectedFlightClose(connection) {
        if (!connection) {
          return '';
        }
        var connFlightDate = new Date(connection.STD).getTime();
        if ($scope.flightETA > connFlightDate) return '';
        if (connFlightDate - $scope.flightETA <= connection.MCT * 60000) {
          return 'bg-bisque';
        }
        if (connFlightDate - $scope.flightETA <= connection.MCT * 1.2 * 60000) {
          return 'bg-cornsilk';
        }
        return '';
      };
      /**
       * Calculates if a connecting flight is departs sort time after fligths arrival 
       * @memberof FlightInfoCtrl
       * @param {string} connection Connection STD
       * @return {string} cssClass
       */
      var TimeDifference = function TimeDifference(time) {
        var timeString = '';
        var sign = '';
        var dayString = null;
        if (time) {
          var connFlightDate = new Date(time);
          var ms = connFlightDate.getTime() - $scope.flightETA; // this is a time in milliseconds
          if (ms < 0) {
            ms = -ms;
            sign = "-";
          }
          var days = Math.floor(ms / (24 * 60 * 60 * 1000));
          days = days < 0 ? days + 1 : days;
          var daysms = ms % (24 * 60 * 60 * 1000);
          var hours = Math.floor(daysms / (60 * 60 * 1000));
          var hoursms = ms % (60 * 60 * 1000);
          var minutes = Math.floor(hoursms / (60 * 1000));
          timeString = '<strong>' + sign + (hours > 0 ? ("0" + hours).substr(-2) + ":" : '') + ("0" + minutes).substr(-2) + '\'' + '<strong>';
          dayString = ' <span class="badge">' + days + 'd</span>';
        }
        return timeString + (days && days != 0 ? dayString : '');
      };
      /**
       * Open Flight config modal
       * @memberof FlightInfoCtrl
       */
      var openFlightConfig = function openFlightConfig() {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Dialogs/dlgFlightConfig.html',
          controller: 'FlightConfigCtrl',
          size: 'md',
          resolve: {
            flight: function flight() {
              return $scope.flight;
            }
          }
        });
        modalInstance.result.then(function (selectedItem) {
          $scope.flightETA = new Date(selectedItem.ETA).getTime();
          $scope.flight = selectedItem;
        });
      };
      /**
       * Open Flight config modal
       * @memberof FlightInfoCtrl
       */
      var generateDistinctGates = function generateDistinctGates(gates, FlightsFilters) {
        var distinct_gates = [];
        for (var i = 0; i < gates.length; i++) {
          for (var j = 0; j < FlightsFilters.length; j++) {
            var row = gates[i].FlightNo + "," + gates[i].Codeshares.toString();
            if (row.indexOf(FlightsFilters[j].toString()) >= 0) {
              var distinct_gate = {
                FlightNo: gates[i].FlightNo,
                Gate: gates[i].DepGate,
                Arr: gates[i].Arrival,
                STD_lcl: gates[i].STD_lcl,
                STD: gates[i].STD,
                pax: null,
                Codeshares: gates[i].Codeshares
              };
              distinct_gates.push(distinct_gate);
              break;
            }
          }
        }
        return distinct_gates;
      };
      var applyPhoneNumber = function applyPhoneNumber() {
        var crewPhoneNumbers = CrewCallFactory.getFlightCrewCallsFromStorage(flightId);
        flight.crew.forEach(function (user) {
          var phoneNumberInfo = crewPhoneNumbers.find(function (x) {
            return x.CrewId == user.id;
          });
          if (phoneNumberInfo) {
            user.PhoneNumber = phoneNumberInfo.PhoneNumber;
          } else {
            user.PhoneNumber = null;
          }
        });
      };
      var applyPreviousDuty = function applyPreviousDuty() {
        var previousDuties = PreviousDutyFactory.getFlightPreviousDutiesFromStorage(flightId);
        var dutyDate = moment(flight.ScheduledDeparture).startOf('day');
        flight.crew.forEach(function (user) {
          var previousDutyInfo = previousDuties.find(function (x) {
            return x.CrewId == user.id;
          });
          if (previousDutyInfo) {
            user.PreviousDuty = previousDutyInfo.PreviousDuty;
          } else {
            user.PreviousDuty = null;
          }
          if (user.PreviousDuty && user.PreviousDuty.isFlight) {
            var arrivalDate = user.PreviousDuty.ATA;
            if (!arrivalDate) arrivalDate = user.PreviousDuty.ETA;
            if (!arrivalDate) arrivalDate = user.PreviousDuty.STA;
            user.PreviousDuty.showArrivalDate = !moment(arrivalDate).startOf('day').isSame(dutyDate);
            var departureDate = user.PreviousDuty.ATA;
            if (!departureDate) departureDate = user.PreviousDuty.ETA;
            if (!departureDate) departureDate = user.PreviousDuty.STA;
            user.PreviousDuty.showDepartureDate = !moment(departureDate).startOf('day').isSame(dutyDate);
          }
          if (user.PreviousDuty && !user.PreviousDuty.isFlight) {
            user.PreviousDuty.showDate = !moment(user.PreviousDuty.GroundDutyDate).startOf('day').isSame(dutyDate);
          }
        });
      };
      var applyCrewCheckInStatus = function applyCrewCheckInStatus() {
        var crewCheckInStatuses = FlightCheckInsFactory.getFlightCrewCheckInFromStorage(flightId);
        flight.crew.forEach(function (user) {
          var statuses = crewCheckInStatuses.find(function (x) {
            return x.CrewId == user.id;
          });
          if (statuses) {
            user.CheckIn = statuses.CheckIn;
            user.WillBeThereAt = statuses.WillBeThereAt;
          } else {
            user.CheckIn = null;
            user.WillBeThereAt = null;
          }
        });
      };
      /**
       * Returns the ETD for the flight
       * @memberof FlightInfoCtrl
       * @param {object} connFlight The connection flight object
       * @return {string} ETD string
       */
      var getDisplayETD = function getDisplayETD(connFlight) {
        // Default prefix 
        var prefix = "S";
        var timeToShow = connFlight.STD;

        // If ATD is available, use this
        if (connFlight.ATD) {
          prefix = "A";
          timeToShow = connFlight.ATD;
        }
        // If ETD is available, use that
        else if (connFlight.ETD) {
          prefix = "E";
          timeToShow = connFlight.ETD;
        }
        var timeString = moment(timeToShow).format("HH:mm");
        var delay = "";

        // Calculate delay only if ATD or ETD is available
        var actualTime = connFlight.ATD || connFlight.ETD;
        if (actualTime && connFlight.STD) {
          var actualTime = new Date(actualTime).getTime();
          var std = new Date(connFlight.STD).getTime();
          var diff = actualTime - std;

          // Only show delay if it's not zero
          var diffMinutes = Math.floor(diff / 60000);
          if (diffMinutes !== 0) {
            var sign = diffMinutes > 0 ? "+" : "";
            delay = "(" + sign + diffMinutes + ")";
          }
        }
        return {
          prefix: prefix,
          time: timeString,
          delay: delay
        };
      };
      // (1312896)flightId

      applyPhoneNumber();
      applyPreviousDuty();
      applyCrewCheckInStatus();
      $scope.flightCrewPreviousDuty = flight.crew.filter(function (x) {
        return x.PreviousDuty && x.PreviousDuty.isDifferent && (x.position == "CP" || x.position == "FO") && !x.isDHC;
      }).length;
      $scope.cabinCrewPreviousDuty = flight.crew.filter(function (x) {
        return x.PreviousDuty && x.PreviousDuty.isDifferent && (x.position == "SA" || x.position == "FA") && !x.isDHC;
      }).length;
      $scope.dhcCrewPreviousDuty = flight.crew.filter(function (x) {
        return x.PreviousDuty && x.PreviousDuty.isDifferent && x.isDHC;
      }).length;
      $scope.hasPreviousDuties = $scope.flightCrewPreviousDuty + $scope.cabinCrewPreviousDuty + $scope.dhcCrewPreviousDuty;

      //Update scopes for the CrewRoutePanel in Flight-page
      $scope.crewRouteInfoPanel = CrewRouteFactory.getCrewRouteInfoPanel(flight);
      var paxInfo = PaxInfoFactory.getPaxInfoFromStorage(flightId);
      var aircaftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId(flight.FlightId);
      $scope.dayOfFlight = new Date(flight.FlightDate).getDate();
      $scope.showCatIIApprachSection = showCatIIApprachAcTypes.includes(flight.AcType);
      $scope.showGroundInfoSection = showGroundInfoAcTypes.includes(flight.AcType);
      $scope.aimsCrewMemos = AimsCrewMemosFactory.getAimsCrewMemosByDate(flight.FlightDate);

      //Initialized scope variables
      $scope.state = 'flight';
      $scope.isEnabled = false;
      $scope.flight = flight;
      $scope.aircaftPositions = aircaftPositions;
      $scope.isPanelOpen = true;
      $scope.IsProvisional = true;
      $scope.paxInfo = paxInfo;
      $scope.showConnFlights = true;
      $scope.flightZones = RenderFlightZones(flight.Zones);
      var flightArrivalTime = new Date(flight.ScheduledArrival).getTime();

      //Initialize Messages
      $scope.messages = MessageFactory.getMessagesFromIds(flight.messages);
      var messages = $scope.messages;
      $scope.openMessage = openMessage;

      //Initialize CSS classes
      $scope.getTextClass = getTextClass();
      $scope.getTopClass = getTopClass();
      $scope.getBottomClass = getBottomClass();
      $scope.hasIcon = hasIcon();

      //Charts
      $scope.crewChart = generateCrewChart(flight);
      if (paxInfo) {
        $scope.cStat = paxInfo.PaxTotalC / paxInfo.ConfigurationC * 100;
        $scope.yStat = paxInfo.PaxTotalY / paxInfo.ConfigurationY * 100;
        var listSentTimestamp = new Date(paxInfo.LastRun).getTime();
        var DepartureTimestamp = new Date(flight.ScheduledDeparture).getTime();
        //20 minutes before takeoff
        if (DepartureTimestamp - listSentTimestamp <= 1200000) {
          $scope.IsProvisional = false;
        }
      }
      $scope.isConnectedFlightClose = isConnectedFlightClose;
      $scope.flightETA = $scope.flight.ETA ? moment(flight.ETA).valueOf() : flightArrivalTime;
      $scope.TimeDifference = TimeDifference;
      $scope.openFlightConfig = openFlightConfig;
      $scope.togglePanel = togglePanel;
      $scope.toggleViewMode = toggleViewMode;
      $scope.IsOld = _IsOld;
      $scope.openGates = openGates;
      $scope.getDisplayETD = getDisplayETD;
      $scope.staffTravellers = [];
      if (paxInfo) {
        $scope.staffTravellers = paxInfo.StaffPassengers;
      }

      // Show panel if there's at least one
      $scope.hasStaffTravellers = function () {
        return $scope.staffTravellers.length > 0;
      };

      // Dummy toggle function (optional)
      $scope.togglePanel = function (panelId) {
        $('#' + panelId).collapse('toggle');
      };
      $scope.getGroupedStaff = function (type) {
        return $scope.staffTravellers.filter(function (p) {
          return p.StaffTravellerType === type;
        }).sort(function (a, b) {
          return a.Fullname.localeCompare(b.Fullname);
        });
      };
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('groundInfo', groundInfo);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name groundInfo
  * @restrict EA
  * @description
  *   Implementation of groundInfo
  *
  *   Initialize the ground information (Contacts,Hotels)
  * @attr {String} station The name of the station to get the ground information.
  * @example
  *   Usage:
  *   <div groundInfo stations="ATH,LHR"></div>
  * @ngInject
  */
  function groundInfo(AirportContactFactory, AirportHotelFactory) {
    /**
     * Calculates distinct HotelTypes (used for filtering results)
     * @memberof AirportHotelCtrl
     * @param {array} All the airport Hotels (object which containts Hotels property)
     * @return {array} The distinct HotelTypes as an array of strings
    */
    function findDistinctHotelTypes(items) {
      var unique = {};
      var distinct = [];
      for (var i in items) {
        if (items[i].Name && typeof unique[items[i].Name] == "undefined") {
          distinct.push(items[i].Name);
        }
        unique[items[i].Name] = 0;
      }
      return distinct;
    }

    /**
      * Used to properly display some Hotel Types, eg nulls
      * @memberof AirportHotelCtrl
      * @param {string} The Hotel type to examine and "fix"
      * @return {string} The "fixed" string for the given Hotel type (maybe the same as the input value if no fix is needed)
      */
    function printHotelType(HotelType) {
      if (!HotelType || HotelType == '') {
        console.log(HotelType);
        HotelType = '-no Hotel type-';
      }
      return HotelType;
    }

    /**
    * Calculates distinct ContactTypes (used for filtering results)
    * @memberof AirportContactCtrl
    * @param {array} All the airport contacts (object which containts Contacts property)
    * @return {array} The distinct ContactTypes as an array of strings
    */
    function findDistinctContactTypes(items) {
      var unique = {};
      var distinct = [];
      for (var i in items) {
        if (items[i].ContactType && typeof unique[items[i].ContactType] == "undefined") {
          distinct.push(items[i].ContactType);
        }
        unique[items[i].ContactType] = 0;
      }
      return distinct;
    }

    /**
     * Used to properly display some Contact Types, eg nulls
     * @memberof AirportContactCtrl
     * @param {string} The contact type to examine and "fix"
     * @return {string} The "fixed" string for the given contact type (maybe the same as the input value if no fix is needed)
     */
    function printContactType(contactType) {
      if (!contactType || contactType == '') return '-no contact type-';
      return contactType;
    }
    return {
      restrict: 'EA',
      terminal: true,
      templateUrl: 'views/directives/groundInfo.tpl.html',
      scope: true,
      link: function link($scope, element, attrs) {
        var stations = attrs.stations ? attrs.stations.split(",") : [];
        $scope.stationsInfo = [];
        $scope.filterHotelType = '';
        $scope.filterContactType = '';

        //scope methods
        $scope.printHotelType = printHotelType;
        $scope.printContactType = printContactType;
        $scope.showInfo = showInfo;
        angular.forEach(stations, function (station) {
          var stationInfo = {};
          var flightDate = $scope.flight && $scope.flight.FlightDate ? $scope.flight.FlightDate : null;
          var contactInfo = AirportContactFactory.getAirportContacts(station);
          stationInfo.Contacts = contactInfo ? contactInfo.Contacts : [];
          stationInfo.ContactTypes = findDistinctContactTypes(stationInfo.Contacts);
          var hotelInfo = AirportHotelFactory.getAirportHotels(station, flightDate);
          stationInfo.Hotels = hotelInfo ? hotelInfo.Hotels : [];
          stationInfo.HotelTypes = findDistinctHotelTypes(stationInfo.Hotels);
          stationInfo.ActiveHotels = false;
          stationInfo.ActiveContacts = false;
          stationInfo.ActiveGeneralInfo = false;
          stationInfo.Name = station;
          if (stationInfo.Hotels.length > 0 || stationInfo.Contacts.length > 0) {
            $scope.stationsInfo.push(stationInfo);
          }
        });
        var oldViewStation = '';
        var oldViewType = '';
        function showInfo(station, type) {
          angular.forEach($scope.stationsInfo, function (stationInfo) {
            if (stationInfo.Name == station.Name) {
              if (type == 'Hotels') {
                stationInfo.ActiveHotels = !stationInfo.ActiveHotels;
                stationInfo.ActiveContacts = false;
                stationInfo.ActiveGeneralInfo = false;
              } else if (type == 'Contacts') {
                stationInfo.ActiveContacts = !stationInfo.ActiveContacts;
                stationInfo.ActiveHotels = false;
                stationInfo.ActiveGeneralInfo = false;
              } else if (type == 'General') {
                stationInfo.ActiveGeneralInfo = !stationInfo.ActiveGeneralInfo;
                stationInfo.ActiveHotels = false;
                stationInfo.ActiveContacts = false;
              }
            } else {
              stationInfo.ActiveHotels = false;
              stationInfo.ActiveContacts = false;
              stationInfo.ActiveGeneralInfo = false;
            }
          });
        }
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('GroundServicesFactory', GroundServicesFactory);
  /**
   * @memberOf PilotReports
   * @ngdoc factory
   * @name GroundServicesFactory
   * @description
   * Get Ground Services
   * @gnInject
   */

  function GroundServicesFactory(GenericService) {
    /**
    * Initialize the GroundServices
    * @memberof GroundServicesFactory
    */
    function GroundService() {
      this.Station = null;
    }
    var objType = 'groundServices';
    var objCallBack = GroundService;
    var service = {
      fromObjectList: fromObjectList,
      getGroundServicesFromStorage: getGroundServicesFromStorage,
      setGroundServicesToStorage: setGroundServicesToStorage,
      clearGroundServicesFromStorage: clearGroundServicesFromStorage,
      getGroundServicesByStation: getGroundServicesByStation,
      upsertGroundServices: upsertGroundServices
    };

    /**
     * Extend an array of Objects from the default GroundService Object
     * @memberof GroundServicesFactory
     * @param {Array} objList  an Array Of ground Services
     * @returns {Array} groundServices
     */
    function fromObjectList(objList) {
      return GenericService.fromObjectList(objList, objCallBack);
    }

    /**
    * Get ground services from local storage
    * @memberof GroundServicesFactory
    * @returns {Array} groundServices 
    */
    function getGroundServicesFromStorage() {
      return GenericService.list(objType, objCallBack);
    }

    /**
     * Save ground services to storage
     * @memberof GroundServicesFactory
     * @param {Array} List of ground services
     */
    function setGroundServicesToStorage(groundServices) {
      if (groundServices) {
        for (var i = 0; i < groundServices.length; i++) {
          for (var j = 0; j < groundServices[i].Services.length; j++) {
            // isDefault could be null
            if (groundServices[i].Services[j].IsDefault) groundServices[i].Services[j].Used = 1;else groundServices[i].Services[j].Used = 0;
          }
        }
        GenericService.saveAll(groundServices, objType, objCallBack);
      }
    }

    /**
     * Remove the ground services from the local storage
     * @memberof GroundServicesFactory
     */
    function clearGroundServicesFromStorage() {
      GenericService.removeAll(objType, objCallBack);
    }

    /**
     * Get Ground Services of a current station from the local storage
     * @memberof GroundServicesFactory
     * @param {number} station 
     * @return {object} GroundServices 
     */
    function getGroundServicesByStation(station) {
      var objects = getGroundServicesFromStorage();
      if (objects == null) return [];
      var results = [];
      var arrayLength = objects.length;
      for (var i = 0; i < arrayLength; i++) {
        if (objects[i].Station == station) {
          results = objects[i].Services;
        }
      }
      return results;
    }

    /**
    * Upsert ground services
    * @memberof GroundServicesFactory
    */
    function upsertGroundServices(groundServices) {
      var newStations = groundServices.map(function (x) {
        return x.Station;
      });
      var servicesLS = this.getGroundServicesFromStorage();
      servicesLS = servicesLS.filter(function (x) {
        return !newStations.includes(x.Station);
      });
      var updatedServicesList = servicesLS.concat(groundServices);
      setGroundServicesToStorage(updatedServicesList);
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.filter('paxNames', paxNames);
  /**
  * @memberof PilotReports
  * @ngdoc filter
  * @name paxNames
  * @description 
  *  List pax names in list and return $sce html 
  * @ngInject
  */
  function paxNames($sce) {
    return function (input) {
      var html = '"<div class=\'row\'><div class=\'col-sm-offset-6 col-sm-2\'><strong>C</strong></div><div class=\' col-sm-1\'><strong>Y</strong></div> </div>';
      html = html + "<div class=\'row\'> <strong class=\'col-xs-6\'> Passengers </strong>";
      html = html + '<div class=\'col-xs-2\'>' + input.PassengerSummaryC.Passengers + "</div>";
      html = html + '<div class=\'col-xs-1\'>' + input.PassengerSummaryY.Passengers + '</div></div>';
      html = html + "<div class=\'row\'> <strong class=\'col-xs-6\'> PRM </strong>";
      html = html + '<div class=\'col-xs-2\'>' + input.PassengerSummaryC.PRM + "</div>";
      html = html + '<div class=\'col-xs-1\'>' + input.PassengerSummaryY.PRM + '</div></div>';
      html = html + "<div class=\'row\'> <strong class=\'col-xs-6\'> UMNR </strong>";
      html = html + '<div class=\'col-xs-2\'>' + input.PassengerSummaryC.UMNR + "</div>";
      html = html + '<div class=\'col-xs-1\'>' + input.PassengerSummaryY.UMNR + '</div></div>';
      html = html + "<div class=\'row\'> <strong class=\'col-xs-6\'> DEP </strong>";
      html = html + '<div class=\'col-xs-2\'>' + input.PassengerSummaryC.DEP + "</div>";
      html = html + '<div class=\'col-xs-1\'>' + input.PassengerSummaryY.DEP + '</div></div>\"';
      return $sce.trustAsHtml(html);
    };
  }
  ;
})();
"use strict";

(function () {
  a3_pilot_reports.directive('reportsPanel', reportsPanel);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name reportsPanel
  * @restrict E
  * @description
  *   Implementation of reportsPanel
  *   Initialize the panels with reports.
  * @example
  *   Usage:
  *   <reports-panel flight-id="id"></reports-panel>
  * @ngInject
  */
  function reportsPanel($location, defaultCalendarDate) {
    function link($scope, element, attrs) {
      $scope.togglePanel = togglePanel;
      var flight = $scope.flight;
      $scope.showSafetyReport = showSafetyReport();
      //Initialize CSS classes
      $scope.getTextClass = getTextClass();
      $scope.getTopClass = getTopClass();
      $scope.getBottomClass = getBottomClass();
      $scope.hasIcon = hasIcon();
      $scope.openCabinReport = openCabinReport;

      /**
       * toggle Panel
       * @memberof FlightInfoCtrl
       * @param {number} panelId
       */
      function togglePanel(panelId) {
        $('#' + panelId).toggle();
      }
      function showSafetyReport() {
        var today = new Date().toUTC();
        if (defaultCalendarDate) {
          today = new Date(defaultCalendarDate).toUTC();
        }
        var flightDate = new Date(flight.FlightDate);
        var trimmedToday = new Date(today);
        var trimmedFlightDate = new Date(flightDate);
        var diffDays = Date.DifferenceInDays(trimmedToday.trimTime(), trimmedFlightDate.trimTime());
        return diffDays <= 0;
      }

      /**
       * Return the text ccs class accoriding to report status
       * @memberof FlightInfoCtrl
       * @returns {string} cssClass
       */
      function getTextClass() {
        var classname = "";
        if (flight.LineStatus === 'na') classname = "text-gray";else if (flight.LineStatus === 'pending') classname = "text-blue";else if (flight.LineStatus === 'pendingoverdue') classname = "text-blue";else if (flight.LineStatus === 'draft' || flight.LineStatus === 'draftotheruser') {
          classname = "text-orange";
        } else if (flight.LineStatus === 'completed' || flight.LineStatus === 'completedotheruser') {
          classname = "text-purple";
        } else if (flight.LineStatus === 'stored' || flight.LineStatus === 'storedotheruser' || flight.LineStatus === 'stored+otheruser' || flight.LineStatus === 'synched' || flight.LineStatus === 'synchedotheruser') {
          classname = "text-green";
        }
        return classname;
      }

      /**
       * Return the panel upper ccs class accoriding to report status
       * @memberof FlightInfoCtrl
       * @returns {string} cssClass
       */
      function getTopClass() {
        var classname = "";
        if (flight.LineStatus === 'na') classname = "border-top-gray";else if (flight.LineStatus === 'pending') classname = "border-top-blue";else if (flight.LineStatus === 'pendingoverdue') classname = "border-top-blue";else if (flight.LineStatus === 'draft' || flight.LineStatus === 'draftotheruser') {
          classname = "border-top-orange";
        } else if (flight.LineStatus === 'completed' || flight.LineStatus === 'completedotheruser') {
          classname = "border-top-purple";
        } else if (flight.LineStatus === 'stored' || flight.LineStatus === 'storedotheruser' || flight.LineStatus === 'stored+otheruser' || flight.LineStatus === 'synched' || flight.LineStatus === 'synchedotheruser') {
          classname = "border-top-green";
        }
        return classname;
      }

      /**
       * Return the panel border ccs class accoriding to report status
       * @memberof FlightInfoCtrl
       * @returns {string} cssClass
       */
      function getBottomClass() {
        var classname = "";
        if (flight.LineStatus === 'na') classname = "border-bottom-gray";else if (flight.LineStatus === 'pending') classname = "border-bottom-blue";else if (flight.LineStatus === 'pendingoverdue') classname = "border-bottom-blue";else if (flight.LineStatus === 'draft' || flight.LineStatus === 'draftotheruser') {
          classname = "border-bottom-orange";
        } else if (flight.LineStatus === 'completed' || flight.LineStatus === 'completedotheruser') {
          classname = "border-bottom-purple";
        } else if (flight.LineStatus === 'stored' || flight.LineStatus === 'storedotheruser' || flight.LineStatus === 'stored+otheruser' || flight.LineStatus === 'synched' || flight.LineStatus === 'synchedotheruser') {
          classname = "border-bottom-green";
        }
        return classname;
      }

      /**
       * If report from another user exists, show icon
       * @memberof FlightInfoCtrl
       * @returns {boolean} hasIcon
       */
      function hasIcon() {
        var hasIcon = false;
        if (flight.LineStatus === 'draftotheruser' || flight.LineStatus === 'completedotheruser' || flight.LineStatus === 'storedotheruser' || flight.LineStatus === 'stored+otheruser' || flight.LineStatus === 'synchedotheruser') {
          hasIcon = true;
        }
        return hasIcon;
      }

      /**
      * Redirects to cabin report page
      * @memberof FlightInfoCtrl
      * @returns {boolean} hasIcon
      */
      function openCabinReport() {
        $location.path("reportsHistory/" + flight.CabinReportId + "/" + flight.FlightId + "/Cabin");
      }
    }
    return {
      restrict: 'E',
      templateUrl: "views/directives/reportsPanel.tpl.html",
      scope: false,
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('ssr', ssr);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name ssr
  * @restrict EA
  * @description
  *   Implementation of issues
  *
  *   Initialize the special service template
  * @attr {String} format The name of the format to initialize the ssr.
  * @example
  *   Usage:
  *   <div ssr format="compact"></div>
  * @ngInject
  */
  function ssr($sce, ssrCodes, showRecomendedWaterAcTypes) {
    return {
      restrict: 'EA',
      terminal: true,
      templateUrl: 'views/directives/ssr.tpl.html',
      scope: {
        paxInfo: '=',
        flight: '='
      },
      link: function link($scope, element, attrs) {
        $scope.format = attrs.format;
        $scope.FQTVGold = detailedInfo('FQTVGold');
        $scope.FQTVSilver = detailedInfo('FQTVSilver');
        $scope.UMNR = detailedInfo('UMNR');
        $scope.PRM = detailedInfo('WCBD,WCBW,WCHC,WCHR,WCHS,WCLB,WCMP,WCOB');
        $scope.DEAF = detailedInfo('DEAF');
        $scope.BLND = detailedInfo('BLND');
        $scope.DPNA = detailedInfo('DPNA');
        $scope.DEP = detailedInfo('DEPA,DEPU,ESCD');
        $scope.INAD = detailedInfo('INAD');
        $scope.MEDA = detailedInfo('AOXY,MEDA,MEQT,POXY');
        $scope.CBBG = detailedInfo('CBBG');
        $scope.OTH = detailedInfo('AVIH,BIKE,EMIG,ESAN,EXST,FAMS,GPST,HAJJ,PETC,SVAN,WEAP,XBGS,MAAS');
        $scope.VIP = detailedInfo('VIP');
        $scope.showFQTVGold = false;
        $scope.showFQTVSilver = false;
        $scope.showUMNR = false;
        $scope.showPRM = false;
        $scope.showDEAF = false;
        $scope.showBLND = false;
        $scope.showDPNA = false;
        $scope.showDEP = false;
        $scope.showINAD = false;
        $scope.showMEDA = false;
        $scope.showCBBG = false;
        $scope.showOTH = false;
        $scope.showVIP = false;
        $scope.waterQuantity = getWaterQuantity();
        $scope.showRecomendedWater = showRecomendedWater();
        function showRecomendedWater() {
          return showRecomendedWaterAcTypes.includes($scope.flight.AcType);
        }
        function getWaterQuantity() {
          var totalPax = $scope.flight.BookedC + $scope.flight.BookedY;
          var startDate = moment($scope.flight.ScheduledDeparture);
          var endDate = moment($scope.flight.ScheduledArrival);
          var duration = moment.duration(endDate.diff(startDate)).asHours();
          var waterQuantity = (0, 18 * totalPax * duration) / 200;
          var formattedwaterQuantity = waterQuantity.toString().substring(0, 4);
          return formattedwaterQuantity;
        }
        function detailedInfo(properties) {
          var propertiesArray = properties.split(',');
          var htmlPopover = '';
          if ($scope.paxInfo && $scope.paxInfo.PassengerSummaryC && $scope.paxInfo.PassengerSummaryY) {
            if (propertiesArray.length > 1) {
              htmlPopover = '<div class="row"><div class="col-sm-offset-9  col-xs-offset-8 col-xs-1"><strong>C</strong></div><div class=" col-xs-1"><strong>Y</strong></div><div class=" col-xs-1"><strong>Total</strong></div> </div>';
              angular.forEach(propertiesArray, function (property) {
                var Total = $scope.paxInfo.PassengerSummaryC['Total' + property] + $scope.paxInfo.PassengerSummaryY['Total' + property];
                if (Total > 0) {
                  var code = '';
                  for (var i = 0; i < ssrCodes.length; i++) {
                    if (ssrCodes[i].code == property) {
                      code = ssrCodes[i].description;
                    }
                  }
                  htmlPopover = htmlPopover + '<div class="row"> <strong class="col-xs-2">' + property + "</strong>";
                  htmlPopover = htmlPopover + '<span class="col-sm-7 col-xs-6 text-medium">' + code + "</span>";
                  htmlPopover = htmlPopover + '<div class="col-xs-1">' + $scope.paxInfo.PassengerSummaryC[property] + "</div>";
                  htmlPopover = htmlPopover + '<div class="col-xs-1">' + $scope.paxInfo.PassengerSummaryY[property] + "</div>";
                  htmlPopover = htmlPopover + '<div class="col-xs-1">' + Total + "</div></div>";
                }
              });
            } else {
              angular.forEach(propertiesArray, function (property) {
                var Total = $scope.paxInfo.PassengerSummaryC['Total' + property] + $scope.paxInfo.PassengerSummaryY['Total' + property];
                htmlPopover = '<div class="row"> <strong class="col-xs-3 col-md-2 col-xs-offset-1 col-md-offset-4">C ' + $scope.paxInfo.PassengerSummaryC[property] + '</strong>';
                htmlPopover = htmlPopover + ' <strong class="col-xs-3 col-md-2">Y ' + $scope.paxInfo.PassengerSummaryY[property] + '</strong>';
                if (Total) {
                  htmlPopover = htmlPopover + ' <strong class="col-xs-4 col-md-3"> Total ' + Total + '</strong>';
                }
                htmlPopover = htmlPopover + '</div>';
              });
            }
          }
          return $sce.trustAsHtml(htmlPopover);
        }
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('SyncPaxCtrl', SyncPaxCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name SyncPaxCtrl
  * @description 
  *   Get the latest  PAX and gate Information
  * @ngInject
  */
  function SyncPaxCtrl($scope, InfoAPIService, $uibModalInstance, $route, $timeout, flightId, LogService, FlightFactory, FlightSessionFactory, CourseFactory, CrewCallFactory, PreviousDutyFactory) {
    var flight = FlightFactory.getFlightFromTotalFlights(flightId);
    $scope.hideElements = true;
    $scope.showOnSuccess = false;
    $scope.showOnEmptyData = false;
    $scope.showOnSuccessNoFlightData = false;
    $scope.showOnOutOfDateRange = false;
    $scope.cancel = cancel;
    $scope.flightId = flightId;
    var isThisFlightSynced = false;
    $scope.isFetchingFlightData = false;
    $scope.flightDataStatus = [{
      datatype: "Flight Status",
      status: "PENDING",
      text: "Pending..."
    }, {
      datatype: "Aircraft Movement",
      status: "PENDING",
      text: "Pending..."
    }, {
      datatype: "Crew Info",
      status: "PENDING",
      text: "Pending..."
    }, {
      datatype: "Crew Contacts",
      status: "PENDING",
      text: "Pending..."
    },
    // {
    // 	datatype: "Aims Crew Memos",
    // 	status: "PENDING",
    // 	text: "Pending..."
    // },
    {
      datatype: "Pax Info",
      status: "PENDING",
      text: "Pending..."
    }, {
      datatype: "Meals",
      status: "PENDING",
      text: "Pending..."
    }, {
      datatype: "Connections",
      status: "PENDING",
      text: "Pending..."
    }, {
      datatype: "Training Info",
      status: "PENDING",
      text: "Pending..."
    }];

    /**
     * Close the modal
     * @memberof SyncPaxCtrl
     */
    function cancel() {
      $uibModalInstance.close('close');
      $route.reload();
    }
    ;
    var q = InfoAPIService.getPax(flightId);
    $scope.isFetchingFlightData = true;
    q.then(function (responseData) {
      updateStatusGenerator(responseData);
      $scope.isFetchingFlightData = !$scope.isFetchingFlightData;
      if (responseData == undefined || responseData.data == undefined || responseData.data.data == undefined) {
        var err = new Error();
        err.status = -1;
        var msg = "ResponseData error in sync :" + JSON.stringify(responseData);
        LogService.debug(msg, err);
        q.reject(err);
      }

      //Save training
      var trainingCourses = responseData.data.data.TrainingCourses;
      if (trainingCourses && trainingCourses.length) {
        trainingCourses.forEach(function (trainingCourse) {
          CourseFactory.upsertCourse(trainingCourse, function (course) {
            FlightSessionFactory.applyTraineeInfoToSession(course, course.Id, new moment(flight.DutyDate).format("YYYY-MM-DD"), flight.DutyNo, flight.DutyDay, function (session) {});
          });
        });
      }

      //1. First remove all additional info (phone numbers & previous duties) for this flight
      CrewCallFactory.cleanFlightCrewNumbers(flightId);
      PreviousDutyFactory.cleanFlightPreviousDuties(flightId);

      //2. Then save any fetched info
      if (responseData.data.data.FlightInfo) {
        var crew = responseData.data.data.FlightInfo.crew;
        CrewCallFactory.saveFlightPhoneNumbers(flightId, crew, flight.ScheduledArrival, flight.ScheduledDeparture);
        PreviousDutyFactory.saveFlightPreviousDuties(flightId, crew);
      }

      //Save pax
      if (responseData.data.data.CabinServiceManagementLists) {
        for (var i = 0; i < responseData.data.data.CabinServiceManagementLists.length; i++) {
          if (responseData.data.data.CabinServiceManagementLists[i].FlightId == flightId) {
            //check for out of date range pax info
            var today = new Date().getTime();
            var paxDate = new Date(responseData.data.data.CabinServiceManagementLists[i].LastRun).getTime();
            if (paxDate <= today - 172800000) {
              $scope.showOnOutOfDateRange = true;
              break;
            }
            $scope.pax = responseData.data.data.CabinServiceManagementLists[i];
            $scope.showOnSuccess = true;
            isThisFlightSynced = true;
            break;
          }
        }
        if (!$scope.showOnSuccess) {
          $scope.showOnSuccessNoFlightData = true;
        }

        // $timeout(function() {
        // 	$uibModalInstance.close();
        // 	$route.reload();
        // }, 3000);
      } else {
        $scope.showOnEmptyData = true;
      }
    }, function (responseData) {
      updateStatusGenerator(responseData);
      $scope.isFetchingFlightData = !$scope.isFetchingFlightData;
      $scope.hideElements = false;
    });
    function updateStatusGenerator(data) {
      if (!data.data || !data.data.success) {
        for (var i = 0; i < $scope.flightDataStatus.length; i++) {
          $scope.flightDataStatus[i].status = "FAIL";
          $scope.flightDataStatus[i].text = "Update failed";
        }
      } else {
        var newDuty = data.data.data;
        InfoAPIService.updateFlightStatusSetter(newDuty, $scope.flightDataStatus);
      }
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('turnAroundTimes', turnAroundTimes);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name turnAroundTimes
  * @restrict EA
  * @description
  *   Implementation of turnAroundTimes
  *
  *   Initialize the turn Around Times panel needs to have flight in scope
  * @example
  *   Usage:
  *   <div turn-around-times></div>
  * @ngInject
  */
  function turnAroundTimes(AircaftPositionsFactory, turnAroundTimesSupportingAcTypes) {
    /**
     * Initialize turnAroundTimes
     * @memberof turnAroundTimes
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service} attributes attributes of this element
     */
    function link($scope, element, attrs) {
      $scope.showTaTpanel = false;
      var supportsTurnAround = $scope.flight && turnAroundTimesSupportingAcTypes.includes($scope.flight.AcType);
      if ($scope.flight && $scope.flight.FlightId && supportsTurnAround) {
        var aircaftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId($scope.flight.FlightId);
        if (aircaftPositions != null && aircaftPositions.PreviousSTA) {
          var std = moment.utc($scope.flight.ScheduledDeparture);
          var TaTMinutes = $scope.flight.AcType == '321' ? -50 : -45;
          var startofTAT = moment.utc($scope.flight.ScheduledDeparture).add(TaTMinutes, 'm');
          var prevATA = aircaftPositions.PreviousATA ? moment.utc(aircaftPositions.PreviousATA) : null;
          var prevSTA = moment.utc(aircaftPositions.PreviousSTA);
          var lateArrival = 0;
          var inadequateGroundTime = 0;
          if (startofTAT.diff(prevSTA, 'm') >= 0 && aircaftPositions.PreviousATA) {
            var comparedValue = startofTAT;
            if (lateArrival > 0) {
              var comparedValue = prevATA;
            }
            lateArrival = prevATA.diff(comparedValue, 'm');
            $scope.ShowlateArrival = true;
          } else {
            lateArrival = aircaftPositions.PreviousATA ? prevATA.diff(prevSTA, 'm') : 0;
            inadequateGroundTime = prevSTA.diff(startofTAT, 'm');
            if (lateArrival < 0) {
              inadequateGroundTime = inadequateGroundTime + lateArrival;
            }
          }
          $scope.lateArrival = lateArrival < 0 ? 0 : lateArrival;
          $scope.inadequateGroundTime = inadequateGroundTime < 0 ? 0 : inadequateGroundTime;
          $scope.showTaTpanel = true;
        }
      }
    }
    return {
      restrict: 'EA',
      terminal: true,
      templateUrl: 'views/directives/turnAroundTimes.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('AddFlightCtrl', AddFlightCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name AddFlightCtrl
  * @description 
  *   Add a new flight that is not in schedule
  * @ngInject
  */
  function AddFlightCtrl($scope, UserFactory, FlightFactory, AircraftTypeFactory, $uibModalInstance, $route) {
    $scope.isSecure = UserFactory.isSecure();

    // cancel
    $scope.doCancel = doCancel;

    // add flight
    $scope.doAdd = doAdd;

    // setup datetime pickers
    var now = new Date();
    var minSelectableDate = new Date();
    var maxSelectableDate = new Date();
    minSelectableDate.setDate(now.getDate() - 15);
    maxSelectableDate.setDate(now.getDate() + 2);
    $scope.minSelectableDateStr = minSelectableDate.toString('dd-MM-yyyy');
    $scope.maxSelectableDateStr = maxSelectableDate.toString('dd-MM-yyyy');
    $scope.selectedDate = null;
    $scope.selectedTime = null;
    $scope.hstep = 1;
    $scope.mstep = 1;
    $scope.ismeridian = false;
    $scope.dateFormat = 'dd-MM-yyyy';
    $scope.hourFormat = "HH:mm";
    $scope.datepicker = {
      opened: false
    };
    $scope.openDatepicker = openDatepicker;

    // get the values from ui and create a flight
    $scope.createFlightFromUIValues = createFlightFromUIValues;

    // setup aircraft types
    var actypes = AircraftTypeFactory.getAircraftTypesFromStorage();
    if (!(actypes instanceof Array)) actypes = [];
    actypes.push({
      Code: 'other'
    });
    $scope.aircraftTypes = actypes;

    // function to process the form
    $scope.processForm = processForm;

    /**
     * Add the flight to schedule
     * @memberof AddFlightCtrl
     */
    function doAdd() {
      $scope.processForm();
    }

    /**
     * Close the modal
     * @memberof AddFlightCtrl
     */
    function doCancel() {
      $uibModalInstance.close('cancel');
    }

    /**
     * Open Datepicker
     * @memberof AddFlightCtrl
     */
    function openDatepicker() {
      $scope.datepicker.opened = true;
    }
    ;

    /**
     * Get the values from ui and create a flight 
     * @memberof AddFlightCtrl
     */
    function createFlightFromUIValues() {
      // get moment dt from controls
      var flightDate = $scope.formData.flightDateStr;
      var flightSTD = $scope.formData.flightTimeStr;
      // convert them to dates
      flightDate = new Date(flightDate);
      flightSTD = new Date(flightSTD);
      // combine date and time
      flightDate.setHours(flightSTD.getHours(), flightSTD.getMinutes(), 0, 0);
      // flightDate = flightDate.fromUTC();
      // get other flight details
      var flightNumber = $scope.formData.flightNumber;
      var flightDeparture = $scope.formData.flightDeparture;
      var flightDestination = $scope.formData.flightDestination;
      var flightRegNo = $scope.formData.flightRegNo;
      var flightAcType = null;
      if ($scope.formData.flightAcType != null) flightAcType = $scope.formData.flightAcType;

      // try to create a local flight
      var newFlight = FlightFactory.createLocalFlight(flightDate, flightNumber, flightDeparture, flightDestination, flightRegNo, flightAcType);
      return newFlight;
    }

    /**
     * Process and validate the form
     * @memberof AddFlightCtrl
     */
    function processForm() {
      // if all valid
      if ($scope.formFlight.$valid) {
        try {
          // try to create a local flight
          var newFlight = $scope.createFlightFromUIValues();

          // save the local flight
          if (newFlight != null) {
            FlightFactory.saveLocalFlight(newFlight);
          }
          if (newFlight == null) {
            bootbox.alert("<h4>Error</h4>Unable to create a flight record.");
          } else {
            (function () {
              $uibModalInstance.close();
              $route.reload();
            })();
          }
        } catch (e) {
          bootbox.alert("<h4>Error</h4>Unable to create a flight record due to unexpected error:\n" + e.message);
        }
      } else {
        bootbox.alert("Please fill in all the required fields.");
      }
    }

    // initialize form data
    $scope.formData = {};
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('CalendarCtrl', CalendarCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name CalendarCtrl
  * @description 
  *   View your schedule (flights and ground duties)
  * @ngInject
  */
  function CalendarCtrl($scope, version, $location, MemoFactory, FlightFactory, UserFactory, CrewRouteFactory, MessageFactory, UpdateService, SyncLogFactory, $timeout, $uibModal, GroundDutyFactory, SettingsMain, defaultCalendarDate, CrewHotelFactory, TrainingSessionFactory, FlightSessionFactory, ScheduleAcknowledgeFactory, TraineeCoursesDetailsFactory) {
    $scope.pendingOverdueReports = 0;
    $scope.draftReports = 0;
    $scope.completedReports = 0;
    $scope.isSecure = UserFactory.isSecure();
    $scope.state = 'calendar';
    if (version) {
      $scope.version = version.replace('appVersion_', '');
    } else {
      $scope.version = '';
    }

    //scope variables
    var user = UserFactory.getUser();
    $scope.logged_user_info = user.aimsId + ' - ' + user.name;
    $scope.storageUsage = storageUsage;

    //SetupView
    $scope.setupView = setupView;

    //Pages
    $scope.addFlight = addFlight;
    $scope.searchPastGroundDuties = searchPastGroundDuties;

    //Modals
    $scope.openSynch = openSynch;
    $scope.hasUnsetTraining = false;
    var groundSessions = [];
    var flightSessions = [];
    TrainingSessionFactory.getAll(function (savedGroundSessions) {
      FlightSessionFactory.getAll(function (savedFlightSessions) {
        groundSessions = savedGroundSessions;
        flightSessions = savedFlightSessions;
        $scope.setupView(false);
      });
    });

    /**
     * Setups Calendar View
     * @memberof CalendarCtrl
     * @param {boolean} isReload
     */
    function setupView(isReload) {
      if (!UserFactory.isLoggedIn()) {
        $location.path("/login");
      }
      $scope.NeedsToSync = UpdateService.updater();
      /*				
      var reportstobesynched = PilotReportLocalEditFactory.getPilotReportLocalEditThatNeedToBeSynched();
      
      $scope.number_of_reports_to_sync = reportstobesynched.length;
      */
      $scope.number_of_messages = MessageFactory.getMessagesFromStorage().length;
      $scope.number_of_messages_not_readen = MessageFactory.getCountOfUnreadMessages();

      //Get count of unread memos but remove the ones that belong in 'Training Surveys' Category
      MemoFactory.getUnreadMemos(function (memos) {
        var unreadMemosCount = 0;
        //remove memos that belong in "Training Surveys" category
        for (var i = 0; i < memos.length; i++) {
          if (memos[i].Category != "Training Surveys") {
            unreadMemosCount++;
          }
        }
        $scope.unreadMemosCount = unreadMemosCount;
      });

      // read the flights from the local storage and display them
      var flights = FlightFactory.getFlightsFromStorageAndCheckIfTooOld();

      // also load the flights created by the user
      flights = FlightFactory.getLocalFlightsAndMergeWithServerFlights(flights);

      // if no local flights are found then force sync
      if (!isReload) {
        needsToSync = true;
      }
      var crewRoutes = CrewRouteFactory.getCrewRoutesFromStorage();
      var groundDuties = GroundDutyFactory.getGroundDutiesFromStorage();
      var crewRoutesEvents = formatCrewRoutes(crewRoutes);
      var traineeGroundCourses = TraineeCoursesDetailsFactory.getTraineeCourses();
      var groundDutiesEvents = formatGroundDuties(groundDuties, traineeGroundCourses);
      var traineeFlightCourses = TraineeCoursesDetailsFactory.getFlightCourses();
      var flightEvents = formatFlights(flights, traineeFlightCourses);
      var events = flightEvents.concat(groundDutiesEvents).concat(crewRoutesEvents);
      var specialDates = findScheduleChangedDates();

      // //temporary disable for A3
      // var showInCalendar = CrewHotelFactory.showHotelsInCalendar(flights)
      // if(showInCalendar){
      // 	var crewHotels = CrewHotelFactory.getCrewHotelsFromStorage();
      // 	var crewHotelsEvents = formatHotels(crewHotels);
      // 	events = events.concat(crewHotelsEvents);
      // }

      //Enable again!
      var crewHotels = CrewHotelFactory.getCrewHotelsFromStorage();
      var crewHotelsEvents = formatHotels(crewHotels);
      events = events.concat(crewHotelsEvents);
      calendar(events, specialDates);
      var needsToSync = false;

      // check the last sync date
      var lastLog = SyncLogFactory.getSyncLog();
      var canShowSync = true;
      if (lastLog == null) {
        needsToSync = true;
      } else {
        canShowSync = lastLog.canShowSync(); //used to avoid showing again and again the dialog :: delay X minutes before showing again
        if (lastLog.date == null) needsToSync = true;else if (lastLog.date != null) {
          if (Date.today().add(-1).days().toUTC().isAfter(new Date(lastLog.date).toUTC()) || lastLog.forceSync) {
            if (!isReload) needsToSync = true;
          }
        }
      }
      var isOpenUpdateModal = ($(".modal-updating").data('bs.modal') || {
        isShown: false
      }).isShown;
      if (needsToSync && canShowSync && !isOpenUpdateModal) {
        $scope.openSynch();
      } else {
        MemoFactory.getMandatoryUnreadMemos(function (memos) {
          var mandatoryUnread = 0;
          //remove memos that belong in "Training Surveys" category
          for (var i = 0; i < memos.length; i++) {
            if (memos[i].Category != "Training Surveys") {
              mandatoryUnread++;
            }
          }
          $scope.mandatoryUnread = mandatoryUnread;
          if ($scope.mandatoryUnread > 0) {
            openMandatoryModal();
          }
        });
      }
    }
    function openMandatoryModal() {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/Flight/dlgMandatory.html',
        controller: 'MandatoryModalCtrl',
        size: 'md',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          mandatoryUnread: $scope.mandatoryUnread
        }
      });
    }

    /**
     * Finds the dates with a change on their schedule
     * @memberof CalendarCtrl
     * @param {array} events Calendar events (Flights and Ground duties) 
     * @returm {array} scheduleChangedDates
     */
    function findScheduleChangedDates() {
      var scheduleChangedDates = ScheduleAcknowledgeFactory.getScheduleChangesFromStorage();
      return scheduleChangedDates;
    }

    /**
     * Initialize Calendar
     * @memberof CalendarCtrl
     * @param {array} events Flights and Ground duties 
     * @param {array} specialDates The Schedule Changed Dates
     */
    function calendar(events, specialDates) {
      $("#calendar").fullCalendar({
        defaultView: getDefaultView(),
        defaultDate: defaultCalendarDate,
        firstDay: 1,
        lang: 'en',
        editable: false,
        draggable: false,
        selectable: false,
        selectHelper: false,
        unselectAuto: false,
        disableResizing: false,
        droppable: false,
        fixedWeekCount: false,
        nextDayThreshold: "00:00:00",
        header: {
          left: 'title',
          center: '',
          right: 'month,listMonth today prev,next'
        },
        timeFormat: 'HH:mm',
        displayEventEnd: true,
        events: events,
        eventRender: function eventRender(event, element, icon) {
          if ($('#calendar').fullCalendar('getView').type === 'listMonth') {
            element.find('.fc-list-item-title').addClass('listview-icon');
            $.each(event.className, function (index, icon) {
              element.addClass(event.listViewColor);
            });
            // $.each(event.icons, function (index, icon) {
            //     element.find('.listview-icon').prepend("<i style='padding-right:5px;' class='fa " + icon + " '></i> ");
            // });

            if (!event.description == "") {
              element.find('.fc-list-item-title').append("<span>" + "  " + event.description + "</span>");
            }
            if (!event.icon == "") {
              element.find('.fc-list-item-title').append("<i class='listViewCalendar-icon fa " + event.icon + " '></i>");
            }
            if (!event.second_icon == "") {
              element.find('.fc-list-item-title').append("<i class='listViewCalendar-icon fa " + event.second_icon + " '></i>");
            }
            if (!event.third_icon == "") {
              element.find('.fc-list-item-title').append("<i class='listViewCalendar-icon fa " + event.third_icon + " '></i>");
            }
          } else {
            if (event.type == "crewRoute" || event.type == "crewHotel") {
              element.find('.fc-time').remove();
            }
            element.find('.fc-title').prepend("<br/>");
            if (!event.description == "") {
              if (event.routeIndicators && event.routeIndicators.length > 0) {
                var routeIndicatorLetters = "";
                for (var j = 0; j < event.routeIndicators.length; j++) {
                  var letter = "<strong class='pull-right " + event.routeIndicators[j].routeIndicatorColor + "'>" + event.routeIndicators[j].routeIndicatorCode + "</strong>";
                  routeIndicatorLetters = routeIndicatorLetters + letter;
                }
                element.find('.fc-title').append("<br/><span class='calendar-light'>" + event.description + "</span>" + routeIndicatorLetters + "<br/>");
              } else {
                element.find('.fc-title').append("<br/><span class='calendar-light'>" + event.description + "</span> <br/>");
              }
            }
            if (!event.icon == "") {
              element.find('.fc-title').append("<i class='calendar-icon fa " + event.icon + " '></i>");
            }
            if (!event.second_icon == "") {
              element.find('.fc-title').append("<i class='calendar-second-icon fa " + event.second_icon + " '></i>");
            }
            if (!event.third_icon == "") {
              element.find('.fc-title').append("<i class='calendar-second-icon fa " + event.third_icon + " '></i>");
            }
          }
        },
        dayRender: function dayRender(date, cell) {
          for (var i = 0; i < specialDates.length; i++) {
            var objdate = new Date(specialDates[i]);
            if (date._d.getFullYear() == objdate.getFullYear() && date._d.getDate() == objdate.getDate() && date._d.getMonth() == objdate.getMonth()) cell.addClass('bg-yellow');
          }
        },
        dayClick: function dayClick(date, jsEvent, view) {},
        eventClick: function eventClick(calEvent, jsEvent, view) {
          if (calEvent.type == "flight") {
            $timeout(function () {
              gotoFlightInfo(calEvent._id);
            });
          } else if (calEvent.type == "groundDuty") {
            $timeout(function () {
              gotoGroundDutyInfo(calEvent._id);
            });
          } else if (calEvent.type == "crewRoute") {
            $timeout(function () {
              gotoCrewRouteInfo(calEvent.dutyNo, calEvent.dutyDay);
            });
          }
        },
        height: 'auto'
      });
      function getDefaultView() {
        var calendarStyle = SettingsMain.getCalendarViewStyle();
        if (calendarStyle == null) {
          calendarStyle = detectMobile() ? "listMonth" : "month";
        }
        return calendarStyle;
      }
      function detectMobile() {
        var isMobile = window.innerWidth <= 800 && window.innerHeight <= 735;
        return isMobile;
      }
      $('.fc-listMonth-button').click(function () {
        SettingsMain.setCalendarViewStyle('listMonth');
      });
      $('.fc-month-button').click(function () {
        SettingsMain.setCalendarViewStyle('month');
      });
    }
    /**
     * Transform flights in calendar events
     * @memberof CalendarCtrl
     * @param {array} flights The Scheduled Flights 
     * @return {array} events 
     */
    function formatFlights(flights, traineeFlightCourses) {
      var flightEvents = [];
      for (var i = 0; i < flights.length; i++) {
        var description = flights[i].getRoute();
        var title = flights[i].FlightNo;
        var third_icon = "";
        var flightCourseStatuses = [];
        var flightCoursesFlat = [];
        if (flights[i].TrainingIndicatorCode) {
          title = title + " " + flights[i].TrainingIndicatorCode;
        }

        /* Trainee flight courses */

        var relatedFlightTraineeCourses = [];
        for (var j = 0; j < traineeFlightCourses.length; j++) {
          if (flights[i].IsTrainee == true && flights[i].FlightId == traineeFlightCourses[j].FlightId) {
            relatedFlightTraineeCourses = traineeFlightCourses.find(function (x) {
              return x.FlightId == flights[i].FlightId;
            });
            flightCoursesFlat = flightCoursesFlat.concat(relatedFlightTraineeCourses);

            /*  NotSet = 0,
                InProgress = 1,
                Completed = 2,
                Pending = 3,
                NeedsApproval = 4,
                NotCompleted = 5 
            */
          }

          if (flightCoursesFlat.length > 0) {
            console.log(relatedFlightTraineeCourses);
            console.log(flightCourseStatuses);
          }
        }
        if (flightCoursesFlat.length > 0) {
          flightCoursesFlat.forEach(function (x) {
            flightCourseStatuses.push(x.Status);
          });
        }
        if (flightCourseStatuses.includes(1)) {
          //Pending
          third_icon = "fa-graduation-cap text-blue";
        } else if (flightCourseStatuses.includes(2)) {
          //Completed
          third_icon = "fa-graduation-cap text-green";
        } else if (flightCourseStatuses.includes(4) || flightCourseStatuses.includes(5)) {
          //Needs approval or stopped
          third_icon = "fa-graduation-cap text-orange";
        }
        var classname = "";
        var icon = "fa-plane";
        var second_icon = "";
        var id = flights[i].FlightId;
        var type = "flight";
        var listViewColor = "";

        /*              Weights for status of reports
                        6 --> na
                        5 --> draft
                        4 --> pendingoverdue
                        3 --> pending
                        2 --> completed
                        1 --> synched */

        var CabinReportStatusWeight = 0;
        if (flights[i].LineStatus === 'na') CabinReportStatusWeight = 6;else if (flights[i].LineStatus === 'pending') CabinReportStatusWeight = 3;else if (flights[i].LineStatus === 'pendingoverdue') {
          CabinReportStatusWeight = 4;
          $scope.pendingOverdueReports++;
        } else if (flights[i].LineStatus === 'draft' || flights[i].LineStatus === 'draftotheruser') {
          $scope.draftReports++;
          CabinReportStatusWeight = 5;
        } else if (flights[i].LineStatus === 'completed' || flights[i].LineStatus === 'completedotheruser') {
          $scope.completedReports++;
          CabinReportStatusWeight = 2;
        } else if (flights[i].LineStatus === 'stored' || flights[i].LineStatus === 'storedotheruser' || flights[i].LineStatus === 'stored+otheruser' || flights[i].LineStatus === 'synched' || flights[i].LineStatus === 'synchedotheruser') {
          CabinReportStatusWeight = 1;
        }
        //Remove Assessment Weight For Coloring
        /*    var AssessmentStatusWeight = 0;
            if (isAssessmentEnabled && flights[i].assessment){
                if(flights[i].assessment.IsExist || flights[i].assessment.Status == 'Stored'){
                    AssessmentStatusWeight = 1
                }else if(flights[i].assessment.Status == 'Completed'){
                    AssessmentStatusWeight = 2;
                }else if(flights[i].assessment.Status == 'Pending'){
                    AssessmentStatusWeight = 3;
                }else if(flights[i].assessment.Status == 'Draft'){
                    AssessmentStatusWeight = 5;
                }
            }*/

        var statusWeight = CabinReportStatusWeight;
        // var statusWeight = CabinReportStatusWeight > AssessmentStatusWeight ? CabinReportStatusWeight : AssessmentStatusWeight;

        if (statusWeight == 6) {
          if (flights[i].IsDHC) {
            classname = "fc-aluminum";
            icon = "";
            listViewColor = "lv-aluminium";
          } else {
            classname = "fc-white";
            icon = "";
            listViewColor = "lv-white";
          }
        } else if (statusWeight == 5) {
          classname = "fc-orange";
          icon = "fa-pencil";
          listViewColor = "lv-orange";
        } else if (statusWeight == 4) {
          classname = "fc-seablue";
          icon = "fa-exclamation-triangle text-lemon";
          listViewColor = "lv-seablue";
        } else if (statusWeight == 3) {
          classname = "fc-blue";
          icon = "fa-plus";
          listViewColor = "lv-blue";
        } else if (statusWeight == 2) {
          classname = "fc-purple";
          icon = "fa-check-circle";
          listViewColor = "lv-purple";
        } else if (statusWeight == 1) {
          classname = "fc-green";
          icon = "fa-cloud-download";
          listViewColor = "lv-green";
        }
        if (flights[i].IsScheduleChanged && flights[i].LineStatus != 'na') {
          classname = classname + " text-yellow-important";
        }
        if (flights[i].LineStatus === 'draftotheruser' || flights[i].LineStatus === 'completedotheruser' || flights[i].LineStatus === 'synchedotheruser' || flights[i].LineStatus === 'storedotheruser' || flights[i].LineStatus === 'stored+otheruser') second_icon = "fa-user";
        var IsScheduleChanged = flights[i].IsScheduleChanged;
        var ScheduledDeparture = flights[i].ScheduledDeparture;
        if (flights[i].ScheduledArrival == null) {
          var ScheduledArrival = ScheduledDeparture;
        } else {
          var ScheduledArrival = flights[i].ScheduledArrival;
        }
        var event = {
          _id: id,
          title: title,
          start: ScheduledDeparture,
          end: ScheduledArrival,
          description: description,
          icon: icon,
          second_icon: second_icon,
          className: classname,
          type: type,
          isScheduleChanged: IsScheduleChanged,
          listViewColor: listViewColor,
          third_icon: third_icon
        };
        flightEvents.push(event);
      }
      return flightEvents;
    }

    /**
     * Transform Ground Duties in calendar events
     * @memberof CalendarCtrl
     * @param {array} duties The Scheduled Ground Duties 
     * @return {array} events 
     */
    function formatGroundDuties(duties, traineeGroundCourses) {
      var groundEvents = [];
      var now = moment.utc();
      for (var i = 0; i < duties.length; i++) {
        //var description = duties[i].DutyDescription +"<br/>";
        var description = duties[i].Code;
        var title = duties[i].Title ? duties[i].Title : duties[i].Duty;
        var classname = "fc-white";
        var icon = "";
        if (duties[i].RelatedGroundDuties && duties[i].RelatedGroundDuties.length > 1) {
          icon = "fa-graduation-cap"; // icon only if training

          //Get ground courses
          var courseStatuses = [];
          var coursesFlat = [];
          for (var j = 0; j < duties[i].RelatedGroundDuties.length; j++) {
            /* Trainee ground courses */
            if (traineeGroundCourses.length > 0) {
              var relatedTraineeCourse = traineeGroundCourses.find(function (x) {
                return x.GroundDutyId == duties[i].Id;
              });
            }
            var relatedDutyCourse = duties[i].RelatedGroundDuties[j].Courses;
            if (relatedDutyCourse) {
              coursesFlat = coursesFlat.concat(relatedDutyCourse);
            }
            if (relatedTraineeCourse) {
              coursesFlat = coursesFlat.concat(relatedTraineeCourse);
            }
          }
          coursesFlat.forEach(function (x) {
            courseStatuses.push(x.Status);
          });

          /*Statuses
          	Completed : session has been sent
          	Outdated  :	session submission is overdue
          	Draft	  : session completion has started but not submitted
          	Pending   : session submission not yet due
          */
          /*  NotSet = 0,
                            InProgress = 1,
                            Completed = 2,
                            Pending = 3,
                            NeedsApproval = 4,
                            NotCompleted = 5 
                        */
          if (courseStatuses.includes("Pending") || courseStatuses.includes(1)) {
            //Pending
            classname = "fc-blue-inverted";

            //Outdated
            var dutyEnd = moment.utc(duties[i].DutyEnd);
            var duration = moment.duration(now.diff(dutyEnd)).asHours();
            if (duration > 1) {
              if (courseStatuses.includes("Pending")) $scope.hasUnsetTraining = true;
              classname = "fc-seablue-inverted";
              icon = "fa-exclamation-triangle text-yellow";
            }

            //Draft
            var courseId = coursesFlat[0].CourseId; // each duty should contain ONLY ONE COURSE
            var duty = duties[i];
            if (groundSessions && groundSessions.length) {
              var existingSession = groundSessions.find(function (s) {
                return s.courseId == courseId && s.day == duty.DutyDateS && s.dutyId == duty.Id;
              });
              if (existingSession && !existingSession.HasLimitedInfo && existingSession.trainees && existingSession.trainees.length) {
                //a training session with trainees exists
                classname = "fc-orange-inverted";
                icon = "fa-graduation-cap";
              }
            }
          } else if (courseStatuses.includes("Completed") || courseStatuses.includes(2)) {
            //Completed
            classname = "fc-green-inverted ";
          } else if (courseStatuses.includes(4) || courseStatuses.includes(5)) {
            //Needs approval or stopped
            classname = "fc-orange-inverted";
          }
        }
        var second_icon = "";
        if (duties[i].Unread) {
          second_icon = "fa-envelope text-orange";
        }
        var id = duties[i].Id;
        var type = "groundDuty";
        var start = duties[i].DutyBegin ? duties[i].DutyBegin : duties[i].DutyDateS ? duties[i].DutyDateS : duties[i].DutyDate;
        var end = duties[i].DutyEnd;
        var listViewColor = "lv-white";
        var event = {
          _id: id,
          title: title,
          start: start,
          end: end,
          description: description,
          icon: icon,
          second_icon: second_icon,
          className: classname,
          type: type,
          listViewColor: listViewColor
        };
        groundEvents.push(event);
      }
      return groundEvents;
    }

    /**
           * Transform Crew Routes in calendar events
           * @memberof CalendarCtrl
           * @param {array} routes The Scheduled Crew Routes 
           * @return {array} events 
           */
    function formatCrewRoutes(routes) {
      var crewRouteEvents = [];
      var now = moment.utc();
      for (var i = 0; i < routes.length; i++) {
        var description = routes[i].Route;
        // var title = (duties[i].Title)? duties[i].Title : duties[i].Duty;

        var classname = "fc-white";
        var icon = "";
        var second_icon = "";

        //Get ground courses
        var courseStatuses = [];
        var courses = routes[i].Courses;
        if (courses) {
          courses.forEach(function (x) {
            courseStatuses.push(x.Status);
          });
        }

        /*Statuses
        	Completed : session has been sent
        	Outdated  :	session submission is overdue
        	Draft	  : session completion has started but not submitted
        	Pending   : session submission not yet due
        */

        var trainingStatus = "";
        if (courseStatuses.includes("Pending")) {
          //Pending
          trainingStatus = "Pending";

          //Outdated
          var dutyEnd = moment.utc(routes[i].DutyEnd);
          var duration = moment.duration(now.diff(dutyEnd)).asHours();
          if (duration > 1) {
            if (courseStatuses.includes("Pending")) $scope.hasUnsetTraining = true;
            trainingStatus = "Outdated";
          }

          //Draft
          var courseIds = courses.map(function (x) {
            return x.CourseId;
          });
          var route = routes[i];
          if (flightSessions && flightSessions.length > 0) {
            //TODO msis fix
            var dutyBegin = new moment(route.DutyBegin).format("YYYY-MM-DD");
            var dutyEnd = new moment(route.DutyEnd).format("YYYY-MM-DD");
            //TODO:: fix null.courseId
            var existingSessions = flightSessions.filter(function (s) {
              return s != null && courseIds.includes(s.courseId) && (new moment(s.day).isSame(dutyBegin) || new moment(s.day).isSame(dutyEnd) || new moment(s.day).isBetween(dutyBegin, dutyEnd)) && s.dutyDay == route.DutyDay && s.dutyNo == route.DutyNo;
            });
            if (existingSessions && existingSessions.some(function (x) {
              return !x.HasLimitedInfo && x.trainees && x.trainees.length;
            })) {
              //a training session with trainees exists
              trainingStatus = "Draft";
            }
          }
        } else if (courseStatuses.includes("Completed")) {
          //Completed
          trainingStatus = "Completed";
          classname = "fc-green-inverted ";
        }
        if (trainingStatus == "Outdated") {
          second_icon = "fa-exclamation-triangle text-yellow second-icon-training";
          classname = "fc-seablue-inverted";
        } else if (trainingStatus == "Draft") {
          classname = "fc-orange-inverted";
        } else if (trainingStatus == "Pending") {
          classname = "fc-blue-inverted";
        } else if (trainingStatus == "Completed") {
          classname = "fc-green-inverted";
        }
        if (courses && courses.length) {
          icon = "fa-graduation-cap";
        }
        var routeIndicators = [];
        if (routes[i].RouteIndicators) {
          // Swap : [RECTYPE] = 106
          // Pre-Assigned : [RECTYPE] = 1
          // Requested : [RECTYPE] = 100
          // Unfinalised : [RECTYPE] = 101
          var routeIndicatorCodes = routes[i].RouteIndicators.split(',').map(Number);
          for (var j = 0; j < routeIndicatorCodes.length; j++) {
            var routeIndicatorCode = "";
            var routeIndicatorColor = "";
            if (routeIndicatorCodes[j]) {
              if (routeIndicatorCodes[j] == 106) {
                routeIndicatorCode = "S";
                routeIndicatorColor = "text-purple";
              } else if (routeIndicatorCodes[j] == 1) {
                routeIndicatorCode = "P";
                routeIndicatorColor = "text-teal";
              } else if (routeIndicatorCodes[j] == 100) {
                routeIndicatorCode = "R";
              } else if (routeIndicatorCodes[j] == 101) {
                routeIndicatorCode = "U";
                routeIndicatorColor = "text-red";
              }
              if (routeIndicatorCode.length > 0) {
                routeIndicators.push({
                  routeIndicatorCode: routeIndicatorCode,
                  routeIndicatorColor: routeIndicatorColor
                });
              }
            }
          }
        }

        // var id = routes[i].Id;
        var type = "crewRoute";
        var dutyNo = routes[i].DutyNo;
        var dutyDay = routes[i].DutyDay;
        var start = routes[i].DutyBegin ? routes[i].DutyBegin : routes[i].DutyDateS ? routes[i].DutyDateS : routes[i].DutyDate;
        var end = routes[i].DutyEnd;
        var listViewColor = "lv-white";
        var event = {
          // _id:id,
          // title: title,
          dutyNo: dutyNo,
          dutyDay: dutyDay,
          start: start,
          end: end,
          description: description,
          icon: icon,
          second_icon: second_icon,
          className: classname,
          type: type,
          listViewColor: listViewColor,
          routeIndicators: routeIndicators
        };
        crewRouteEvents.push(event);
      }
      return crewRouteEvents;
    }

    /**
         * Transform Crew Hotels in calendar events
         * @memberof CalendarCtrl
         * @param {array} crew hotels 
         * @return {array} events 
         */
    function formatHotels(hotels, flights, groundDuties) {
      var crewRouteEvents = [];
      for (var i = 0; i < hotels.length; i++) {
        var title = hotels[i].HotelName;
        var classname = "fc-gray-inverted";
        var icon = "fa-bed";
        var second_icon = "";
        var type = "crewHotel";
        var start = moment(hotels[i].DutyDate).endOf('day').toJSON();
        var listViewColor = "lv-white";
        var event = {
          title: title,
          start: start,
          end: start,
          icon: icon,
          second_icon: second_icon,
          className: classname,
          type: type,
          listViewColor: listViewColor
        };
        crewRouteEvents.push(event);
      }
      return crewRouteEvents;
    }

    //Modal functions
    /**
     * Open Synch Modal
     * @memberof CalendarCtrl
     */

    function openSynch() {
      //store last time the sync dialog was displayed
      SyncLogFactory.setLastShow();
      openSynchModal();
    }
    function openSynchModal() {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/Dialogs/dlgSynch.html',
        controller: 'SynchCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      });
      modalInstance.result.then(function (synchresult) {
        //refresh the view after a successful sync
        if (!synchresult == 'cancel') {
          $scope.setupView(true);
        }
      }, function () {});
    }

    /**
     * Open the "Add a flight" Modal
     * @memberof CalendarCtrl
     */
    function addFlight() {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/Dialogs/dlgAddFlight.html',
        controller: 'AddFlightCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      });
    }

    /**
     * Open the "Search Ground Duties" Modal
     * @memberof CalendarCtrl
     */
    function searchPastGroundDuties() {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/Dialogs/dlgSearchGroundDuties.html',
        controller: 'SearchPastGDCtrl',
        size: 'md',
        backdrop: 'static',
        keyboard: false
      });
    }

    /**
     * Redirect to flight Info
     * @memberof CalendarCtrl
     */
    function gotoFlightInfo(FlightId) {
      $location.path('/flightinfo/' + FlightId);
    }

    /**
     * Redirect to groundDuty Info
     * @memberof CalendarCtrl
     */
    function gotoGroundDutyInfo(GroundDutyId) {
      $location.path('/groundDuty/' + GroundDutyId);
    }

    /**
           * Redirect to crewRoute Info
           * @memberof CalendarCtrl
           */
    function gotoCrewRouteInfo(dutyNo, dutyDay) {
      $location.path('/crewRoute/' + dutyNo + '/' + dutyDay);
    }

    /**
     * Calculates the local storage Usage
     * @memberof CalendarCtrl
     * @return {string} usage
     */
    function storageUsage() {
      var usage = localStorageMD5Service.usedSize();
      return usage;
    }
  }
})();
"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
(function () {
  'use strict';

  a3_pilot_reports.factory('FlightFactory', FlightFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name FlightFactory
  * @description 
  *   Add, Update, Delete and Get Flights 
  * @ngInject
  */
  function FlightFactory($log, localStorageMD5Service, UserFactory, PilotReportLocalEditFactory, ServerPilotReportFactory, ServerCabinReportFactory, apiUrl, FlightCrewMemberFactory, MessageFactory, liveVersion, GenericService, SyncLogFactory) {
    var daysThatAFlightIsConsideredTooOld = -20;

    /**
    * Initialize the Flight
    * @memberof FlightFactory
    */
    function Flight() {
      this.AcTailNo = null;
      this.AcType = null;
      this.Category = null;
      this.CrewAimsId = null;
      this.Departure = null;
      this.Arrival = null;
      this.FlightAimsId = null;
      this.FlightId = null;
      this.FlightDate = null;
      this.FlightNo = null;
      this.IsDHC = null;
      this.Position = null;
      this.ScheduledDeparture = null;
      this.Status = null;
      this.LineStatus = null;
      this.LineStatusDescr = null;
      this.LocalReportId = null;
      this.ServerReportLink = null;
      this.ScheduledDepartureDateUTC = null;
      this.ScheduledDepartureTimeUTC = null;
      this.LocalReportHasNothingToReport = false;
      this.ServerReportHasNothingToReport = false;
      this.CabinReportId = null;
      this.IsLocal = false;
      this.pilotReports = [];
      this.cabinReports = [];
      this.pilotReportStatusDescr = '';
      //v1.1 added pax and dep/arr details
      this.BookedC = null;
      this.BookedY = null;
      this.BookedInf = null;
      this.BookedPad = null;
      this.BookedChld = null;
      this.ActualC = null;
      this.ActualY = null;
      this.ActualInf = null;
      this.ActualPad = null;
      this.ActualChld = null;
      this.DepartureICAO = null;
      this.DepartureCountry = null;
      this.DepartureName = null;
      this.ArrivalICAO = null;
      this.ArrivalCountry = null;
      this.ArrivalName = null;
      this.crew = [];

      //new fields 
      this.DepartureGate = null;
      this.DepartureTimezone = null;
      this.ArrivalTimezone = null;
      this.CallSign = null;
      this.ScheduledArrival = null;
      this.messages = [];
      this.FlightsFilters = [];
      this.ETA = null;
      this.IsScheduleChanged = false;
      this.Zones = [];
      this.GetId = GetId;
      this.getRoute = getRoute;
      this.getDescription = getDescription;
      this.initialize = initialize;
      this.initializePilotReportStatus = initializePilotReportStatus;
      this.getPilotReportStatusDescr = getPilotReportStatusDescr;
      this.updateFlightFromReport = updateFlightFromReport;
      this.getServerPilotReportForUser = getServerPilotReportForUser;
      this.getServerPilotReportsByAnotherUser = getServerPilotReportsByAnotherUser;
      this.getServerPilotReportForUser = getServerPilotReportForUser;
    }
    var service = {
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      getFlightsFromStorage: getFlightsFromStorage,
      getFlightsFromStorageAndCheckIfTooOld: getFlightsFromStorageAndCheckIfTooOld,
      setFlightsToStorage: setFlightsToStorage,
      storeFlightsWithReportsAndMessages: storeFlightsWithReportsAndMessages,
      clearFlightsFromStorage: clearFlightsFromStorage,
      getFlightFromStorage: getFlightFromStorage,
      createLocalFlight: createLocalFlight,
      saveLocalFlight: saveLocalFlight,
      getLocalFlightsAndMergeWithServerFlights: getLocalFlightsAndMergeWithServerFlights,
      getLocalFlightFromStorage: getLocalFlightFromStorage,
      markScheduleChangedFlights: markScheduleChangedFlights,
      getServerPilotReportForUser: getServerPilotReportForUser,
      getServerPilotReportsByAnotherUser: getServerPilotReportsByAnotherUser,
      updateFlightFromReport: updateFlightFromReport,
      initializeFlights: initializeFlights,
      updateFlight: updateFlight,
      mergeFlightInfo: mergeFlightInfo,
      getFlightsByRoute: getFlightsByRoute,
      getFlightFromTotalFlights: getFlightFromTotalFlights,
      getFlightsByDutyNo: getFlightsByDutyNo,
      getFlightsByFlightId: getFlightsByFlightId,
      getCabinReportId: getCabinReportId,
      insertFlightsWithPendingTrainings: insertFlightsWithPendingTrainings,
      getTheFirstAndTheLastFlightDates: getTheFirstAndTheLastFlightDates
    };
    function initializeFlights() {
      var objList = localStorageMD5Service.get(objType);
      if (objList == null) return null;
      var arrayLength = objList.length;
      var flights = new Array();
      for (var i = 0; i < arrayLength; i++) {
        var flight = new Flight();
        angular.extend(flight, objList[i]);
        if (objList[i].crew == null) objList[i].crew = [];
        flight.crew = new Array();
        for (var j = 0; j < objList[i].crew.length; j++) {
          flight.crew.push(FlightCrewMemberFactory.fromObject(objList[i].crew[j]));
        }
        flight.initialize();
        flights.push(flight);
      }
      localStorageMD5Service.set('flights', flights);
    }
    function updateFlight(flight) {
      // get the  flights array from storage
      var flights = getFlightsFromStorage();

      // find the current flight in the array (if present)
      var arrayLength = flights.length;
      var flightIndex = -1;
      for (var i = 0; i < arrayLength; i++) {
        if (flights[i].FlightId != null && flights[i].FlightId == flight.FlightId) {
          flightIndex = i;
          break;
        }
      }

      //Add or update a copy of the current report
      if (flightIndex >= 0) flights[flightIndex] = flight;else flights.push(flight);

      //Save
      localStorageMD5Service.set('flights', flights);
    }
    function updateFlightFromReport(report) {
      var flight = getFlightFromStorage(report.FlightId);
      if (flight != null && flight != undefined) {
        flight.AcTailNo = report.AcTailNo;
        flight.AcType = report.AcType;
        var allflights = getFlightsFromStorage();
        for (var i = 0; i < allflights.length; i++) {
          if (allflights[i].FlightId != null && allflights[i].FlightId == report.FlightId) {
            var reportIndex = i;
            break;
          }
        }
        flight.initialize();
        allflights[reportIndex] = flight;
        setFlightsToStorage(allflights);
      }
    }
    function getServerPilotReportForUser(userAimsId) {
      if (this.pilotReports == null) return null;
      var result = null;
      for (var i = 0; i < this.pilotReports.length; i++) {
        if (this.pilotReports[i] != null) {
          if (this.pilotReports[i].AuthorAimsId == userAimsId) {
            result = this.pilotReports[i];
            break;
          }
        }
      }
      return result;
    }
    function getServerPilotReportsByAnotherUser(userAimsId) {
      if (this.pilotReports == null) return [];
      var result = [];
      for (var i = 0; i < this.pilotReports.length; i++) {
        if (this.pilotReports[i] != null) {
          if (this.pilotReports[i].AuthorAimsId != userAimsId) {
            result.push(this.pilotReports[i]);
          }
        }
      }
      return result;
    }
    function insertFlightsWithPendingTrainings(flightsWithPendings) {
      if (flightsWithPendings) {
        var flights = getFlightsFromStorage();
        var flightIdsLS = flights.map(function (x) {
          return x.FlightId;
        });
        var flightsToInsert = flightsWithPendings.filter(function (f) {
          return !flightIdsLS.includes(f.FlightId);
        });
        var updatedFlightList = flights.concat(flightsToInsert);
        setFlightsToStorage(updatedFlightList);
      }
    }
    var objType = 'flights';
    var objCallback = Flight;
    /**
     * Overide default get Id
     * @memberof FlightFactory
     * @returns {number} Id 
     */
    function GetId() {
      return this.FlightId;
    }
    /**
     * Get flight's Route
     * @memberof FlightFactory
     * @returns {string} route 
     */
    function getRoute() {
      if (this.Departure == null && this.Arrival == null) return '-null-';else return (this.Departure || '?') + '-' + (this.Arrival || '?');
    }
    /**
     * Get flight's description
     * @memberof FlightFactory
     * @returns {string} description 
     */
    function getDescription() {
      if (this.FlightNo == null && this.Departure == null && this.Arrival == null) return '-null-';else return (this.ScheduledDepartureDateUTC || '?') + ' ' + (this.FlightNo || '?') + ' ' + (this.Departure || '?') + '-' + (this.Arrival || '?');
    }

    /**
     * Initialize Pilot Report
     * @memberof FlightFactory
     */
    function initialize() {
      try {
        // SD date/time
        if (this.ScheduledDeparture != null) {
          var STD = this.ScheduledDeparture;
          if (STD.indexOf('Z') < 0) STD += 'Z';
          STD = new moment(STD);
          STD = new Date(STD);
          STD = STD.toUTC();
          this.ScheduledDepartureDateUTC = STD.toString('yyyy-MM-dd');
          this.ScheduledDepartureTimeUTC = STD.toString('HH:mm');
        }

        // load the user
        var user = UserFactory.getUser();

        // check if there is a cabin report or a server report for this flight
        if (this.cabinReports.length > 0) {
          var token = '';
          if (user != null) {
            token = user.token;
            token = encodeURIComponent(token);
          }
          this.CabinReportId = this.cabinReports[0].ReportId;
        } else this.CabinReportId = null;

        // initialize the pilot report status field
        this.initializePilotReportStatus(user);

        // initialize css classes for display
        this.pilotReportStatusDescr = this.getPilotReportStatusDescr();
      } catch (ex) {
        $log.error("initialize failed: " + ex.message);
      }
    }
    /**
     * Initialize Pilot report Status
     * @memberof FlightFactory
     * @param {object} user 
     */
    function initializePilotReportStatus(user) {
      // check that the user is a CP
      if (user == null || this.IsDHC != 0 || this.Position != 'CP') {
        this.LineStatus = "na";
        return;
      }

      // initialize to pending
      this.LineStatus = "pending";

      // check if there is a local edit report or a server report for this
      // flight
      var serverReportForThisUser = this.getServerPilotReportForUser(user.aimsId);
      var serverReportsByAnotherUser = this.getServerPilotReportsByAnotherUser(user.aimsId);
      var hasServerReportForThisUser = serverReportForThisUser != null;
      var hasServerReportsByAnotherUser = serverReportsByAnotherUser.length > 0;
      var localReport = PilotReportLocalEditFactory.getPilotReportLocalEditForFlight(this.FlightId);
      this.LocalReportId = null;
      this.ServerReportLink = null;

      // if there is a local copy of the report
      if (localReport != null) {
        this.LocalReportId = localReport.ReportGuid;
        this.LocalReportHasNothingToReport = localReport.NothingToReport;
        if (localReport.Status === 'draft') {
          if (hasServerReportsByAnotherUser) this.LineStatus = "draftotheruser";else this.LineStatus = "draft";
        } else if (localReport.Status === 'completed') {
          if (hasServerReportsByAnotherUser) this.LineStatus = "completedotheruser";else this.LineStatus = "completed";
        } else if (localReport.Status === 'synched') {
          if (hasServerReportsByAnotherUser) this.LineStatus = "synchedotheruser";else this.LineStatus = "synched";
        } else {
          if (hasServerReportsByAnotherUser) this.LineStatus = "draftotheruser";else this.LineStatus = "draft";
        }
      } else {
        // if there is a server report by this and by another user
        if (hasServerReportForThisUser && hasServerReportsByAnotherUser) {
          this.LineStatus = "stored+otheruser";
          // Something if this or any other user has something to
          // report
          this.ServerReportHasNothingToReport = serverReportForThisUser.ReportedItems == 0;
          if (this.ServerReportHasNothingToReport) {
            // if nothing to report by this user, check if any other
            // user has something to report
            for (var i = 0; i < serverReportsByAnotherUser.length; i++) {
              if (serverReportsByAnotherUser[i].ReportedItems > 0) {
                this.ServerReportHasNothingToReport = false;
                break;
              }
            }
          }
        }
        // if there is a server report for another user
        else if (hasServerReportsByAnotherUser) {
          this.LineStatus = "storedotheruser";
          this.ServerReportHasNothingToReport = true;
          for (var i = 0; i < serverReportsByAnotherUser.length; i++) {
            if (serverReportsByAnotherUser[i].ReportedItems > 0) {
              this.ServerReportHasNothingToReport = false;
              break;
            }
          }
        }
        // if there is a server report for only this user
        else if (hasServerReportForThisUser) {
          this.LineStatus = "stored";
          this.ServerReportHasNothingToReport = serverReportForThisUser.ReportedItems == 0;
        }
        // no server report
        else {
          this.LocalReportId = "new";

          // no server report found for this user, status is pending
          if (new Date(this.ScheduledDeparture) < new Date()) {
            this.LineStatus = "pendingoverdue";
          } else {
            this.LineStatus = "pending";
          }
        }
      }
    }

    /**
     * Get Pilot Report Status Descr
     * @memberof FlightFactory
     * @returns {string} description 
     */
    function getPilotReportStatusDescr() {
      if (this.LineStatus === 'na') return "n/a";else if (this.LineStatus === 'pending') return "Pending";else if (this.LineStatus === 'pendingoverdue') return "Pending";else if (this.LineStatus === 'draft') return "Draft";else if (this.LineStatus === 'completed') return "Completed";else if (this.LineStatus === 'synched') return "Synched";else if (this.LineStatus === 'draftotheruser') return "Draft +";else if (this.LineStatus === 'completedotheruser') return "Completed +";else if (this.LineStatus === 'synchedotheruser') return "Synched +";else if (this.LineStatus === 'stored') return "Stored";else if (this.LineStatus === 'storedotheruser') return "Stored";else if (this.LineStatus === 'stored+otheruser') return "Stored +";else return this.LineStatus;
    }

    /**
     * Get Server PilotReport For the selected User
     * @memberof FlightFactory
     * @param {number} userAimsId The user aims Id
     * @return {object} pilotReport 
     */
    function getServerPilotReportForUser(userAimsId) {
      if (this.pilotReports == null) return null;
      var result = null;
      for (var i = 0; i < this.pilotReports.length; i++) {
        if (this.pilotReports[i] != null) {
          if (this.pilotReports[i].AuthorAimsId == userAimsId) {
            result = this.pilotReports[i];
            break;
          }
        }
      }
      return result;
    }

    /**
     * Get Server pilotReport For others than the selected User
     * @memberof FlightFactory
     * @param {number} userAimsId The user aims Id
     * @return {object} pilotReport 
     */
    function getServerPilotReportsByAnotherUser(userAimsId) {
      if (this.pilotReports == null) return new Array();
      var result = new Array();
      for (var i = 0; i < this.pilotReports.length; i++) {
        if (this.pilotReports[i] != null) {
          if (this.pilotReports[i].AuthorAimsId != userAimsId) {
            result.push(this.pilotReports[i]);
          }
        }
      }
      return result;
    }

    //Factory Functions

    /**
     * Get Flight from local and storage flights
     * @memberof FlightFactory
     * @param {number} flightId 
     * @return {object} flight
     */
    function getFlightFromTotalFlights(flightId) {
      var flight = getFlightFromStorage(flightId);
      if (!flight) {
        flight = getLocalFlightFromStorage(flightId);
      }
      return flight;
    }

    /**
     * Get Flight from local and storage flights
     * @memberof FlightFactory
     * @param {number} flightId 
     * @return {object} flight
     */
    function getFlightsByRoute(Route, DutyDate) {
      var flights = getFlightsFromStorage();
      if (flights == null) return [];
      var result = [];
      var arrayLength = flights.length;
      for (var i = 0; i < arrayLength; i++) {
        if (flights[i].Route == Route && flights[i].DutyDate == DutyDate) {
          result.push(flights[i]);
        }
      }
      return result;
    }

    /**
     * Extend Object from the default Flight Object
     * @memberof FlightFactory
     * @param {Object} obj  a Flight
     * @returns {Object} Flight
     */
    function fromObject(obj) {
      if (obj == null) return null;
      var flight = new Flight();
      angular.extend(flight, obj);
      //handle crew members
      if (obj.crew == null) obj.crew = [];
      flight.crew = FlightCrewMemberFactory.fromObjectList(obj.crew);
      return flight;
    }
    ;

    /**
     * Extend an array of Objects from the default flight Object
     * @memberof FlightFactory
     * @param {Array} objList  an Array Of flights
     * @returns {Array} flights
     */
    function fromObjectList(objList) {
      if (objList == null) return [];
      var arrayLength = objList.length;
      var flights = new Array();
      for (var i = 0; i < arrayLength; i++) {
        var flight = new Flight();
        angular.extend(flight, objList[i]);
        //handle crew members
        if (objList[i].crew == null) objList[i].crew = [];
        flights.push(flight);
      }
      return flights;
    }
    ;

    /**
     * Returns all the flights from storage
     * @memberof FlightFactory
     * @returns {Array} flights
     */
    function getFlightsFromStorage() {
      var objects = localStorageMD5Service.get('flights');
      return fromObjectList(objects);
    }

    /**
    * Returns the flights from local storage only if they are recent
    * @memberof FlightFactory
    * @returns {Array} flights
    */
    function getFlightsFromStorageAndCheckIfTooOld() {
      var result = getFlightsFromStorage();
      if (result == null) return null;
      var dataIsRecent = false;
      var arrayLength = result.length;

      // loop all flights and break if a flight in the last 10 days is found
      for (var i = 0; i < arrayLength; i++) {
        if (Date.today().add(daysThatAFlightIsConsideredTooOld).days().toUTC().isBefore(new Date(result[i].ScheduledDeparture).toUTC().trimTime())) {
          dataIsRecent = true;
          break;
        }
      }
      if (dataIsRecent == true || !liveVersion) return result;else return null;
    }

    /**
     * Set flights to  storage
     * @memberof FlightFactory
     * @returns {Array} flights
     */
    function setFlightsToStorage(flights) {
      for (var i = 0; i < flights.length; i++) {
        if (flights[i].FlightId == undefined || flights[i].FlightId == null) {
          flights[i].FlightId = guid();
        }
      }
      localStorageMD5Service.set('flights', flights);
    }

    /**
    * Store Flights With Reports And Messages
    * @memberof FlightFactory
    * @param {Array} flights 
    * @param {Array} pilotReports
    * @param {Array} messages
    */
    function storeFlightsWithReportsAndMessages(flights, pilotReports, cabinReports, messages) {
      var flightsX = fromObjectList(flights);
      var pilotReportsX = ServerPilotReportFactory.fromObjectList(pilotReports);
      var cabinReportsX = ServerCabinReportFactory.fromObjectList(cabinReports);
      var messagesX = MessageFactory.fromObjectList(messages);
      if (flightsX && flightsX instanceof Array && flightsX.length > 0 && (pilotReportsX && cabinReportsX || messagesX)) {
        // loop all flights
        var user = UserFactory.getUser();
        var f, pr, cr, me;
        for (var fi = 0; fi < flightsX.length; fi++) {
          f = flightsX[fi];

          // find pilot reports for this flight
          f.pilotReports = [];
          f.cabinReports = [];
          if (pilotReportsX && pilotReportsX instanceof Array && pilotReportsX.length > 0) {
            for (var pri = 0; pri < pilotReportsX.length; pri++) {
              pr = pilotReportsX[pri];
              if (pr.FlightId != null && pr.FlightId == f.FlightId || pr.FlightAimsId != null && pr.FlightAimsId == f.FlightAimsId) {
                if (pr.AuthorAimsId == f.CrewAimsId) {
                  pr.Source = ServerPilotReportFactory.constSourceStoredOwn;
                  f.pilotReports.push(pr);
                } else {
                  pr.Source = ServerPilotReportFactory.constSourceStoredOther;
                  f.pilotReports.push(pr);
                }
              }
            }
          }

          // find cabin reports for this flight
          if (cabinReportsX && cabinReportsX instanceof Array && cabinReportsX.length > 0) {
            for (var cri = 0; cri < cabinReportsX.length; cri++) {
              cr = cabinReportsX[cri];
              if (cr.FlightId != null && cr.FlightId == f.FlightId || cr.FlightAimsId != null && cr.FlightAimsId == f.FlightAimsId) {
                f.cabinReports.push(cr);
              }
            }
          }
          if (messagesX && messagesX instanceof Array && messagesX.length > 0) {
            for (var mi = 0; mi < messagesX.length; mi++) {
              me = messagesX[mi];
              if (me.QueryType.trim() == 'Country' && (me.Country.trim() == f.ArrivalCountry || me.Country.trim() == f.DepartureCountry)) {
                f.messages.push(me.Id);
              } else if (me.QueryType.trim() == 'FlightNo' && me.FlightNo == f.FlightNo) {
                f.messages.push(me.Id);
              } else if (me.QueryType.trim() == 'Airports') {
                if (me.FlightDirection == 'DEP' && me.AirportA == f.Departure && me.AirportB == f.Arrival) {
                  f.messages.push(me.Id);
                } else if (me.FlightDirection == 'ARR' && me.AirportB == f.Departure && me.AirportA == f.Arrival) {
                  f.messages.push(me.Id);
                } else if (me.FlightDirection == 'ANY' && (me.AirportA == f.Departure && me.AirportB == f.Arrival || me.AirportB == f.Departure && me.AirportA == f.Arrival)) {
                  f.messages.push(me.Id);
                }
              } else if (me.QueryType.trim() == 'Airport') {
                if (me.FlightDirection == 'DEP' && me.AirportA == f.Departure) {
                  f.messages.push(me.Id);
                } else if (me.FlightDirection == 'ARR' && me.AirportA == f.Arrival) {
                  f.messages.push(me.Id);
                } else if (me.FlightDirection == 'ANY' && (me.AirportA == f.Departure || me.AirportA == f.Arrival)) {
                  f.messages.push(me.Id);
                }
              } else if (me.QueryType.trim() == 'Registration' && f.AcTailNo == me.Registration) {
                f.messages.push(me.Id);
              } else if (me.QueryType.trim() == 'AcType' && f.AcType == me.AcType) {
                f.messages.push(me.Id);
              }
            }
          }
          f.initialize();
        }
      }
      localStorageMD5Service.set('flights', flightsX);
    }

    /**
     * Remove the flights of the storage
     * @memberof FlightFactory
     */
    function clearFlightsFromStorage() {
      GenericService.removeAll(objType, objCallback);
    }

    /**
     * Get Flight from storage flights
     * @memberof FlightFactory
     * @param {number} flightId 
     * @return {object} flight
     */
    function getFlightFromStorage(flightId) {
      var objects = getFlightsFromStorage();
      if (objects == null) return null;
      var result = null;
      var arrayLength = objects.length;
      for (var i = 0; i < arrayLength; i++) {
        if (objects[i].GetId() == flightId) {
          result = objects[i];
          break;
        }
      }
      return result;
    }

    /**
    * create a local flight (Add flight button on main screen)
    * @memberof FlightFactory
    * @param {string} datetime 
    * @param {string} number 
    * @param {string} departure 
    * @param {string} destination 
    * @param {string} regno 
    * @param {string} actype 
    * @return {object} flight
    */
    function createLocalFlight(datetime, number, departure, destination, regno, actype) {
      var user = UserFactory.getUser();
      if (user == null) return null;
      var result = new Flight();
      result.AcTailNo = regno;
      result.AcType = actype;
      result.Category = '-';
      result.CrewAimsId = user.aimsId;
      result.Departure = departure;
      result.Arrival = destination;
      result.FlightAimsId = guid();
      result.FlightId = guid();
      result.FlightDate = datetime.toString('yyyy-MM-dd') + 'T' + datetime.toString('HH:mm:ss');
      ;
      result.FlightNo = number;
      result.IsDHC = 0;
      result.Position = user.position;
      result.ScheduledDeparture = datetime.toString('yyyy-MM-dd') + 'T' + datetime.toString('HH:mm:ss');
      result.Status = 'OK';
      result.IsLocal = true;
      result.initialize();
      return result;
    }

    /**
     * Save a local flight
     * @memberof FlightFactory
     * @param {object} flight
     */
    function saveLocalFlight(flight) {
      // get the local flights array from storage
      var localFlights = fromObjectList(localStorageMD5Service.get('localFlights'));
      if (localFlights == null) localFlights = new Array();

      // find the current flight in the array (if present)
      var arrayLength = localFlights.length;
      var flightIndex = -1;
      for (var i = 0; i < arrayLength; i++) {
        if (localFlights[i].FlightId == flight.FlightId) {
          flightIndex = i;
          break;
        }
      }

      // add or update a copy of the current report
      if (flightIndex >= 0) localFlights[flightIndex] = flight;else localFlights.push(flight);

      // save
      localStorageMD5Service.set('localFlights', localFlights);
    }

    /**
     * Save a local flight
     * @memberof FlightFactory
     * @param {object} flight
     */
    function getLocalFlightsAndMergeWithServerFlights(serverFlights) {
      if (serverFlights == null) serverFlights = new Array();

      // get the local flights array from storage
      var localFlights = fromObjectList(localStorageMD5Service.get('localFlights'));
      if (localFlights == null) localFlights = new Array();

      // add the local flight to the given array
      var arrayLength = localFlights.length;
      for (var i = 0; i < arrayLength; i++) {
        localFlights[i].initialize();
        serverFlights.push(localFlights[i]);
      }
      return serverFlights;
    }

    /**
     * Get Flight from local flights
     * @memberof FlightFactory
     * @param {number} flightId 
     * @return {object} flight
     */
    function getLocalFlightFromStorage(flightId) {
      var flight = GenericService.get(flightId, 'localFlights', objCallback);
      if (flight) {
        flight.initialize();
      }
      return fromObject(flight);
    }
    /**
     * mark Schedule Changed Flights by comparing flights from new and old data
     * @memberof FlightFactory
     * @param {object} newFlights 
     * @param {object} oldFlights
     * @return {object} newFlights 
     */
    function markScheduleChangedFlights(newFlights, oldFlights) {
      var lastScheduleDate = SyncLogFactory.getLastScheduleDate();

      //if there are no old flights  or no last schedule date
      if (oldFlights && lastScheduleDate) {
        //loop all new flights
        var exists;
        for (var i = 0; i < newFlights.length; i++) {
          //loop all old flights
          exists = false;
          for (var j = 0; j < oldFlights.length; j++) {
            if (newFlights[i].FlightNo == oldFlights[j].FlightNo && newFlights[i].FlightNo == oldFlights[j].FlightNo && newFlights[i].FlightDate == oldFlights[j].FlightDate && newFlights[i].Departure == oldFlights[j].Departure) {
              exists = true;
              break;
            }
          }
          //check if flight is newly added and is before the last schedule date
          var flightDate = new Date(newFlights[i].FlightDate);
          if (!exists && flightDate.getTime() <= lastScheduleDate) {
            newFlights[i].IsScheduleChanged = true;
          }
        }
      }
      return newFlights;
    }

    //factory functions
    /**
     * Update Passenger information
     * @memberof FlightFactory
     * @param {object} flightInfo  The flight informations 
     */
    function mergeFlightInfo(flightInfo, showPaxNames) {
      if (flightInfo) {
        var currentFlightInfo = GenericService.get(flightInfo.FlightId, objType, objCallback);
        currentFlightInfo.CrewAimsId = flightInfo.CrewAimsId;
        currentFlightInfo.DutyDate = flightInfo.DutyDate;
        currentFlightInfo.Route = flightInfo.Route;
        currentFlightInfo.FlightId = flightInfo.FlightId;
        currentFlightInfo.FlightAimsId = flightInfo.FlightAimsId;
        currentFlightInfo.FlightDate = flightInfo.FlightDate;
        currentFlightInfo.FlightNo = flightInfo.FlightNo;
        currentFlightInfo.Departure = flightInfo.Departure;
        currentFlightInfo.Arrival = flightInfo.Arrival;
        currentFlightInfo.AcType = flightInfo.AcType;
        currentFlightInfo.AcTailNo = flightInfo.AcTailNo;
        currentFlightInfo.ScheduledDeparture = flightInfo.ScheduledDeparture;
        currentFlightInfo.ScheduledArrival = flightInfo.ScheduledArrival;
        currentFlightInfo.BookedC = flightInfo.BookedC;
        currentFlightInfo.BookedY = flightInfo.BookedY;
        currentFlightInfo.BookedInf = flightInfo.BookedInf;
        currentFlightInfo.BookedPad = flightInfo.BookedPad;
        currentFlightInfo.BookedChld = flightInfo.BookedChld;
        currentFlightInfo.ActualC = flightInfo.ActualC;
        currentFlightInfo.ActualY = flightInfo.ActualY;
        currentFlightInfo.ActualInf = flightInfo.ActualInf;
        currentFlightInfo.ActualPad = flightInfo.ActualPad;
        currentFlightInfo.ActualChld = flightInfo.ActualChld;
        currentFlightInfo.Category = flightInfo.Category;
        currentFlightInfo.Status = flightInfo.Status;
        currentFlightInfo.Position = flightInfo.Position;
        currentFlightInfo.IsDHC = flightInfo.IsDHC;
        currentFlightInfo.CallSign = flightInfo.CallSign;
        currentFlightInfo.DepartureGate = flightInfo.DepartureGate;
        currentFlightInfo.DepartureStand = flightInfo.DepartureStand;
        currentFlightInfo.ArrivalStand = flightInfo.ArrivalStand;
        currentFlightInfo.DepartureICAO = flightInfo.DepartureICAO;
        currentFlightInfo.DepartureName = flightInfo.DepartureName;
        currentFlightInfo.DepartureCountry = flightInfo.DepartureCountry;
        currentFlightInfo.ArrivalICAO = flightInfo.ArrivalICAO;
        currentFlightInfo.ArrivalName = flightInfo.ArrivalName;
        currentFlightInfo.ArrivalCountry = flightInfo.ArrivalCountry;
        currentFlightInfo.DepartureTimezone = flightInfo.DepartureTimezone;
        currentFlightInfo.ArrivalTimezone = flightInfo.ArrivalTimezone;
        currentFlightInfo.DepartureSchengen = flightInfo.DepartureSchengen;
        currentFlightInfo.ArrivalSchengen = flightInfo.ArrivalSchengen;
        currentFlightInfo.DepartureEU = flightInfo.DepartureEU;
        currentFlightInfo.ArrivalEU = flightInfo.ArrivalEU;
        currentFlightInfo.ETD = flightInfo.ETD;
        currentFlightInfo.ATD = flightInfo.ATD;
        currentFlightInfo.ETA = flightInfo.ETA;
        currentFlightInfo.ATA = flightInfo.ATA;
        currentFlightInfo.CTOT = flightInfo.CTOT;
        currentFlightInfo.DepartureCountryISO = flightInfo.DepartureCountryISO;
        currentFlightInfo.ArrivalCountryISO = flightInfo.ArrivalCountryISO;
        currentFlightInfo.crew = flightInfo.crew;
        currentFlightInfo.Zones = flightInfo.Zones;
        currentFlightInfo.showPaxNames = showPaxNames;
        GenericService.save(currentFlightInfo, objType, objCallback);
      }
    }

    /**
           * Get Flights of a Crew Route
           * @memberof FlightFactory
           * @param {number} dutyNo 
           * @param {string} dutyDay
     * @return {array} flights
           */
    function getFlightsByDutyNo(dutyNo, dutyDay) {
      var flights = getFlightsFromStorage();
      if (flights == null) return [];
      var result = [];
      var arrayLength = flights.length;
      for (var i = 0; i < arrayLength; i++) {
        if (flights[i].DutyNo == dutyNo && flights[i].DutyDay == dutyDay) {
          result.push(flights[i]);
        }
      }
      return result;
    }

    /**
     * Get Flights of a Crew Route using a flightId
     * @memberof FlightFactory
     * @param {number} flightId 
     * @return {array} flights
     */
    function getFlightsByFlightId(flightId) {
      var result = [];
      var flights = getFlightFromStorage(flightId);
      if (flights != null) {
        for (var i = 0; i < flights.length; i++) {
          if (flights[i].DutyNo == dutyNo && flights[i].DutyDay == dutyDay) {
            result.push(flights[i]);
          }
        }
      }
      return result;
    }
    function getCabinReportId() {
      var res = this.CabinReportLink;
      return res;
    }
    function getTheFirstAndTheLastFlightDates() {
      var flights = getFlightsFromStorage();
      var parseDate = function parseDate(dateString) {
        return new Date(dateString);
      };
      var firstFlightDate = null;
      var lastFlightDate = null;
      var _iterator = _createForOfIteratorHelper(flights),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var obj = _step.value;
          var currentDate = parseDate(obj.FlightDate);
          if (!firstFlightDate || currentDate < firstFlightDate) {
            firstFlightDate = currentDate;
          }
          if (!lastFlightDate || currentDate > lastFlightDate) {
            lastFlightDate = currentDate;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return {
        firstDate: firstFlightDate,
        lastDate: lastFlightDate
      };
    }
    return service;
  }
  ;
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('FlightCrewMemberFactory', FlightCrewMemberFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name FlightCrewMemberFactory
  * @description 
  *   Add, Update, Delete and Get Flight Crew Members.
  * @ngInject
  */
  function FlightCrewMemberFactory(GenericModalFactory) {
    /**
    * Initialize the FlightCrewMember
    * @memberof FlightCrewMemberFactory
    */
    function FlightCrewMember() {
      this.aimsId = null;
      this.id = null;
      this.isDHC = null;
      this.name = null;
      this.position = null;
      this.sex = null;
      this.shortname = null;
    }
    var service = {
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      deleteFromList: deleteFromList
    };

    /**
    * Extend Object from the default FlightCrewMember Object
    * @memberof FlightCrewMemberFactory
    * @param {Object} obj a FlightCrewMember
    * @returns {Object} FlightCrewMember
    */
    function fromObject(obj) {
      return GenericModalFactory.fromObject(obj, FlightCrewMember);
    }

    /**
     * Delete object from given list and update it
     * @memberof FlightCrewMemberFactory
     * @param {object} obj  a Flight Crew Member
     * @param {Array} objList  an Array Of Flight Crew Member
     * @returns {Array} FlightCrewMembers
     *
     */
    function deleteFromList(obj, objList) {
      return GenericModalFactory.deleteFromList(obj, objList);
    }

    /**
     * Delete object from given list and update it
     * @memberof FlightCrewMemberFactory
     * @param {object} obj  a Flight Crew Member
     * @param {Array} objList  an Array Of Flight Crew Member
     * @returns {Array} FlightCrewMembers
     *
     */
    function fromObjectList(objList) {
      return GenericModalFactory.fromObjectList(objList, FlightCrewMember);
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('SearchPastGDCtrl', SearchPastGDCtrl);
  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name SearchPastGDCtrl
  * @description 
  *   Search old ground duties 
  * @ngInject
  */
  function SearchPastGDCtrl($scope, GroundDutyFactory, PastDutyFactory, $uibModalInstance, $route, CourseFactory, defaultCalendarDate, CrewRouteFactory, FlightFactory) {
    $scope.dutyId = null;
    $scope.showContent = 'search';
    $scope.course = {
      isCourseLimited: true
    };
    $scope.hasError = false;

    // cancel
    $scope.doCancel = doCancel;

    //Close modal
    $scope.closeModal = closeModal;
    var today = new Date().toUTC();
    if (defaultCalendarDate) {
      today = new Date(defaultCalendarDate).toUTC();
    }
    $scope.dutyDatePicker = {
      value: today,
      format: 'dd-MM-yyyy',
      opened: false
    };
    $scope.dateFormat = 'dd-MM-yyyy';
    $scope.openDatepicker = openDatepicker;
    function openDatepicker() {
      $scope.dutyDatePicker.opened = true;
    }
    $scope.searchGDByDate = searchGDByDate;
    function searchGDByDate() {
      $scope.hasError = false;
      $scope.showContent = 'loading';
      PastDutyFactory.getPastDuties($scope.dutyDatePicker.value.toString('yyyy-MM-dd')).then(function (res) {
        return handleSubmitResponse(res);
      })["catch"](function (res) {
        return handleFailedResponse(res);
      });
    }

    // search pending gd
    $scope.searchGD = searchGD;

    /**
     * Close the modal
     * @memberof SearchPastGDCtrl
     */
    function doCancel() {
      $uibModalInstance.close('cancel');
    }
    function searchGD() {
      $scope.showContent = 'loading';
      PastDutyFactory.getPastDuties('').then(function (res) {
        return handleSubmitResponse(res);
      })["catch"](function (res) {
        return handleFailedResponse(res);
      });
    }
    function handleSubmitResponse(res) {
      $scope.showContent = 'results';
      $scope.availableCources = res.data.trainingCourses;
      $scope.pendingDuties = res.data.pendingGroundDuties;
      $scope.flightTrainings = res.data.pendingRoutes;
      $scope.pendingFlightCourses = res.data.flightCourses;
      var flights = res.data.flightsForPendingRoutes;
      FlightFactory.insertFlightsWithPendingTrainings(flights);
      $scope.availableCources.forEach(function (course) {
        // Combine CourseId and PhaseId if PhaseId exists, otherwise use CourseId
        if (course.PhaseId != null && course.PhaseId != undefined) {
          var _course$CourseId;
          course.Id = "".concat((_course$CourseId = course.CourseId) !== null && _course$CourseId !== void 0 ? _course$CourseId : course.Id, "_").concat(course.PhaseId);
        } else {
          var _course$CourseId2;
          course.Id = (_course$CourseId2 = course.CourseId) !== null && _course$CourseId2 !== void 0 ? _course$CourseId2 : course.Id;
        }
        course.HasLimitedInfo = true;
        CourseFactory.upsertCourse(course, function () {});
      });
      $scope.pendingDuties.forEach(function (duty) {
        duty.isManualEntry = true;
        duty.hasPendingCourse = true;
        GroundDutyFactory.addGroundDuty(duty);
      });
      $scope.flightTrainings.forEach(function (pendingRoute) {
        pendingRoute.isManualEntry = true;
        pendingRoute.hasPendingCourse = true;
        CrewRouteFactory.addCrewRouteDuty(pendingRoute);
      });
      $scope.pendingFlightCourses.forEach(function (course) {
        course.HasLimitedInfo = true;
        CourseFactory.upsertCourse(course, function () {});
      });
    }
    function handleFailedResponse(res) {
      $scope.showContent = 'results';
      $scope.hasError = true;
    }
    function closeModal() {
      $uibModalInstance.close();
      $route.reload();
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('gdCrewInfo', gdCrewInfo);
  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name crewInfo
  * @restrict E
  * @description
  *   Crew Table with a double row per crew member
  * @example
  *   Usage:
  *   <gd-crew-info crew="crewMembers" grounddutyid="id"></gd-crew-info>
  * @ngInject
  */
  function gdCrewInfo($uibModal, UserFactory) {
    function link(scope) {
      scope.user = UserFactory.getUser();
      scope.openPhoneConfirmation = openPhoneConfirmation;
      scope.showInfoRow = showInfoRow;
      function openPhoneConfirmation(_crew) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/CrewInfo/dlgConfirmCrewCall.html',
          controller: 'CrewCallCtrl',
          size: 'md',
          resolve: {
            crew: function crew() {
              return _crew;
            },
            groundDutyId: function groundDutyId() {
              return scope.grounddutyid;
            },
            flightId: function flightId() {
              return null;
            }
          }
        });
        modalInstance.result.then(function (confirm) {});
      }
      function showInfoRow(item) {
        var differentUser = scope.user.aimsId != item.AIMS_ID;
        var phoneAvailable = item.PhoneNumber && item.PhoneNumber != '';
        return differentUser && phoneAvailable;
      }
    }
    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/GroundDuty/gdCrewInfo.tpl.html',
      scope: {
        crew: "=",
        grounddutyid: "="
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('GroundDutyCtrl', GroundDutyCtrl);
  /**
   * @memberof PilotReports
   * @ngdoc controller
   * @name GroundDutyCtrl
   * @description 
   * Shows the ground duty information
   * @ngInject
   */
  function GroundDutyCtrl(GroundDutyFactory, CourseFactory, TrainingSessionFactory, $scope, $location, $routeParams) {
    $scope.toggleCrewList = toggleCrewList;
    $scope.toggleEditMode = toggleEditMode;
    $scope.selectTrainee = selectTrainee;
    $scope.instructors = [];
    $scope.trainees = [];
    $scope.groundDutyId = groundDutyId;
    $scope.refresh = refresh;
    $scope.refreshSuccess = true;
    $scope.isRefreshing = false;
    var groundDutyId = Number($routeParams.groundDutyId);
    var groundDuty = GroundDutyFactory.getGroundDutyFromStorage(groundDutyId);
    $scope.dutyCourses = GroundDutyFactory.getGroundDutyActiveCourses(groundDutyId);
    if (!groundDuty) {
      // go to dashboard if no groundDuty
      $location.path("/");
    } else {
      //Toggle trainees
      groundDuty.Trainees.forEach(function (relatedTrainees) {
        relatedTrainees.isCollapsed = false;
        relatedTrainees.dynamicSize = 10;
      });

      //Collect all trainees in list
      var traineesFlat = [];
      groundDuty.Trainees.forEach(function (related) {
        related.CrewMembers.forEach(function (trainee) {
          traineesFlat.push(trainee);
        });
      });
      groundDuty.traineesFlat = traineesFlat;
      if (groundDuty.RelatedGroundDuties) {
        $scope.courses = GroundDutyFactory.getGroundDutyActiveCourses(groundDutyId);
      }
      updateCrewMemberScopes(groundDuty);
      $scope.groundDuty = groundDuty;
      $scope.groundDutyId = groundDutyId;
    }
    function toggleCrewList(relatedTrainees) {
      relatedTrainees.isCollapsed = !relatedTrainees.isCollapsed;
      if (relatedTrainees.isCollapsed) relatedTrainees.dynamicSize = relatedTrainees.CrewMembers.length;else relatedTrainees.dynamicSize = 10;
    }
    function toggleEditMode(elem, className) {
      $('body').find('div#' + elem + ' > div').not('.tip').hide("slow");
      $('body').find('div#' + elem + ' div.' + className).not('.tip').show("slow");
    }

    /**
     * Edit ground duty's attendance list
     * @param {object} trainee 
     */
    function selectTrainee(trainee) {
      //Value will be saved in ground duty's crew members
      trainee.Absent = !trainee.Absent;
      GroundDutyFactory.updateGroundDuty($scope.groundDuty);
    }

    /**
     * Sync ground duty
     */
    function refresh() {
      var courseIds = $scope.dutyCourses.map(function (x) {
        return x.CourseId;
      }).filter(onlyUnique);
      var refreshGroundDuty = {
        DutyId: groundDutyId,
        CourseIds: courseIds
      };
      $scope.isRefreshing = true;

      //get latest info
      GroundDutyFactory.refresh(refreshGroundDuty, function (responseData) {
        $scope.isRefreshing = false;
        $scope.refreshSuccess = true;

        //update ground duty.
        var groundDuty = responseData.data.GroundDuty;
        if (groundDuty) {
          GroundDutyFactory.mergeGroundDutyInfo(groundDuty);
        }

        //Save training
        var trainingCourses = responseData.data.TrainingCourses;
        if (trainingCourses && trainingCourses.length) {
          trainingCourses.forEach(function (trainingCourse) {
            CourseFactory.upsertCourse(trainingCourse, function (course) {
              TrainingSessionFactory.applyTraineeInfoToSession(course, course.Id, $scope.groundDuty.DutyDateS, groundDutyId, function (session) {});
            });
          });
        }
        updateCrewMemberScopes(groundDuty);
      })["catch"](function () {
        $scope.refreshSuccess = false;
        $scope.isRefreshing = false;
      });
    }
    function updateCrewMemberScopes(groundDuty) {
      if (groundDuty && groundDuty.RelatedGroundDuties && groundDuty.RelatedGroundDuties.length > 0) {
        var relatedDutyIns = groundDuty.RelatedGroundDuties.filter(function (x) {
          return x.IsInstructor == true;
        });
        if (relatedDutyIns && relatedDutyIns.length > 0) {
          $scope.instructors = relatedDutyIns[0].CrewMembers;
        }
        var relatedDutyTr = groundDuty.RelatedGroundDuties.filter(function (x) {
          return x.IsInstructor == false;
        });
        if (relatedDutyTr && relatedDutyTr.length > 0) {
          $scope.trainees = relatedDutyTr.flatMap(function (a) {
            return a.CrewMembers;
          });
        }
      }
    }
    function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }
  }
})();
"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
(function () {
  'use strict';

  a3_pilot_reports.factory('GroundDutyFactory', GroundDutyFactory);
  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name GroundDutyFactory
  * @description 
  * Add, Update and Get Ground Duties.
  * @ngInject
  */
  function GroundDutyFactory(GenericService, $http, apiUrl) {
    /**
    * Initialize the GroundDuty
    * @memberof GroundDutyFactory
    */
    function GroundDuty() {
      this.Id = null;
      this.Duty = null;
      this.DutyDescription = null;
      this.DutyBegin = null;
      this.DutyEnd = null;
      this.GetId = GetId;
      this.isTraining = false;
      this.icon = null;
      this.Instructors = new Array();
      this.Trainees = new Array();
      this.isManualEntry = false;
      this.hasPendingCourse = false;
    }
    var objType = 'groundDuty';
    var objCallback = GroundDuty;
    var service = {
      getGroundDutiesFromStorage: getGroundDutiesFromStorage,
      setGroundDutiesToStorage: setGroundDutiesToStorage,
      getGroundDutyFromStorage: getGroundDutyFromStorage,
      getGroundDutiesByDutyNo: getGroundDutiesByDutyNo,
      mergeGroundDutyInfo: mergeGroundDutyInfo,
      updateGroundDuty: updateGroundDuty,
      getGroundDutyActiveCourses: getGroundDutyActiveCourses,
      setCourseCompleted: setCourseCompleted,
      setCoursePending: setCoursePending,
      mergeGroundDutiesToStorage: mergeGroundDutiesToStorage,
      refresh: refresh,
      addGroundDuty: addGroundDuty,
      removeGroundDuty: removeGroundDuty,
      getManualGroundDutiesFromStorage: getManualGroundDutiesFromStorage,
      getFirstAndLastDateOfGroundDuties: getFirstAndLastDateOfGroundDuties
    };

    //object functions
    /**
     * Overide default get Id
     * @memberof GroundDutyFactory
     * @returns {number} Id 
     */
    function GetId() {
      return this.Id;
    }
    /**
     * Get Ground Duties.
     * @memberof GroundDutyFactory
     * @returns {Array} GroundDuties 
     */
    function getGroundDutiesFromStorage() {
      return GenericService.list(objType, objCallback);
    }
    /**
     * Get GroundDuty from storage groundDuties
     * @memberof GroundDutyFactory
     * @param {number} groundDutyId 
     * @return {object} groundDuty
     */
    function getGroundDutyFromStorage(groundDutyId) {
      var groundDuty = GenericService.get(groundDutyId, objType, objCallback);
      var instructors = [];
      var trainees = [];
      if (groundDuty != null && groundDuty != undefined) {
        //only training
        if (groundDuty.RelatedGroundDuties && groundDuty.RelatedGroundDuties.length > 1) {
          groundDuty.isTraining = true;
          groundDuty.RelatedGroundDuties.forEach(function (element) {
            if (element.IsInstructor) {
              instructors.push(element);
            } else {
              trainees.push(element);
            }
          });
          groundDuty.Trainees = trainees;
          groundDuty.Instructors = instructors;
        }
      }
      return groundDuty;
    }

    /**
     * Save Ground Duties to storage
     * @memberof GroundDutyFactory
     * @param {Array} GroundDuties A list of Ground Duties
     */
    function setGroundDutiesToStorage(objList) {
      GenericService.saveAll(objList, objType);
    }

    /**
    * Get GroundDuties of a Crew Route
    * @memberof GroundDutyFactory
    * @param {number} dutyNo 
    * @param {string} dutyDay
    * @return {array} groundDuties
    */
    function getGroundDutiesByDutyNo(dutyNo, dutyDay) {
      var groundDuties = getGroundDutiesFromStorage();
      if (groundDuties == null) return [];
      var result = [];
      var instructors = [];
      var trainees = [];
      var arrayLength = groundDuties.length;
      for (var i = 0; i < arrayLength; i++) {
        if (groundDuties[i].DutyNo == dutyNo && groundDuties[i].DutyDay == dutyDay) {
          //only training
          if (groundDuties[i].RelatedGroundDuties && groundDuties[i].RelatedGroundDuties.length > 1) {
            groundDuties[i].isTraining = true;
            instructors = [];
            trainees = [];
            groundDuties[i].RelatedGroundDuties.forEach(function (element) {
              if (element.IsInstructor) {
                instructors.push(element);
              } else {
                trainees.push(element);
              }
            });
            groundDuties[i].Trainees = trainees;
            groundDuties[i].Instructors = instructors;
          }
          result.push(groundDuties[i]);
        }
      }
      return result;
    }

    /**
    * Merge new info to current Ground Duty
    * @memberof GroundDutyFactory
    * @param {object} duty 
    */
    function mergeGroundDutyInfo(duty) {
      var currentGroundDutyInfo = GenericService.get(duty.Id, objType, objCallback);
      currentGroundDutyInfo.Code = duty.Code;
      currentGroundDutyInfo.Description = duty.Description;
      currentGroundDutyInfo.DutyDate = duty.DutyDate;
      currentGroundDutyInfo.GroundDutyNo = duty.GroundDutyNo;
      currentGroundDutyInfo.DutyDateS = duty.DutyDateS;
      currentGroundDutyInfo.DutyBegin = duty.DutyBegin;
      currentGroundDutyInfo.DutyEnd = duty.DutyEnd;
      currentGroundDutyInfo.DutyDay = duty.DutyDay;
      currentGroundDutyInfo.DutyNo = duty.DutyNo;
      currentGroundDutyInfo.Route = duty.Route;
      if (currentGroundDutyInfo.RelatedGroundDuties && currentGroundDutyInfo.RelatedGroundDuties.length) {
        currentGroundDutyInfo.RelatedGroundDuties = duty.RelatedGroundDuties;
      }
      GenericService.save(currentGroundDutyInfo, objType, objCallback);
    }
    function updateGroundDuty(groundDuty) {
      GenericService.save(groundDuty, objType, objCallback);
    }
    function addGroundDuty(groundDuty) {
      var storedGroundDuty = GenericService.get(groundDuty.Id, objType, objCallback);
      if (!storedGroundDuty) {
        GenericService.add(groundDuty, objType, objCallback);
      } else {
        updateGroundDuty(groundDuty);
      }
    }
    function removeGroundDuty(groundDuty) {
      GenericService.remove(groundDuty, objType, objCallback);
    }
    function setCourseCompleted(dutyId, courseId) {
      var groundDuty = GenericService.get(dutyId, objType, objCallback);

      // Parse courseId if it contains an underscore.
      var simpleCourseId = courseId;
      var phaseId = null;
      if (courseId.indexOf('_') > -1) {
        var parts = courseId.split('_');
        simpleCourseId = parts[0];
        phaseId = parts[1];
      }
      if (groundDuty.RelatedGroundDuties && groundDuty.RelatedGroundDuties.length > 0) {
        groundDuty.RelatedGroundDuties.forEach(function (relatedDuty) {
          if (relatedDuty.Courses && relatedDuty.Courses.length > 0) {
            var matchingCourse;
            if (phaseId) {
              matchingCourse = relatedDuty.Courses.find(function (course) {
                return course.CourseId == simpleCourseId && course.PhaseId == phaseId;
              });
            } else {
              matchingCourse = relatedDuty.Courses.find(function (course) {
                return course.CourseId == simpleCourseId;
              });
            }
            if (matchingCourse) {
              matchingCourse.Status = "Completed";
            }
          }
        });
      }
      // groundDuty.RelatedGroundDuties.filter(x=>x.Courses).forEach(function(item){
      //     var groundDutyCourse =  item.Courses.find(x=>x.CourseId == courseId);
      //     if(groundDutyCourse)  groundDutyCourse.Status = "Completed";
      // });

      var allCoursesAreCompleted = false;
      if (groundDuty.RelatedGroundDuties && groundDuty.RelatedGroundDuties.length > 0) {
        allCoursesAreCompleted = groundDuty.RelatedGroundDuties.filter(function (x) {
          return x.Courses && x.Courses.length > 0;
        }).every(function (relatedDuty) {
          return relatedDuty.Courses.every(function (course) {
            return course.Status == "Completed";
          });
        });
      }
      if (groundDuty.isManualEntry && allCoursesAreCompleted) {
        groundDuty.hasPendingCourse = false;
      }
      updateGroundDuty(groundDuty);
    }
    function setCoursePending(dutyId, courseId) {
      var groundDuty = GenericService.get(dutyId, objType, objCallback);
      groundDuty.RelatedGroundDuties.filter(function (x) {
        return x.Courses;
      }).forEach(function (item) {
        var groundDutyCourse = item.Courses.find(function (x) {
          return x.CourseId == courseId;
        });
        if (groundDutyCourse) groundDutyCourse.Status = "Pending";
      });
      updateGroundDuty(groundDuty);
    }
    function getGroundDutyActiveCourses(groundDutyId) {
      var groundDuty = GenericService.get(groundDutyId, objType, objCallback);
      var courses = [];
      if (groundDuty != null && groundDuty != undefined) {
        if (groundDuty.RelatedGroundDuties && groundDuty.RelatedGroundDuties.length > 1) {
          groundDuty.RelatedGroundDuties.filter(function (x) {
            return !x.IsInstructor && x.Courses;
          }).forEach(function (item) {
            courses.push.apply(courses, _toConsumableArray(item.Courses));
          });
        }
      }
      return courses;
    }

    /**Save Ground Duties to storage but keep local storage values
    * Necessary to maintain Absent values in training duties
    */
    function mergeGroundDutiesToStorage(objList, fromSync) {
      var groundDuties = getGroundDutiesFromStorage();
      if (!fromSync) {
        groundDuties.filter(function (x) {
          return x.isManualEntry;
        }).forEach(function (duty) {
          objList.push(duty);
        });
      }
      if (groundDuties) {
        objList.forEach(function (incomingDuty) {
          if (incomingDuty.RelatedGroundDuties) {
            var incomingTraineesFlat = [];
            incomingDuty.RelatedGroundDuties.filter(function (x) {
              return !x.IsInstructor;
            }).forEach(function (related) {
              related.CrewMembers.forEach(function (trainee) {
                incomingTraineesFlat.push(trainee);
              });
            });

            //Initialize all as present
            incomingTraineesFlat.forEach(function (incomingTrainee) {
              incomingTrainee.Absent = false;
            });

            //Copy Absent value from existing local storage duties
            var existingDuty = groundDuties.find(function (x) {
              return x.Id == incomingDuty.Id;
            });
            if (existingDuty && existingDuty.RelatedGroundDuties) {
              var existingTraineesFlat = [];
              existingDuty.RelatedGroundDuties.filter(function (x) {
                return !x.IsInstructor;
              }).forEach(function (related) {
                related.CrewMembers.forEach(function (trainee) {
                  existingTraineesFlat.push(trainee);
                });
              });
              incomingTraineesFlat.forEach(function (incomingTrainee) {
                var existingTrainee = existingTraineesFlat.find(function (x) {
                  return x.Id == incomingTrainee.Id;
                });
                if (existingTrainee) {
                  incomingTrainee.Absent = existingTrainee.Absent;
                }
              });
            }
          }
        });
      }
      GenericService.saveAll(objList, objType);
    }
    function refresh(refreshGroundDuty, callback) {
      return $http.post(apiUrl + '/GroundDuty/Refresh', refreshGroundDuty, {
        'Content-Type': 'application/json'
      }).then(callback);
    }

    /**Get manual Ground Duties from storage*/
    function getManualGroundDutiesFromStorage() {
      var groundDuties = getGroundDutiesFromStorage();
      return groundDuties.filter(function (x) {
        return x.isManualEntry;
      });
    }
    function getFirstAndLastDateOfGroundDuties() {
      var groundDuties = getGroundDutiesFromStorage();
      var parseDate = function parseDate(dateString) {
        return new Date(dateString);
      };
      var firstDutyDate = null;
      var lastDutyDate = null;
      var _iterator = _createForOfIteratorHelper(groundDuties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var obj = _step.value;
          var currentDate = parseDate(obj.DutyDate);
          if (!firstDutyDate || currentDate < firstDutyDate) {
            firstDutyDate = currentDate;
          }
          if (!lastDutyDate || currentDate > lastDutyDate) {
            lastDutyDate = currentDate;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return {
        firstDate: firstDutyDate,
        lastDate: lastDutyDate
      };
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('PastDutyFactory', PastDutyFactory);
  /**
  * @memberof CabinReports
  * @ngdoc factory
  * @name PastDutyFactory
  * @description 
  * Get Past Duties.
  * @ngInject
  */
  function PastDutyFactory($http, apiUrl) {
    var service = {
      getPastDuties: getPastDuties
    };
    function getPastDuties(selectedDate, callback) {
      return $http.get(apiUrl + '/Training/GetPastDuties?specificDutyDate=' + selectedDate, {
        'Content-Type': 'application/json'
      })["catch"](callback);
    }

    // function getPastDuties(selectedDate, callback) {
    //     return $http.get(apiUrl + '/Training/GetPastDuties/', { 'Content-Type': 'application/json' })
    //     .catch(callback);         
    // } 
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('annualLeavesSummary', annualLeavesSummary);
  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name annualLeavesSummary
  * @restrict E
  * @description
  *    Implementation of annual Leaves Summary
  * @example
  *   Usage:
  *   <annual-leaves-summary></annual-leaves-summary>
  * @ngInject
  */
  function annualLeavesSummary(AnnualLeavesFactory) {
    function link($scope, element, attrs) {
      $scope.showAnnualLeavesSummary = false;
      var annualLeavesInfo = AnnualLeavesFactory.getAnnualLeavesToStorage();
      if (annualLeavesInfo && annualLeavesInfo.length > 0) {
        $scope.showAnnualLeavesSummary = true;
        $scope.annualLeaves = groupAnnualLeavesByType(annualLeavesInfo);
      }
      function groupAnnualLeavesByType(annualLeavesInfo) {
        var groupedLeaves = [];
        annualLeavesInfo = annualLeavesInfo.sort(function (a, b) {
          return b.Date < a.Date ? 1 : -1;
        });
        for (var i = 0; i < annualLeavesInfo.length; i++) {
          var previousGroup = groupedLeaves[groupedLeaves.length - 1];
          if (i != 0 && previousGroup.type == annualLeavesInfo[i].Type && new Date(annualLeavesInfo[i].Date) - new Date(previousGroup.dates[previousGroup.dates.length - 1]) === 86400000) {
            previousGroup.dates.push(annualLeavesInfo[i].Date);
          } else {
            var item = {
              type: annualLeavesInfo[i].Type,
              dates: []
            };
            item.dates.push(annualLeavesInfo[i].Date);
            groupedLeaves.push(item);
          }
        }
        return groupedLeaves;
      }
    }
    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/LeaveRequest/annual-leaves-summary.tpl.html',
      scope: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('AnnualLeavesFactory', AnnualLeavesFactory);

  /**
   * @memberof PilotReports
   * @ngdoc factory
   * @name AnnualLeavesFactory
   * @description 
   *    Get Annual Leaves Data 
   * @ngInject
   */
  function AnnualLeavesFactory(GenericService, $http, apiUrl) {
    /**
     * Initialize the AnnualLeaves
     * @memberof CheckInFactory
     */
    function AnnualLeaves() {}
    var objType = 'AnnualLeaves';
    var objCallback = AnnualLeaves;
    var service = {
      setAnnualLeavesToStorage: setAnnualLeavesToStorage,
      getAnnualLeavesToStorage: getAnnualLeavesToStorage
    };

    /**
    * Save Annual Leaves
    * @param {array} annualLeavesInInfo 
    */
    function setAnnualLeavesToStorage(annualLeavesInInfo) {
      if (annualLeavesInInfo == undefined || annualLeavesInInfo == null) {
        GenericService.removeAll(objType);
      } else {
        GenericService.saveAll(annualLeavesInInfo, objType, objCallback);
      }
    }

    /**
    * Gets annual leaves
    * @returns {annualLeavesObj} annualLeavesObj
    */
    /**
     * Get annual leaves
     */
    function getAnnualLeavesToStorage() {
      return GenericService.list(objType, objCallback);
      ;
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('flexCombination', FlexCombination);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name FlexCombination
  * @restrict E
  * @description
  *   Implementation of Flex Combinations
  *
  *   Initialize the Flex Combination of a season
  * @example
  *   Usage:
  *   <flex-combination season-configuration="seasonConfiguration"  season-request="seasonRequest"></flex-combination>
  * @ngInject
  */
  function FlexCombination($timeout) {
    function link(scope, element, attrs) {
      angular.forEach(scope.seasonRequest.LeaveRequestPriorityPeriods, function (value, key) {
        var temp = value.MockLeaveRequestPrioritySlots;
        var temp2 = value.LeaveRequestPrioritySlots;
        $timeout(function () {
          value.MockLeaveRequestPrioritySlots = angular.fromJson(temp);
          value.LeaveRequestPrioritySlots = angular.fromJson(temp2);
        });
      });
      scope.sortableOptions = {
        handle: '>.row .myHandle',
        update: function update(e, ui) {},
        stop: function stop(e, ui) {
          for (var i = 0; i < scope.seasonRequest.LeaveRequestPriorityPeriods.length; i++) {
            sortSetupOrderNo(scope.seasonRequest.LeaveRequestPriorityPeriods[i]);
          }
        }
      };
      scope.setupOrderNo = setupOrderNo;
      function sortSetupOrderNo(period) {
        if (Array.isArray(period.LeaveRequestPrioritySlots)) {
          for (var i = 0; i < period.LeaveRequestPrioritySlots.length; i++) {
            period.LeaveRequestPrioritySlots[i].OrderNo = i + 1;
          }
        }
      }
      ;
      function setupOrderNo(period) {
        if (Array.isArray(period.MockLeaveRequestPrioritySlots)) {
          period.LeaveRequestPrioritySlots = [];
          for (var i = 0; i < period.MockLeaveRequestPrioritySlots.length; i++) {
            var temp = Object.assign({}, period.MockLeaveRequestPrioritySlots[i]);
            temp.OrderNo = i + 1;
            period.LeaveRequestPrioritySlots.push(temp);
          }
        }
      }
      ;
      scope.removeSlot = removeSlot;
      function removeSlot(slotIndex, period) {
        period.LeaveRequestPrioritySlotsHelper = [];
        for (var i = 0; i < period.LeaveRequestPrioritySlots.length; i++) {
          if (i != slotIndex) {
            period.LeaveRequestPrioritySlotsHelper.push(period.LeaveRequestPrioritySlots[i]);
          }
        }
        period.LeaveRequestPrioritySlots = period.LeaveRequestPrioritySlotsHelper;
        period.MockLeaveRequestPrioritySlots = period.LeaveRequestPrioritySlotsHelper;
        setupOrderNo(period);
      }
    }
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/LeaveRequest/flexCombinations.tpl.html',
      scope: {
        seasonConfiguration: '<',
        seasonRequest: '=',
        editable: '<'
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('LeaveRequestCtrl', LeaveRequestCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name LeaveRequestCtrl
  * @description 
  *   View Leave Request Tool
  * @ngInject
  */
  function LeaveRequestCtrl($route, $scope, $filter, LeaveRequestFactory, $uibModal, $timeout) {
    $scope.state = 'leaveRequest';
    $scope.getRandomBorderColor = getRandomBorderColor;
    $scope.getRandomTextColor = getRandomTextColor;
    $scope.IsValidLeaveRequest = IsValidLeaveRequest;
    $scope.showHelp = showHelp;
    $scope.showSuccessLeaveApplicationMessage = false;
    $scope.hasErrors = false;
    progressBarBox(true);
    LeaveRequestFactory.getConfigurationDetails(function (responseData) {
      $scope.QualificationGroup = responseData.data.data.QualificationGroup;
      $scope.LeaveRequestInformation = responseData.data.data.LeaveRequestInformation;
      $scope.QualificationGroup.RequestLessDays = $scope.QualificationGroup.RequestLessDays ? $scope.QualificationGroup.RequestLessDays : false;
      $scope.QualificationGroup.RequestNoLeave = $scope.QualificationGroup.RequestNoLeave ? $scope.QualificationGroup.RequestNoLeave : false;
      if (responseData.data && responseData.data.data && responseData.data.data.QualificationGroup && responseData.data.data.LeaveRequestInformation) {
        //TEST
        //$scope.LeaveRequestInformation.GroupStatus = "PROCESS";

        $scope.closeDateStr = moment($scope.LeaveRequestInformation.CloseDate).format('Do of MMMM');
        $scope.isOpen = $scope.LeaveRequestInformation.GroupStatus == "OPEN";
        $scope.LeaveRequest = {
          YearId: $scope.LeaveRequestInformation.YearId,
          MemberId: $scope.LeaveRequestInformation.MemberId,
          RequestNoleave: responseData.data.data.LeaveRequest ? responseData.data.data.LeaveRequest.RequestNoleave : false,
          // Default: Request Leave selected
          LeaveRequestSeasons: []
        };
        if (responseData.data.data.LeaveRequest) {
          $scope.showSuccessLeaveApplicationMessage = true;
        }
        if (responseData.data.data.LeaveRequest && !responseData.data.data.LeaveRequest.RequestNoleave) {
          mergeRequest(responseData.data.data.LeaveRequest, $scope.QualificationGroup.Seasons);
        } else {
          initializeNewRequest($scope.QualificationGroup.Seasons);
          //Temporary: Hide Instructions
          //if($scope.isOpen) $timeout(showHelp,500);
        }
      } else {
        $scope.hasErrors = true;
      }
      progressBarBox(false);
    }, function (data) {
      $scope.hasErrors = true;
      progressBarBox(false);
    });
    function mergeRequest(leaveRequest, seasons) {
      $scope.LeaveRequest = leaveRequest;
      for (var j = 0; j < leaveRequest.LeaveRequestSeasons.length; j++) {
        leaveRequest.LeaveRequestSeasons[j].HasSpecificCombinations = $filter('filter')(leaveRequest.LeaveRequestSeasons[j].LeaveRequestPriorities, {
          Type: 'All'
        }).length > 0;
        for (var i = 0; i < seasons.length; i++) {
          if (seasons[i].Id == leaveRequest.LeaveRequestSeasons[j].SeasonId) {
            leaveRequest.LeaveRequestSeasons[j].StartDate = seasons[i].StartDate;
            leaveRequest.LeaveRequestSeasons[j].EndDate = seasons[i].EndDate;
            leaveRequest.LeaveRequestSeasons[j].Slots = seasons[i].Slots;
            leaveRequest.LeaveRequestSeasons[j].Configurations = seasons[i].Configurations;
            setupMockLeaveRequestPriorities(leaveRequest.LeaveRequestSeasons[j].LeaveRequestPriorities, seasons[i].Slots);
            for (var h = 0; h < seasons[i].Configurations.length; h++) {
              if (seasons[i].Configurations[h].Id == leaveRequest.LeaveRequestSeasons[j].ConfigurationId) {
                leaveRequest.LeaveRequestSeasons[j].Configuration = seasons[i].Configurations[h];
              }
            }
          }
        }
      }
      $scope.LeaveRequest = leaveRequest;
    }
    function setupMockLeaveRequestPriorities(priorities, slots) {
      for (var i = 0; i < priorities.length; i++) {
        for (var j = 0; j < priorities[i].LeaveRequestPriorityPeriods.length; j++) {
          for (var h = 0; h < priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots.length; h++) {
            var tempOrderNo = priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots[h].OrderNo;
            //need clone the priority slot to fix conflicts with onder numbers
            priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots[h] = JSON.parse(JSON.stringify(findSlot(priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots[h], slots)));
            if (priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots[h]) {
              priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots[h].OrderNo = tempOrderNo;
            }
          }
          //need clone the priority slot to fix conflicts with onder numbers
          priorities[i].LeaveRequestPriorityPeriods[j].MockLeaveRequestPrioritySlots = JSON.parse(JSON.stringify(priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots));
        }
      }
    }
    function findSlot(value, slots) {
      var temp = null;
      for (var i = 0; i < slots.length; i++) {
        if (slots[i].Id == value.Id) {
          temp = slots[i];
        }
      }
      return temp;
    }
    function showHelp() {
      $uibModal.open({
        templateUrl: 'views/LeaveRequest/dlgLeaveRequestInstructions.html',
        controller: 'LeaveRequestInstructionsCtrl',
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
        resolve: {}
      });
    }
    function initializeNewRequest(seasons) {
      for (var i = 0; i < seasons.length; i++) {
        var leaveRequestSeason = seasons[i];
        leaveRequestSeason.SeasonId = leaveRequestSeason.Id;
        var flexLeaveRequestPriority = {
          Type: "Any",
          Priority: 1000,
          LeaveRequestPriorityPeriods: []
        };
        var configurationDays = [];
        for (var j = 0; j < seasons[i].Configurations.length; j++) {
          configurationDays.push(seasons[i].Configurations[j].Days);
        }
        leaveRequestSeason.Days = configurationDays.unique();
        leaveRequestSeason.HasSpecificCombinations = false;
        leaveRequestSeason.LeaveRequestPriorities = [flexLeaveRequestPriority];
        $scope.LeaveRequest.LeaveRequestSeasons.push(leaveRequestSeason);
      }
    }
    function IsValidLeaveRequest() {
      var isValid = true;
      if (!$scope.LeaveRequest.RequestNoleave) {
        //Validate only if Requested Leave
        if ($scope.LeaveRequest && !$scope.invalidSelectedLeaveDays) {
          for (var i = 0; i < $scope.LeaveRequest.LeaveRequestSeasons.length; i++) {
            for (var j = 0; j < $scope.LeaveRequest.LeaveRequestSeasons[i].LeaveRequestPriorities.length; j++) {
              if ($scope.LeaveRequest.LeaveRequestSeasons[i].LeaveRequestPriorities[j].HasInvalidPeriod) {
                isValid = false;
                break;
              }
            }
            if (!$scope.LeaveRequest.LeaveRequestSeasons[i].Configuration) {
              isValid = false;
              break;
            }
          }
        } else {
          isValid = false;
        }
      }
      return isValid;
    }
    $scope.updateLeaveRequestSeason = updateLeaveRequestSeason;
    $scope.showCombo = false;
    $scope.radioConfigurationModel = null;
    $scope.sendRequest = sendRequest;
    $scope.addComment = addComment;
    function addComment(request) {
      request.Comments = " ";
    }
    function sendRequest() {
      //Request No Leave: Clear any selected values
      if ($scope.LeaveRequest.RequestNoleave) {
        $scope.LeaveRequest.LeaveRequestSeasons = [];
      }
      progressBarBox(true);
      LeaveRequestFactory.saveLeaveRequest($scope.LeaveRequest, onSuccessSendRequest, onErrorSendRequest);
    }
    function onSuccessSendRequest(data) {
      progressBarBox(false);
      if (data.data.success == true) {
        ShowSuccessMessage();
      } else {
        ShowErrorMessage();
      }
    }
    function onErrorSendRequest(data) {
      progressBarBox(false);
      ShowErrorMessage();
    }
    function ShowSuccessMessage() {
      var closeDateStr = moment($scope.LeaveRequestInformation.CloseDate).format('Do of MMMM');
      bootbox.alert({
        title: "<div class='text-green'>Success</div>",
        message: "You have successfully submitted your leave request. You can modify your leave request untill the " + closeDateStr + ".",
        callback: function callback() {
          $route.reload();
        }
      });
    }
    function ShowErrorMessage() {
      bootbox.alert({
        title: "<div class='text-red'>Error</div>",
        message: "Failed to send your leave request. Please try again later",
        callback: function callback() {
          $route.reload();
        }
      });
    }
    function progressBarBox(isOpen) {
      if (isOpen) {
        bootbox.dialog({
          closeButton: false,
          message: '<div class="text-center"><i class="fa fa-spin fa-spinner"></i> Please wait...</div>'
          //title: "Please wait..."
        });
      } else {
        bootbox.hideAll();
      }
    }

    /*        function setupView() {
                if (!UserFactory.isLoggedIn()) {
                    $location.path("/login");
                }*/

    //$scope.sortableOptions['ui-floating'] = true;

    function updateLeaveRequestSeason(season) {
      season.ConfigurationId = season.Configuration.Id;
      for (var i = 0; i < season.LeaveRequestPriorities.length; i++) {
        for (var j = 0; j < season.Configuration.Periods.length; j++) {
          season.Configuration.Periods[j].ConfigurationPeriodId = season.Configuration.Periods[j].Id;
        }
        season.LeaveRequestPriorities[i].LeaveRequestPriorityPeriods = JSON.parse(JSON.stringify(season.Configuration.Periods));
      }
      var totalDays = 0;
      var hasConfig = true;
      for (var i = 0; i < $scope.LeaveRequest.LeaveRequestSeasons.length; i++) {
        totalDays = totalDays + ($scope.LeaveRequest.LeaveRequestSeasons[i].Configuration && $scope.LeaveRequest.LeaveRequestSeasons[i].Configuration.Days ? $scope.LeaveRequest.LeaveRequestSeasons[i].Configuration.Days : 0);
        hasConfig = hasConfig && $scope.LeaveRequest.LeaveRequestSeasons[i].Configuration;
      }
      if (totalDays > $scope.LeaveRequestInformation.LeaveDays) {
        $scope.invalidSelectedLeaveDays = true;
        bootbox.alert("<h4 class='text-deep-orange'>Warning!</h4> You are entilted to <strong>" + $scope.LeaveRequestInformation.LeaveDays + " leave days </strong> but you have selected a combination of  <strong>" + totalDays + " days</strong>. Please proceed with the necessary changes.");
      } else if (!$scope.QualificationGroup.RequestLessDays && totalDays < $scope.LeaveRequestInformation.LeaveDays) {
        $scope.invalidSelectedLeaveDays = true;
        if (hasConfig) {
          bootbox.alert("<h4 class='text-deep-orange'>Warning!</h4> You are entilted to <strong>" + $scope.LeaveRequestInformation.LeaveDays + " leave days </strong> but you have selected a combination of  <strong>" + totalDays + " days</strong>. Please proceed with the necessary changes.");
        }
      } else {
        $scope.invalidSelectedLeaveDays = false;
      }
    }
    function getRandomBorderColor(season) {
      var cssClass = "border-left-green";
      if (!season.Configuration) {
        cssClass = "border-left-orange";
      }
      return cssClass;
    }
    function getRandomTextColor(season) {
      var cssClass = "text-green";
      if (!season.Configuration) {
        cssClass = "text-orange";
      }
      return cssClass;
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('LeaveRequestFactory', LeaveRequestFactory);

  /**
   * @memberof PilotReports
   * @ngdoc factory
   * @name LeaveRequestFactory
   * @description 
   *    Get Leave Request Configuration Data and submit new Leave Request
   * @ngInject
   */
  function LeaveRequestFactory(GenericService, $http, $q, apiUrl) {
    var service = {
      getConfigurationDetails: getConfigurationDetails,
      saveLeaveRequestInformation: saveLeaveRequestInformation,
      getLeaveRequestInformation: getLeaveRequestInformation,
      saveLeaveRequest: saveLeaveRequest
    };

    /**
    * Initialize the LeaveRequestInformation
    * @memberof LeaveRequestFactory
    */
    function LeaveRequestInformation() {}
    var objType = 'LeaveRequestInformation';
    var objCallback = LeaveRequestInformation;
    var leaveRequestApiURL = apiUrl + '/LeaveRequest';

    /**
     * Get the LeaveRequestInformation and the qualification Group
     * @memberof LeaveRequestFactory
     * @param {function} callback  an on success callback function
     * @param {function} errorCallback  an on error callback function
     */
    function getConfigurationDetails(callback, errorCallback) {
      return $http.get(leaveRequestApiURL, {
        'Content-Type': 'application/json'
      }).then(function (responseData) {
        if (responseData && responseData.data && responseData.data.data && responseData.data.data.LeaveRequestInformation) {
          saveLeaveRequestInformation(responseData.data.data.LeaveRequestInformation);
        }
        callback(responseData);
      })["catch"](errorCallback);
    }
    function saveLeaveRequest(request, callback, errorCallback) {
      var cleanRequest = angular.toJson(request);
      return $http.post(leaveRequestApiURL, cleanRequest, {
        'Content-Type': 'application/json'
      }).then(function (responseData) {
        if (responseData && responseData.data && responseData.data.data && responseData.data.data.LeaveRequestInformation) {
          saveLeaveRequestInformation(responseData.data.data.LeaveRequestInformation);
        }
        console.log(request);
        callback(responseData);
      })["catch"](errorCallback);
    }
    /**
     * Save the leave Request Information  Object in local storage
     * @memberof LeaveRequestFactory
     * @param {object} leaveRequestInformation  a leaveRequestInformation
     */
    function saveLeaveRequestInformation(leaveRequestInformation) {
      GenericService.saveOne(leaveRequestInformation, objType, objCallback);
    }

    /**
     * Save the leave Request Information  Object in local storage
     * @memberof LeaveRequestFactory     
     * @returns {object} leaveRequestInformation  
     */
    function getLeaveRequestInformation() {
      return GenericService.getOne(objType, objCallback);
    }

    /*      function postProposal(proposal){
              return $http.post(apiUrl + '/bucket/PostProposal/', proposal, { 'Content-Type' : 'application/json' });
          }
       */

    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('LeaveRequestInstructionsCtrl', LeaveRequestInstructionsCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name LeaveRequestInstructionsCtrl
  * @description 
  *   Get the Leave Request Instructions
  * @ngInject
  */
  function LeaveRequestInstructionsCtrl($scope, $uibModalInstance) {
    $scope.page = 1;
    $scope.cancel = cancel;
    $scope.nextPage = nextPage;
    $scope.previousPage = previousPage;
    $scope.instructionPages = 3;

    /**
     * Goes to the next page of  leave instructions
     * @memberof LeaveRequestInstructionsCtrl
     */
    function nextPage() {
      $scope.page = $scope.page + 1;
      normalizePage();
    }

    /**
    * Goes to the previous page of leave instructions
    * @memberof LeaveRequestInstructionsCtrl
    */
    function previousPage() {
      $scope.page = $scope.page - 1;
      normalizePage();
    }

    /**
     * Normalize the page number if it is out of range
     * @memberof LeaveRequestInstructionsCtrl
     */
    function normalizePage() {
      if ($scope.page > $scope.instructionPages || $scope.page < 1) {
        $scope.page = 1;
      }
    }
    /**
     * Close the modal
     * @memberof LeaveRequestInstructionsCtrl
     */
    function cancel() {
      $uibModalInstance.close('close');
    }
    ;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('specificCombinations', SpecificCombinations);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name SpecificCombinations
  * @restrict E
  * @description
  *   Implementation of Specific Combinations
  *
  *   Initialize the Specific Combinations of a season
  * @example
  *   Usage:
  *   <specific-combinations season-configuration="seasonConfiguration"  season-requests="seasonRequests"></specific-combinations>
  * @ngInject
  */
  function SpecificCombinations($filter) {
    function link(scope, element, attrs) {
      scope.IsEditEnabled = false;
      scope.selectEditablePeriod = selectEditablePeriod;
      scope.updateEditablePeriod = updateEditablePeriod;
      scope.removeSpecificCombination = removeSpecificCombination;
      scope.addNewSpecificCombination = addNewSpecificCombination;
      scope.getBorderClass = getBorderClass;
      scope.selectedSlotTemp = null;
      scope.isDisabled = isDisabled;
      scope.specificCombinations = $filter('filter')(scope.seasonRequests, {
        Type: 'All'
      });
      scope.sortableOptions = {
        handle: '> .row .myHandle',
        update: function update(e, ui) {},
        stop: function stop(e, ui) {
          recalculatePriorities();
        }
      };
      function recalculatePriorities() {
        for (var i = 0; i < scope.specificCombinations.length; i++) {
          scope.specificCombinations[i].Priority = i + 1;
        }
      }
      function selectEditablePeriod(period, request) {
        if (!period.isEditable) {
          resetEditablePeriods();
          if (period.LeaveRequestPrioritySlots && period.LeaveRequestPrioritySlots.length > 0) {
            scope.selectedSlotTemp = period.LeaveRequestPrioritySlots[0];
          } else {
            scope.selectedSlotTemp = null;
          }
          scope.selectedRequestTemp = request;
          scope.selectedSlotDaysTemp = period.Days;
          period.isEditable = true;
          scope.IsEditEnabled = true;
        } else {
          resetEditablePeriods();
        }
      }
      function getBorderClass(request) {
        var hasEmptyFields = false;
        var hasFilledFields = false;
        var cssClass = "";
        for (var i = 0; i < request.LeaveRequestPriorityPeriods.length; i++) {
          hasEmptyFields = hasEmptyFields || !request.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots || request.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots.length == 0;
          hasFilledFields = hasFilledFields || !(!request.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots || request.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots.length == 0);
        }
        if (hasEmptyFields && hasFilledFields) {
          cssClass = 'specific-combination-orange';
          request.HasInvalidPeriod = true;
        } else if (hasEmptyFields && !hasFilledFields) {
          cssClass = 'specific-combination-blue';
          request.HasInvalidPeriod = false;
        } else if (hasFilledFields && !hasEmptyFields) {
          cssClass = 'specific-combination-green';
          request.HasInvalidPeriod = false;
        }
        return cssClass;
      }
      function isDisabled(slot) {
        var CSSclass = "";
        if (scope.selectedRequestTemp) {
          for (var i = 0; i < scope.selectedRequestTemp.LeaveRequestPriorityPeriods.length; i++) {
            if (scope.selectedRequestTemp.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots && scope.selectedRequestTemp.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots.length > 0 && (scope.selectedRequestTemp.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots[0].Id == slot.Id || scope.selectedRequestTemp.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots[0].EndDay >= slot.StartDay && scope.selectedRequestTemp.LeaveRequestPriorityPeriods[i].LeaveRequestPrioritySlots[0].StartDay <= slot.EndDay)) {
              CSSclass = "disabled";
              break;
            }
          }
        }
        return CSSclass;
      }
      function resetEditablePeriods() {
        for (var i = 0; i < scope.seasonRequests.length; i++) {
          for (var j = 0; j < scope.seasonRequests[i].LeaveRequestPriorityPeriods.length; j++) {
            scope.seasonRequests[i].LeaveRequestPriorityPeriods[j].isEditable = false;
          }
        }
        scope.IsEditEnabled = false;
      }
      function updateEditablePeriod(slot) {
        for (var i = 0; i < scope.seasonRequests.length; i++) {
          for (var j = 0; j < scope.seasonRequests[i].LeaveRequestPriorityPeriods.length; j++) {
            if (scope.seasonRequests[i].LeaveRequestPriorityPeriods[j].isEditable && slot && slot.Code) {
              scope.seasonRequests[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots = [slot];
            }
          }
        }
        resetEditablePeriods();
      }
      function removeSpecificCombination(priority) {
        var indexOfRemovedObj = null;
        for (var i = 0; i < scope.seasonRequests.length; i++) {
          if (scope.seasonRequests[i].Priority == priority) {
            indexOfRemovedObj = i;
          }
        }
        if (indexOfRemovedObj != null) {
          scope.seasonRequests.splice(indexOfRemovedObj, 1);
          scope.specificCombinations = $filter('filter')(scope.seasonRequests, {
            Type: 'All'
          });
          recalculatePriorities();
        }
      }
      function addNewSpecificCombination() {
        var newSpecificCombinationPriority = 1;
        if (scope.specificCombinations && scope.specificCombinations.length > 0) {
          newSpecificCombinationPriority = scope.specificCombinations.length + 1;
        }
        var newObj = {
          Type: "All",
          Priority: newSpecificCombinationPriority,
          LeaveRequestPriorityPeriods: []
        };
        scope.seasonRequests.push(newObj);
        updateLeaveRequestSeason();
        scope.specificCombinations = $filter('filter')(scope.seasonRequests, {
          Type: 'All'
        });
        scope.IsEditEnabled = false;
      }
      function updateLeaveRequestSeason() {
        scope.seasonConfiguration.ConfigurationId = scope.seasonConfiguration.Configuration.Id;
        for (var i = 0; i < scope.seasonRequests.length; i++) {
          for (var j = 0; j < scope.seasonConfiguration.Configuration.Periods.length; j++) {
            scope.seasonConfiguration.Configuration.Periods[j].ConfigurationPeriodId = scope.seasonConfiguration.Configuration.Periods[j].Id;
          }
          if (scope.seasonRequests[i].LeaveRequestPriorityPeriods && scope.seasonRequests[i].LeaveRequestPriorityPeriods.length == 0) {
            scope.seasonRequests[i].LeaveRequestPriorityPeriods = JSON.parse(JSON.stringify(scope.seasonConfiguration.Configuration.Periods));
          }
        }
      }
    }
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/LeaveRequest/specificCombinations.tpl.html',
      scope: {
        seasonConfiguration: '<',
        seasonRequests: '=',
        editable: '<'
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('encryptionInterceptor', encryptionInterceptor);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name httpHeaderInterceptor
  * @description 
  *  Add CrewToken on non login requests
  * @ngInject
  */
  function encryptionInterceptor($location, apiUrl) {
    return {
      request: function request(config) {
        if (config.url.includes("api")) {
          if (config.method === "POST" || config.method === "PUT") {
            var encryptedData = encrypt(config.data);
            console.log(encryptedData);
          } else if (config.method === "GET") {
            var absolutePath = config.url;
            var stringToHash = absolutePath.substring(absolutePath.lastIndexOf("/") + 1, absolutePath.length);
            var hash = (stringToHash + user.aimsId).getHash();
          }
        }
        return config;
      }
    };
  }
  function encrypt(data) {}
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.config(exceptionConfig);

  /**
  * @memberof PilotReports
  * @ngdoc config
  * @name exceptionConfig
  * @description 
  *   By default, AngularJS will catch errors and log them to
  *   the Console. We want to keep that behavior; however, we
  *   want to intercept it so that we can also log the errors
  *   to the server for later analysis.
  * @ngInject
  */
  function exceptionConfig($provide) {
    $provide.decorator('$exceptionHandler', extendExceptionHandler);
  }

  /**
  * @memberof exceptionConfig
  * @description 
  *   Override default exception handling and log errors 
  * @ngInject
  */
  function extendExceptionHandler($delegate, LogService) {
    return function (exception, cause) {
      $delegate(exception, cause);
      /**
       * Could add the error to a service's collection,
       * add errors to $rootScope, log errors to remote web server,
       * or log locally. Or throw hard. It is entirely up to you.
       * throw exception;
       */
      LogService.error(exception, cause);
    };
  }
})();
"use strict";

(function () {
  'use strict';

  //***************************************************************************//
  //************ Redirect HTTP401 to login page, examine json format on success
  //***************************************************************************//
  // register the interceptor as a service
  a3_pilot_reports.factory('http401interceptor', http401interceptor);

  /* @ngInject */
  function http401interceptor($q, $location, $log) {
    return {
      'response': function response(_response) {
        // do something on success
        //expecting specific object as a response: success:true/false,errorMessage:string,data:any not null object
        //var contentType=response.headers("content-type");
        var header = "";
        if (_response && _response.headers() && _response.headers("content-type")) header = _response.headers("content-type").substring(0, 16);
        if (header === "application/json") {
          var errorMessage = "";
          var isError = false;
          if (_response == null || _response.data == null || _response.data.success == null || _response.data.errorMessage == null || _response.data.data === 'undefined') {
            isError = true;
            errorMessage = "Server response not found";
          } else if (_response.data.success == false) {
            isError = true;
            errorMessage = _response.data.errorMessage;
          }
          if (isError) $q.reject(_response, errorMessage);
        }
        return _response || $q.when(_response);
      },
      // optional method
      'responseError': function responseError(rejection) {
        if (rejection.status === 401) {
          $log.error('Authorization failed. Need to login again');
          if ($location.path() != '/login') {
            $location.path('/login');
            //force refresh so that the browser will download any updates from the cache.manifest
            //without refresh, user may stick to an older version for ever
            setTimeout(function () {
              window.location.reload(true);
            }, 1000);
          }
          return $q.reject(rejection);
        } else {
          return $q.reject(rejection);
        }
      }
    };
  }
  ;
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('httpCrewTokenInterceptor', httpCrewTokenInterceptor);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name httpCrewTokenInterceptor
  * @description 
  *  Add CrewToken on non login requests
  * @ngInject
  */
  function httpCrewTokenInterceptor($location, $log, localStorageMD5Service, UserTokenFactory) {
    return {
      request: function request(config) {
        if ($location.$$url != "/login") {
          // get the user token
          var user = localStorageMD5Service.get('user');
          var token = '';
          if (user != null) token = user.token;
          config.headers['X-CrewToken'] = token;
        }
        return config;
      },
      response: function response(_response) {
        if (_response.headers()['content-type'] === "application/json; charset=utf-8") {
          var expiresAt = _response.headers()['x-expires-token'];
          var crewToken = _response.headers()['x-rolling-token'];
          if (expiresAt && crewToken) {
            var user = localStorageMD5Service.get('user');
            if (user != null) {
              user.token = crewToken;
              user.expires = expiresAt;
              localStorageMD5Service.set('user', user);
            }
            UserTokenFactory.setToken(crewToken);
          }
        }
        return _response;
      }
    };
  }
})();
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
(function () {
  'use strict';

  a3_pilot_reports.factory('httpHeaderInterceptor', httpHeaderInterceptor);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name httpHeaderInterceptor
  * @description 
  *  Add CrewToken on non login requests
  * @ngInject
  */
  function httpHeaderInterceptor($location, localStorageMD5Service, apiUrl) {
    return {
      request: function request(config) {
        if ($location.$$url != "/login") {
          if (config.url.includes("api")) {
            var user = localStorageMD5Service.get('user');
            var aimsIdToString = user.aimsId.toString();
            if (config.method === "POST" || config.method === "PUT") {
              var dataToHash = _typeof(config.data) === "object" ? angular.toJson(config.data) + aimsIdToString : config.data + aimsIdToString;
              var hash = dataToHash.getHash();
              config.headers['X-VCode'] = hash;
            } else if (config.method === "GET") {
              var absolutePath = config.url;
              var stringToHash = absolutePath.substring(absolutePath.lastIndexOf("/") + 1, absolutePath.length);
              var hash = (stringToHash + aimsIdToString).getHash();
              config.headers['X-VCode'] = hash;
            }
          }
        }
        return config;
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.config(httpProviderConfig);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name httpCrewTokenInterceptor
  * @description 
  *  Add CrewToken on non login requests
  * @ngInject
  */
  function httpProviderConfig($httpProvider) {
    $httpProvider.defaults.useXDomain = true;
    delete $httpProvider.defaults.headers.common['X-Requested-With'];
    $httpProvider.interceptors.push('http401interceptor');
    $httpProvider.interceptors.push('httpCrewTokenInterceptor');
    $httpProvider.interceptors.push('httpHeaderInterceptor');
    //$httpProvider.interceptors.push('encryptionInterceptor');
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.config(localStorageMD5Config);

  /**
  * @memberof PilotReports
  * @ngdoc config
  * @name localStorageMD5Config
  * @description 
  *   Config localStorageMD5ServiceProvider directly by using localStorageMD5ServiceProvider
  * @ngInject
  */
  function localStorageMD5Config(localStorageMD5ServiceProvider, localStorageServiceProvider) {
    //localStorageMD5ServiceProvider.help();
    var regx = /[?&]secure[&#]?/;
    if (regx.exec(window.location.href)) {
      console.log('*** SECURE MODE ***');
      localStorageServiceProvider.setStorageType('sessionStorage');
    }
    localStorageServiceProvider.setPrefix('a3.pilot.reports');
    localStorageServiceProvider.setStorageCookie(10, '/');
    localStorageMD5ServiceProvider.enableCompression();
  }
  ;
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory("LogService", LogService);

  /**
      * @memberof PilotReports
      * @ngdoc factory
      * @name LogService
      * @description 
      *  The error log service is our wrapper around the core error
      *  handling ability of AngularJS. Notice that we pass off to
      *  the native "$log" method and then handle our additional
      *  server-side logging.
      * @ngInject
      */
  function LogService($log, $injector, $window, apiUrl, UserTokenFactory, version) {
    var lastError = null;
    var acceptedTimeDiff = 5;
    function post(errorMessage, stackTrace, cause) {
      try {
        var $http = $injector.get("$http");
        /*// get the user token
        var user = UserFactory.getUser();
        var token = '';
        if (user != null)
        	token = user.token;*/
        var token = UserTokenFactory.getToken();
        // Log the JavaScript error to the server.
        // --
        // NOTE: In this demo, the POST URL doesn't
        // exists and will simply return a 404.
        $http({
          method: "POST",
          url: apiUrl + "/log",
          contentType: "application/json",
          data: {
            errorUrl: $window.location.href,
            errorMessage: version + " " + errorMessage,
            stackTrace: stackTrace,
            cause: cause || ""
          },
          beforeSend: function beforeSend(request) {
            request.setRequestHeader('X-CrewToken', token);
          }
        });
      } catch (loggingError) {
        // For Developers - log the log-failure.
        $log.warn("Error logging failed");
        $log.log(loggingError);
      }
    }
    ;
    function postFilter(errorMessage, stackTrace, cause) {
      if (lastError != null && lastError.errorDescr == errorMessage) {
        var timestampDiff = Date.now() - lastError.timestamp;
        var timeDiffInSec = timestampDiff / 1000;
        if (timeDiffInSec > acceptedTimeDiff) {
          lastError = {
            'errorDescr': errorMessage,
            'timestamp': Date.now()
          };
          post(errorMessage, stackTrace, cause);
        }
      } else {
        lastError = {
          'errorDescr': errorMessage,
          'timestamp': Date.now()
        };
        post(errorMessage, stackTrace, cause);
      }
    }
    ;
    return {
      debug: function debug(errorMessage, error) {
        if (error == null) {
          error = new Error();
        }
        if (errorMessage != null) {
          error.description = errorMessage;
        }
        post(error.description, error.stack, "");
      },
      error: function error(exception, cause) {
        // Pass off the error to the default error handler
        // on the AngualrJS logger. This will output the
        // error to the console (and let the application
        // keep running normally for the user).
        $log.error.apply($log, arguments);

        // Now, we need to try and log the error the server.
        // --
        // NOTE: In production, I have some debouncing
        // logic here to prevent the same client from
        // logging the same error over and over again! All
        // that would do is add noise to the log.
        var errorMessage = exception.toString();
        //var stackTrace = stacktraceService.print({ e: exception });
        //var stackTrace = $log.info({ e: exception });
        var stackTrace = exception.stack;
        postFilter(errorMessage, stackTrace, cause);
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('UserTokenFactory', UserTokenFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name UserTokenFactory
  * @description 
  *  Used to maintain the user token, outside the localStorage, in order to be accessible from the service which logs js errors
  * /(this service may not use localstorage provider)
  * @ngInject
  */
  function UserTokenFactory() {
    return {
      token: '',
      setToken: function setToken(value) {
        this.token = value;
      },
      getToken: function getToken() {
        return this.token;
      }
    };
  }
})();
"use strict";

// create guid
var guid = function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  return function () {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  };
}();

// generic sort function
var sort_by = function sort_by(field, reverse, primer) {
  var key = function key(x) {
    return primer ? primer(x[field]) : x[field];
  };
  return function (a, b) {
    var A = key(a),
      B = key(b);
    return (A < B ? -1 : A > B ? 1 : 0) * [-1, 1][+!!reverse];
  };
};
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('LoginCtrl', LoginCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name LoginCtrl
  * @description 
  *  Manages the login view
  * @ngInject
  */
  function LoginCtrl($location, $scope, localStorageMD5Service, UserFactory) {
    $scope.isSupported = isSupported;
    $scope.isSecure = UserFactory.isSecure();
    $scope.isLoggingIn = false;
    $scope.formData = {};
    $scope.goSecure = goSecure;
    $scope.errorName = "";

    //$('button').tooltip(); //show tooltips on buttons

    $scope.goNormal = goNormal;
    $scope.moreInfo = false; //used to show more info on the page

    $scope.toggleMoreInfo = toggleMoreInfo;
    $scope.processForm = processForm;
    $scope.resetDevice = resetDevice;
    $scope.resetUser = resetUser;
    $scope.loginFailedAttemps = UserFactory.getLoginFailedAttemps();

    /**
     * Informs you if local storage is supported 
     * @memberof LoginCtrl
     * @returns {boolean} isSupported
     */
    function isSupported() {
      return localStorageMD5Service.isSupported;
    }

    /**
     * Converts application to normal local storage mode 
     * @memberof LoginCtrl
     */
    function goNormal() {
      var path = window.location.href;
      path = path.replace('?secure', '');
      window.location = path;
      location.reload();
    }

    /**
     * Proccess login form and try to login
     * @memberof LoginCtrl
     */
    function goSecure() {
      var path = window.location.href;
      path = path + '?secure';
      window.location = path;
      location.reload();
    }

    /**
     * Show More info
     * @memberof LoginCtrl
     */
    function toggleMoreInfo() {
      $scope.moreInfo = !$scope.moreInfo;
    }

    /**
     * Proccess login form and try to login
     * @memberof LoginCtrl
     */
    function processForm() {
      $scope.loginFailedAttemps = UserFactory.getLoginFailedAttemps();
      if ($scope.loginFailedAttemps > 3) {
        localStorageMD5Service.remove('failedLoginAttemps');
        resetUser();
      } else {
        $scope.isLoggingIn = true;
        UserFactory.azlogin(afterLoginSuccess, afterLoginError, afterLoginFinal)["catch"](function (error) {
          afterLoginError();
        });
      }
    }
    ;

    /**
           * AfterLoginSuccess
           * @memberof LoginCtrl
           */
    function afterLoginSuccess() {
      // load main page
      $scope.isLoggingIn = false;
      $scope.errorName = "";
      $location.path("/");
    }

    /**
           * AfterLoginFinal
           * @memberof LoginCtrl
           */
    function afterLoginFinal(response) {
      $scope.isLoggingIn = false;
    }

    /**
           * AfterLoginError
           * @memberof LoginCtrl
           */
    function afterLoginError(response) {
      $scope.isLoggingIn = false;

      // display an error message
      if (response && response.status == 401) {
        if (response.data && response.data.Message) $scope.errorName = response.data.Message.length > 1 ? response.data.Message : "You are not authorized to use this CLS Pilot app | Message: " + response.data.Message;else $scope.errorName = "You are not authorized to use this CLS Pilot app";
      } else if (response && response.status == 404) {
        $scope.errorName = "Could not reach the remote server for authentication. Please connect to the Internet and try again.";
      } else {
        $scope.errorName = "An error occured during authentication. Please make sure you are connected to the Internet and try again.";
      }
      ;
    }

    /**
     * Redirect to reset view
     * @memberof LoginCtrl
     */
    function resetDevice() {
      $location.path("/reset");
    }

    /**
     * Sign out
     * @memberof LoginCtrl
     */
    function resetUser() {
      UserFactory.azSignOut();
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.service("PilotAPIService", PilotAPIService);

  /**
  * @memberof PilotReports
  * @ngdoc service
  * @name PilotAPIService
  * @description 
  *   Api login service
  * @ngInject
  */
  function PilotAPIService($http, $q, apiUrl) {
    return {
      /**
      * Login to Pilot Api
      * @memberof PilotAPIService
      * @param {number} username
      * @returns {string} password
      */
      login: function login(token) {
        var call = $q.defer();
        var bearer = "Bearer " + token;
        $http.post(apiUrl + '/login', {}, {
          'headers': {
            'Content-Type': 'application/json',
            'Authorization': bearer
          }
        }).then(function (responseData) {
          call.resolve(responseData);
        }, function (err) {
          call.reject(err);
        });
        return call.promise;
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('UserFactory', UserFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name UserFactory
  * @description 
  *   Add, Update, Delete and Get User.
  * @ngInject
  */
  function UserFactory(LogService, localStorageMD5Service, $http, apiUrl, PilotAPIService, DataCleanerFactory, GenericService, azureADAuth) {
    var msalConfig = {
      auth: azureADAuth,
      cache: {
        cacheLocation: "sessionStorage",
        // This configures where your cache will be stored
        storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
      }
    };

    var myMSALObj = new msal.PublicClientApplication(msalConfig);
    var username = null;
    myMSALObj.handleRedirectPromise().then(handleResponse)["catch"](function (error) {
      LogService.error(error, 'Failed to handle redirect Login');
    });
    function handleResponse(response) {
      if (response !== null) {
        username = response.account.username;
      } else {
        selectAccount();
      }
    }
    function selectAccount() {
      /**
       * See here for more info on account retrieval: 
       * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-common/docs/Accounts.md
       */
      var currentAccounts = myMSALObj.getAllAccounts();
      if (currentAccounts.length === 0) {
        return;
      } else if (currentAccounts.length > 0) {
        username = currentAccounts[0].username;
      }
    }

    /**
    * Initialize the User
    * @memberof UserFactory
    */
    function User() {
      this.id = null;
      this.aimsId = null;
      this.username = null;
      this.name = null;
      this.shortname = null;
      this.position = null;
      this.hashedPwd = null;
      this.token = null;
      this.syncDialogLastDt = null;
      this.getDescription = getDescription;
      this.tokenExtended = false;
    }
    var service = {
      getUser: getUser,
      setUser: setUser,
      isSecure: isSecure,
      isLoggedIn: isLoggedIn,
      clearActiveUser: clearActiveUser,
      setActiveUser: setActiveUser,
      login: login,
      extendToken: extendToken,
      azlogin: azlogin,
      azSignOut: azSignOut,
      getLoginFailedAttemps: getLoginFailedAttemps,
      newLoginFailedAttemp: newLoginFailedAttemp
    };
    var objType = 'user';
    var objCallback = User;

    //Object Functions
    function getDescription() {
      if (this.aimsid == null && this.name == null) return '-null-';else return (this.aimsid || '?') + ' - ' + (this.name || '?');
    }

    //Factory Functions
    /**
     * Get User 
     * @memberof UserFactory
     * @returns {Object} User
     */
    function getUser() {
      return GenericService.getOne(objType, objCallback);
    }

    /**
    * Save User 
    * @memberof UserFactory
    * @param {Object} User
    */
    function setUser(user) {
      GenericService.saveAll(user, objType, objCallback);
    }

    /**
     * Checks if local storage is on secure mode 
     * @memberof UserFactory
     * @param {boolean} isSecure
     */
    function isSecure() {
      return localStorageMD5Service.isSecure();
    }

    /**
     * Check if user exists and he has logged in
     * @memberof UserFactory
     * @param {boolean} isLoggedIn
     */
    function isLoggedIn() {
      var user = null;
      try {
        user = getUser();
        if (user != null) {
          var act = localStorageMD5Service.get('active');
          if (!act || !act.aimsId || act.aimsId != user.aimsId) {
            user = null;
          }
        } else user = null;
      } catch (e) {
        user = null;
      }
      return user;
    }

    /**
     * Clear Active User
     * @memberof UserFactory
     */
    function clearActiveUser() {
      localStorageMD5Service.remove('active');
    }

    /**
     * Save Active User 
     * @memberof UserFactory
     * @param {Object} User
     */
    function setActiveUser(user) {
      if (user != null && user.aimsId != null) {
        var value = {
          aimsId: user.aimsId
        };
        localStorageMD5Service.set('active', value);
      }
    }
    function azlogin(onsuccess, onerror, onfinally) {
      return new Promise(function (resolve, reject) {
        var loginRequest = {
          scopes: ["User.Read"]
        };
        var silentRequest = {
          scopes: ["openid", "profile", "User.Read"],
          redirectUri: "http://localhost:3000/blank.html"
        };
        if (username == null) {
          myMSALObj.loginRedirect(loginRequest);
          resolve(); // Resolve immediately for redirect scenario
        } else {
          silentRequest.account = myMSALObj.getAccountByUsername(username);
          var token = null;
          myMSALObj.acquireTokenSilent(silentRequest).then(function (tokenResponse) {
            if (!tokenResponse.idToken) {
              LogService.error('response.idToken is undefined');
              newLoginFailedAttemp(); // Run newLoginFailedAttemp() if idToken is undefined
              reject(new Error('Token is not available')); // Reject the promise
            } else {
              token = tokenResponse.idToken;
              localStorageMD5Service.remove('failedLoginAttemps');
              login(token, onsuccess, onerror, onfinally);
              resolve(); // Resolve after successful login
            }
          })["catch"](function (error) {
            if (error instanceof msal.InteractionRequiredAuthError) {
              LogService.error(error, 'Fallback to interaction when silent call fails');
              // Handle the redirection process error here if needed
              myMSALObj.acquireTokenRedirect(silentRequest).then(function () {
                // Continue with the process after successful redirection
                resolve();
              })["catch"](function (redirectError) {
                LogService.error(redirectError, 'Error during redirection');
                newLoginFailedAttemp(); // Run newLoginFailedAttemp() for redirection errors
                reject(redirectError); // Reject the promise with the redirection error
              });
            } else {
              LogService.error(error, 'Failed to acquire token silently');
              newLoginFailedAttemp(); // Run newLoginFailedAttemp() for other errors
              reject(error); // Reject the promise with the error
            }
          });
        }
      });
    }

    function azSignOut() {
      /**
       * You can pass a custom request object below. This will override the initial configuration. For more information, visit:
       * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#request
       */

      var logoutRequest = {
        account: myMSALObj.getAccountByUsername(username),
        postLogoutRedirectUri: window.location.href
      };
      myMSALObj.logoutRedirect(logoutRequest);
    }

    /**
     * Add code to try to login locally if remote login fails with a 404 or timeout
     * @memberof UserFactory
     * @param {number} username The User Name
     * @param {string} password The User Password
     * @param {function} onsuccess callback function if the call is a success
     * @param {function} onerror callback function if the call failed
     * @param {function} onfinally callback function that runs on the end
     */
    function login(token, onsuccess, onerror, onfinally) {
      clearActiveUser();
      var q = PilotAPIService.login(token);
      q.then(function (response) {
        // if the user that tries to log in is different than the last
        // logged in user, then reset all stored server data
        var localUser = getUser();
        if (localUser != null && localUser.aimsId != null && localUser.aimsId.toString() != response.data.data.aimsId.toString()) {
          DataCleanerFactory.deleteAllData();
        }
        // delete any flights created locally, that do not have any local
        // reports
        DataCleanerFactory.deleteOrphanedLocalFlights();

        // assign the logged in user
        var user = response.data.data;
        setUser(user);
        setActiveUser(user);
        if (typeof onsuccess == "function") {
          onsuccess();
        }
      });
      q["catch"](function (response) {
        if (typeof onerror == "function") {
          onerror(response);
        }
      });
      q["finally"](function (response) {
        if (typeof onfinally == "function") {
          onfinally();
        }
      });
      return q;
    }

    /**
          * the function that extends the token for limited time if a user forgot their password
          * @memberof UserFactory
          * @param {function} onsuccess callback function if the call is a success
          * @param {function} onerror callback function if the call failed
          */
    function extendToken(onsuccess, onerror) {
      var user = getUser();
      $http.post(apiUrl + '/login/extendtoken', {
        'Token': user.token
      }, {
        'Content-Type': 'application/json'
      }).then(function (response) {
        user.token = response.data.data;
        user.tokenExtended = true;
        setUser(user);
        setActiveUser(user);
        if (typeof onsuccess == "function") {
          onsuccess();
        }
      })["catch"](function (response) {
        if (typeof onerror == "function") {
          onerror(response);
        }
      });
    }
    function getLoginFailedAttemps() {
      var failedLoginAttemps = localStorageMD5Service.get('failedLoginAttemps');
      if (failedLoginAttemps) {
        return failedLoginAttemps;
      } else {
        return 0;
      }
    }
    function newLoginFailedAttemp() {
      var value = 1;
      var failedLoginAttemps = localStorageMD5Service.get('failedLoginAttemps');
      if (failedLoginAttemps && failedLoginAttemps !== "null") {
        var attempsToNumber = Number(failedLoginAttemps);
        value = value + attempsToNumber;
      }
      localStorageMD5Service.set('failedLoginAttemps', value);
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('MessageCtrl', MessageCtrl);

  /* @ngInject */
  function MessageCtrl($scope, $location, MessageFactory, $filter, $sce) {
    var messages = [];
    $scope.messages = MessageFactory.getMessagesFromStorage();
    messages = $scope.messages;
    $scope.state = 'messages';

    //Initialized scope variables

    $scope.openMessage = openMessage;
    $scope.isEnabled = false;
    $scope.messageCount = messages.length;
    $scope.trustAsHtml = trustAsHtml;
    $scope.setupView = setupView;

    /**
    * Trust this html style text
    * @memberof MessageCtrl
    * @param {string} body The body message
    */
    function trustAsHtml(body) {
      return $sce.trustAsHtml(body);
    }

    /**
    * Setup the message View
    * @memberof MessageCtrl
    * @param {boolean} isEnabled Show only unread messages
    */
    function setupView(isEnabled) {
      $scope.messages = $filter('messageFilter')(messages, isEnabled);
    }

    /**
     * View Selected message
     * @memberof MessageCtrl
     * @param {object} message The selected Message
     */
    function openMessage(message) {
      if (message.ReadDt == null) {
        MessageFactory.markReaden(message.Id);
        message.ReadDt = new Date();
      }
    }
  }
  ;
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.filter('messageFilter', messageFilter);

  /**
  * @memberof PilotReports
  * @ngdoc filter
  * @name messageFilter
  * @description 
  *   Filters messages in order to show only the unread.
  * @ngInject
  */
  function messageFilter() {
    return function (input, isEnable) {
      if (isEnable) {
        var result = [];
        for (var i = 0; i < input.length; i++) {
          if (input[i].ReadDt == null) {
            result.push(input[i]);
          }
        }
        return result;
      } else {
        return input;
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('MessageFactory', MessageFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name MessageFactory
  * @description 
  *   Add, Update, Delete and Get Messages.
  * @ngInject
  */
  function MessageFactory(GenericService) {
    /**
    * Initialize the Message
    * @memberof MessageFactory
    */
    function Message() {
      this.Id = null;
      this.Title = null;
      this.AuthorName = null;
      this.Body = null;
      this.AcType = null;
      this.AirportA = null;
      this.AirportB = null;
      this.Country = null;
      this.FlightDirection = null;
      this.FlightNo = null;
      this.ValidFrom = null;
      this.ValidTo = null;
      this.PositionCP = true;
      this.PositionFA = true;
      this.PositionFO = true;
      this.PositionSA = true;
      this.QueryType = null;
      this.ReadDt = null;
      this.Registration = null;
      this.FeedbackCause = null;
    }
    var objType = 'messages';
    var objCallback = Message;
    var service = {
      fromObjectList: fromObjectList,
      getMessagesFromStorage: getMessagesFromStorage,
      setMessagesToStorage: setMessagesToStorage,
      clearMessagesFromStorage: clearMessagesFromStorage,
      getCountOfUnreadMessages: getCountOfUnreadMessages,
      getMessagesFromIds: getMessagesFromIds,
      getUnreadMessages: getUnreadMessages,
      markReaden: markReaden,
      markReadAsSynched: markReadAsSynched,
      getUnsynchedReadMessages: getUnsynchedReadMessages,
      storeMessagesFromServer: storeMessagesFromServer
    };

    /**
     * Extend an array of Objects from the default message Object
     * @memberof MessageFactory
     * @param {Array} objList  an Array Of messages
     * @returns {Array} messages
     */
    function fromObjectList(objList) {
      return GenericService.fromObjectList(objList, objCallback);
    }

    /**
     * Get messages
     * @memberof MessageFactory
     * @returns {Array} messages 
     */
    function getMessagesFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    /**
     * Save messages to storage
     * @memberof MessageFactory
     * @param {Array} messages A list of messages
     */
    function setMessagesToStorage(messages) {
      GenericService.saveAll(messages, objType, objCallback);
    }

    /**
     * Remove the messages of  the local storage
     * @memberof MessageFactory
     */
    function clearMessagesFromStorage() {
      GenericService.removeAll(objType, objCallback);
    }

    /**
     * Get count of unread messages
     * @memberof MessageFactory
     * @returns {number} result 
     */
    function getCountOfUnreadMessages() {
      var messages = getMessagesFromStorage();
      if (!messages) return 0;
      var result = 0;
      var arrayLength = messages.length;
      for (var i = 0; i < arrayLength; i++) {
        if (!messages[i].ReadDt) {
          result++;
        }
      }
      return result;
    }

    /**
     * Get messages from given ids
     * @memberof MessageFactory
     * @param {Ids} List of Ids
     * @returns {Array} selectedMessages 
     */
    function getMessagesFromIds(Ids) {
      var messages = getMessagesFromStorage();
      var selectedMessages = [];
      if (Ids != undefined || Ids != null) {
        for (var i = 0; i < Ids.length; i++) {
          for (var j = 0; j < messages.length; j++) {
            if (Ids[i] == messages[j].Id) {
              selectedMessages.push(messages[j]);
              break;
            }
          }
        }
      }
      return selectedMessages;
    }

    /**
     * Get  unread messages
     * @memberof MessageFactory
     * @returns {Array} filteredMessages 
     */
    function getUnreadMessages() {
      var messages = getMessagesFromStorage();
      filteredMessages = [];
      for (var i = 0; i < messages.length; i++) {
        if (!messages[i].ReadDt == null) {
          filteredMessages.push(messages[i]);
        }
      }
      return filteredMessages;
    }

    /**
     * Get  unread messages
     * @memberof MessageFactory
     * @returns {Array} filteredMessages 
     */
    function markReaden(messageId) {
      // get the Message array from storage
      var messages = getMessagesFromStorage();
      if (messages == null) messages = [];

      // find the current Message from the array (if present)
      var arrayLength = messages.length;
      for (var i = 0; i < arrayLength; i++) {
        if (messages[i].Id == messageId) {
          messages[i].ReadDt = new Date();
          break;
        }
      }
      setMessagesToStorage(messages);
    }

    /**
     * Mark the messages as synched and save it
     * @memberof MessageFactory
     * @param {array} readMessages A list of synced messages
     */
    function markReadAsSynched(readMessages) {
      var messages = getMessagesFromStorage();
      if (readMessages && messages) {
        var id;
        for (var i = 0; i < readMessages.length; i++) {
          id = readMessages[i].Id;
          for (var x = 0; x < messages.length; x++) {
            if (messages[x].Id === id) {
              messages[x].Synched = true;
            }
          }
        }
        setMessagesToStorage(messages);
      }
    }

    /**
     * Get the messages that are unsynched and not read and save them
     * @memberof MessageFactory
     * @param {array} readMessages A list of synced messages
     */
    function getUnsynchedReadMessages() {
      var messages = getMessagesFromStorage();
      var data = fromObjectList(messages);
      var filtered = null;
      if (data && data.length > 0) {
        filtered = [];
        for (var i = 0; i < data.length; i++) {
          if (data[i].ReadDt && !data[i].Synched) {
            filtered.push({
              Id: data[i].Id,
              ReadDt: data[i].ReadDt
            });
          }
        }
      }
      return filtered;
    }

    /**
     * Store the messages from the sync api
     * @memberof MessageFactory
     * @param {array} readMessages A list of  messages
     */
    function storeMessagesFromServer(messages) {
      if (messages) {
        for (var i = 0; i < messages.length; i++) {
          messages[i].AuthorName = messages[i].AuthorName.replace("GATEWAY\\", "");
          messages[i].AuthorName = messages[i].AuthorName.replace(".", " ");

          //messages already saved as Read in the server, should not be send to the server again
          if (messages[i].ReadDt) messages[i].Synched = true;else messages[i].Synched = false;
        }
      }
      setMessagesToStorage(messages);
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('MessageModalCtrl', MessageModalCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name MessageModalCtrl
  * @description 
  *  Manages the message Modal
  * @ngInject
  */
  function MessageModalCtrl($scope, message, $uibModalInstance, $sce) {
    $scope.message = message;
    $scope.cancel = cancel;
    $scope.messageBody = $sce.trustAsHtml(message.Body);

    /**
     * Close the modal
     * @memberof MemoModalCtrl
     */
    function cancel() {
      $uibModalInstance.close('close');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('PassengerCtrl', PassengerCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name PassengerCtrl
  * @description 
  *  Manages the passenger information view
  * @ngInject
  */
  function PassengerCtrl(passenger, arrival, $scope, $uibModalInstance) {
    $scope.passenger = passenger;
    $scope.arrival = arrival;
    $scope.cancel = cancel;
    $scope.IsOld = IsOld;

    /**
     * Checks if the data are new
     * @memberof PassengerCtrl
     * @param {string} time timestamp
     * @return {boolean} IsOld
     */
    function IsOld(time) {
      IsOld = false;
      if (time) {
        var now = new Date();
        var timeDate = new Date(time);
        var diff = now.getTime() - timeDate.getTime();
        if (diff > 3600000) {
          IsOld = true;
        }
      }
      return IsOld;
    }

    /**
     * Close the modal
     * @memberof PassengerCtrl
     */
    function cancel() {
      $uibModalInstance.dismiss('');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('PaxCtrl', PaxCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name PaxCtrl
  * @description 
  *  Manages the passenger seatmap and information view
  * @ngInject
  */
  function PaxCtrl($scope, FlightFactory, PaxInfoFactory, $routeParams, $uibModal, $location) {
    var flightId = $routeParams.flightId;
    var flight = FlightFactory.getFlightFromStorage(flightId);
    var paxInfo = PaxInfoFactory.getPaxInfoFromStorage(flightId);
    $scope.state = 'pax';
    $scope.flight = flight;
    $scope.showMobileMenuFilters = false;
    $scope.filterPax = filterPax;
    $scope.viewMode = viewMode;
    $scope.filterRow = filterRow;
    $scope.filterCol = filterCol;
    $scope.paxInfo = paxInfo;
    $scope.howClose = '';
    $scope.IsOld = IsOld;
    $scope.openPassenger = openPassenger;
    $scope.resetFilters = resetFilters;
    $scope.isConnectedFlightClose = isConnectedFlightClose;
    $scope.TimeDifference = TimeDifference;
    $scope.IsProvisional = true;
    $scope.specialMeals = 0;
    $scope.toggleFlightInfoView = toggleFlightInfoView;
    $scope.mode = "seatMap";
    $scope.radioModel = "Seatmap";
    if (flight == null) {
      flight = FlightFactory.getLocalFlightFromStorage(flightId);
    }
    if (flight != null) {
      if (paxInfo) {
        var connectingPax = 0;
        for (var i = 0; i < paxInfo.ConnectingFlights.length; i++) {
          connectingPax = connectingPax + paxInfo.ConnectingFlights[i].PassengerSummaryC.Passengers + paxInfo.ConnectingFlights[i].PassengerSummaryY.Passengers;
        }
        $scope.connectingPax = connectingPax;
        for (var i = 0; i < paxInfo.Seatmap.length; i++) {
          for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
            if (paxInfo.Seatmap[i].Columns[j].SpecialMeal) {
              $scope.specialMeals++;
            }
            if (paxInfo.Seatmap[i].Columns[j].SpecialMealB) {
              $scope.specialMeals++;
            }
            if (paxInfo.Seatmap[i].Columns[j].ConnectingFlightId && paxInfo.Seatmap[i].Columns[j].ConnectingFlightId != 0) {
              for (var h = 0; h < paxInfo.ConnectingFlights.length; h++) {
                if (paxInfo.Seatmap[i].Columns[j].ConnectingFlightId == paxInfo.ConnectingFlights[h].FlightId) {
                  paxInfo.Seatmap[i].Columns[j].Connection = paxInfo.ConnectingFlights[h];
                }
              }
            }
          }
        }
        var listSentTimestamp = new Date(paxInfo.LastRun).getTime();
        var DepartureTimestamp = new Date(flight.ScheduledDeparture).getTime();
        //20 minutes before takeoff
        if (DepartureTimestamp - listSentTimestamp <= 1200000) {
          $scope.IsProvisional = false;
        }
      }
      var flightArrivalTime = new Date(flight.ScheduledArrival).getTime();
      $scope.flightETA = flight.ETA ? new Date(flight.ETA).getTime() : flightArrivalTime;
      initializeFilters();
      initializeViewMode();
    } else {
      $location.path("/");
    }

    /**
     * Initialize Passenger Filters
     * @memberof PaxCtrl
     */
    function initializeFilters() {
      $scope.filterPaxC = false;
      $scope.filterPaxY = false;
      $scope.filterAdults = false;
      $scope.filterChildren = false;
      $scope.filterInfants = false;
      $scope.filterUMs = false;
      $scope.filterFqtv = false;
      $scope.filterConnections = false;
      $scope.filterSpecialMeals = false;
      $scope.filterFqtvSilver = false;
      $scope.filterFqtvGold = false;
      $scope.filterWheelchair = false;
      $scope.filterAssistance = false;
      $scope.filterDeportees = false;
      $scope.filterDHC = false;
      $scope.filterVIP = false;
    }

    /**
     * Filter Passenger by given filter
     * @memberof PaxCtrl
     * @param {string} criteria The selected filter criteria
     */
    function filterPax(criteria) {
      if (criteria == "PaxC") {
        var val = !$scope.filterPaxC;
        initializeFilters();
        $scope.filterPaxC = val;
      } else if (criteria == "PaxY") {
        var val = !$scope.filterPaxY;
        initializeFilters();
        $scope.filterPaxY = val;
      } else if (criteria == "Adults") {
        var val = !$scope.filterAdults;
        initializeFilters();
        $scope.filterAdults = val;
      } else if (criteria == "Children") {
        var val = !$scope.filterChildren;
        initializeFilters();
        $scope.filterChildren = val;
      } else if (criteria == "Infants") {
        var val = !$scope.filterInfants;
        initializeFilters();
        $scope.filterInfants = val;
      } else if (criteria == "Fqtv-silver") {
        var val = !$scope.filterFqtvSilver;
        initializeFilters();
        $scope.filterFqtvSilver = val;
      } else if (criteria == "Fqtv-gold") {
        var val = !$scope.filterFqtvGold;
        initializeFilters();
        $scope.filterFqtvGold = val;
      } else if (criteria == "Connections") {
        var val = !$scope.filterConnections;
        $scope.showConnections = true;
        initializeFilters();
        $scope.filterConnections = val;
      } else if (criteria == "UMs") {
        var val = !$scope.filterUMs;
        initializeFilters();
        $scope.filterUMs = val;
      } else if (criteria == "SpecialMeals") {
        var val = !$scope.filterSpecialMeals;
        initializeFilters();
        $scope.showMeals = true;
        $scope.filterSpecialMeals = val;
      } else if (criteria == "Wheelchair") {
        var val = !$scope.filterWheelchair;
        initializeFilters();
        $scope.filterWheelchair = val;
      } else if (criteria == "Assistance") {
        var val = !$scope.filterAssistance;
        initializeFilters();
        $scope.filterAssistance = val;
      } else if (criteria == "Deportees") {
        var val = !$scope.filterDeportees;
        initializeFilters();
        $scope.filterDeportees = val;
      } else if (criteria == "DHC") {
        var val = !$scope.filterDHC;
        initializeFilters();
        $scope.filterDHC = val;
      } else if (criteria == "VIP") {
        var val = !$scope.filterVIP;
        initializeFilters();
        $scope.filterVIP = val;
      }
    }

    /**
     * Toggle view from seatmap to paxlist
     * @memberof PaxCtrl
     */
    function toggleFlightInfoView(mode) {
      $scope.mode = mode;
    }

    /**
     * Initialize View Mode
     * @memberof PaxCtrl
     */
    function initializeViewMode() {
      $scope.showPaxName = true;
      $scope.showDetails = true;
      $scope.showConnections = true;
      $scope.showMeals = false;
    }

    /**
     * Set the desired view style
     * @memberof PaxCtrl
     * @param {string} mode The view mode
     */
    function viewMode(mode) {
      if (mode == "PaxName") {
        $scope.showPaxName = !$scope.showPaxName;
      } else if (mode == "Details") {
        $scope.showDetails = !$scope.showDetails;
      } else if (mode == "Connections") {
        $scope.showConnections = !$scope.showConnections;
      } else if (mode == "Meals") {
        $scope.showMeals = !$scope.showMeals;
      }
    }

    /**
     * Show only the  Rows that have a passenger that is valid with the current filters
     * @memberof PaxCtrl
     * @param {object} row The passenger row
     */
    function filterRow(row) {
      var isValid = false;
      if ($scope.filterPaxC || $scope.filterPaxY || $scope.filterAdults || $scope.filterChildren || $scope.filterInfants || $scope.filterUMs || $scope.filterFqtv || $scope.filterConnections || $scope.filterSpecialMeals || $scope.filterFqtvSilver || $scope.filterFqtvGold || $scope.filterWheelchair || $scope.filterAssistance || $scope.filterDeportees || $scope.filterDHC || $scope.filterVIP) {
        for (var i = 0; i < row.Columns.length; i++) {
          if (filterCol(row.Columns[i])) {
            isValid = true;
          }
        }
      } else {
        isValid = true;
      }
      return isValid;
    }

    /**
     * Disable the  passenger seats that is not valid with the current filters
     * @memberof PaxCtrl
     * @param {object} col The passenger seat
     */
    function filterCol(col) {
      var IsValid = true;
      if ($scope.filterPaxC && col.Cabin != "C") {
        IsValid = false;
      } else if ($scope.filterPaxY && col.Cabin != "Y") {
        IsValid = false;
      } else if ($scope.filterAdults && col.Type != 'A') {
        IsValid = false;
      } else if ($scope.filterChildren && col.Type != 'C') {
        IsValid = false;
      } else if ($scope.filterInfants && col.Type != 'I' && !(col.Type == 'A' && col.InfantName)) {
        IsValid = false;
      } else if ($scope.filterFqtv && col.Fqtv == null) {
        IsValid = false;
      } else if ($scope.filterConnections && col.Connection == null) {
        IsValid = false;
      } else if ($scope.filterUMs && !(col.SSR != null && col.SSR.IsUMNR)) {
        IsValid = false;
      } else if ($scope.filterSpecialMeals && col.SpecialMeal == null && col.SpecialMealB == null) {
        IsValid = false;
      } else if ($scope.filterFqtvSilver && !(col.Fqtv != null && (col.Fqtv.TierLevel == 'BLUT' || col.Fqtv.TierLevel == 'SLVT'))) {
        IsValid = false;
      } else if ($scope.filterFqtvGold && !(col.Fqtv != null && col.Fqtv.TierLevel == 'GLDT')) {
        IsValid = false;
      } else if ($scope.filterWheelchair && !(col.SSR != null && col.SSR.IsGroupPRM)) {
        IsValid = false;
      } else if ($scope.filterAssistance && !(col.SSR != null && (col.SSR.IsDEAF || col.SSR.IsBLND || col.SSR.IsDPNA))) {
        IsValid = false;
      } else if ($scope.filterDeportees && !(col.SSR != null && (col.SSR.IsINAD || col.SSR.IsGroupDEP))) {
        IsValid = false;
      } else if ($scope.filterDHC && !col.IsDHC) {
        IsValid = false;
      } else if ($scope.filterVIP && !col.IsVIP) {
        IsValid = false;
      }
      return IsValid;
    }

    /**
     * Initialize Passenger Filters and the desired view style
     * @memberof PaxCtrl
     */
    function resetFilters() {
      initializeFilters();
      initializeViewMode();
    }

    /**
     * Open Passenger Modal View
     * @memberof PaxCtrl
     * @param {object} inputObject The passenger informations
     * @param {string} arrival The flights Arrival
     */
    function openPassenger(inputObject, _arrival) {
      if (inputObject.IsEmptySeat == 0 && (inputObject.SeatMode == 'Seat' || inputObject.SeatMode == 'Jumpseat')) {
        $uibModal.open({
          templateUrl: 'views/Dialogs/dlgPassenger.html',
          controller: 'PassengerCtrl',
          size: 'md',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            passenger: function passenger() {
              return inputObject;
            },
            arrival: function arrival() {
              return _arrival;
            }
          }
        });
      }
    }

    /**
     * Checks if the data are new
     * @memberof PaxCtrl
     * @param {string} time timestamp
     * @return {boolean} IsOld
     */
    function IsOld(time) {
      IsOld = false;
      if (time) {
        var now = new Date();
        var timeDate = new Date(time);
        var diff = now.getTime() - timeDate.getTime();
        if (diff > 3600000) {
          IsOld = true;
        }
      }
      return IsOld;
    }

    /**
     * Calculates if a connecting flight is departs sort time after fligths arrival 
     * @memberof PaxCtrl
     * @param {string} connection Connection STD
     * @return {string} cssClass
     */
    function isConnectedFlightClose(connection) {
      if (!connection) {
        return '';
      }
      var connFlightDate = new Date(connection.STD).getTime();
      if ($scope.flightETA > connFlightDate) return '';
      if (connFlightDate - $scope.flightETA < connection.MCT * 60000) {
        return 'bg-bisque';
      }
      if (connFlightDate - $scope.flightETA < (connection.MCT + 15) * 60000) {
        return 'bg-cornsilk';
      }
      return '';
    }

    /**
     * Returns the time difference
     * @memberof PaxCtrl
     * @param {string} time Connection STD
     * @return {string} timeDifference
     */
    function TimeDifference(time) {
      var timeString = '';
      var sign = '';
      var dayString = null;
      if (time) {
        var connFlightDate = new Date(time);
        var ms = connFlightDate.getTime() - $scope.flightETA; // this is a time in milliseconds
        if (ms < 0) {
          ms = -ms;
          sign = "-";
        }
        var days = Math.floor(ms / (24 * 60 * 60 * 1000));
        days = days < 0 ? days + 1 : days;
        var daysms = ms % (24 * 60 * 60 * 1000);
        var hours = Math.floor(daysms / (60 * 60 * 1000));
        var hoursms = ms % (60 * 60 * 1000);
        var minutes = Math.floor(hoursms / (60 * 1000));
        timeString = '<strong>' + sign + (hours > 0 ? ("0" + hours).substr(-2) + ":" : '') + ("0" + minutes).substr(-2) + '\'' + '<strong>';
        dayString = ' <span class="badge">' + days + 'd</span>';
      }
      return timeString + (days && days != 0 ? dayString : '');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('PaxInfoFactory', PaxInfoFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name PaxInfoFactory
  * @description 
  *   Add, Update, Delete and Get Passenger information.
  * @ngInject
  */
  function PaxInfoFactory(IndexedDBService, GenericService, localStorageMD5Service, SyncLogFactory, FlightFactory, CrewRouteFactory) {
    /**
    * Initialize the PaxInfo
    * @memberof PaxInfoFactory
    */
    function PaxInfo() {
      this.Id = null;
      this.STD_utc = null;
      this.STD_lcl = null;
      this.STA_utc = null;
      this.STA_lcl = null;
      this.AcType = null;
      this.Registration = null;
      this.ConfigurationC = null;
      this.ConfigurationY = null;
      this.PaxTotalC = null;
      this.PaxTotalY = null;
      this.MarketingFlightNos = null;
      this.SupplementaryInfo = null;
      this.LastRun = null;
      this.Offpoints = [];
      this.ConnFlights = [];
      this.Seatmap = [];
      this.curtainRows = [];
      this.Statistics = {};
      this.GetId = GetId;
    }
    var objType = 'PaxInfo';
    var objCallback = PaxInfo;
    var service = {
      setPaxInfoToStorage: setPaxInfoToStorage,
      getPaxInfoFromStorage: getPaxInfoFromStorage,
      getPaxInfoList: getPaxInfoList,
      updatePaxInfo: updatePaxInfo,
      getAllPaxInfoFromStorage: getAllPaxInfoFromStorage,
      cleanOldDataPaxInfo: cleanOldDataPaxInfo,
      setMaskPaxInfoInRoute: setMaskPaxInfoInRoute
    };

    /**
     * Overide default get Id
     * @memberof PaxInfoFactory
     * @returns {number} Id 
     */
    function GetId() {
      return this.FlightId;
    }

    /**
    * Get Passenger information list for the selected flight
    * @memberof PaxInfoFactory
    * @param {number} flightId  The flight id 
    */
    function getPaxInfoList(flightId, callback) {
      var intFlightId = +flightId;
      var passengerList = [];
      var paxInfo = getPaxInfoFromStorage(intFlightId);
      if (paxInfo) {
        for (var i = 0; i < paxInfo.Seatmap.length; i++) {
          for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
            var passenger = paxInfo.Seatmap[i].Columns[j];
            if (!passenger.IsEmptySeat && passenger.SeatMode == "Seat") {
              passengerList.push(passenger);
            }
          }
        }
      }
      callback(passengerList);
    }

    /**
     * Overide default get Id
     * @memberof PaxInfoFactory
     * @returns {number} Id 
     */
    function GetStatistics(paxInfo) {
      var statistics = {};
      var syncLog = SyncLogFactory.getSyncLog();
      if (paxInfo && paxInfo.Seatmap) {
        paxInfo.curtainRows = [];
        var cabinType;
        for (var i = 0; i < paxInfo.Seatmap.length; i++) {
          for (var j = 0; j < paxInfo.Seatmap[i].Columns.length; j++) {
            if (paxInfo.Seatmap[i].Columns[j].Cabin == 'J') {
              paxInfo.Seatmap[i].Columns[j].Cabin = 'Y';
            }
            if (cabinType == null) {
              cabinType = paxInfo.Seatmap[i].Columns[j].Cabin;
            } else if (cabinType != paxInfo.Seatmap[i].Columns[j].Cabin && paxInfo.Seatmap[i - 1] && paxInfo.Seatmap[i].Columns[j].Cabin != null) {
              cabinType = paxInfo.Seatmap[i].Columns[j].Cabin;
              paxInfo.curtainRows.push(paxInfo.Seatmap[i - 1].RowNo);
            }
          }
        }
      }
      return statistics;
    }

    /**
     * Set Passenger informations
     * @memberof PaxInfoFactory
     * @param {Array} paxInfos  The passenger informations 
     */
    function setPaxInfoToStorage(paxInfos) {
      if (paxInfos) {
        for (var i = 0; i < paxInfos.length; i++) {
          paxInfos[i].Statistics = GetStatistics(paxInfos[i]);
        }
      }
      GenericService.saveAll(paxInfos, objType, objCallback);
    }

    /**
     * Set  a Passenger information list
     * @memberof PaxInfoFactory
     * @param {object} paxInfo  A passenger information list
     */
    function savePaxInfoToStorage(paxInfo) {
      paxInfo.Statistics = GetStatistics(paxInfo);
      paxInfos[i].Seatmap = [];
      GenericService.save(paxInfo, objType, objCallback);
    }

    /**
    * Clean Old Data
    * @memberof PaxInfoFactory
    * @param {Array} pendingFlightIds FlightIds with pending reports
    */
    function cleanOldDataPaxInfo(pendingFlightIds) {
      // get paxInfo for the flights with draft reports from indexedDB (gets the new paxInfo if the flightId exists in sync response)
      var paxInfoFromStorage = getAllPaxInfoFromStorage();
      var oldDraftPaxInfo = paxInfoFromStorage.filter(function (item) {
        return pendingFlightIds.includes(item.FlightId);
      });
      GenericService.saveAll(oldDraftPaxInfo, objType, objCallback);
    }

    /**
     * Get Passenger information for the selected flight
     * @memberof PaxInfoFactory
     * @param {Array} paxInfos  The passenger informations 
     */
    function getPaxInfoFromStorage(flightId) {
      return GenericService.get(flightId, objType, objCallback);
    }

    //factory functions
    /**
     * Update Passenger information
     * @memberof PaxInfoFactory
     * @param {object} paxInfo  The passenger informations 
     */
    function updatePaxInfo(paxInfo) {
      if (paxInfo) {
        paxInfo.Statistics = GetStatistics(paxInfo);
        if (GenericService.get(paxInfo.FlightId, objType, objCallback)) GenericService.save(paxInfo, objType, objCallback);else GenericService.add(paxInfo, objType, objCallback);
      }
    }

    /**
     * Get Passenger information for the selected flights
     * @memberof PaxInfoFactory
     */
    function getAllPaxInfoFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    /**
      * Update Passenger information
      * @memberof PaxInfoFactory
      */
    function migratePaxInfo() {
      var lsPaxInfo = localStorageMD5Service.get(objType);
      if (lsPaxInfo && lsPaxInfo.length > 0) {
        IndexedDBService.addAll(objType, lsPaxInfo);
        localStorageMD5Service.remove(objType);
      }
    }

    /**
     * Hide pax name with condition
     * @memberof PaxInfoFactory
     */
    function setMaskPaxInfoInRoute(flightInfo) {
      if (flightInfo && flightInfo.showPaxNames) {
        var applyMask = false;
        var flights = CrewRouteFactory.getCrewRouteFlights(flightInfo.DutyNo, flightInfo.DutyDay, flightInfo.FlightDate);
        flights = $filter('orderBy')(flights, 'ScheduledDeparture');
        var lastFlight = flights[flights.length - 1];
        if (moment.utc().diff(moment(lastFlight.ATA), 'hours') > 2) {
          //set mask
          applyMask = true;
        } else if (moment.utc().diff(moment(lastFlight.ScheduledArrival), 'hours') > 4) {
          //set mask
          applyMask = true;
        }
        if (applyMask) {
          flights.forEach(function (flight) {
            flight.showPaxNames = false;
            FlightFactory.updateFlight(flight);
          });
          flightIds = flights.map(function (item) {
            return item.FlightId; // or Id (todo: check)
          });

          setMaskPaxInfoToStorage(flightIds);
        }
      }
    }
    function setMaskPaxInfoToStorage(flightIds) {
      getAllPaxInfoFromStorage(function (paxInfoResult) {
        var maskedPaxFlightList = [];
        maskedPaxFlightList = paxInfoResult.filter(function (item) {
          return flightIds.includes(item.FlightId);
        });
        for (var i = 0; i < maskedPaxFlightList.length; i++) {
          maskPaxNames(maskedPaxFlightList[i]);
        }
        var otherPaxInfo = paxInfoResult.filter(function (item) {
          return !flightIds.includes(item.FlightId);
        });
        var newListPaxInfo = otherPaxInfo.concat(maskedPaxFlightList);
        GenericService.saveAll(newListPaxInfo, objType, objCallback);
      });
    }
    function maskPaxNames(pax) {
      if (pax) {
        for (var i = 0; i < pax.Seatmap.length; i++) {
          for (var j = 0; j < pax.Seatmap[i].Columns.length; j++) {
            var passenger = pax.Seatmap[i].Columns[j];
            if (!passenger.IsEmptySeat && passenger.SeatMode == "Seat") {
              passenger.InfantSurname = passenger.InfantSurname ? "*****" : passenger.InfantSurname;
              passenger.InfantGivenName = passenger.InfantGivenName ? "*****" : passenger.InfantGivenName;
              passenger.Surname = passenger.Surname ? "*****" : passenger.Surname;
              passenger.GivenName = passenger.GivenName ? "*****" : passenger.GivenName;
            }
          }
        }
      }
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('AircraftTypeFactory', AircraftTypeFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name AircraftTypeFactory
  * @description 
  *   Manage Aircraft Types.
  * @ngInject
  */
  function AircraftTypeFactory($log, GenericValuesFactory) {
    /**
     * Initialiaze AircraftType object 
     * @memberof AircraftTypeFactory
     */
    function AircraftType() {
      this.Code = null;
    }
    var callback = AircraftType;
    var type = 'aircraftTypes';
    var service = {
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      toObjectList: toObjectList,
      getAircraftTypesFromStorage: getAircraftTypesFromStorage,
      setAircraftTypesToStorage: setAircraftTypesToStorage,
      clearAircraftTypesFromStorage: clearAircraftTypesFromStorage
    };

    /**
     * Extend given AircraftType object 
     * @memberof AircraftTypeFactory
     * @param {object} obj The AircraftType object that will be extended
     * @returns {object} AircraftType
     */
    function fromObject(obj) {
      return GenericValuesFactory.fromObject(obj, callback);
    }

    /**
     * Extend given AircraftType object list
     * @memberof AircraftTypeFactory
     * @param {array} objList The list of AircraftType objects that will be extended
     * @returns {object} AircraftTypes
     */
    function fromObjectList(objList) {
      return GenericValuesFactory.fromObjectList(objList, callback);
    }

    /**
     * Extend given AircraftType object list
     * @memberof AircraftTypeFactory
     * @param {array} objList The list of AircraftType objects that will be extended
     * @returns {object} AircraftTypes
     */
    function toObjectList(objList) {
      return GenericValuesFactory.objList(objList);
    }

    /**
     * Get all the AircraftType objects
     * @memberof AircraftTypeFactory
     * @returns {array} AircraftTypes
     */
    function getAircraftTypesFromStorage() {
      return GenericValuesFactory.getValuesFromStorage(callback, type);
    }

    /**
     * Set all the AircraftTypes
     * @memberof AircraftTypeFactory
     * @param {array} objects A list of AircraftTypes.
     */
    function setAircraftTypesToStorage(objList) {
      GenericValuesFactory.setValuesToStorage(objList, type);
    }

    /**
     * Clear all the AircraftTypes
     * @memberof AircraftTypeFactory
     */
    function clearAircraftTypesFromStorage() {
      GenericValuesFactory.clearValuesFromStorage(type);
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.filter('byCategory', byCategory);

  /**
  * @memberof PilotReports
  * @ngdoc filter
  * @name byCategory
  * @description 
  *   Filter questions by catecory and search text
  * @ngInject
  */
  function byCategory() {
    return function (questions, obj) {
      var items = {
        category: obj.category,
        searchText: obj.query ? obj.query.toLowerCase() : "",
        out: []
      };
      angular.forEach(questions, function (value, key) {
        if (this.category === value.CategoryLabel && (value.Label.toLowerCase().indexOf(this.searchText) >= 0 || value.Description.toLowerCase().indexOf(this.searchText) >= 0)) {
          this.out.push(value);
        }
      }, items);
      return items.out.dynamicSort('OrderNo');
    };
  }
  ;
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('OpenReportDialogCtrl', OpenReportDialogCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name OpenReportDialogCtrl
  * @description 
  *  Manages the open report modal functionality 
  * @ngInject
  */
  function OpenReportDialogCtrl($scope, $uibModalInstance, $location, apiUrl, UserFactory, FlightFactory, PilotReportLocalEditFactory, flightId) {
    // load the user
    var user = UserFactory.getUser();

    // load the flight
    var flight = FlightFactory.getFlightFromStorage(flightId);
    if (flight == null) return;

    // load the reports
    var serverReportForThisUser = flight.getServerPilotReportForUser(user.aimsId);
    var serverReportsByAnotherUser = flight.getServerPilotReportsByAnotherUser(user.aimsId);
    var localReport = PilotReportLocalEditFactory.getPilotReportLocalEditForFlight(flightId);

    // the user can create a new report only if there is not an existing one and there is not a server report by him
    if (localReport != null || serverReportForThisUser != null) $scope.canCreateNewLocalReport = false;else $scope.canCreateNewLocalReport = true;
    var allServerReports = new Array();
    if (serverReportForThisUser != null) {
      serverReportForThisUser.IsSameUser = " (YOU)";
      allServerReports.push(serverReportForThisUser);
    }
    for (var i = 0; i < serverReportsByAnotherUser.length; i++) allServerReports.push(serverReportsByAnotherUser[i]);
    $scope.localReport = localReport;
    $scope.serverReports = allServerReports;
    $scope.cancel = cancel;
    $scope.createNewLocalReport = createNewLocalReport;
    $scope.openLocalReport = openLocalReport;
    $scope.openServerReport = openServerReport;

    /**
     * Close Modal
     * @memberof OpenReportDialogCtrl
     */
    function cancel() {
      $uibModalInstance.dismiss('');
    }
    ;

    /**
     * Create new report and close modal
     * @memberof OpenReportDialogCtrl
     */
    function createNewLocalReport() {
      $location.path("report/new:" + -1 + "/" + flightId);
      $uibModalInstance.dismiss('');
    }
    ;

    /**
     * Open Local Report
     * @memberof OpenReportDialogCtrl
     * @param {object} report
     */
    function openLocalReport(report) {
      $location.path("report/" + report.ReportGuid);
      $uibModalInstance.dismiss('');
    }
    ;

    /**
     * Open Server stored Report
     * @memberof OpenReportDialogCtrl
     * @param {object} report
     */
    function openServerReport(report) {
      //get user token and send it as a parameter on the call
      var token = '';
      if (user != null) {
        token = user.token;
        token = encodeURIComponent(token);
        $location.path("reportsHistory/" + report.ReportId + "/" + flightId + "/Pilot");
      }
      $uibModalInstance.dismiss('');
    }
    ;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('PilotReportLocalEditFactory', PilotReportLocalEditFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name PilotReportLocalEditFactory
  * @description 
  *   Manage Local Pilot Reports.
  * @ngInject
  */
  function PilotReportLocalEditFactory($log, localStorageMD5Service, GenericService, GroundServicesFactory) {
    /**
     * Initialiaze PilotReportLocalEdit object 
     * @memberof PilotReportLocalEditFactory
     */
    function PilotReportLocalEdit() {
      this.ReportGuid = null;
      this.AuthorId = null;
      this.AuthorAimsId = null;
      this.AuthorName = null;
      this.Created = null;
      this.FlightAimsId = null;
      this.FlightId = null;
      this.LastUpdated = null;
      this.Departure = null;
      this.Arrival = null;
      this.AcType = null;
      this.AcTailNo = null;
      this.FlightDate = null;
      this.FlightNo = null;
      this.ScheduledDeparture = null;
      this.ScheduledDepartureDateUTC = null;
      this.ScheduledDepartureTimeUTC = null;
      this.Departure = null;
      this.Arrival = null;
      this.ReportId = null;
      this.NothingToReport = null;
      this.Status = null; // pending, draft, completed, synched
      this.Sections = [];
      this.ActiveItems = 0;
      this.WarningItems = 0;
      this.IsValid = false;
      //v1.1 added pax and dep/arr details
      this.BookedC = null;
      this.BookedY = null;
      this.BookedInf = null;
      this.BookedPad = null;
      this.BookedChld = null;
      this.ActualC = null;
      this.ActualY = null;
      this.ActualInf = null;
      this.ActualPad = null;
      this.ActualChld = null;
      this.DepartureICAO = null;
      this.DepartureCountry = null;
      this.DepartureName = null;
      this.ArrivalICAO = null;
      this.ArrivalCountry = null;
      this.ArrivalName = null;
      this.crew = null;
      this.AutolandSatisfactory = false;
      this.AutolandUnsatisfactory = false;
      this.AutolandWorkOrderNo = null;
      this.AutolandWorkOrderNoIsValid = null;
      this.catApproachUnsatisfactory = false;
      this.catApproachSatisfactory = false;
      this.AutolandReasonIsPractice = false;
      this.AutolandReasonIsLowVisibility = false;
      this.ManualLanding = false;
      this.ManualLandingComments = null;
      this.GroundServicesSectionHasValue = false;
      this.ArrivalGroundServices = [];
      this.DepartureGroundServices = [];
      this.ACUProvision = {
        isRequired: false,
        hasValue: false,
        isValid: false,
        values: {
          Yes: false,
          No: false,
          Delayed: false,
          NotRequired: false,
          Faulty: false
        },
        value: null,
        remarks: null,
        delayMinutes: null
      };

      //new fields 
      this.DepartureGate = null;
      this.DepartureTimezone = null;
      this.ArrivalTimezone = null;
      this.CallSign = null;
      this.ScheduledArrival = null;
      this.getDescription = getDescription;
      this.getRoute = getRoute;
      this.updateTotals = updateTotals;
      this.saveReport = saveReport;
      this.saveReportAsTemp = saveReportAsTemp;
    }
    var objType = 'pilotReportLocalEdits';
    var objCallback = PilotReportLocalEdit;
    var service = {
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      getPilotReportsFromStorage: getPilotReportsFromStorage,
      setPilotReportsToStorage: setPilotReportsToStorage,
      deleteTempReport: deleteTempReport,
      deleteReport: deleteReport,
      getPilotReportLocalEditFromTemp: getPilotReportLocalEditFromTemp,
      getPilotReportLocalEditForFlight: getPilotReportLocalEditForFlight,
      getPilotReportLocalEdit: getPilotReportLocalEdit,
      getPilotReportLocalEditCountThatNeedToBeSynched: getPilotReportLocalEditCountThatNeedToBeSynched,
      getPilotReportLocalEditThatNeedToBeSynched: getPilotReportLocalEditThatNeedToBeSynched,
      getNewReport: getNewReport,
      markReportAsSynched: markReportAsSynched,
      setPilotReportToStorage: setPilotReportToStorage,
      checkForNewGroundServices: checkForNewGroundServices,
      getFlightIdsWithPendingReports: getFlightIdsWithPendingReports
    };

    /**
     * Get a short Description of this Pilot report
     * @memberof PilotReportLocalEditFactory
     * @returns {string} Description 
     */
    function getDescription() {
      var s = this.FlightNo + ' ' + this.Departure + '-' + this.Arrival + ' ' + this.ScheduledDepartureDateUTC + ' by ' + this.AuthorName;
      return s;
    }

    /**
     * Get the Route of this Pilot report
     * @memberof PilotReportLocalEditFactory
     * @returns {string} Route 
     */
    function getRoute() {
      if (this.Departure == null && this.Arrival == null) return '-';else return (this.Departure || '?') + '-' + (this.Arrival || '?');
    }

    /**
     * Update the totals of all the section of the report
     * @memberof PilotReportLocalEditFactory
     */
    function updateTotals() {
      var allActiveItems = 0;
      var allWarningItems = 0;
      var sectionCount = this.Sections.length;
      for (var i = 0; i < sectionCount; i++) {
        var sectionActiveItems = 0;
        var sectionWarningItems = 0;
        var itemCount = this.Sections[i].Items.length;
        for (var j = 0; j < itemCount; j++) {
          if (this.Sections[i].Items[j].ItemHasValue == true) {
            if (this.Sections[i].Items[j].ItemValue != null && this.Sections[i].Items[j].ItemValue != '' || this.Sections[i].Items[j].DelayMinutes != null && this.Sections[i].Items[j].DelayMinutes > 0) {
              allActiveItems++;
              sectionActiveItems++;
            } else {
              allWarningItems++;
              sectionWarningItems++;
            }
          }
        }
        this.Sections[i].ActiveItems = sectionActiveItems;
        this.Sections[i].WarningItems = sectionWarningItems;
      }
      this.ActiveItems = allActiveItems;
      this.WarningItems = allWarningItems;
      this.GroundServicesSectionHasValue = false;
      // if(this.ArrivalGroundServices){
      // 	for (var i = 0; i < this.ArrivalGroundServices.length; i++) {
      // 		if (this.ArrivalGroundServices[i].Used) {
      // 			this.GroundServicesSectionHasValue = true;
      // 		}
      // 	}
      // }
      if (this.DepartureGroundServices) {
        for (var i = 0; i < this.DepartureGroundServices.length; i++) {
          if (this.DepartureGroundServices[i].Used) {
            this.GroundServicesSectionHasValue = true;
          }
        }
      }

      //Check if the report is valid:
      this.IsValid = true;

      //check valid ACU Provision
      this.ACUProvision.isValid = true;
      if (this.ACUProvision.isRequired && this.ACUProvision.value == null || this.ACUProvision.isRequired && this.ACUProvision.value == 'Delayed' && (this.ACUProvision.delayMinutes == null || this.ACUProvision.delayMinutes == 0)) {
        this.IsValid = false;
        this.ACUProvision.isValid = false;
      }

      //check valid Autoland Unsatisfactory
      if (this.AutolandUnsatisfactory && !this.AutolandWorkOrderNoIsValid) {
        this.IsValid = false;
      }

      //check valid form
      if (!this.NothingToReport && (this.ActiveItems == 0 && !this.ACUProvision.isRequired || this.WarningItems > 0)) {
        this.IsValid = false;
      }
    }

    /**
     * Save the Pilot Report
     * @memberof PilotReportLocalEditFactory
     */
    function saveReport() {
      // update the LastUpdated field
      this.LastUpdated = new Date();

      // get the reports array from storage
      var allReports = getPilotReportsFromStorage();
      if (allReports == null) allReports = [];

      // find the current report from the array (if present)
      var arrayLength = allReports.length;
      var reportIndex = -1;
      for (var i = 0; i < arrayLength; i++) {
        if (allReports[i].ReportGuid == this.ReportGuid) {
          reportIndex = i;
          break;
        }
      }

      // add or update a copy of the current report
      if (reportIndex >= 0) allReports[reportIndex] = this;else allReports.push(this);

      // save
      setPilotReportsToStorage(allReports);
    }

    /**
     * Save the Report As Temp
     * @memberof PilotReportLocalEditFactory
     */
    function saveReportAsTemp() {
      // update the LastUpdated field
      this.LastUpdated = new Date();

      // save as temp
      localStorageMD5Service.remove('pilotReportLocalEdit_TEMP');
      localStorageMD5Service.set('pilotReportLocalEdit_TEMP', this);
    }

    //Factory Functions

    /**
     * Extend Object from the default local Pilot Report Object
     * @memberof PilotReportLocalEditFactory
     * @param {Object} obj  a PilotReportLocalEdit
     * @returns {Object} PilotReportLocalEdit
     */
    function fromObject(obj) {
      return GenericService.fromObject(obj, objCallback);
    }
    function fromObjectList(objList) {
      return GenericService.fromObjectList(objList, objCallback);
    }

    /**
     * Get Pilot Reports from storage
     * @memberof PilotReportLocalEditFactory
     * @returns {Array} PilotReports
     */
    function getPilotReportsFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    /**
     * Get Pilot Reports from storage
     * @memberof PilotReportLocalEditFactory
     * @returns {Array} PilotReports
     */
    function setPilotReportsToStorage(pilotReportLocalEdits) {
      GenericService.saveAll(pilotReportLocalEdits, objType, objCallback);
    }

    /**
     * Delete Pilot Temporary Report from storage
     * @memberof PilotReportLocalEditFactory
     */
    function deleteTempReport() {
      localStorageMD5Service.remove('pilotReportLocalEdit_TEMP');
    }

    /**
     * Delete Selected repport
     * @memberof PilotReportLocalEditFactory
     * @param {string} reportGuid The report's Identifier
     */
    function deleteReport(reportGuid) {
      var allReports = getPilotReportsFromStorage();
      if (allReports == null) return false;
      var updatedReports = [];
      var arrayLength = allReports.length;
      var reportIndex = -1;
      for (var i = 0; i < arrayLength; i++) {
        if (allReports[i].ReportGuid == reportGuid) {
          reportIndex = i;
          // break;
        } else {
          updatedReports.push(allReports[i]); // copy report in new array
        }
      }

      if (reportIndex = -1) {
        setPilotReportsToStorage(updatedReports);
      }
    }

    /**
     * Get the Pilot repport of this flight
     * @memberof PilotReportLocalEditFactory
     * @param {number} flightId A flight Id
     * @return {Object} report 
     */
    function getPilotReportLocalEditFromTemp() {
      var pilotReportLocalEdit = localStorageMD5Service.get('pilotReportLocalEdit_TEMP');
      pilotReportLocalEdit = checkForNewGroundServices(pilotReportLocalEdit);
      return fromObject(pilotReportLocalEdit);
    }

    /**
     * Get the Pilot repport of this flight
     * @memberof PilotReportLocalEditFactory
     * @param {number} flightId A flight Id
     * @return {Object} report 
     */
    function getPilotReportLocalEditForFlight(flightId) {
      var pilotReportLocalEdits = getPilotReportsFromStorage();
      if (pilotReportLocalEdits == null) return null;
      var result = null;
      var arrayLength = pilotReportLocalEdits.length;
      for (var i = 0; i < arrayLength; i++) {
        if (pilotReportLocalEdits[i].FlightId == flightId) {
          result = pilotReportLocalEdits[i];
          break;
        }
      }
      result = checkForNewGroundServices(result);
      return result;
    }
    /**
     * Get the Pilot repport
     * @memberof PilotReportLocalEditFactory
     * @param {string} reportGuid A report Id
     * @return {Object} report 
     */
    function getPilotReportLocalEdit(reportGuid) {
      var pilotReportLocalEdits = getPilotReportsFromStorage();
      if (pilotReportLocalEdits == null) return null;
      var result = null;
      var arrayLength = pilotReportLocalEdits.length;
      for (var i = 0; i < arrayLength; i++) {
        if (pilotReportLocalEdits[i].ReportGuid == reportGuid) {
          result = pilotReportLocalEdits[i];
          break;
        }
      }
      result = checkForNewGroundServices(result);
      return result;
    }

    /**
           * add any new ground services from storage to the existing report
           * @memberof PilotReportLocalEditFactory
     * @param {Object} report
           * @return {Object} report 
           */
    function checkForNewGroundServices(report) {
      if (report == null) return report;
      var depStorageGroundServices = GroundServicesFactory.getGroundServicesByStation(report.Departure);
      //var arrStorageGroundServices =  GroundServicesFactory.getGroundServicesByStation(report.Arrival);
      for (var i = 0; i < depStorageGroundServices.length; i++) {
        var found = false;
        for (var j = 0; j < report.DepartureGroundServices.length; j++) {
          if (depStorageGroundServices[i].ServiceType === report.DepartureGroundServices[j].ServiceType) {
            //this ground service is available according to the localstorage but its not in the report
            found = true;
            break;
          }
        }
        if (!found) {
          report.DepartureGroundServices.push(depStorageGroundServices[i]);
        }
      }
      // for (var i = 0; i < arrStorageGroundServices.length; i++) {
      // 	var found = false;
      // 	for (var j = 0; j < report.ArrivalGroundServices.length; j++){
      // 		if (arrStorageGroundServices[i].ServiceType === report.ArrivalGroundServices[j].ServiceType){
      // 			//this ground service is available according to the localstorage but its not in the report
      // 			found = true;
      // 			break;
      // 		}
      // 	}
      // 	if (!found){
      // 		report.ArrivalGroundServices.push(arrStorageGroundServices[i]);
      // 	}
      // }
      return report;
    }

    /**
     * Get the number of reports that need to be synched
     * @memberof PilotReportLocalEditFactory
     * @return {number} result A Pilot Report
     */
    function getPilotReportLocalEditCountThatNeedToBeSynched() {
      var pilotReportLocalEdits = getPilotReportsFromStorage();
      if (pilotReportLocalEdits == null) return 0;
      var result = 0;
      var arrayLength = pilotReportLocalEdits.length;
      for (var i = 0; i < arrayLength; i++) {
        if (pilotReportLocalEdits[i].Status === 'completed') {
          result++;
        }
      }
      return result;
    }
    function getPilotReportLocalEditThatNeedToBeSynched() {
      var result = new Array();
      var pilotReportLocalEdits = getPilotReportsFromStorage();
      if (pilotReportLocalEdits == null) return result;
      var arrayLength = pilotReportLocalEdits.length;
      for (var i = 0; i < arrayLength; i++) {
        if (pilotReportLocalEdits[i].Status === 'completed') {
          result.push(pilotReportLocalEdits[i]);
        }
      }
      return result;
    }

    /**
     * Gonstructor for a new Pilot Report
     * @memberof PilotReportLocalEditFactory
     * @return {array} result 
     */
    function getNewReport() {
      return new PilotReportLocalEdit();
    }

    /**
     * Mark selected report As Synched
     * @memberof PilotReportLocalEditFactory
     * @param {string} reportGuid The report Guid
     * @return {boolean} isSuccess 
     */
    function markReportAsSynched(reportGuid) {
      var report = getPilotReportLocalEdit(reportGuid);
      if (report == null) return false;
      report.Status = 'synched';
      report.saveReport();
      return true;
    }

    /**
     * Save  Selected Pilot repport
     * @memberof PilotReportLocalEditFactory
     * @param {Object} report A Pilot Report
     */
    function setPilotReportToStorage(report) {
      var allReports = getPilotReportsFromStorage();
      if (allReports == null) return false; // cannot delete a report, if none exist

      // find the current report from the array (if present)
      var updatedReports = [];
      var arrayLength = allReports.length;
      var reportIndex = -1;
      for (var i = 0; i < arrayLength; i++) {
        if (allReports[i].ReportGuid == report.ReportGuid) {
          updatedReports.push(report);
          reportIndex = i;
        } else {
          updatedReports.push(allReports[i]); // copy report in new array
        }
      }

      if (reportIndex != -1) {
        setPilotReportsToStorage(updatedReports);
      }
    }

    /**
         * Get flight ids with pending reports 
         * @memberof PilotReportLocalEditFactory
         * @return [long] List of flight ids 
         */
    function getFlightIdsWithPendingReports() {
      var pilotReportLocalEdits = getPilotReportsFromStorage();
      var flightIds = [];
      if (pilotReportLocalEdits != null) {
        var now = moment();
        //var now = moment('2016-06-14') //For debug;
        for (var i = 0; i < pilotReportLocalEdits.length; i++) {
          var flightDate = moment(pilotReportLocalEdits[i].FlightDate);
          if (pilotReportLocalEdits[i].Status !== 'stored' && now.diff(flightDate, 'days') < 5) {
            flightIds.push(pilotReportLocalEdits[i].FlightId);
          }
        }
      }
      return flightIds;
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('PilotReportLocalEditCreatorFactory', PilotReportLocalEditCreatorFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name PilotReportLocalEditCreatorFactory
  * @description 
  *  Create a new local Report
  * @ngInject
  */
  function PilotReportLocalEditCreatorFactory($log, localStorageMD5Service, FlightFactory, ReportGuidFactory, PilotReportTemplateFactory, PilotReportLocalEditFactory, UserFactory, GroundServicesFactory, acuSupportingAcTypes) {
    var service = {
      createNewLocalReportForFlight: createNewLocalReportForFlight
    };

    /**
     * Create a new Local Report For the Selected Flight
     * @memberof PilotReportLocalEditCreatorFactory
     * @param {number} flightId 
     * @returns {object} report 
     */
    function createNewLocalReportForFlight(flightId, flightAimsId) {
      // load the user
      var user = UserFactory.getUser();
      if (user == null) return null;

      // check if a report exists for this flight and user
      var existingReport = PilotReportLocalEditFactory.getPilotReportLocalEditForFlight(flightId);
      if (existingReport != null) return existingReport;

      // get a guid for the report
      var newReportGuid = ReportGuidFactory.getNextGuid();
      if (newReportGuid == null) return null;

      // load the pilot report template
      var reportTemplate = PilotReportTemplateFactory.getPilotReportTemplateFromStorage();
      if (reportTemplate == null) return null;

      // load the flight
      var flight = FlightFactory.getFlightFromStorage(flightId, flightAimsId);
      if (flight == null) {
        // if not found, also check the local flights
        var flight = FlightFactory.getLocalFlightFromStorage(flightId, flightAimsId);

        // if still not found, then return null
        if (flight == null) return null;
      }

      // create the new report
      var newReport = PilotReportLocalEditFactory.getNewReport();

      // assign data on the new report
      newReport.AuthorId = user.id;
      newReport.AuthorAimsId = user.aimsId;
      newReport.AuthorName = user.name;
      newReport.Created = new Date();
      newReport.FlightAimsId = flight.FlightAimsId;
      newReport.FlightId = flight.FlightId;
      newReport.LastUpdated = new Date();
      newReport.AcType = flight.AcType;
      newReport.AcTailNo = flight.AcTailNo;
      newReport.FlightDate = flight.FlightDate;
      newReport.FlightNo = flight.FlightNo;
      newReport.Departure = flight.Departure;
      newReport.Arrival = flight.Arrival;
      newReport.ScheduledDeparture = flight.ScheduledDeparture;
      newReport.ScheduledDepartureDateUTC = flight.ScheduledDepartureDateUTC;
      newReport.ScheduledDepartureTimeUTC = flight.ScheduledDepartureTimeUTC;
      newReport.ReportGuid = newReportGuid;
      newReport.ReportId = null;
      newReport.NothingToReport = false;
      newReport.Status = 'pending';
      newReport.Sections = reportTemplate.Sections;
      //details from flight (assuming flight contains these fields)

      if (flight.DepartureName) {
        newReport.DepartureICAO = flight.DepartureICAO;
        newReport.DepartureCountry = flight.DepartureCountry;
        newReport.DepartureName = flight.DepartureName;
        newReport.ArrivalICAO = flight.ArrivalICAO;
        newReport.ArrivalCountry = flight.ArrivalCountry;
        newReport.ArrivalName = flight.ArrivalName;
      }
      //pax figures from flight (assuming flight contains these figures)
      if (typeof flight.BookedY != 'undefined') {
        newReport.BookedC = flight.BookedC;
        newReport.BookedY = flight.BookedY;
        newReport.BookedInf = flight.BookedInf;
        newReport.BookedPad = flight.BookedPad;
        newReport.BookedChld = flight.BookedChld;
        newReport.ActualC = flight.ActualC;
        newReport.ActualY = flight.ActualY;
        newReport.ActualInf = flight.ActualInf;
        newReport.ActualPad = flight.ActualPad;
        newReport.ActualChld = flight.ActualChld;
      }
      newReport.crew = flight.crew;

      //new values
      newReport.DepartureTimezone = flight.DepartureTimezone;
      newReport.ArrivalTimezone = flight.ArrivalTimezone;
      newReport.CallSign = flight.CallSign;
      newReport.ScheduledArrival = flight.ScheduledArrival;
      newReport.DepartureGate = flight.DepartureGate;

      //add ground services
      newReport.DepartureGroundServices = GroundServicesFactory.getGroundServicesByStation(flight.Departure);
      //We don't show Arrival Services any more...
      //newReport.ArrivalGroundServices = GroundServicesFactory.getGroundServicesByStation(flight.Arrival);

      //ACU provision
      if (acuSupportingAcTypes.includes(flight.AcType) && (flight.Departure == 'ATH' || flight.Departure == 'SKG' || flight.Departure == 'PAS')) {
        newReport.ACUProvision.isRequired = true;
      }
      newReport.updateTotals();

      // return the new report
      return newReport;
    }
    return service;
  }
  ;
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('PilotReportSendToServerFactory', PilotReportSendToServerFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name PilotReportSendToServerFactory
  * @description 
  *   Transform Pilot Reports in order to send them to the server
  * @ngInject
  */
  function PilotReportSendToServerFactory($log) {
    /**
    * Initialize the PilotReportSendToServer
    * @memberof PilotReportSendToServerFactory
    */
    function PilotReportSendToServer() {
      this.Created = null;
      this.LastUpdated = null;
      this.FlightAimsId = null;
      this.FlightId = null;
      this.FlightDate = null;
      this.FlightNo = null;
      this.Departure = null;
      this.Arrival = null;
      this.ReportGuid = null;
      this.AuthorCrewId = null;
      this.AuthorCrewAimsId = null;
      this.Items = [];
      this.Autoland = 'manual';
      this.AutolandWorkOrderNo = null;
      this.ArrivalGroundServices = [];
      this.DepartureGroundServices = [];
      this.AutolandReason = null;
      this.ManualLandingComments = null;
    }

    /**
    * Initialize the PilotReportSendToServerItem
    * @memberof PilotReportSendToServerFactory
    */
    function PilotReportSendToServerItem() {
      this.ReportGuid = null;
      this.TemplateItemId = null;
      this.Value = 0;
      this.Remarks = '';
      this.DelayMinutes = null;
    }
    var service = {
      getCompletedListFromPilotReportLocalEdits: getCompletedListFromPilotReportLocalEdits
    };

    /**
     * Transform all cabin local reports in order to be sent to the server
     * @memberof PilotReportSendToServerFactory
     * @param {Array} pilotReportLocalEdits
     * @returns {Array} PilotReportsSendToServer 
     */
    function getCompletedListFromPilotReportLocalEdits(pilotReportLocalEdits) {
      var result = [];
      if (pilotReportLocalEdits == null) return result;
      var arrayLength = pilotReportLocalEdits.length;
      for (var i = 0; i < arrayLength; i++) {
        if (pilotReportLocalEdits[i].Status === 'completed') {
          result.push(getReportFromPilotReportLocalEdit(pilotReportLocalEdits[i]));
        }
      }

      //Temporary: fix: Ground Services:  Used values (true/false) from local storage.
      var resultChecked = fixUsedValueLS(result);
      return resultChecked;
    }

    //Temporary: fix - Ground Services - local storage from true/false values. (int Used: 0:false, 1:true, 2:inop) 
    function fixUsedValueLS(cabinReportLocalEdits) {
      for (var i = 0; i < cabinReportLocalEdits.length; i++) {
        if (cabinReportLocalEdits[i].DepartureGroundServices.length > 0) {
          for (var j = 0; j < cabinReportLocalEdits[i].DepartureGroundServices.length; j++) {
            if (cabinReportLocalEdits[i].DepartureGroundServices[j]) {
              if (cabinReportLocalEdits[i].DepartureGroundServices[j].Used === true) {
                cabinReportLocalEdits[i].DepartureGroundServices[j].Used = 1;
              } else if (cabinReportLocalEdits[i].DepartureGroundServices[j].Used === false) {
                cabinReportLocalEdits[i].DepartureGroundServices[j].Used = 0;
              }
            }
          }
        }
      }
      return cabinReportLocalEdits;
    }

    /**
    * Transform a pilot local reports in order to be sent to the server
    * @memberof PilotReportSendToServerFactory
    * @param {object} pilotReportLocalEdit
    * @returns {object} PilotReportSendToServer 
    */
    function getReportFromPilotReportLocalEdit(pilotReportLocalEdit) {
      var result = new PilotReportSendToServer();
      result.Created = pilotReportLocalEdit.Created;
      result.LastUpdated = pilotReportLocalEdit.LastUpdated;
      result.FlightAimsId = pilotReportLocalEdit.FlightAimsId;
      result.FlightId = pilotReportLocalEdit.FlightId;
      result.FlightDate = pilotReportLocalEdit.FlightDate;
      result.FlightNo = pilotReportLocalEdit.FlightNo;
      result.Departure = pilotReportLocalEdit.Departure;
      result.Arrival = pilotReportLocalEdit.Arrival;
      result.ReportGuid = pilotReportLocalEdit.ReportGuid;
      result.AuthorCrewId = pilotReportLocalEdit.AuthorId;
      result.AuthorCrewAimsId = pilotReportLocalEdit.AuthorAimsId;
      result.Items = new Array();
      //result.ArrivalGroundServices = pilotReportLocalEdit.ArrivalGroundServices;
      result.DepartureGroundServices = pilotReportLocalEdit.DepartureGroundServices;
      result.ACUProvisionValue = pilotReportLocalEdit.ACUProvision.value;
      result.ACUProvisionRemarks = pilotReportLocalEdit.ACUProvision.remarks;
      result.ACUProvisionDelayMinutes = pilotReportLocalEdit.ACUProvision.delayMinutes;
      if (pilotReportLocalEdit.AutolandSatisfactory) {
        result.Autoland = 'AutolandSatisfactory';
      } else if (pilotReportLocalEdit.AutolandUnsatisfactory) {
        result.Autoland = 'AutolandUnsatisfactory';
        result.AutolandWorkOrderNo = pilotReportLocalEdit.AutolandWorkOrderNo;
      } else if (pilotReportLocalEdit.ManualLanding) {
        result.Autoland = 'ManualLanding';
        result.ManualLandingComments = pilotReportLocalEdit.ManualLandingComments;
      } else if (pilotReportLocalEdit.catApproachUnsatisfactory) {
        result.Autoland = 'CATApproachUnsatisfactory';
      } else if (pilotReportLocalEdit.catApproachSatisfactory) {
        result.Autoland = 'CATApproachSatisfactory';
      }
      if (pilotReportLocalEdit.AutolandReasonIsLowVisibility) {
        result.AutolandReason = 'LVP in Force';
      } else if (pilotReportLocalEdit.AutolandReasonIsPractice) {
        result.AutolandReason = 'Practice Autoland';
      }
      var sectionCount = pilotReportLocalEdit.Sections.length;
      for (var i = 0; i < sectionCount; i++) {
        var itemCount = pilotReportLocalEdit.Sections[i].Items.length;
        for (var j = 0; j < itemCount; j++) {
          var newItem = new PilotReportSendToServerItem();
          newItem.ReportGuid = pilotReportLocalEdit.ReportGuid;
          newItem.TemplateItemId = pilotReportLocalEdit.Sections[i].Items[j].Id;
          newItem.Value = pilotReportLocalEdit.Sections[i].Items[j].ItemHasValue ? 1 : 0;
          if (newItem.Value == 1) {
            newItem.Remarks = pilotReportLocalEdit.Sections[i].Items[j].ItemValue;
          }
          newItem.DelayMinutes = pilotReportLocalEdit.Sections[i].Items[j].DelayMinutes;
          result.Items.push(newItem);
        }
      }
      return result;
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('PilotReportSyncResultFactory', PilotReportSyncResultFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name PilotReportSyncResultFactory
  * @description 
  *   Manage Pilot Report Sync Results
  * @ngInject
  */
  function PilotReportSyncResultFactory($log, GenericService) {
    /**
    * Initialize the PilotReportSyncResult
    * @memberof PilotReportSyncResultFactory
    */
    function PilotReportSyncResult() {
      this.reportGuid = null;
      this.message = null;
      this.success = null;
      this.FlightAimsId = null;
      this.FlightId = null;
      this.ScheduledDepartureDateUTC = null;
      this.FlightNo = null;
      this.Departure = null;
      this.Arrival = null;
      this.ScheduledDepartureTimeUTC = null;
      this.AcTailNo = null;
      this.Result = null;
      this.getRoute = getRoute;
    }
    var objType = 'pilotReportSyncResult';
    var objCallback = PilotReportSyncResult;
    var service = {
      fromObjectList: fromObjectList,
      getSyncResult: getSyncResult,
      getPilotReportSyncResultsFromStorage: getPilotReportSyncResultsFromStorage,
      setPilotReportSyncResultsToStorage: setPilotReportSyncResultsToStorage,
      clearPilotReportSyncResultsFromStorage: clearPilotReportSyncResultsFromStorage,
      getSuccesses: getSuccesses,
      getFailures: getFailures
    };

    /**
    * Get Report Route
    * @memberof PilotReportSyncResultFactory
    * @return {string} route
    */
    function getRoute() {
      if (this.Departure == null && this.Arrival == null) return '-null-';else return (this.Departure || '?') + '-' + (this.Arrival || '?');
    }

    /**
     * Extend an array of Objects from the default PilotReportSyncResult Object
     * @memberof PilotReportSyncResultFactory
     * @param {Array} objList  an Array Of Pilot Report Sync Results
     * @returns {Array} PilotReportSyncResults
     */
    function fromObjectList(objList) {
      return GenericService.fromObjectList(objList, objCallback);
    }

    /**
     * Get Sync Result  from given list
     * @memberof PilotReportSyncResultFactory
     * @param {Array} syncResults  an Array Of Pilot Report Sync Results
     * @param {string} reportGuid The report's Guid
     * @returns {object} PilotReportSyncResult
     */
    function getSyncResult(syncResults, reportGuid) {
      var result = null;
      var arrayLength = syncResults.length;
      for (var i = 0; i < arrayLength; i++) {
        if (syncResults[i].reportGuid == reportGuid) {
          result = syncResults[i];
          break;
        }
      }
      return result;
    }

    /**
     * Get Sync Results
     * @memberof PilotReportSyncResultFactory
     * @returns {array} PilotReportSyncResults
     */
    function getPilotReportSyncResultsFromStorage() {
      return GenericService.list(objType, objCallback);
    }

    /**
     * Get Sync Results
     * @memberof PilotReportSyncResultFactory
     * @returns {array} PilotReportSyncResults
     */
    function setPilotReportSyncResultsToStorage(pilotReportSyncResults) {
      GenericService.saveAll(pilotReportSyncResults, objType, objCallback);
    }

    /**
     * Clear all Pilot Sync Results
     * @memberof PilotReportSyncResultFactory
     * @returns {array} PilotReportSyncResults
     */
    function clearPilotReportSyncResultsFromStorage() {
      GenericService.removeAll(objType, objCallback);
    }

    /**
     * Get Successfull Sync Results from given syncResult
     * @memberof PilotReportSyncResultFactory
     * @returns {array} successes
     */
    function getSuccesses(syncResults) {
      var result = 0;
      for (var i = 0; i < syncResults.length; i++) {
        if (syncResults[i].success == true) {
          result = result + 1;
        }
      }
      return result;
    }

    /**
     * Get Failed Sync Results from given syncResults
     * @memberof PilotReportSyncResultFactory
     * @returns {array} failures
     */
    function getFailures(syncResults) {
      var result = 0;
      for (var i = 0; i < syncResults.length; i++) {
        if (syncResults[i].success == false) {
          result = result + 1;
        }
      }
      return result;
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('PilotReportTemplateFactory', PilotReportTemplateFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name PilotReportTemplateItemFactory
  * @description 
  *   Manage Pilot Report Template Item.
  * @ngInject
  */
  function PilotReportTemplateFactory($log, localStorageMD5Service, GenericService) {
    /**
    * Initialize the PilotReportTemplate
    * @memberof PilotReportTemplateFactory
    */
    function PilotReportTemplate() {
      this.Sections = new Array();
      this.getDescription = getDescription;
    }

    /**
    * Initialize the PilotReportTemplateItem
    * @memberof PilotReportTemplateFactory
    */
    function PilotReportTemplateItem() {
      this.Id = null;
      this.Description = null;
      this.Label = null;
      this.OrderNo = null;
      this.CategoryLabel = null;
      this.PresetComments = null;
    }

    /**
    * Initialize the PilotReportTemplateSection
    * @memberof PilotReportTemplateFactory
    */
    function PilotReportTemplateSection() {
      this.Id = null;
      this.Label = null;
      this.OrderNo = null;
      this.Items = new Array();
    }
    function getDescription() {
      if (this.Sections == null) return '-null-';else return this.Sections.length;
    }
    var service = {
      getPilotReportTemplateFromStorage: getPilotReportTemplateFromStorage,
      setPilotReportTemplateToStorage: setPilotReportTemplateToStorage,
      clearPilotReportTemplateFromStorage: clearPilotReportTemplateFromStorage
    };
    function fromObject(obj) {
      if (obj == null) return null;
      var rptt = new PilotReportTemplate();
      angular.extend(rptt, obj);

      // extend sections
      var sectionsTemp = rptt.Sections.slice();
      rptt.Sections = new Array();
      var sectionCount = sectionsTemp.length;
      for (var i = 0; i < sectionCount; i++) {
        var sct = new PilotReportTemplateSection();
        angular.extend(sct, sectionsTemp[i]);
        rptt.Sections.push(sct);

        // extend section items
        var itemsTemp = sectionsTemp[i].Items.slice();
        sct.Items = new Array();
        var itemCount = itemsTemp.length;
        for (var j = 0; j < itemCount; j++) {
          var itm = new PilotReportTemplateItem();
          angular.extend(itm, sectionsTemp[i].Items[j]);
          sct.Items.push(itm);
        }
      }
      return rptt;
    }
    ;

    /**
     * Get Pilot Report Template Items
     * @memberof PilotReportTemplateItemFactory
     * @returns {Array} PilotReportTemplateItems 
     */
    function getPilotReportTemplateFromStorage() {
      var pilotReportTemplate = localStorageMD5Service.get('pilotReportTemplate');
      return fromObject(pilotReportTemplate);
    }

    /**
     * Save Pilot Report Template Items to storage
     * @memberof PilotReportTemplateItemFactory
     * @param {Array} PilotReportTemplateItems A list of Pilot Report Template Items
     */
    function setPilotReportTemplateToStorage(pilotReportTemplate) {
      localStorageMD5Service.set('pilotReportTemplate', pilotReportTemplate);
    }

    /**
    * Clear Pilot Report Template from storage
    * @memberof PilotReportTemplateItemFactory
    * @param {Array} PilotReportTemplateItems A list of Pilot Report Template Items
    */
    function clearPilotReportTemplateFromStorage() {
      localStorageMD5Service.remove('pilotReportTemplate');
    }

    // Return constructor - this is what defines the actual
    // injectable in the DI framework.
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('ReportCtrl', ReportCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name ReportCtrl
  * @description 
  *  Manages the Report View
  * @ngInject
  */
  function ReportCtrl($scope, $routeParams, UserFactory, AircaftPositionsFactory, FlightFactory, PilotReportLocalEditFactory, PilotReportLocalEditCreatorFactory, $location, SettingsMain, $timeout, ReportGuidFactory, $route, aircraftLateArrivalReportId, inadequateGroundTimeReportId, FlightDelaysFactory, autolandSupportingAcTypes, showCatIIApprachAcTypes) {
    $scope.discard = discard;
    $scope.infoSaveOperation = infoSaveOperation;
    $scope.setCategory = setCategory;
    $scope.state = 'report';
    $scope.deleteReportClicked = deleteReportClicked;
    $scope.autoAdjustTarget = null;
    $scope.autoAdjustTimer = null;
    $scope.autoAdjustRun = autoAdjustRun;
    $scope.saveDraftClicked = saveDraftClicked;
    $scope.saveClicked = saveClicked;
    $scope.cancelClicked = cancelClicked;
    $scope.reportItemValueChanged = reportItemValueChanged;
    $scope.adjustTextarea = adjustTextarea;
    $scope.clearRemarks = clearRemarks;
    $scope.reportChanged = reportChanged;
    $scope.AutolandChanged = AutolandChanged;
    $scope.CatApproachChanged = CatApproachChanged;
    $scope.AutolandReasonChanged = AutolandReasonChanged;
    $scope.updateAutolandStatus = updateAutolandStatus;
    $scope.CatAutolandReasonChanged = CatAutolandReasonChanged;
    $scope.updateCatAutolandStatus = updateCatAutolandStatus;
    $scope.isValidWorkOrderNo = false;
    $scope.workOrderNo = null;
    $scope.validationWorkOrderNo = validationWorkOrderNo;
    $scope.autoGetDelaysInItems = autoGetDelaysInItems;
    $scope.autoGetDelaysIsExecuted = false;
    $scope.enableAutofillDelaysButton = false;
    $scope.flightDelays = null;
    $scope.sumReportedDelay = null;
    $scope.plusNumber = plusNumber;
    $scope.minusNumber = minusNumber;
    $scope.clearNumber = clearNumber;
    $scope.clearACUProvisionRemarks = clearACUProvisionRemarks;
    $scope.updateACUProvisionValue = updateACUProvisionValue;
    $scope.updateACUProvisionRemarks = updateACUProvisionRemarks;
    $scope.plusACUMinutes = plusACUMinutes;
    $scope.minusACUMinutes = minusACUMinutes;
    $scope.clearACUMinutes = clearACUMinutes;
    $scope.logIt = logIt;
    function logIt(x) {
      console.log("User = " + JSON.stringify(x));
    }

    // get the report id
    var reportId = $routeParams.reportId;
    var report = null;

    // show logged user info
    var user = UserFactory.getUser();
    $scope.logged_user_info = user.aimsId + ' - ' + user.name;
    $scope.isSecure = UserFactory.isSecure();

    // new / edit existing / load from temp
    if (reportId.startsWith('new:')) {
      // get the flight id
      var flightAimsId = reportId.substring(4, reportId.length);
      var flightId = $routeParams.flightId;

      // create a new report
      var newLocalReport = PilotReportLocalEditCreatorFactory.createNewLocalReportForFlight(flightId, flightAimsId);
      if (newLocalReport == null) {
        bootbox.alert("<h4>Attention</h4>Unable to create a new log!<br/>Available pool of resources has been depleted and you need to synchronize with the server to renew it.", function () {
          $location.path("/");
          $scope.$apply();
        });
        return;
      } else {
        // load the new report
        report = newLocalReport;
      }
    } else if (reportId == 'temp') {
      // load the report from the temp place
      report = PilotReportLocalEditFactory.getPilotReportLocalEditFromTemp();
      if (report == null) {
        // since we could not load the temp report, delete it
        PilotReportLocalEditFactory.deleteTempReport();
        bootbox.alert("<h4>Warning</h4>Unable to load temporary log.<br/>No temporary log found in this device", function () {
          $location.path("/");
          $scope.$apply();
        });
        return;
      }
    } else {
      // load the report
      report = PilotReportLocalEditFactory.getPilotReportLocalEdit(reportId);
      if (report == null) {
        bootbox.alert("<h4>Warning</h4>Unable to load the requested log.<br/>This entry does not exist in this device, our its data are corrupted and the entry is unusable.", function () {
          $location.path("/");
          $scope.$apply();
        });
        return;
      }
    }

    //flight
    var flight = FlightFactory.getFlightFromTotalFlights(report.FlightId);

    //Get flight delays
    $scope.flightDelays = FlightDelaysFactory.getFlightDelaysByFlightId(report.FlightId);
    if ($scope.flightDelays) {
      //Update scope for the visibility autofill delays button
      checkAutofillDelaysButton();
      updateSumValueOfReportedDelays();
    }
    if (!flight) {
      // go to dashboard if no flight
      $location.path("/");
    }
    $scope.showAutolandSection = autolandSupportingAcTypes.includes(flight.AcType);
    $scope.showCatIIApprachSection = showCatIIApprachAcTypes.includes(flight.AcType);

    /*       //find late arrival report item and fill it with previous Late Aircraft Arrival
            var lateArrivalreportItem = null; 
            report.Sections.forEach(
                function(section){
                    var filteredItems = section.Items.filter(
                        function(item){
                            return item.Id == aircraftLateArrivalReportId
                        });
                    if(filteredItems.length==1){
                        lateArrivalreportItem = filteredItems[0];
                    }
                }
            );
            
            var inadequateGroundTimeReportItem = null; 
            report.Sections.forEach(
                function(section){
                    var filteredItems = section.Items.filter(
                        function(item){
                            return item.Id == inadequateGroundTimeReportId
                        });
                    if(filteredItems.length==1){
                        inadequateGroundTimeReportItem = filteredItems[0];
                    }
                }
            );*/

    /*        var aircaftPositions =  AircaftPositionsFactory.getAircaftPositionsByFlightId(flight.FlightId);
            if(aircaftPositions && aircaftPositions.PreviousSTA && !$scope.isTurboProp){
                var startofTAT = moment.utc(flight.ScheduledDeparture).add(-45, 'm');
                var prevATA = moment.utc(aircaftPositions.PreviousATA);
                var prevSTA = moment.utc(aircaftPositions.PreviousSTA);
                var lateArrival = 0;
                var inadequateGroundTime = 0;
                    if(startofTAT.diff(prevSTA, 'm')>=0 && aircaftPositions.PreviousATA){
                  
                        var comparedValue = startofTAT;
                        if(lateArrival > 0){
                            var comparedValue = prevATA;
                        }
                        lateArrival = prevATA.diff(comparedValue, 'm');
                    }else{
                        lateArrival = aircaftPositions.PreviousATA ? prevATA.diff(prevSTA, 'm') : 0;
                        inadequateGroundTime = prevSTA.diff(startofTAT, 'm');
                        if(lateArrival<0){
                            inadequateGroundTime = inadequateGroundTime + lateArrival;
                        }
                    }
                
                if(lateArrival>0 && lateArrivalreportItem && !lateArrivalreportItem.ItemHasValue){
                    lateArrivalreportItem.ItemValue = "Late Aircraft Arrival " + lateArrival + " minutes";
                    lateArrivalreportItem.ItemHasValue= true;
                }
                
                if(inadequateGroundTime>0 && inadequateGroundTimeReportItem && !inadequateGroundTimeReportItem.ItemHasValue){
                    inadequateGroundTimeReportItem.ItemValue = "Inadequate Ground Time " + inadequateGroundTime + " minutes";
                    inadequateGroundTimeReportItem.ItemHasValue= true;
                }
            }
            */

    $scope.flight = flight;
    $scope.panels = {
      delays: {
        open: true
      },
      showOnlyOne: true,
      report: {
        visible: true,
        open: true,
        cssClass: function cssClass() {
          return report.IsValid ? 'panel-green' : 'panel-orange';
        }
      },
      autoland: {
        open: report.AutolandSatisfactory || report.AutolandUnsatisfactory
      },
      catApproach: {
        open: report.catApproachSatisfactory || report.catApproachUnsatisfactory
      },
      Flight: {
        visible: true,
        open: false,
        cssClass: function cssClass(report) {
          if (report.WarningItems > 0) return 'panel-orange';else if (report.ActiveItems > 0) return 'panel-green';else return 'panel-default';
        }
      },
      groundServices: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          if (report.GroundServicesSectionHasValue) return 'panel-green';else return 'panel-default';
        }
      },
      acuProvision: {
        visible: true,
        open: false,
        cssClass: function cssClass() {
          if (report.ACUProvision.isValid) return 'panel-green';else if (report.ACUProvision.isRequired && !report.ACUProvision.isValid) {
            return 'panel-orange';
          } else return 'panel-default';
        }
      }
    };
    $scope.GetCategoryCSS = GetCategoryCSS;
    function GetCategoryCSS(items, category) {
      var itemsInCategory = items.filter(function (item) {
        return item.CategoryLabel == category;
      });
      var completed = itemsInCategory.some(function (item) {
        return item.ItemHasValue == true && item.ItemValue && item.ItemValue.length > 0;
      });
      var draft = itemsInCategory.some(function (item) {
        return item.ItemHasValue == true && (!item.ItemValue || item.ItemValue == "");
      });
      if (draft) return 'panel-orange';else if (completed) return 'panel-green';else return 'panel-gray';
    }
    $scope.countDHC = 0;
    if (report.crew) $scope.countDHC = report.crew.filter(function (item) {
      return item.isDHC == true;
    }).length;
    if (report && report.ScheduledArrival) {
      var nowTimeStamp = new Date().getTime();
      var schedullDepartureTimestamp = new Date(report.ScheduledArrival).getTime();
      $scope.isFuture = nowTimeStamp < schedullDepartureTimestamp;
    }
    $scope.showCompleted = showCompleted;
    $scope.showAll = showAll;
    $scope.compressedMode = false;
    function showCompleted() {
      $scope.panels.report.open = !$scope.panels.report.open;
      $scope.compressedMode = true;
    }
    function showAll() {
      $scope.panels.report.open = !$scope.panels.report.open;
      $scope.compressedMode = false;
    }

    // update totals and set to scope
    report.updateTotals();
    $scope.report = report;
    var categoryFilter = null;
    var categoryFilters = [];
    for (var i = 0; i < report.Sections.length; i++) {
      categoryFilter = {
        category: '',
        section: report.Sections[i].Label
      };
      categoryFilters.push(categoryFilter);
    }
    $scope.categoryfilters = categoryFilters;

    // save the report to a temp place
    if (report.Status != 'synched') report.saveReportAsTemp();

    // set editing page to report
    SettingsMain.setEditingPage('report');

    /**
     * When report changes run to update the item
     * @memberof ReportCtrl
     */
    function reportChanged(item) {
      // put preset comments
      if (item != null) {
        if (item.PresetComments != null) {
          if (item.ItemValue == null || item.ItemValue == '') {
            item.ItemValue = item.PresetComments;
          }
        }
      }
      updateSumValueOfReportedDelays();

      // update the report totals
      report.updateTotals();

      // save the report to a temp place
      if (report.Status != 'synched') report.saveReportAsTemp();
    }
    function AutolandChanged(result) {
      if (result == true && report.AutolandSatisfactory) {
        report.AutolandUnsatisfactory = false;
        report.ManualLanding = false;
      } else if (result == false && report.AutolandUnsatisfactory) {
        report.AutolandSatisfactory = false;
        report.ManualLanding = false;
      } else if (result == "manual" && report.ManualLanding) {
        report.AutolandUnsatisfactory = false;
        report.AutolandSatisfactory = false;
      }
      reportChanged();
    }
    function CatApproachChanged(result) {
      if (result == true && report.catApproachSatisfactory) {
        report.catApproachUnsatisfactory = false;
        report.ManualLanding = false;
      } else if (result == false && report.catApproachUnsatisfactory) {
        report.catApproachSatisfactory = false;
        report.ManualLanding = false;
      } else if (result == "manual" && report.ManualLanding) {
        report.catApproachUnsatisfactory = false;
        report.catApproachSatisfactory = false;
      }
      reportChanged();
    }
    function AutolandReasonChanged(result) {
      if (result == true) {
        report.AutolandReasonIsPractice = false;
        report.AutolandSatisfactory = false;
        report.AutolandUnsatisfactory = false;
        report.ManualLanding = false;
        report.AutolandWorkOrderNo = "";
        report.ManualLandingComments = "";
      } else if (result == false) {
        report.AutolandReasonIsLowVisibility = false;
        report.AutolandSatisfactory = false;
        report.AutolandUnsatisfactory = false;
        report.ManualLanding = false;
        report.AutolandWorkOrderNo = "";
        report.ManualLandingComments = "";
      }
      reportChanged();
    }
    function CatAutolandReasonChanged(result) {
      if (result == true) {
        report.AutolandReasonIsPractice = false;
        report.catApproachUnsatisfactory = false;
        report.catApproachSatisfactory = false;
        report.ManualLanding = false;
        report.ManualLandingComments = "";
      } else if (result == false) {
        report.AutolandReasonIsLowVisibility = false;
        report.catApproachUnsatisfactory = false;
        report.catApproachSatisfactory = false;
        report.ManualLanding = false;
        report.ManualLandingComments = "";
      }
      reportChanged();
    }
    function updateAutolandStatus() {
      if (!$scope.report.AutolandSatisfactory && !$scope.report.AutolandUnsatisfactory && !report.ManualLanding) {
        $scope.report.AutolandReasonIsPractice = false;
        $scope.report.AutolandReasonIsLowVisibility = false;
      }
      reportChanged();
    }
    ;
    function updateCatAutolandStatus() {
      if (!$scope.report.catApproachSatisfactory && !$scope.report.catApproachUnsatisfactory && !report.ManualLanding) {
        $scope.report.AutolandReasonIsPractice = false;
        $scope.report.AutolandReasonIsLowVisibility = false;
      }
      reportChanged();
    }
    ;

    /**
     * Clear Remarks
     * @memberof ReportCtrl
     * @param {object} item Report s question
     */
    function clearRemarks(item) {
      // put preset comments
      if (item != null) {
        item.ItemValue = null;
        reportChanged(item);
      }
    }

    /**
         * Enable Autofill Delays Button
         * @memberof ReportCtrl
         */
    function checkAutofillDelaysButton() {
      report.Sections.forEach(function (section) {
        var filteredItems = section.Items.filter(function (item) {
          return item.DelayCodes && item.DelayCodes.length > 0;
        });
        if (filteredItems.length > 0 && $scope.flightDelays && ($scope.flightDelays.DC9 != null && $scope.flightDelays.DC9 != 0 || $scope.flightDelays.DC93 != null && $scope.flightDelays.DC93 != 0)) {
          $scope.enableAutofillDelaysButton = true;
          return;
        }
      });
    }

    /**
         * Auto Get Delays In Items
         * @memberof ReportCtrl
         */
    function autoGetDelaysInItems() {
      if ($scope.flightDelays) {
        report.Sections.forEach(function (section) {
          var filteredItems = section.Items.filter(function (item) {
            var getItem = false;
            if (item.DelayCodes && item.DelayCodes.length > 0) {
              var itemDelayCodeList = item.DelayCodes.split(',');
              if (itemDelayCodeList.includes("9") || itemDelayCodeList.includes("93")) {
                getItem = true;
              }
            }
            return getItem;
          });
          if (filteredItems.length > 0) {
            filteredItems.forEach(function (item) {
              item.DelayMinutes = GetDelayMinutes(item, $scope.flightDelays);
              if (item.DelayMinutes > 0) {
                item.ItemHasValue = true;
                item.ItemValue = "Delay minutes have been added automatically.";
              }
            });
          }
        });
      }
      reportChanged();
      $scope.autoGetDelaysIsExecuted = true;
    }

    /**
           * update Sum Value Of Reported Delays (excepts 93 and 9 codes)
           * @memberof ReportCtrl
           */
    function updateSumValueOfReportedDelays() {
      if ($scope.flightDelays) {
        var sumDelays = 0;
        report.Sections.forEach(function (section) {
          var filteredItems = section.Items.filter(function (item) {
            var getItem = false;
            if (item.ItemHasValue == true && item.DelayCodes && item.DelayCodes.length > 0) {
              var itemDelayCodeList = item.DelayCodes.split(',');
              if (!itemDelayCodeList.includes("9") && !itemDelayCodeList.includes("93")) {
                getItem = true;
              }
            }
            return getItem;
          });
          if (filteredItems.length > 0) {
            filteredItems.forEach(function (item) {
              if (item.DelayMinutes) {
                sumDelays = sumDelays + item.DelayMinutes;
              }
            });
          }
        });
        $scope.sumReportedDelay = sumDelays;
      }
    }

    /**
           * Get flight delays from local storage
           * @memberof ReportCtrl
           */
    function GetDelayMinutes(item, flightDelays) {
      var itemDelayCodeList = item.DelayCodes.split(',');
      var dc9 = 0;
      var dc93 = 0;
      if (flightDelays && itemDelayCodeList.includes("9")) {
        dc9 = flightDelays.DC9;
      }
      if (flightDelays && itemDelayCodeList.includes("93")) {
        dc93 = flightDelays.DC93;
      }

      // take the max value
      return dc9 > dc93 ? dc9 : dc93;
    }

    /**
     * increases delays minutes number 
     * @memberof ReportCtrl
     */
    function plusNumber(item) {
      // put preset comments
      if (item != null) {
        if (item.DelayMinutes != null) {
          item.DelayMinutes++;
        } else {
          item.DelayMinutes = 1;
        }
        reportChanged(item);
      }
    }
    /**
     * decreases delays minutes number 
     * @memberof ReportCtrl
     */
    function minusNumber(item) {
      if (item != null) {
        if (item.DelayMinutes != null && item.DelayMinutes > 0) {
          item.DelayMinutes--;
        } else {
          item.DelayMinutes = 0;
        }
        reportChanged(item);
      }
    }

    /**
     * Clear delays minutes number 
     * @memberof ReportCtrl
     */
    function clearNumber(item) {
      item.DelayMinutes = null;
      reportChanged(item);
    }
    function autoAdjustRun() {
      var t = $scope.autoAdjustTarget;
      t.style.overflow = 'hidden';
      t.style.height = 0;
      t.style.height = t.scrollHeight + 'px';
      if (t.style.height < 40) t.style.height = 40;
      $scope.autoAdjustTarget = null;
      $scope.autoAdjustTimer = null;

      // also, update the report and save it to a temp place
      report.updateTotals();
      if (report.Status != 'synched') report.saveReportAsTemp();
    }
    function adjustTextarea($event) {
      //$event.keyCode = 13
      //performing adjusts using a timer, to minimize times it executes, and make it faster on ipad2
      if ($scope.autoAdjustTimer != null) {
        clearTimeout($scope.autoAdjustTimer);
        //old object pending... execute its adjustment and then plan new object's adjustment
        if ($event.target != $scope.autoAdjustTarget) {
          $scope.autoAdjustRun();
        }
      }
      $scope.autoAdjustTarget = $event.target;
      $scope.autoAdjustTimer = setTimeout($scope.autoAdjustRun, 500);
    }

    /**
     * When the user types a value into a report item updates totals of the report
     * @memberof ReportCtrl
     */
    function reportItemValueChanged() {
      // update the report totals
      report.updateTotals();
    }

    /**
     * Go to calendar and reset report
     * @memberof ReportCtrl
     */
    function cancelClicked() {
      // delete the temp report
      PilotReportLocalEditFactory.deleteTempReport();

      // set editing page to none
      SettingsMain.setEditingPage(null);

      // go to dashboard
      $location.path("/");
    }

    /**
     * Save Completed and Go to calendar
     * @memberof ReportCtrl
     */
    function saveClicked() {
      // save the report
      report.Status = 'completed';
      report.saveReport();
      FlightFactory.updateFlightFromReport(report);
      // delete the temp report
      PilotReportLocalEditFactory.deleteTempReport();

      //set editing page to none
      SettingsMain.setEditingPage(null);
      infoSaveOperation(report.Status);

      // go to flight info
      $location.path('/flightinfo/' + report.FlightId);
    }

    /**
     * Save Draft
     * @memberof ReportCtrl
     */
    function saveDraftClicked() {
      // save the report
      report.Status = 'draft';
      report.saveReport();
      FlightFactory.updateFlightFromReport(report);
      // delete the temp report
      PilotReportLocalEditFactory.deleteTempReport();

      // set editing page to none
      SettingsMain.setEditingPage(null);
      infoSaveOperation(report.Status);
      // go to dashboard
      //$location.path("/");
    }

    function setCategory(category, section) {
      console.log(category);
      var newCategoryFilters = [];
      for (var i = 0; i < categoryFilters.length; i++) {
        if (categoryFilters[i].section == section) {
          categoryFilters[i] = {
            category: category,
            section: section
          };
        }
        newCategoryFilters.push(categoryFilters[i]);
      }
      categoryFilters = newCategoryFilters;
      $scope.categoryfilters = categoryFilters;
    }

    /**
     * Save Draft
     * @memberof ReportCtrl
     */
    function deleteReportClicked() {
      var status = report.status;
      var title = "Warning";
      if (status == 'synched') {
        title = "Attention";
      }
      bootbox.dialog({
        message: "Please confirm that you wish to permanently reset this CP Flight Log.",
        title: "<strong>" + title + "<strong>",
        buttons: {
          cancel: {
            label: "Cancel",
            className: "btn-default"
          },
          danger: {
            label: "Reset CP Flight Log",
            className: "btn-warning",
            callback: function callback() {
              //add code here to remove report from temp location and possibly from permanent location
              //TODO:
              PilotReportLocalEditFactory.deleteReport(report.ReportGuid);
              // delete the temp report
              PilotReportLocalEditFactory.deleteTempReport();
              FlightFactory.updateFlightFromReport(report);
              // set editing page to none
              SettingsMain.setEditingPage(null);
              //next code moves user to main page
              $timeout(function () {
                if ($location.path() == "/report/temp") {
                  $scope.openReport();
                } else {
                  $route.reload();
                }
              });
            }
          }
        }
      });
    }

    /**
     * Show information about the save action
     * @memberof ReportCtrl
     * @param {string} state The action of the save completed or draft or discard
     */
    function infoSaveOperation(state) {
      if (state == 'completed') {
        $scope.infosaveactiontype = state;
        $scope.infosaveaction = true;
      } else if (state == 'draft') {
        $scope.infosaveactiontype = state;
        $scope.infosaveaction = true;
      } else if (state == 'discard') {
        $scope.infosaveactiontype = state;
        $scope.infosaveaction = true;
      }
      $timeout(function () {
        $scope.infosaveaction = false;
      }, 5000);
    }
    function discard() {
      if (report == null) {
        report = PilotReportLocalEditFactory.getPilotReportLocalEditForFlight(flightId);
      }
      var guid = report.ReportGuid;
      var status = report.Status;

      // delete the temp report
      PilotReportLocalEditFactory.deleteTempReport();

      //reuse guid if this was a new report
      if (status == 'pending') ReportGuidFactory.restoreGuid(report.ReportGuid);

      // new / edit existing / load from temp
      if (reportId.startsWith('new:')) {
        var flightId = $routeParams.flightId;
        // create a new report
        var newLocalReport = PilotReportLocalEditCreatorFactory.createNewLocalReportForFlight(flightId);
        if (newLocalReport == null) {
          bootbox.alert("<h4>Attention</h4>Unable to create a new log!<br/>Available pool of resources has been depleted and you need to synchronize with the server to renew it.", function () {
            $location.path("/");
            $scope.$apply();
          });
        } else {
          // load the new report
          report = newLocalReport;
        }
      } else if (reportId == 'temp') {
        // load the report from the temp place
        report = PilotReportLocalEditFactory.getPilotReportLocalEditFromTemp();
        if (report == null && status != 'pending') {
          // since we could not load the temp report, delete it
          PilotReportLocalEditFactory.deleteTempReport();
          bootbox.alert("<h4>Warning</h4>Unable to load temporary log.<br/>No temporary log found in this device or the report was corrupted", function () {
            $location.path("/");
            $scope.$apply();
          });
        }
        if (report == null) {
          report = PilotReportLocalEditCreatorFactory.createNewLocalReportForFlight($scope.flight.FlightId);
        }
      } else {
        // load the report
        report = PilotReportLocalEditFactory.getPilotReportLocalEdit(reportId);
        if (report == null) {
          bootbox.alert("<h4>Warning</h4>Unable to load the requested log.<br/>This entry does not exist in this device, our its data are corrupted and the entry is unusable.", function () {
            $location.path("/");
            $scope.$apply();
          });
        }
      }
      $scope.report = report;
      infoSaveOperation('discard');
    }
    function validationWorkOrderNo() {
      if (!isNaN(+report.AutolandWorkOrderNo) && report.AutolandWorkOrderNo.length >= 6 && report.AutolandWorkOrderNo.length <= 10) {
        report.AutolandWorkOrderNoIsValid = true;
        report.updateTotals();
        if (report.Status != 'synched') report.saveReportAsTemp();
      } else {
        report.AutolandWorkOrderNoIsValid = false;
        report.IsValid = false;
      }
    }

    /**
          * update ACU Provision Value
          * @memberof ReportCtrl
          */
    function updateACUProvisionValue(selectedValue) {
      report.ACUProvision.values = {
        Yes: false,
        No: false,
        Delayed: false,
        NotRequired: false,
        Faulty: false
      };
      report.ACUProvision.values[selectedValue] = true;
      report.ACUProvision.value = selectedValue;
      report.updateTotals();
    }

    /**
           * clear ACU Provision Remarks
           * @memberof ReportCtrl
           */
    function clearACUProvisionRemarks() {
      if (report.ACUProvision.remarks != null) {
        report.ACUProvision.remarks = null;
        report.updateTotals();
      }
    }

    /**
           * update ACU Provision Remarks - using debounce: ng-model-options="{ debounce: 1200 }" ng-change="updateACUProvisionRemarks()"
           * @memberof ReportCtrl
           */
    function updateACUProvisionRemarks() {
      report.updateTotals();
    }

    /**
     * increases acu delays minutes number 
     * @memberof ReportCtrl
     */
    function plusACUMinutes() {
      if (report.ACUProvision != null) {
        if (report.ACUProvision.delayMinutes != null) {
          report.ACUProvision.delayMinutes++;
        } else {
          report.ACUProvision.delayMinutes = 1;
        }
        reportChanged();
      }
    }
    /**
     * decreases acu delays minutes number 
     * @memberof ReportCtrl
     */
    function minusACUMinutes() {
      if (report.ACUProvision != null) {
        if (report.ACUProvision.delayMinutes != null && report.ACUProvision.delayMinutes > 0) {
          report.ACUProvision.delayMinutes--;
        } else {
          report.ACUProvision.delayMinutes = 0;
        }
        reportChanged();
      }
    }

    /**
     * Clear acu delays minutes number 
     * @memberof ReportCtrl
     */
    function clearACUMinutes() {
      report.ACUProvision.delayMinutes = null;
      reportChanged();
    }
  }
  ;
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('ReportGuidFactory', ReportGuidFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name ReportGuidFactory
  * @description 
  *   Manages ReportGuid
  * @ngInject
  */
  function ReportGuidFactory($log, localStorageMD5Service) {
    /**
    * Initialize the ReportGuid
    * @memberof ReportGuidFactory
    */
    function ReportGuid() {
      this.Guid = null;
    }
    var objType = 'reportGuids';
    var objCallback = ReportGuid;
    var service = {
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      toObjectList: toObjectList,
      getReportGuidsFromStorage: getReportGuidsFromStorage,
      setReportGuidsToStorage: setReportGuidsToStorage,
      clearReportGuidsFromStorage: clearReportGuidsFromStorage,
      getNextGuid: getNextGuid,
      getRemainingReportGuids: getRemainingReportGuids,
      restoreGuid: restoreGuid
    };

    /**
     * Extend Object from the default ReportGuid Object
     * @memberof ReportGuidFactory
     * @param {Object} obj  a ReportGuid
     * @returns {Object} ReportGuid
     */
    function fromObject(obj) {
      if (obj == null) return null;
      var reportGuid = new ReportGuid();
      reportGuid.Guid = obj;
      return reportGuid;
    }
    ;

    /**
      * Extend an array of Objects from the default ReportGuid Object
      * @memberof ReportGuidFactory
      * @param {Array} objList  an Array Of ReportGuids
      * @returns {Array} ReportGuids
      */
    function fromObjectList(objList) {
      if (objList == null) return null;
      var arrayLength = objList.length;
      var reportGuids = new Array();
      for (var i = 0; i < arrayLength; i++) {
        var reportGuid = new ReportGuid();
        reportGuid.Guid = objList[i];
        reportGuids.push(reportGuid);
      }
      return reportGuids;
    }

    /**
      * Extend an array of Objects from the default ReportGuid Object
      * @memberof ReportGuidFactory
      * @param {Array} objList  an Array Of ReportGuids
      * @returns {Array} ReportGuids
      */
    function toObjectList(guidList) {
      if (guidList == null) return null;
      var arrayLength = guidList.length;
      var objList = new Array();
      for (var i = 0; i < arrayLength; i++) {
        objList.push(guidList[i].Guid);
      }
      return objList;
    }

    /**
         * Get all the reportGuid objects
         * @memberof reportGuid
         * @returns {array} ACSupplies
         */
    function getReportGuidsFromStorage() {
      var reportGuids = localStorageMD5Service.get('reportGuids');
      return fromObjectList(reportGuids);
    }

    /**
     * Set all the reportGuid objects
     * @memberof ReportGuidFactory
     * @return {string} reportGuid
     */
    function setReportGuidsToStorage(reportGuids) {
      localStorageMD5Service.set('reportGuids', reportGuids);
    }

    /**
    * Delete all the reportGuid objects
    * @memberof ReportGuidFactory
    */
    function clearReportGuidsFromStorage() {
      localStorageMD5Service.remove('reportGuids');
    }

    /**
     * Get the next available guid and remove it from pool
     * @memberof ReportGuidFactory
     * @return {string} reportGuid
     */
    function getNextGuid() {
      var reportGuids = getReportGuidsFromStorage();
      if (reportGuids == null) return null;
      var validGuidIndex = -1;
      var resultingGuid = null;
      var arrayLength = reportGuids.length;
      for (var i = 0; i < arrayLength; i++) {
        if (reportGuids[i].Guid != null && reportGuids[i].Guid != '') {
          validGuidIndex = i;
          resultingGuid = reportGuids[i].Guid;
          break;
        }
      }
      if (validGuidIndex >= 0) {
        // remove the guid from the array
        reportGuids.splice(validGuidIndex, 1);

        // save the new array
        setReportGuidsToStorage(toObjectList(reportGuids));
      }
      return resultingGuid;
    }

    /**
     * Get the  count of remaining reportGuid objects
     * @memberof reportGuid
     * @returns {number} reportGuidsLength
     */
    function getRemainingReportGuids() {
      var reportGuids = getReportGuidsFromStorage();
      if (reportGuids == null) return 0;
      return reportGuids.length;
    }

    /**
    * Restore previously used guid into the pool of guids,Used when a report is being cancelled or deleted (and it has not been sent to the server)
    * @memberof ReportGuidFactory
    * @param {string} reportGuid
    */
    function restoreGuid(guid) {
      //reject incorrect values
      if (typeof guid == 'undefined' || guid == null || guid == '') return false;
      var reportGuids = getReportGuidsFromStorage();
      if (reportGuids == null) reportGuids = [];
      var arrayLength = reportGuids.length;
      for (var i = 0; i < arrayLength; i++) {
        if (reportGuids[i].Guid == guid) {
          return false;
        }
      }

      //add the guid into the pool of guids
      var repGuid = fromObject(guid);
      reportGuids.push(repGuid);

      // save the new array
      setReportGuidsToStorage(toObjectList(reportGuids));
      return true;
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('ReportsHistoryCtrl', ReportsHistoryCtrl);
  function ReportsHistoryCtrl($scope, $routeParams, $timeout, ReportsHistoryFactory, FlightFactory) {
    var reportId = $routeParams.reportId;
    var flightId = $routeParams.flightId;
    var reportType = $routeParams.reportType;
    var flight = FlightFactory.getFlightFromStorage(flightId);
    window.addEventListener('online', function (e) {
      $timeout(checkConnectionStatus());
    });
    $scope.reports = [];
    $scope.flight = flight;
    $scope.contentToShow = "loading";
    $scope.errorMessage = "";
    $scope.showImage = showImage;
    $scope.imageData = "";
    $scope.closeImage = closeImage;
    $scope.init = function () {
      checkConnectionStatus();
    };
    $scope.init();

    /**
     * Fetches the reports
     * @memberof ReportsHistoryCtrl  
     */
    function fetchReports() {
      ReportsHistoryFactory.getReportsHistory(reportId, reportType).then(function (response) {
        return handleResponse(response);
      })["catch"](function () {
        showError("We could not get any reports!");
      });
    }

    /**
     * Displays the error message
     * @memberof ReportsHistoryCtrl  
      * @param {string} message message to display
     */
    function showError(message) {
      $scope.contentToShow = "error";
      $scope.errorMessage = message;
    }

    /**
     * Checks if the client is online or offline 
     * if is online fetches the reports else displays relative message
     * @memberof ReportsHistoryCtrl  
     */
    function checkConnectionStatus() {
      var isOnline = window.navigator.onLine;
      if (isOnline) {
        fetchReports();
      } else {
        showError("Please check the internet connection!");
      }
    }

    /**
     * Handles the response from the API 
     * if is success displays the reports else shows the error message.
     * @memberof ReportsHistoryCtrl  
     * @param {object} response the response object from API
     */
    function handleResponse(response) {
      if (response.data.success) {
        if (response.data.data.length > 0) {
          $scope.contentToShow = "reports";
          $scope.reports = response.data.data;
        } else {
          showError("There are no reports for this flight!");
        }
      } else {
        showError("We could not get any reports!");
      }
    }

    /**
     * Displays the image in bootbox dialog box
     * @memberof ReportsHistoryCtrl  
     * @param {object} ImageData The
     */
    function showImage(ImageData) {
      $scope.contentToShow = "image";
      $scope.imageData = ImageData;
    }

    /**
     * The function that closes the image and displays the reports again
     * @memberof ReportsHistoryCtrl  
     */
    function closeImage() {
      $scope.contentToShow = "reports";
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('ReportsHistoryFactory', ReportsHistoryFactory);

  /* @ngInject */
  function ReportsHistoryFactory($http, apiUrl) {
    /**
     * Fetches the ReportIncidents from API
     * @memberof ReportsHisReportsHistoryFactorytoryCtrl  
     */
    function getReportsHistory(reportId, reportType) {
      return $http.get(apiUrl + '/reports/GetHistoryReport?reportId=' + reportId + '&type=' + reportType, {
        'Content-Type': 'application/json'
      }).then(function (x) {
        return x;
      });
    }
    var service = {
      getReportsHistory: getReportsHistory
    };
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.filter('searchTextFilterforCategories', searchTextFilterforCategories);

  /**
  * @memberof PilotReports
  * @ngdoc filter
  * @name searchTextFilterforCategories
  * @description 
  *   Filter questions by search text
  * @ngInject
  */
  function searchTextFilterforCategories() {
    return function (input, obj) {
      var items = {
        searchText: obj.searchText ? obj.searchText.toLowerCase() : "",
        out: []
      };
      if (!items.searchText || items.searchText == '') {
        items.out = input;
      } else {
        angular.forEach(input, function (value, key) {
          if (value.Label.toLowerCase().indexOf(this.searchText) >= 0 || value.Description.toLowerCase().indexOf(this.searchText) >= 0) {
            this.out.push(value);
          }
        }, items);
      }
      var categoryLabels = items.out.dynamicSort('CategoryOrderNo').map(function (r) {
        return r.CategoryLabel;
      });
      return categoryLabels.unique();
    };
  }
  ;
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('ServerCabinReportFactory', ServerCabinReportFactory);

  /* @ngInject */
  function ServerCabinReportFactory($log, GenericService) {
    function ServerCabinReport() {
      this.AuthorAimsId = null;
      this.AuthorName = null;
      this.Created = null;
      this.FlightAimsId = null;
      this.FlightId = null;
      this.LastUpdated = null;
      this.ReportGuid = null;
      this.ReportId = null;
      this.getDescription = getDescription;
    }
    function getDescription() {
      if (this.Created == null && this.AuthorName == null) return '-null-';else return (this.Created || '?') + ' - ' + (this.AuthorName || '?');
    }
    var objCallback = ServerCabinReport;
    var service = {
      fromObjectList: fromObjectList
    };
    function fromObjectList(objList) {
      return GenericService.fromObjectList(objList, objCallback);
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('ServerPilotReportFactory', ServerPilotReportFactory);

  /* @ngInject */
  function ServerPilotReportFactory(GenericService) {
    // Define the constructor function.
    function ServerPilotReport() {
      this.AuthorAimsId = null;
      this.AuthorName = null;
      this.Created = null;
      this.FlightAimsId = null;
      this.FlightId = null;
      this.LastUpdated = null;
      this.ReportGuid = null;
      this.ReportId = null;
      this.ReportedItems = null;
      this.Source = null; // use ServerPilotReport.constSource* values
      this.getDescription = getDescription;
      this.isNothingToReport = isNothingToReport;
    }
    var objCallback = ServerPilotReport;
    function getDescription() {
      if (this.Created == null && this.AuthorName == null && this.ReportedItems == null) return '-null-';else return (this.AuthorAimsId || '?') + ' ' + (this.AuthorName || '?') + ' @ ' + (this.Created || '?') + (this.ReportedItems || 0) == 0 ? ' :: Nothing to report' : (this.ReportedItems || 0) + ' items logged';
    }
    function isNothingToReport() {
      return (this.ReportedItems || 0) == 0;
    }
    var service = {
      fromObjectList: fromObjectList,
      constSourceLocalOwn: 'localOwn',
      // stored locally by this user
      constSourceLocalOther: 'localOther',
      // stored locally by another user
      constSourceStoredOwn: 'storedOwn',
      // stored on the  server by this user
      constSourceStoredOther: 'storedOther' // stored on the server by another user
    };

    function fromObjectList(objList) {
      return GenericService.fromObjectList(objList, objCallback);
    }
    ;
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.filter('unique', unique);

  /* @ngInject */
  function unique() {
    return function (input, key) {
      var unique = {};
      var uniqueList = [];
      for (var i = 0; i < input.length; i++) {
        if (typeof unique[input[i][key]] == "undefined") {
          unique[input[i][key]] = "";
          uniqueList.push(input[i]);
        }
      }
      return uniqueList;
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('CalendarRedirectModalCtrl', CalendarRedirectModalCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name CalendarRedirectModalCtrl
  * @description 
  * Modal to redirect to Calendar after all mandatory memos are read
  * @ngInject
  */
  function CalendarRedirectModalCtrl($scope, $location, $uibModalInstance) {
    $scope.gotoCalendar = gotoCalendar;
    function gotoCalendar() {
      cancel();
      $location.path('/');
    }

    /**
    * Closes modal
    * @memberof CalendarRedirectModalCtrl
    */
    function cancel() {
      $uibModalInstance.close('cancel');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('MandatoryModalCtrl', MandatoryModalCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name MandatoryModalCtrl
  * @description 
  * Warning Modal about unread mandatory memos
  * @ngInject
  */
  function MandatoryModalCtrl($scope, mandatoryUnread, MemoFactory, $uibModal, $routeParams, $location, $uibModalInstance) {
    $scope.mandatoryUnread = mandatoryUnread;
    $scope.gotoMandatoryUnreadMemos = gotoMandatoryUnreadMemos;
    function gotoMandatoryUnreadMemos() {
      $location.path('/memos/unreadMandatory');
      cancel();
    }

    /**
    * Closes modal
    * @memberof ProposalInfoModalCtr
    */
    function cancel() {
      $uibModalInstance.close('cancel');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('MemoFactory', MemoFactory);

  /**
   * @memberof PilotReports
   * @ngdoc factory
   * @name MemoFactory
   * @description 
   *   Add, Update, Delete and Get Memos.
   * @ngInject
   */
  function MemoFactory(FlightFactory, GroundDutyFactory, IndexedDBService, PaxInfoFactory, $q) {
    /**
     * Initialize the Memo
     * @memberof MemoFactory
     */
    function Memo() {
      this.Id = null;
      this.expired = false;
    }
    var objType = 'Memos';
    var objCallback = Memo;
    var service = {
      getMemosFromStorage: getMemosFromStorage,
      setMemosToStorage: setMemosToStorage,
      clearMemosFromStorage: clearMemosFromStorage,
      getMemosForFlight: getMemosForFlight,
      getStoredMemosIds: getStoredMemosIds,
      saveOneMemoToStorage: saveOneMemoToStorage,
      addMemoToStorage: addMemoToStorage,
      deleteMemoFromStorage: deleteMemoFromStorage,
      setMemosFromServer: setMemosFromServer,
      getMemosForGroundDuty: getMemosForGroundDuty,
      getMemosForCrewRoute: getMemosForCrewRoute,
      getUnreadMemos: getUnreadMemos,
      getMandatoryUnreadMemos: getMandatoryUnreadMemos,
      getAllUnreadGroundDutyMemos: getAllUnreadGroundDutyMemos,
      markGroundDutiesUnread: markGroundDutiesUnread,
      info: info
    };

    /**
     * Get Memos
     * @memberof MemoFactory
     * @param {function} callback  
     */
    function getMemosFromStorage(callback) {
      //return GenericService.list(objType,objCallback);
      IndexedDBService.getAll(objType).then(function (results) {
        callback(results);
      });
    }
    ;

    /**
     * Set Memos
     * @memberof MemoFactory
     * @param {array} Memos   a list of memos to set to indexedDB
     */
    function setMemosToStorage(Memos) {
      IndexedDBService.addAll(objType, Memos);
    }
    ;

    /**
     * Update Memo to Storage
     * @memberof MemoFactory
     * @param {object} Memo   a memo
     */
    function saveOneMemoToStorage(Memo) {
      IndexedDBService.put(objType, Memo);
    }
    ;
    function info() {
      IndexedDBService.info(objType);
    }

    /**
     * Add Memo to Storage
     * @memberof MemoFactory
     * @param {object} Memo   a memo
     */
    function addMemoToStorage(Memo) {
      IndexedDBService.add(objType, Memo);
    }
    ;

    /**
     * Delete Memo from Storage
     * @memberof MemoFactory
     * @param {number} MemoId  The unique Identifier of the Memo
     */
    function deleteMemoFromStorage(MemoId) {
      IndexedDBService.remove(objType, MemoId);
    }
    ;

    /**
     * Clear Memo from Storage
     * @memberof MemoFactory
     */
    function clearMemosFromStorage() {
      IndexedDBService.removeAll(objType);
    }
    ;
    function ValidateCountryCategory(criteria, isDepartureCategory, isArrivalCategory) {
      var isValid = false;
      if (criteria.Special == "Specific") {
        isValid = (criteria.Field == "Intra" && isDepartureCategory || criteria.Field == "Extra" && !isDepartureCategory) && (criteria.FieldOptional == "Intra" && isArrivalCategory || criteria.FieldOptional == "Extra" && !isArrivalCategory);
      } else {
        if (criteria.Field == "Intra") {
          isValid = isDepartureCategory && criteria.Special != "To" || isArrivalCategory && criteria.Special != "From";
        } else if (criteria.Field == "Extra") {
          isValid = !isDepartureCategory && criteria.Special != "To" || !isArrivalCategory && criteria.Special != "From";
        }
      }
      return isValid;
    }
    function isValid(field, departureField, arrivalField, special) {
      var isValid = false;
      var isDeparture = departureField == field;
      var isArrival = arrivalField == field;
      if (special == "From") {
        isValid = isDeparture;
      } else if (special == "To") {
        isValid = isArrival;
      } else {
        isValid = isArrival || isDeparture;
      }
      return isValid;
    }
    function getMemosForGroundDuty(Id, callback) {
      var groundDuty = GroundDutyFactory.getGroundDutyFromStorage(Id);
      if (!groundDuty) {
        return [];
      }
      getMemosFromStorage(function (results) {
        var memosCollection = results;
        var groundDutyMemos = [];
        var fromDutyDate = new Date(groundDuty.DutyDate).getTime();
        var toDutyDate = new Date(groundDuty.DutyDate).getTime();
        for (var i = 0; i < memosCollection.length; i++) {
          if (new Date(memosCollection[i].ValidFrom).getTime() <= fromDutyDate && new Date(memosCollection[i].ValidTo).getTime() >= toDutyDate) {
            for (var j = 0; j < memosCollection[i].MemoCriteria.length; j++) {
              var item = memosCollection[i].MemoCriteria[j];
              if (item.QueryType == "GroundDutyCode" && (item.Field == groundDuty.DutyNo || item.Field == groundDuty.GroundDutyNo)) {
                groundDutyMemos.push(memosCollection[i]);
                break;
              }
            }
          }
        }
        callback(groundDutyMemos);
      });
    }
    /**
     * Get Memos that are relate to this flight
     * @memberof MemoFactory
     * @param {number} Id  The unique Identifier of the Memo
     * @param {function} callback  The callback function
     */
    function getMemosForFlight(Id, callback) {
      var flight = FlightFactory.getFlightFromStorage(Id);
      if (!flight) {
        flight = FlightFactory.getLocalFlightFromStorage(Id);
      }
      if (!flight) {
        return [];
      }
      getMemosFromStorage(function (results) {
        var memosCollection = results;
        var flightMemos = [];
        PaxInfoFactory.getPaxInfoFromStorage(flight.FlightId, function (paxInfo) {
          for (var i = 0; i < memosCollection.length; i++) {
            if (new Date(memosCollection[i].ValidFrom).getTime() <= new Date(flight.ScheduledDeparture).getTime() && new Date(memosCollection[i].ValidTo).getTime() >= new Date(flight.ScheduledArrival).getTime()) {
              for (var j = 0; j < memosCollection[i].MemoCriteria.length; j++) {
                var item = memosCollection[i].MemoCriteria[j];
                if (item.AcRegistration == flight.AcTailNo || item.QueryType == "Airport" && isValid(item.Airport, flight.Departure, flight.Arrival, item.Special) || item.FlightNo == flight.FlightNo || item.AcType == flight.AcType || isValidZone(item, flight.Zones) || item.RouteStart == flight.Departure && item.RouteEnd == flight.Arrival || item.ViceVersa && item.RouteStart == flight.Arrival && item.RouteEnd == flight.Departure || item.QueryType == "Country" && isValid(item.Country, flight.DepartureCountry, flight.ArrivalCountry, item.Special) || item.QueryType == "Schengen" && ValidateCountryCategory(item, flight.DepartureSchengen, flight.ArrivalSchengen) || item.QueryType == "European" && ValidateCountryCategory(item, flight.DepartureEU, flight.ArrivalEU) || paxInfo && item.QueryType == "SsrCode" && PassengersHasSsrCode(paxInfo, item) || item.QueryType == "TrainingId" && item.Field == flight.TrainingIndicatorId) {
                  flightMemos.push(memosCollection[i]);
                  break;
                }
              }
            }
          }
          callback(flightMemos);
        });
      });
    }

    /**
     * Get Memos that are related to this crew route, by combining multiple flight and groundDuty memos 
     * @memberof MemoFactory
     * @param {number} DutyNo Crew Route Identifier
     * @param {number} DutyDay Crew Route Day
     * @param {function} callback  The callback function
     */
    function getMemosForCrewRoute(DutyNo, DutyDay, callback) {
      var groundDuties = GroundDutyFactory.getGroundDutiesByDutyNo(DutyNo, DutyDay);
      var flights = FlightFactory.getFlightsByDutyNo(DutyNo, DutyDay);
      PaxInfoFactory.getAllPaxInfoFromStorage(function (paxInfoResult) {
        getMemosFromStorage(function (results) {
          var memosCollection = results;
          var allMemos = [];
          for (var i = 0; i < memosCollection.length; i++) {
            var inserted = false;
            //first check if memo is connected with any groundDuties
            for (var g = 0; g < groundDuties.length; g++) {
              var fromDutyDate = new Date(groundDuties[g].DutyDate).getTime();
              var toDutyDate = new Date(groundDuties[g].DutyDate).getTime();
              if (new Date(memosCollection[i].ValidFrom).getTime() <= fromDutyDate && new Date(memosCollection[i].ValidTo).getTime() >= toDutyDate) {
                for (var j = 0; j < memosCollection[i].MemoCriteria.length; j++) {
                  var item = memosCollection[i].MemoCriteria[j];
                  if (item.QueryType == "GroundDutyCode" && (item.Field == groundDuties[g].DutyNo || item.Field == groundDuties[g].GroundDutyNo)) {
                    allMemos.push(memosCollection[i]);
                    inserted = true;
                    break;
                  }
                }
              }
              if (inserted) break; //don't check other groundDuties - memo is already inserted
            }
            //if memo was checked for all groundDuties and was not connected with any, check in flights
            if (!inserted) {
              for (var f = 0; f < flights.length; f++) {
                var paxInfo = null;
                if (new Date(memosCollection[i].ValidFrom).getTime() < new Date(flights[f].ScheduledDeparture).getTime() && new Date(memosCollection[i].ValidTo).getTime() > new Date(flights[f].ScheduledArrival).getTime()) {
                  //check if flight has paxInfo 
                  for (var p = 0; p < paxInfoResult.length; p++) {
                    if (paxInfoResult[p].FlightId == flights[f].FlightId) {
                      paxInfo = paxInfoResult[p];
                      break;
                    }
                  }
                  for (var j = 0; j < memosCollection[i].MemoCriteria.length; j++) {
                    var item = memosCollection[i].MemoCriteria[j];
                    if (item.AcRegistration == flights[f].AcTailNo || item.QueryType == "Airport" && isValid(item.Airport, flights[f].Departure, flights[f].Arrival, item.Special) || item.FlightNo == flights[f].FlightNo || item.AcType == flights[f].AcType || isValidZone(item.Zone, flights[f].Zones) || item.RouteStart == flights[f].Departure && item.RouteEnd == flights[f].Arrival || item.ViceVersa && item.RouteStart == flights[f].Arrival && item.RouteEnd == flights[f].Departure || item.QueryType == "Country" && isValid(item.Country, flights[f].DepartureCountry, flights[f].ArrivalCountry, item.Special) || item.QueryType == "Schengen" && ValidateCountryCategory(item, flights[f].DepartureSchengen, flights[f].ArrivalSchengen) || item.QueryType == "European" && ValidateCountryCategory(item, flights[f].DepartureEU, flights[f].ArrivalEU) || paxInfo && item.QueryType == "SsrCode" && PassengersHasSsrCode(paxInfo, item) || item.QueryType == "TrainingId" && item.Field == flights[f].TrainingIndicatorId) {
                      allMemos.push(memosCollection[i]);
                      inserted = true;
                      break;
                    }
                  }
                }
                if (inserted) break; //don't check other flights - memo is already inserted
              }
            }
          }

          callback(allMemos);
        });
      });
    }
    function PassengersHasSsrCode(paxInfo, memoCriterion) {
      var retVal = false;
      for (var key in paxInfo.PassengerSummaryY) {
        if (key === memoCriterion.Field && paxInfo.PassengerSummaryY[key] > 0) {
          retVal = true;
          break;
        }
      }
      for (var key in paxInfo.PassengerSummaryX) {
        if (key === memoCriterion.Field && paxInfo.PassengerSummaryY[key] > 0) {
          retVal = true;
          break;
        }
      }
      return retVal;
    }

    /**
     * Check if the zone is valid
     * @memberof MemoFactory
     * @param {CriteriaZone} Zone from MemoCriteria
     * @param {FlightZones} List of Zones from flight
     */
    function isValidZone(CriteriaZone, FlightZones) {
      if (!CriteriaZone || CriteriaZone.Type != "Zone" || !FlightZones || FlightZones.length == 0) {
        return false;
      } else {
        // some is equivalent to Any()
        var zoneExist = FlightZones.some(function (item) {
          return item.Title.toUpperCase() == CriteriaZone.Field.toUpperCase() && item.Class.toUpperCase() == CriteriaZone.FieldOptional.toUpperCase();
        });
        return zoneExist;
      }
    }

    /**
     * Get Stored Memos 
     * @memberof MemoFactory
     * @param {function} callback  The callback function
     */
    function getStoredMemosIds(callback) {
      getMemosFromStorage(function (memos) {
        var memoIds = [];
        for (var i = 0; i < memos.length; i++) {
          var memoIdRead = {
            Id: memos[i].Id,
            ReadDt: memos[i].ReadDt
          };
          memoIds.push(memoIdRead);
        }
        callback(memoIds);
      });
    }

    /**
     * set memos from server api  
     * @memberof MemoFactory
     * @param {array} memos  The memos 
     * @param {array} memoIdsToSend  The old memos of the storage
     * @param {string} lastSyncDate  The last Sync Date 
     */
    function setMemosFromServer(memos, memoIdsToSend, lastSyncDate) {
      if (!memoIdsToSend || memoIdsToSend.length == 0 || !lastSyncDate) {
        setMemosToStorage(memos);
      } else {
        for (var j = 0; j < memos.length; j++) {
          var IsMemoIncluded = false;
          for (var h = 0; h < memoIdsToSend.length; h++) {
            if (memos[j].Id == memoIdsToSend[h].Id) {
              IsMemoIncluded = true;
              break;
            }
          }
          if (IsMemoIncluded) {
            memos[j].IsUpdated = true;
            memos[j].IsNew = false;
            saveOneMemoToStorage(memos[j]);
          } else {
            memos[j].IsNew = true;
            memos[j].IsUpdated = false;
            addMemoToStorage(memos[j]);
          }
        }
      }
    }

    /**
     * Get Unread Memos 
     * @memberof MemoFactory
     */
    function getUnreadMemos(callback) {
      getMemosFromStorage(function (memos) {
        if (!memos) return [];
        var result = [];
        var arrayLength = memos.length;
        for (var i = 0; i < arrayLength; i++) {
          if (!memos[i].ReadDt) {
            result.push(memos[i]);
          }
        }
        callback(result);
      });
    }

    /**
     * Get Unread Mandatory Memos
     * @memberof MemoFactory
     */
    function getMandatoryUnreadMemos(callback) {
      getMemosFromStorage(function (memos) {
        if (!memos) return [];
        var result = [];
        var arrayLength = memos.length;
        for (var i = 0; i < arrayLength; i++) {
          if (!memos[i].ReadDt && memos[i].IsMandatory) {
            result.push(memos[i]);
          }
        }
        callback(result);
      });
    }

    /**
    * Gets all unread memos related to a Ground Duty
    * @memberof MemoFactory
    */
    function getAllUnreadGroundDutyMemos(callback) {
      getMemosFromStorage(function (results) {
        var memosCollection = results;
        var unreadGroundDutyMemos = [];
        for (var i = 0; i < memosCollection.length; i++) {
          for (var j = 0; j < memosCollection[i].MemoCriteria.length; j++) {
            var item = memosCollection[i].MemoCriteria[j];
            if (item.QueryType == "GroundDutyCode" && memosCollection[i].ReadDt == null) {
              unreadGroundDutyMemos.push(memosCollection[i]);
              break;
            }
          }
        }
        callback(unreadGroundDutyMemos);
      });
    }

    /**
    * Flags Ground Duties if they have at least one unread memo
    * @memberof MemoFactory
    */
    function markGroundDutiesUnread() {
      getAllUnreadGroundDutyMemos(function (groundDutyMemos) {
        var groundDuties = GroundDutyFactory.getGroundDutiesFromStorage();
        if (groundDuties != null) {
          for (var i = 0; i < groundDuties.length; i++) {
            groundDuties[i].Unread = false;

            //check if this ground duty has any unread ground duty memo
            var fromDutyDate = new Date(groundDuties[i].DutyDate).getTime();
            var toDutyDate = new Date(groundDuties[i].DutyDate).getTime();
            for (var j = 0; j < groundDutyMemos.length; j++) {
              if (new Date(groundDutyMemos[j].ValidFrom).getTime() <= fromDutyDate && new Date(groundDutyMemos[j].ValidTo).getTime() >= toDutyDate) {
                for (var z = 0; z < groundDutyMemos[j].MemoCriteria.length; z++) {
                  var item = groundDutyMemos[j].MemoCriteria[z];
                  if (item.Field == groundDuties[i].DutyNo || item.Field == groundDuties[i].GroundDutyNo) {
                    groundDuties[i].Unread = true;
                    break;
                  }
                }
              }
            }
          }
          GroundDutyFactory.setGroundDutiesToStorage(groundDuties);
        }
      });
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('MemoImagesFactory', MemoImagesFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name MemoImagesFactory
  * @description 
  *   Add, Update, Delete and Get Memo's Images.
  * @ngInject
  */
  function MemoImagesFactory(GenericService, IndexedDBService) {
    /**
    * Initialize the MemoImage
    * @memberof MemoImagesFactory
    */
    function MemoImage() {
      this.Id = null;
    }
    var objType = 'MemoImages';
    var objCallback = MemoImage;
    var service = {
      getMemoImagesFromStorage: getMemoImagesFromStorage,
      setMemoImagesToStorage: setMemoImagesToStorage,
      saveOneMemoImageToStorage: saveOneMemoImageToStorage,
      addMemoImageToStorage: addMemoImageToStorage,
      deleteMemoImageFromStorage: deleteMemoImageFromStorage,
      deleteMemoImageByMemoId: deleteMemoImageByMemoId,
      setImagesToServer: setImagesToServer,
      clearMemoImagesFromStorage: clearMemoImagesFromStorage,
      getMemoImagesByIndex: getMemoImagesByIndex
    };

    /**
     * Get Memo Images 
     * @memberof MemoImagesFactory
     * @param {function} callback  
     */
    function getMemoImagesFromStorage(callback) {
      //return GenericService.list(objType,objCallback);
      IndexedDBService.getAll(objType).then(function (results) {
        callback(results);
      });
    }
    ;

    /**
     * Get Memo Images  by memo Id
     * @memberof MemoImagesFactory
     * @param {number} id Memo Id  
     * @param {function} callback  
     */
    function getMemoImagesByIndex(id, callback) {
      //return GenericService.list(objType,objCallback);
      IndexedDBService.getByIndex(objType, 'memoId', id).then(function (results) {
        callback(results);
      });
    }
    ;

    /**
     * Add Memo Images 
     * @memberof MemoImagesFactory
     * @param {array} MemoImages List of memo images
     */
    function setMemoImagesToStorage(MemoImages) {
      //GenericService.saveAll(Memos,objType,objCallback);
      IndexedDBService.addAll(objType, MemoImages);
    }
    ;

    /**
     * Update Memo Images 
     * @memberof MemoImagesFactory
     * @param {object} MemoImage a memo image
     */
    function saveOneMemoImageToStorage(MemoImage) {
      IndexedDBService.put(objType, MemoImage);
    }
    ;

    /**
     * Add Memo Image
     * @memberof MemoImagesFactory
     * @param {object} MemoImage a memo image
     */
    function addMemoImageToStorage(MemoImage) {
      IndexedDBService.add(objType, MemoImage);
    }
    ;

    /**
     * Delete  Memo Image
     * @memberof MemoImagesFactory
     * @param {number} MemoImageId a memo image Id
     */
    function deleteMemoImageFromStorage(MemoImageId) {
      IndexedDBService.remove(objType, MemoImageId);
    }
    ;

    /**
     * Delete  Memo Image by MemoId
     * @memberof MemoImagesFactory
     * @param {number} MemoId a memo Id
     */
    function deleteMemoImageByMemoId(MemoId) {
      IndexedDBService.removeByIndex(objType, 'memoId', MemoId);
    }
    ;

    /**
     * Set  Memo Image by api call
     * @memberof MemoImagesFactory
     * @param {array} images List of memo images
     */
    function setImagesToServer(images) {
      for (var i = 0; i < images.length; i++) {
        addMemoImageToStorage(images[i]);
      }
    }

    /**
     * Remove  Memo Images from storage
     * @memberof MemoImagesFactory
     */
    function clearMemoImagesFromStorage() {
      IndexedDBService.removeAll(objType);
    }
    ;
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('MemoModalCtrl', MemoModalCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name MemoModalCtrl
  * @description 
  *  Manages the Memo Modal
  * @ngInject
  */
  function MemoModalCtrl($scope, memo, $uibModalInstance, $sce, MemoImagesFactory) {
    $scope.memo = memo;
    $scope.cancel = cancel;
    $scope.hasCountry = false;
    $scope.hasFlightNo = false;
    $scope.hasAirport = false;
    $scope.hasRoute = false;
    $scope.hasAcType = false;
    $scope.hasZone = false;
    $scope.hasEuropean = false;
    $scope.hasSchengen = false;
    $scope.hasAcRegistration = false;
    $scope.hasSsrCode = false;
    $scope.hasTrainingIndicator = false;
    $scope.hasGroundDuties = false;
    $scope.hasNone = true;
    $scope.images = [];
    $scope.showImage = showImage;
    $scope.body = $sce.trustAsHtml(memo.Body);
    MemoImagesFactory.getMemoImagesByIndex(memo.Id, function (results) {
      $scope.images = results;
    });

    /**
     * Open A new Tab and show the image 
     * @memberof MemoModalCtrl
     * @param {string} src Base64 endode string of Image
     */
    function showImage(src) {
      var image = new Image();
      image.src = src;
      var w = window.open("");
      w.document.write(image.outerHTML);
    }

    /**
     * Show the criteria of the memo 
     * @memberof MemoModalCtrl
     */
    (function changeFlags() {
      angular.forEach(memo.MemoCriteria, function (criteria) {
        if (criteria.Country || criteria.Type == "Country" && criteria.Field) {
          $scope.hasCountry = true;
          $scope.hasNone = false;
        }
        if (criteria.FlightNo || criteria.Type == "FlightNo" && criteria.Field) {
          $scope.hasFlightNo = true;
          $scope.hasNone = false;
        }
        if (criteria.Airport || criteria.Type == "Airport" && criteria.Field) {
          $scope.hasAirport = true;
          $scope.hasNone = false;
        }
        if (criteria.RouteStart || criteria.Type == "RouteStart" && criteria.Field) {
          $scope.hasRoute = true;
          $scope.hasNone = false;
        }
        if (criteria.AcType || criteria.Type == "AcType" && criteria.Field) {
          $scope.hasAcType = true;
          $scope.hasNone = false;
        }
        if (criteria.Zone || criteria.Type == "Zone" && criteria.Field) {
          $scope.hasZone = true;
          $scope.hasNone = false;
        }
        if (criteria.AcRegistration || criteria.Type == "AcRegistration" && criteria.Field) {
          $scope.hasAcRegistration = true;
          $scope.hasNone = false;
        }
        if (criteria.Type == "SsrCode" && criteria.Field) {
          $scope.hasSsrCode = true;
          $scope.hasNone = false;
        }
        if (criteria.Type == "TrainingId" && criteria.Field) {
          $scope.hasTrainingIndicator = true;
          $scope.hasNone = false;
        }
        if (criteria.Type == "European" && criteria.Field) {
          $scope.hasEuropean = true;
          $scope.hasNone = false;
        }
        if (criteria.Type == "Schengen" && criteria.Field) {
          $scope.hasSchengen = true;
          $scope.hasNone = false;
        }
        if (criteria.Type == "GroundDutyCode" && criteria.Field) {
          $scope.hasGroundDuties = true;
          $scope.hasNone = false;
        }
      });
    })();

    /**
     * Close the modal
     * @memberof MemoModalCtrl
     */
    function cancel() {
      $uibModalInstance.close('close');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('MemosCtrl', MemosCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name MemosCtrl
  * @description 
  *  Manages the Memos View
  * @ngInject
  */

  function MemosCtrl($scope, MemoFactory, $uibModal, $routeParams) {
    $scope.memosByCategory = [];
    $scope.openMemo = openMemo;
    $scope.searchText = '';
    $scope.searchMemos = searchMemos;
    $scope.state = 'memos';
    $scope.select = select;
    $scope.toggleSidePanel = toggleSidePanel;
    $scope.searchResultsCount = searchResultsCount;
    $scope.shownSideMenu = false;
    $scope.active = 1;
    $scope.showhideDescr = showhideDescr;
    $scope.toShowBody = true;
    $scope.toShowAppliesTo = true;
    $scope.hasCountry = false;
    $scope.hasFlightNo = false;
    $scope.hasAirport = false;
    $scope.hasRoute = false;
    $scope.hasAcType = false;
    $scope.hasZone = false;
    $scope.hasEuropean = false;
    $scope.hasSchengen = false;
    $scope.hasAcRegistration = false;
    $scope.hasSsrCode = false;
    $scope.hasTrainingIndicator = false;
    $scope.hasGroundDuties = false;
    MemoFactory.getMemosFromStorage(function (results) {
      var tommorowTimestamp = new Date().getTime() + 86400000;
      for (var i = 0; i < results.length; i++) {
        results[i].expired = new Date(results[i].ValidTo).getTime() < tommorowTimestamp;
      }

      //Remove from Library memos that belong in "Training Surveys" category
      var memos = [];
      for (var i = 0; i < results.length; i++) {
        if (results[i].Category != "Training Surveys") {
          memos.push(results[i]);
        }
      }
      $scope.memos = memos;
      var memosByCategory = MemosByCategories(memos);
      if ($routeParams.filter == 'unread') {
        $scope.radioModel = 'Unread';
        searchMemos($scope.searchText, 'Unread');
      } else if ($routeParams.filter == 'unreadMandatory') {
        $scope.radioModel = 'UnreadMandatory';
        searchMemos($scope.searchText, 'UnreadMandatory');
      } else {
        $scope.radioModel = 'All';
        //default category on load
        $scope.selected = memosByCategory[0];
        $scope.memosByCategory = memosByCategory;
        searchResultsCount();
      }
    });
    function searchResultsCount() {
      var sum = 0;
      for (var i = 0; i < $scope.memosByCategory.length; i++) {
        sum += $scope.memosByCategory[i].memoList.length;
      }
      $scope.searchResults = sum;
    }
    function MemosByCategories(memoList) {
      var memos = [];
      for (var i = 0; i < memoList.length; i++) {
        var memo = memoList[i];
        if (!memos.filter(function (e) {
          return e.Category == memo.Category;
        }).length > 0) {
          memos.push({
            Category: memo.Category,
            memoList: [memo],
            filterList: [memo]
          });
        } else if (memos.filter(function (e) {
          return e.Category == memo.Category;
        }).length > 0) {
          memos.filter(function (object) {
            if (object.Category == memo.Category) {
              return object;
            }
            ;
          })[0].memoList.push(memo);
        }
        (function changeFlags() {
          angular.forEach(memoList[i].MemoCriteria, function (criteria) {
            if (criteria.Country || criteria.Type == "Country" && criteria.Field) {
              $scope.hasCountry = true;
              $scope.hasNone = false;
            }
            if (criteria.FlightNo || criteria.Type == "FlightNo" && criteria.Field) {
              $scope.hasFlightNo = true;
              $scope.hasNone = false;
            }
            if (criteria.Airport || criteria.Type == "Airport" && criteria.Field) {
              $scope.hasAirport = true;
              $scope.hasNone = false;
            }
            if (criteria.RouteStart || criteria.Type == "RouteStart" && criteria.Field) {
              $scope.hasRoute = true;
              $scope.hasNone = false;
            }
            if (criteria.AcType || criteria.Type == "AcType" && criteria.Field) {
              $scope.hasAcType = true;
              $scope.hasNone = false;
            }
            if (criteria.Zone || criteria.Type == "Zone" && criteria.Field) {
              $scope.hasZone = true;
              $scope.hasNone = false;
            }
            if (criteria.AcRegistration || criteria.Type == "AcRegistration" && criteria.Field) {
              $scope.hasAcRegistration = true;
              $scope.hasNone = false;
            }
            if (criteria.Type == "SsrCode" && criteria.Field) {
              $scope.hasSsrCode = true;
              $scope.hasNone = false;
            }
            if (criteria.Type == "TrainingId" && criteria.Field) {
              $scope.hasTrainingIndicator = true;
              $scope.hasNone = false;
            }
            if (criteria.Type == "European" && criteria.Field) {
              $scope.hasEuropean = true;
              $scope.hasNone = false;
            }
            if (criteria.Type == "Schengen" && criteria.Field) {
              $scope.hasSchengen = true;
              $scope.hasNone = false;
            }
            if (criteria.Type == "GroundDutyCode" && criteria.Field) {
              $scope.hasGroundDuties = true;
              $scope.hasNone = false;
            }
          });
        })();
      }
      return memos.dynamicSort("Category", true);
    }
    function select(category) {
      selectMemoCategory(category);
      toggleSidePanel();
    }
    function selectMemoCategory(category) {
      var memosByCategory = $scope.memosByCategory;
      for (var i = 0; i < memosByCategory.length; i++) {
        if (memosByCategory[i].Category == category.Category) {
          $scope.selected = memosByCategory[i];
          break;
        }
      }
    }
    function showhideDescr() {
      $scope.toShowBody = !$scope.toShowBody;
      $scope.toShowAppliesTo = !$scope.toShowAppliesTo;
    }
    function toggleSidePanel() {
      $scope.shownSideMenu = !$scope.shownSideMenu;
    }

    //Pagination
    $scope.pageOptions = [{
      name: '5',
      value: '5'
    }, {
      name: '8',
      value: '8'
    }, {
      name: '15',
      value: '15'
    }, {
      name: '30',
      value: '30'
    }, {
      name: '50',
      value: '50'
    }];
    $scope.viewby = $scope.pageOptions[1].value;
    $scope.currentPage = 1;
    $scope.itemsPerPage = $scope.viewby;
    $scope.maxSize = 5; //Number of pager buttons to show
    $scope.setPage = setPage;
    $scope.setItemsPerPage = setItemsPerPage;

    //Controller functions

    /**
    * Set pagination page number
    * @memberof MemosCtrl
    * @param {number} pageNo list page number
    */
    function setPage(pageNo) {
      $scope.currentPage = pageNo;
    }

    /**
     * Set items per  page 
     * @memberof MemosCtrl
     * @param {number} num the Number of items to show per page
     */
    function setItemsPerPage(num) {
      $scope.itemsPerPage = num;
      $scope.currentPage = 1; //reset to first paghe
    }

    /**
     * View Selected Memo
     * @memberof MemosCtrl
     * @param {object} memo The selected Memo
     */
    function openMemo(_memo) {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/Memos/dlgMemo.html',
        controller: 'MemoModalCtrl',
        size: 'lg',
        keyboard: false,
        resolve: {
          memo: function memo() {
            return _memo;
          }
        }
      });
      modalInstance.result.then(function () {
        if (_memo.ReadDt == null) {
          _memo.ReadDt = new Date();
          MemoFactory.saveOneMemoToStorage(_memo);
          //check if memo is connected to a ground duty
          for (var i = 0; i < _memo.MemoCriteria.length; i++) {
            var item = _memo.MemoCriteria[i];
            if (item.QueryType == "GroundDutyCode") {
              MemoFactory.markGroundDutiesUnread();
              break;
            }
          }
          searchMemos($scope.searchText, '');
        }
      });
    }
    function redirectModal() {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/Memos/dlgCalendarRedirect.html',
        controller: 'CalendarRedirectModalCtrl',
        backdrop: 'static',
        size: 'md',
        keyboard: false
      });
    }

    /**
     * Search the selected text In Memo Title and body
     * @memberof MemosCtrl
     * @param {string} text The desired search text
     */
    function searchMemos(text, filter) {
      if (filter != '') {
        $scope.radioModel = filter;
      }
      var filteredMemos = [];
      var searchText = text.toLowerCase();
      var newList = $scope.memos;
      for (var i = 0; i < newList.length; i++) {
        if ($scope.radioModel == 'General') {
          if (newList[i].MemoCriteria.length > 0) {
            continue;
          }
        } else if ($scope.radioModel == 'Unread') {
          if (newList[i].ReadDt) {
            continue;
          }
        } else if ($scope.radioModel == 'Mandatory') {
          if (!newList[i].IsMandatory) {
            continue;
          }
        } else if ($scope.radioModel == 'UnreadMandatory') {
          if (newList[i].ReadDt || !newList[i].IsMandatory) {
            continue;
          }
        } else if ($scope.radioModel == 'Monthly') {
          var diffTime = Math.abs(new Date() - moment.utc(newList[i].LastUpdated).utc().toDate());
          var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          if (diffDays >= 30) {
            continue;
          }
        }
        var memoTitle = newList[i].Title.toLowerCase();
        if (memoTitle.indexOf(searchText) > -1) {
          filteredMemos.push(newList[i]);
          continue;
        }
      }
      var memosByCategory = MemosByCategories(filteredMemos);
      $scope.memosByCategory = memosByCategory;
      var showAllCategory = {
        Category: 'Show All',
        memoList: filteredMemos,
        filterList: filteredMemos
      };
      if (searchText != null && searchText != undefined && searchText.length > 0) {
        memosByCategory.push(showAllCategory);
      }
      searchResultsCount();
      if (!memosByCategory || !memosByCategory.length) {
        $scope.selected == null; //selected could be null if search didn't return any results
        if ($scope.radioModel == 'UnreadMandatory') {
          //all mandatory memos were read
          // $scope.radioModel = 'All';
          // searchMemos(searchText, '');
          redirectModal();
        }
      } else if ($scope.selected == null) {
        //search now returns results
        $scope.selected = memosByCategory[0];
      }
      if (searchText != null && searchText != undefined && searchText.length > 0) {
        $scope.selected = showAllCategory;
      }
      var select = false;
      for (var i = 0; i < memosByCategory.length; i++) {
        if ($scope.selected.Category == memosByCategory[i].Category) {
          selectMemoCategory(memosByCategory[i]);
          select = true;
          break;
        }
      }
      if (!select) $scope.selected = memosByCategory[0];
    }
  }
})();
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
(function () {
  'use strict';

  a3_pilot_reports.factory('RequestFactory', RequestFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name RequestFactory
  * @description 
  *   Add & delete requests and get Roster Requests & get ancillaries
  * @ngInject
  */
  function RequestFactory($http, apiUrl, GenericService) {
    /**
    * Initialize the CrewAssessment
    * @memberof AssessmentSyncResultFactory
    */
    function RequestSubmissionDeadline() {
      this.showSubmissionDeadlineModal = false;
    }
    var submitResponseObj = {
      success: false,
      message: '',
      data: null
    };
    var objType = 'requestSubmissionEndDates';
    var objCallback = RequestSubmissionDeadline;
    var service = {
      setSubmissionDeadlineDateToStorage: setSubmissionDeadlineDateToStorage,
      getSubmissionDeadlineDateFromStorage: getSubmissionDeadlineDateFromStorage,
      showSubmissionDeadlineModal: showSubmissionDeadlineModal,
      showSubmissionDeadlineAlert: showSubmissionDeadlineAlert,
      updateShowSubmissionDeadlineModal: updateShowSubmissionDeadlineModal,
      getActiveRequests: getActiveRequests,
      getAncillaries: getAncillaries,
      sendFlightRequest: sendFlightRequest,
      sendShiftRequest: sendShiftRequest,
      sendOvernightRequest: sendOvernightRequest,
      sendOtherRequest: sendOtherRequest,
      sendGroundRequest: sendGroundRequest,
      deleteFlightRequest: deleteFlightRequest,
      deleteShiftRequest: deleteShiftRequest,
      deleteOvernightRequest: deleteOvernightRequest,
      deleteOtherRequest: deleteOtherRequest,
      deleteGroundRequest: deleteGroundRequest,
      getPastRequests: getPastRequests
    };

    /**
     * Save submission end date of crew member's qualification group to storage
     * @param {array} objList A list of Crew Expiries
     */
    function setSubmissionDeadlineDateToStorage(objList) {
      if (objList != null) {
        var submissionDeadline = {
          submissionEndDate: objList,
          showSubmissionDeadlineModal: true
        };
        GenericService.saveOne(submissionDeadline, objType, objCallback);
      }
    }

    /**
     * Calculates days left
     * @memberof CalendarCtrl
     * @return {string} usage
     */
    function daysDiff(date) {
      var today = moment().startOf('day');
      var expiryDate = moment(date);
      return expiryDate.diff(today, 'days');
    }

    /**
     * Get submission end date of crew member's qualification group from storage
     */
    function getSubmissionDeadlineDateFromStorage() {
      return GenericService.getOne(objType, objCallback);
    }

    /**
     * Shows submission deadline modal
     * @memberof ExpiriesFactory
     * @returns {bool} returns the value of showSubmissionDeadlineModal property
     */
    function showSubmissionDeadlineModal() {
      var needsReminder = false;
      var submissionDeadline = getSubmissionDeadlineDateFromStorage();
      if (submissionDeadline) {
        var diffDays = daysDiff(submissionDeadline.submissionEndDate);
        if (submissionDeadline && submissionDeadline.submissionEndDate && submissionDeadline.showSubmissionDeadlineModal) {
          if (diffDays == 1 || diffDays == -1 || diffDays == 0) {
            needsReminder = true;
          }
        }
      }
      return needsReminder;
    }

    /**
     * Shows submission deadline alert
     * @memberof ExpiriesFactory
     * @returns {bool} returns the value of showSubmissionDeadlineAlert property
     */
    function showSubmissionDeadlineAlert() {
      var needsAlert = false;
      var submissionDeadline = getSubmissionDeadlineDateFromStorage();
      if (submissionDeadline) {
        var diffDays = daysDiff(submissionDeadline.submissionEndDate);
        if (submissionDeadline && submissionDeadline.submissionEndDate) {
          if (diffDays <= 10 && diffDays >= 0) {
            needsAlert = true;
          }
        }
      }
      return needsAlert;
    }

    /* Update submissionEndDate modal object to storage
    * @memberof RequestFactory
    * @param {bool} canShowModal whether the modal can be displayed
    */
    function updateShowSubmissionDeadlineModal(canShowModal) {
      var submissionDeadline = getSubmissionDeadlineDateFromStorage();
      submissionDeadline.showSubmissionDeadlineModal = canShowModal;
      GenericService.saveOne(submissionDeadline, objType, objCallback);
    }

    /**
    * Gets all types of the existing requests
    */
    function getActiveRequests() {
      return $http.get(apiUrl + '/RosterRequests/GetRequests', {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
    }

    /**
    * Gets all ancilleries
    */
    function getAncillaries() {
      return $http.get(apiUrl + '/RosterRequests/GetAncillaries', {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
    }

    /**
    * Sends the flight request
    */
    function sendFlightRequest(rosterRequest) {
      var requestTimesFixed = _objectSpread({}, rosterRequest);
      if (rosterRequest.afterTime) {
        requestTimesFixed.afterTime = rosterRequest.afterTime.clone();
        var startDateObj = new Date(requestTimesFixed.afterTime).fromUTC();
        requestTimesFixed.afterTime = moment(startDateObj);
      } else {
        requestTimesFixed.afterTime = null;
      }
      if (rosterRequest.beforeTime) {
        requestTimesFixed.beforeTime = rosterRequest.beforeTime.clone();
        var endDateObj = new Date(requestTimesFixed.beforeTime).fromUTC();
        requestTimesFixed.beforeTime = moment(endDateObj);
      } else {
        requestTimesFixed.beforeTime = null;
      }
      var rosterRequestsURL = apiUrl + '/RosterRequests/FlightRequestInsert';
      return $http.post(rosterRequestsURL, requestTimesFixed, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
    }

    /**
    * Sends the shift request
    */
    function sendShiftRequest(rosterRequest) {
      var rosterRequestsURL = apiUrl + '/RosterRequests/ShiftTimeRequestInsert';
      return $http.post(rosterRequestsURL, rosterRequest, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
    }

    /**
    * Sends the overnight request
    */
    function sendOvernightRequest(rosterRequest) {
      var rosterRequestsURL = apiUrl + '/RosterRequests/OvernightsRequestInsert';
      return $http.post(rosterRequestsURL, rosterRequest, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
    }

    /**
    * Sends the other request
    */
    function sendOtherRequest(rosterRequest) {
      var rosterRequestsURL = apiUrl + '/RosterRequests/OtherRequestInsert';
      return $http.post(rosterRequestsURL, rosterRequest, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
    }

    /**
    * Sends the ground request
    */
    function sendGroundRequest(rosterRequest) {
      var rosterRequestsURL = apiUrl + '/RosterRequests/GroundDutyRequestInsert';
      return $http.post(rosterRequestsURL, rosterRequest, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
    }

    /**
    * Gets the response message
    */
    function getResponse(res) {
      submitResponseObj.success = res.data.success;
      if (res.data.success) {
        submitResponseObj.message = "Data retrieved successfully";
        submitResponseObj.data = res.data.data;
      } else {
        submitResponseObj.message = res.data.errorMessage;
      }
      return submitResponseObj;
    }

    /**
    * Gets the creation response message
    */
    function getCreateRequestResponse(res) {
      submitResponseObj.success = res.data.success;
      if (res.data.success) {
        submitResponseObj.message = "Request submited successfully";
        submitResponseObj.data = res.data.data;
      } else {
        submitResponseObj.message = res.data.errorMessage;
      }
      return submitResponseObj;
    }

    /**
    * Gets the response failure message
    */
    function getResponseFailed(res) {
      submitResponseObj.success = false;
      submitResponseObj.message = "Something went wrong!";
      return submitResponseObj;
    }

    /**
    * Deletes the flight request
    */
    function deleteFlightRequest(requestId) {
      var deleteRequestsURL = apiUrl + '/RosterRequests/FlightRequestDelete';
      return $http.post(deleteRequestsURL, requestId, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      });
    }

    /**
    * Deletes the shift request
    */
    function deleteShiftRequest(requestId) {
      var deleteRequestsURL = apiUrl + '/RosterRequests/ShiftTimeRequestDelete';
      return $http.post(deleteRequestsURL, requestId, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      });
    }

    /**
    * Deletes the overnight request
    */
    function deleteOvernightRequest(requestId) {
      var deleteRequestsURL = apiUrl + '/RosterRequests/OvernightsRequestDelete';
      return $http.post(deleteRequestsURL, requestId, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      });
    }

    /**
    * Deletes the other request
    */
    function deleteOtherRequest(requestId) {
      var deleteRequestsURL = apiUrl + '/RosterRequests/OtherRequestDelete';
      return $http.post(deleteRequestsURL, requestId, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      });
    }

    /**
    * Deletes the ground request
    */
    function deleteGroundRequest(requestId) {
      var deleteRequestsURL = apiUrl + '/RosterRequests/GroundDutyRequestDelete';
      return $http.post(deleteRequestsURL, requestId, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getCreateRequestResponse(res);
      });
    }

    /**
    * Gets all types of the past requests
    */
    function getPastRequests() {
      return $http.get(apiUrl + '/RosterRequests/GetPastRequests', {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('requestForm', requestForm);
  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name requestForm
  * @restrict E
  * @description
  *   Crew Table with a double row per crew member
  * @example
  *   Usage:
  *   <request-form request-type="Ground Duty" ></request-form>
  *   <request-form request-type="Flight" ></request-form>
  * @ngInject
  */
  function requestForm() {
    function link(scope, attrs) {}
    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/RosterRequests/requestForm.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('RequestInstructionsCtrl', RequestInstructionsCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name RequestInstructionsCtrl
  * @description 
  *   Get the Roster Request Instructions
  * @ngInject
  */
  function RequestInstructionsCtrl($scope, $uibModalInstance) {
    $scope.page = 1;
    $scope.cancel = cancel;
    $scope.nextPage = nextPage;
    $scope.previousPage = previousPage;
    $scope.instructionPages = 1;

    /**
     * Goes to the next page of  leave instructions
     * @memberof RequestInstructionsCtrl
     */
    function nextPage() {
      $scope.page = $scope.page + 1;
      normalizePage();
    }

    /**
    * Goes to the previous page of leave instructions
    * @memberof RequestInstructionsCtrl
    */
    function previousPage() {
      $scope.page = $scope.page - 1;
      normalizePage();
    }

    /**
     * Normalize the page number if it is out of range
     * @memberof RequestInstructionsCtrl
     */
    function normalizePage() {
      if ($scope.page > $scope.instructionPages || $scope.page < 1) {
        $scope.page = 1;
      }
    }
    /**
     * Close the modal
     * @memberof RequestInstructionsCtrl
     */
    function cancel() {
      $uibModalInstance.close('close');
    }
    ;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('requestItem', requestItem);
  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name requestItem
  * @restrict E
  * @description
  *   Request info
  * @example
  *   Usage:
  *   <request-item request="request" request-type="Flight" on-deleted="deleteRequest(requestId, requestType)"></request-item>
  * @ngInject
  */
  function requestItem($uibModal, RequestFactory) {
    function link(scope, element, attrs) {
      //scope.request
      scope.loading = false;
      scope.errorMessage = null;
      scope.contents = {
        showPendingIcon: false,
        //sholwAcknowledgedIcon: false,
        showAcceptedIcon: false,
        showRejectedIcon: false,
        showFullRequestComment: false,
        showFullRejectComment: false,
        rejectReason: "",
        infoMessage: "",
        loading: false,
        showErrorMessage: false,
        errorMessage: "",
        textclass: ""
      };
      scope.confirmCancelRequest = confirmCancelRequest;
      scope.toggleFullCommentVisibility = toggleFullCommentVisibility;
      scope.toggleFullRejectCommentVisibility = toggleFullRejectCommentVisibility;
      scope.todayDate = moment().format('DD/MM');
      getFlightDescription();
      function getFlightDescription() {
        scope.request.FlightDescription = null;
        if (scope.request.FlightNo) {
          scope.request.FlightDescription = scope.request.FlightNo;
        } else if (scope.request.FlightDutyCategory) {
          scope.request.FlightDescription = scope.request.FlightDutyCategory;
        } else if (scope.request.AfterTime && scope.request.BeforeTime) {
          scope.request.FlightDescription = moment.utc(scope.request.AfterTime).format('HH:mm') + " - " + moment.utc(scope.request.BeforeTime).format('HH:mm');
        } else if (scope.request.AfterTime) {
          scope.request.FlightDescription = "after " + moment.utc(scope.request.AfterTime).format('HH:mm');
        } else if (scope.request.BeforeTime) {
          scope.request.FlightDescription = "till " + moment.utc(scope.request.BeforeTime).format('HH:mm');
        }
      }
      //Toggles comments
      function toggleFullCommentVisibility() {
        scope.contents.showFullRequestComment = !scope.contents.showFullRequestComment;
      }
      function toggleFullRejectCommentVisibility() {
        scope.contents.showFullRejectComment = !scope.contents.showFullRejectComment;
      }
      getContents();

      //update contents obj:
      function getContents() {
        if (scope.request.StatusText == "FinalAccepted") {
          scope.contents.textclass = "text-green";
          scope.contents.showAcceptedIcon = true;
          scope.contents.infoMessage = "your request has been accepted!";
        } else if (scope.request.StatusText == "Accepted") {
          scope.contents.textclass = "text-indigo";
          scope.contents.showPendingIcon = true;
          scope.contents.infoMessage = "your request is under review!";
        } else if (scope.request.StatusText == "Pending") {
          scope.contents.textclass = "text-light-blue";
          scope.contents.showPendingIcon = true;
          scope.contents.infoMessage = "your request is pending!";
        } else if (scope.request.StatusText == "Acknowledged") {
          scope.contents.textclass = "text-light-blue";
          scope.contents.showPendingIcon = true;
          scope.contents.infoMessage = "your request is under review!";
        } else if (scope.request.StatusText == "Rejected") {
          scope.contents.rejectReason = scope.rejectReason;
          scope.contents.textclass = "text-red";
          scope.contents.showRejectedIcon = true;
          scope.contents.infoMessage = "your request has been rejected!";
        }
      }

      /**
       * Opens confirmation modal for the request cancel action
       * @memberof request
       */
      function confirmCancelRequest() {
        bootbox.dialog({
          message: "<strong>You are about to cancel your request. Are you sure?</strong><br/><br/>",
          title: "Caution!",
          buttons: {
            confirm: {
              label: 'Confirm',
              className: "btn-danger",
              callback: function callback() {
                cancelRequest();
              }
            },
            cancel: {
              label: "Cancel",
              className: "btn-default",
              callback: function callback() {}
            }
          }
        });
      }
      function cancelRequest() {
        scope.contents.loading = true;
        if (scope.requestType == "Flight") {
          RequestFactory.deleteFlightRequest(scope.request.Id).then(function (res) {
            handleDeleteResponse(res);
          })["catch"](function () {
            handleErrorResponse();
          });
        } else if (scope.requestType == "Ground") {
          RequestFactory.deleteGroundRequest(scope.request.Id).then(function (res) {
            handleDeleteResponse(res);
          })["catch"](function () {
            handleErrorResponse();
          });
        } else if (scope.requestType == "ShiftTime") {
          RequestFactory.deleteShiftRequest(scope.request.Id).then(function (res) {
            handleDeleteResponse(res);
          })["catch"](function () {
            handleErrorResponse();
          });
        } else if (scope.requestType == "Overnight") {
          RequestFactory.deleteOvernightRequest(scope.request.Id).then(function (res) {
            handleDeleteResponse(res);
          })["catch"](function () {
            handleErrorResponse();
          });
        } else if (scope.requestType == "Other") {
          RequestFactory.deleteOtherRequest(scope.request.Id).then(function (res) {
            handleDeleteResponse(res);
          })["catch"](function () {
            handleErrorResponse();
          });
        }
      }
      function handleDeleteResponse(res) {
        scope.contents.loading = false;
        if (res.success == true) {
          scope.refreshRequests();
        } else {
          scope.contents.showErrorMessage = true;
          scope.contents.errorMessage = "Cancel request failed.";
        }
      }
      function handleErrorResponse() {
        scope.contents.loading = false;
        scope.contents.showErrorMessage = true;
        scope.contents.errorMessage = "Cancel request failed.";
      }
    }
    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/RosterRequests/requestItem.tpl.html',
      scope: {
        request: '=',
        requestType: "@",
        rejectReason: "@",
        refreshRequests: "&",
        isHistoryView: '@'
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('RequestsCtrl', RequestsCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name RequestsCtrl
  * @description 
  *   Shows Roster Requests
  * @ngInject
  */
  function RequestsCtrl($scope, RequestFactory, $timeout, $uibModal, LogService) {
    $scope.state = 'requests';
    $scope.ancillaries = null;
    $scope.activeRequests = null;
    $scope.isAvailableFeature = false;
    $scope.hasAncillaries = false; //for testing true || live false !;
    $scope.showActiveRequests = false; //for testing true || live false !;
    $scope.contentToShow = "loading";
    window.addEventListener('online', function (e) {
      $timeout(checkConnectionStatus());
    });
    $scope.init = checkConnectionStatus();
    $scope.closeAlert = closeAlert;
    $scope.openRequest = openRequest;
    $scope.page = null;
    $scope.closeForm = closeForm;
    $scope.newForm = {};
    $scope.submitRequest = submitRequest;
    $scope.submitForcedRequest = submitForcedRequest;
    $scope.forceSubmitRequest = forceSubmitRequest;
    $scope.getActiveRequests = getActiveRequests;
    $scope.updateFromValue = updateFromValue;
    $scope.dutyCode = "";
    $scope.showHelp = showHelp;
    $scope.instruction = '';
    $scope.flightRequestType = null;
    $scope.setFlightRequestType = setFlightRequestType;
    $scope.resetStart = resetStart;
    $scope.resetEnd = resetEnd;
    //ground duties request types:
    $scope.singleDayRequestType = true;
    $scope.toggleGroundRequestType = toggleGroundRequestType;
    $scope.updateFromValueGD = updateFromValueGD;
    $scope.submitLoader = false;
    $scope.toggleViewMode = toggleViewMode;
    $scope.getPastRequests = getPastRequests;
    $scope.isHistoryView = false;
    $scope.showPastRequests = false;
    $scope.hasDutyPreferencesSettings = false;

    //------------ Request List --------------
    // $scope.showMobileRequestListCriteria = true;
    $scope.filterRequest = filterRequest;
    $scope.getRequestBorderStyle = getRequestBorderStyle;
    $scope.getRejectReason = getRejectReason;
    $scope.toggle = {
      Accepted: true,
      Rejected: true,
      Pending: true,
      FinalAccepted: true
    };
    $scope.submissionDeadline = RequestFactory.getSubmissionDeadlineDateFromStorage();
    $scope.daysDiff = daysDiff;

    /**
     * Calculates days left
     * @memberof CalendarCtrl
     * @return {string} usage
     */
    function daysDiff(date) {
      var today = moment().startOf('day');
      var expiryDate = moment(date);
      return expiryDate.diff(today, 'days');
    }

    /**
     * Get ancillaries for the forms
     * @memberof RequestsCtrl  
     */
    function getAncillaries() {
      RequestFactory.getAncillaries().then(function (response) {
        $scope.contentToShow = "";
        if (response.success) {
          if (response.data) {
            $scope.ancillaries = response.data;

            // Request types based on crew member's qualification group(s) settings
            $scope.hasDutyPreferencesSettings = $scope.ancillaries.ShiftTimeRequests && $scope.ancillaries.ShiftTimeRequests.length > 0;
            $scope.hasOtherRequestsSettings = $scope.ancillaries.HasOtherRequestsSettings;
            $scope.hasFlightRequestsByFlightNoSettings = $scope.ancillaries.HasFlightRequestsByFlightNoSettings;
            $scope.hasFlightRequestsByTimeRangesSettings = $scope.ancillaries.HasFlightRequestsByTimeRangesSettings;
            $scope.flightOrDutyPreferenceIsVisible = $scope.ancillaries.FlightDutyCategories && $scope.ancillaries.FlightDutyCategories.length > 0 || $scope.hasFlightRequestsByFlightNoSettings || $scope.hasFlightRequestsByTimeRangesSettings;

            // Create Your Request Menu: visibility option                                       
            $scope.isAvailableFeature = $scope.ancillaries.DutyCodes && $scope.ancillaries.DutyCodes.length > 0 || $scope.flightOrDutyPreferenceIsVisible || $scope.hasDutyPreferencesSettings || $scope.hasOtherRequestsSettings;
            $scope.hasAncillaries = true;
            $scope.newForm.singleDate = $scope.ancillaries.RosterPeriodFrom;
            $scope.newForm.dateFrom = $scope.ancillaries.RosterPeriodFrom;
            $scope.newForm.dateTo = $scope.ancillaries.RosterPeriodTo;

            //groundDuties
            $scope.newForm.dutyDateFrom = $scope.ancillaries.RosterPeriodFrom;
            $scope.newForm.dutyDateTo = $scope.ancillaries.RosterPeriodFrom;
            $scope.optionsSingle = {
              minDate: $scope.ancillaries.RosterPeriodFrom,
              initDate: $scope.ancillaries.RosterPeriodFrom
            };
            $scope.optionsFrom = {
              minDate: $scope.ancillaries.RosterPeriodFrom,
              initDate: $scope.ancillaries.RosterPeriodFrom
            };
            $scope.optionsTo = {
              minDate: $scope.ancillaries.RosterPeriodFrom,
              initDate: $scope.ancillaries.RosterPeriodTo
            };
            $scope.optionsDutyDateTo = {
              minDate: $scope.ancillaries.RosterPeriodFrom,
              initDate: $scope.ancillaries.RosterPeriodFrom
            };

            // Fetch flight category types for the dropdown list
            $scope.ancillaries.flightCategoryTypes = [];
            if ($scope.hasFlightRequestsByFlightNoSettings) {
              $scope.ancillaries.flightCategoryTypes.push({
                Value: 1,
                Text: 'Flight No.'
              });
            }
            if ($scope.ancillaries.FlightDutyCategories && $scope.ancillaries.FlightDutyCategories.length > 0) {
              $scope.ancillaries.flightCategoryTypes.push({
                Value: 2,
                Text: 'Flight Duty Preference'
              });
            }
            if ($scope.hasFlightRequestsByTimeRangesSettings) {
              $scope.ancillaries.flightCategoryTypes.push({
                Value: 3,
                Text: 'Flight Duty Preference with time limit'
              });
            }
          } else {
            //TODO:: fix message
            showError("Ancillaries not found.");
          }
        } else {
          showError(response.message);
        }
      });
    }

    /**
     * Get Active Requests
     * @memberof RequestsCtrl  
     */
    function getActiveRequests() {
      RequestFactory.getActiveRequests().then(function (response) {
        if (response.success) {
          if (response.data) {
            $scope.activeRequests = response.data;
            $scope.instruction = response.data.QualificationGroupInstruction;
            $scope.showActiveRequests = response.data.FlightRequests.length || response.data.GroundDutyRequests.length || response.data.OtherRequests.length || response.data.OvernightsRequests.length || response.data.ShiftTimeRequests.length;
          } else {
            showError("Something went wrong while fetching your roster requests.");
          }
        } else {
          showError(response.message);
        }
      });
    }
    function getPastRequests() {
      RequestFactory.getPastRequests().then(function (response) {
        if (response.success) {
          if (response.data) {
            $scope.pastRequests = response.data;
            $scope.isHistoryView = true;
            $scope.instruction = response.data.QualificationGroupInstruction;
            $scope.showPastRequests = response.data.FlightRequests.length > 0 || response.data.GroundDutyRequests.length > 0 || response.data.OtherRequests.length > 0 || response.data.OvernightsRequests.length > 0 || response.data.ShiftTimeRequests.length > 0;
          } else {
            showError("Something went wrong while fetching your roster requests.");
          }
        } else {
          showError(response.message);
        }
      });
    }

    /**
     * Displays the error message
     * @memberof RequestsCtrl  
     * @param {string} message message to display
     */
    function showError(message) {
      $scope.contentToShow = "error";
      $scope.errorMessage = message;
    }

    /**
     * Displays the success message
     * @memberof RequestsCtrl
     */
    function showSuccess(message) {
      $scope.contentToShow = "success";
      $scope.successMessage = message;
    }
    function closeAlert() {
      $scope.contentToShow = "";
    }

    /**
     * Checks if the client is online or offline 
     * @memberof RequestsCtrl  
     */
    function checkConnectionStatus() {
      var isOnline = window.navigator.onLine;
      if (isOnline) {
        getAncillaries();
        getActiveRequests();
      } else {
        showError("Please check your internet connection!");
      }
    }

    /**
     * Date to always greater than date from
     * @memberof RequestsCtrl  
     */
    function updateFromValue(dateFrom) {
      $scope.newForm.dateTo = dateFrom;
      $scope.optionsTo = {
        minDate: dateFrom
      };
    }

    /**
     * Date picker limits for the ground duty requests
     * @memberof RequestsCtrl  
    */
    function updateFromValueGD(dateFrom, limitation) {
      $scope.newForm.dateTo = dateFrom;
      $scope.optionsDutyDateTo = {
        initDate: dateFrom,
        minDate: dateFrom,
        maxDate: dateFrom.AddDays(limitation - 1)
      };
    }
    function setFlightRequestType() {
      //[{Value: 1, Text:'Flight No.'}, {Value: 2, Text:'Flight Duty Preference'}, {Value: 3, Text:'Time Limitations'}]
      $scope.flightRequestType = +$scope.newForm.flightRequestType; //parseInt(numberString);
    }

    function resetStart() {
      $scope.newForm.afterTime = null;
    }
    function resetEnd() {
      $scope.newForm.beforeTime = null;
    }
    function toggleGroundRequestType() {
      if ($scope.newForm.groundRequestType == 'continuous') {
        $scope.singleDayRequestType = false;
      } else {
        $scope.singleDayRequestType = true;
      }
    }

    /**
     * Opens the request type selected
     * @memberof RequestsCtrl
     */
    function openRequest(inputObject, dutyCode) {
      clearForms();
      if (inputObject == "Flight") {
        $scope.page = 'Flight';
        // Preselect "Flight Duty Preference" only when Flight page is opened
        if ($scope.ancillaries.flightCategoryTypes && $scope.ancillaries.flightCategoryTypes.length > 0) {
          $scope.newForm.flightRequestType = "2";
          $scope.flightRequestType = 2;
        }
      } else if (inputObject == "Duty Preference") {
        $scope.page = 'Duty Preference';
      } else if (inputObject == "Overnight") {
        $scope.page = 'Overnight';
      } else if (inputObject == "Other") {
        $scope.page = 'Other';
      } else if (inputObject == "Ground Duty") {
        $scope.page = 'Ground Duty';
        $scope.dutyCode = dutyCode;
      }
    }

    /**
     * Submits the request form
     * @memberof RequestsCtrl
     */
    function submitRequest(inputObject, dutyCode) {
      $scope.submitLoader = true;
      if (inputObject == "Flight" && $scope.flightRequestType != null) {
        var rosterRequest = {
          FlightDate: $scope.newForm.singleDate.toString("yyyy/MM/dd"),
          ReasonId: $scope.newForm.requestReason.Id,
          Comments: $scope.newForm.comments,
          Type: $scope.flightRequestType,
          IsForced: false
        };
        if ($scope.flightRequestType == 1) {
          rosterRequest.FlightNo = $scope.newForm.flightNo;
        } else if ($scope.flightRequestType == 2) {
          rosterRequest.FlightDutyCategoryId = $scope.newForm.flightDuty.Id;
        } else if ($scope.flightRequestType == 3) {
          rosterRequest.afterTime = $scope.newForm.afterTime !== null && $scope.newForm.afterTime !== undefined ? moment($scope.newForm.afterTime) : null;
          rosterRequest.beforeTime = $scope.newForm.beforeTime !== null && $scope.newForm.beforeTime !== undefined ? moment($scope.newForm.beforeTime) : null;
        }
        RequestFactory.sendFlightRequest(rosterRequest).then(function (response) {
          handleSubmitResponse(response, rosterRequest);
        });
      } else if (inputObject == "Ground Duty") {
        //validation with duty limitation
        var trimmedFrom = new Date($scope.newForm.dateFrom);
        var trimmedTo = new Date($scope.newForm.dateTo);
        var diffDays = Date.DifferenceInDays(trimmedFrom.trimTime(), trimmedTo.trimTime());
        if (diffDays > dutyCode.Limitation) {
          //show warning message? : 
          $scope.disableSubmit = true;
        }
        if ($scope.singleDayRequestType) {
          $scope.newForm.dateTo = $scope.newForm.dateFrom;
        }
        var rosterRequest = {
          DutyDateFrom: $scope.newForm.dateFrom.toString("yyyy/MM/dd"),
          DutyDateTo: $scope.newForm.dateTo.toString("yyyy/MM/dd"),
          GroundDuty: dutyCode.Code,
          ReasonId: $scope.newForm.requestReason.Id,
          Comments: $scope.newForm.comments,
          IsForced: false
        };
        RequestFactory.sendGroundRequest(rosterRequest).then(function (response) {
          handleSubmitResponse(response, rosterRequest);
        });
      } else if (inputObject == "Duty Preference") {
        var dateFrom = moment(new Date($scope.newForm.dateFrom));
        var dateTo = moment(new Date($scope.newForm.dateTo));

        // Check if the request period is less than one month
        var duration = dateTo.diff(dateFrom, 'days');
        if (duration < 29) {
          var title = "<strong>Warning!</strong>";
          var message = "<strong>Please select a period of at least one month. Requests shorter than one month cannot be processed. <br>Thank you for helping us create a more balanced schedule!</strong><br>";
          bootbox.dialog({
            message: message,
            title: title,
            buttons: {
              cancel: {
                label: "Close",
                className: "btn-default",
                callback: function callback() {
                  $scope.$apply(function () {
                    $scope.submitLoader = false;
                  });
                }
              }
            }
          });
          return;
        }

        // Check if the end date exceeds January 31 of the next year
        // January 31 of the next year
        var maxEndDate = moment().endOf('year').add(1, 'months').endOf('day');
        if (dateTo.diff(maxEndDate, 'seconds') > 0) {
          var title = "<strong>Warning!</strong>";
          var message = "<strong>End dates beyond January 31 of the following year cannot be accepted.<br> Thank you for helping us keep schedules organized!</strong><br>";
          bootbox.dialog({
            message: message,
            title: title,
            buttons: {
              cancel: {
                label: "Close",
                className: "btn-default",
                callback: function callback() {
                  $scope.$apply(function () {
                    $scope.submitLoader = false;
                  });
                }
              }
            }
          });
          return;
        }
        var rosterRequest = {
          DateFrom: $scope.newForm.dateFrom.toString("yyyy/MM/dd"),
          DateTo: $scope.newForm.dateTo.toString("yyyy/MM/dd"),
          ShiftTimeId: $scope.newForm.shiftTime.Id,
          ReasonId: $scope.newForm.requestReason.Id,
          Comments: $scope.newForm.comments
        };
        RequestFactory.sendShiftRequest(rosterRequest).then(function (response) {
          handleSubmitResponse(response);
        });
      } else if (inputObject == "Overnight") {
        var rosterRequest = {
          DateFrom: $scope.newForm.dateFrom.toString("yyyy/MM/dd"),
          DateTo: $scope.newForm.dateTo.toString("yyyy/MM/dd"),
          Minimum: $scope.newForm.minOvernight,
          Maximum: $scope.newForm.maxOvernight,
          ReasonId: $scope.newForm.requestReason.Id,
          Comments: $scope.newForm.comments
        };
        RequestFactory.sendOvernightRequest(rosterRequest).then(function (response) {
          handleSubmitResponse(response);
        });
      } else if (inputObject == "Other") {
        var rosterRequest = {
          DateFrom: $scope.newForm.dateFrom.toString("yyyy/MM/dd"),
          DateTo: $scope.newForm.dateTo.toString("yyyy/MM/dd"),
          ReasonId: $scope.newForm.requestReason.Id,
          RequestFreeText: $scope.newForm.otherComments
        };
        RequestFactory.sendOtherRequest(rosterRequest).then(function (response) {
          handleSubmitResponse(response);
        });
      }
    }

    /**
     * Handles the response from the API
     * @memberof RequestsCtrl  
     * @param {object} response the response object from API
     */
    function handleSubmitResponse(response, rosterRequest) {
      var responseData = null;
      if (response.data) {
        if (typeof response.data === 'string') {
          try {
            responseData = JSON.parse(response.data);
          } catch (error) {
            LogService.error(error, 'Failed to parse JSON');
          }
        } else {
          responseData = response.data;
        }
      }
      if (rosterRequest && response.success == true && responseData && responseData.success == false) {
        if (responseData.isOverlappingDuty) {
          //bootbox for the overlap warning
          showOverlappingMessage();
        } else if (responseData.periodNotFound) {
          showPeriodNotFoundMessage();
        } else if ($scope.page == "Ground Duty" || $scope.page == "Flight") {
          //bootbox to confirm the forced submit - new submit on confirmed
          forceSubmitRequest(rosterRequest, $scope.page, responseData);
        } else {
          //show error message
          showError('Request submission failed.');
        }
      } else if (response.success == false) {
        //show error message
        showError(response.message);
      } else if (responseData.success == false) {
        //show error message
        showError('Request submission failed.');
      } else {
        //show success message
        showSuccess("Request submited successfully.");
        //refresh request list!
        getActiveRequests();
      }
      closeForm();
    }

    /**
     * Clears forms
     * @memberof RequestsCtrl
     */
    function clearForms() {
      $scope.newForm = {};
      if ($scope.ancillaries) {
        $scope.newForm.singleDate = $scope.ancillaries.RosterPeriodFrom;
        $scope.newForm.dateFrom = $scope.ancillaries.RosterPeriodFrom;
        $scope.newForm.dateTo = $scope.ancillaries.RosterPeriodTo;
        $scope.singleDayRequestType = true;
        $scope.submitLoader = false;
        $scope.disableSubmit = false;
      }
    }

    /**
     * Closes forms
     * @memberof RequestsCtrl
     */
    function closeForm() {
      clearForms();
      $scope.page = null;
    }

    /**
     * Opens confirmation modal when request is submitted
     * @memberof RequestsCtrl
     */
    function forceSubmitRequest(rosterRequest, type, responseData) {
      var rosterPeriodFrom = moment.utc(responseData.rosterPeriodFrom).format('D MMM YYYY');
      var rosterPeriodTo = moment.utc(responseData.rosterPeriodTo).format('D MMM YYYY');
      var title = "<strong>Warning!</strong>";
      console.log(rosterRequest);
      var message = "";

      // Check if the limitation is reached and extra gound duties requests are prevented
      if (responseData.limitationReached && responseData.preventExtraGroundDutyRequests) {
        // Show an error message instead of the management approval option
        message = "<strong>You cannot submit this request as you have reached the maximum allowed ground duty requests limit for this Roster Period.</strong>";
        bootbox.dialog({
          message: message,
          title: title,
          buttons: {
            cancel: {
              label: "Close",
              className: "btn-default",
              callback: function callback() {}
            }
          }
        });
        return;
      }

      // Check if the limitation is reached and extra flight requests are prevented
      if (responseData.limitationReached && responseData.preventExtraFlightRequests) {
        // Show an error message instead of the management approval option
        message = "<strong>You cannot submit this request as you have reached the maximum allowed flight requests limit for this Roster Period.</strong>";
        bootbox.dialog({
          message: message,
          title: title,
          buttons: {
            cancel: {
              label: "Close",
              className: "btn-default",
              callback: function callback() {}
            }
          }
        });
        return;
      }
      if (responseData.limitationReached) {
        message = message + "<strong>You have exceeded the maximum number of Requests " + "(" + responseData.activeRequests + "/" + responseData.maxLimit + ")" + " for this Roster Period " + "(" + rosterPeriodFrom + " to " + rosterPeriodTo + ")." + "</strong><br>";
      }
      if (responseData.isOverdue == true) {
        message = message + "<strong>The Deadline to submit requests for this Roster Period " + "(" + rosterPeriodFrom + " to " + rosterPeriodTo + ") has passed.</strong><br><br>";
      }
      if (type == "Ground Duty" && responseData.hasDailyLimitation == true) {
        message = message + "<strong>The selected date " + rosterRequest.DutyDate + " has limited Availability. The probability to get your request is low.</strong><br>";
      }
      if (type == "Ground Duty" && responseData.weekendRequestsLimitReached == true) {
        message = message + "<strong>You have exceeded the allowed number of Weekends Requests for this Roster Period " + "(" + rosterPeriodFrom + " to " + rosterPeriodTo + ").</strong><br><br>";
      }
      message = message + " <strong>Your request will be ignored by the system. Do you want to send it for Managment Approval? </strong><br>";
      bootbox.dialog({
        message: message,
        title: title,
        buttons: {
          confirm: {
            label: 'Confirm',
            className: "btn-success",
            callback: function callback() {
              submitForcedRequest(rosterRequest, type);
            }
          },
          cancel: {
            label: "Cancel",
            className: "btn-default",
            callback: function callback() {}
          }
        }
      });
    }

    /**
     * Opens a modal with overlapping message
     * @memberof RequestsCtrl
     */
    function showPeriodNotFoundMessage() {
      var title = "<strong>Warning!</strong>";
      var message = "<strong>You cannot send request for this roster period.</strong><br>";
      bootbox.dialog({
        message: message,
        title: title,
        buttons: {
          cancel: {
            label: "Close",
            className: "btn-default",
            callback: function callback() {}
          }
        }
      });
    }

    /**
     * Opens a modal with overlapping message
     * @memberof RequestsCtrl
     */
    function showOverlappingMessage() {
      var title = "<strong>Warning!</strong>";
      var message = "<strong>You cannot submit 2 requests for the same date.</strong><br>";
      bootbox.dialog({
        message: message,
        title: title,
        buttons: {
          cancel: {
            label: "Close",
            className: "btn-default",
            callback: function callback() {}
          }
        }
      });
    }

    /**
     * Submits the forced request
     * @memberof RequestsCtrl
     */
    function submitForcedRequest(rosterRequest, type) {
      if (type == "Flight") {
        rosterRequest.IsForced = true;
        RequestFactory.sendFlightRequest(rosterRequest).then(function (response) {
          handleSubmitResponse(response);
        });
      } else if (type == "Ground Duty") {
        rosterRequest.IsForced = true;
        RequestFactory.sendGroundRequest(rosterRequest).then(function (response) {
          handleSubmitResponse(response);
        });
      }
    }
    function getRejectReason(rejectReasonId) {
      var reasonText = "";
      if (rejectReasonId && $scope.ancillaries) {
        var rejectReason = $scope.ancillaries.RejectReasons.find(function (f) {
          return f.Id == rejectReasonId;
        });
        if (rejectReason) {
          reasonText = rejectReason.Text;
        }
      }
      return reasonText;
    }
    function filterRequest(request) {
      var isShown = false;
      if (request.Id > 0) {
        if (request.StatusText == "FinalAccepted" && $scope.toggle.FinalAccepted) {
          isShown = true;
        } else if ((request.ValidationStatusText == "Validated" && request.StatusText != "FinalAccepted" || request.StatusText == "Accepted" || request.StatusText == "Acknowledged") && $scope.toggle.Accepted) {
          isShown = true;
        } else if (request.StatusText == "Pending" && $scope.toggle.Pending) {
          isShown = true;
        } else if (request.StatusText == "Rejected" && $scope.toggle.Rejected) {
          isShown = true;
        }
      }
      return isShown;
    }
    function getRequestBorderStyle(request) {
      var textclass = "";
      if (request.StatusText == "FinalAccepted") {
        textclass = "border-left-green";
      } else if (request.StatusText == "Accepted") {
        textclass = "border-left-indigo";
      } else if (request.StatusText == "Pending" || request.StatusText == "Acknowledged") {
        textclass = "border-left-light-blue";
      } else if (request.StatusText == "Rejected") {
        textclass = "border-left-red";
      } else {
        textclass = "border-left-blue-gray";
      }
      return textclass;
    }
    function showHelp() {
      $uibModal.open({
        templateUrl: 'views/RosterRequests/dlgRequestInstructions.html',
        controller: 'RequestInstructionsCtrl',
        size: 'lg',
        scope: $scope,
        backdrop: 'static',
        keyboard: false,
        resolve: {}
      });
    }
    function toggleViewMode(elem, className) {
      $('body').find('div#' + elem + ' > div').not('.tip').hide("slow");
      $('body').find('div#' + elem + ' div.' + className).not('.tip').show("slow");
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('AcknowledgeModalCtrl', AcknowledgeModalCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name AcknowledgeModalCtrl
  * @description 
  * Warning Modal about unread mandatory memos
  * @ngInject
  */
  function AcknowledgeModalCtrl($scope, ScheduleAcknowledgeFactory, $route, $uibModalInstance) {
    $scope.ConfirmAcknowledge = ConfirmAcknowledge;
    $scope.cancel = cancel;
    $scope.showContent = 'confirm';
    $scope.responseObj = {
      success: false,
      message: '',
      Results: []
    };
    $scope.results = [];
    function ConfirmAcknowledge() {
      $scope.showContent = 'loading';
      ScheduleAcknowledgeFactory.acknowledgeChanges().then(function (res) {
        return handleSubmitResponse(res);
      })["catch"](function (res) {
        return handleSubmitResponse(res);
      });
    }
    function handleSubmitResponse(res) {
      $scope.showContent = 'results';
      $scope.responseObj = res;
      if (res.Results && res.Results.some(function (s) {
        return !s.IsSuccess;
      })) {
        $scope.responseObj.success = false;
        $scope.responseObj.message = 'Some dates cannot be acknowledged';
      }
    }

    /**
    * Closes modal
    * @memberof ProposalInfoModalCtr
    */
    function cancel() {
      $uibModalInstance.close('cancel');
      if ($scope.responseObj.success) {
        $route.reload();
      }
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('ScheduleAcknowledgeFactory', ScheduleAcknowledgeFactory);
  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name ScheduleAcknowledgeFactory
  * @description 
  *   Get list, Update list & Acknowledge schedule changes
  * @ngInject
  */
  function ScheduleAcknowledgeFactory(localStorageMD5Service, GenericService, $http, apiUrl, defaultCalendarDate) {
    /**
     * Initialize the ScheduleChanges
     * @memberof ScheduleAcknowledgeFactory
     */
    function ScheduleChanges() {
      this.dates = [];
      this.showScheduleChangesModal = false;
    }
    var objType = 'ScheduleChanges';
    var objCallback = ScheduleChanges;
    var response = {
      success: false,
      message: '',
      Results: []
    };
    var service = {
      setAllScheduleChangesToStorage: setAllScheduleChangesToStorage,
      getScheduleChangesFromStorage: getScheduleChangesFromStorage,
      updateShowScheduleChangesModal: updateShowScheduleChangesModal,
      showScheduleChangesModal: showScheduleChangesModal,
      hasScheduleChanges: hasScheduleChanges,
      acknowledgeChanges: acknowledgeChanges
    };

    /**
     * Save All Schedule changes
     * @param {array} objList 
     */
    function setAllScheduleChangesToStorage(objList) {
      if (objList == null || !objList.length > 0) {
        GenericService.removeAll(objType);
      } else {
        var scheduleChanges = {
          dates: objList,
          showScheduleChangesModal: true
        };
        GenericService.saveOne(scheduleChanges, objType, objCallback);

        //GenericService.saveAll(objList,objType);
      }
    }

    /**
     * Get all Schedule changes
     */
    function getScheduleChangesFromStorage() {
      var dateList = [];
      var scheduleChanges = GenericService.getOne(objType, objCallback);
      if (scheduleChanges != null && scheduleChanges.dates != null) {
        scheduleChanges.dates.forEach(function (dateS) {
          var stringToDate = moment.utc(dateS);
          dateList.push(stringToDate);
        });
      }
      return dateList;
    }

    /* Update scheduleChanges object to storage
    * @memberof ScheduleAcknowledgeFactory
    * @param {bool} canShowModal whether the modal can be display
    */
    function updateShowScheduleChangesModal(canShowModal) {
      var scheduleChanges = GenericService.getOne(objType, objCallback);
      scheduleChanges.showScheduleChangesModal = canShowModal;
      GenericService.saveOne(scheduleChanges, objType, objCallback);
    }

    /**
     * ShowScheduleChangesModal check
     * @memberof ScheduleAcknowledgeFactory
     * @returns {bool} returns the value of showAutolandModal property
     */
    function showScheduleChangesModal() {
      var scheduleChanges = GenericService.getOne(objType, objCallback);
      if (scheduleChanges && scheduleChanges.dates != null && scheduleChanges.dates.length > 0) {
        var fistChange = moment.utc(scheduleChanges.dates[0]);
        var today = moment.utc();
        if (defaultCalendarDate) {
          today = moment.utc(defaultCalendarDate);
        }
        var datediff = fistChange.diff(today, 'days');
        return datediff <= 1 && scheduleChanges.showScheduleChangesModal;
      } else {
        return false;
      }
    }
    function hasScheduleChanges() {
      var dates = getScheduleChangesFromStorage();
      return dates != null && dates.length > 0;
    }

    /**
     * Acknowledge Changes 
     * @param {date} dateFrom The first schedule change date
     * @param {date} dateTo The last schedule change date
     * @returns {promise} response
     */
    function acknowledgeChanges() {
      //get dates from local storage
      var datesToAcknowledge = getScheduleChangesFromStorage();
      return $http.post(apiUrl + '/ScheduleAcknowledge/AcknowledgeScheduleChanges', datesToAcknowledge, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return updateScheduleChangesCallBack(res);
      })["catch"](function (res) {
        return acknowledgeFailedCallBack(res);
      });
    }

    /**
     * Update Schedule changes dates
     * @param {object} res 
     * @param {object} objectToAdd 
     * @returns {object} response
     */
    function updateScheduleChangesCallBack(res) {
      response.success = res.data.success;
      if (res.data.success) {
        //update local storage
        setAllScheduleChangesToStorage(res.data.data.DatesWithChanges);
        response.message = "Success! Your Acknowledge has been sent";
        response.Results = res.data.data.Results;
      } else {
        response.message = res.data.errorMessage;
      }
      return response;
    }

    /**
    * The callback function upon failure on submit
    * @returns {object} response
    */
    function acknowledgeFailedCallBack(res) {
      response.success = false;
      response.message = "Oops! Something went wrong";

      //TODO::Check status=500 error: returns res = {data: {…}, status: 500, config: {…}, statusText: "Internal Server Error", headers: ƒ}
      // res.data.data is null
      if (res.data && res.data.data && res.data.data.Results) {
        response.Results = res.data.data.Results;
      } else {
        //log results
        console.log(res);
      }
      return response;
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('FatigueCtrl', FatigueCtrl);
  function FatigueCtrl($scope, $routeParams, FlightFactory, SafetyReportFactory, $location, $timeout) {
    var flightId = $routeParams.flightId;
    var flight = FlightFactory.getFlightFromStorage(flightId);
    $scope.flight = flight;
    $scope.responseMessage = "";
    $scope.showPanel = "submit";
    $scope.operationalPhasesOptions = ['Parked', 'Pushback', 'Taxi-Out', 'Take-Off', 'Climb', 'Cruise', 'Descent', 'Approach', 'Landing', 'Taxi-In'];
    $scope.rateFeltOptions = ['Fully Alert - wide awake', 'Very Lively - responsive, but not at peak', 'OK - somewhat fresh', 'A Little Tired - less than fresh', 'Moderately Tired - let down'];
    $scope.signsPhysicalOptions = ['No physical signs noted ', 'Fidgeting', 'Rubbing eyes', 'Heavy eyelids', 'Yawning', 'Frequent blinking', 'Staring blankly', 'Long blinks', 'Difficulty keeping eyes open', 'Head nodding', 'Micro-sleeps', 'Unintentional sleeps'];
    $scope.signsCognitiveOptions = ['No cognitive signs noted', 'Impaired attention', 'Difficulty concentrating', 'Impaired memory', 'Reduced communication', 'Impaired problem solving', 'Increased risk taking', 'Impaired situational awareness', 'Accidentally doing the wrong thing (error)', 'Accidentally not doing the right thing (omission)', 'Failure to anticipate the event or action'];
    $scope.signsEmotionalOptions = ['No emotional signs', 'More quiet or withdrawn than usual', 'Lacking in energy', 'Lacking in motivation to do the task well', 'Negative mood', 'Irritable or grumpy behavior'];
    $scope.counterMeasuresOptions = ['Controlled rest', 'Caffeine', 'Use of automationy', 'Change of controls', 'Turn up the lights', 'Food, drink', 'Increased checks', 'Workload share', 'Increased communication', 'Inform a colleague'];
    $scope.hours24Options = Array.from({
      length: 21
    }, function (_, i) {
      return i;
    }); // Generates an array with values from 0 to 20

    $scope.hoursAwakeOptions = Array.from({
      length: 21
    }, function (_, i) {
      return i;
    }); // Generates an array with values from 0 to 20

    $scope.formData = {
      flightId: $routeParams.flightId,
      flightNo: flight.FlightNo,
      flightDate: flight.ScheduledDeparture,
      flightDep: flight.Departure,
      flightArr: flight.Arrival,
      flightRegistration: flight.AcTailNo,
      occurenceTitle: "",
      description: "",
      // attachedFiles: [],
      operationalPhase: "",
      rateFelt: "",
      signsPhysical: [],
      signsCognitive: [],
      signsEmotional: [],
      hours24: "",
      hoursAwake: "",
      rateFeltSecond: "",
      counterMeasures: []
    };
    $scope.toggleSelection = function (option, signs) {
      var idx = signs.indexOf(option);
      if (idx > -1) {
        signs.splice(idx, 1);
      } else {
        signs.push(option);
      }
    };
    $scope.isChecked = function (option, signs) {
      return signs.indexOf(option) > -1;
    };
    $scope.getSelectedOptionsText = function (signs) {
      if (signs.length === 0) {
        return "- Select options -";
      }
      return signs.join(', ');
    };
    $scope.isRequiredFieldEmpty = function (field) {
      return !field.length;
    };
    $scope.sizeLimitKb = 25000;
    $scope.fileTooLargeMsg = false;
    $scope.confirmCreateFatigueReport = confirmCreateFatigueReport;
    $scope.fileUploaded = fileUploaded;
    $scope.removeFile = removeFile;
    $scope.isIFileTooLarge = isFileTooLarge;
    $scope.submitFatigueReport = submitFatigueReport;
    $scope.sendFatigueReport = sendFatigueReport;
    $scope.submitted = false;
    function submitFatigueReport() {
      if ($scope.fatigueReport.$valid) {
        confirmCreateFatigueReport();
      } else {
        bootbox.alert("Please fill in all the required fields.");
      }
    }
    function confirmCreateFatigueReport() {
      bootbox.dialog({
        message: "<strong>Would you like to proceed with the Fatigue Report?</strong><br/><br/>",
        title: "Send Report",
        buttons: {
          confirm: {
            label: 'Confirm',
            className: "btn-success",
            callback: function callback() {
              $scope.showPanel = "loading";
              SafetyReportFactory.saveFatigueReport($scope.formData).then(function (res) {
                return handleSubmitResponse(res);
              });
            }
          },
          cancel: {
            label: "Cancel",
            className: "btn-default",
            callback: function callback() {}
          }
        }
      });
    }
    function handleSubmitResponse(res) {
      var alertStyle = res.success ? "success" : "warning";
      bootbox.dialog({
        message: "<div class='alert alert-" + alertStyle + "'><strong>" + res.message + " </strong></div>",
        title: "Response Message",
        buttons: {
          cancel: {
            label: "Close",
            className: "btn-default",
            callback: function callback() {
              if (res.success) {
                $timeout(gotoFlightInfo(flightId));
              } else {
                $timeout($scope.showPanel = "submit");
              }
            }
          }
        }
      });
    }
    function sendFatigueReport(formData) {
      $scope.submitted = true;
      if ($scope.fatigueReport.$valid && !$scope.isRequiredFieldEmpty(formData.signsPhysical) && !$scope.isRequiredFieldEmpty(formData.signsCognitive) && !$scope.isRequiredFieldEmpty(formData.signsEmotional)) {
        createFatigueReport();
      } else {
        bootbox.alert("Please fill in all the required fields.");
      }
    }
    function createFatigueReport() {
      bootbox.dialog({
        message: "<strong>Would you like to send the Fatigue Report?</strong><br/><br/>",
        title: "Send Report",
        buttons: {
          confirm: {
            label: 'Confirm',
            className: "btn-success",
            callback: function callback() {
              $scope.showPanel = "loading";
              SafetyReportFactory.emailFatigueReport($scope.formData).then(function (res) {
                return handleSubmitResponse(res);
              });
            }
          },
          cancel: {
            label: "Cancel",
            className: "btn-default",
            callback: function callback() {}
          }
        }
      });
    }
    function isFileTooLarge(image) {
      var isLarge = false;
      if (image && image.dataURL != null) {
        isLarge = image.dataURL.length > $scope.sizeLimitKb * 1024;
      }
      return isLarge;
    }
    function fileUploaded(data) {
      var fileResult = data; //$scope.imageBrowsed;
      var uploadedFile = {};
      uploadedFile.fileBlobb = fileResult.dataURL;
      uploadedFile.description = fileResult.fileType || fileResult.file.type;
      uploadedFile.fileName = fileResult.fileName;

      // var files = $scope.formData.attachedFiles;
      if ($scope.formData.attachedFiles.length < 5) {
        // var n = Object.create(attachedFile);
        $scope.formData.attachedFiles.push(uploadedFile);
      } else {
        $scope.showMaxFiles = true;
      }
    }
    function removeFile(attachedFile) {
      var files = $scope.formData.attachedFiles;
      var arrayLenght = files.length;
      var itemIndex = -1;
      for (var i = 0; i < arrayLenght; i++) {
        if (files[i].fileName == attachedFile.fileName) {
          itemIndex = i;
          break;
        }
      }
      if (itemIndex >= 0) {
        files.splice(itemIndex, 1);
        return attachedFile;
      }
      if ($scope.showMaxImages) {
        appendPhoto();
      }
      $scope.showMaxImages = false;
    }
    function gotoFlightInfo(flightId) {
      $location.path('/flightinfo/' + flightId);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('SafetyCtrl', SafetyCtrl);
  function SafetyCtrl($scope, $timeout, operationalPhases, $routeParams, FlightFactory, SafetyReportFactory, UserFactory, $location) {
    var flightId = $routeParams.flightId;
    var flight = FlightFactory.getFlightFromStorage(flightId);
    var user = UserFactory.getUser();
    $scope.flight = flight;
    $scope.tcas = false;
    $scope.egpws = false;
    $scope.bird = false;
    $scope.selectedCategory = "General";
    $scope.operationalPhases = angular.fromJson(operationalPhases);
    $scope.categories = ["General", "TCAS", "Bird Strike", "EGPWS"];
    $scope.usefulnesses = ["NECESSARY", "NUISANCE", "USEFUL"];
    $scope.showMaxImages = false;
    $scope.responseMessage = "";
    $scope.showPanel = "submit";
    $scope.formData = {
      flightId: $routeParams.flightId,
      flightNo: flight.FlightNo,
      flightDate: flight.ScheduledDeparture,
      flightDep: flight.Departure,
      flightArr: flight.Arrival,
      flightRegistration: flight.AcTailNo,
      occurenceTitle: "",
      description: "",
      selectedPhase: "",
      meteo: "",
      trainingFlight: findTrainingFlight(),
      attachedFiles: [],
      isConfidential: false,
      // tcasType: {},   

      atcCallsign: "",
      alertType: "",
      usefulness: "",
      originalRa: "",
      subsequentRa: "",
      isRaFollowed: "",
      eventLocation: "",
      airMiss: "",
      trafficBearing: null,
      distance: null,
      altitude: null,
      relativeAltitude: null,
      visualContact: "",
      seatbeltSign: "",
      paxNo: null,
      // birdStrikeType: {},
      birdSpecies: "",
      numberSeen: "",
      birdNo: null,
      birdSize: "",
      areaOfDamage: "",
      speed: null,
      height: null,
      hasPilotWarned: "",
      birdEventLocation: "",
      runwayUsed: "",
      //egpwsType: {}
      eqpwsEventLocation: ""
    };
    $scope.confirmCreateReport = confirmCreateReport;
    $scope.fileUploaded = fileUploaded;
    $scope.removeFile = removeFile;
    $scope.showSelectedCategory = showSelectedCategory;
    $scope.submitForm = submitForm;
    function findTrainingFlight() {
      return flight.crew.some(function (item) {
        return item.aimsId == user.aimsId && item.TrainingIndicatorCode != null && item.TrainingIndicatorCode.length > 0;
      });
    }
    function showSelectedCategory() {
      if ($scope.selectedCategory == "TCAS") {
        $scope.tcas = true;
        $scope.egpws = false;
        $scope.bird = false;
        clearForm();
      } else if ($scope.selectedCategory == "EGPWS") {
        $scope.egpws = true;
        $scope.tcas = false;
        $scope.bird = false;
        clearForm();
      } else if ($scope.selectedCategory == "Bird Strike") {
        $scope.bird = true;
        $scope.tcas = false;
        $scope.egpws = false;
        clearForm();
      } else {
        $scope.tcas = false;
        $scope.egpws = false;
        $scope.bird = false;
        clearForm();
      }
    }
    function clearForm() {
      // tcas type fields
      $scope.formData.atcCallsign = "";
      $scope.formData.alertType = "";
      $scope.formData.usefulness = "";
      $scope.formData.originalRa = "";
      $scope.formData.subsequentRa = "";
      $scope.formData.isRaFollowed = "";
      $scope.formData.eventLocation = "";
      $scope.formData.airMiss = "";
      $scope.formData.trafficBearing = null;
      $scope.formData.distance = null;
      $scope.formData.altitude = null;
      $scope.formData.relativeAltitude = null;
      $scope.formData.visualContact = "";
      $scope.formData.seatbelt = "";
      $scope.formData.paxNo = null;

      // bird strike type fields
      $scope.formData.birdSpecies = "";
      $scope.formData.numberSeen = "";
      $scope.formData.birdNo = null;
      $scope.formData.birdSize = "";
      $scope.formData.areaOfDamage = "";
      $scope.formData.speed = null;
      $scope.formData.height = null;
      $scope.formData.hasPilotWarned = "";
      $scope.formData.birdEventLocation = "";
      $scope.formData.runwayUsed = "";

      // egpws type field
      $scope.formData.eqpwsEventLocation = "";
    }
    function submitForm() {
      if ($scope.formFlightReport.$valid) {
        confirmCreateReport();
        //console.log($scope.formData.attachedFiles);        
      } else {
        bootbox.alert("Please fill in all the required fields.");
      }
    }
    function confirmCreateReport() {
      bootbox.dialog({
        message: "<strong>Would you like to proceed with the Safety Report?</strong><br/><br/>",
        title: "Send Report",
        buttons: {
          confirm: {
            label: 'Confirm',
            className: "btn-success",
            callback: function callback() {
              $scope.showPanel = "loading";
              SafetyReportFactory.saveSafetyReport($scope.formData).then(function (res) {
                return handleSubmitResponse(res);
              });
            }
          },
          cancel: {
            label: "Cancel",
            className: "btn-default",
            callback: function callback() {}
          }
        }
      });
    }
    function handleSubmitResponse(res) {
      var alertStyle = res.success ? "success" : "warning";
      bootbox.dialog({
        message: "<div class='alert alert-" + alertStyle + "'><strong>" + res.message + " </strong></div>",
        title: "Response Message",
        buttons: {
          cancel: {
            label: "Close",
            className: "btn-default",
            callback: function callback() {
              if (res.success) {
                $timeout(gotoFlightInfo(flightId));
              } else {
                $timeout($scope.showPanel = "submit");
              }
            }
          }
        }
      });
    }
    function isFileTooLarge(image) {
      var isLarge = false;
      if (image && image.dataURL != null) {
        isLarge = image.dataURL.length > $scope.sizeLimitKb * 1024;
      }
      return isLarge;
    }
    function fileUploaded(data) {
      var fileResult = data; //$scope.imageBrowsed;
      var uploadedFile = {};
      if (isFileTooLarge(data)) {
        $scope.fileTooLargeMsg = true;
      } else {
        $scope.fileTooLargeMsg = false;
        uploadedFile.fileBlobb = fileResult.dataURL;
        uploadedFile.description = fileResult.fileType || fileResult.file.type;
        uploadedFile.fileName = fileResult.fileName;

        // var files = $scope.formData.attachedFiles;
        if ($scope.formData.attachedFiles.length < 5) {
          // var n = Object.create(attachedFile);
          $scope.formData.attachedFiles.push(uploadedFile);
        } else {
          $scope.showMaxFiles = true;
        }
      }
    }
    function removeFile(attachedFile) {
      var files = $scope.formData.attachedFiles;
      var arrayLenght = files.length;
      var itemIndex = -1;
      for (var i = 0; i < arrayLenght; i++) {
        if (files[i].fileName == attachedFile.fileName) {
          itemIndex = i;
          break;
        }
      }
      if (itemIndex >= 0) {
        files.splice(itemIndex, 1);
        return attachedFile;
      }
      if ($scope.showMaxImages) {
        appendPhoto();
      }
      $scope.showMaxImages = false;
    }
    function gotoFlightInfo(flightId) {
      $location.path('/flightinfo/' + flightId);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('SafetyReportFactory', SafetyReportFactory);
  function SafetyReportFactory($http, apiUrl) {
    var submitResponseObj = {
      success: false,
      message: ''
    };
    var service = {
      saveSafetyReport: saveSafetyReport,
      saveFatigueReport: saveFatigueReport,
      emailFatigueReport: emailFatigueReport
    };
    function saveSafetyReport(safetyReport) {
      var aqdBaseURL = apiUrl + '/SafetyReports/SaveSafetyReport';
      return $http.post(aqdBaseURL, safetyReport, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
    }
    function saveFatigueReport(fatigueReport) {
      var aqdBaseURL = apiUrl + '/SafetyReports/SaveFatigueReport';
      return $http.post(aqdBaseURL, fatigueReport, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getResponse(res);
      })["catch"](function (res) {
        return getResponseFailed(res);
      });
    }
    function getResponse(res) {
      submitResponseObj.success = res.data.success;
      if (res.data.success) {
        submitResponseObj.message = "Safety Report Submited successfully";
      } else {
        submitResponseObj.message = res.data.errorMessage;
      }
      return submitResponseObj;
    }
    function getResponseFailed(res) {
      submitResponseObj.success = false;
      submitResponseObj.message = "Something went wrong!";
      return submitResponseObj;
    }
    function emailFatigueReport(fatigueReport) {
      var aqdBaseURL = apiUrl + '/SafetyReports/EmailFatigueReport';
      return $http.post(aqdBaseURL, fatigueReport, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return getFatigueResponse(res);
      })["catch"](function (res) {
        return getFatigueResponseFailed(res);
      });
    }
    function getFatigueResponse(res) {
      submitResponseObj.success = res.data.success;
      if (res.data.success) {
        submitResponseObj.message = "Fatigue Report sent successfully.";
      } else {
        submitResponseObj.message = res.data.errorMessage;
      }
      return submitResponseObj;
    }
    function getFatigueResponseFailed(res) {
      submitResponseObj.success = false;
      submitResponseObj.message = "Something went wrong!";
      return submitResponseObj;
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('SearchFlightsCtrl', SearchFlightsCtrl);
  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name SearchFlightsCtrl
  * @description 
  *   Search Flight info modal
  * @ngInject
  */
  function SearchFlightsCtrl($scope, $uibModalInstance, $route, $location, defaultCalendarDate, SearchFlightsFactory, GroundDutyFactory, FlightFactory) {
    $scope.showContent = 'search';
    $scope.hasError = false;
    $scope.flightFound = null;
    $scope.searchFlights = searchFlights;
    $scope.searchCriteriaContent = searchCriteriaContent;
    $scope.closeModal = closeModal;
    $scope.gotoSelectedFlightInfo = gotoSelectedFlightInfo;
    $scope.validationFormError = '';
    $scope.hasPublishedRoster = true;

    //Date picker:
    $scope.openDatepicker = openDatepicker;
    var today = new Date().toUTC();
    if (defaultCalendarDate) {
      today = new Date(defaultCalendarDate).toUTC();
    }
    function openDatepicker() {
      $scope.searchCriteria.flightDatePicker.opened = true;
    }
    updateSearchCriteriaScope();
    function updateSearchCriteriaScope() {
      var fromDate = null;
      var toDate = null;
      var groundDutyDates = GroundDutyFactory.getFirstAndLastDateOfGroundDuties();
      var flightDates = FlightFactory.getTheFirstAndTheLastFlightDates();
      if (groundDutyDates && flightDates && groundDutyDates.firstDate && flightDates.firstDate) {
        fromDate = groundDutyDates.firstDate < flightDates.firstDate ? groundDutyDates.firstDate : flightDates.firstDate;
        toDate = groundDutyDates.lastDate > flightDates.lastDate ? groundDutyDates.lastDate : flightDates.lastDate;
      } else if (flightDates && flightDates.firstDate) {
        fromDate = flightDates.firstDate;
        toDate = flightDates.lastDate;
      } else if (groundDutyDates && groundDutyDates.firstDate) {
        fromDate = groundDutyDates.firstDate;
        toDate = groundDutyDates.lastDate;
      } else {
        $scope.hasPublishedRoster = false;
        $scope.showContent = "results";
        $scope.hasError = true;
      }
      $scope.searchCriteria = {
        flightDatePicker: {
          value: today,
          format: 'dd-MM-yyyy',
          opened: false,
          options: {
            minDate: fromDate,
            maxDate: toDate
          }
        },
        flightNo: "",
        departure: "",
        arrival: ""
      };
    }
    function searchFlights() {
      $scope.hasError = false;
      if ($scope.searchCriteria.flightNo.length == 0 && $scope.searchCriteria.departure.length == 0 && $scope.searchCriteria.arrival.length == 0) {
        $scope.validationFormError = 'Ensure that at least one optional value is provided.';
      } else {
        $scope.showContent = 'loading';
        SearchFlightsFactory.getFlights($scope.searchCriteria).then(function (res) {
          return handleResponse(res);
        })["catch"](function (res) {
          return handleFailedResponse(res);
        });
      }
    }
    function handleResponse(res) {
      $scope.showContent = 'results';
      if (res.data && res.data.success && res.data.data) {
        $scope.flightsFound = res.data.data;

        //auto redirect when only one flight in results:
        // if($scope.flightsFound.lenght == 1){
        //     gotoSelectedFlightInfo($scope.flightsFound[0].flightId, $scope.flightsFound[0].flightDate, $scope.flightsFound[0].flightNo, $scope.flightsFound[0].departure);
        // }
      } else {
        $scope.hasError = true;
      }
    }
    function handleFailedResponse(res) {
      $scope.showContent = 'results';
      $scope.hasError = true;
    }
    function searchCriteriaContent() {
      $scope.showContent = 'search';
    }

    /**
     * Redirect to selected flight info
     */
    function gotoSelectedFlightInfo(flightId, flightDate, flightNo, departure) {
      closeModal();
      $location.path('/selectedflightinfo/' + flightId + '/' + flightDate + '/' + flightNo + '/' + departure);
    }

    /**
     * Close the modal
     * @memberof SearchPastGDCtrl
     */
    function closeModal() {
      $uibModalInstance.close('cancel');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('SearchFlightsFactory', SearchFlightsFactory);
  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name SearchFlightsFactory
  * @description 
  * Get selected flight info
  * @ngInject
  */
  function SearchFlightsFactory($http, $q, apiUrl, $timeout) {
    var service = {
      getFlights: getFlights,
      getFlightInfo: getFlightInfo
    };
    function getFlights(criteria, callback) {
      //test UI:
      //return getFlightsDummy(criteria)

      var flightDate = criteria.flightDatePicker.value.toString('yyyy-MM-dd');
      var uri = encodeURI(apiUrl + '/SearchFlights/GetFlights?flightDate=' + flightDate + '&flightNo=' + criteria.flightNo + '&departure=' + criteria.departure + '&arrival=' + criteria.arrival);
      return $http.get(uri, {
        'Content-Type': 'application/json'
      })["catch"](callback);
    }
    function getFlightInfo(flightId, flightDate, flightNo, departure, callback) {
      var flightDateStr = flightDate.toString('yyyy-MM-dd');

      // $http({
      //     url: apiUrl + '/SearchFlights/GetFlightInfo', 
      //     method: "GET",
      //     contentType: "application/json",
      //     params: {flightId: flightId, flightDate: flightDateStr, flightNo: flightNo, departure: departure}
      //  });

      var uri = encodeURI(apiUrl + '/SearchFlights/GetFlightInfo?flightId=' + flightId + '&flightDate=' + flightDateStr + '&flightNo=' + flightNo + '&departure=' + departure);
      return $http.get(uri, {
        'Content-Type': 'application/json'
      })["catch"](callback);
    }
    function getFlightsDummy(criteria) {
      // Create a deferred object to handle the promise
      var deferred = $q.defer();
      // Simulate an asynchronous operation (e.g., API call) with a delay
      $timeout(function () {
        var flightDate = criteria.flightDatePicker.value.toString('yyyy-MM-dd');

        // Simulate getting flight data asynchronously
        var testSuccessResults = {
          data: getDummyFlightResults(),
          success: true,
          errorMessage: ""
        };

        // Resolve the promise with the retrieved data
        deferred.resolve(testSuccessResults);
      }, 2000);

      // Return the promise
      return deferred.promise;
    }
    function getDummyFlightResults() {
      return {
        "FlightsFound": [{
          "Id": 1,
          "FlightNo": "A3123",
          "FlightDate": "2023-10-20T00:00:00",
          "Registration": "AAA-OK1",
          "STD": "2023-10-20T08:00:00",
          "STA": "2023-10-20T12:00:00",
          "Departure": "ATH",
          "Arrival": "SKG"
        }, {
          "Id": 2,
          "FlightNo": "A3789",
          "FlightDate": "2023-10-21T00:00:00",
          "Registration": "AAA-OK2",
          "STD": "2023-10-21T15:30:00",
          "STA": "2023-10-21T19:30:00",
          "Departure": "SKG",
          "Arrival": "ATH"
        }, {
          "Id": 3,
          "FlightNo": "OA456",
          "FlightDate": "2023-10-22T00:00:00",
          "Registration": "CCC-OK3",
          "STD": "2023-10-22T10:15:00",
          "STA": "2023-10-22T14:15:00",
          "Departure": "ATH",
          "Arrival": "SKG"
        }]
      };
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('SelectedFlightCtrl', SelectedFlightCtrl);
  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name SelectedFlightCtrl
  * @description 
  *   Show selected Flight info page
  * @ngInject
  */
  function SelectedFlightCtrl($scope, $routeParams, defaultCalendarDate, SearchFlightsFactory, $timeout, showRecomendedWaterAcTypes) {
    //get value from routeParams:
    var flightId = $routeParams.flightId;
    var flightDate = $routeParams.flightDate;
    var flightNo = $routeParams.flightNo;
    var departure = $routeParams.departure;
    window.addEventListener('online', function (e) {
      $timeout(checkConnectionStatus());
    });
    $scope.init = checkConnectionStatus();
    $scope.contentToShow = "loading";
    $scope.flightInfo = null;
    $scope.hasFlightInfo = false;
    $scope.pilotCrewMembers = [];
    $scope.cabinCrewMembers = [];
    $scope.dhcCrewMembers = [];
    $scope.waterQuantity = null;
    $scope.supportsWaterUpliftAcType = false;
    $scope.crewRouteInfoPanel = {
      hasAircraftPositions: true,
      crewRouteDuties: []
    };

    /**
     * Checks if the client is online or offline 
     * @memberof SelectedFlightCtrl  
     */
    function checkConnectionStatus() {
      var isOnline = window.navigator.onLine;
      if (isOnline) {
        getFlightInfo();
      } else {
        showError("Please check your internet connection!");
      }
    }
    function getFlightInfo() {
      SearchFlightsFactory.getFlightInfo(flightId, flightDate, flightNo, departure).then(function (res) {
        return handleResponse(res);
      })["catch"](function (res) {
        return handleFailedResponse(res);
      });
    }
    function handleResponse(res) {
      if (res.data.success) {
        if (res.data.data && res.data.data.Flight) {
          $scope.flightInfo = res.data.data;
          updateFlightInfoScopes(res.data.data);
          updateCrewMembersScopes();
          updatePaxPanelScopes();
          $scope.contentToShow = 'results';
          $scope.hasFlightInfo = true;
        } else {
          showError("Flight Info not found.");
        }
      } else {
        showError(res.data.errorMessage);
      }
    }
    function handleFailedResponse(res) {
      $scope.contentToShow = 'results';
      $scope.hasError = true;
      showError(res.errorMessage);
    }

    /**
     * Displays the error message
     * @memberof SelectedFlightCtrl  
     * @param {string} message message to display
     */
    function showError(message) {
      $scope.contentToShow = "error";
      $scope.errorMessage = message;
    }
    function updateCrewMembersScopes() {
      $scope.pilotCrewMembers = $scope.flightInfo.CrewInfo.filter(function (x) {
        return (x.PositionCode == 'CP' || x.PositionCode == "FO") && !x.DHC;
      });
      $scope.cabinCrewMembers = $scope.flightInfo.CrewInfo.filter(function (x) {
        return (x.PositionCode == 'SA' || x.PositionCode == "FA") && !x.DHC;
      });
      $scope.dhcCrewMembers = $scope.flightInfo.CrewInfo.filter(function (x) {
        return x.DHC;
      });
    }
    function updatePaxPanelScopes() {
      $scope.supportsWaterUpliftAcType = showRecomendedWaterAcTypes.includes($scope.flightInfo.AcType);
      getWaterQuantity();
    }
    function getWaterQuantity() {
      var totalPax = $scope.flightInfo.Flight.BOOKED_C + $scope.flightInfo.Flight.BOOKED_Y;
      var startDate = moment($scope.flightInfo.Flight.STD);
      var endDate = moment($scope.flightInfo.Flight.STA);
      var duration = moment.duration(endDate.diff(startDate)).asHours();
      var waterQuantity = (0, 18 * totalPax * duration) / 200;
      var formattedwaterQuantity = waterQuantity.toString().substring(0, 4);
      $scope.waterQuantity = formattedwaterQuantity;
      if (waterQuantity) {
        $scope.supportsWaterUpliftAcType = true;
      }
    }
    function updateFlightInfoScopes(flightInfoObj) {
      var flight = {};
      flight.showPreviousAcPos = true;
      flight.showNextAcPos = true;
      flight.hasChangeAircraft = false;
      flight.DutyType = 'Flight';
      flight.FlightId = flightInfoObj.Flight.FlightId;
      flight.FlightNo = flightInfoObj.Flight.FlightNo;
      flight.Departure = flightInfoObj.Flight.DEP;
      flight.Arrival = flightInfoObj.Flight.ARR;
      flight.AcTailNo = flightInfoObj.Flight.Registration;
      flight.AcType = flightInfoObj.Flight.AcType;
      flight.DepartureStand = flightInfoObj.Flight.DEPSTAND;
      flight.ArrivalStand = flightInfoObj.Flight.ARRSTAND;
      flight.BookedC = flightInfoObj.Flight.BOOKED_C;
      flight.BookedY = flightInfoObj.Flight.BOOKED_Y;
      flight.ScheduledDeparture = flightInfoObj.Flight.STD;
      var STD = new Date(flight.ScheduledDeparture);
      flight.ScheduledDepartureDateUTC = STD.toString('yyyy-MM-dd');
      flight.ScheduledDepartureTimeUTC = STD.toString('HH:mm');
      flight.ScheduledArrival = flightInfoObj.Flight.STA;
      flight.CTOT = flightInfoObj.Flight.CTOT;
      flight.ETD = flightInfoObj.Flight.ETD;
      flight.ATD = flightInfoObj.Flight.ATD;
      flight.ETA = flightInfoObj.Flight.ETA;
      flight.ATA = flightInfoObj.Flight.ATA;
      flight.DepartureCountryISO = flightInfoObj.Flight.DepartureCountryISO;
      flight.ArrivalCountryISO = flightInfoObj.Flight.ArrivalCountryISO;
      flight.DepartureEU = flightInfoObj.Flight.DepartureEU;
      flight.ArrivalEU = flightInfoObj.Flight.ArrivalEU;
      flight.DepartureSchengen = flightInfoObj.Flight.DepartureSchengen;
      flight.ArrivalSchengen = flightInfoObj.Flight.ArrivalSchengen;
      var diffMin = Date.DifferenceInMinutes(flight.ScheduledDeparture, flight.ScheduledArrival);
      flight.BTime = Date.MinutesToStringSimple(diffMin);
      flight.Delay = moment(flight.ATD).diff(moment(flight.ScheduledDeparture), 'minutes') || "";
      flight.ArrDelay = moment(flight.ATA).diff(moment(flight.ScheduledArrival), 'minutes') || "";
      flight.flightDelays = {};
      flight.flightDelays.TotalDelay = flightInfoObj.FlightDelays.TotalDelay;
      flight.flightDelays.UnJustified = flightInfoObj.FlightDelays.UnJustified;
      flight.flightDelays.DC93 = flightInfoObj.FlightDelays.DC93;
      flight.flightDelays.DC9 = flightInfoObj.FlightDelays.DC9;
      //flight.crewMeals : no info

      flight.aircaftPositions = flightInfoObj.AircaftPositions;
      $scope.crewRouteInfoPanel.crewRouteDuties.push(flight);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.service("InfoAPIService", InfoAPIService);

  /**
  * @memberof PilotReports
  * @ngdoc service
  * @name InfoAPIService
  * @description 
  *  Information service which gets latest pax and gate data
  * @ngInject
  */
  function InfoAPIService($http, $q, apiUrl, LogService, SyncAPIService, UserFactory, FlightGateFactory, FlightFactory, PaxInfoFactory, AircaftPositionsFactory, GroundDutyFactory, FlightCheckInsFactory, FlightDelaysFactory) {
    /**
     * get latest Passenger information
     * @memberof InfoAPIService
     * @return {object} promise
     */
    function getPax(flightId) {
      //Prepare to request training courses fetch
      var flight = FlightFactory.getFlightFromTotalFlights(flightId);
      var flightInfo = {
        FlightId: flightId,
        FlightCourses: flight ? flight.Courses : []
      };
      var user = UserFactory.getUser();
      var call = $q.defer();
      $http.post(apiUrl + '/info/Pax', flightInfo, {
        'Content-Type': 'application/json'
      }).then(function (responseData) {
        if (responseData == undefined || responseData.data == undefined || responseData.data.data == undefined) {
          var err = new Error();
          err.status = -1;
          var msg = "ResponseData error in info/gates :" + JSON.stringify(responseData);
          LogService.debug(msg, err);
          call.reject(err);
          return;
        }
        var newDutyInfo = responseData.data.data;
        newDutyInfo.FlightId = flightId;
        updateFlightLocalStorage(newDutyInfo);
        updateCrewCheckIn(newDutyInfo);
        FlightDelaysFactory.upsertFlightDelays(newDutyInfo.FlightDelays);

        // return true
        call.resolve(responseData);
      }, function (err) {
        call.reject(err);
      });
      return call.promise;
    }

    /**
     * Gets latest info for each duty in a crew route
     * @memberof InfoAPIService
     * @param {object} crewRouteDuty 
     * @param {function} callback 
     */
    function refreshCrewRoute(crewRouteDuty, callback) {
      var crewRouteInfo = {
        DutyNo: crewRouteDuty.DutyNo,
        DutyDay: crewRouteDuty.DutyDay,
        Route: crewRouteDuty.Route,
        From: crewRouteDuty.DutyBegin,
        To: crewRouteDuty.DutyEnd,
        FlightCourses: crewRouteDuty.Courses,
        CurrentDutyDate: crewRouteDuty.CurrentDutyDate
      };
      //refresh route for the current day (Flight page)
      if (crewRouteDuty.CurrentDutyDate) {
        return $http.post(apiUrl + '/info/RefreshFlight', crewRouteInfo, {
          'Content-Type': 'application/json'
        }).then(callback);
      }
      //Refresh whole Crew Route (Crew Route oage)
      else {
        return $http.post(apiUrl + '/info/RefreshCrewRoute', crewRouteInfo, {
          'Content-Type': 'application/json'
        }).then(callback);
      }
    }

    /**
     * Updates Route's Data Status depending on Refresh respond
     * @memberof InfoAPIService
     * @param {object} newDuty - Refresh respond
     * @param {array} dataStatus 
     */
    function updateCrewRouteStatusSetter(dataStatus, crewRouteStatuses) {
      if (crewRouteStatuses.meals) {
        updateStatusSetter(dataStatus, ["Meals"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Meals"], "N/A", "No available data");
      }
      if (crewRouteStatuses.airportContacts) {
        updateStatusSetter(dataStatus, ["Airport Contacts"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Airport Contacts"], "N/A", "No available data");
      }
      if (crewRouteStatuses.groundServices) {
        updateStatusSetter(dataStatus, ["Ground Services"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Ground Services"], "N/A", "No available data");
      }
      if (crewRouteStatuses.airportHotels) {
        updateStatusSetter(dataStatus, ["Hotels"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Hotels"], "N/A", "No available data");
      }
      if (crewRouteStatuses.crewAimsMemos) {
        updateStatusSetter(dataStatus, ["Aims Memos"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Aims Memos"], "N/A", "No available data");
      }
    }

    /**
     * Updates Flight's Data Status depending on Refresh respond
     * @memberof InfoAPIService
     * @param {object} newDuty - Refresh respond
     * @param {array} dataStatus 
     */
    function updateFlightStatusSetter(newDuty, dataStatus) {
      if (newDuty.FlightInfo) {
        updateStatusSetter(dataStatus, ["Flight Status"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Flight Status"], "N/A", "No available data");
      }
      if (newDuty.AircraftPositions && newDuty.AircraftPositions.length > 0) {
        updateStatusSetter(dataStatus, ["Aircraft Movement"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Aircraft Movement"], "N/A", "No available data");
      }
      if (newDuty.FlightInfo && newDuty.FlightInfo.crew && newDuty.FlightInfo.crew.length > 0) {
        updateStatusSetter(dataStatus, ["Crew Info"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Crew Info"], "N/A", "No available data");
      }
      if (newDuty.FlightInfo && newDuty.FlightInfo.crew && newDuty.FlightInfo.crew.length > 0 && newDuty.FlightInfo.crew.filter(function (x) {
        return x.PhoneNumber != null;
      }).length > 0) {
        updateStatusSetter(dataStatus, ["Crew Contacts"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Crew Contacts"], "N/A", "No available data");
      }
      if (newDuty.CabinServiceManagementLists && newDuty.CabinServiceManagementLists.length > 0) {
        updateStatusSetter(dataStatus, ["Meals"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Meals"], "N/A", "No available data");
      }
      if (newDuty.CabinServiceManagementLists && newDuty.CabinServiceManagementLists.length > 0 && newDuty.CabinServiceManagementLists[0].ConnectingFlights && newDuty.CabinServiceManagementLists[0].ConnectingFlights.length > 0) {
        updateStatusSetter(dataStatus, ["Connections"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Connections"], "N/A", "No available data");
      }
      if (newDuty.CabinServiceManagementLists && newDuty.CabinServiceManagementLists.length > 0 && newDuty.CabinServiceManagementLists[0].ConnectingFlights && newDuty.CabinServiceManagementLists.length > 0) {
        updateStatusSetter(dataStatus, ["Pax Info"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Pax Info"], "N/A", "No available data");
      }
      if (newDuty.TrainingCourses && newDuty.TrainingCourses.length > 0) {
        updateStatusSetter(dataStatus, ["Training Info"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Training Info"], "N/A", "No available data");
      }
    }

    /**
     * Updates Ground Duty's Data Status depending on Refresh respond
     * @memberof InfoAPIService
     * @param {array} newDuty - Refresh respond
     * @param {array} dataStatus 
     */
    function updateGroundStatusSetter(newDuty, dataStatus) {
      if (newDuty) {
        updateStatusSetter(dataStatus, ["Duty Info"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Duty"], "N/A", "No available data");
      }
      if (newDuty && newDuty.RelatedGroundDuties && newDuty.RelatedGroundDuties.length > 1) {
        updateStatusSetter(dataStatus, ["Instructors"], "SUCCESS", "Successfully updated");
        updateStatusSetter(dataStatus, ["Trainees"], "SUCCESS", "Successfully updated");
      } else {
        updateStatusSetter(dataStatus, ["Instructors"], "N/A", "No available data");
        updateStatusSetter(dataStatus, ["Trainees"], "N/A", "No available data");
      }
    }

    /**
     * Changes the state of Data Status
     * @memberof InfoAPIService
     * @param {array} dataStatus 
     * @param {array} array - Datatype to change
     * @param {string} status - New status
     * @param {string} text - New text
     */
    function updateStatusSetter(dataStatus, array, status, text) {
      var objsTochange = dataStatus.filter(function (x) {
        var res = array.filter(function (s) {
          return s == x.datatype;
        });
        return res.length > 0 ? true : false;
      });
      objsTochange.forEach(function (x) {
        x.status = status;
        x.text = text;
        var index = dataStatus.map(function (x) {
          return x.datatype;
        }).indexOf(x.datatype);
        dataStatus[index] = x;
      });
    }

    /**
     * Update Flight Info in Local Storage
     * @memberof InfoAPIService
     * @param {object} duty 
     */
    function updateFlightLocalStorage(duty) {
      // save flight gates to local storage
      //var flightGates = duty.FlightGates;
      //FlightGateFactory.processUpdatedData(flightGates);
      //Update Aircraft positions
      if (duty.AircraftPositions != null && duty.AircraftPositions.length > 0) {
        AircaftPositionsFactory.updateAircraftPositionsToStorage(duty.AircraftPositions[0], duty.FlightInfo.FlightId);
      }

      // update flight to local storage
      FlightFactory.mergeFlightInfo(duty.FlightInfo, duty.ShowPaxNames);
      //Enrich flight info after sync
      SyncAPIService.updatePilotReportLocalEditFromSynch();
      // update paxinfo to local storage

      if (duty.CabinServiceManagementLists && duty.CabinServiceManagementLists.length > 0) {
        PaxInfoFactory.updatePaxInfo(duty.CabinServiceManagementLists[0]);
      }

      // update messages to local storage
      // MessageFactory.markReadAsSynched(duty.Messages);
      // MessageFactory.storeMessagesFromServer(duty.Messages);
    }
    /**
     * Update Flight crew check-in Info in Local Storage
     * @memberof InfoAPIService
     * @param {object} duty 
     */
    function updateCrewCheckIn(duty) {
      if (duty.FlightInfo) {
        FlightCheckInsFactory.updateFlightCrewCheckInToStorage(duty);
      }
    }

    /**
     * Update Ground Duty Info in Local Storage
     * @memberof InfoAPIService
     * @param {object} duty 
     */
    function updateGroundDutyLocalStorage(duty) {
      GroundDutyFactory.mergeGroundDutyInfo(duty);
    }
    return {
      getPax: getPax,
      refreshCrewRoute: refreshCrewRoute,
      updateFlightStatusSetter: updateFlightStatusSetter,
      updateGroundStatusSetter: updateGroundStatusSetter,
      updateStatusSetter: updateStatusSetter,
      updateFlightLocalStorage: updateFlightLocalStorage,
      updateGroundDutyLocalStorage: updateGroundDutyLocalStorage,
      updateCrewRouteStatusSetter: updateCrewRouteStatusSetter,
      updateCrewCheckIn: updateCrewCheckIn
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.service("SyncAPIService", SyncAPIService);
  /**
  * @memberof PilotReports
  * @ngdoc service
  * @name SyncAPIService
  * @description 
  * Generic Sync service which sends all your reports and Get all the latest data
  * @ngInject
  */
  function SyncAPIService($http, $q, apiUrl, FlightFactory, ReportGuidFactory, PilotReportTemplateFactory, SyncLogFactory, PilotReportLocalEditFactory, PilotReportSendToServerFactory, PilotReportSyncResultFactory, AircraftTypeFactory, DataCleanerFactory, MessageFactory, LogService, GroundDutyFactory, MemoFactory, PaxInfoFactory, CrewRouteFactory, CrewMealFactory, MemoImagesFactory, AircaftPositionsFactory, AimsCrewMemosFactory, LeaveRequestFactory, AutolandFactory, CatIIFactory, CrewHotelFactory, CourseFactory, ScheduleAcknowledgeFactory, CrewCallFactory, PreviousDutyFactory, LogCallFactory, CheckInFactory, FlightCheckInsFactory, TimeLogFactory, AnnualLeavesFactory, ExpiriesFactory, FlightDelaysFactory, TraineeCoursesDetailsFactory, RequestFactory) {
    /**
     * Find if a relative old flight exists and if exists update it 
     * @memberof SyncAPIService
     * @param {object} oldflight
     * @param {array} flights
     * @return {boolean} hasRelativeFlight
     */
    function relativeFlightMatcher(oldflight, flights) {
      var relativeFlights = [];
      var found = false;
      for (var i = 0; i < flights.length; i++) {
        if (oldflight.FlightNo == flights[i].FlightNo && oldflight.FlightDate == flights[i].FlightDate && oldflight.Departure == flights[i].Departure) {
          relativeFlights.push(flights[i]);
          found = true;
          break;
        }
      }
      if (!found) {
        var flight = null;
        var oldFlightNo = null;
        var lastDigit = oldflight.FlightNo.substr(oldflight.FlightNo.length - 1, 1);
        oldFlightNo = !isNaN(lastDigit) ? oldflight.FlightNo : oldflight.FlightNo.substr(0, oldflight.FlightNo.length - 1);
        for (var i = 0; i < flights.length; i++) {
          lastDigit = flights[i].FlightNo.substr(flights[i].FlightNo.length - 1, 1);
          flight = !isNaN(lastDigit) ? flights[i].FlightNo : flights[i].FlightNo.substr(0, flights[i].FlightNo.length - 1);
          if (oldFlightNo == flight && oldflight.FlightDate == flights[i].FlightDate && oldflight.Departure == flights[i].Departure) {
            relativeFlights.push(flights[i]);
          }
        }
      }
      if (relativeFlights.length == 1) {
        var pilotReportLocalEdit = PilotReportLocalEditFactory.getPilotReportLocalEditForFlight(oldflight.FlightId);
        pilotReportLocalEdit.FlightAimsId = relativeFlights[0].FlightAimsId;
        pilotReportLocalEdit.FlightId = relativeFlights[0].FlightId;
        PilotReportLocalEditFactory.setPilotReportToStorage(pilotReportLocalEdit);
        return true;
      } else if (relativeFlights.length > 1) {
        for (var i = 1; i < relativeFlights.length; i++) {
          for (var j = 0; j < relativeFlights.length - i; j++) {
            if (relativeFlights[j].FlightNo > relativeFlights[j + 1].FlightNo) {
              var a = relativeFlights[j];
              relativeFlights[j] = relativeFlights[j + 1];
              relativeFlights[j + 1] = a;
            }
          }
        }
        var pilotReportLocalEdit = PilotReportLocalEditFactory.getPilotReportLocalEditForFlight(oldflight.FlightId);
        pilotReportLocalEdit.FlightAimsId = relativeFlights[0].FlightAimsId;
        pilotReportLocalEdit.FlightId = relativeFlights[0].FlightId;
        PilotReportLocalEditFactory.setPilotReportReportToStorage(pilotReportLocalEdit);
        return true;
      } else {
        return false;
      }
    }
    ;
    return {
      /**
       * Send and get the latest information 
       * @memberof SyncAPIService
       * @param {object} aimsId
       * @param {array} memoIdsToSend 
       */
      doSync: function doSync(aimsId, memoIdsToSend) {
        //Clear timeLogs from local storage older than 2 days
        TimeLogFactory.cleanOldData();
        //clear CrewMeal ratings from local storage that have timestamp older than 20 days
        DataCleanerFactory.deleteOldCrewMealsRatings();

        // get the saved pilot reports
        var allSavedReports = PilotReportLocalEditFactory.getPilotReportsFromStorage();

        // keep only the ones that are ready to be sent
        var reportsToSend = PilotReportSendToServerFactory.getCompletedListFromPilotReportLocalEdits(allSavedReports);
        var messagesToSend = MessageFactory.getMessagesFromStorage();
        var lastLog = SyncLogFactory.getSyncLog();
        var lastSyncDate = lastLog.date;

        //Get call requests made while offline
        var phoneCallLog = {
          CrewCallReports: LogCallFactory.getLogCallsFromStorage()
        };
        var syncData = {
          "SyncPilotReports": reportsToSend,
          "Messages": messagesToSend,
          "MemoIds": memoIdsToSend,
          "CrewCallLog": phoneCallLog,
          "LastSyncDate": lastSyncDate
        };
        var call = $q.defer();
        $http.post(apiUrl + '/sync', syncData, {
          'Content-Type': 'application/json'
        }).then(function (responseData) {
          if (responseData == undefined || responseData.data == undefined || responseData.data.data == undefined || responseData.data.data.SyncPilotData == undefined) {
            var err = new Error();
            err.status = -1;
            var msg = "ResponseData error in sync :" + JSON.stringify(responseData);
            LogService.debug(msg, err);
            call.reject(err);
            return;
          }
          var response = responseData.data.data;

          //keep flights, will be used to retain a flight for old unsynched reports
          var orgFlights = FlightFactory.getFlightsFromStorage();

          // clear existing server data
          FlightFactory.clearFlightsFromStorage();
          ReportGuidFactory.clearReportGuidsFromStorage();
          PilotReportTemplateFactory.clearPilotReportTemplateFromStorage();
          AircraftTypeFactory.clearAircraftTypesFromStorage();
          PilotReportSyncResultFactory.clearPilotReportSyncResultsFromStorage();
          MessageFactory.clearMessagesFromStorage();
          AimsCrewMemosFactory.clearAimsCrewMemosFactoryFromStorage();

          // save flight data to local storage
          var flightData = response.SyncPilotData.flights;
          var flights = FlightFactory.markScheduleChangedFlights(flightData, orgFlights);
          var pilotReports = response.SyncPilotData.pilotReports;
          var cabinReports = response.SyncPilotData.cabinReports;
          var messages = response.SyncPilotData.messages;
          for (var i = 0; i < messages.length; i++) {
            messages[i].AuthorName = messages[i].AuthorName.replace("GATEWAY\\", "");
            messages[i].AuthorName = messages[i].AuthorName.replace(".", " ");
          }
          MessageFactory.setMessagesToStorage(messages);
          var fromSync = true;
          GroundDutyFactory.mergeGroundDutiesToStorage(response.SyncPilotData.groundDuties, fromSync);
          CrewRouteFactory.setCrewRoutesToStorage(response.SyncPilotData.CrewRoutes);
          CrewMealFactory.setCrewMealsToStorage(response.SyncPilotData.CateringCrewMeals);
          CrewHotelFactory.setCrewHotelsToStorage(response.SyncPilotData.CrewHotels);
          CheckInFactory.setCheckInInfoToStorage(response.CrewCheckInInfo);
          AnnualLeavesFactory.setAnnualLeavesToStorage(response.AnnualLeaves);
          ExpiriesFactory.setCrewExpiriesToStorage(response.CrewExpiries);
          AimsCrewMemosFactory.setAimsCrewMemosToStorage(response.SyncPilotData.aimsCrewMemos);
          ExpiriesFactory.setAllExpiriesToStorage(response.AllExpiries);

          //Save schedule changes dates 
          ScheduleAcknowledgeFactory.setAllScheduleChangesToStorage(response.SyncPilotData.ScheduleChanges);
          if (response.RosterRequestAncillaries) {
            RequestFactory.setSubmissionDeadlineDateToStorage(response.RosterRequestAncillaries.SubmissionEndDate);
          }

          //clean crew call logs
          if (response.SyncPilotData.CrewCallLog && response.SyncPilotData.CrewCallLog.ResponseSuccess) {
            LogCallFactory.cleanLogsFromStorage();
          }

          //save training courses
          var rawTrainingCourses = response.SyncPilotData.TrainingCourses;
          var courses = [];
          rawTrainingCourses.forEach(function (course) {
            courses.push({
              Id: course.PhaseId !== undefined ? course.Id + "_" + course.PhaseId : course.Id,
              Title: course.Title,
              CourseId: course.Id,
              PhaseId: course.PhaseId,
              PhaseTitle: course.PhaseTitle,
              HasLimitedInfo: true
            });
          });
          CourseFactory.setCoursesFromServer(courses);

          //clean crew member info
          var responseFlightIds = response.SyncPilotData.flights.map(function (x) {
            return x.FlightId;
          });
          CrewCallFactory.cleanOldData(responseFlightIds);
          PreviousDutyFactory.cleanOldData(responseFlightIds);
          FlightCheckInsFactory.cleanOldData(responseFlightIds);
          AircaftPositionsFactory.cleanOldData(responseFlightIds);
          //AimsCrewMemosFactory.cleanOldAimsCrewMemos();

          AutolandFactory.setAutolandToStorage(response.SyncPilotData.AutolandOperations, flightData);
          CatIIFactory.setCatIIToStorage(response.SyncPilotData.CatIIOperations, flightData);
          var pendingFlightIds = PilotReportLocalEditFactory.getFlightIdsWithPendingReports();
          PaxInfoFactory.cleanOldDataPaxInfo(pendingFlightIds);
          //Data cleaner for flight delays
          FlightDelaysFactory.cleanOldFlightDelays(responseFlightIds);

          //save, update or add   memos
          var memos = response.SyncPilotData.memos;
          MemoFactory.setMemosFromServer(memos, memoIdsToSend, lastSyncDate);

          //delete leftover memos
          var serverMemoIds = response.SyncPilotData.memoIds;
          for (var i = 0; i < serverMemoIds.length; i++) {
            MemoFactory.deleteMemoFromStorage(serverMemoIds[i]);
          }
          for (var i = 0; i < memos.length; i++) {
            MemoImagesFactory.deleteMemoImageByMemoId(memos[i].Id);
          }
          var images = response.SyncPilotData.Images;
          MemoImagesFactory.setImagesToServer(images);
          for (var i = 0; i < serverMemoIds.length; i++) {
            MemoImagesFactory.deleteMemoImageByMemoId(serverMemoIds[i]);
          }

          // save guids to local storage
          var reportGuids = response.SyncPilotData.guids;
          ReportGuidFactory.setReportGuidsToStorage(reportGuids);
          var traineeCourses = response.SyncPilotData.TraineeCourses;
          TraineeCoursesDetailsFactory.setTraineeCoursesToStorage(traineeCourses);
          var traineeFlightCourses = response.SyncPilotData.TraineeFlightCourses;
          TraineeCoursesDetailsFactory.setTraineeFlightCoursesToStorage(traineeFlightCourses);

          // save pilot report template to storage
          var pilotReportTemplate = response.SyncPilotData.pilotReportTemplate;
          PilotReportTemplateFactory.setPilotReportTemplateToStorage(pilotReportTemplate);

          // save aircraft types to local storage
          var aircraftTypes = response.SyncPilotData.aircraftTypes;
          AircraftTypeFactory.setAircraftTypesToStorage(aircraftTypes);

          // get the sync results
          var syncResults = PilotReportSyncResultFactory.fromObjectList(response.SyncPilotData.reportResults);

          // mark sent reports as synched
          for (var j = 0; j < reportsToSend.length; j++) {
            var syncResult = PilotReportSyncResultFactory.getSyncResult(syncResults, reportsToSend[j].ReportGuid);
            if (syncResult != null) {
              if (syncResult.success) {
                PilotReportLocalEditFactory.markReportAsSynched(reportsToSend[j].ReportGuid);
                syncResult.Result = 'Successfully submitted';
              } else {
                syncResult.Result = 'Submission error';
              }

              // find flight and append report fields (storage cleared: use orgFlight)
              var flight = null;
              if (orgFlights != null) {
                for (var i = 0; i < orgFlights.length; i++) {
                  if (orgFlights[i].FlightId != null && orgFlights[i].FlightId == reportsToSend[j].FlightId || orgFlights[i].FlightAimsId != null && orgFlights[i].FlightAimsId == reportsToSend[j].FlightAimsId) {
                    flight = orgFlights[i];
                    break;
                  }
                }
              }
              //var flight = FlightFactory.getFlightFromStorage(reportsToSend[j].FlightAimsId);

              if (flight != null) {
                syncResult.FlightAimsId = flight.FlightAimsId;
                syncResult.FlightId = flight.FlightId;
                syncResult.ScheduledDepartureDateUTC = flight.ScheduledDepartureDateUTC;
                syncResult.FlightNo = flight.FlightNo;
                syncResult.Departure = flight.Departure;
                syncResult.Arrival = flight.Arrival;
                syncResult.ScheduledDepartureTimeUTC = flight.ScheduledDepartureTimeUTC;
                syncResult.AcTailNo = flight.AcTailNo;
              }
            }
          }

          // save the sync results
          PilotReportSyncResultFactory.setPilotReportSyncResultsToStorage(syncResults);

          // log the sync user and date
          SyncLogFactory.setSyncLog(aimsId, response.SyncPilotData.version, response.SyncPilotData.toDate);

          // delete local flights with no local reports
          DataCleanerFactory.deleteOrphanedLocalFlights();
          LeaveRequestFactory.saveLeaveRequestInformation(response.SyncPilotData.LeaveRequestInformation);

          //**************** ADD CODE TO KEEP FLIGHTS IF THEY STIL HAVE AN NOT SYCNHED REPORT *********************//
          //find flight ids used by draft or completed (not synched for some reason) reports
          if (allSavedReports) {
            var verifyFlightAimsIds = [];
            var verifyFlightIds = [];
            for (var i = 0; i < allSavedReports.length; i++) {
              if (allSavedReports[i].Status == 'draft' || allSavedReports[i].Status == 'completed') verifyFlightAimsIds.push(allSavedReports[i].FlightAimsId);
              verifyFlightIds.push(allSavedReports[i].FlightId);
            }
            //search these ids into the newly received flights
            if (verifyFlightAimsIds.length > 0) {
              var missingIds = [];
              var missingAimsIds = [];
              var found, id, aimsId;
              for (var i = 0; i < verifyFlightAimsIds.length; i++) {
                found = false;
                aimsId = verifyFlightAimsIds[i];
                id = verifyFlightIds[i];
                for (var f = 0; f < flights.length; f++) {
                  if (flights[f].FlightId != null && flights[f].FlightId == id || flights[f].FlightAimsId != null && flights[f].FlightAimsId == aimsId) {
                    found = true;
                    break;
                  }
                }
                if (!found) missingIds.push(id);
                missingAimsIds.push(aimsId);
              }
              //search missing flights in flights stored before sync
              if (orgFlights) {
                for (var m = 0; m < missingIds.length; m++) {
                  id = missingIds[m];
                  aimsId = missingAimsIds[m];
                  for (var o = 0; o < orgFlights.length; o++) {
                    if (orgFlights[o].FlightId != null && orgFlights[o].FlightId == id || orgFlights[o].FlightAimsId != null && orgFlights[o].FlightAimsId == aimsId) {
                      if (!relativeFlightMatcher(orgFlights[o], flights)) {
                        flights.push(orgFlights[o]);
                      }
                      break;
                    }
                  }
                }
              }
            }
          }

          //FlightFactory.setFlightsToStorage(flights);
          FlightFactory.storeFlightsWithReportsAndMessages(flights, pilotReports, cabinReports, messages);
          // return true
          call.resolve(responseData);
        }, function (err) {
          call.reject(err);
        });
        return call.promise;
      },
      /**
       * Update local reports from synced Fligths 
       * @memberof SyncAPIService
       */
      updatePilotReportLocalEditFromSynch: function updatePilotReportLocalEditFromSynch() {
        var pilotReportLocalEdits = PilotReportLocalEditFactory.getPilotReportsFromStorage();
        if (pilotReportLocalEdits != undefined && pilotReportLocalEdits != null) {
          for (var i = 0; i < pilotReportLocalEdits.length; i++) {
            var flight = FlightFactory.getFlightFromStorage(pilotReportLocalEdits[i].FlightId, pilotReportLocalEdits[i].FlightAimsId);
            if ((pilotReportLocalEdits[i].Status == "draft" || pilotReportLocalEdits[i].Status == "completed") && flight != undefined) {
              pilotReportLocalEdits[i].Departure = flight.Departure;
              pilotReportLocalEdits[i].Arrival = flight.Arrival;
              pilotReportLocalEdits[i].AcType = flight.AcType;
              pilotReportLocalEdits[i].AcTailNo = flight.AcTailNo;
              pilotReportLocalEdits[i].FlightNo = flight.FlightNo;
              pilotReportLocalEdits[i].DepartureICAO = flight.DepartureICAO;
              pilotReportLocalEdits[i].DepartureCountry = flight.DepartureCountry;
              pilotReportLocalEdits[i].DepartureName = flight.DepartureName;
              pilotReportLocalEdits[i].ArrivalICAO = flight.ArrivalICAO;
              pilotReportLocalEdits[i].ArrivalCountry = flight.ArrivalCountry;
              pilotReportLocalEdits[i].ArrivalName = flight.ArrivalName;
              pilotReportLocalEdits[i].ScheduledDepartureDateUTC = flight.ScheduledDepartureDateUTC;
              pilotReportLocalEdits[i].ScheduledDepartureTimeUTC = flight.ScheduledDepartureTimeUTC;
              pilotReportLocalEdits[i].ScheduledDeparture = flight.ScheduledDeparture;
              pilotReportLocalEdits[i].BookedC = flight.BookedC;
              pilotReportLocalEdits[i].BookedY = flight.BookedY;
              pilotReportLocalEdits[i].BookedInf = flight.BookedInf;
              pilotReportLocalEdits[i].BookedPad = flight.BookedPad;
              pilotReportLocalEdits[i].BookedChld = flight.BookedChld;
              pilotReportLocalEdits[i].ActualC = flight.ActualC;
              pilotReportLocalEdits[i].ActualY = flight.ActualY;
              pilotReportLocalEdits[i].ActualInf = flight.ActualInf;
              pilotReportLocalEdits[i].ActualPad = flight.ActualPad;
              pilotReportLocalEdits[i].ActualChld = flight.ActualChld;
              pilotReportLocalEdits[i].DepartureGate = flight.DepartureGate;
              pilotReportLocalEdits[i].DepartureTimezone = flight.DepartureTimezone;
              pilotReportLocalEdits[i].ArrivalTimezone = flight.ArrivalTimezone;
              pilotReportLocalEdits[i].CallSign = flight.CallSign;
              pilotReportLocalEdits[i].ScheduledArrival = flight.ScheduledArrival;
              pilotReportLocalEdits[i].crew = flight.crew;
            }
          }
          PilotReportLocalEditFactory.setPilotReportsToStorage(pilotReportLocalEdits);
        }
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('SynchCtrl', SynchCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name SynchCtrl
  * @description 
  *  Manage Sync View
  * @ngInject
  */
  function SynchCtrl($scope, $uibModalInstance, UserFactory, FlightFactory, PilotReportLocalEditFactory, SyncAPIService, SyncLogFactory, ReportGuidFactory, PilotReportSyncResultFactory, DataCleanerFactory, MessageFactory, MemoFactory, $route) {
    $scope.syncResultsVisible = false;
    $scope.isSynching = false;

    // get the number of reports to synch
    var reportstobesynched = PilotReportLocalEditFactory.getPilotReportLocalEditThatNeedToBeSynched();

    // display the number of reports to synch
    $scope.number_of_reports_to_sync = reportstobesynched.length;

    // get the last sync date
    $scope.isFirstSync = false;
    $scope.isTooOldSync = false;
    $scope.lastSyncDate = '-';
    $scope.syncVersion = '1.1';
    var lastLog = SyncLogFactory.getSyncLog();
    if (lastLog == null) {
      $scope.isFirstSync = true;
    } else {
      if (lastLog.date != null) {
        $scope.lastSyncDate = new Date(lastLog.date).toUTC().toString('dd-MM-yyyy HH:mm') + ' UTC';
        if (Date.today().add(-3).days().toUTC().isAfter(new Date(lastLog.date).toUTC())) $scope.isTooOldSync = true;
      }
      if (lastLog.version != null) $scope.syncVersion = lastLog.version;
    }

    // get the report credits
    $scope.reportCredits = ReportGuidFactory.getRemainingReportGuids();

    // setup the grid
    $scope.syncTableData = PilotReportLocalEditFactory.getPilotReportLocalEditThatNeedToBeSynched();
    $scope.doSynch = doSynch;
    $scope.ok = ok;
    $scope.cancel = cancel;
    $scope.showSyncResults = showSyncResults;
    $scope.syncResultsOk = syncResultsOk;

    /**
    * Start Synch functionality
    * @memberof SynchCtrl
    */
    function doSynch() {
      //waiting for memoIds before we sync
      MemoFactory.getStoredMemosIds(function (memoIdsToSend) {
        // get the user
        var user = UserFactory.getUser();

        // call the remote service for data
        var q = SyncAPIService.doSync(user.aimsId, memoIdsToSend);
        $scope.isSynching = true;
        q.then(function (response) {
          $scope.isSynching = false;
          if ($scope.number_of_reports_to_sync > 0) {
            $scope.showSyncResults('synched');
          } else {
            $scope.showSyncResults('synched-no-send');
          }
          DataCleanerFactory.deleteSynchedLocalPilotReports();
          DataCleanerFactory.deleteOrphanedLocalReports();
          SyncAPIService.updatePilotReportLocalEditFromSynch();
          MemoFactory.markGroundDutiesUnread();
        });
        q["catch"](function (err) {
          $scope.isSynching = false;
          if (err.status == -1) {
            $scope.errorName = "There were problems during the server synchronization. Please try again.";
          } else if (err.status != 401) {
            // if an error was encountered display an error message
            $scope.errorName = "Could not reach the remote server. Please connect to the Internet and try again.";
          } else {
            $uibModalInstance.close('');
          }
        });
      });
    }
    ;

    /**
    * Close  modal
    * @memberof SynchCtrl
    */
    function ok() {
      $uibModalInstance.close('');
    }
    ;

    /**
    * show Report Sync Results
    * @memberof SynchCtrl
    */
    function cancel() {
      $uibModalInstance.close('cancel');
    }
    ;

    /**
    * show Report Sync Results
    * @memberof SynchCtrl
    */
    function showSyncResults(syncResult) {
      $scope.syncResultsVisible = true;

      // setup the grid
      $scope.syncResultsTableData = PilotReportSyncResultFactory.getPilotReportSyncResultsFromStorage();
      $scope.syncSuccesses = PilotReportSyncResultFactory.getSuccesses($scope.syncResultsTableData);
      $scope.syncFailures = PilotReportSyncResultFactory.getFailures($scope.syncResultsTableData);
      if ($scope.syncResultsTableData != null) {
        $scope.reports_to_sync = $scope.syncResultsTableData.length;
      } else {
        $scope.reports_to_sync = 0;
      }
      if ($scope.syncSuccesses == 1) {
        $scope.sync_successes_descr = 'Pilot Report was';
      } else {
        $scope.sync_successes_descr = 'Pilot Reports were';
      }
      if ($scope.syncFailures == 1) {
        $scope.sync_failures_descr = 'Pilot Report was';
      } else {
        $scope.sync_failures_descr = 'Pilot Reports were';
      }
      $scope.unreadMessages = MessageFactory.getCountOfUnreadMessages();
    }
    ;

    /**
    * show Report Sync Results
    * @memberof SynchCtrl
    */
    function syncResultsOk() {
      $uibModalInstance.close('synched');
      $route.reload();
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('SyncLogFactory', SyncLogFactory);

  /* @ngInject */
  function SyncLogFactory($log, GenericService) {
    // Define the constructor function.
    function SyncLog() {
      this.userAimsId = null;
      this.date = null;
      this.version = null;
      this.lastShow = null;
      this.isUpdated = false;
      this.lastScheduleDate = null;
      this.forceSync = false;
      //checks if sync log displayed in the last X minutes, to avoid constantly
      //showing the sync dialog
      this.canShowSync = canShowSync;
    }
    var objType = 'syncLog';
    var objCallback = SyncLog;
    var service = {
      getSyncLog: getSyncLog,
      setSyncLog: setSyncLog,
      updateSyncVersion: updateSyncVersion,
      setLastShow: setLastShow,
      clearSyncLog: clearSyncLog,
      getLastScheduleDate: getLastScheduleDate,
      setLastScheduleDate: setLastScheduleDate,
      forceSync: forceSync
    };
    function canShowSync() {
      var can = false;
      if (this.lastShow == null) can = true;else if (new Date().add(-10).minutes().toUTC().isAfter(new Date(this.lastShow).toUTC())) {
        can = true;
      }
      return can;
    }
    function getSyncLog() {
      return GenericService.getOne(objType, objCallback);
    }
    function setSyncLog(userAimsId, version, lastScheduleDate) {
      var newLog = new SyncLog();
      newLog.userAimsId = userAimsId;
      newLog.date = new Date();
      newLog.version = version;
      newLog.lastShow = new Date();
      newLog.isUpdated = false;
      newLog.forceSync = false;
      newLog.lastScheduleDate = new Date(lastScheduleDate).getTime();
      GenericService.saveOne(newLog, objType, objCallback);
    }
    function updateSyncVersion(version) {
      var syncLog = getSyncLog();
      syncLog.version = version;
      syncLog.isUpdated = true;
      GenericService.saveOne(syncLog, objType, objCallback);
    }
    function getLastScheduleDate() {
      var syncLog = getSyncLog();
      if (syncLog == null) {
        return null;
      } else {
        return syncLog.lastScheduleDate;
      }
    }
    function setLastScheduleDate(date) {
      var log = getSyncLog();
      if (log == null) log = new SyncLog();
      log.lastScheduleDate = date;
      GenericService.saveOne(log, objType, objCallback);
    }
    function setLastShow() {
      var log = getSyncLog();
      if (log == null) log = new SyncLog();
      log.lastShow = new Date();
      GenericService.saveOne(log, objType, objCallback);
    }
    function clearSyncLog() {
      GenericService.removeAll(objType, objCallback);
    }

    /**
     * Forces Sync Modal to appear
     * @memberof SyncLogFactory
     */
    function forceSync() {
      var syncLog = getSyncLog();
      if (syncLog == null) syncLog = new SyncLog();
      syncLog.forceSync = true;
      GenericService.saveOne(syncLog, objType, objCallback);
    }

    // Return constructor - this is what defines the actual
    // injectable in the DI framework.
    return service;
  }
  ;
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('PhotoFactory', PhotoFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name PhotoFactory
  * @description 
  *   Manage Report's Photos.
  * @ngInject
  */
  function PhotoFactory(GenericModalFactory) {
    /**
     * Initialiaze Photo object 
     * @memberof PhotoFactory
     */
    function Photo() {
      this.Id = null;
      this.Remarks = null;
      this.RemarksShort = null;
      this.PhotoData = null;
      this.FileType = null;
    }
    var service = {
      createNew: createNew,
      fromObject: fromObject,
      fromObjectList: fromObjectList,
      deleteFromList: deleteFromList
    };

    /**
     * Create a new Photo object 
     * @memberof PhotoFactory
     * @returns {object} Photo
     */
    function createNew() {
      return GenericModalFactory.createNew(Photo);
    }

    /**
     * Extend given Photo object 
     * @memberof PhotoFactory
     * @param {object} obj The Photo object that will be extended
     * @returns {object} Photo
     */
    function fromObject(obj) {
      return GenericModalFactory.fromObject(obj, Photo);
    }

    /**
     * Delete Photo object from given list
     * @memberof PhotoFactory
     * @param {object} obj The Photo object that will be deleted
     * @returns {array} Photos
     */
    function deleteFromList(obj, objList) {
      return GenericModalFactory.deleteFromList(obj, objList);
    }

    /**
     * Extend given Photo object 
     * @memberof PhotoFactory
     * @param {object} obj The Photo object that will be extended
     * @returns {object} Photo
     */
    function fromObjectList(objList) {
      return GenericModalFactory.fromObjectList(objList, Photo);
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('TicketCtrl', TicketCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name TicketCtrl
  * @description 
  *  Send a ticket
  * @ngInject
  */
  function TicketCtrl($scope, UserFactory, PhotoFactory, TicketAPIService, $location, $uibModal, version) {
    var user = UserFactory.getUser();
    user;
    $scope.submitted = false;
    $scope.ticket = {};
    $scope.ticket.photos = [];
    $scope.maximumAttatchedPhotos = 3;
    $scope.showMaxImages = false;
    $scope.quality = 0.6;
    $scope.width = 1280;
    $scope.height = 1024;
    $scope.sizeLimitKb = 1000;
    $scope.imageTooLargeMsg = false;
    $scope.gotoHome = gotoHome;
    $scope.state = 'ticket';
    $scope.ticket.Version = version;
    appendPhoto();
    $scope.sendTicket = sendTicket;
    $scope.imageUploaded = imageUploaded;
    $scope.removePhoto = removePhoto;
    if (user && user.aimsId && UserFactory.isLoggedIn()) {
      $scope.ticket.aimsId = user.aimsId;
      $scope.isLogged = true;
    }

    /**
     * Redirects to home view
     * @memberof TicketCtrl
     */
    function gotoHome() {
      $location.path("/");
    }

    /**
     * Send  application ticket information
     * @memberof TicketCtrl
     */
    function sendTicket() {
      $scope.submitted = true;
      if (validateTicket()) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Dialogs/dlgTicketSend.html',
          controller: 'TicketModalCtrl',
          size: 'md',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            ticket: function ticket() {
              return $scope.ticket;
            }
          }
        });
        modalInstance.result.then(function () {
          $location.path("/");
        });
      }
    }

    /**
     * Validate ticket before sending
     * @memberof TicketCtrl
     * @return {boolean} isValid
     */
    function validateTicket() {
      var isValid = false;
      if ($scope.ticket.aimsId && $scope.ticket.title && $scope.ticket.description) {
        isValid = true;
      }
      return isValid;
    }

    /**
     * is Image Too Large 
     * @memberof TicketCtrl
     * @return {boolean} isValid
     */
    function isImageTooLarge(image) {
      var isLarge = false;
      if (image && image.dataURL != null) {
        isLarge = image.dataURL.length > $scope.sizeLimitKb * 1024;
      }
      return isLarge;
    }

    /**
     * Upload Image
     * @memberof TicketCtrl
     */
    function imageUploaded(data, img) {
      //console.log('told of a new image', imageResult, this.imageBrowsed, $scope.imageBrowsed);
      var imageResult = data; //$scope.imageBrowsed;
      if (imageResult != null) {
        if (isImageTooLarge(data)) {
          $scope.imageTooLargeMsg = true;
        } else {
          $scope.imageTooLargeMsg = false;
          img.PhotoData = imageResult.dataURL;
          img.FileType = imageResult.fileType || imageResult.file.type;
          img.Remarks = imageResult.fileName;
          appendPhoto();
        }
      }
    }

    /**
     * Allows to add more photos up to the maximum number allowed
     * @memberof TicketCtrl
     */
    function appendPhoto() {
      if ($scope.ticket.photos.length < $scope.maximumAttatchedPhotos) {
        var photo = PhotoFactory.createNew();
        $scope.ticket.photos.push(photo);
      } else {
        $scope.showMaxImages = true;
      }
    }

    /**
     * Remove Selected photo
     * @memberof TicketCtrl
     * @param {object} photo
     */
    function removePhoto(photo) {
      PhotoFactory.deleteFromList(photo, $scope.ticket.photos);
      if ($scope.showMaxImages) {
        appendPhoto();
      }
      $scope.showMaxImages = false;
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.service("TicketAPIService", TicketAPIService);

  /**
  * @memberof PilotReports
  * @ngdoc service
  * @name TicketAPIService
  * @description 
  *  Manages the api calls for the Ticket report system
  * @ngInject
  */
  function TicketAPIService($http, $q, apiUrl, localStorageMD5Service, LogService) {
    /**
     * Send Ticket
     * @memberof TicketAPIService
     * @return {object} promise
     */
    function sendTicket(ticket) {
      var call = $q.defer();
      ticket.DeviceData = getStoredValues();
      $http.post(apiUrl + '/ticket', ticket, {
        'Content-Type': 'application/json'
      }).then(function (responseData) {
        if (responseData == undefined || responseData.data == undefined || responseData.data.data == undefined) {
          var err = new Error();
          err.status = -1;
          var msg = "ResponseData error while sending a ticket :" + JSON.stringify(responseData);
          LogService.debug(msg, err);
          call.reject(err);
        } else {
          // return true
          call.resolve(responseData);
        }
      }, function (err) {
        call.reject(err);
      });
      return call.promise;
    }

    /**
    * Get all values from localstorage
    * @memberof TicketAPIService
    */
    function getStoredValues() {
      var values = [];
      var keys = localStorageMD5Service.keys();
      if (keys) {
        var key, value, sizeActual, error;
        for (var i = 0; i < keys.length; i++) {
          key = keys[i];
          try {
            value = localStorageMD5Service.get(key);
            value = angular.toJson(value);
            sizeActual = localStorageMD5Service.usedSize(key);
            error = null;
          } catch (e) {
            error = e.message || e.errorMessage;
          }
          values.push({
            key: key,
            value: value,
            error: error,
            size: value ? value.length : 0,
            sizeActual: sizeActual
          });
        }
      }
      return values;
    }
    return {
      sendTicket: sendTicket
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('TicketModalCtrl', TicketModalCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name TicketCtrl
  * @description 
  *  Report a bug of the application
  * @ngInject
  */
  function TicketModalCtrl($scope, $uibModalInstance, $timeout, TicketAPIService, LogService, PhotoFactory, ticket) {
    $scope.successful = false;
    $scope.error = false;
    var q = TicketAPIService.sendTicket(ticket);
    q.then(function (responseData) {
      if (responseData.data.data) {
        $scope.successful = true;
      } else {
        $scope.error = true;
      }
      $timeout(function () {
        $uibModalInstance.close();
      }, 3000);
    }, function () {
      $scope.error = true;
      $timeout(function () {
        $uibModalInstance.close();
      }, 3000);
    });
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.service("SWUpdateService", SWUpdateService);

  /**
  * @memberof PilotReports
  * @ngdoc service
  * @name SWUpdateService
  * @description 
  *  manages the service-worker update
  * @ngInject
  */
  function SWUpdateService(LogService) {
    /**
     * initialize service worker
     * @memberof SWUpdateService
     */
    function initialize() {
      // Delay registration until after the page has loaded
      window.addEventListener('load', function () {
        //kill switch. uncomment this and comment out everything else sw related
        // navigator.serviceWorker.getRegistrations().then(function (registrations) {
        //     //returns installed service workers
        //     if (registrations.length) {
        //       for(var registration of registrations) {
        //         registration.unregister();
        //       }
        //     }
        // });

        //register the service worker and work with the promise it returns
        navigator.serviceWorker.register('service-worker.js').then(function (reg) {
          // use a variable to make sure we refresh the page only once
          var refreshing;

          //fires when a new Service Worker takes control of the current page (refreshes the page)
          navigator.serviceWorker.addEventListener('controllerchange', function () {
            if (refreshing) return;
            refreshing = true;
            window.location.reload();
          });
        })["catch"](function (e) {
          LogService.error(e, 'Tried to register the service worker');
        });
      });
    }

    /**
     * poll the server for new service worker file (new app version)
     * @memberof SWUpdateService
     */
    function checkUpdates(reg) {
      if (reg == null) return;

      //ask server for new service worker
      reg.update();
    }

    /**
     * If new service worker has been waiting too long, force update
     * @memberof SWUpdateService
     */
    function checkVersionExpiration(reg) {
      if (reg == null) return;
      reg.waiting.postMessage('checkVersionExpiration');
    }

    /**
     * Activate the new service worker that was waiting
     * @memberof SWUpdateService
     */
    function update(reg) {
      reg.waiting.postMessage('skipWaiting');
    }
    return {
      initialize: initialize,
      checkUpdates: checkUpdates,
      checkVersionExpiration: checkVersionExpiration,
      update: update
    };
  }
})();
"use strict";

(function () {
  a3_pilot_reports.directive('traineeSyllabus', traineeSyllabus);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name traineeSyllabus
  * @restrict E
  * @description
  *   Initialize read only view of submitted syllabus
  * @example
  *   Usage:
  *   <trainee-syllabus></trainee-syllabus>
  * @ngInject
  */

  function traineeSyllabus($filter) {
    function link(scope) {
      setSyllabus(scope.traineeSession);
      function setSyllabus(traineeSession) {
        var traineeSessionItems = [];
        scope.phase.Syllabus.ActiveVersion.SyllabusItems.forEach(function (item) {
          if (item.Active == true) {
            var syllabusItem = JSON.parse(JSON.stringify(item));
            syllabusItem.Tries = [];
            syllabusItem.Selected = false;
            var relatedSessionItem = null;
            if (scope.type == "signature") {
              relatedSessionItem = traineeSession.Items.find(function (x) {
                return x.Id == syllabusItem.Id;
              });
            } else {
              relatedSessionItem = traineeSession.Items.find(function (x) {
                return x.SyllabusItemId == syllabusItem.Id;
              });
            }
            if (relatedSessionItem) {
              syllabusItem.Selected = true;
              syllabusItem.Tries = relatedSessionItem.Tries;
              syllabusItem.hasRemarks = relatedSessionItem.Tries.some(function (x) {
                return x.Comments && x.Comments.length > 0;
              }) || relatedSessionItem.Tries.some(function (t) {
                return t.TryGrading.Competences.some(function (x) {
                  return x.Comments && x.Comments.length > 0;
                });
              });
              syllabusItem.Tries.forEach(function (attempt) {
                attempt.Selected = true;
              });
            }
            if (scope.type == "signature") {
              setPanelStyleByProgress(syllabusItem);
            } else {
              setPanelStyleBySelected(syllabusItem);
            }
            traineeSessionItems.push(syllabusItem);
          }
        });
        scope.traineeSession.ItemsGrouped = [];
        scope.traineeSession.ItemsGrouped = SyllabusGrouping(traineeSessionItems);
      }
      function setPanelStyleByProgress(item) {
        var historyTriesCount = item.Tries.length;
        var newTriesCount = item.Tries.filter(function (x) {
          return !x.isReadOnly && x.Selected;
        }).length;
        item.TriesPerformedCount = historyTriesCount + newTriesCount;
        var completedItem = item.TriesPerformedCount >= item.MandatoryCount;
        if (item.MandatoryCount == 0) {
          //non-mandatory items are considered completed if performed at least once
          completedItem = item.TriesPerformedCount >= 1;
        }
        if (completedItem) {
          item.PanelClass = 'panel-green panel-border-left-green ';
        } else {
          item.PanelClass = 'panel-border-left-blue ';
        }
      }
      function setPanelStyleBySelected(item) {
        var historyTriesCount = item.Tries.length;
        item.TriesPerformedCount = historyTriesCount;
        var completedItem = item.TriesPerformedCount >= item.Mandatory;
        if (completedItem) {
          item.PanelClass = 'panel-green panel-border-left-green ';
        } else {
          item.PanelClass = 'panel-border-left-blue ';
        }
      }
      function SyllabusGrouping(items) {
        //Syllabus Items Group By 'GroupId'
        var syllabusGroups = [];
        items.forEach(function (item) {
          if (!syllabusGroups.some(function (x) {
            return x.Id == item.SelectedGroup.Id;
          })) {
            if (!item.SelectedGroup) {
              item.SelectedGroup = {
                Id: 0,
                Title: 'General'
              };
            }
            var syllabusGroup = {
              Id: item.SelectedGroup.Id,
              Title: item.SelectedGroup.Title ? item.SelectedGroup.Title : 'General',
              Items: []
            };
            syllabusGroup.Items.push(item);
            syllabusGroups.push(syllabusGroup);
          } else {
            syllabusGroups.filter(function (x) {
              return x.Id == item.SelectedGroup.Id;
            })[0].Items.push(item);
          }
        });
        return syllabusGroups;
      }
    }
    return {
      restrict: 'E',
      templateUrl: 'views/TraineeCourse/trainee-syllabus.tpl.html',
      scope: {
        phase: "=",
        traineeSession: "=",
        type: "="
      },
      terminal: true,
      link: link
    };
  }
})();
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
(function () {
  'use strict';

  a3_pilot_reports.controller('TraineeCourseCtrl', TraineeCourseCtrl);
  /**
      * @memberof PilotReports
      * @ngdoc controller
      * @name TraineeCourseCtrl
      * @description 
      *
      * @ngInject
      */
  function TraineeCourseCtrl($scope, $routeParams, TraineeCoursesDetailsFactory, TrainingSessionFactory, $location) {
    var traineeCourseId = Number($routeParams.traineeCourseId);
    $scope.hasError = false;
    $scope.isLoading = true;
    $scope.courseDate = $routeParams.date;
    $scope.isTraineeView = true;
    $scope.gotoCalendar = gotoCalendar;
    $scope.setSelectedPhase = setSelectedPhase;
    $scope.responseObj = {
      success: false,
      message: '',
      Results: []
    };
    $scope.results = [];
    $scope.showWarning = false;
    TraineeCoursesDetailsFactory.getTraineeCourse(traineeCourseId).then(function (res) {
      return handleSubmitResponse(res);
    })["catch"](function (res) {
      return handleFailedResponse(res);
    });
    function handleSubmitResponse(res) {
      $scope.responseObj = res;
      if (res.success) {
        $scope.traineeCourse = res.Results.data.traineeCourse;
        $scope.courseDetails = res.Results.data.courseDetails;
        $scope.traineeCourse.Phases.forEach(function (phase) {
          phase.StatusClass = '';
          if (phase.PhaseStatus == 'InProgress') {
            phase.StatusClass = "border-left-blue";
            phase.TextClass = "text-blue";
            phase.BtnClass = "bg-blue text-white";
          } else if (phase.PhaseStatus == 'Pending') {
            phase.StatusClass = "border-left-gray ";
            phase.TextClass = "text-gray";
            phase.BtnClass = "bg-gray text-white";
          } else if (phase.PhaseStatus == 'Completed') {
            phase.StatusClass = "border-left-green";
            phase.TextClass = "text-green";
            phase.BtnClass = "bg-green text-white";
          }
        });
        $scope.traineeCourse.Phases.forEach(function (phase) {
          phase.Sessions.forEach(function (sessionTrainee) {
            if (sessionTrainee) {
              $scope.traineeSession = sessionTrainee;
              $scope.traineeSession.hasDayGrading = sessionTrainee.DayGrading.Comments || sessionTrainee.DayGrading.GradeType != 'NotSet' && sessionTrainee.DayGrading.Grade || sessionTrainee.DayGrading.Competences.length > 0;
              $scope.traineeSession.hasReleaseGrading = sessionTrainee.ReleaseGrading.Comments || sessionTrainee.ReleaseGrading.GradeType != 'NotSet' && sessionTrainee.ReleaseGrading.Grade || sessionTrainee.ReleaseGrading.Competences.length > 0;
              $scope.traineeSession.AcTypes = [];
              $scope.traineeSession.AcTypes = _toConsumableArray(new Set($scope.traineeSession.Sectors.map(function (ses) {
                return ses.AcType;
              })));
              //GroupBy AcType
              $scope.traineeSession.SectorsByAcType = [];
              $scope.traineeSession.AcTypes.forEach(function (acType) {
                var group = {
                  AcType: acType,
                  Sectors: $scope.traineeSession.Sectors.filter(function (x) {
                    return x.AcType == acType;
                  })
                };
                $scope.traineeSession.SectorsByAcType.push(group);
              });
            } else {
              trainee.Session = {
                Released: course.selectedPhase.ModuleType == "Training" ? false : true,
                CrewId: trainee.CrewId,
                Items: [],
                Absent: false,
                DayGrading: {
                  Comments: null,
                  Grade: null,
                  Competences: []
                },
                ReleaseGrading: {
                  Comments: null,
                  Grade: null,
                  Competences: []
                },
                NeedsAdditionalTraining: false,
                AdditionalTrainingRemarks: null,
                CompleteAdditionalTraining: false
              };
            }
          });
          getSelectedPhase($scope.traineeCourse);
          var phaseId = $scope.traineeCourse.Phases[0].PhaseId;
          initPhaseDetails(phaseId);
        });
      } else {
        $scope.showWarning = true;
        $scope.responseObj;
      }
    }
    function initPhaseDetails(phaseId) {
      $scope.selectedPhase = $scope.courseDetails.CoursePhases.find(function (x) {
        return x.Id == phaseId;
      });
      $scope.traineePhase = $scope.traineeCourse.Phases.find(function (x) {
        return x.PhaseId == phaseId;
      });
      $scope.selectedTraineePhase = $scope.courseDetails.CoursePhases.find(function (x) {
        return x.Id == phaseId;
      });
      $scope.traineeInstructions = $scope.selectedPhase.TraineeInstructions;
      $scope.examinerInstructions = $scope.selectedPhase.ExaminerInstructions;
      $scope.flatSullabusItems = [];
      $scope.traineeCourse.Phases.forEach(function (phase) {
        phase.Sessions.forEach(function (session) {
          session.Items.forEach(function (item) {
            var flatItem = TrainingSessionFactory.createFlatHistorySullabusItem($scope.traineeCourse, phase, session, item);
            $scope.flatSullabusItems.push(flatItem);
          });
        });
      });
      $scope.flatCourseSullabusItems = [];
      $scope.courseDetails.CoursePhases.filter(function (x) {
        return x.Syllabus;
      }).forEach(function (phase, index, array) {
        phase.Syllabus.ActiveVersion.SyllabusItems.forEach(function (syllabusItem) {
          var syllabusItemHistory = $scope.flatSullabusItems.filter(function (item) {
            return item.ItemId == syllabusItem.Id;
          });
          $scope.flatCourseSullabusItems.push(syllabusItemHistory);
        });
      });
      $scope.isLoading = false;
    }
    function handleFailedResponse(res) {
      $scope.hasError = true;
    }
    function getSelectedPhase(course) {
      var hasSelectedPhase = false;
      var phases = course.Phases;
      phases.forEach(function (phase, index, array) {
        phase.isFirst = index == 0;
        phase.isLast = index + 1 == array.length;
        // Select the first InProgress & selected phase
        if (!hasSelectedPhase && phase.Status == "InProgress" && phase.isSelected) {
          phase.Selected = true;
          hasSelectedPhase = true;
        }
      });

      // Select the first InProgress phase
      if (!hasSelectedPhase && phases.some(function (x) {
        return x.Status == "InProgress";
      })) {
        phases.find(function (x) {
          return x.Status == "InProgress";
        }).Selected = true;
        hasSelectedPhase = true;
      }
      if (!hasSelectedPhase) {
        phases.find(function (x) {
          return x.isFirst;
        }).Selected = true;
      }
      $scope.selectedPhase = phases.find(function (x) {
        return x.Selected;
      });
      return $scope.selectedPhase;
    }
    function setSelectedPhase(phaseId) {
      $scope.selectedPhase = $scope.courseDetails.CoursePhases.find(function (x) {
        return x.Id == phaseId;
      });
      $scope.courseDetails.CoursePhases.find(function (x) {
        return x.Id == phaseId;
      }).Selected = true;
      initPhaseDetails(phaseId);
      return $scope.selectedPhase;
    }
    function gotoCalendar() {
      $location.path("/");
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('traineeCoursesDetails', traineeCoursesDetails);
  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name traineeCoursesDetails
  * @restrict E
  * @description
  *    Implementation of trainee Courses Details
  * @example
  *   Usage:
  *   <trainee-courses-details></trainee-courses-details>
  * @ngInject
  */
  function traineeCoursesDetails(TraineeCoursesDetailsFactory, $location, $uibModal, $routeParams) {
    function link(scope, attrs) {
      // scope.getTraineeCourse = getTraineeCourse;
      scope.goToTraineeCourse = goToTraineeCourse;
      scope.goToTraineeFlightCourse = goToTraineeFlightCourse;
      scope.HasTraineeView = true;
      scope.isLoading = false;
      scope.traineeCourses = [];
      scope.traineeFlightCourses = [];
      var dutyId = scope.groundDutyId;
      if (dutyId != null) {
        scope.traineeCourses = TraineeCoursesDetailsFactory.getTraineeGroundCourses(dutyId);
      }
      if (scope.flightId != null || scope.Flight != null) {
        var flightId = scope.flightId != null ? scope.flightId : scope.Flight.FlightId;
      }
      if (flightId != null) {
        scope.traineeFlightCourses = TraineeCoursesDetailsFactory.getTraineeFlightCourses(flightId);
      }
      if (scope.traineeCourses.length > 0) {
        var date = scope.groundDuty.DutyDateS;
      }
      if (scope.traineeFlightCourses.length > 0) {
        var flightDate = new moment(scope.flight.FlightDate).format("DD-MM-YYYY");
      }
      manageCourseStatus(scope.traineeCourses, scope.traineeFlightCourses);
      function manageCourseStatus(traineeCourses, traineeFlightCourses) {
        traineeCourses.forEach(function (course) {
          //Pending
          if (course.Status == "1") {
            course.StatusClass = "text-blue";
          }
          //Completed
          else if (course.Status == "2") {
            course.StatusClass = "text-green";
          }
          //NotCompleted - stopped
          else if (course.Status == "5") {
            course.StatusClass = "text-orange";
          }
        });
        traineeFlightCourses.forEach(function (course) {
          //Pending
          if (course.Status == "1") {
            course.StatusClass = "text-blue";
          }
          //Completed
          else if (course.Status == "2") {
            course.StatusClass = "text-green";
          }
          //NotCompleted - stopped
          else if (course.Status == "5") {
            course.StatusClass = "text-orange";
          }
        });
      }

      /**
      * Redirect to Course Session
      */
      function goToTraineeCourse(traineeCourseId) {
        $location.path('/traineecourse/' + traineeCourseId + '/' + dutyId + '/' + date);
      }
      function goToTraineeFlightCourse(traineeCourseId) {
        $location.path('/traineecourse/' + traineeCourseId + '/' + flightId + '/' + flightDate);
      }
    }
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/TraineeCourse/trainee-courses-details.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('TraineeCoursesDetailsFactory', TraineeCoursesDetailsFactory);

  /**
   * @memberof PilotReports
   * @ngdoc factory
   * @name TraineeCoursesDetailsFactory
   * @description 
   * Get, Set and Submit Trainee Courses Details.
   * @ngInject
   */
  function TraineeCoursesDetailsFactory(localStorageMD5Service, $http, apiUrl, GenericService, $timeout) {
    var objTypeGround = 'traineeCourses';
    var objTypeFlight = 'traineeFlightCourses';
    var objCallbackGround = TraineeCourses;
    var objCallbackFlights = TraineeFlightCourses;
    window.addEventListener('online', function (e) {
      $timeout(checkConnectionStatus());
    });
    var response = {
      success: false,
      message: '',
      Results: []
    };
    var service = {
      setTraineeCoursesToStorage: setTraineeCoursesToStorage,
      getTraineeGroundCourses: getTraineeGroundCourses,
      getTraineeCourses: getTraineeCourses,
      getTraineeCourse: getTraineeCourse,
      setTraineeFlightCoursesToStorage: setTraineeFlightCoursesToStorage,
      getTraineeFlightCourses: getTraineeFlightCourses,
      getFlightCourses: getFlightCourses
    };
    function TraineeCourses() {
      this.DutyDate = null;
      this.Status = null;
      this.GroundDutyId = null;
    }
    function checkConnectionStatus() {
      response.success = false;
      response.message = "Please check the internet connection!";
    }

    /**
    * Set all the trainee courses
    * @memberof TraineeCoursesDetailsFactory
    * @param {array} objects A list of trainee courses.
    */
    function setTraineeCoursesToStorage(data) {
      GenericService.saveAll(data, objTypeGround, objCallbackGround);
    }
    function getTraineeGroundCourses(dutyId) {
      var results = [];
      var listOfValues = localStorageMD5Service.get(objTypeGround);
      if (listOfValues) {
        var traineeCoursesPerDuty = listOfValues.filter(function (item) {
          return item.GroundDutyId == dutyId;
        });
        results = traineeCoursesPerDuty.map(function (item) {
          return item;
        });
      }
      return results;
    }
    function getTraineeCourses() {
      return GenericService.list(objTypeGround, objCallbackGround);
    }
    function getFlightCourses() {
      return GenericService.list(objTypeFlight, objCallbackFlights);
    }
    function TraineeFlightCourses() {}
    function getTraineeCourse(traineeCourseId, callback) {
      return $http.get(apiUrl + '/Training/GetTraineeCourse?traineeCourseId=' + traineeCourseId, {
        'Content-Type': 'application/json'
      }).then(function (res) {
        return updateTraineeCourseCallBack(res);
      })["catch"](function (res) {
        return traineeCourseFailedCallBack(res);
      });
    }
    function updateTraineeCourseCallBack(res) {
      response.success = res.data.success;
      if (res.data.success) {
        response.Results = res.data;
      } else {
        response.message = res.data.errorMessage;
      }
      return response;
    }

    /**
    * The callback function upon failure on submit
    * @returns {object} response
    */
    function traineeCourseFailedCallBack(res) {
      if (!window.navigator.onLine) {
        checkConnectionStatus();
      } else {
        response.success = false;
        response.message = "Oops! Something went wrong";

        //TODO::Check status=500 error: returns res = {data: {…}, status: 500, config: {…}, statusText: "Internal Server Error", headers: ƒ}
        // res.data.data is null
        if (res.data.data && res.data.data.Results) {
          response.Results = res.data.data.Results;
        } else {
          //log results
          console.log(res);
        }
      }
      return response;
    }
    function setTraineeFlightCoursesToStorage(data) {
      GenericService.saveAll(data, objTypeFlight, objCallbackFlights);
    }
    function getTraineeFlightCourses(flightId) {
      var results = [];
      var listOfValues = localStorageMD5Service.get(objTypeFlight);
      if (listOfValues) {
        var traineeCoursesPerDuty = listOfValues.filter(function (item) {
          return item.FlightId == flightId;
        });
        results = traineeCoursesPerDuty.map(function (item) {
          return item;
        });
      }
      return results;
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('additionalTrainingReadOnly', additionalTrainingReadOnly);
  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name additionalTrainingReadOnly
  * @restrict E
  * @description
  *    Implementation of additional Training ReadOnly
  * @example
  *   Usage:
  *   <additional-training-read-only></additional-training-read-only>
  * @ngInject
  */
  function additionalTrainingReadOnly() {
    function link() {}
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/TrainingReadOnly/additional-training-read-only.tpl.html',
      scope: {
        traineeSession: "="
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('competencesReadOnly', competencesReadOnly);
  /**
  * @memberof PilotnReports
  * @ngdoc directive
  * @name competencesReadOnly
  * @restrict E
  * @description
  *    Implementation of competences read only
  * @example
  *   Usage:
  *   <competences-read-only></competences-read-only>
  * @ngInject
  */
  function competencesReadOnly() {
    function link(scope, element, attrs) {
      if (scope.trainee.Competences) {
        scope.trainee.Competences.forEach(function (competence) {
          competence.hasSelectedSubCompetence = competence.SubCompetences.some(function (x) {
            return x.Selected;
          });
        });
      }
    }
    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/TrainingReadOnly/competences-read-only.tpl.html',
      scope: {
        trainee: "="
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  a3_pilot_reports.directive('courseReadOnly', courseReadOnly);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name courseReadOnly
  * @restrict E
  * @description
  *   Initialize read only view of what was submitted
  * @example
  *   Usage:
  *   <course-read-only></course-read-only>
  * @ngInject
  */

  function courseReadOnly() {
    function link(scope) {
      scope.leftScroll = leftScroll;
      scope.rightScroll = rightScroll;
      scope.selectedTraineeSession = selectedTraineeSession;
      scope.selected = false;
      scope.selectedAbsentTraineeSession = selectedAbsentTraineeSession;
      scope.selectedPhase = scope.phases.find(function (x) {
        return x.PhaseId == scope.session.PhaseId;
      });
      scope.selectedTraineeBadge = {
        crewId: scope.session.TraineesSessions[0].CrewId
      };
      function leftScroll() {
        document.querySelector('.horizontal-scroll').scrollLeft -= 500;
      }
      function rightScroll() {
        document.querySelector('.horizontal-scroll').scrollLeft += 500;
      }
      function selectedTraineeSession() {
        return function (traineeSession) {
          var showSession = false;
          if (traineeSession.CrewId === scope.selectedTraineeBadge.crewId) {
            showSession = true;
          }
          return showSession;
        };
      }
      function selectedAbsentTraineeSession() {
        return function (traineeSession) {
          var showPanel = false;
          if (traineeSession.CrewId === scope.selectedTraineeBadge.crewId && traineeSession.Items.length == 0) {
            showPanel = true;
          }
          return showPanel;
        };
      }
    }
    return {
      restrict: 'E',
      templateUrl: "views/TrainingReadOnly/course-read-only.tpl.html",
      scope: {
        phases: "=",
        session: "="
      },
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('gradingReadOnly', gradingReadOnly);
  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name gradingReadOnly
  * @restrict E
  * @description
  *    Implementation of grading read only
  * @example
  *   Usage:
  *   <grading-read-only></grading-read-only>
  * @ngInject
  */
  function gradingReadOnly() {
    function link(scope, element, attrs) {
      if (scope.settings) {
        scope.grading.GradeType = scope.settings.GradeType;
      }
    }
    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/TrainingReadOnly/grading-read-only.tpl.html',
      scope: {
        grading: "=",
        settings: "="
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('pilotFunctionReadOnly', pilotFunctionReadOnly);
  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name pilotFunctionReadOnly
  * @restrict E
  * @description
  *    Implementation of sector history
  * @example
  *   Usage:
  *   <pilot-function-read-only></pilot-function-read-only>
  * @ngInject
  */
  function pilotFunctionReadOnly(FlightFactory, UserFactory, $timeout, $routeParams) {
    function link(scope, element, attrs) {}
    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/TrainingReadOnly/pilot-function-read-only.tpl.html',
      scope: {
        session: "="
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('sectorHistory', sectorHistory);
  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name sectorHistory
  * @restrict E
  * @description
  *    Implementation of sector history
  * @example
  *   Usage:
  *   <sector-history></sector-history>
  * @ngInject
  */
  function sectorHistory() {
    function link(scope, element, attrs) {}
    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/TrainingReadOnly/sector-history.tpl.html',
      scope: {
        history: "="
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  a3_pilot_reports.directive('syllabusProgressReadOnly', syllabusProgressReadOnly);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name syllabusReadOnly
  * @restrict E
  * @description
  *   Initialize read only view of submitted syllabus
  * @example
  *   Usage:
  *   <syllabus-progress-read-only></syllabus-progress-read-only>
  * @ngInject
  */

  function syllabusProgressReadOnly() {
    function link(scope) {
      scope.showRemarks = {
        value: false
      };
      scope.oneAtATime = true;
      scope.filterItems = filterItems;
      scope.toggleItems = toggleItems;
      setSyllabus(scope.history);
      function setSyllabus(history) {
        var traineeSessionItems = [];
        scope.phase.Syllabus.SyllabusItems.forEach(function (item) {
          var syllabusItem = JSON.parse(JSON.stringify(item));
          syllabusItem.Tries = [];
          syllabusItem.Selected = false;
          var relatedSessionItem = history.SyllabusProgress.find(function (x) {
            return x.SyllabusItemId == syllabusItem.Id;
          });
          if (relatedSessionItem) {
            syllabusItem.hasRemarks = relatedSessionItem.Tries.some(function (x) {
              return x.Comments && x.Comments.length > 0;
            }) || relatedSessionItem.Tries.some(function (t) {
              return t.TryGrading.Competences.some(function (x) {
                return x.Comments && x.Comments.length > 0;
              });
            });
            syllabusItem.Selected = true;
            syllabusItem.Tries = relatedSessionItem.Tries;
            syllabusItem.Tries.forEach(function (attempt) {
              attempt.Selected = true;
            });
          }
          setPanelStyle(syllabusItem);
          traineeSessionItems.push(syllabusItem);
        });
        history.ItemsGrouped = SyllabusGrouping(traineeSessionItems);
      }
      function setPanelStyle(item) {
        var historyTriesCount = item.Tries.filter(function (x) {
          return x.isReadOnly;
        }).length;
        var newTriesCount = item.Tries.filter(function (x) {
          return !x.isReadOnly && x.Selected;
        }).length;
        item.TriesPerformedCount = historyTriesCount + newTriesCount;
        var completedItem = item.TriesPerformedCount >= item.MandatoryCount;
        if (item.MandatoryCount == 0) {
          //non-mandatory items are considered completed if performed at least once
          completedItem = item.TriesPerformedCount >= 1;
        }
        if (completedItem) {
          item.PanelClass = 'panel-green panel-border-left-green ';
        } else {
          item.PanelClass = 'panel-border-left-blue ';
        }
      }
      function SyllabusGrouping(items) {
        //Syllabus Items Group By 'GroupId'
        var syllabusGroups = [];
        items.forEach(function (item) {
          if (!syllabusGroups.some(function (x) {
            return x.Id == item.SelectedGroup.Id;
          })) {
            if (!item.SelectedGroup) {
              item.SelectedGroup = {
                Id: 0,
                Title: 'General'
              };
            }
            var syllabusGroup = {
              Id: item.SelectedGroup.Id,
              Title: item.SelectedGroup.Title ? item.SelectedGroup.Title : 'General',
              Items: []
            };
            syllabusGroup.Items.push(item);
            syllabusGroups.push(syllabusGroup);
          } else {
            syllabusGroups.filter(function (x) {
              return x.Id == item.SelectedGroup.Id;
            })[0].Items.push(item);
          }
        });
        return syllabusGroups;
      }
      function filterItems() {
        return function (item) {
          var showItem = true;
          if (scope.showRemarks.value) {
            showItem = item.hasRemarks;
          } else {
            scope.oneAtATime = true;
          }
          return showItem;
        };
      }
      function toggleItems() {
        scope.oneAtATime = !scope.showRemarks.value;
        scope.history.ItemsGrouped.forEach(function (syllabusGroup) {
          syllabusGroup.Items.forEach(function (item) {
            item.isOpen = scope.showRemarks.value;
          });
        });
      }
    }
    return {
      restrict: 'E',
      templateUrl: 'views/TrainingReadOnly/syllabus-progress-read-only.tpl.html',
      scope: {
        phase: "=",
        history: "="
      },
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  a3_pilot_reports.directive('syllabusReadOnly', syllabusReadOnly);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name syllabusReadOnly
  * @restrict E
  * @description
  *   Initialize read only view of submitted syllabus
  * @example
  *   Usage:
  *   <syllabus-read-only></syllabus-read-only>
  * @ngInject
  */

  function syllabusReadOnly() {
    function link(scope) {
      setSyllabus(scope.traineeSession);
      function setSyllabus(traineeSession) {
        var traineeSessionItems = [];
        scope.phase.Syllabus.SyllabusItems.forEach(function (item) {
          var syllabusItem = JSON.parse(JSON.stringify(item));
          syllabusItem.Tries = [];
          syllabusItem.Selected = false;
          var relatedSessionItem = null;
          if (scope.type == "signature") {
            relatedSessionItem = traineeSession.Items.find(function (x) {
              return x.Id == syllabusItem.Id;
            });
          } else {
            relatedSessionItem = traineeSession.Items.find(function (x) {
              return x.SyllabusItemId == syllabusItem.Id;
            });
          }
          if (relatedSessionItem) {
            syllabusItem.Selected = true;
            syllabusItem.Tries = relatedSessionItem.Tries;
          }
          if (scope.type == "signature") {
            setPanelStyleByProgress(syllabusItem);
          } else {
            setPanelStyleBySelected(syllabusItem);
          }
          traineeSessionItems.push(syllabusItem);
        });
        traineeSession.ItemsGrouped = SyllabusGrouping(traineeSessionItems);
        traineeSession.ItemsGrouped.forEach(function (group) {
          group.Items.forEach(function (item) {
            //find first not ReadOnly try
            item.firstTry = item.Tries.find(function (x) {
              return !x.isReadOnly;
            });
          });
        });
      }
      function setPanelStyleByProgress(item) {
        var historyTriesCount = item.Tries.filter(function (x) {
          return x.isReadOnly;
        }).length;
        var newTriesCount = item.Tries.filter(function (x) {
          return !x.isReadOnly && x.Selected;
        }).length;
        item.TriesPerformedCount = historyTriesCount + newTriesCount;
        var completedItem = item.TriesPerformedCount >= item.MandatoryCount;
        if (item.MandatoryCount == 0) {
          //non-mandatory items are considered completed if performed at least once
          completedItem = item.TriesPerformedCount >= 1;
        }
        var nonCompetentItem = false;
        if (item.IsGradable && item.Selected) {
          var gradingType = item.GradeType; //Numeric or Outcome or Competences
          var traineeSelectedTries = item.Tries.filter(function (x) {
            return x.Selected;
          });
          traineeSelectedTries.forEach(function (selectedTry) {
            if (!invalidItem && gradingType == "Outcome" && selectedTry.TryGrading.Grade == "Fail") {
              nonCompetentItem = true;
            }
          });
        }
        if (completedItem && !nonCompetentItem) {
          item.PanelClass = 'panel-green panel-border-left-green ';
        } else if (completedItem && nonCompetentItem) {
          item.PanelClass = 'panel-border-left-pink';
        } else {
          item.PanelClass = 'panel-border-left-blue ';
        }
      }
      function setPanelStyleBySelected(item) {
        var newTriesCount = item.Tries.filter(function (x) {
          return x.Selected;
        }).length;
        var selectedItem = newTriesCount > 0;
        var nonCompetentItem = false;
        var completedItem = item.Tries.length >= item.MandatoryCount;
        if (item.MandatoryCount == 0) {
          //non-mandatory items are considered completed if performed at least once
          completedItem = item.TriesPerformedCount >= 1;
        }
        if (item.IsGradable && item.Selected) {
          var outcomeType = item.GradeType == "Outcome";
          var traineeSelectedTries = item.Tries.filter(function (x) {
            return x.Selected;
          });
          if (outcomeType) {
            traineeSelectedTries.forEach(function (selectedTry) {
              if (outcomeType && selectedTry.TryGrading.Grade == "Fail") {
                nonCompetentItem = true;
              }
            });
          }
        }
        if (completedItem && selectedItem && !nonCompetentItem) {
          item.PanelClass = 'panel-green panel-border-left-green ';
        } else if (completedItem && selectedItem && nonCompetentItem) {
          item.PanelClass = 'panel-border-left-pink';
        } else {
          item.PanelClass = 'panel-border-left-blue ';
        }
      }
      function SyllabusGrouping(items) {
        //Syllabus Items Group By 'GroupId'
        var syllabusGroups = [];
        items.forEach(function (item) {
          if (!syllabusGroups.some(function (x) {
            return x.Id == item.SelectedGroup.Id;
          })) {
            if (!item.SelectedGroup) {
              item.SelectedGroup = {
                Id: 0,
                Title: 'General'
              };
            }
            var syllabusGroup = {
              Id: item.SelectedGroup.Id,
              Title: item.SelectedGroup.Title ? item.SelectedGroup.Title : 'General',
              Items: []
            };
            syllabusGroup.Items.push(item);
            syllabusGroups.push(syllabusGroup);
          } else {
            syllabusGroups.filter(function (x) {
              return x.Id == item.SelectedGroup.Id;
            })[0].Items.push(item);
          }
        });
        return syllabusGroups;
      }
    }
    return {
      restrict: 'E',
      templateUrl: 'views/TrainingReadOnly/syllabus-read-only.tpl.html',
      scope: {
        phase: "=",
        traineeSession: "=",
        type: "="
      },
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('DebugCtrl', DebugCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name DebugCtrl
  * @description 
  *  Manage Debug view
  * @ngInject
  */
  function DebugCtrl($location, $scope, UserFactory, DebugFactory, localStorageMD5Service) {
    $scope.isSecure = UserFactory.isSecure();
    $scope.adminkey = "";
    $scope.authorized = false;
    $scope.checkAuthorized = function () {
      var verify = localStorageMD5Service.md5hash($scope.adminkey);
      DebugFactory.CheckAuthorized(verify, function (responseData) {
        if ($scope.authorized != responseData.data.data) {
          $scope.authorized = responseData.data.data;
          $scope.refreshStoredValues();
        }
      })["catch"](function (error) {
        $scope.authorized = responseData.Data;
        console.error('Wrong Password', error.status, error.statusText);
      });
    };

    // show logged user info
    var user = UserFactory.getUser();
    $scope.logged_user_info = "-user has not logged in-";
    if (user) $scope.logged_user_info = user.aimsId + ' - ' + user.name;
    $scope.storedValues = [];
    $scope.addKeyName = null;
    $scope.updateAll = updateAll;
    $scope.refreshStoredValues = refreshStoredValues;
    $scope.add = add;
    $scope.update = update;
    $scope["delete"] = deleteItem;
    $scope.exit = exit;

    /**
    * Update all the local storage 
    * @memberof DebugCtrl
    */
    function updateAll() {
      try {
        var items = JSON.parse($scope.updateAllJson);
        for (var i = 0; i < items.length; i++) {
          var obj = null;
          if (items[i].value != '') obj = angular.fromJson(items[i].value);
          localStorageMD5Service.set(items[i].key, obj);
        }
        $scope.refreshStoredValues();
      } catch (e) {
        alert('Error: ' + e.message || e.errorMessage);
      }
    }

    /**
    * Refresh values from localstorage
    * @memberof DebugCtrl
    */
    function refreshStoredValues() {
      var values = [];
      if ($scope.authorized) {
        var keys = localStorageMD5Service.keys();
        if (keys) {
          var key, value, sizeActual, error;
          for (var i = 0; i < keys.length; i++) {
            key = keys[i];
            try {
              value = localStorageMD5Service.get(key);
              value = angular.toJson(value);
              sizeActual = localStorageMD5Service.usedSize(key);
              error = null;
            } catch (e) {
              error = e.message || e.errorMessage;
            }
            values.push({
              key: key,
              value: value,
              error: error,
              size: value ? value.length : 0,
              sizeActual: sizeActual
            });
          }
        }
      }
      $scope.storedValues = values;
    }

    /**
    * Add a new local storage key
    * @memberof DebugCtrl
    */
    function add() {
      try {
        var key = $scope.addKeyName;
        if (!key || key == '') return false;
        var keys = localStorageMD5Service.keys();
        if (keys && keys.indexOf(key) > 0) {
          alert('Key exists!');
          return false;
        }
        localStorageMD5Service.set(key, ["empty"]);
        $scope.refreshStoredValues();
        $scope.addKeyName = null;
      } catch (e) {
        alert('Error: ' + e.message || e.errorMessage);
      }
    }

    /**
    * Update an existing local storage key
    * @memberof DebugCtrl
    * @param {object} item
    */
    function update(item) {
      try {
        var obj = null;
        if (item.value != '') obj = angular.fromJson(item.value);
        localStorageMD5Service.set(item.key, obj);
        $scope.refreshStoredValues();
      } catch (e) {
        alert('Error: ' + e.message || e.errorMessage);
      }
    }

    /**
    * delete an existing local storage key
    * @memberof DebugCtrl
    * @param {object} item
    */
    function deleteItem(item) {
      if (confirm('Confirm deletion of key ' + item.key)) {
        localStorageMD5Service.remove(item.key);
        $scope.refreshStoredValues();
      }
    }

    /**
    * Redirect to main Menu
    * @memberof DebugCtrl
    */
    function exit() {
      $location.path("/");
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('DebugFactory', DebugFactory);

  /**
  * @memberof PilotReports
  * @ngdoc factory
  * @name DebugFactory
  * @description 
  *    Authorize check from API ...
  * @ngInject
  */
  function DebugFactory(GenericService, $http, $q, apiUrl, LogService) {
    /**
    * Initialize Debug
    * @memberof DebugFactory
    */
    var service = {
      CheckAuthorized: CheckAuthorized
    };
    function CheckAuthorized(value, callback) {
      return $http.get(apiUrl + '/debug/CheckAuthorized/' + value, {
        'Content-Type': 'application/json'
      }).then(callback);
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('ResetDeviceCtrl', ResetDeviceCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name ResetDeviceCtrl
  * @description 
  *  Manage Reset view
  * @ngInject
  */
  function ResetDeviceCtrl($location, $route, $scope, $log, DataCleanerFactory, UserFactory, localStorageMD5Service) {
    $scope.isSecure = UserFactory.isSecure();

    // show logged user info
    var user = UserFactory.getUser();
    $scope.logged_user_info = "-user has not logged in-";
    if (user) $scope.logged_user_info = user.aimsId + ' - ' + user.name;
    $scope.resetDevice = resetDevice;
    $scope.cancelReset = cancelReset;

    /**
    * Reset Device storage
    * @memberof ResetDeviceCtrl
    */
    function resetDevice() {
      DataCleanerFactory.deleteAllData();
      bootbox.alert("Your device has been reset.", function () {
        $location.path("/login");
        $scope.$apply();
      });
    }

    /**
    * Cancel Reset and go to main page.
    * @memberof ResetDeviceCtrl
    */
    function cancelReset() {
      $location.path("/");
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('AbsentTraineesModalCtrl', AbsentTraineesModalCtrl);
  /**
   * @memberof PilotReports
   * @ngdoc controller
   * @name AbsentTraineesModalCtrl
   * @description 
   * Show absent trainee(s) modal
   * @ngInject
   */

  function AbsentTraineesModalCtrl($scope, $uibModalInstance, absentTrainees) {
    $scope.cancel = cancel;
    $scope.confirm = confirm;
    $scope.absentTrainees = absentTrainees;

    /**
     * Close the modal
     * @memberof AbsentTraineesModalCtrl
     */
    function cancel() {
      $uibModalInstance.close();
    }
    function confirm() {
      $uibModalInstance.close('confirmed');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('additionalTraining', additionalTraining);
  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name additionalTraining
  * @restrict E
  * @description
  *   Implementation of additional Training
  * @example
  *   Usage:
  *   <additional-training></additional-training>
  * @ngInject
  */
  function additionalTraining($uibModal) {
    function link(scope) {
      scope.filterTrainee = filterTrainee;
      scope.yesAdditional = yesAdditional;
      scope.noAdditional = noAdditional;
      scope.NeedsAdditionalTraining = false;
      scope.clearAdditionalNotes = clearAdditionalNotes;
      scope.remarksSelection = remarksSelection;
      scope.completeAdditional = completeAdditional;
      scope.continueAdditional = continueAdditional;
      scope.selectedTrainee.startAdditional = false;
      scope.initializeAdditional = initializeAdditional;
      scope.toggleAdditional = toggleAdditional;
      scope.selectedTrainee.continueAdditional = false;
      scope.openAdditionalModal = openAdditionalModal;
      function yesAdditional(trainee) {
        scope.selectedTrainee.NeedsAdditionalTraining = true;
        trainee.Session.NeedsAdditionalTraining = true;
        scope.CompleteAdditionalTraining = false;
        trainee.Session.CompleteAdditionalTraining = false;
        trainee.Session.UnderAdditionalTraining = false;
        scope.selectedTrainee.startAdditional = true;
        remarksSelection(trainee);
      }
      function noAdditional(trainee) {
        scope.selectedTrainee.NeedsAdditionalTraining = false;
        trainee.Session.NeedsAdditionalTraining = false;
        scope.CompleteAdditionalTraining = false;
        trainee.Session.CompleteAdditionalTraining = false;
        trainee.Session.UnderAdditionalTraining = false;
        trainee.Session.AdditionalTrainingStatus = 'None';
        clearAdditionalNotes(trainee);
      }
      function clearAdditionalNotes(trainee) {
        scope.selectedTrainee.Session.AdditionalTrainingRemarks = '';
        trainee.Session.AdditionalTrainingRemarks = '';
      }
      function completeAdditional(trainee) {
        scope.selectedTrainee.NeedsAdditionalTraining = false;
        trainee.Session.NeedsAdditionalTraining = false;
        scope.CompleteAdditionalTraining = true;
        trainee.Session.CompleteAdditionalTraining = true;
        trainee.Session.UnderAdditionalTraining = true;
        remarksSelection(trainee);
      }
      function continueAdditional(trainee) {
        scope.selectedTrainee.NeedsAdditionalTraining = true;
        trainee.Session.NeedsAdditionalTraining = true;
        scope.CompleteAdditionalTraining = false;
        trainee.Session.CompleteAdditionalTraining = false;
        trainee.Session.UnderAdditionalTraining = true;
        remarksSelection(trainee);
      }
      function filterTrainee() {
        return function (trainee) {
          var showTrainee = true;
          if (scope.selectedTrainee) {
            //individual grading view: filter selected
            showTrainee = scope.selectedTrainee.CrewId == trainee.CrewId;
          }
          return showTrainee;
        };
      }
      function remarksSelection(trainee) {
        trainee.Session.AdditionalTrainingRemarks = scope.selectedTrainee.Session.AdditionalTrainingRemarks;
      }
      function toggleAdditional(trainee) {
        if (scope.selectedTrainee.continueAdditional) {
          continueAdditional(trainee);
        } else {
          completeAdditional(trainee);
        }
      }
      function initializeAdditional(trainee) {
        if (scope.selectedTrainee.startAdditional) {
          yesAdditional(trainee);
        } else {
          noAdditional(trainee);
        }
      }
      function openAdditionalModal(userInput) {
        $uibModal.open({
          templateUrl: 'views/Dialogs/dlgAdditionalTraining.html',
          controller: 'AdditionalTrainingModalCtrl',
          size: 'md',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            retVal: function retVal() {
              return userInput;
            },
            startAdd: userInput
          }
        });
      }
    }
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: 'views/Training/additionalTraining.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('AdditionalTrainingModalCtrl', AdditionalTrainingModalCtrl);

  /**
  * @memberof PilotReports
  * @ngdoc controller
  * @name AdditionalTrainingModalCtrl
  * @description 
  *  Manages Additional Training Modal
  * @ngInject
  */
  function AdditionalTrainingModalCtrl($scope, $uibModalInstance, retVal) {
    $scope.ok = ok;
    $scope.cancel = cancel;
    if (retVal) {
      $scope.startAdd = true;
    } else {
      $scope.startAdd = false;
    }
    /**
     * Close modal after confirm
     * @memberof AdditionalTrainingModalCtrl
     */
    function ok() {
      $uibModalInstance.close(null);
    }

    /**
     * Close Modal
     * @memberof AdditionalTrainingModalCtrl
     */
    function cancel() {
      $uibModalInstance.close(null);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('certificateExam', certificateExam);
  /**
  * @ngdoc directive
  * @name certificateExam
  * @restrict E
  * @description
  *   Implementation of certificate exam grading
  * @example
  *   Usage:
  *   <certificate-exam></certificate-exam>
  * @ngInject
  */
  function certificateExam(TrainingSessionFactory, FlightSessionFactory) {
    function link(scope, element, attrs) {
      if (scope.trainees) collapseAll();
      scope.validateTrainee = validateTrainee;
      scope.getRemainingCharacters = getRemainingCharacters;
      scope.collapseAll = collapseAll;
      scope.gradeUp = gradeUp;
      scope.gradeDown = gradeDown;
      var courseId = scope.dutyCourse.Id;
      var isGround = false;
      if (scope.groundDuty) {
        isGround = true;
        var date = scope.groundDuty.DutyDateS;
        var dutyId = scope.groundDuty.Id;
      } else {
        var date = scope.crewRouteDuty.date;
        var dutyNo = scope.crewRouteDuty.DutyNo;
        var dutyDay = scope.crewRouteDuty.DutyDay;
      }
      var gradeBase = scope.selectedPhase.ReleaseGrading.CertificateGradeBase;
      scope.gradeBase = gradeBase;
      scope.gradeMin = 0;
      scope.gradeMax = 100;

      //Accordion setting
      scope.oneAtATime = true;
      scope.gradingStatus = 'All';

      //Initialize trainees 
      scope.sessions = [];
      scope.trainees.filter(function (x) {
        return x.EligibilityStatus && !x.Session.Absent;
      }).forEach(function (trainee) {
        var session = trainee.Session.ReleaseGrading;
        session.Name = trainee.Name;
        session.AimsId = trainee.AimsId;
        session.isOpen = false;
        if (!session.CertificateOutcome) session.CertificateOutcome = "Pass";
        if (gradeBase && !session.Grade) session.Grade = gradeBase;
        if (!gradeBase) session.Grade = null;
        scope.sessions.push(session);
      });
      scope.sessions.forEach(function (traineeSession) {
        validateGrading(traineeSession);
      });
      function validateGrading(trainee) {
        // Invalid grading
        // 1. If none
        // 2. Over gradeMax
        // 3. Below gradeMin
        // 4. Non numeric
        trainee.isCertificateValid = gradeBase ? trainee.Grade != null && trainee.Grade != undefined : true;
      }
      function validateTrainee(trainee) {
        if (gradeBase) {
          validateGrading(trainee);
          if (trainee.isCertificateValid) {
            calculateOutcome(trainee);
          }
        }
        if (isGround) {
          TrainingSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyId, console.log, function (e) {
            console.log(e);
          });
        } else {
          FlightSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyNo, dutyDay, console.log, function (e) {
            console.log(e);
          });
        }
      }
      function gradeUp(trainee) {
        if (trainee.isCertificateValid && trainee.Grade < scope.gradeMax) {
          trainee.Grade++;
        }
        if (!trainee.isCertificateValid) {
          trainee.Grade++;
        }
        validateTrainee(trainee);
      }
      function gradeDown(trainee) {
        if (trainee.isExamValid && trainee.Grade > scope.gradeMin) {
          trainee.Grade--;
        }
        if (!trainee.isExamValid) {
          trainee.Grade--;
        }
        validateTrainee(trainee);
      }
      function calculateOutcome(trainee) {
        if (trainee.Grade < gradeBase) {
          trainee.CertificateOutcome = "Fail";
        } else {
          trainee.CertificateOutcome = "Pass";
        }
      }
      function getRemainingCharacters(text, max) {
        if (typeof text === "undefined" || text === null) return '';
        if (typeof max === "undefined" || max === null || max < 0 || !max) max = 4000;
        var length = text.length;
        return 'characters left: ' + (max - length);
      }
      function collapseAll() {
        scope.isAllOpen = !scope.isAllOpen;
        scope.trainees.forEach(function (trainee) {
          var session = trainee.Session.ReleaseGrading;
          session.isOpen = scope.isAllOpen;
        });
      }
    }
    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/Training/certificate-exam.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('CompetenceModalCtrl', CompetenceModalCtrl);
  /**
   * @memberof PilotReports
   * @ngdoc controller
   * @name CompetenceModalCtrl
   * @description 
   * Show competence grading helper
   * @ngInject
   */

  function CompetenceModalCtrl($scope, $uibModalInstance, competence) {
    $scope.close = close;
    $scope.competence = competence;

    /**
     * Close the modal
     * @memberof CompetenceModalCtrl
     */
    function close() {
      $uibModalInstance.close($scope.competence.Grading);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('competences', competences);
  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name certificates
  * @restrict E
  * @description
  *   Implementation of competences
  * @example
  *   Usage:
  *   <competences></competences>
  * @ngInject
  */
  function competences($uibModal, $timeout) {
    function link(scope, element, attrs) {
      scope.manageCompetenceGrading = manageCompetenceGrading;
      scope.selectSubCompetence = selectSubCompetence;
      scope.openGradingModal = openGradingModal;
      scope.trainee.Competences.forEach(function (competence) {
        competence.isCollapsed = competence.hasMandatory || competence.hasOptional;
        competence.showComments = competence.hasMandatory || competence.hasOptional || competence.Comments && competence.Comments != "";
      });
      validateTraineeCompetences(scope.trainee);
      function validateTraineeCompetences(trainee) {
        var missingGrading = trainee.Competences.some(function (c) {
          return c.Grading == null;
        });
        var missingPerformanceIndicators = trainee.Competences.filter(function (c) {
          return c.hasMandatory;
        }).some(function (c) {
          return !c.SubCompetences.some(function (sub) {
            return sub.Selected;
          });
        });
        trainee.isCompetenceValid = !missingGrading && !missingPerformanceIndicators;
      }
      function manageCompetenceGrading(competence) {
        var grading = competence.Grading ? Number(competence.Grading) : null;
        var hadMandatory = competence.hasMandatory;
        var hadOptional = competence.hasOptional;
        competence.hasMandatory = competence.MandatorySub.includes(grading);
        competence.hasOptional = competence.OptionalSub.includes(grading);
        competence.isCollapsed = competence.hasMandatory || competence.hasOptional;
        if (competence.isCollapsed) competence.showComments = true;

        //From Mandatory to None remove selected Sub Competences
        if ((hadMandatory || hadOptional) && !competence.hasMandatory && !competence.hasOptional) {
          competence.SubCompetences.forEach(function (sub) {
            sub.Selected = false;
          });
        }
        validateTraineeCompetences(scope.trainee);
        switch (competence.Grading) {
          case 5:
            competence.GradingMessage = competence.GradeA;
            break;
          case 4:
            competence.GradingMessage = competence.GradeB;
            break;
          case 3:
            competence.GradingMessage = competence.GradeC;
            break;
          case 2:
            competence.GradingMessage = competence.GradeD;
            break;
          case 1:
            competence.GradingMessage = competence.GradeE;
            break;
          default:
            competence.GradingMessage = "";
        }
        scope.gradingSelection();
      }
      function selectSubCompetence(sub) {
        sub.Selected = !sub.Selected;
        if (sub.Selected) scope.gradingSelection();
        validateTraineeCompetences(scope.trainee);
      }
      function openGradingModal(_competence) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Training/dlgCompetenceGrading.html',
          controller: 'CompetenceModalCtrl',
          backdrop: 'static',
          keyboard: false,
          size: 'md',
          resolve: {
            competence: function competence() {
              return _competence;
            }
          }
        });
        modalInstance.result.then(function (grading) {
          if (grading) {
            manageCompetenceGrading(_competence, grading);
          }
        });
      }
    }
    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/Training/competences.tpl.html',
      scope: {
        trainee: "=",
        gradingSelection: "&onGradingSelection"
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('courseFooter', courseFooter);

  /**
   * @memberof PilotReports
   * @ngdoc directive
   * @name courseFooter
   * @restrict E
   * @description
   *   Implementation of courseFooter (appears in course view)
   * @example
   *   Usage:
   *   <course-footer></course-footer>
   * @ngInject 
   */
  function courseFooter($location, $routeParams) {
    function link(scope) {
      scope.gotoCalendar = gotoCalendar;
      scope.gotoGroundDuty = gotoGroundDuty;
      scope.gotoCrewRoute = gotoCrewRoute;
      scope.gotoFlight = gotoFlight;
      function gotoCalendar() {
        $location.path("/");
      }
      function gotoGroundDuty() {
        $location.path('/groundDuty/' + Number($routeParams.dutyId));
      }
      function gotoCrewRoute() {
        var dutyNo = scope.crewRouteDuty.DutyNo;
        var dutyDay = scope.crewRouteDuty.DutyDay;
        $location.path('/crewRoute/' + dutyNo + '/' + dutyDay);
      }
      function gotoFlight() {
        var flightId = Number($routeParams.flightId);
        $location.path('/flightinfo/' + flightId);
      }
    }
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: "views/Training/course-footer.tpl.html",
      scope: false,
      link: link
    };
  }
})();
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
(function () {
  'use strict';

  a3_pilot_reports.directive('course', course);
  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name course
  * @restrict E
  * @description
  *   Implementation of training course
  * @example
  *   Usage:
  *   <course></course>
  * @ngInject
  */
  function course(GroundDutyFactory, CourseFactory, TrainingSessionFactory, FlightSessionFactory, $timeout, $uibModal, $location, $routeParams, $window) {
    function link(scope, element, attrs) {
      var _courseId = scope.dutyCourse.Id;
      var phaseId = scope.dutyCourse.PhaseId;
      var isGround = false;
      if (scope.groundDuty) {
        isGround = true;
        var _date = scope.groundDuty.DutyDateS;
        var _dutyId = scope.groundDuty.Id;
      } else {
        var _date = scope.crewRouteDuty.date;
        var _dutyNo = scope.crewRouteDuty.DutyNo;
        var _dutyDay = scope.crewRouteDuty.DutyDay;

        //var trainingFlightIds = scope.crewRouteDuty.Courses.find(x => x.CourseId == courseId && new moment(x.Date).isSame(date)).TrainingFlightIds;
        var trainingFlightIds = scope.crewRouteDuty.Courses.find(function (x) {
          return x.PhaseId == phaseId && new moment(x.Date).isSame(_date);
        }).TrainingFlightIds;
        if (scope.course.Media) scope.course.Media.radioModel = "Flight";
      }
      scope.isGround = isGround;
      scope.updateSession = updateSession;
      scope.availableCourseInfo = false;
      scope.oneTraineeAtATime = true;
      scope.allAbsent = false;
      scope.SubmitSession = SubmitSession;
      scope.close = close;
      scope.updateTraineeSignatures = updateTraineeSignatures;
      scope.checkReleaseAvailability = checkReleaseAvailability;
      scope.setReleaseStatus = setReleaseStatus;
      scope.reloadReleasePanel = reloadReleasePanel;
      scope.showReleasePanel = showReleasePanel;
      scope.filterSelectedSyllabus = filterSelectedSyllabus;
      scope.filterPresentTrainees = filterPresentTrainees;
      scope.selectedPhaseIndex = selectedPhaseIndex();
      scope.releaseTrainee = releaseTrainee;
      scope.showReleaseBtn = showReleaseBtn;
      scope.showGroupReleaseBtn = showGroupReleaseBtn;
      scope.releaseGroup = releaseGroup;
      scope.validateTraineeForm = validateTraineeForm;
      scope.openTraineeSignature = openTraineeSignature;
      scope.resetSignature = resetSignature;
      scope.getTraineeClass = getTraineeClass;
      scope.leftScroll = leftScroll;
      scope.rightScroll = rightScroll;
      scope.togglePanel = togglePanel;
      scope.isReleaseSelected = false;
      scope.toggleBtn = toggleBtn;
      scope.setAdditionalTrainingDetails = setAdditionalTrainingDetails;
      scope.hasLowDayGrading = hasLowDayGrading;
      scope.hasLowSyllabusGrading = hasLowSyllabusGrading;
      if (scope.selectedPhase.ModuleType == "Training" && scope.selectedPhase.EnableAdditionalTraining) {
        scope.AvailableAdditionalTraining = true;
      }
      if (!isGround && scope.selectedPhase.ModuleType == "Training") {
        scope.AvailableAdditionalTraining = true;
      }
      function setAdditionalTrainingDetails() {
        if (scope.isReleaseSelected && !isGround) {
          if (scope.selectedTrainee.Session.AdditionalTrainingRemarks != undefined) {
            scope.selectedTrainee.Session.AdditionalTrainingRemarks = '';
          }
          scope.selectedTrainee.Session.CompleteAdditionalTraining = true;
          scope.selectedTrainee.Session.NeedsAdditionalTraining = false;
        }
      }
      function toggleBtn() {
        scope.isReleaseSelected = !scope.isReleaseSelected;
      }
      function selectedPhaseIndex() {
        var index = 0;
        scope.course.CrewCoursePhases.some(function (phase, i) {
          if (phase.PhaseId == scope.selectedPhase.PhaseId) {
            index = i;
            return true;
          }
        });
        return index;
      }
      function filterSelectedSyllabus() {
        return function (syllabus) {
          var showTrainee = true;
          if (scope.traineeSyllabi && scope.traineeSyllabi.length > 1) {
            showTrainee = syllabus.TraineeIds[0] == scope.selectedTrainee.CrewId;
          }
          return showTrainee;
        };
      }
      function filterPresentTrainees() {
        return function (trainee) {
          return !trainee.Session.Absent;
        };
      }
      scope.reloadFooter = true;
      scope.reloadRelease = true;
      setTraineeSessions();
      updateSession();
      setReleaseStatus();
      function ResetTraineeSignatures() {
        scope.trainees.forEach(function (trainee) {
          trainee.Session.Authorized = false;
        });
      }
      function setReleaseStatus() {
        scope.trainees.forEach(function (trainee) {
          trainee.ShowReleaseWarning = false;
        });
        scope.course.AvailableRelease = checkReleaseAvailability();

        //Handle trainee signatures
        scope.requiresTraineeSignature = RequiresTraineeSignature();
        if (!scope.requiresTraineeSignature) ResetTraineeSignatures();
        scope.allSignaturesComplete = !scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return !x.Session.Authorized;
        });
        scope.someSignaturesComplete = scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return x.Session.Authorized;
        });

        //For flights : check minDays - minSectors
        if (!isGround && scope.course.AvailableRelease && (scope.selectedPhase.MinDays > 0 || scope.selectedPhase.MinSectors > 0)) {
          scope.trainees.filter(function (x) {
            return x.AvailableRelease;
          }).forEach(function (trainee) {
            var phaseInfo = trainee.Phases.find(function (x) {
              return x.PhaseId == scope.selectedPhase.PhaseId;
            });
            var completedDays = 0;
            var completedSectors = 0;
            if (phaseInfo.Sessions) {
              //previous sessions
              completedDays = phaseInfo.Sessions.length;
              phaseInfo.Sessions.forEach(function (pastSession) {
                if (pastSession.Sectors) {
                  completedSectors = completedSectors + pastSession.Sectors.length;
                }
              });
            }
            trainee.CompletedDays = completedDays + 1; //add current day
            trainee.CompletedSectors = completedSectors + trainingFlightIds.length; //add current sectors
            if (trainee.CompletedDays < scope.selectedPhase.MinDays || trainee.CompletedSectors < scope.selectedPhase.MinSectors) {
              trainee.ShowReleaseWarning = true;
            }
          });
        }

        //For ground: check aircraft visits
        if (isGround && (scope.course.AvailableRelease || scope.selectedPhase.ModuleType == "Check") && scope.selectedPhase.AircraftTypes.length) {
          var trainees = scope.trainees;
          if (scope.selectedPhase.ModuleType != "Check") trainees.filter(function (x) {
            return x.AvailableRelease;
          });
          trainees.forEach(function (trainee) {
            var phaseInfo = trainee.Phases.find(function (x) {
              return x.PhaseId == scope.selectedPhase.PhaseId;
            });
            var visitedAircrafts = [];
            if (phaseInfo.Sessions) {
              //previous sessions
              phaseInfo.Sessions.forEach(function (session) {
                visitedAircrafts = visitedAircrafts.concat(session.AircraftTypesVisited);
              });
            }
            if (scope.course.Media) {
              trainee.visitedAircrafts = visitedAircrafts.concat(scope.course.Media.inputAircrafts); //add current arvis
            }

            trainee.pendingAircrafts = [];
            trainee.pairPendingAircrafts = [];
            var pendingAircrafts = [];
            scope.selectedPhase.AircraftTypes.forEach(function (type) {
              var array = type.split(',');

              //if arvi requirement is not met
              if (trainee.visitedAircrafts && !array.some(function (x) {
                return trainee.visitedAircrafts.includes(x);
              })) {
                var pendingArviList = [];
                if (array.length > 1) {
                  array.forEach(function (arvi) {
                    pendingArviList.push(arvi);
                  });
                } else {
                  pendingArviList.push(array[0]);
                }
                pendingAircrafts.push(pendingArviList);
              }
            });
            trainee.pendingAircrafts = pendingAircrafts;
            trainee.ShowReleaseWarning = trainee.pendingAircrafts.length > 0;
          });
        }
        scope.showReleaseWarning = scope.trainees.some(function (x) {
          return x.ShowReleaseWarning;
        });
      }
      function reloadReleasePanel() {
        setReleaseStatus();
        scope.reloadRelease = false;
        $timeout(function () {
          scope.reloadRelease = true;
        }, 100);
      }
      function updateSession() {
        scope.trainees.forEach(function (trainee) {
          trainee.Session.selected = false;
        });
        if (scope.selectedTraineeBadge && scope.trainees.find(function (x) {
          return x.CrewId == scope.selectedTraineeBadge.CrewId;
        })) {
          scope.trainees.find(function (x) {
            return x.CrewId == scope.selectedTraineeBadge.CrewId;
          }).Session.selected = true;
          scope.selectedTrainee = scope.trainees.find(function (x) {
            return x.Session.selected;
          });
        }
        if (isGround) {
          TrainingSessionFactory.updateSession(scope.trainees, scope.course, _courseId, _date, _dutyId, console.log, function (e) {
            console.log(e);
          });
        } else {
          FlightSessionFactory.updateSession(scope.trainees, scope.course, _courseId, _date, _dutyNo, _dutyDay, console.log, function (e) {
            console.log(e);
          });
        }
      }
      function setTraineeSessions() {
        var phase = scope.selectedPhase;
        // Set Day Grading
        var dayCompetences = phase.DayGrading.Competences;
        dayCompetences.forEach(function (competence) {
          competence.MandatorySub = setSubCompetenceValues(competence.MandatorySubCompetences);
          competence.OptionalSub = setSubCompetenceValues(competence.OptionalSubCompetences);

          //Filter out from optional the ones common with mandatory
          competence.OptionalSub = competence.OptionalSub.filter(function (c) {
            return !competence.MandatorySub.includes(c);
          });
        });
        var dayGradingSessions = scope.trainees.map(function (x) {
          return x.Session.DayGrading;
        });
        dayGradingSessions.forEach(function (traineeSession) {
          traineeSession.Competences = setTraineeCompetences(dayCompetences, traineeSession);
        });

        // Set Release Grading
        var releaseCompetences = phase.ReleaseGrading.Competences;
        releaseCompetences.forEach(function (competence) {
          competence.MandatorySub = setSubCompetenceValues(competence.MandatorySubCompetences);
          competence.OptionalSub = setSubCompetenceValues(competence.OptionalSubCompetences);

          //Filter out from optional the ones common with mandatory
          competence.OptionalSub = competence.OptionalSub.filter(function (c) {
            return !competence.MandatorySub.includes(c);
          });
        });
        var releaseGradingSessions = scope.trainees.map(function (x) {
          return x.Session.ReleaseGrading;
        });
        releaseGradingSessions.forEach(function (traineeSession) {
          traineeSession.Competences = setTraineeCompetences(releaseCompetences, traineeSession);
        });

        // Set Syllabus
        if (scope.selectedPhase.Syllabus) setSyllabus();

        //Check if all are absent
        if (scope.trainees && scope.trainees.length && !scope.trainees.some(function (x) {
          return !x.Session.Absent;
        })) {
          scope.allAbsent = true;
        }
      }
      function setSyllabus() {
        var traineeSyllabi = [];
        if (!scope.selectedPhase.Syllabus.IsGradable && !scope.selectedPhase.InFlight) {
          //Non Gradable syllabus & Ground: All trainees share the same syllabus
          var traineeSyllabus = {
            TraineeIds: scope.trainees.filter(function (x) {
              return !x.Session.Absent;
            }).map(function (x) {
              return x.CrewId;
            }),
            Items: []
          };
          traineeSyllabi.push(traineeSyllabus);
        } else {
          //Gradable syllabus || flight: each trainee will have its own
          scope.trainees.filter(function (x) {
            return !x.Session.Absent;
          }).forEach(function (trainee) {
            var traineeSyllabus = {
              TraineeIds: [trainee.CrewId],
              Items: []
            };
            traineeSyllabi.push(traineeSyllabus);
          });
        }

        //Set syllabus item sub competences 
        scope.selectedPhase.Syllabus.SyllabusItems.forEach(function (item) {
          item.Competences.forEach(function (competence) {
            competence.MandatorySub = setSubCompetenceValues(competence.MandatorySubCompetences);
            competence.OptionalSub = setSubCompetenceValues(competence.OptionalSubCompetences);

            //Filter out from optional the ones common with mandatory
            competence.OptionalSub = competence.OptionalSub.filter(function (c) {
              return !competence.MandatorySub.includes(c);
            });
          });
        });
        scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).forEach(function (trainee) {
          var traineeSessionItems = [];
          scope.selectedPhase.Syllabus.SyllabusItems.forEach(function (item) {
            var syllabusItem = JSON.parse(JSON.stringify(item));

            //Get any history tries
            var historyTries = [];
            if (syllabusItem.History && syllabusItem.History.length) {
              var itemsHistory = syllabusItem.History.filter(function (x) {
                return x.CrewId == trainee.CrewId;
              });
              if (itemsHistory.length) {
                var allHistoryTries = [];
                itemsHistory.forEach(function (item) {
                  allHistoryTries = allHistoryTries.concat(item.Tries);
                });
                allHistoryTries.forEach(function (historyTry) {
                  var performedTry = {
                    ActionNo: historyTry.ActionNo,
                    isReadOnly: true,
                    Comments: historyTry.Comments,
                    InstructorName: historyTry.InstructorName,
                    SubmissionDate: historyTry.SubmissionDate,
                    Grade: historyTry.TryGrading.Grade,
                    AcTypes: historyTry.AcTypes,
                    Sectors: historyTry.Sectors
                  };
                  historyTries.push(performedTry);
                });
              }
            }
            var relatedSessionItem = trainee.Session.Items.find(function (x) {
              return x.Id == syllabusItem.Id;
            });

            //Pending tries
            var pendingTriesLeft = syllabusItem.MandatoryCount - historyTries.length;
            if (syllabusItem.MandatoryCount == 0 && historyTries.length == 0) {
              //for non-mandatory items: add 1 attempt if not already performed
              pendingTriesLeft = 1;
            }
            var pendingTries = [];
            for (var i = 0; i < pendingTriesLeft; i++) {
              pendingTries.push({
                Comments: null,
                ActionNo: historyTries.length + i + 1,
                isFirstTry: i == 0,
                TryGrading: {
                  Grade: syllabusItem.DefaultGrade ? syllabusItem.DefaultGrade : null,
                  Competences: [],
                  GradeType: syllabusItem.GradeType
                }
              });
            }

            //Add pending tries to history tries
            var tries = historyTries.concat(pendingTries);

            //Create syllabus item depending on existing values
            if (!relatedSessionItem) {
              tries.filter(function (x) {
                return !x.isReadOnly;
              }).forEach(function (attempt) {
                attempt.TryGrading.Competences = setTraineeCompetences(syllabusItem.Competences, attempt.TryGrading);
              });
              var newItem = {
                RepeatRequired: false,
                Selected: false,
                Tries: tries,
                PhaseId: scope.selectedPhase.PhaseId,
                Id: syllabusItem.Id
              };
              traineeSessionItems.push(newItem);
              mergeSyllabusItemWithSession(syllabusItem, newItem);
            } else {
              var sessionTries = [];
              tries.forEach(function (tryItem) {
                var relatedSessionTry = relatedSessionItem.Tries.find(function (x) {
                  return x.ActionNo == tryItem.ActionNo;
                });
                if (relatedSessionTry && !tryItem.isReadOnly) {
                  sessionTries.push(deepCopy(relatedSessionTry));
                } else {
                  sessionTries.push(deepCopy(tryItem));
                }
              });

              //Add any Extra tries
              if (syllabusItem.MandatoryCount > 0) {
                var extraTries = relatedSessionItem.Tries.filter(function (x) {
                  return x.ActionNo > syllabusItem.MandatoryCount && !x.isReadOnly;
                });
                sessionTries = sessionTries.concat(extraTries);
              }
              sessionTries.filter(function (x) {
                return !x.isReadOnly;
              }).forEach(function (attempt) {
                attempt.TryGrading.Competences = setTraineeCompetences(syllabusItem.Competences, attempt.TryGrading);
              });
              var existingItem = {
                RepeatRequired: relatedSessionItem.RepeatRequired,
                Selected: relatedSessionItem.Selected,
                Tries: sessionTries,
                PhaseId: scope.selectedPhase.PhaseId,
                Id: syllabusItem.Id
              };
              traineeSessionItems.push(existingItem);
              mergeSyllabusItemWithSession(syllabusItem, existingItem);
            }
            var traineeSyllabus = traineeSyllabi.find(function (x) {
              return x.TraineeIds.includes(trainee.CrewId);
            });
            if (!traineeSyllabus.Items.some(function (x) {
              return x.Id == syllabusItem.Id;
            })) {
              traineeSyllabus.Items.push(syllabusItem);
            }
          });
          trainee.Session.Items = traineeSessionItems;
        });
        traineeSyllabi.forEach(function (syllabus) {
          SyllabusGrouping(syllabus);
        });
        scope.traineeSyllabi = traineeSyllabi;
      }
      function mergeSyllabusItemWithSession(syllabusItem, sessionItem) {
        syllabusItem.RepeatRequired = sessionItem.RepeatRequired;
        syllabusItem.Selected = sessionItem.Selected;
        syllabusItem.Tries = sessionItem.Tries;
      }
      function leftScroll() {
        document.querySelector('.horizontal-scroll').scrollLeft -= 500;
      }
      function rightScroll() {
        document.querySelector('.horizontal-scroll').scrollLeft += 500;
      }
      function deepCopy(originalObject) {
        return JSON.parse(JSON.stringify(originalObject));
      }
      function SyllabusGrouping(syllabus) {
        //Syllabus Items Group By 'GroupId'
        var syllabusGroups = [];
        syllabus.Items.forEach(function (item) {
          if (!syllabusGroups.some(function (x) {
            return x.Id == item.SelectedGroup.Id;
          })) {
            if (!item.SelectedGroup) {
              item.SelectedGroup = {
                Id: 0,
                Title: 'General'
              };
            }
            var syllabusGroup = {
              Id: item.SelectedGroup.Id,
              Title: item.SelectedGroup.Title ? item.SelectedGroup.Title : 'General',
              Items: []
            };
            syllabusGroup.Items.push(item);
            syllabusGroups.push(syllabusGroup);
          } else {
            syllabusGroups.filter(function (x) {
              return x.Id == item.SelectedGroup.Id;
            })[0].Items.push(item);
          }
        });
        syllabus.ItemsGrouped = syllabusGroups;
      }
      function setTraineeCompetences(competences, sessionItem) {
        var traineeCompetences = [];
        competences.forEach(function (competence) {
          var traineeCompetence = JSON.parse(JSON.stringify(competence));
          var existingCompetence = sessionItem.Competences.find(function (x) {
            return x.Id == traineeCompetence.Id;
          });
          //Get saved values
          traineeCompetence.Grading = existingCompetence ? existingCompetence.Grading : null;
          traineeCompetence.Comments = existingCompetence ? existingCompetence.Comments : null;
          if (existingCompetence) {
            traineeCompetence.SubCompetences.filter(function (x) {
              return existingCompetence.SubCompetences.some(function (y) {
                return y.Id == x.Id;
              });
            }).forEach(function (commonSub) {
              commonSub.Selected = existingCompetence.SubCompetences.find(function (s) {
                return s.Id == commonSub.Id;
              }).Selected;
            });
            traineeCompetence.hasMandatory = traineeCompetence.MandatorySub.includes(Number(traineeCompetence.Grading));
            traineeCompetence.hasOptional = traineeCompetence.OptionalSub.includes(Number(traineeCompetence.Grading));
          }
          traineeCompetences.push(traineeCompetence);
        });
        return traineeCompetences;
      }
      function setSubCompetenceValues(current) {
        var updated = [];
        var first = parseInt(current[0], 10);
        var last = current[current.length - 1];
        if (first) {
          for (var i = first; i <= last; i++) {
            updated.push(i);
          }
        }
        return updated;
      }

      /*****************************************************************  Submit ********************************************************************************/
      function SubmitSession() {
        setReleaseStatus();
        if (!isValidForm()) {
          scope.modalInstance = $uibModal.open({
            templateUrl: 'views/Training/dlgSubmitValidation.html',
            scope: scope,
            backdrop: 'static',
            keyboard: false,
            size: 'lg'
          });
        } else {
          if (isGround) {
            //Last save before submission
            TrainingSessionFactory.updateSession(scope.trainees, scope.course, _courseId, _date, _dutyId, function () {
              // Get all trainees found for this session (filter by course and date)
              TrainingSessionFactory.getSessionTrainees(_courseId, _date, _dutyId, function (Trainees) {
                var _absentTrainees = Trainees.filter(function (x) {
                  return x.Session.Absent;
                });
                if (_absentTrainees.length > 0) {
                  scope.modalInstance = $uibModal.open({
                    templateUrl: 'views/Training/dlgAbsentTrainees.html',
                    controller: 'AbsentTraineesModalCtrl',
                    scope: scope,
                    backdrop: 'static',
                    keyboard: false,
                    size: 'md',
                    resolve: {
                      absentTrainees: function absentTrainees() {
                        return _absentTrainees;
                      }
                    }
                  });
                  scope.modalInstance.result.then(function (response) {
                    if (response === 'confirmed') {
                      manageSubmission(Trainees);
                    }
                  });
                } else {
                  manageSubmission(Trainees);
                }
              });
            });
          } else {
            //Last save before submission
            FlightSessionFactory.updateSession(scope.trainees, scope.course, _courseId, _date, _dutyNo, _dutyDay, function () {
              // Get all trainees found for this session (filter by course and date)
              FlightSessionFactory.getSessionTrainees(_courseId, _date, _dutyNo, _dutyDay, function (Trainees) {
                manageSubmission(Trainees);
              });
            });
          }
        }
      }
      function manageSubmission(Trainees) {
        PrepareSessionForSubmission(Trainees);
        setReleaseStatus();
        var _requiresInstructorSignature = RequiresInstructorSignature();
        var _confirmationMsg = scope.selectedPhase.ReleaseGrading.ConfirmationMessage;

        // submit now
        var _releaseGrading = (scope.selectedPhase.ReleaseGrading.Comments || scope.selectedPhase.ReleaseGrading.GradeType == 'Numeric' || scope.selectedPhase.ReleaseGrading.GradeType == 'Outcome' || scope.selectedPhase.ReleaseGrading.Competences.length) && scope.selectedPhase.ReleaseGrading.GradeType != 'CertificateExam';
        var _needsAdditionalTraining = false;
        if (scope.selectedTrainee != null) {
          _needsAdditionalTraining = scope.selectedTrainee.NeedsAdditionalTraining;
        }
        scope.modalInstance = $uibModal.open({
          templateUrl: 'views/Training/dlgSign.html',
          controller: 'SignatureModalCtrl',
          backdrop: 'static',
          keyboard: false,
          size: 'md',
          resolve: {
            courseId: function courseId() {
              return _courseId;
            },
            date: function date() {
              return _date;
            },
            dutyId: function dutyId() {
              return _dutyId;
            },
            dutyNo: function dutyNo() {
              return _dutyNo;
            },
            dutyDay: function dutyDay() {
              return _dutyDay;
            },
            confirmationMsg: function confirmationMsg() {
              return _confirmationMsg;
            },
            requiresInstructorSignature: function requiresInstructorSignature() {
              return _requiresInstructorSignature;
            },
            trainees: function trainees() {
              return scope.trainees;
            },
            submitSession: function submitSession() {
              return SaveSession;
            },
            releaseGrading: function releaseGrading() {
              return _releaseGrading;
            },
            isReleased: function isReleased() {
              return scope.course.ReleasedPhase;
            },
            needsAdditionalTraining: function needsAdditionalTraining() {
              return _needsAdditionalTraining;
            }
          }
        });
        scope.modalInstance.result.then(function (result) {
          if (result.success) {
            $location.path("/");
          }
        });
      }
      function RequiresTraineeSignature() {
        // End of session signature
        var endOfSessionSignature = scope.selectedPhase.DayGrading.TraineeSignature;

        // End of module signature
        var endOfModuleSignature = scope.course.ReleasedPhase && scope.selectedPhase.ReleaseGrading.TraineeSignature;
        return endOfSessionSignature || endOfModuleSignature;
      }
      function RequiresInstructorSignature() {
        /*  Instructor signature needed if
            1. Syllabus attached needs signature
            2. Completed syllabus items need signature
            3. End of session needs signature
            4. Module is released and end of module needs signature
        */

        // 1. Check if syllabus exists and needs signature
        var syllabusSignature = scope.selectedPhase.Syllabus && scope.selectedPhase.Syllabus.SignatureRequired;

        // 2. Filter selected syllabus items & check if they need signature
        var selectedItems = [];
        scope.trainees.forEach(function (trainee) {
          var traineeSelectedItems = trainee.Session.Items.filter(function (x) {
            return x.Selected;
          }).map(function (x) {
            return x.Id;
          });
          selectedItems = selectedItems.concat(traineeSelectedItems);
        });
        selectedItems = _toConsumableArray(new Set(selectedItems));
        var syllabusItemSignature = scope.selectedPhase.Syllabus && scope.selectedPhase.Syllabus.SyllabusItems.filter(function (x) {
          return selectedItems.includes(x.Id);
        }).some(function (x) {
          return x.SignatureRequired;
        });

        // 3. End of session signature
        var endOfSessionSignature = scope.selectedPhase.DayGrading.InstructorSignature;

        // 4. End of module signature
        var endOfModuleSignature = scope.course.AvailableRelease && scope.course.ReleasedPhase && scope.selectedPhase.ReleaseGrading.InstructorSignature;
        return syllabusSignature || syllabusItemSignature || endOfSessionSignature || endOfModuleSignature;
      }

      /**
       * Check if Release requirements are met
       * @param {object} group 
       */
      function checkReleaseAvailability() {
        //Available Release if No pending mandatory items
        //Calculate item status for each trainee
        scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).forEach(function (sessionTrainee) {
          if (scope.selectedPhase.Syllabus) {
            var syllabusItems = scope.selectedPhase.Syllabus.SyllabusItems;
            sessionTrainee.Session.Items.forEach(function (sessionItem) {
              var performedTries = sessionItem.Tries.filter(function (x) {
                return x.isReadOnly || x.Selected;
              }).length; // history & current session
              var mandatoryCount = syllabusItems.find(function (x) {
                return x.Id == sessionItem.Id;
              }).MandatoryCount;
              sessionItem.Status = mandatoryCount > 0 && performedTries < mandatoryCount ? "Pending" : "Completed";
            });
            sessionTrainee.AvailableRelease = !sessionTrainee.Session.Items.some(function (x) {
              return x.Status == "Pending";
            });
          } else {
            sessionTrainee.AvailableRelease = true;
          }
        });
        if (scope.selectedPhase.ModuleType == "Training") {
          scope.trainees.filter(function (x) {
            return !x.Session.Absent && !x.AvailableRelease;
          }).forEach(function (trainee) {
            trainee.Session.Released = false;
          });
          if (scope.trainees.filter(function (x) {
            return !x.Session.Absent;
          }).some(function (x) {
            return !x.AvailableRelease;
          })) {
            scope.trainees.filter(function (x) {
              return !x.Session.Absent;
            }).forEach(function (trainee) {
              trainee.Session.Released = false;
            });
          }
        }
        scope.course.ReleasedPhase = scope.trainees.filter(function (x) {
          return !x.Absent;
        }).some(function (x) {
          return x.Session.Released;
        });
        return !scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return !x.AvailableRelease && x.AdditionalTrainingStatus == 'UnderAdditionalTraining';
        });
      }
      function SaveSession(password, withRelease) {
        scope.submittedSession.SignaturePassword = password;
        if (scope.submittedSession.TraineeSessions.filter(function (x) {
          return x.AdditionalTrainingStatus == 'UnderAdditionalTraining';
        }).length > 0) {
          scope.submittedSession.TraineeSessions.filter(function (x) {
            return !x.Absent && scope.selectedTrainee.AdditionalTrainingStatus == 'UnderAdditionalTraining';
          }).forEach(function (trainee) {
            if (!trainee.NeedsAdditionalTraining) {
              trainee.NeedsAdditionalTraining = false;
              trainee.UnderAdditionalTraining = true;
              trainee.CompleteAdditionalTraining = true;
            }
          });
        }
        if (scope.submittedSession.TraineeSessions.find(function (x) {
          return x.CompleteAdditionalTraining == true;
        })) {
          scope.submittedSession.TraineeSessions.filter(function (x) {
            return !x.Absent && scope.selectedTrainee.AdditionalTrainingStatus == 'UnderAdditionalTraining';
          }).forEach(function (trainee) {
            if (!trainee.NeedsAdditionalTraining) {
              trainee.NeedsAdditionalTraining = false;
              trainee.UnderAdditionalTraining = true;
              trainee.CompleteAdditionalTraining = true;
            }
          });
        }
        if (scope.submittedSession.NeedsAdditionalTraining) {
          withRelease = false;
        }
        if (withRelease) {
          scope.submittedSession.ReleasedPhase = true;
          scope.submittedSession.TraineeSessions.filter(function (x) {
            return !x.Absent;
          }).forEach(function (trainee) {
            trainee.Released = true;
          });
        }
        if (isGround) {
          if (scope.submittedSession.CourseId && scope.submittedSession.CourseId.includes("_")) {
            scope.submittedSession.CourseId = scope.submittedSession.CourseId.split("_")[0];
          }
          return TrainingSessionFactory.submitSession(scope.submittedSession);
        } else {
          if (scope.submittedSession.CourseId && scope.submittedSession.CourseId.includes("_")) {
            scope.submittedSession.CourseId = scope.submittedSession.CourseId.split("_")[0];
          }
          return FlightSessionFactory.submitSession(scope.submittedSession);
        }
      }
      function PrepareSessionForSubmission(Trainees) {
        // Filter Trainee Sessions
        var trainees = Trainees.filter(function (x) {
          return x.EligibilityStatus;
        });
        trainees.forEach(function (trainee) {
          trainee.Session.Items = trainee.Session.Items.filter(function (x) {
            return x.Selected;
          });

          // Empty absent trainee sessions
          if (trainee.Session.Absent) {
            trainee.Session.Items = [];
            trainee.Session.DayGrading.Comments = null;
            trainee.Session.DayGrading.Competences = [];
            trainee.Session.DayGrading.Grade = null;
            trainee.Session.ReleaseGrading.Comments = null;
            trainee.Session.ReleaseGrading.Competences = [];
            trainee.Session.ReleaseGrading.Grade = null;
            trainee.Session.NeedsAdditionalTraining = false;
            trainee.Session.AdditionalTrainingRemarks = null;
          }
        });
        var sessionSectors = [];
        if (!isGround) {
          //Collect session sectors for flight
          trainingFlightIds.forEach(function (flightId) {
            var sector = {
              FlightId: flightId,
              PM: null,
              PF: null,
              SessionSectorSeats: []
            };
            if (scope.course.PilotFunctions) {
              // Set PM/PF values
              var sectors = [];
              scope.course.PilotFunctions.forEach(function (pilot) {
                sectors = sectors.concat(pilot.Sectors.filter(function (x) {
                  return x.FlightId == flightId && !x.NonApplicable;
                }));
              });
              var PMsector = sectors.find(function (sec) {
                return sec.isPM;
              });
              var PFsector = sectors.find(function (sec) {
                return !sec.isPM;
              });
              var NAsector = sectors.find(function (sec) {
                return sec.NonApplicable;
              });
              if (PMsector) sector.PM = PMsector.CrewId;
              if (PFsector) sector.PF = PFsector.CrewId;
              if (NAsector) sector.NonApplicable = NAsector.CrewId;

              // Set seat values
              scope.course.PilotFunctions.forEach(function (pilot) {
                var isInstructor = pilot.IsInstructor;
                var relevantSector = pilot.Sectors.find(function (x) {
                  return x.FlightId == flightId;
                });
                //   && (isInstructor || !x.NonApplicable)
                if (relevantSector) {
                  var seat = {
                    CrewId: relevantSector.CrewId,
                    Seat: relevantSector.Seat
                  };
                  sector.SessionSectorSeats.push(seat);
                }
              });
            }
            sessionSectors.push(sector);
          });
        }

        // Create Session
        scope.submittedSession = {
          SessionDate: _date,
          CourseId: _courseId,
          GroundDutyIds: isGround ? [_dutyId] : [],
          Sectors: sessionSectors,
          AircraftVisits: scope.course.Media && scope.course.Media.radioModel == "Aircraft" ? scope.course.Media.inputAircrafts : [],
          SelectedMedia: scope.course.Media ? scope.course.Media.radioModel : "",
          SyntheticDeviceId: scope.course.Media && scope.course.Media.radioModel == "Simulator" ? scope.course.Media.selectedDevice.selection : null,
          ReleasedPhase: scope.course.ReleasedPhase,
          GradeType: scope.selectedPhase.DayGrading.GradeType,
          ReleaseGradeType: scope.selectedPhase.ReleaseGrading.GradeType,
          TraineeSessions: trainees.map(function (x) {
            return x.Session;
          }),
          SyllabusVersionId: scope.selectedPhase.Syllabus ? scope.selectedPhase.Syllabus.SyllabusVersionId : null,
          PhaseId: scope.selectedPhase.PhaseId,
          DowntimeDuration: scope.course.Media && scope.course.Media.radioModel == "Simulator" && scope.downtimeDuration.radioValue == 'true' ? scope.downtimeDuration.minutes : null
        };
      }
      function isValidForm() {
        /*Requirements before submitting a session
            1. OnLine Mode
            2. Date Allowed
            3. Pending syllabus items
            4. Pending syllabus items for different trainee
            5. Media Validation
            6. Day Grading
            7. Release Grading
            8. Certificate Exam Grading
            9. Trainee Signature
        */

        var isValid = false;
        var info = {
          border: "",
          icon: "",
          msg: "",
          scrollToTop: false
        };
        if (!window.navigator.onLine) {
          info = {
            border: "border-left-red",
            icon: "fa-warning text-red",
            msg: "  <strong>Online mode</strong> is required in order to submit a training. <p>Check your connection and try again!</p>",
            scrollToTop: false
          };
        } else if (!dateAllowed()) {
          info = {
            border: "border-left-red",
            icon: "fa-calendar-times-o text-red",
            msg: "You can not submit a session earlier than its duty date!",
            scrollToTop: false
          };
        } else if (!isSeatValid()) {
          info = {
            border: "border-left-orange",
            icon: "fa-plane text-orange",
            msg: "You need to select different seats for each pilot!",
            scrollToTop: true
          };
        } else if (!isPilotFunctionValid()) {
          info = {
            border: "border-left-orange",
            icon: "fa-plane text-orange",
            msg: " Each sector should have a different PM/PF value for each pilot!",
            scrollToTop: true
          };
        } else if (syllabusPending()) {
          var traineeDetailsMsg = "";
          if (scope.selectedTrainee && (scope.selectedPhase.Syllabus.IsGradable || scope.selectedPhase.InFlight)) {
            traineeDetailsMsg = " for <b>" + scope.selectedTrainee.Name + "</b>";
          }
          info = {
            border: "border-left-orange",
            icon: "fa-calendar-times-o text-orange",
            msg: "Form cannot be submitted! <p>Please complete all mandatory syllabus items" + traineeDetailsMsg + "</p>",
            scrollToTop: false
          };
        } else if (traineesPending()) {
          info = {
            border: "border-left-orange",
            icon: "fa-calendar-times-o text-orange",
            msg: "Form cannot be submitted! <p>Please complete all trainee forms. </p>",
            scrollToTop: true
          };
        } else if (!isMediaValid()) {
          if (scope.hasNoAircraft) {
            info = {
              border: "border-left-orange",
              icon: "fa-plane text-orange",
              msg: "You need to provide an aircraft type!",
              scrollToTop: true
            };
          } else if (scope.hasNoDevice) {
            info = {
              border: "border-left-orange",
              icon: "fa-plane text-orange",
              msg: "You need to select a synthetic device!",
              scrollToTop: true
            };
          }
        } else if (!isSyllabusGradingValid()) {
          var invalidTrainees = scope.trainees.filter(function (t) {
            return t.Session.SyllabusValidationErrors && t.Session.SyllabusValidationErrors.Items.length;
          });
          info = {
            border: "border-left-orange",
            icon: "fa-warning text-orange",
            msg: "Some of the selected syllabus items require a grading",
            SyllabusErrors: invalidTrainees.map(function (t) {
              return t.Session.SyllabusValidationErrors;
            }),
            scrollToTop: false
          };
        } else if (!isGradingValid()) {
          if (!scope.gradingValidationInfo.isDayCompetencesValid || !scope.gradingValidationInfo.isReleaseCompetencesValid) {
            info = {
              border: "border-left-orange",
              icon: "fa-warning text-orange",
              msg: "You need to grade all competences before submitting!",
              scrollToTop: false
            };
          } else if (!scope.gradingValidationInfo.isDayGradingValid || !scope.gradingValidationInfo.isReleaseGradingValid) {
            info = {
              border: "border-left-orange",
              icon: "fa-warning text-orange",
              msg: "You need to grade all trainees!",
              scrollToTop: false
            };
          } else if (!scope.gradingValidationInfo.isCertificateGradingValid) {
            info = {
              border: "border-left-orange",
              icon: "fa-warning text-orange",
              msg: "You need to grade all certificate exams!",
              scrollToTop: false
            };
          }
        } else if (scope.requiresTraineeSignature && !scope.allSignaturesComplete) {
          if (scope.selectedTrainee && !scope.selectedTrainee.Session.Authorized) {
            info = {
              border: "border-left-orange",
              icon: "fa-pencil-square-o text-orange",
              msg: "<b>" + scope.selectedTrainee.Name + "</b> needs to sign the form!",
              scrollToTop: false
            };
          } else {
            info = {
              border: "border-left-orange",
              icon: "fa-warning text-orange",
              msg: "All trainees need to sign their forms!",
              scrollToTop: true
            };
          }
        } else {
          isValid = true;
        }
        scope.info = info;
        return isValid;
      }
      function dateAllowed() {
        var dateAllowed = false;

        //Submission is allowed only on the day of the training and after
        var trainingDay = moment.utc(_date).valueOf();
        var today = moment.utc().valueOf();
        if (today >= trainingDay) {
          dateAllowed = true;
        }
        return dateAllowed;
      }
      function isSeatValid() {
        var isValid = true;
        if (!isGround) {
          for (var i = 0; i < trainingFlightIds.length; i++) {
            var selectedSeats = [];
            scope.course.PilotFunctions.forEach(function (pilot) {
              selectedSeats = selectedSeats.concat(pilot.Sectors.filter(function (x) {
                return !x.NonApplicable && x.FlightId == trainingFlightIds[i];
              }).map(function (x) {
                return x.Seat;
              }));
            });
            isValid = new Set(selectedSeats).size == selectedSeats.length;
            if (!isValid) break;
          }
        }
        return isValid;
      }
      function isPilotFunctionValid() {
        var isValid = true;
        if (!isGround) {
          for (var i = 0; i < trainingFlightIds.length; i++) {
            var sectors = [];
            scope.course.PilotFunctions.forEach(function (pilot) {
              sectors = sectors.concat(pilot.Sectors.filter(function (x) {
                return !x.NonApplicable && x.FlightId == trainingFlightIds[i];
              }));
            });

            // isValid = sectors.filter(x => x.isPM || x.isPF).length == 1;
            if (!isValid) break;
          }
        }
        return isValid;
      }
      function syllabusPending() {
        var syllabus = scope.selectedPhase.Syllabus;
        var type = scope.selectedPhase.ModuleType;
        return syllabus && type == 'Check' && (scope.selectedTrainee && !scope.selectedTrainee.AvailableRelease || !scope.selectedTrainee && scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return !x.AvailableRelease;
        }));
      }
      function traineesPending() {
        var syllabus = scope.selectedPhase.Syllabus;
        var type = scope.selectedPhase.ModuleType;
        return syllabus && type == 'Check' && scope.selectedTrainee && scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return !x.AvailableRelease;
        });
      }
      function isSyllabusGradingValid() {
        var syllabus = scope.selectedPhase.Syllabus;
        if (syllabus && syllabus.IsGradable) {
          var gradableSyllabusItems = syllabus.SyllabusItems.filter(function (x) {
            return x.IsGradable;
          });
          var gradableSyllabusItemIds = gradableSyllabusItems.map(function (x) {
            return x.Id;
          });

          //foreach trainee get selected tries that need grading
          scope.trainees.filter(function (x) {
            return !x.Session.Absent;
          }).forEach(function (trainee) {
            var invalidItems = [];
            trainee.Session.Items.filter(function (x) {
              return x.Selected && gradableSyllabusItemIds.includes(x.Id);
            }).forEach(function (selectedItem) {
              var syllabusItem = gradableSyllabusItems.find(function (x) {
                return x.Id == selectedItem.Id;
              });
              var gradingType = syllabusItem.GradeType; //Numeric or Outcome or Competences
              var traineeSelectedTries = selectedItem.Tries.filter(function (x) {
                return x.Selected;
              });
              traineeSelectedTries.forEach(function (selectedTry) {
                var invalidGrading = gradingType != "Competences" && !selectedTry.TryGrading.Grade;
                var invalidCompetences = gradingType == "Competences" && !selectedTry.TryGrading.isCompetenceValid;
                if (invalidGrading || invalidCompetences) {
                  invalidItems.push(syllabusItem.Title);
                }
              });
            });
            trainee.Session.SyllabusValidationErrors = {
              Name: trainee.Name,
              Items: invalidItems
            };
          });
        }
        return !scope.trainees.some(function (t) {
          return t.Session.SyllabusValidationErrors && t.Session.SyllabusValidationErrors.Items.length;
        });
      }
      function isGradingValid() {
        var isDayGradingValid = scope.selectedPhase.DayGrading.GradeType == "NotSet";
        var isReleaseGradingValid = scope.selectedPhase.ReleaseGrading.GradeType == "NotSet" || scope.selectedPhase.ReleaseGrading.GradeType == "CertificateExam" || !scope.course.AvailableRelease || !scope.course.ReleasedPhase;
        var isCertificateGradingValid = scope.selectedPhase.ReleaseGrading.GradeType != "CertificateExam" || !scope.course.ReleasedPhase;
        var isDayCompetencesValid = scope.selectedPhase.DayGrading.Competences.length == 0;
        var isReleaseCompetencesValid = scope.selectedPhase.ReleaseGrading.Competences.length == 0 || !scope.course.AvailableRelease || !scope.course.ReleasedPhase;
        if (!isDayGradingValid) isDayGradingValid = !scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return !x.Session.DayGrading.isGradeValid;
        });
        if (!isReleaseGradingValid) isReleaseGradingValid = !scope.trainees.filter(function (x) {
          return !x.Session.Absent && x.Session.Released;
        }).some(function (x) {
          return !x.Session.ReleaseGrading.isGradeValid;
        });
        if (!isCertificateGradingValid) isCertificateGradingValid = !scope.trainees.filter(function (x) {
          return !x.Session.Absent && x.AvailableRelease;
        }).some(function (x) {
          return !x.Session.ReleaseGrading.isCertificateValid;
        });
        if (!isDayCompetencesValid) isDayCompetencesValid = !scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return !x.Session.DayGrading.isCompetenceValid;
        });
        if (!isReleaseCompetencesValid) isReleaseCompetencesValid = !scope.trainees.filter(function (x) {
          return !x.Session.Absent && x.Session.Released;
        }).some(function (x) {
          return !x.Session.ReleaseGrading.isCompetenceValid;
        });
        scope.gradingValidationInfo = {
          isDayGradingValid: isDayGradingValid,
          isReleaseGradingValid: isReleaseGradingValid,
          isDayCompetencesValid: isDayCompetencesValid,
          isReleaseCompetencesValid: isReleaseCompetencesValid,
          isCertificateGradingValid: isCertificateGradingValid
        };
        return isDayGradingValid && isReleaseGradingValid && isDayCompetencesValid && isReleaseCompetencesValid && isCertificateGradingValid;
      }
      function isTraineeGradingValid(trainee) {
        var isDayGradingValid = scope.selectedPhase.DayGrading.GradeType == "NotSet";
        var isReleaseGradingValid = scope.selectedPhase.ReleaseGrading.GradeType == "NotSet" || scope.selectedPhase.ReleaseGrading.GradeType == "CertificateExam" || !scope.course.AvailableRelease || !scope.course.ReleasedPhase;
        var isCertificateGradingValid = scope.selectedPhase.ReleaseGrading.GradeType != "CertificateExam" || !scope.course.ReleasedPhase;
        var isDayCompetencesValid = scope.selectedPhase.DayGrading.Competences.length == 0;
        var isReleaseCompetencesValid = scope.selectedPhase.ReleaseGrading.Competences.length == 0 || !scope.course.AvailableRelease || !scope.course.ReleasedPhase;
        if (!isDayGradingValid) isDayGradingValid = trainee.Session.DayGrading.isGradeValid;
        if (!isReleaseGradingValid) isReleaseGradingValid = !trainee.Session.Released || trainee.Session.ReleaseGrading.isGradeValid;
        if (!isCertificateGradingValid) isCertificateGradingValid = !trainee.AvailableRelease || trainee.Session.ReleaseGrading.isCertificateValid;
        if (!isDayCompetencesValid) isDayCompetencesValid = trainee.Session.DayGrading.isCompetenceValid;
        if (!isReleaseCompetencesValid) isReleaseCompetencesValid = !trainee.Session.Released || trainee.Session.ReleaseGrading.isCompetenceValid;
        trainee.Session.gradingValidationInfo = {
          isDayGradingValid: isDayGradingValid,
          isReleaseGradingValid: isReleaseGradingValid,
          isDayCompetencesValid: isDayCompetencesValid,
          isReleaseCompetencesValid: isReleaseCompetencesValid,
          isCertificateGradingValid: isCertificateGradingValid
        };
        return isDayGradingValid && isReleaseGradingValid && isDayCompetencesValid && isReleaseCompetencesValid && isCertificateGradingValid;
      }
      function hasLowDayGrading(trainee) {
        scope.traineeHasLowGrading = false;
        var hasDayNumericGrading = scope.selectedPhase.DayGrading.GradeType == "Numeric";
        var hasDayOutcomeGrading = scope.selectedPhase.DayGrading.GradeType == "Outcome";
        var hasDayCompetences = scope.selectedPhase.DayGrading.Competences.length > 0;
        if (trainee != null) {
          if (hasDayNumericGrading && (trainee.Session.DayGrading.Grade == 1 || trainee.Session.DayGrading.Grade == 2)) {
            scope.traineeHasLowGrading = true;
          }
          if (hasDayOutcomeGrading && (trainee.Session.DayGrading.Grade == "Fail" || trainee.Session.DayGrading.Grade == "PasswithTrainingRecommendation")) {
            scope.traineeHasLowGrading = true;
          }
          if (hasDayCompetences) {
            trainee.Session.DayGrading.Competences.forEach(function (competence) {
              if (competence.hasMandatory) scope.traineeHasLowGrading = true;
            });
          }
        }
        return scope.traineeHasLowGrading;
      }
      function hasLowSyllabusGrading(trainee) {
        scope.traineeHasLowSyllabusGrading = false;
        var syllabus = scope.selectedPhase.Syllabus;
        if (trainee != null) {
          if (syllabus && syllabus.IsGradable) {
            var gradableSyllabusItems = syllabus.SyllabusItems.filter(function (x) {
              return x.IsGradable;
            });
            var gradableSyllabusItemIds = gradableSyllabusItems.map(function (x) {
              return x.Id;
            });

            //get selected tries that has low grading
            trainee.Session.Items.filter(function (x) {
              return x.Selected && gradableSyllabusItemIds.includes(x.Id);
            }).forEach(function (selectedItem) {
              var traineeSelectedTries = selectedItem.Tries.filter(function (x) {
                return x.Selected;
              });
              traineeSelectedTries.forEach(function (selectedTry) {
                if (selectedTry.TryGrading.Grade == 1 || selectedTry.TryGrading.Grade == 2 || selectedTry.TryGrading.Grade == 'Fail') scope.traineeHasLowSyllabusGrading = true;
                if (selectedTry.TryGrading.GradeType == 'Competences') {
                  selectedTry.TryGrading.Competences.forEach(function (competence) {
                    if (competence.hasMandatory) scope.traineeHasLowSyllabusGrading = true;
                  });
                }
              });
            });
          }
        }
        return scope.traineeHasLowSyllabusGrading;
      }
      function isMediaValid() {
        scope.hasNoAircraft = scope.course.Media && scope.course.Media.radioModel == "Aircraft" && !scope.course.Media.inputAircrafts.length;
        scope.hasNoDevice = scope.course.Media && scope.course.Media.radioModel == "Simulator" && !scope.course.Media.selectedDevice.selection;
        return !scope.hasNoAircraft && !scope.hasNoDevice;
      }

      /**
       * Triggered after a trainee has successfully signed
       */
      function updateTraineeSignatures() {
        updateSession();
        scope.allSignaturesComplete = !scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return !x.Session.Authorized;
        });
        scope.someSignaturesComplete = scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return x.Session.Authorized;
        });
      }
      function close() {
        scope.modalInstance.close();
        if (scope.info && scope.info.scrollToTop) {
          $window.scrollTo(0, 0);
        }
      }
      function showReleasePanel(syllabus) {
        var retVal = false;
        var phase = scope.selectedPhase;
        var availableCourse = scope.availableCourse && scope.trainees.length;
        var isCheck = phase.ModuleType == 'Check';
        var releaseGrading = (phase.ReleaseGrading.Comments || phase.ReleaseGrading.GradeType == 'Numeric' || phase.ReleaseGrading.GradeType == 'Outcome' || phase.ReleaseGrading.Competences.length) && phase.ReleaseGrading.GradeType != 'CertificateExam';
        if (isCheck) {
          retVal = availableCourse && releaseGrading;
        } else if (scope.traineeSyllabi.length > 1) {
          var crewId = syllabus.TraineeIds[0];
          var trainee = scope.trainees.find(function (x) {
            return x.CrewId == crewId;
          });
          retVal = scope.reloadRelease && trainee.AvailableRelease && trainee.Session.Released && availableCourse && releaseGrading;
        } else {
          retVal = scope.reloadRelease && scope.course.AvailableRelease && scope.course.ReleasedPhase && availableCourse && releaseGrading;
        }
        return retVal;
      }
      function releaseTrainee(syllabus) {
        var crewIds = syllabus.TraineeIds;
        var trainees = scope.trainees.filter(function (x) {
          return crewIds.includes(x.CrewId);
        });
        trainees.forEach(function (trainee) {
          trainee.Session.Released = !trainee.Session.Released;
        });
        scope.course.ReleasedPhase = scope.trainees.filter(function (x) {
          return !x.Absent;
        }).some(function (x) {
          return x.Session.Released;
        });
      }
      function releaseGroup() {
        scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).forEach(function (trainee) {
          trainee.Session.Released = !trainee.Session.Released;
        });
        scope.course.ReleasedPhase = scope.trainees.filter(function (x) {
          return !x.Absent;
        }).some(function (x) {
          return x.Session.Released;
        });
        setReleaseStatus();
      }
      function showReleaseBtn(syllabus) {
        var retVal = false;
        var availableCourse = scope.availableCourse && scope.trainees.length;
        var isCheck = scope.selectedPhase.ModuleType == 'Check';
        if (isCheck) {
          retVal = false;
        } else if (scope.traineeSyllabi.length > 1) {
          var crewId = syllabus.TraineeIds[0];
          var trainee = scope.trainees.find(function (x) {
            return x.CrewId == crewId;
          });
          retVal = scope.reloadRelease && availableCourse && trainee.AvailableRelease;
        } else {
          retVal = scope.reloadRelease && availableCourse && scope.course.AvailableRelease;
        }
        return retVal;
      }
      function showGroupReleaseBtn() {
        var retVal = false;
        var availableCourse = scope.availableCourse && scope.trainees.length > 0;
        var isCheck = scope.selectedPhase.ModuleType == 'Check';
        var releaseGrading = (scope.selectedPhase.ReleaseGrading.Comments || scope.selectedPhase.ReleaseGrading.GradeType == 'Numeric' || scope.selectedPhase.ReleaseGrading.GradeType == 'Outcome' || scope.selectedPhase.ReleaseGrading.Competences.length) && scope.selectedPhase.ReleaseGrading.GradeType != 'CertificateExam';
        if (isCheck) {
          retVal = false;
        } else {
          retVal = scope.reloadRelease && availableCourse && releaseGrading && !scope.trainees.filter(function (x) {
            return !x.Session.Absent;
          }).some(function (x) {
            return !x.AvailableRelease;
          });
        }
        return retVal;
      }
      function getTraineeClass(crewId) {
        isSyllabusGradingValid();
        var textClass = "";
        var trainee = scope.trainees.find(function (x) {
          return x.CrewId == crewId;
        });
        var syllabus = scope.selectedPhase.Syllabus;
        var type = scope.selectedPhase.ModuleType;
        var allSyllabusCompleted = trainee.AvailableRelease;

        //Draft status
        var selectedItems = trainee.Session.Items.some(function (i) {
          return i.Tries.filter(function (t) {
            return !t.isReadOnly;
          }).some(function (t) {
            return t.Selected;
          });
        });

        //Validate syllabus
        var validSyllabusGrading = !trainee.Session.SyllabusValidationErrors || !trainee.Session.SyllabusValidationErrors.Items.length;

        //Validate Day grading
        var isDayGradingValid = scope.selectedPhase.DayGrading.GradeType == "NotSet";
        var isDayCompetencesValid = scope.selectedPhase.DayGrading.Competences.length == 0;
        if (!isDayGradingValid) isDayGradingValid = trainee.Session.DayGrading.isGradeValid;
        if (!isDayCompetencesValid) isDayCompetencesValid = trainee.Session.DayGrading.isCompetenceValid;

        //Validate Release grading
        var isReleaseGradingValid = scope.selectedPhase.ReleaseGrading.GradeType == "NotSet" || scope.selectedPhase.ReleaseGrading.GradeType == "CertificateExam" || scope.selectedPhase.ModuleType == "Training" && (!trainee.AvailableRelease || !trainee.Session.Released);
        var isReleaseCompetencesValid = scope.selectedPhase.ReleaseGrading.Competences.length == 0 || scope.selectedPhase.ModuleType == "Training" && (!trainee.AvailableRelease || !trainee.Session.Released);
        if (!isReleaseGradingValid) isReleaseGradingValid = !trainee.Session.Released || trainee.Session.ReleaseGrading.isGradeValid;
        if (!isReleaseCompetencesValid) isReleaseCompetencesValid = !trainee.Session.Released || trainee.Session.ReleaseGrading.isCompetenceValid;
        if (selectedItems) {
          textClass = "bg-amber text-white";
          if (validSyllabusGrading && isDayGradingValid && isDayCompetencesValid && isReleaseGradingValid && isReleaseCompetencesValid && (type == 'Training' || allSyllabusCompleted)) {
            textClass = "bg-green text-white";
          }
        }
        return textClass;
      }
      function togglePanel(panelId) {
        $('#' + panelId).toggle();
      }

      /**
       * Toggle signature panel while trainee hasn't signed yet
       * @param {object} trainee 
       */
      function openTraineeSignature(_trainee) {
        //Enter signature mode : trainee form becomes read-only
        if (!_trainee.Session.Authorized) {
          setReleaseStatus();
          //Trainee can sign only if his form is valid
          if (!validateTraineeForm(_trainee)) {
            scope.modalInstance = $uibModal.open({
              templateUrl: 'views/Training/dlgSubmitValidation.html',
              scope: scope,
              backdrop: 'static',
              keyboard: false,
              size: 'lg'
            });
          } else {
            scope.modalInstance = $uibModal.open({
              templateUrl: 'views/Training/dlgTraineeSignature.html',
              controller: 'TraineeSignatureModalCtrl',
              scope: scope,
              backdrop: 'static',
              keyboard: false,
              size: 'md',
              resolve: {
                trainee: function trainee() {
                  return _trainee;
                },
                signatureSuccess: function signatureSuccess() {
                  return updateTraineeSignatures;
                }
              }
            });
          }
        }
        scope.someSignaturesComplete = scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).some(function (x) {
          return x.Session.Authorized;
        });
      }
      function validateTraineeForm(trainee) {
        var trainee = scope.selectedTrainee;
        var isValid = false;
        var info = {
          border: "",
          icon: "",
          msg: "",
          scrollToTop: false
        };
        if (!window.navigator.onLine) {
          info = {
            border: "border-left-red",
            icon: "fa-warning text-red",
            msg: "  <strong>Online mode</strong> is required in order to sign. <p>Check your connection and try again!</p>",
            scrollToTop: false
          };
        } else if (syllabusPending()) {
          var traineeDetailsMsg = "";
          if (trainee && (scope.selectedPhase.Syllabus.IsGradable || scope.selectedPhase.InFlight)) {
            traineeDetailsMsg = " for <b>" + trainee.Name + "</b>";
          }
          info = {
            border: "border-left-orange",
            icon: "fa-calendar-times-o text-orange",
            msg: "Form cannot be submitted! <p>Please complete all mandatory syllabus items" + traineeDetailsMsg + "</p>",
            scrollToTop: false
          };
        } else if (!isSyllabusGradingValid() && trainee.Session.SyllabusValidationErrors && trainee.Session.SyllabusValidationErrors.Items.length) {
          info = {
            border: "border-left-orange",
            icon: "fa-warning text-orange",
            msg: "Some of the selected syllabus items require a grading",
            SyllabusErrors: trainee.Session.SyllabusValidationErrors,
            scrollToTop: false
          };
        } else if (!isTraineeGradingValid(trainee)) {
          if (!trainee.Session.gradingValidationInfo.isDayCompetencesValid || !trainee.Session.gradingValidationInfo.isReleaseCompetencesValid) {
            info = {
              border: "border-left-orange",
              icon: "fa-warning text-orange",
              msg: "You need to grade all competences!",
              scrollToTop: false
            };
          } else if (!trainee.Session.isDayGradingValid || !trainee.Session.isReleaseGradingValid) {
            info = {
              border: "border-left-orange",
              icon: "fa-warning text-orange",
              msg: "You need to select an overall grade !",
              scrollToTop: false
            };
          } else if (!trainee.Session.isCertificateGradingValid) {
            info = {
              border: "border-left-orange",
              icon: "fa-warning text-orange",
              msg: "You need to grade all certificate exams!",
              scrollToTop: false
            };
          }
        } else {
          isValid = true;
        }
        scope.info = info;
        return isValid;
      }
      function resetSignature(_trainee2) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Training/dlgResetSignature.html',
          controller: 'TraineeSignatureModalCtrl',
          scope: scope,
          backdrop: 'static',
          keyboard: false,
          size: 'md',
          resolve: {
            trainee: function trainee() {
              return _trainee2;
            },
            signatureSuccess: function signatureSuccess() {
              return updateTraineeSignatures;
            }
          }
        });
        modalInstance.result.then(function (confirm) {
          if (confirm) {
            _trainee2.Session.Authorized = false;
            scope.trainees.find(function (x) {
              return x.CrewId == _trainee2.CrewId;
            }).Session.Authorized = false;
            updateTraineeSignatures();
          }
        });
      }
    }
    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/Training/course.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.factory('CourseFactory', CourseFactory);

  /**
   * @memberof PilotReports
   * @ngdoc factory
   * @name CourseFactory
   * @description 
   *   Add, Update, Delete and Get Training Courses.
   * @ngInject
   */
  function CourseFactory(IndexedDBService, GroundDutyFactory, $http, apiUrl) {
    /**
     * Initialize Course
     * @memberof CourseFactory
     */
    function Course() {
      this.Id = null;
      this.phaseId = null;
    }
    var objType = 'Courses';
    var objCallback = Course;
    var service = {
      setCoursesFromServer: setCoursesFromServer,
      setCoursesToStorage: setCoursesToStorage,
      //save all courses
      addCourseToStorage: addCourseToStorage,
      //update course
      saveOneCourseToStorage: saveOneCourseToStorage,
      //save course
      getCoursesFromStorage: getCoursesFromStorage,
      //get all
      getCourseFromStorage: getCourseFromStorage,
      //getById
      updateCourseInfo: updateCourseInfo,
      updateFlightCourseInfo: updateFlightCourseInfo,
      getCoursesFromStorageByIds: getCoursesFromStorageByIds,
      setCourseOutdated: setCourseOutdated,
      upsertCourse: upsertCourse
    };

    /**
     * Get Course By Id
     * @memberof CourseFactory
     * @param {function} callback  
     */
    function getCourseFromStorage(courseId, callback, errorCallback) {
      // Check if courseId contains an underscore
      if (!(typeof courseId === "string" && courseId.includes("_"))) {
        courseId = Number(courseId);
      }

      // Query IndexedDB with the determined courseId
      IndexedDBService.getById(objType, courseId).then(function (result) {
        callback(result);
      })["catch"](function (error) {
        errorCallback(error);
      });
    }

    /**
    * Get Courses
    * @memberof CourseFactory
    * @param {function} callback  
    */
    function getCoursesFromStorage(callback, errorCallback) {
      IndexedDBService.getAll(objType).then(function (results) {
        callback(results);
      })["catch"](errorCallback);
    }
    ;

    /**
     * Get Course By Ids
     * @memberof CourseFactory
     * @param {function} callback  
     */
    function getCoursesFromStorageByIds(courseIds, callback, errorCallback) {
      IndexedDBService.getAll(objType).then(function (results) {
        var selectedResults = [];
        results.forEach(function (result) {
          if (courseIds.includes(result.Id) && selectedResults.filter(function (x) {
            return x.Id == result.Id;
          }).length == 0) {
            selectedResults.push(result);
          }
        });
        callback(selectedResults);
      })["catch"](errorCallback);
    }
    ;
    function updateCourseInfo(courseId, dutyId, callback, errorOnSaveCallback, errorOnNetwork) {
      var traingingApiURL = apiUrl + '/Training?courseId=' + courseId + '&dutyId=' + dutyId;
      $http.get(traingingApiURL, {
        'Content-Type': 'application/json'
      }).then(function (data) {
        var course = data.data;
        course.FetchedTime = moment.utc().toJSON();
        var duty = GroundDutyFactory.getGroundDutyFromStorage(dutyId);
        course.FetchedDutyCodes = duty.RelatedGroundDuties.filter(function (x) {
          return !x.IsInstructor;
        }).map(function (x) {
          return String(x.GroundDutyNo);
        });
        course.LastFetchedDutyId = dutyId;

        //Upsert course in IndexDB 
        upsertCourse(course, function (course) {
          callback(course);
        }, errorOnSaveCallback);
      })["catch"](errorOnNetwork);
    }
    function updateFlightCourseInfo(crewRouteCourse, date, dutyNo, dutyDay, callback, errorOnSaveCallback, errorOnNetwork) {
      var traingingApiURL = apiUrl + '/Training/GetCrewRouteTraining';
      $http.post(traingingApiURL, crewRouteCourse, {
        'Content-Type': 'application/json'
      }).then(function (data) {
        var course = data.data;
        course.FetchedTime = moment.utc().toJSON();
        course.FetchedCrewRoute = {
          date: date,
          dutyNo: dutyNo,
          dutyDay: dutyDay
        };
        if (crewRouteCourse.PhaseId) {
          course.PhaseId = crewRouteCourse.PhaseId;
          course.CourseId = course.Id;
          course.Id = course.Id + "_" + course.PhaseId;
        }
        //Upsert course in IndexDB 
        upsertCourse(course, function (course) {
          callback(course);
        }, errorOnSaveCallback);
      })["catch"](errorOnNetwork);
    }
    function upsertCourse(course, callback, errorOnSaveCallback) {
      getCourseFromStorage(course.Id, function (localCourse) {
        if (localCourse) {
          saveOneCourseToStorage(course);
        } else {
          addCourseToStorage(course);
        }
        callback(course);
      }, errorOnSaveCallback);
    }
    function setCourseOutdated(courseId, callback, errorCallback) {
      getCourseFromStorage(courseId, function (localCourse) {
        if (localCourse) {
          localCourse.NeedsRefresh = true;
          saveOneCourseToStorage(localCourse);
        }
        if (callback) {
          callback();
        }
      }, errorCallback);
    }

    /**
    * Set Courses from server API  
    * @memberof CourseFactory
    * @param {array} courses Courses Object
    * @param {array} courseIdsToSend  Current courses of the storage
    * @param {string} lastSyncDate  Last Sync Date 
    */
    function setCoursesFromServer(courses, callback, errorCallback) {
      getCoursesFromStorage(function (localCourses) {
        // No courses found - Save All Incoming
        if (!localCourses || localCourses.length == 0) {
          setCoursesToStorage(courses, console.log, console.warn);
        } else {
          for (var j = 0; j < courses.length; j++) {
            var IsCourseIncluded = false;
            for (var h = 0; h < localCourses.length; h++) {
              if (courses[j].Id == localCourses[h].Id) {
                IsCourseIncluded = true;
                break;
              }
            }

            //Update existing course
            if (IsCourseIncluded) {
              localCourses[h].Title = courses[j].Title; //Update title from sync
              saveOneCourseToStorage(localCourses[h]);
            }
            //Add a new Course
            else {
              addCourseToStorage(courses[j]);
            }
          }
          localCourses.filter(function (x) {
            return !courses.some(function (z) {
              return z.Id == x.Id;
            });
          }).forEach(function (course) {
            IndexedDBService.remove(objType, course.Id);
          });
        }
      });
    }

    /**
     * Set Courses
     * @memberof CourseFactory
     * @param {array} Courses A list of courses to set to indexedDB
     */
    function setCoursesToStorage(Courses, callback, errorCallback) {
      IndexedDBService.addAll(objType, Courses).then(callback)["catch"](errorCallback);
      ;
    }
    ;

    /**
     * Add Course to Storage
     * @memberof CourseFactory
     * @param {object} Course
     */
    function addCourseToStorage(Course, callback, errorCallback) {
      IndexedDBService.add(objType, Course).then(callback)["catch"](errorCallback);
      ;
    }
    ;

    /**
     * Update Course to Storage
     * @memberof CourseFactory
     * @param {object} Course
     */
    function saveOneCourseToStorage(Course, callback, errorCallback) {
      IndexedDBService.put(objType, Course).then(callback)["catch"](errorCallback);
    }
    ;
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('FlightCourseCtrl', FlightCourseCtrl);
  /**
   * @memberof PilotReports
   * @ngdoc controller
   * @name FlightCourseCtrl
   * @description 
   *
   * @ngInject
   */
  function FlightCourseCtrl($route, $filter, $timeout, FlightSessionFactory, CrewRouteFactory, FlightFactory, GroundDutyFactory, CourseFactory, $scope, $location, $routeParams) {
    $scope.gotoCourse = gotoCourse;
    $scope.gotoCrewRoute = gotoCrewRoute;
    $scope.gotoFlight = gotoFlight;
    $scope.stickySelectedTrainee = stickySelectedTrainee;
    $scope.toggleView = toggleView;
    $scope.refreshCourse = refresh;
    $scope.courseTrainees = [];
    var courseId = $routeParams.courseId;
    var dutyNo = Number($routeParams.dutyNo);
    var dutyDay = Number($routeParams.dutyDay);
    $scope.viewFromFlight = Number($routeParams.flightId);
    var phaseId = Number($routeParams.phaseId);
    if (isNaN(phaseId) || phaseId === undefined || phaseId === null) {
      phaseId = courseId.split("_")[1]; // Get the part after the underscore
    }

    $scope.PhaseId = phaseId;
    var crewRouteDuty = CrewRouteFactory.getCrewRouteFromStorage(dutyNo, dutyDay);
    var date = $routeParams.date;
    crewRouteDuty.date = date;
    var crewRouteCourse;
    if (phaseId != undefined && phaseId != null && !isNaN($scope.PhaseId)) {
      var simpleCourseId = courseId.split("_")[0];
      crewRouteCourse = crewRouteDuty.Courses.find(function (x) {
        return x.CourseId == simpleCourseId && x.PhaseId == phaseId && new moment(x.Date).isSame(date);
      });
    } else {
      crewRouteCourse = crewRouteDuty.Courses.find(function (x) {
        return x.CourseId == courseId && new moment(x.Date).isSame(date);
      });
    }
    $scope.isEdit = false;
    $scope.loading = false;
    $scope.refreshSuccess = true; //show refresh icon

    if (!crewRouteDuty) {
      // go to dashboard if no groundDuty
      $location.path("/");
    } else {
      $scope.flights = FlightFactory.getFlightsByDutyNo(dutyNo, dutyDay);
      $scope.currentFlight = $scope.flights.filter(function (f) {
        return f.FlightId == Number($routeParams.flightId);
      });

      //Get Crew Route's course
      CourseFactory.getCourseFromStorage(courseId, function (savedCourse) {
        var dutyCourse = savedCourse;
        $scope.dutyCourse = dutyCourse;
        initCourse(false);
      });
      $scope.crewRouteDuty = crewRouteDuty;
    }
    function gotoFlight() {
      var flightId = Number($routeParams.flightId);
      $location.path('/flightinfo/' + flightId);
    }
    function manageCourseStatus(dutyCourse, course, afterRefresh) {
      var crewRouteCourse;
      if (course.CourseId) {
        crewRouteCourse = crewRouteDuty.Courses.find(function (x) {
          return x.CourseId == course.CourseId && new moment(x.Date).isSame(date);
        });
      } else {
        crewRouteCourse = crewRouteDuty.Courses.find(function (x) {
          return x.CourseId == course.Id && new moment(x.Date).isSame(date);
        });
      }

      // COMPLETED : has been submitted
      var isCourseComplete = crewRouteCourse.Status == "Completed";

      // NEEDS SUBMIT : 1 hour has passed since the end of the course
      var now = moment.utc();
      if (!(dutyCourse !== null && dutyCourse !== void 0 && dutyCourse.IsCompleted)) {
        var needsSubmit = false;
        var fetched = moment.utc(crewRouteDuty.DutyEnd);
        var duration = moment.duration(now.diff(fetched)).asHours();
        if (duration > 1) {
          needsSubmit = true;
        }
      }

      // LIMITED : no info available
      var isCourseLimited = !course || course.HasLimitedInfo || course.HasLimitedSession && !afterRefresh;

      // OUTDATED : NeedsRefresh || 18 hours since last refresh
      var isCourseOutdated = false;
      if (course && course.FetchedTime) {
        var now = moment.utc();
        var fetched = moment.utc(course.FetchedTime);
        var duration = moment.duration(now.diff(fetched)).asHours();
        if (duration > 18 || course.NeedsRefresh) {
          isCourseOutdated = true;
        }
      }
      var hasAdditionalTrainingRequest = false;
      if (course.SubmittedSessions && course.SubmittedSessions.length > 0) {
        if (course.SubmittedSessions[course.SubmittedSessions.length - 1].TraineesSessions.filter(function (y) {
          return y.NeedsAdditionalRequest == true;
        }).length > 0) {
          hasAdditionalTrainingRequest = true;
          course.hasAdditionalTrainingRequest = true;
        }
        ;
      }
      var isUnderAdditionalTraining = false;
      if (course.SubmittedSessions && course.SubmittedSessions.length > 0) {
        if (course.SubmittedSessions.map(function (x) {
          return x.TraineesSessions.find(function (y) {
            return y.UnderAdditionalTraining == true;
          });
        })) {
          isUnderAdditionalTraining = true;
          course.isUnderAdditionalTraining = true;
        }
        ;
      }
      $scope.headerMsg = "Refresh Course";
      if (isCourseLimited) $scope.headerMsg = "Fetch Course";
      $scope.hasPendingTraining = !isCourseComplete;
      $scope.hasUnsetTraining = needsSubmit;
      $scope.isCourseLimited = isCourseLimited;
      $scope.isCourseComplete = isCourseComplete;
      $scope.isCourseOutdated = isCourseOutdated;
      $scope.hasAdditionalTrainingRequest = hasAdditionalTrainingRequest;
      $scope.hasNotifications = isCourseLimited || isCourseOutdated || isCourseComplete;
    }
    function initCourse(afterRefresh) {
      var _$scope$dutyCourse;
      if ($scope.dutyCourse) {
        var courseId = $scope.dutyCourse.Id;
        // var onlyCourseId = $scope.dutyCourse.Id;
        var onlyCourseId = typeof courseId === "string" && courseId.includes("_") ? Number(courseId.split("_")[0]) // Split and convert to number
        : Number(courseId);
      } else {
        var courseId = $scope.crewRouteDuty.Courses[0].CourseId;
        var onlyCourseId = $scope.crewRouteDuty.Courses[0].CourseId;
        console.log(':', $scope.crewRouteDuty);
      }
      var crewRouteCourse;
      if ((_$scope$dutyCourse = $scope.dutyCourse) !== null && _$scope$dutyCourse !== void 0 && _$scope$dutyCourse.PhaseId) {
        crewRouteCourse = $scope.crewRouteDuty.Courses.find(function (x) {
          return x.CourseId == onlyCourseId && x.PhaseId == $scope.dutyCourse.PhaseId && new moment(x.Date).isSame(date);
        });
      } else {
        crewRouteCourse = $scope.crewRouteDuty.Courses.find(function (x) {
          return x.CourseId == onlyCourseId && new moment(x.Date).isSame(date);
        });
      }
      FlightSessionFactory.getSession(courseId, date, dutyNo, dutyDay, crewRouteCourse.TrainingFlightIds, afterRefresh, function (course) {
        if (course && !course.HasLimitedInfo) {
          $scope.availableCourse = true;
          $scope.selectedPhase = course.selectedPhase;
          $scope.trainees = course.CourseTrainees;
          course.SequenceWarning = false;
        }
        $scope.course = course;
        manageCourseStatus($scope.dutyCourse, course, afterRefresh);
        toggleView('History'); //default

        if ($scope.trainees) {
          stickySelectedTrainee();
          //Check for status change (new trainees found on a submitted session (reset) || failed certificate trainees want to retake the test)
          if (afterRefresh && $scope.isCourseComplete && $scope.trainees.length) {
            CrewRouteFactory.setCoursePending(dutyNo, dutyDay, courseId, date);
            $scope.isCourseComplete = false;
            $route.reload();
          }
        }
        $scope.reload = false;
        $timeout(function () {
          $scope.reload = true;
        }, 100);
      });
    }
    function gotoCourse(course, phaseId) {
      var path = '/course/' + course.Id + '/' + groundDuty.DutyDateS + "/" + groundDuty.Id;
      if (phaseId) {
        path += '/' + phaseId;
      }
      $location.path(path);
    }

    // function gotoCourse(course) {
    //     $location.path('/course/' + course.Id + '/' + groundDuty.DutyDateS + "/" + groundDuty.Id);
    // }

    function gotoCrewRoute() {
      $location.path('/crewRoute/' + dutyNo + '/' + dutyDay);
    }
    function refresh() {
      $scope.loading = true;
      if ($scope.isOffline) {
        $timeout(function () {
          $scope.loading = false;
        }, 100);
        $scope.refreshSuccess = false;
        $scope.availableCourseInfo = false;
        $scope.refreshErrorMsg = "Online mode is required in order to get course. Please connect to the internet and try again.";
      } else {
        CourseFactory.updateFlightCourseInfo(crewRouteCourse, date, dutyNo, dutyDay, function () {
          $scope.loading = false;
          $scope.refreshSuccess = true;
          $scope.availableCourseInfo = true;
          initCourse(true);
          $scope.reload = false;
          $timeout(function () {
            $scope.reload = true;
          }, 100);
        }, function () {
          $scope.loading = false;
          $scope.refreshSuccess = false;
          $scope.availableCourseInfo = false;
          $scope.refreshErrorMsg = "Something went wrong! Please Try again.";
        }, function (error) {
          console.log(error);
          $scope.loading = false;
          $scope.refreshSuccess = false;
          $scope.availableCourseInfo = false;
          $scope.refreshErrorMsg = "Oops! Something went wrong!";

          //null exception!
          // if (error.data.errorMessage){
          //     $scope.refreshErrorMsg = error.data.errorMessage;
          // }
        });
      }
    }

    function stickySelectedTrainee() {
      if ($scope.trainees && $scope.trainees.filter(function (x) {
        return !x.Session.Absent;
      }).length) {
        if ($scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).find(function (x) {
          return x.Session.selected;
        })) {
          $scope.selectedTrainee = $scope.trainees.filter(function (x) {
            return !x.Session.Absent;
          }).find(function (x) {
            return x.Session.selected;
          });
        } else {
          $scope.selectedTrainee = $scope.trainees.filter(function (x) {
            return !x.Session.Absent;
          })[0];
        }
      } else {
        $scope.selectedTrainee = null;
      }
      if ($scope.selectedTrainee) $scope.selectedTraineeBadge = {
        CrewId: $scope.selectedTrainee.CrewId
      };
    }
    function toggleView(mode) {
      $scope.viewMode = mode;
    }
  }
})();
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
(function () {
  'use strict';

  a3_pilot_reports.factory('FlightSessionFactory', FlightSessionFactory);

  /**
   * @memberof PilotReports
   * @ngdoc factory
   * @name FlightSessionFactory
   * @description 
   *   Add, Update, Delete and Flight Sessions.
   * @ngInject
   */
  function FlightSessionFactory(IndexedDBService, CrewRouteFactory, FlightFactory, CourseFactory, $http, apiUrl, $filter) {
    /**
     * Initialize Session
     * @memberof FlightSessionFactory
     */
    function Session() {
      this.Id = null;
    }
    var objType = 'FlightSessions';
    var objCallback = Session;
    var service = {
      getAll: getAll,
      getSession: getSession,
      setSession: setSession,
      updateSession: updateSession,
      getSessionTrainees: getSessionTrainees,
      submitSession: submitSession,
      remove: remove,
      getCrewRouteFlightTrainees: getCrewRouteFlightTrainees,
      applyTraineeInfoToSession: applyTraineeInfoToSession
    };

    /**
     * Get all flight training sessions
     * @memberof FlightSessionFactory
     * @param {function} callback  
     */
    function getAll(callback) {
      IndexedDBService.getAll(objType).then(function (results) {
        callback(results);
      });
    }
    ;

    /**
     * Get session By day and courseId
     * @memberof FlightSessionFactory
     * @param {function} callback  
     */
    function getSession(courseId, day, dutyNo, dutyDay, trainingFlightIds, afterRefresh) {
      var callback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function () {};
      var errorCallback = arguments.length > 7 ? arguments[7] : undefined;
      // if (courseId && courseId.includes("_")) {
      //     courseId = courseId.split("_")[0];
      //   }
      IndexedDBService.getById(objType, [day, courseId, dutyNo, dutyDay]).then(function (session) {
        CourseFactory.getCourseFromStorage(courseId, function (course) {
          if (course && !course.HasLimitedInfo && course.CrewCoursePhases && course.CourseTrainees) {
            mergeCourseWithSession(course, session, dutyNo, dutyDay, trainingFlightIds, afterRefresh);
          }
          callback(course);
        }, errorCallback);
      })["catch"](errorCallback);
    }

    /**
     * Remove session By day, dutyNo, dutyDay and courseId
     * @memberof FlightSessionFactory
     * @param {function} callback  
     */
    function remove(courseId, day, dutyNo, dutyDay, callback, errorCallback) {
      IndexedDBService.remove(objType, [day, courseId, dutyNo, dutyDay]).then(callback)["catch"](errorCallback);
    }
    ;

    /**
    * Get session Trainees By day and courseId
    * @memberof FlightSessionFactory
    * @param {function} callback  
    */
    function getSessionTrainees(courseId, day, dutyNo, dutyDay, callback, errorCallback) {
      IndexedDBService.getById(objType, [day, courseId, dutyNo, dutyDay]).then(function (session) {
        var trainees = session && session.trainees ? session.trainees : [];
        callback(trainees);
      })["catch"](errorCallback);
    }
    ;

    /**
    * Set session
    * @memberof FlightSessionFactory
    * @param {function} callback  
    */
    function setSession(session, callback, errorCallback) {
      IndexedDBService.getById(objType, [session.day, session.courseId, session.dutyNo, session.dutyDay]).then(function (result) {
        if (result) {
          saveSessionToStorage(session).then(callback)["catch"](errorCallback);
          ;
        } else {
          addSessionToStorage(session).then(callback)["catch"](errorCallback);
        }
      })["catch"](errorCallback);
    }
    ;

    /**
    * Set session
    * @memberof FlightSessionFactory
    * @param {function} callback  
    */
    function updateSession(trainees, session, courseId, day, dutyNo, dutyDay, callback, errorCallback) {
      IndexedDBService.getById(objType, [day, courseId, dutyNo, dutyDay]).then(function (localSession) {
        var isNewSession = false;
        if (!localSession) {
          localSession = {
            courseId: courseId,
            day: day,
            dutyNo: dutyNo,
            dutyDay: dutyDay,
            trainees: []
          };
          isNewSession = true;
        } else {
          localSession.trainees = [];
        }
        if (session) {
          localSession.Media = session.Media;
          localSession.ReleasedPhase = session.ReleasedPhase;
          localSession.PilotFunctions = session.PilotFunctions;
          localSession.TraineeEligibilty = session.TraineeEligibilty;
        }
        trainees.forEach(function (trainee) {
          localSession.trainees.push(trainee);
        });
        if (isNewSession) {
          addSessionToStorage(localSession).then(callback)["catch"](errorCallback);
        } else {
          saveSessionToStorage(localSession).then(callback)["catch"](errorCallback);
        }
      })["catch"](errorCallback);
    }
    function mergeCourseWithSession(course, session, dutyNo, dutyDay, trainingFlightIds, afterRefresh) {
      course.HasLimitedSession = session == undefined;
      var hasPreviousSessions = mergeSyllabusWithHistory(course.CourseTrainees, course.CrewCoursePhases);
      filterTraineesByEligibility(dutyNo, dutyDay, course, trainingFlightIds, session, afterRefresh);
      course.CrewCoursePhases.forEach(function (phase) {
        calculatePhaseStatus(phase, course);
      });
      course.selectedPhase = getSelectedPhase(course);

      // Calculate eligible trainees phase status
      course.CourseTrainees.forEach(function (trainee) {
        var traineePhase = trainee.Phases.find(function (x) {
          return x.PhaseId == course.selectedPhase.PhaseId;
        });
        if (traineePhase) {
          trainee.ActivePhaseStatus = traineePhase.PhaseStatus;
        } else {
          trainee.ActivePhaseStatus = "Pending";
        }
        trainee.Selectable = trainee.ActivePhaseStatus == "InProgress";
      });

      // Non InProgress trainees will be marked as NonEligible (remove further ahead trainees on multiple InProgress phases)
      course.CourseTrainees.filter(function (x) {
        return !x.Selectable;
      }).forEach(function (invalidPhaseTrainee) {
        invalidPhaseTrainee.EligibilityStatus = false;
        invalidPhaseTrainee.EligibilityDesc = "AlreadySubmitted";
        course.NonEligibleTrainees.push(invalidPhaseTrainee);
      });
      course.CourseTrainees = course.CourseTrainees.filter(function (x) {
        return x.EligibilityStatus;
      });

      // Get trainee sessions
      course.CourseTrainees.forEach(function (trainee) {
        var sessionTrainee = session ? session.trainees.find(function (x) {
          return x.CrewId == trainee.CrewId;
        }) : null;
        if (sessionTrainee) {
          trainee.Session = sessionTrainee.Session;
        } else {
          trainee.Session = {
            Released: course.selectedPhase.ModuleType == "Training" ? false : true,
            CrewId: trainee.CrewId,
            Items: [],
            Absent: false,
            DayGrading: {
              Comments: null,
              Grade: null,
              Competences: []
            },
            ReleaseGrading: {
              Comments: null,
              Grade: null,
              Competences: []
            },
            NeedsAdditionalTraining: false,
            AdditionalTrainingRemarks: null,
            CompleteAdditionalTraining: false
          };
        }
      });

      /*  Set default values for release option
          Training Modules: 'No' release as default
          Check Module: 'Yes' release as default
      */
      course.ReleasedPhase = course.selectedPhase.ModuleType == "Training" ? false : true;
      if (session) {
        course.Media = session.Media;
        course.ReleasedPhase = session.ReleasedPhase;
        course.PilotFunctions = session.PilotFunctions;
        course.TraineeEligibilty = session.TraineeEligibilty;
      }
    }
    function getSelectedPhase(course) {
      var hasSelectedPhase = false;
      var phases = course.CrewCoursePhases;
      if (course.PhaseId) {
        var phaseById = phases.find(function (x) {
          return x.PhaseId == course.PhaseId;
        });
        if (phaseById) {
          phaseById.Selected = true;
          return phaseById;
        }
      }
      phases.forEach(function (phase, index, array) {
        phase.isFirst = index == 0;
        phase.isLast = index + 1 == array.length;
        // Select the first InProgress & selected phase
        if (!hasSelectedPhase && phase.Status == "InProgress" && phase.isSelected) {
          phase.Selected = true;
          hasSelectedPhase = true;
        }
      });

      // Select the first InProgress phase
      if (!hasSelectedPhase && phases.some(function (x) {
        return x.Status == "InProgress";
      })) {
        phases.find(function (x) {
          return x.Status == "InProgress";
        }).Selected = true;
        hasSelectedPhase = true;
      }
      if (!hasSelectedPhase) {
        phases.find(function (x) {
          return x.isFirst;
        }).Selected = true;
      }
      var selectedPhase = phases.find(function (x) {
        return x.Selected;
      });
      return selectedPhase;
    }
    function filterTraineesByEligibility(dutyNo, dutyDay, course, trainingFlightIds, session, afterRefresh) {
      var _course$CourseTrainee;
      // Trainee Eligiblity cases
      // 1. After refresh - Save newly fetched eligibility in session
      // 2. No refresh & Session exists - Get last fetched eligibility from session
      // 3. No refresh & No session exists - Rely on previously fetched eligibility (different duty - same course)

      var traineeEligibility = course.TraineeEligibilty;
      if (!afterRefresh && session && session.TraineeEligibilty) {
        traineeEligibility = session.TraineeEligibilty;
      }
      if (session) session.TraineeEligibilty = traineeEligibility; //update session eligibility

      // Get crew route trainees without any training records
      var trainees = getCrewRouteFlightTrainees(dutyNo, dutyDay, trainingFlightIds);
      var inactiveTrainees = trainees.filter(function (x) {
        return !course.CourseTrainees.some(function (z) {
          return z.CrewId == x.CrewId;
        });
      });

      //Exclude Non valid trainees
      var eligibleTraineeIds = Object.keys(traineeEligibility).filter(function (x) {
        return traineeEligibility[x] == "NotStarted" || traineeEligibility[x] == "ValidPhase" || traineeEligibility[x] == "FailedCertificate";
      }).map(Number);
      var eligibleTrainees = inactiveTrainees.filter(function (x) {
        return eligibleTraineeIds.includes(x.CrewId);
      });
      eligibleTrainees.forEach(function (trainee) {
        trainee.EligibilityStatus = true;
      });
      createNewPhaseTrainees(dutyNo, dutyDay, trainingFlightIds, course, eligibleTrainees);

      // Merge eligibleTrainees (inactive) with CourseTrainees (eligible & active)
      course.CourseTrainees.forEach(function (trainee) {
        trainee.EligibilityStatus = true;
      });
      (_course$CourseTrainee = course.CourseTrainees).push.apply(_course$CourseTrainee, _toConsumableArray(eligibleTrainees));

      // Non eligible trainees
      var nonEligibleTrainees = inactiveTrainees.filter(function (x) {
        return !eligibleTraineeIds.includes(x.CrewId);
      });
      course.NonEligibleTrainees = nonEligibleTrainees;
      var courseValidPositions = [];
      if (course.PositionCP) {
        courseValidPositions.push("CP");
      }
      if (course.PositionFO) {
        courseValidPositions.push("FO");
      }
      if (course.PositionSA) {
        courseValidPositions.push("SA");
      }
      if (course.PositionFA) {
        courseValidPositions.push("FA");
      }

      //Filter trainees by course position 
      trainees.forEach(function (trainee) {
        if (!courseValidPositions.includes(trainee.position)) {
          trainee.EligibilityStatus = false;
          nonEligibleTrainees.push(trainee);
        }
      });
      nonEligibleTrainees.forEach(function (trainee) {
        trainee.EligibilityStatus = false;
        trainee.EligibilityDesc = traineeEligibility[trainee.CrewId];
      });

      // Result:
      // CourseTrainees = eligible trainees (active or new)
      // Non EligibleTrainees
    }

    /**
     * Create first phase foreach trainee
     * @param {object} groundDuty
     * @param {object} course
     * @param {array} trainees Eligible trainees that haven't yet started training
     */
    function createNewPhaseTrainees(dutyNo, dutyDay, trainingFlightIds, course, trainees) {
      var flights = FlightFactory.getFlightsByDutyNo(dutyNo, dutyDay).filter(function (f) {
        return trainingFlightIds.some(function (z) {
          return z == f.FlightId;
        });
      });
      //Match TrainingIndicators with PhaseDutyNos
      var crewCoursePhaseDutyNos = [];
      var crewrouteTrainingIndicators = [];
      course.CrewCoursePhases.forEach(function (coursePhase) {
        crewCoursePhaseDutyNos = crewCoursePhaseDutyNos.concat(coursePhase.FlightTrainingIndicators);
      });

      // Test reasons
      var testFlight = flights.find(function (x) {
        return x.FlightId == 1186970;
      });
      if (testFlight) {
        testFlight.TrainingIndicatorId = 2;
      }
      flights.forEach(function (flight) {
        var _flight$TrainingIndic;
        crewrouteTrainingIndicators.push((_flight$TrainingIndic = flight.TrainingIndicatorId) === null || _flight$TrainingIndic === void 0 ? void 0 : _flight$TrainingIndic.toString());
      });
      var relatedDutyNos = crewCoursePhaseDutyNos.filter(function (x) {
        return crewrouteTrainingIndicators.includes(x);
      });
      var relatedPhases = course.CrewCoursePhases.filter(function (x) {
        return x.FlightTrainingIndicators.some(function (fti) {
          return relatedDutyNos.includes(fti);
        });
      });

      //From related phases, select first in order
      relatedPhases = $filter('orderBy')(relatedPhases, 'OrderNo');
      var firstPhase = relatedPhases[0];
      trainees.forEach(function (trainee) {
        trainee.Phases = [{
          PhaseId: firstPhase.PhaseId,
          PhaseStatus: "InProgress",
          RepeatRequestedItems: [],
          isSelected: true //selectedPhase
        }];
      });
    }

    function getCrewRouteFlightTrainees(dutyNo, dutyDay, trainingFlightIds) {
      var flights = FlightFactory.getFlightsByDutyNo(dutyNo, dutyDay).filter(function (f) {
        return trainingFlightIds.some(function (z) {
          return z == f.FlightId;
        });
      });
      var trainees = [];
      flights.forEach(function (flight) {
        flight.crew.filter(function (x) {
          return x.IsTrainee && !x.isDHC;
        }).forEach(function (trainee) {
          if (!trainees.some(function (x) {
            return x.id == trainee.id;
          })) {
            //do not push duplicates : trainees that are in multiple flights
            trainees.push(trainee);
          }
        });
      });
      trainees.forEach(function (trainee) {
        trainee.CrewId = trainee.id;
        trainee.Id = trainee.id;
        trainee.Name = trainee.name;
        trainee.AimsId = trainee.aimsId;
      });
      return trainees;
    }
    function calculatePhaseStatus(phase, course) {
      course.CourseTrainees.forEach(function (trainee) {
        var traineePhase = trainee.Phases.find(function (x) {
          return x.PhaseId == phase.PhaseId;
        });
        if (traineePhase && traineePhase.PhaseStatus == "InProgress") {
          phase.Status = "InProgress";
        } else if (!traineePhase && phase.Status != "InProgress") {
          phase.Status = "Pending";
        } else if (traineePhase && traineePhase.PhaseStatus == "Completed" && phase.Status != "InProgress") {
          phase.Status = "Completed";
        }
        //Selected phase, If at least one trainee has it selected
        if (traineePhase && !phase.isSelected) {
          phase.isSelected = traineePhase.isSelected;
        }
      });
    }
    function mergeSyllabusWithHistory(trainees, phases) {
      var flatSullabusItems = [];
      trainees.forEach(function (trainee) {
        trainee.Phases.forEach(function (phase) {
          phase.Sessions.forEach(function (session) {
            session.Items.forEach(function (item) {
              var flatItem = createFlatHistorySullabusItem(trainee, phase, session, item);
              flatSullabusItems.push(flatItem);
            });
          });
        });
      });
      phases.filter(function (x) {
        return x.Syllabus;
      }).forEach(function (phase, index, array) {
        phase.Syllabus.SyllabusItems.forEach(function (syllabusItem) {
          syllabusItem.History = flatSullabusItems.filter(function (item) {
            return item.ItemId == syllabusItem.Id;
          });
        });
      });
      var hasPreviousSessions = flatSullabusItems.length > 0;
      return hasPreviousSessions;
    }
    function createFlatHistorySullabusItem(trainee, phase, session, item) {
      var flatItem = {
        CrewId: trainee.CrewId,
        PhaseId: phase.PhaseId,
        SessionId: session.SessionId,
        SessionComments: session.SessionComments,
        SubmissionDate: item.SubmissionDate,
        RepeatRequired: item.RepeatRequired,
        Tries: item.Tries,
        ItemId: item.SyllabusItemId,
        Grade: session.Grade,
        GradeType: session.GradeType,
        InstructorName: session.InstructorName,
        InstructorAimsId: session.InstructorAimsId
      };
      return flatItem;
    }

    /**
     * Add Session to Storage
     * @memberof FlightSessionFactory
     * @param {object} Session
     */
    function addSessionToStorage(session) {
      return IndexedDBService.add(objType, session);
    }
    ;

    /**
     * Update Session to Storage
     * @memberof FlightSessionFactory
     * @param {object} Session
     */
    function saveSessionToStorage(session) {
      return IndexedDBService.put(objType, session);
    }
    ;
    function submitSession(submittedSession, callback) {
      var traingingApiURL = apiUrl + '/Training/SubmitTraining';
      return $http.post(traingingApiURL, submittedSession, {
        'Content-Type': 'application/json'
      }).then(callback);
    }
    function applyTraineeInfoToSession(course, courseId, day, dutyNo, dutyDay, callback, errorCallback) {
      IndexedDBService.getById(objType, [day, courseId, dutyNo, dutyDay]).then(function (localSession) {
        var isNewSession = false;
        if (!localSession) {
          localSession = {
            courseId: courseId,
            day: day,
            dutyNo: dutyNo,
            dutyDay: dutyDay,
            trainees: [],
            TraineeEligibilty: course.TraineeEligibilty,
            CourseTrainees: course.CourseTrainees
          };
          isNewSession = true;
        } else {
          localSession.CourseTrainees = course.CourseTrainees;
          localSession.TraineeEligibilty = course.TraineeEligibilty;
        }
        if (isNewSession) {
          addSessionToStorage(localSession).then(callback)["catch"](errorCallback);
        } else {
          saveSessionToStorage(localSession).then(callback)["catch"](errorCallback);
        }
      })["catch"](errorCallback);
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('grading', grading);
  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name grading
  * @restrict E
  * @description
  *   Implementation of overall grading
  * @example
  *   Usage:
  *   <grading></grading>
  * @ngInject
  */
  function grading() {
    function link(scope, element, attrs) {
      scope.getRemainingCharacters = getRemainingCharacters;
      scope.validateGrading = validateGrading;
      scope.filterValidTrainees = filterValidTrainees;
      scope.filterTrainee = filterTrainee;
      scope.saveComment = saveComment;
      scope.isDayGrading = scope.type == "day";
      scope.hasCertificateExam = scope.type == "certificate";
      scope.isCheck = scope.phase == "Check";

      //Separate DayGrading and ReleaseGrading 
      scope.sessions = [];
      scope.trainees.filter(function (x) {
        return !x.Session.Absent;
      }).forEach(function (trainee) {
        var session = scope.isDayGrading ? trainee.Session.DayGrading : trainee.Session.ReleaseGrading;
        session.Name = trainee.Name;
        session.AimsId = trainee.AimsId;
        session.CrewId = trainee.CrewId;
        if (scope.isDayGrading || !scope.isDayGrading && !scope.isCheck && trainee.AvailableRelease || !scope.isDayGrading && scope.isCheck) {
          scope.sessions.push(session);
        }
      });
      scope.sessions.forEach(function (traineeSession) {
        validateGrading(traineeSession);
      });
      filterValidTrainees();

      /**
       * Calculate remaining characters for comment input
       * @param {string} text 
       * @param {number} max 
       */
      function getRemainingCharacters(text, max) {
        if (typeof text === "undefined" || text === null) return '';
        if (typeof max === "undefined" || max === null || max < 0 || !max) max = 4000;
        var length = text.length;
        return 'characters left: ' + (max - length);
      }
      function validateGrading(trainee) {
        trainee.isGradeValid = trainee.Grade != null && trainee.Grade != undefined;
      }
      function filterValidTrainees() {
        scope.sessions.forEach(function (traineeSession) {
          traineeSession.isValid = traineeSession.isGradeValid && (!scope.settings.Competences.length || traineeSession.isCompetenceValid);
        });
      }
      function filterTrainee() {
        return function (trainee) {
          var showTrainee = true;
          if (scope.selected) {
            //individual grading view: filter selected
            showTrainee = scope.selected.CrewId == trainee.CrewId;
          }
          return showTrainee;
        };
      }
      function saveComment() {
        scope.commentInput();
      }
    }
    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/Training/grading.tpl.html',
      scope: {
        trainees: "=",
        settings: "=",
        type: "@",
        phase: "=",
        selected: "=",
        commentInput: "&onCommentInput"
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('GroundCourseCtrl', GroundCourseCtrl);
  /**
   * @memberof PilotReports
   * @ngdoc controller
   * @name GroundCourseCtrl
   * @description 
   *
   * @ngInject
   */
  function GroundCourseCtrl($route, $filter, $timeout, TrainingSessionFactory, CrewRouteFactory, FlightFactory, GroundDutyFactory, CourseFactory, $scope, $location, $routeParams) {
    $scope.gotoCourse = gotoCourse;
    $scope.gotoGroundDuty = gotoGroundDuty;
    $scope.stickySelectedTrainee = stickySelectedTrainee;
    $scope.toggleView = toggleView;
    $scope.refreshCourse = refresh;
    $scope.courseTrainees = [];

    // var courseId = Number($routeParams.courseId);
    var courseId = typeof $routeParams.courseId === "string" && $routeParams.courseId.includes("_") && !$routeParams.courseId.includes("_undefined") ? Number($routeParams.courseId.split("_")[0]) // Extract and convert the first part to number
    : Number($routeParams.courseId); //  Convert to number directly if no underscore

    var phaseId = typeof $routeParams.courseId === "string" && $routeParams.courseId.includes("_") ? Number($routeParams.courseId.split("_")[1]) // Extract Phase ID if exists
    : undefined;
    $scope.PhaseId = phaseId;
    var groundDutyId = Number($routeParams.dutyId);
    var groundDuty = GroundDutyFactory.getGroundDutyFromStorage(groundDutyId);
    $scope.isEdit = false;
    $scope.loading = false;
    $scope.allAbsent = false;
    $scope.refreshSuccess = true; //show refresh icon

    if (!groundDuty) {
      // go to dashboard if no groundDuty
      $location.path("/");
    } else {
      var date = groundDuty.DutyDateS;
      if (groundDuty.RelatedGroundDuties) {
        var courses = GroundDutyFactory.getGroundDutyActiveCourses(groundDutyId);
        if (courses.length) {
          CourseFactory.getCourseFromStorage($routeParams.courseId, function (dutyCourse) {
            $scope.dutyCourse = dutyCourse;
            initCourse(false);
          });
        }
      }
      $scope.groundDuty = groundDuty;
      $scope.groundDutyId = groundDutyId;
    }
    function initCourse(afterRefresh) {
      TrainingSessionFactory.getSession(courseId, date, groundDutyId, afterRefresh, function (course) {
        if (course && !course.HasLimitedInfo) {
          $scope.availableCourse = true;
          $scope.selectedPhase = course.selectedPhase;
          $scope.trainees = course.CourseTrainees;
          course.SequenceWarning = false;
        }
        $scope.course = course;
        manageCourseStatus($scope.dutyCourse, course, afterRefresh);
        toggleView('History'); //default

        if ($scope.trainees) {
          applyAttendanceFromGroundDuty(groundDuty, $scope.trainees);
          stickySelectedTrainee();
          if ($scope.trainees.length && !$scope.trainees.some(function (x) {
            return !x.Session.Absent;
          })) {
            $scope.allAbsent = true;
          }

          //Check for status change (new trainees found on a submitted session (reset) || failed certificate trainees want to retake the test)
          if (afterRefresh && $scope.isCourseComplete && $scope.trainees.length) {
            GroundDutyFactory.setCoursePending(groundDutyId, courseId);
            $scope.isCourseComplete = false;
            $route.reload();
          }
        }
        $scope.reload = false;
        $timeout(function () {
          $scope.reload = true;
        }, 100);
      });
    }
    function applyAttendanceFromGroundDuty(groundDuty, trainees) {
      groundDuty.Trainees.forEach(function (related) {
        related.CrewMembers.forEach(function (crew) {
          var trainee = trainees.find(function (x) {
            return x.CrewId == crew.Id;
          });
          if (trainee) {
            trainee.Session.Absent = crew.Absent;
          }
        });
      });
    }

    // function gotoCourse(course) {
    //     $location.path('/course/' + course.Id + '/' + groundDuty.DutyDateS + "/" + groundDuty.Id);
    // }

    function gotoCourse(course, phaseId) {
      var path = '/course/' + course.Id + '/' + groundDuty.DutyDateS + "/" + groundDuty.Id;
      if (phaseId) {
        path += '/' + phaseId;
      }
      $location.path(path);
    }
    function refresh() {
      $scope.loading = true;
      if ($scope.isOffline) {
        $timeout(function () {
          $scope.loading = false;
        }, 100);
        $scope.refreshSuccess = false;
        $scope.availableCourseInfo = false;
        $scope.refreshErrorMsg = "Online mode is required in order to get course. Please connect to the internet and try again.";
      } else {
        var courseId = typeof $scope.dutyCourse.Id === "string" && $scope.dutyCourse.Id.includes("_") ? Number($scope.dutyCourse.Id.split("_")[0]) // Extract first part as number
        : Number($scope.dutyCourse.Id);
        CourseFactory.updateCourseInfo(courseId, groundDutyId, function () {
          $scope.loading = false;
          $scope.refreshSuccess = true;
          $scope.availableCourseInfo = true;
          initCourse(true);
          $scope.reload = false;
          $timeout(function () {
            $scope.reload = true;
          }, 100);
        }, function () {
          $scope.loading = false;
          $scope.refreshSuccess = false;
          $scope.availableCourseInfo = false;
          $scope.refreshErrorMsg = "Something went wrong! Please Try again.";
        }, function (error) {
          console.log(error);
          $scope.loading = false;
          $scope.refreshSuccess = false;
          $scope.availableCourseInfo = false;
          $scope.refreshErrorMsg = "Oops! Something went wrong!";

          //null exception!
          // if (error.data.errorMessage) {
          //     $scope.refreshErrorMsg = error.data.errorMessage;
          // }
        });
      }
    }

    function manageCourseStatus(dutyCourse, course, afterRefresh) {
      // COMPLETED : has been submitted
      // var isCourseComplete = courses.find(x => x.CourseId == dutyCourse.Id && x.Status == "Completed") != null;
      var isCourseComplete = courses.some(function (x) {
        // Check if PhaseId exists and combine CourseId with PhaseId
        var courseKey = x.PhaseId ? "".concat(x.CourseId, "_").concat(x.PhaseId) : x.CourseId;

        // Get dutyCourse's ID (considering PhaseId)
        var dutyCourseKey = dutyCourse.PhaseId ? "".concat(dutyCourse.CourseId, "_").concat(dutyCourse.PhaseId) : dutyCourse.Id;
        return courseKey === dutyCourseKey && x.Status === "Completed";
      });

      // NEEDS SUBMIT : 1 hour has passed since the end of the course
      var now = moment.utc();
      if (!dutyCourse.IsCompleted) {
        var needsSubmit = false;
        var fetched = moment.utc(groundDuty.DutyEnd);
        var duration = moment.duration(now.diff(fetched)).asHours();
        if (duration > 1) {
          needsSubmit = true;
        }
      }

      // LIMITED : no info available
      var isCourseLimited = !course || course.HasLimitedInfo || course.HasLimitedSession && !afterRefresh;

      // OUTDATED : NeedsRefresh || 18 hours since last refresh
      var isCourseOutdated = false;
      if (course && course.FetchedTime) {
        var now = moment.utc();
        var fetched = moment.utc(course.FetchedTime);
        var duration = moment.duration(now.diff(fetched)).asHours();
        if (duration > 18 || course.NeedsRefresh) {
          isCourseOutdated = true;
        }
      }
      $scope.headerMsg = "Refresh Course";
      if (isCourseLimited) $scope.headerMsg = "Fetch Course";
      $scope.hasPendingTraining = !isCourseComplete;
      $scope.hasUnsetTraining = needsSubmit;
      $scope.isCourseLimited = isCourseLimited;
      $scope.isCourseComplete = isCourseComplete;
      $scope.isCourseOutdated = isCourseOutdated;
      $scope.hasNotifications = isCourseLimited || isCourseOutdated || isCourseComplete;
    }
    function gotoGroundDuty() {
      $location.path('/groundDuty/' + groundDutyId);
    }
    function stickySelectedTrainee() {
      var availableRelease = $scope.selectedPhase.ModuleType == "Check" || !$scope.trainees.filter(function (x) {
        return !x.Session.Absent;
      }).some(function (tr) {
        return tr.Session.Items.some(function (i) {
          return i.Status == "Pending";
        });
      });
      var individualGrading = $scope.trainees && $scope.trainees.filter(function (x) {
        return !x.Session.Absent;
      }).length && $scope.selectedPhase && ($scope.selectedPhase.Syllabus && $scope.selectedPhase.Syllabus.IsGradable || $scope.selectedPhase.HasDayGrading || $scope.selectedPhase.HasReleaseGrading && availableRelease || RequiresTraineeSignature());
      if (individualGrading) {
        if ($scope.trainees.filter(function (x) {
          return !x.Session.Absent;
        }).find(function (x) {
          return x.Session.selected;
        })) {
          $scope.selectedTrainee = $scope.trainees.filter(function (x) {
            return !x.Session.Absent;
          }).find(function (x) {
            return x.Session.selected;
          });
        } else {
          $scope.selectedTrainee = $scope.trainees.filter(function (x) {
            return !x.Session.Absent;
          })[0];
        }
      } else {
        $scope.selectedTrainee = null;
      }
      if ($scope.selectedTrainee) $scope.selectedTraineeBadge = {
        CrewId: $scope.selectedTrainee.CrewId
      };
    }
    function RequiresTraineeSignature() {
      // End of session signature
      var endOfSessionSignature = $scope.selectedPhase.DayGrading.TraineeSignature;

      // End of module signature
      var endOfModuleSignature = $scope.course.ReleasedPhase && $scope.selectedPhase.ReleaseGrading.TraineeSignature;
      return endOfSessionSignature || endOfModuleSignature;
    }
    function toggleView(mode) {
      $scope.viewMode = mode;
    }
  }
})();
"use strict";

(function () {
  a3_pilot_reports.directive('instructions', instructions);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name notifications
  * @restrict E
  * @description
  *   Show selected module's trainee & instructor instructions
  * @example
  *   Usage:
  *   <instructions></instructions>
  * @ngInject
  */

  function instructions($filter, $routeParams, $location, UserFactory) {
    function link(scope, attrs) {
      scope.warningMessageText = "";
      scope.viewModuleHistory = viewModuleHistory;
      if (!scope.course.isParallel) {
        var currentActiveOrderNo = scope.selectedPhase.OrderNo;
        scope.course.CrewCoursePhases.forEach(function (phase) {
          if (phase.OrderNo < currentActiveOrderNo && phase.Status != "Completed") {
            phase.SequentialWarning = true;
          }

          //check if phase has any history
          var oldSessions = [];
          scope.trainees.filter(function (x) {
            return !x.Session.Absent;
          }).forEach(function (trainee) {
            var historyPhase = trainee.Phases.find(function (x) {
              return x.PhaseId == phase.PhaseId;
            });
            if (historyPhase && historyPhase.Sessions) oldSessions = oldSessions.concat(historyPhase.Sessions);
          });
          phase.hasHistory = oldSessions.length > 0;
        });
      }
      scope.course.CrewCoursePhases.forEach(function (phase) {
        phase.StatusClass = '';
        if (phase.SequentialWarning) {
          phase.StatusClass = "panel-danger border-left-red";
          phase.BtnClass = "bg-red text-white";
        } else if (phase.Status == 'InProgress') {
          phase.StatusClass = "border-left-blue";
          phase.TextClass = "text-blue";
          phase.BtnClass = "bg-blue text-white";
        } else if (phase.Status == 'Pending') {
          phase.StatusClass = "border-left-gray ";
          phase.TextClass = "text-gray";
          phase.BtnClass = "bg-gray text-white";
        } else if (phase.Status == 'Completed') {
          phase.StatusClass = "border-left-green";
          phase.TextClass = "text-green";
          phase.BtnClass = "bg-green text-white";
        }
        if (phase.PhaseId == scope.selectedPhase.PhaseId) {
          phase.StatusClass = phase.StatusClass + " panel-info";
        }
      });
      var furtherAheadPhases = [];
      furtherAheadPhases = scope.course.CrewCoursePhases.filter(function (x) {
        return x.SequentialWarning;
      });
      furtherAheadPhases = $filter('orderBy')(furtherAheadPhases, 'OrderNo');
      if (furtherAheadPhases.length > 0) {
        scope.course.SequenceWarning = true;
        scope.warningMessageText = "<strong>" + furtherAheadPhases[furtherAheadPhases.length - 1].Title + "</strong> is not completed. Confirm that you want to continue to <strong>" + scope.selectedPhase.Title + ".</strong>";
      }
      scope.traineeInstructions = scope.selectedPhase.TraineeInstructions;
      scope.examinerInstructions = scope.selectedPhase.ExaminerInstructions;
      scope.continueSubmission = continueSubmission;
      scope.cancelSubmission = cancelSubmission;
      scope.isInstructorView = false;
      var traineesAimsIds = scope.trainees.map(function (x) {
        return x.AimsId;
      });
      var user = UserFactory.getUser();
      if (!traineesAimsIds.includes(user.aimsId)) {
        scope.isInstructorView = true;
      }
      scope.status = {
        isInstructorOpen: true,
        isTraineeOpen: false
      };
      function continueSubmission() {
        scope.course.SequenceWarning = false;
      }
      function cancelSubmission() {
        if (scope.isGround) {
          gotoGroundDuty();
        } else {
          gotoCrewRoute();
        }
      }
      function gotoGroundDuty() {
        $location.path('/groundDuty/' + Number($routeParams.dutyId));
      }
      function gotoCrewRoute() {
        var dutyNo = scope.crewRouteDuty.DutyNo;
        var dutyDay = scope.crewRouteDuty.DutyDay;
        $location.path('/crewRoute/' + dutyNo + '/' + dutyDay);
      }
      function viewModuleHistory(phaseId) {
        var courseId = $routeParams.courseId;
        var combinedId = typeof courseId === 'string' && courseId.includes('_') ? courseId : "".concat(courseId, "_").concat($routeParams.phaseId);
        var dutyId = Number($routeParams.dutyId);
        var date = $routeParams.date;
        if (dutyId) {
          if (combinedId.includes("_undefined")) {
            courseId = Number($routeParams.courseId.split("_")[0]);
            combinedId = "".concat(courseId, "_").concat($routeParams.phaseId);
          }
          // $location.path('/groundHistory/' + courseId + '/' + dutyId + '/' + date + '/' + phaseId);
          $location.path('/groundHistory/' + combinedId + '/' + dutyId + '/' + date + '/' + phaseId);
        } else {
          if (typeof $routeParams.courseId === 'string' && $routeParams.courseId.split('_').length > 1) {
            courseId = parseInt($routeParams.courseId.split('_')[0], 10);
          }
          var dutyNo = scope.crewRouteDuty.DutyNo;
          var dutyDay = scope.crewRouteDuty.DutyDay;
          var flightId = Number($routeParams.flightId);
          // $location.path('/flightHistory/' + combinedId + '/' + dutyNo + '/' + dutyDay + '/' + date + '/' + phaseId);
          // $location.path(`/flightHistory/${simpleCourseId}_${phaseId}/${dutyNo}/${dutyDay}/${date}`);
          $location.path("/flightHistory/".concat(combinedId, "/").concat(scope.crewRouteDuty.DutyNo, "/").concat(scope.crewRouteDuty.DutyDay, "/").concat($routeParams.date, "/").concat(flightId, "/").concat(phaseId));
        }
      }
    }
    return {
      restrict: 'E',
      templateUrl: "views/Training/instructions.tpl.html",
      scope: false,
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  a3_pilot_reports.directive('media', media);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name ground Media
  * @restrict E
  * @description
  *   Initialize panel with media of training selection, aircraft types & synthetic devices
  * @example
  *   Usage:
  *   <media></media>
  * @ngInject
  */

  function media($location, CourseFactory) {
    function link(scope, attrs) {
      scope.addAircraftRow = addAircraftRow;
      scope.removeAircraftRow = removeAircraftRow;
      scope.showDowntimeDuration = showDowntimeDuration;
      scope.clearDowntimeDuration = clearDowntimeDuration;
      scope.isObjectEmpty = isObjectEmpty;
      scope.downtimeDuration = {
        radioValue: 'false',
        show: false,
        minutes: null
      };
      scope.sessionDuration = scope.groundDuty ? (new Date(scope.groundDuty.DutyEnd) - new Date(scope.groundDuty.DutyBegin)) / (1000 * 60) : undefined;
      scope.downtimeDurationValueChanged = downtimeDurationValueChanged;
      initializeMedia();
      scope.filterSyntheticDevices = filterSyntheticDevices;
      function isObjectEmpty(obj) {
        return Object.keys(obj).length === 0;
      }
      function initializeMedia() {
        if (scope.course) {
          if (!scope.course.Media) {
            // Create Media object
            scope.course.Media = {
              inputAircrafts: [],
              selectedAircraft: {
                selection: undefined
              },
              selectedDevice: {
                selection: undefined
              },
              radioModel: ""
            };
          }
          if (scope.course.Media.radioModel == "" || mediaRemoved()) {
            //Auto select media on init or if selection was removed in admin settings
            if (scope.selectedPhase.InSimulator) scope.course.Media.radioModel = "Simulator";
            if (scope.selectedPhase.InAircraft) scope.course.Media.radioModel = "Aircraft";
            if (scope.selectedPhase.InClassroom) scope.course.Media.radioModel = "Classroom";
          }
          if (scope.selectedPhase.InSimulator) {
            // Check if training centers exist
            if (scope.course.TrainingCenters && scope.course.TrainingCenters.length > 0) {
              var defaultCenter = scope.course.TrainingCenters.find(function (x) {
                return x.IsDefault;
              });
              if (defaultCenter) {
                scope.course.selectedTrainingCenter = defaultCenter.Id;
                filterSyntheticDevices(defaultCenter.Id);
              } else {
                // If no default center, select "No Center"
                scope.course.selectedTrainingCenter = 'No Center';
                // No need to filter devices based on training center, show all devices
                filterSyntheticDevices('No Center');
              }
            }

            // Auto-select the first device if not already selected and devices exist
            if (scope.course.SyntheticDevices && !isObjectEmpty(scope.course.SyntheticDevices)) {
              if (!scope.course.Media.selectedDevice) {
                scope.course.Media.selectedDevice = {};
              }
              if (!scope.course.Media.selectedDevice.selection) {
                // Select the first available device
                scope.course.Media.selectedDevice.selection = Object.keys(scope.course.SyntheticDevices)[0];
              }
            } else {
              // No devices available, clear the selection
              scope.course.Media.selectedDevice.selection = undefined;
            }
          }

          // Create downtime duration object
          scope.downtimeDuration = {
            radioValue: 'false',
            show: false,
            minutes: null
          };
        }
      }
      function filterSyntheticDevices(trainingCenterId) {
        if (!scope.course.AllSyntheticDevices) {
          return;
        }
        if (trainingCenterId && trainingCenterId !== 'No Center') {
          scope.course.SyntheticDevices = scope.course.AllSyntheticDevices.filter(function (device) {
            return device.TrainingCenterId == trainingCenterId;
          });
          if (scope.course.SyntheticDevices && scope.course.SyntheticDevices.length > 0) {
            var defaultDevice = scope.course.SyntheticDevices.find(function (device) {
              return device.IsDefault;
            });
            if (defaultDevice) {
              scope.course.Media.selectedDevice.selection = defaultDevice.Id;
            } else {
              scope.course.Media.selectedDevice.selection = null;
            }
          } else {
            scope.course.Media.selectedDevice.selection = scope.course.AllSyntheticDevices;
          }
        } else {
          scope.course.SyntheticDevices = scope.course.AllSyntheticDevices;
        }
      }
      function mediaRemoved() {
        return scope.course.Media.radioModel == "Simulator" && !scope.selectedPhase.InSimulator || scope.course.Media.radioModel == "Aircraft" && !scope.selectedPhase.InAircraft || scope.course.Media.radioModel == "Classroom" && !scope.selectedPhase.InClassroom;
      }
      function addAircraftRow() {
        var aircraftTypes = scope.course.AircraftTypes;
        if (scope.course.Media.selectedAircraft.selection != undefined && aircraftTypes && aircraftTypes.includes(scope.course.Media.selectedAircraft.selection) && (!scope.course.Media.inputAircrafts || !scope.course.Media.inputAircrafts.includes(scope.course.Media.selectedAircraft.selection))) {
          //Add to selected
          if (!scope.course.Media.inputAircrafts) {
            scope.course.Media.inputAircrafts = [];
          }
          scope.course.Media.inputAircrafts.push(scope.course.Media.selectedAircraft.selection);

          //Remove from options
          scope.course.AircraftTypes = aircraftTypes.filter(function (aircraft) {
            return aircraft != scope.course.Media.selectedAircraft.selection;
          });

          //Clear 
          scope.course.Media.selectedAircraft.selection = undefined;
        }
      }
      function removeAircraftRow(aircraft) {
        //Remove from selected
        var acIndex = scope.course.Media.inputAircrafts.indexOf(aircraft);
        scope.course.Media.inputAircrafts.splice(acIndex, 1);

        //Add back to options
        scope.course.AircraftTypes.push(aircraft);
      }
      function showDowntimeDuration(showDowntime) {
        if (showDowntime == true) {
          scope.downtimeDuration.show = true;
        } else {
          scope.downtimeDuration.show = false;
        }
      }
      function clearDowntimeDuration() {
        scope.downtimeDuration.minutes = null;
      }
      ;
      function downtimeDurationValueChanged() {
        if (scope.downtimeDuration.minutes > scope.sessionDuration) {
          scope.downtimeDuration.minutes = scope.sessionDuration;
        }
        return scope.downtimeDuration.minutes;
      }
    }
    return {
      restrict: 'E',
      templateUrl: "views/Training/media.tpl.html",
      scope: false,
      terminal: true,
      link: link
    };
  }
})();
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
(function () {
  'use strict';

  a3_pilot_reports.controller('ModuleHistoryCtrl', ModuleHistoryCtrl);
  /**
   * @memberof PilotReports
   * @ngdoc controller
   * @name ModuleHistoryCtrl
   * @description 
   *
   * @ngInject
   */
  function ModuleHistoryCtrl($scope, $routeParams, TrainingSessionFactory, CourseFactory, FlightSessionFactory, $location) {
    $scope.rightScroll = rightScroll;
    $scope.leftScroll = leftScroll;
    $scope.selectedTrainee = selectedTrainee;
    $scope.selectedSession = selectedSession;
    $scope.gotoCourse = gotoCourse;
    var isGround = false;
    if ($routeParams.dutyId) {
      isGround = true;
      var courseId = typeof $routeParams.courseId === "string" && $routeParams.courseId.includes("_") ? Number($routeParams.courseId.split("_")[0]) // Split and convert to number
      : Number($routeParams.courseId);
      var combinedCourseId = !isNaN(Number($routeParams.courseId)) ? Number($routeParams.courseId) : $routeParams.courseId;
      var dutyId = Number($routeParams.dutyId);
      var date = $routeParams.date;
      var phaseId = Number($routeParams.phaseId);
    } else {
      var courseId = !isNaN(Number($routeParams.courseId)) ? Number($routeParams.courseId) : $routeParams.courseId;
      var dutyNo = Number($routeParams.dutyNo);
      var dutyDay = Number($routeParams.dutyDay);
      var date = $routeParams.date;
      var flightId = $routeParams.flightId;
      var phaseId = Number($routeParams.phaseId);
    }
    CourseFactory.getCourseFromStorage(courseId, function (course) {
      $scope.phase = course.CrewCoursePhases.find(function (x) {
        return x.PhaseId == phaseId;
      });
      $scope.course = course;
      if (isGround) {
        TrainingSessionFactory.getSessionTrainees(combinedCourseId, date, dutyId, function (trainees) {
          initHistory(trainees);
        });
      } else {
        FlightSessionFactory.getSessionTrainees(courseId, date, dutyNo, dutyDay, function (trainees) {
          initHistory(trainees);
        });
      }
    });
    function initHistory(trainees) {
      if (trainees && trainees.length) {
        trainees.forEach(function (trainee) {
          trainee.HistoryPhase = trainee.Phases.find(function (x) {
            return x.PhaseId == phaseId;
          });
        });
        $scope.historyTrainees = setHistoryTrainees(trainees);
        $scope.selectedTraineeBadge = {
          crewId: trainees[0].CrewId,
          traineeSessionId: trainees[0].HistoryPhase.Sessions[0].Id
        };
        $scope.selectedSubmittedSessionBadge = {
          sessionId: trainees[0].HistoryPhase.Sessions[0].SessionId
        };
      }
    }
    function setHistoryTrainees(trainees) {
      var historyTrainees = trainees.filter(function (x) {
        return x.HistoryPhase && x.HistoryPhase.Sessions && !x.Session.Absent;
      });
      historyTrainees.forEach(function (trainee) {
        trainee.HistoryPhase.hasSectors = trainee.HistoryPhase.Sessions.some(function (x) {
          return x.Sectors && x.Sectors.length > 0;
        });
        trainee.HistoryPhase.Sessions.forEach(function (session) {
          session.hasDayGrading = session.DayGrading.Comments || session.DayGrading.GradeType != 'NotSet' && session.DayGrading.Grade || session.DayGrading.Competences.length > 0;
          session.hasReleaseGrading = session.ReleaseGrading.Comments || session.ReleaseGrading.GradeType != 'NotSet' && session.ReleaseGrading.Grade || session.ReleaseGrading.Competences.length > 0;
          session.AcTypes = _toConsumableArray(new Set(session.Sectors.map(function (ses) {
            return ses.AcType;
          })));

          //GroupBy AcType
          session.SectorsByAcType = [];
          session.AcTypes.forEach(function (acType) {
            var group = {
              AcType: acType,
              Sectors: session.Sectors.filter(function (x) {
                return x.AcType == acType;
              })
            };
            session.SectorsByAcType.push(group);
          });
        });
        setTraineeSummary(trainee.HistoryPhase);
      });
      return historyTrainees;
    }
    function setTraineeSummary(phase) {
      var sectorSummary = [];
      var totalSectors = 0;

      //Unique ac types of all sessions
      var allAcTypes = [];
      phase.Sessions.forEach(function (session) {
        allAcTypes = allAcTypes.concat(session.AcTypes);
      });
      allAcTypes = _toConsumableArray(new Set(allAcTypes));

      //Group by ac type
      allAcTypes.forEach(function (acType) {
        var sectors = [];
        phase.Sessions.forEach(function (session) {
          sectors = sectors.concat(session.Sectors.filter(function (x) {
            return x.AcType == acType;
          }));
        });
        var sectorGroup = {
          AcType: acType,
          Sectors: sectors
        };
        totalSectors = totalSectors + sectors.length;
        sectorSummary.push(sectorGroup);
      });
      phase.SectorSummary = sectorSummary;
      phase.TotalSectors = totalSectors;
    }
    function selectedTrainee() {
      return function (trainee) {
        var showSession = false;
        if (trainee.CrewId === $scope.selectedTraineeBadge.crewId) {
          showSession = true;
        }
        return showSession;
      };
    }
    function selectedSession() {
      return function (historyTrainee) {
        var showSession = false;
        if (historyTrainee.SessionId === $scope.selectedSubmittedSessionBadge.sessionId) {
          showSession = true;
        }
        return showSession;
      };
    }
    function leftScroll() {
      document.querySelector('.horizontal-scroll').scrollLeft -= 500;
    }
    function rightScroll() {
      document.querySelector('.horizontal-scroll').scrollLeft += 500;
    }
    function gotoCourse() {
      if (isGround) {
        if ($routeParams.courseId && $routeParams.courseId.includes("_")) {
          var pathPhaseId = Number($routeParams.courseId.split("_")[1]);
          $location.path('/groundcourse/' + courseId + '/' + Number($routeParams.dutyId) + '/' + $routeParams.date + '/' + pathPhaseId);
        } else {
          $location.path('/groundcourse/' + courseId + '/' + Number($routeParams.dutyId) + '/' + $routeParams.date);
        }
      } else {
        if ($routeParams.courseId && $routeParams.courseId.includes("_")) {
          var pathPhaseId = Number($routeParams.courseId.split("_")[1]);
          $location.path('/flightcourse/' + courseId + '/' + Number($routeParams.dutyNo) + '/' + Number($routeParams.dutyDay) + '/' + $routeParams.date + '/' + flightId + '/' + pathPhaseId);
        } else {
          $location.path('/flightcourse/' + Number($routeParams.courseId) + '/' + Number($routeParams.dutyNo) + '/' + Number($routeParams.dutyDay) + '/' + $routeParams.date);
        }
      }
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('nonEligibleTrainees', nonEligibleTrainees);

  /**
   * @memberof PilotReports
   * @ngdoc directive
   * @name nonEligibleTrainees
   * @restrict E
   * @description
   *   Show trainees that are not eligible for this training session
   * @example
   *   Usage:
   *   <non-eligible-trainees></non-eligible-trainees>
   * @ngInject 
   */
  function nonEligibleTrainees(FlightSessionFactory, $routeParams) {
    function link(scope) {
      scope.categories = setCategories();

      //Collect duty trainees
      var dutyTrainees = [];
      if (scope.groundDuty) {
        scope.groundDuty.Trainees.forEach(function (related) {
          related.CrewMembers.forEach(function (trainee) {
            dutyTrainees.push(trainee);
          });
        });
      } else {
        var date = $routeParams.date;
        var dutyNo = Number($routeParams.dutyNo);
        var dutyDay = Number($routeParams.dutyDay);
        // var crewRouteCourse = scope.crewRouteDuty.Courses.find(x => x.CourseId == scope.course.Id && new moment(x.Date).isSame(date));
        var crewRouteCourse = scope.crewRouteDuty.Courses.find(function (x) {
          return x.PhaseId == scope.course.PhaseId && new moment(x.Date).isSame(date);
        });
        var dutyTrainees = FlightSessionFactory.getCrewRouteFlightTrainees(dutyNo, dutyDay, crewRouteCourse.TrainingFlightIds);
      }
      if (scope.course && scope.course.CourseTrainees) {
        categorizeTrainee(dutyTrainees);
      }
      scope.dutyTrainees = dutyTrainees;
      function setCategories() {
        var parallelMessage = "Trainees may have already completed this module";
        var sequentialMessage = "Trainees have either completed this module or are not yet ready to start it";
        return [{
          title: "InvalidPhase",
          msg: scope.course.isParallel ? parallelMessage : sequentialMessage,
          trainees: [],
          all: false
        }, {
          title: "Submitted",
          msg: "Trainees have already been submitted",
          trainees: [],
          all: false
        }, {
          title: "RecurrentPeriod",
          msg: "Trainees have completed the course earlier",
          trainees: [],
          all: false
        }, {
          title: "InvalidRole",
          msg: "For this training, cabin crew trainees can only be assessed by a cabin crew instructor",
          trainees: [],
          all: false
        }];
      }
      function categorizeTrainee(dutyTrainees) {
        var allEligibilityTrainees = scope.course.CourseTrainees.concat(scope.course.NonEligibleTrainees);
        dutyTrainees.forEach(function (dutyTrainee) {
          var courseTrainee = allEligibilityTrainees.find(function (x) {
            return x.CrewId == dutyTrainee.Id;
          });
          if (courseTrainee) {
            // if (courseTrainee.ActivePhaseStatus == 'Completed') {
            //     scope.categories.find(x => x.title=="Completed").trainees.push(dutyTrainee);
            // }
            if (!courseTrainee.EligibilityStatus && courseTrainee.EligibilityDesc == 'AlreadySubmitted') {
              scope.categories.find(function (x) {
                return x.title == "Submitted";
              }).trainees.push(dutyTrainee);
            }
            if (!courseTrainee.EligibilityStatus && courseTrainee.EligibilityDesc == 'InvalidPhase') {
              scope.categories.find(function (x) {
                return x.title == "InvalidPhase";
              }).trainees.push(dutyTrainee);
            }
            if (!courseTrainee.EligibilityStatus && courseTrainee.EligibilityDesc == 'CooldownPending') {
              scope.categories.find(function (x) {
                return x.title == "RecurrentPeriod";
              }).trainees.push(dutyTrainee);
            }
            if (!courseTrainee.EligibilityStatus && courseTrainee.EligibilityDesc == 'InvalidRole') {
              scope.categories.find(function (x) {
                return x.title == "InvalidRole";
              }).trainees.push(dutyTrainee);
            }
          }
        });
        var allCategory = scope.categories.find(function (x) {
          return x.trainees.length == dutyTrainees.length;
        }); //all trainees in same category
        if (allCategory) {
          allCategory.all = true;
        }
      }
    }
    return {
      restrict: 'E',
      terminal: true,
      templateUrl: "views/Training/non-eligible-trainees.tpl.html",
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('NotificationModalCtrl', NotificationModalCtrl);
  /**
   * @memberof PilotReports
   * @ngdoc controller
   * @name NotificationModalCtrl
   * @description 
   * Shows Show Signature 
   * @ngInject
   */

  function NotificationModalCtrl($scope, $uibModalInstance) {
    $scope.close = close;

    /**
     * Close the modal
     * @memberof NotificationModalCtrl
     */
    function close() {
      $uibModalInstance.close($scope.success);
    }
  }
})();
"use strict";

(function () {
  a3_pilot_reports.directive('notifications', notifications);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name notifications
  * @restrict E
  * @description
  *   Initialize panel with information messages about session's status and necessary actions
  * @example
  *   Usage:
  *   <notifications></notifications>
  * @ngInject
  */

  function notifications($routeParams) {
    function link(scope) {
      var _scope$course, _scope$course2;
      var info = {
        msg: "",
        border: "",
        text: "",
        showHistory: false
      };
      var date = $routeParams.date;
      scope.filterSession = filterSession;
      scope.selectSession = selectSession;
      scope.historyAvailable = false;
      scope.additionalTrainingRequested = false;
      scope.underAdditionalTraining = false;
      scope.showReleaseOption = false;

      //If already submitted : show submitted sessions menu and select first
      if ((_scope$course = scope.course) !== null && _scope$course !== void 0 && _scope$course.SubmittedSessions && (_scope$course2 = scope.course) !== null && _scope$course2 !== void 0 && _scope$course2.SubmittedSessions.length) {
        var submittedDay = scope.course.SubmittedSessions[0].DutyDay;
        var isSame = moment(date).isSame(submittedDay);
        if (isSame) {
          scope.course.historyAvailable = true;
          scope.historyAvailable = true;
          scope.selectedSubmittedSession = {
            sessionId: scope.course.SubmittedSessions[0].SessionId
          };
          scope.course.SubmittedSessions.forEach(function (submittedSession) {
            submittedSession.TraineesSessions.forEach(function (traineeSession) {
              scope.additionalTrainingRequested = traineeSession.NeedsAdditionalRequest;
            });
          });
          scope.course.SubmittedSessions.forEach(function (submittedSession) {
            if (submittedSession.TraineesSessions.some(function (x) {
              return x.IsReleased == false && x.NeedsAdditionalRequest == false;
            })) {
              scope.showReleaseOption = true;
            }
            ;
          });
        }
      }

      // 1. Check if session has been already submitted 
      var isCourseComplete = scope.isCourseComplete;
      if (isCourseComplete) {
        info = {
          msg: "Training form already submitted for this day.",
          border: "border-left-orange",
          text: "text-orange",
          showHistory: true //show what was submitted in read-only view
        };
      }

      // 2. Check if course is Outdated
      var isCourseOutdated = scope.isCourseOutdated;
      if (isCourseOutdated) {
        info = {
          msg: "You have an outdated version of this course. Please Refresh Course.",
          border: "border-left-orange",
          text: "text-orange",
          showHistory: false
        };
      }

      // 3. Check if course needs an initial fetch
      var isCourseLimited = scope.isCourseLimited;
      if (isCourseLimited && !isCourseComplete) {
        isCourseLimited = true;
        info = {
          msg: "You need to perform an initial fetch to receive all available information.",
          border: "border-left-blue",
          text: "text-blue",
          showHistory: false
        };
      }

      // Result
      scope.info = info;

      /**
       * Filter submitted sessions based on selected from the top menu
       * @returns if session is currently selected
       */
      function filterSession() {
        return function (traineeSession) {
          var showSessionTrainees = false;
          if (traineeSession.SessionId === scope.selectedSubmittedSession.sessionId) {
            showSessionTrainees = true;
          }
          return showSessionTrainees;
        };
      }
      function selectSession(sessionId) {
        scope.selectedSubmittedSession.sessionId = sessionId;
      }
    }
    return {
      restrict: 'E',
      templateUrl: "views/Training/notifications.tpl.html",
      scope: false,
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  a3_pilot_reports.directive('pilotFunction', pilotFunction);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name pilotFunction
  * @restrict E
  * @description
  *   Initialize panel with pm/pf and seating info : Only for pilots in flight courses
  * @example
  *   Usage:
  *   <pilot-positions></pilot-positions>
  * @ngInject
  */

  function pilotFunction(FlightFactory, UserFactory, $timeout) {
    function link(scope, attrs, $routeParams) {
      scope.selectSeat = selectSeat;
      scope.selectFunction = selectFunction;
      scope.reloadPilotFunction = false;
      scope.handleMultipleFunctions = handleMultipleFunctions;
      var date = scope.crewRouteDuty.date;
      var courseId = scope.dutyCourse.Id;
      // var crewRouteCourse = scope.crewRouteDuty.Courses.find(x => x.CourseId == courseId && new moment(x.Date).isSame(date));

      var simpleCourseId = scope.dutyCourse.Id;
      var crewRouteCourse;
      if (scope.PhaseId != undefined && scope.PhaseId != null && !isNaN(scope.PhaseId) && !isNaN(scope.PhaseId)) {
        crewRouteCourse = scope.crewRouteDuty.Courses.find(function (x) {
          return x.PhaseId == scope.PhaseId && new moment(x.Date).isSame(date);
        });
      } else {
        crewRouteCourse = scope.crewRouteDuty.Courses.find(function (x) {
          return x.CourseId == simpleCourseId && new moment(x.Date).isSame(date);
        });
      }
      var trainingFlightIds = crewRouteCourse.TrainingFlightIds;
      var trainingFlights = [];
      trainingFlightIds.forEach(function (flightId) {
        trainingFlights.push(FlightFactory.getFlightFromStorage(flightId));
      });
      var instructor = UserFactory.getUser();
      var instructorTrainingIndicator = trainingFlights[0].crew.find(function (x) {
        return x.id == instructor.id;
      }).TrainingIndicatorCode;
      var traineeTrainingIndicator = instructorTrainingIndicator.toLowerCase();
      scope.flights = trainingFlights;
      trainingFlights.forEach(function (flight) {
        flight.hasTwoTrainees = flight.crew.filter(function (x) {
          return x.TrainingIndicatorCode && x.TrainingIndicatorCode == traineeTrainingIndicator && !x.isDHC && x.IsTrainee;
        }).length == 2;
        flight.hasMoreThanThreePilots = flight.crew.filter(function (x) {
          return x.TrainingIndicatorCode && !x.isDHC;
        }).length > 3;
      });
      initializePilotFunctions();

      //Operating pilots can change in each sector
      //When multiple trainees, instructor is not operating
      trainingFlights.forEach(function (flight) {
        //Assign operatingPilots on each flight
        flight.operatingPilots = flight.hasMoreThanThreePilots || flight.hasTwoTrainees ? scope.course.PilotFunctions.filter(function (x) {
          return !x.IsInstructor;
        }) : scope.course.PilotFunctions.filter(function (x) {
          return !x.Sectors.find(function (sec) {
            return sec.FlightId == flight.FlightId;
          }).NonApplicable;
        });
      });
      function initializePilotFunctions() {
        var PilotFunctions = [];
        if (scope.course && scope.trainees.length) {
          //Create trainee info
          scope.trainees.forEach(function (trainee) {
            nameArray = trainee.Name.split(/[ ]+/);
            var pilot = {
              CrewId: trainee.CrewId,
              AimsId: trainee.AimsId,
              Name: trainee.Name,
              FirstName: nameArray[1],
              LastName: nameArray[0],
              IsInstructor: false,
              Sectors: createLegInfo(trainee.CrewId, trainee)
            };
            PilotFunctions.push(pilot);
          });

          //Create instructor info
          var nameArray = instructor.name.split(/[ ]+/);
          var pilot = {
            CrewId: instructor.id,
            AimsId: instructor.aimsId,
            Name: instructor.name,
            FirstName: nameArray[1],
            LastName: nameArray[0],
            IsInstructor: true,
            Sectors: createLegInfo(instructor.id)
          };
          PilotFunctions.push(pilot);

          //make only one pilot flying
          trainingFlights.forEach(function (flight) {
            var sectors = [];
            PilotFunctions.forEach(function (pilot) {
              var pilotSector = pilot.Sectors.find(function (sec) {
                return sec.FlightId == flight.FlightId;
              });
              if (pilotSector && !pilotSector.NonApplicable) {
                sectors.push(pilotSector);
              }
            });
            if (sectors.length > 1) {
              sectors[0].isPM = true;
            }
          });

          //Apply existing saved info
          if (scope.course.PilotFunctions) {
            PilotFunctions.forEach(function (pilot) {
              var existingInfo = scope.course.PilotFunctions.find(function (x) {
                return x.CrewId == pilot.CrewId;
              });
              if (existingInfo) {
                pilot.Seat = existingInfo.Seat;
                var sectors = [];
                pilot.Sectors.forEach(function (incomingSector) {
                  var existingSector = existingInfo.Sectors.find(function (x) {
                    return x.FlightId == incomingSector.FlightId && x.Arrival == incomingSector.Arrival && x.Departure == incomingSector.Departure;
                  });
                  if (existingSector) {
                    var sector = deepCopy(existingSector);
                    sector.NonApplicable = incomingSector.NonApplicable;
                    sector.SeatOptions = incomingSector.SeatOptions;
                    if (!incomingSector.SeatOptions.includes(sector.Seat)) {
                      sector.Seat = incomingSector.Seat;
                    }
                    sectors.push(sector);
                  } else {
                    sectors.push(incomingSector);
                  }
                });
                pilot.Sectors = sectors;
              }
            });
          }
          scope.reloadPilotFunction = true;
        }
        scope.course.PilotFunctions = PilotFunctions;
        console.log(PilotFunctions);
      }
      scope.instructor = instructor;
      function deepCopy(originalObject) {
        return JSON.parse(JSON.stringify(originalObject));
      }
      function createLegInfo(crewId, trainee) {
        var legs = [];
        var traineeSeatOptions = ['Right', 'Left', 'Jumpseat'];
        var instructorSeatOptions = ['Right', 'Left', 'Jumpseat'];
        trainingFlights.forEach(function (flight) {
          var leg = {
            CrewId: crewId,
            FlightId: flight.FlightId,
            Departure: flight.Departure,
            Arrival: flight.Arrival,
            isPM: false,
            NonApplicable: trainee ? false : flight.hasMoreThanThreePilots || flight.hasTwoTrainees,
            SeatOptions: flight.hasMoreThanThreePilots || flight.hasTwoTrainees ? instructorSeatOptions : traineeSeatOptions
          };
          if (trainee) {
            leg.Seat = flight.hasMoreThanThreePilots || flight.hasTwoTrainees ? undefined : 'Right';
          } else {
            leg.Seat = flight.hasMoreThanThreePilots || flight.hasTwoTrainees ? 'Jumpseat' : 'Left';
          }
          legs.push(leg);
        });
        if (trainee) {
          // Get only the flights trainee is a participant of
          var traineeFlightIds = [];
          trainingFlights.forEach(function (flight) {
            var crewMember = flight.crew.find(function (x) {
              return x.id == trainee.CrewId;
            });
            if (crewMember && crewMember.TrainingIndicatorCode && crewMember.TrainingIndicatorCode == traineeTrainingIndicator) {
              traineeFlightIds.push(flight.FlightId);
            }
          });
          var nonActiveLegs = legs.filter(function (l) {
            return !traineeFlightIds.includes(l.FlightId);
          });
          nonActiveLegs.forEach(function (nonActiveLeg) {
            nonActiveLeg.NonApplicable = true;
          });
        }
        return legs;
      }
      function selectSeat(flight, pilot, leg) {
        var _flight$operatingPilo;
        var otherPilotId = (_flight$operatingPilo = flight.operatingPilots.find(function (x) {
          return x.CrewId !== pilot.CrewId;
        })) === null || _flight$operatingPilo === void 0 ? void 0 : _flight$operatingPilo.CrewId;
        if (otherPilotId !== "") {
          var otherPilot = scope.course.PilotFunctions.find(function (x) {
            return x.CrewId == otherPilotId;
          });
        }
        if (otherPilot != null) {
          var otherSector = otherPilot.Sectors.find(function (x) {
            return x.FlightId == leg.FlightId;
          });
        }
        if (flight.hasTwoTrainees || flight.hasMoreThanThreePilots) {
          if (leg.Seat === 'Jumpseat') {
            // Automatically select 'N/A' when the seat is 'Jumpseat'
            leg.NonApplicable = true; // Optionally, set NonApplicable to true for 'N/A'
          } else if (leg.Seat === 'Right' || leg.Seat === 'Left') {
            // Deactivate 'N/A' when the seat is 'Right' or 'Left'
            leg.NonApplicable = false;
          } else {
            // Handle other seat selections as needed
            otherSector.Seat = leg.Seat;
            leg.NonApplicable = false;
          }
        }
      }
      function selectFunction(flight, pilot, leg) {
        var otherPilotId = flight.operatingPilots.find(function (x) {
          return x.CrewId != pilot.CrewId;
        }).CrewId;
        var otherPilot = scope.course.PilotFunctions.find(function (x) {
          return x.CrewId == otherPilotId;
        });
        var otherSector = otherPilot.Sectors.find(function (x) {
          return x.FlightId == leg.FlightId;
        });
        if (leg.isPM) {
          otherSector.isPM = false;
        } else {
          otherSector.isPM = true;
        }
      }
      scope.handleFunctions = handleFunctions;
      scope.checkboxValue = false;
      function handleFunctions(flight, pilot, leg) {
        var otherPilotId = flight.operatingPilots.find(function (x) {
          return x.CrewId != pilot.CrewId;
        }).CrewId;
        var otherPilot = scope.course.PilotFunctions.find(function (x) {
          return x.CrewId == otherPilotId;
        });
        var otherSector = otherPilot.Sectors.find(function (x) {
          return x.FlightId == leg.FlightId;
        });
        if (flight.hasTwoTrainees) {
          if (leg.NonApplicable) {
            leg.Seat = "Jumpseat";
            otherSector.NonApplicable = false;
            pilot.Sectors.find(function (x) {
              return x.FlightId == leg.FlightId;
            }).isPM = '';
          } else {
            pilot.Sectors.find(function (x) {
              return x.FlightId == leg.FlightId;
            }).NonApplicable = '';
            leg.Seat = "";
          }
        }
      }
      function handleMultipleFunctions(flight, pilot, leg) {
        var operatingPilot = flight.operatingPilots.find(function (x) {
          return x.CrewId != pilot.CrewId;
        });
        var operatingPilotId;
        var otherPilot;
        var otherSector;
        if (operatingPilot) {
          operatingPilotId = operatingPilot.CrewId;
          otherPilot = scope.course.PilotFunctions.find(function (x) {
            return x.CrewId == operatingPilotId;
          });
          otherSector = otherPilot.Sectors.find(function (x) {
            return x.FlightId == leg.FlightId;
          });
        }
        if (otherSector && leg.NonApplicable) {
          leg.Seat = "Jumpseat";
          otherSector.NonApplicable = false;
          pilot.Sectors.find(function (x) {
            return x.FlightId == leg.FlightId;
          }).isPM = '';
        }
        if (!leg.NonApplicable) {
          leg.Seat = "";
        }
      }
    }
    return {
      restrict: 'E',
      templateUrl: "views/Training/pilotFunctionPanel.tpl.html",
      scope: false,
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('releasableModule', releasableModule);
  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name releasableModule
  * @restrict E
  * @description
  *    Implementation of releasable Module
  * @example
  *   Usage:
  *   <releasable-module></releasable-module>
  * @ngInject
  */
  function releasableModule(TrainingSessionFactory, $uibModal, $location) {
    function link(scope) {
      scope.Submit = Submit;
      scope.selectedTrainee = selectedTrainee;
      scope.toggleTrainee = toggleTrainee;
      scope.getRemainingCharacters = getRemainingCharacters;
      scope.leftScroll = leftScroll;
      scope.rightScroll = rightScroll;
      scope.validateGrading = validateGrading;
      scope.getTraineeClass = getTraineeClass;
      scope.openTraineeSignature = openTraineeSignature;
      scope.resetSignature = resetSignature;
      scope.close = close;
      var _isGround = scope.groundDuty != null && scope.groundDuty != null;
      var phaseId = scope.course.SubmittedSessions[0].PhaseId;
      var phase = scope.course.CrewCoursePhases.find(function (x) {
        return x.PhaseId == phaseId;
      });
      scope.settings = phase.ReleaseGrading;

      //Collect all trainee sessions that could be released
      var trainees = [];
      scope.course.SubmittedSessions.forEach(function (session) {
        session.TraineesSessions.filter(function (x) {
          return x.CouldBeReleased && !x.NeedsAdditionalRequest && !x.UnderAdditionalTraining && !x.IsStoppedTraineeCourse;
        }).forEach(function (traineeSession) {
          traineeSession.RadioModel = true; //set default realease option true
          trainees.push(traineeSession);
        });
      });
      if (trainees.length) {
        initializeTrainees(trainees, phase);
      }
      scope.phase = phase;
      scope.trainees = trainees;
      function initializeTrainees(trainees, phase) {
        scope.selectedTraineeBadge = {
          crewId: trainees[0].CrewId
        };

        // Set Release Grading
        var releaseCompetences = phase.ReleaseGrading.Competences;
        releaseCompetences.forEach(function (competence) {
          competence.MandatorySub = setSubCompetenceValues(competence.MandatorySubCompetences);
          competence.OptionalSub = setSubCompetenceValues(competence.OptionalSubCompetences);

          //Filter out from optional the ones common with mandatory
          competence.OptionalSub = competence.OptionalSub.filter(function (c) {
            return !competence.MandatorySub.includes(c);
          });
        });

        //Set Trainee Competences
        trainees.forEach(function (traineeSession) {
          var competences = [];
          releaseCompetences.forEach(function (competence) {
            competences.push(JSON.parse(JSON.stringify(competence)));
          });
          traineeSession.ReleaseGrading.Competences = competences;
        });

        //Initialize validation
        trainees.forEach(function (traineeSession) {
          traineeSession.ReleaseGrading.isGradeValid = scope.settings.GradeType == "NotSet";
          traineeSession.ReleaseGrading.isReleaseGradingValid = scope.settings.Competences.length == 0;
        });

        //For ground: check aircraft visits
        if (_isGround && phase.AircraftTypes.length) {
          trainees.forEach(function (trainee) {
            var visitedAircrafts = trainee.AllVisitedAcTypes;
            var pendingAircrafts = [];
            phase.AircraftTypes.forEach(function (type) {
              var array = type.split(',');

              //if arvi requirement is not met
              if (!array.some(function (x) {
                return visitedAircrafts.includes(x);
              })) {
                var pendingArviList = [];
                if (array.length > 1) {
                  array.forEach(function (arvi) {
                    pendingArviList.push(arvi);
                  });
                } else {
                  pendingArviList.push(array[0]);
                }
                pendingAircrafts.push(pendingArviList);
              }
            });
            trainee.pendingAircrafts = pendingAircrafts;
            trainee.ShowReleaseWarning = trainee.pendingAircrafts.length > 0;
          });
        }
        scope.showReleaseWarning = trainees.some(function (x) {
          return x.ShowReleaseWarning;
        });
      }
      function selectedTrainee() {
        return function (trainee) {
          var showTrainee = false;
          if (trainee.CrewId === scope.selectedTraineeBadge.crewId) {
            showTrainee = true;
          }
          return showTrainee;
        };
      }
      function close() {
        scope.modalInstance.close();
      }
      function toggleTrainee() {
        if (!scope.selectedTraineeBadge.crewId) {
          scope.selectedTraineeBadge.crewId = scope.trainees.find(function (x) {
            return x.RadioModel;
          }).CrewId;
        }
        var selectedCrewId = scope.selectedTraineeBadge.crewId;
        var selectedTrainee = scope.trainees.find(function (x) {
          return x.CrewId == selectedCrewId;
        });
        if (selectedTrainee && !selectedTrainee.RadioModel) {
          if (scope.trainees.find(function (x) {
            return x.RadioModel;
          })) {
            scope.selectedTraineeBadge.crewId = scope.trainees.find(function (x) {
              return x.RadioModel;
            }).CrewId;
          } else {
            scope.selectedTraineeBadge.crewId = null;
          }
        }
      }
      function getTraineeClass(crewId) {
        var textClass = "";
        var trainee = scope.trainees.find(function (x) {
          return x.CrewId == crewId;
        });

        //Validate Release grading
        var isReleaseGradingValid = trainee.ReleaseGrading.isGradeValid;
        var isReleaseCompetencesValid = trainee.ReleaseGrading.isCompetenceValid;
        if (isReleaseGradingValid && isReleaseCompetencesValid) {
          textClass = "bg-green text-white";
        } else {
          textClass = "bg-amber text-white";
        }
        return textClass;
      }
      function Submit() {
        if (!isValidForm()) {
          scope.modalInstance = $uibModal.open({
            templateUrl: 'views/Training/dlgSubmitValidation.html',
            scope: scope,
            backdrop: 'static',
            keyboard: false,
            size: 'lg'
          });
        } else {
          scope.modalInstance = $uibModal.open({
            templateUrl: 'views/Training/dlgSign.html',
            controller: 'ReleaseSignatureModalCtrl',
            backdrop: 'static',
            keyboard: false,
            size: 'md',
            resolve: {
              courseId: function courseId() {
                return scope.course.Id;
              },
              isGround: function isGround() {
                return _isGround;
              },
              confirmationMsg: function confirmationMsg() {
                return scope.settings.ConfirmationMessage;
              },
              requiresInstructorSignature: function requiresInstructorSignature() {
                return scope.settings.InstructorSignature;
              },
              trainees: function trainees() {
                return scope.trainees.filter(function (x) {
                  return x.RadioModel;
                });
              },
              submitRelease: function submitRelease() {
                return SubmitRelease;
              }
            }
          });
          scope.modalInstance.result.then(function (result) {
            if (result.success) {
              $location.path("/");
            }
          });
        }
      }
      function SubmitRelease(password) {
        var submittedSessions = {
          SignaturePassword: password,
          TraineesSessions: trainees.filter(function (x) {
            return x.RadioModel;
          })
        };
        return TrainingSessionFactory.releaseSession(submittedSessions);
      }
      function validateGrading(trainee) {
        trainee.ReleaseGrading.isGradeValid = trainee.ReleaseGrading.Grade != null && trainee.ReleaseGrading.Grade != undefined;
      }

      /**
      * Calculate remaining characters for comment input
      * @param {string} text 
      * @param {number} max 
      */
      function getRemainingCharacters(text, max) {
        if (typeof text === "undefined" || text === null) return '';
        if (typeof max === "undefined" || max === null || max < 0 || !max) max = 4000;
        var length = text.length;
        return 'characters left: ' + (max - length);
      }
      function setSubCompetenceValues(current) {
        var updated = [];
        var first = parseInt(current[0], 10);
        var last = current[current.length - 1];
        if (first) {
          for (var i = first; i <= last; i++) {
            updated.push(i);
          }
        }
        return updated;
      }
      function leftScroll() {
        document.querySelector('.horizontal-scroll').scrollLeft -= 500;
      }
      function rightScroll() {
        document.querySelector('.horizontal-scroll').scrollLeft += 500;
      }
      function isValidForm() {
        /*Requirements before split release
            1. OnLine Mode
            2. Valid Release Grading
            3. Trainee Signature
        */

        var selectedTrainee = scope.trainees.find(function (x) {
          return x.CrewId == scope.selectedTraineeBadge.crewId;
        });
        var isValid = false;
        var info = {
          border: "",
          icon: "",
          msg: ""
        };
        if (!window.navigator.onLine) {
          info = {
            border: "border-left-red",
            icon: "fa-warning text-red",
            msg: "  <strong>Online mode</strong> is required in order to submit a training. <p>Check your connection and try again!</p>"
          };
        } else if (scope.settings.TraineeSignature && scope.trainees.filter(function (x) {
          return x.RadioModel;
        }).some(function (x) {
          return !x.Authorized;
        })) {
          if (selectedTrainee && !selectedTrainee.Authorized) {
            info = {
              border: "border-left-orange",
              icon: "fa-pencil-square-o text-orange",
              msg: "<b>" + selectedTrainee.TraineeName + "</b> needs to sign the form!",
              scrollToTop: false
            };
          } else {
            info = {
              border: "border-left-orange",
              icon: "fa-warning text-orange",
              msg: "All trainees need to sign their forms!",
              scrollToTop: true
            };
          }
        } else if (!isGradingValid()) {
          info = {
            border: "border-left-orange",
            icon: "fa-warning text-orange",
            msg: ""
          };
          if (selectedTrainee && !selectedTrainee.ReleaseGrading.isCompetenceValid) {
            info.msg = "You need to grade all competences for <b>" + selectedTrainee.TraineeName + "</b> before submitting!";
          } else if (selectedTrainee && !selectedTrainee.ReleaseGrading.isGradeValid) {
            info.msg = "You need to grade <b>" + selectedTrainee.TraineeName + "</b> before submitting!";
          } else if (!scope.gradingValidationInfo.isReleaseCompetencesValid || !scope.gradingValidationInfo.isReleaseGradingValid) {
            info.msg = "You need to grade all trainees before submitting!";
          }
        } else {
          isValid = true;
        }
        scope.info = info;
        return isValid;
      }
      function validateTraineeForm(trainee) {
        /*Requirements before trainee signature
            1. OnLine Mode
            2. Valid Trainee Release Grading
        */

        var isValid = false;
        var info = {
          border: "",
          icon: "",
          msg: ""
        };
        if (!window.navigator.onLine) {
          info = {
            border: "border-left-red",
            icon: "fa-warning text-red",
            msg: "  <strong>Online mode</strong> is required in order to submit a training. <p>Check your connection and try again!</p>"
          };
        } else if (!trainee.ReleaseGrading.isCompetenceValid) {
          info = {
            border: "border-left-orange",
            icon: "fa-warning text-orange",
            msg: "You need to grade all competences!"
          };
        } else if (!trainee.ReleaseGrading.isGradeValid) {
          info = {
            border: "border-left-orange",
            icon: "fa-warning text-orange",
            msg: "You need to select an overall grade!"
          };
        } else {
          isValid = true;
        }
        scope.info = info;
        return isValid;
      }
      function isGradingValid() {
        var isReleaseGradingValid = scope.settings.GradeType == "NotSet";
        var isReleaseCompetencesValid = scope.settings.Competences.length == 0;
        if (!isReleaseGradingValid) isReleaseGradingValid = !scope.trainees.filter(function (x) {
          return x.RadioModel;
        }).some(function (x) {
          return !x.ReleaseGrading.isGradeValid;
        });
        if (!isReleaseCompetencesValid) isReleaseCompetencesValid = !scope.trainees.filter(function (x) {
          return x.RadioModel;
        }).some(function (x) {
          return !x.ReleaseGrading.isCompetenceValid;
        });
        scope.gradingValidationInfo = {
          isReleaseGradingValid: isReleaseGradingValid,
          isReleaseCompetencesValid: isReleaseCompetencesValid
        };
        return isReleaseGradingValid && isReleaseCompetencesValid;
      }
      function openTraineeSignature(_trainee) {
        //Enter signature mode : trainee form becomes read-only
        if (!_trainee.Authorized) {
          //Trainee can sign only if his form is valid
          if (!validateTraineeForm(_trainee)) {
            scope.modalInstance = $uibModal.open({
              templateUrl: 'views/Training/dlgSubmitValidation.html',
              scope: scope,
              backdrop: 'static',
              keyboard: false,
              size: 'lg'
            });
          } else {
            _trainee.Session = {
              Authorized: false
            };
            _trainee.Name = _trainee.TraineeName;
            scope.modalInstance = $uibModal.open({
              templateUrl: 'views/Training/dlgTraineeSignature.html',
              controller: 'TraineeSignatureModalCtrl',
              scope: scope,
              backdrop: 'static',
              keyboard: false,
              size: 'md',
              resolve: {
                trainee: function trainee() {
                  return _trainee;
                },
                signatureSuccess: function signatureSuccess() {
                  return function () {
                    _trainee.Authorized = true;
                  };
                }
              }
            });
          }
        }
      }
      function resetSignature(_trainee2) {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/Training/dlgResetSignature.html',
          controller: 'TraineeSignatureModalCtrl',
          scope: scope,
          backdrop: 'static',
          keyboard: false,
          size: 'md',
          resolve: {
            trainee: function trainee() {
              return _trainee2;
            },
            signatureSuccess: function signatureSuccess() {
              return function () {};
            }
          }
        });
        modalInstance.result.then(function (confirm) {
          if (confirm) {
            _trainee2.Authorized = false;
            _trainee2.Session.Authorized = false;
          }
        });
      }
    }
    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/Training/releasable-module.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  a3_pilot_reports.directive('releaseWarning', releaseWarning);

  /**
  * @memberof CabinReports
  * @ngdoc directive
  * @name releaseWarning
  * @restrict E
  * @description
  *   Soft rules alert in release
  * @example
  *   Usage:
  *   <release-warning></release-warning>
  * @ngInject
  */

  function releaseWarning() {
    function link(scope, attrs) {
      scope.warningTrainees = scope.trainees.filter(function (x) {
        return !x.Session.Absent && x.ShowReleaseWarning;
      });
      scope.filterSelectedTrainee = filterSelectedTrainee;
      function filterSelectedTrainee() {
        return function (trainee) {
          var showTrainee = false;
          if (scope.selectedTrainee) {
            showTrainee = trainee.CrewId == scope.selectedTrainee.CrewId;
          }
          return showTrainee;
        };
      }
    }
    return {
      restrict: 'E',
      templateUrl: "views/Training/releaseWarning.tpl.html",
      scope: false,
      terminal: true,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('ReleaseSignatureModalCtrl', ReleaseSignatureModalCtrl);
  /**
   * @memberof PilotReports
   * @ngdoc controller
   * @name SignatureModalCtrl
   * @description 
   * Shows Show Signature 
   * @ngInject
   */

  function ReleaseSignatureModalCtrl($scope, $routeParams, CourseFactory, $uibModalInstance, courseId, isGround, confirmationMsg, requiresInstructorSignature, trainees, submitRelease) {
    $scope.close = close;
    $scope.submit = submit;
    $scope.confirm = confirm;
    $scope.confirmAircraft = confirmAircraft;
    $scope.errorMessage = "";
    $scope.successMessage = "";
    $scope.responseText = null;
    $scope.responseHasErrors = null;
    $scope.success = false;
    $scope.isLoading = false;
    $scope.formData = {};
    $scope.requiredSignature = requiresInstructorSignature;
    $scope.isConfirmed = true;
    $scope.finalPendigArVis = [];
    if (isGround && hasPendingAircraftVisits()) {
      $scope.aircraftVisits = true;
    } else if (confirmationMsg) {
      $scope.confirmationMsg = confirmationMsg;
      $scope.isConfirmed = false;
    } else {
      if (!requiresInstructorSignature) {
        //if signature isn't required continue with submit 
        $scope.isLoading = true;
        submit();
      }
    }
    function hasPendingAircraftVisits() {
      var released = trainees.filter(function (x) {
        return x.RadioModel;
      });
      var pendingVisits = released.some(function (x) {
        return x.pendingAircrafts && x.pendingAircrafts.length > 0;
      });
      if (pendingVisits) {
        var maxLength = 0;
        released.forEach(function (trainee) {
          if (trainee.pendingAircrafts.length > maxLength) {
            var maxList = trainee.pendingAircrafts;
            maxLength = maxList.length;
            $scope.finalPendigArVis = trainee.pendingAircrafts;
          }
        });
      }
      return pendingVisits;
    }
    function confirm() {
      $scope.isConfirmed = true;
      if (!requiresInstructorSignature) {
        //if signature isn't required continue with submit 
        $scope.isLoading = true;
        submit();
      }
    }
    function confirmAircraft() {
      $scope.aircraftVisits = false;
      if (confirmationMsg) {
        $scope.confirmationMsg = confirmationMsg;
        $scope.isConfirmed = false;
      }
    }
    function submit() {
      $scope.errorMessage = "";
      $scope.successMessage = "";
      $scope.isLoading = true;
      $scope.success = false;
      var signaturePassword = $scope.formData.password;
      if (!signaturePassword && requiresInstructorSignature) {
        $scope.isLoading = false;
        $scope.errorMessage = "Signature is required. Please enter your password.";
      } else {
        submitRelease(signaturePassword).then(function (data) {
          $scope.isLoading = false;
          var errorMessage = data.data.errorMessage;
          $scope.successMessage = "Training has been submitted.";

          //always show errorMessage even if success is true
          if (errorMessage && errorMessage.length > 0) {
            $scope.errorMessage = errorMessage;

            //not Release Trainees
            var responseTrainees = data.data.data.data;
            var responseTraineeCrewIds = responseTrainees.map(function (trainee) {
              return trainee.CrewId;
            });
            $scope.traineeInfo = trainees.filter(function (x) {
              return responseTraineeCrewIds.includes(x.CrewId);
            });
          } else {
            $scope.errorMessage = null;
          }
          CourseFactory.setCourseOutdated(courseId);
          $scope.success = true;
        })["catch"](function (data) {
          $scope.isLoading = false;
          if (data.data && data.data.errorMessage) {
            $scope.errorMessage = data.data.errorMessage;
          } else {
            $scope.errorMessage = "Failed to save Training Session";
          }
        });
      }

      // clear password
      $scope.formData.password = "";
    }

    /**
     * Close the modal
     * @memberof SignModalCtrl
     */
    function close() {
      var result = {
        "success": $scope.success
      };
      $uibModalInstance.close(result);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('SignatureModalCtrl', SignatureModalCtrl);
  /**
   * @memberof PilotReports
   * @ngdoc controller
   * @name SignatureModalCtrl
   * @description 
   * Shows Show Signature 
   * @ngInject
   */

  function SignatureModalCtrl($scope, $routeParams, $uibModalInstance, TrainingSessionFactory, FlightSessionFactory, GroundDutyFactory, CrewRouteFactory, CourseFactory, courseId, date, dutyId, dutyNo, dutyDay, confirmationMsg, requiresInstructorSignature, trainees, submitSession, releaseGrading, isReleased, needsAdditionalTraining) {
    $scope.close = close;
    $scope.submit = submit;
    $scope.confirm = confirm;
    $scope.confirmSubmit = confirmSubmit;
    $scope.releaseSubmit = releaseSubmit;
    $scope.confirmAircraft = confirmAircraft;
    $scope.errorMessage = "";
    $scope.successMessage = "";
    $scope.responseText = null;
    $scope.responseHasErrors = null;
    $scope.success = false;
    $scope.isLoading = false;
    $scope.withGrading = false;
    $scope.formData = {};
    var requiredSignature = requiresInstructorSignature;
    $scope.requiredSignature = requiredSignature;
    $scope.releaseWarning = false;
    $scope.isConfirmed = true;
    $scope.releaseGrading = releaseGrading;
    $scope.finalPendigArVis = [];
    $scope.needsAdditionalTraining = needsAdditionalTraining;
    var isGroundDuty = false;
    if (dutyId) {
      isGroundDuty = true;
    }
    if (releaseNotSelected()) {
      $scope.releaseWarning = true;
    } else if (isGroundDuty && hasPendingAircraftVisits()) {
      $scope.aircraftVisits = true;
    } else if (confirmationMsg && isReleased) {
      $scope.confirmationMsg = confirmationMsg;
      $scope.isConfirmed = false;
    } else {
      if (!requiresInstructorSignature) {
        //if signature isn't required continue with submit 
        $scope.isLoading = true;
        submit();
      }
    }
    function releaseNotSelected() {
      var allAvailable = !trainees.filter(function (x) {
        return !x.Session.Absent;
      }).some(function (x) {
        return !x.AvailableRelease;
      });
      var notReleased = trainees.filter(function (x) {
        return !x.Session.Absent;
      }).some(function (x) {
        return !x.Session.Released;
      });
      return allAvailable && notReleased;
    }
    function hasPendingAircraftVisits() {
      var released = !trainees.filter(function (x) {
        return !x.Session.Absent;
      }).some(function (x) {
        return !x.Session.Released;
      }) || $scope.withGrading;
      var pendingVisits = released && trainees.filter(function (x) {
        return !x.Session.Absent;
      }).some(function (x) {
        return x.pendingAircrafts && x.pendingAircrafts.length > 0;
      });
      if (pendingVisits) {
        var maxLength = 0;
        trainees.filter(function (x) {
          return !x.Session.Absent;
        }).forEach(function (trainee) {
          if (trainee.pendingAircrafts.length > maxLength) {
            var maxList = trainee.pendingAircrafts;
            maxLength = maxList.length;
            $scope.finalPendigArVis = trainee.pendingAircrafts;
          }
        });
      }
      return pendingVisits;
    }
    function confirm() {
      $scope.isConfirmed = true;
      if (!requiresInstructorSignature) {
        //if signature isn't required continue with submit 
        $scope.isLoading = true;
        submit();
      }
    }
    function confirmSubmit() {
      $scope.releaseWarning = false;
      if (isGroundDuty && hasPendingAircraftVisits()) {
        $scope.aircraftVisits = true;
      }
    }
    function confirmAircraft() {
      $scope.aircraftVisits = false;
      if (confirmationMsg) {
        $scope.confirmationMsg = confirmationMsg;
        $scope.isConfirmed = false;
      }
    }
    function releaseSubmit() {
      $scope.withGrading = true;
      $scope.releaseWarning = false;
      if (hasPendingAircraftVisits()) {
        $scope.aircraftVisits = true;
      } else if (confirmationMsg) {
        $scope.confirmationMsg = confirmationMsg;
        $scope.isConfirmed = false;
      }
    }
    function submit() {
      $scope.errorMessage = "";
      $scope.successMessage = "";
      $scope.isLoading = true;
      $scope.success = false;
      var signaturePassword = $scope.formData.password;
      if (!signaturePassword && requiredSignature) {
        $scope.isLoading = false;
        $scope.errorMessage = "Signature is required. Please enter your password.";
      } else {
        submitSession(signaturePassword, $scope.withGrading).then(function (data) {
          $scope.isLoading = false;
          var errorMessage = data.data.errorMessage;
          $scope.successMessage = "Training has been submitted.";

          //always show errorMessage even if success is true
          if (errorMessage && errorMessage.length > 0) {
            $scope.errorMessage = errorMessage;

            //not Release Trainees
            var responseTrainees = data.data.data.data;
            var responseTraineeCrewIds = responseTrainees.map(function (trainee) {
              return trainee.CrewId;
            });
            $scope.traineeInfo = trainees.filter(function (x) {
              return responseTraineeCrewIds.includes(x.CrewId);
            });
          } else {
            $scope.errorMessage = null;
          }
          if (dutyId) {
            //isGround
            TrainingSessionFactory.remove(courseId, date, dutyId);
            GroundDutyFactory.setCourseCompleted(dutyId, courseId);
          } else {
            //isFlight
            FlightSessionFactory.remove(courseId, date, dutyNo, dutyDay);
            CrewRouteFactory.setCourseCompleted(dutyNo, dutyDay, courseId, date);
          }
          CourseFactory.setCourseOutdated(courseId);
          $scope.success = true;
        })["catch"](function (data) {
          $scope.isLoading = false;
          if (data.data && data.data.errorMessage) {
            $scope.errorMessage = data.data.errorMessage;
          } else {
            $scope.errorMessage = "Failed to save Training Session";
          }
        });
      }

      // clear password
      $scope.formData.password = "";
    }

    /**
     * Close the modal
     * @memberof SignModalCtrl
     */
    function close() {
      var result = {
        "success": $scope.success
      };
      $uibModalInstance.close(result);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('syllabusItemHeader', syllabusItemHeader);
  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name syllabusItemHeader
  * @restrict E
  * @description
  *   Panel heading for syllabus items
  * @example
  *   Usage:
  *   <syllabus-item-header></syllabus-item-header>
  * @ngInject
  */
  function syllabusItemHeader() {
    function link(scope, element, attrs) {
      scope.selectTry = selectTry;
      scope.selectGrading = selectGrading;

      //find first not ReadOnly try
      scope.pendingAttempt = scope.item.Tries.find(function (x) {
        return x.isFirstTry;
      });
      scope.firstTry = scope.item.Tries[0];
      function selectTry() {
        if (scope.pendingAttempt) {
          scope.itemSelection();
        }
      }
      function selectGrading() {
        scope.gradingSelection();
      }
    }
    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/Training/syllabus-item-header.tpl.html',
      scope: {
        item: "=",
        itemSelection: "&onItemSelection",
        gradingSelection: "&onGradingSelection"
      },
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('syllabus', syllabus);
  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name certificates
  * @restrict E
  * @description
  *   Implementation of syllabus
  * @example
  *   Usage:
  *   <syllabus></syllabus>
  * @ngInject
  */
  function syllabus(TrainingSessionFactory, FlightSessionFactory, $timeout) {
    function link(scope, element, attrs) {
      var isGround = false;
      var courseId = scope.dutyCourse.Id;
      if (scope.groundDuty) {
        isGround = true;
        var date = scope.groundDuty.DutyDateS;
        var dutyId = scope.groundDuty.Id;
      } else {
        var date = scope.crewRouteDuty.date;
        var dutyNo = scope.crewRouteDuty.DutyNo;
        var dutyDay = scope.crewRouteDuty.DutyDay;
      }
      scope.updateTraineesSyllabus = updateTraineesSyllabus;
      scope.selectTry = selectTry;
      scope.updateTry = updateTry;
      scope.oneAtATime = true;
      scope.addTry = addTry;
      scope.removeTry = removeTry;
      scope.setPanelStyle = setPanelStyle;
      scope.selectTryFromHeader = selectTryFromHeader;
      scope.gradeFromHeader = gradeFromHeader;
      scope.nonGradableSyllabus = scope.traineeSyllabi[0].Items.every(function (item) {
        return !item.IsGradable;
      });
      scope.personalizedRemarks = false;
      scope.showPersonalizedRemarks = false;
      scope.personalizedRemarksChanged = personalizedRemarksChanged;
      scope.addTraineeRemarksRow = addTraineeRemarksRow;
      scope.traineesPersonalizedRemarks = [];
      scope.updatePersonalizeRemarks = updatePersonalizeRemarks;
      scope.deleteTraineeRemarks = deleteTraineeRemarks;
      scope.isAddRemarksButtonDisabled = isAddRemarksButtonDisabled;
      scope.traineeValueChanged = traineeValueChanged;
      scope.hasSelectedTrainee = false;
      scope.traineeSyllabi.forEach(function (traineeSyllabus) {
        traineeSyllabus.Items.forEach(function (syllabusItem) {
          syllabusItem.usePersonalizedRemarks = false;
          syllabusItem.traineesPersonalizedRemarks = [];
          syllabusItem.Tries.forEach(function (attempt) {
            //Check if default grade exists & set status
            if (syllabusItem.IsGradable && !attempt.isReadOnly) {
              itemAutoSelection(syllabusItem, attempt); //select item depending on grade existence
            }
          });

          setPanelStyle(syllabusItem); //ui depending on validation & status
          updateTraineesSyllabus(syllabusItem, traineeSyllabus); //copy values to all trainee syllabi 
        });
      });

      //Multiple syllabi - Get session to store competence grading
      if (scope.traineeSyllabi.length > 1) {
        scope.traineeSyllabi.forEach(function (traineeSyllabus) {
          var crewId = traineeSyllabus.TraineeIds[0];
          var trainee = scope.trainees.find(function (x) {
            return x.CrewId == crewId;
          });
          traineeSyllabus.TraineeName = trainee.Name;
          traineeSyllabus.TraineeAimsId = trainee.AimsId;
        });
      }
      function gradeFromHeader(syllabus, syllabusItem) {
        var firstPendingTry = syllabusItem.Tries.filter(function (x) {
          return !x.isReadOnly;
        })[0];
        updateTry(syllabus, syllabusItem, firstPendingTry);
        setPanelStyle(syllabusItem);
        updateTraineesSyllabus(syllabusItem, syllabus);
        triggerSyllabusClick();
      }
      function selectTryFromHeader(syllabus, syllabusItem) {
        var firstPendingTry = syllabusItem.Tries.filter(function (x) {
          return !x.isReadOnly;
        })[0];
        selectTry(syllabus, syllabusItem, firstPendingTry);
        if (isGround) {
          TrainingSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyId, console.log, function (e) {
            console.log(e);
          });
        } else {
          FlightSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyNo, dutyDay, console.log, function (e) {
            console.log(e);
          });
        }
        triggerSyllabusClick();
      }
      function triggerSyllabusClick() {
        //preventDefault() and stopPropagation() prevents setReleaseStatus() to be triggered
        $timeout(function () {
          var el = document.getElementById('syllabus');
          angular.element(el).triggerHandler('click');
        }, 0);
      }
      function selectTry(syllabus, syllabusItem, attempt) {
        attempt.Selected = !attempt.Selected;
        syllabusItem.Selected = syllabusItem.Tries.filter(function (t) {
          return !t.isReadOnly;
        }).some(function (t) {
          return t.Selected;
        });
        setPanelStyle(syllabusItem);
        updateTraineesSyllabus(syllabusItem, syllabus);
      }
      function updateTry(syllabus, syllabusItem, attempt) {
        if (syllabusItem.IsGradable) {
          itemAutoSelection(syllabusItem, attempt); //select item depending on grade existence
        }

        setPanelStyle(syllabusItem); //ui depending on validation & status
        updateTraineesSyllabus(syllabusItem, syllabus); //copy values to all trainee syllabi 
        updateSession(); //save in IndexDb
      }

      function itemAutoSelection(syllabusItem, attempt) {
        var hasCompetencesGrading = attempt.TryGrading.Competences.some(function (x) {
          return x.Grading;
        });
        if (attempt.TryGrading.Grade || hasCompetencesGrading) {
          attempt.Selected = true;
          syllabusItem.Selected = true;
        } else {
          attempt.Selected = false;
          syllabusItem.Selected = false;

          //Check if any of the tries has grading - If not, deselect item
          var pendingTries = syllabusItem.Tries.filter(function (x) {
            return !x.isReadOnly;
          }); //filter out history tries
          for (var i = 0; i < pendingTries.length; i++) {
            var itemTry = pendingTries[i];
            var tryCompetenceGrading = itemTry.TryGrading.Competences.some(function (x) {
              return x.Grading;
            });
            if (itemTry.TryGrading.Grade || tryCompetenceGrading) {
              syllabusItem.Selected = true;
              break;
            }
          }
        }
      }
      function setPanelStyle(item) {
        var historyTriesCount = item.Tries.filter(function (x) {
          return x.isReadOnly;
        }).length;
        var newTriesCount = item.Tries.filter(function (x) {
          return !x.isReadOnly && x.Selected;
        }).length;
        item.TriesPerformedCount = historyTriesCount + newTriesCount;
        var completedItem = item.TriesPerformedCount >= item.MandatoryCount;
        if (item.MandatoryCount == 0) {
          //non-mandatory items are considered completed if performed at least once
          completedItem = item.TriesPerformedCount >= 1;
        }
        var invalidItem = false;
        var nonCompetentItem = false;
        if (item.IsGradable && item.Selected) {
          var gradingType = item.GradeType; //Numeric or Outcome or Competences
          var traineeSelectedTries = item.Tries.filter(function (x) {
            return x.Selected;
          });
          traineeSelectedTries.forEach(function (selectedTry) {
            var invalidGrading = gradingType != "Competences" && !selectedTry.TryGrading.Grade;
            var invalidCompetences = gradingType == "Competences" && !selectedTry.TryGrading.isCompetenceValid;
            if (invalidGrading || invalidCompetences) {
              invalidItem = true;
            }
          });
          if (!invalidItem && gradingType == "Outcome" && item.MandatoryCount > 0) {
            // Get the grades from the tries
            var tries = item.Tries.map(function (t) {
              return t.TryGrading.Grade;
            });
            var mandatoryTries = item.MandatoryCount;
            var competentCount = 0;
            var nonCompetentCount = 0;
            var isCompetent = false;
            for (var i = 0; i < tries.length; i++) {
              if (tries[i] === 'Pass') {
                competentCount++;
                nonCompetentCount = 0; // reset non-competent count
                if (competentCount >= mandatoryTries) {
                  item.PanelClass = 'panel-border-left-green';
                  isCompetent = true;
                }
              } else {
                if (tries[i] === 'Fail') {
                  nonCompetentCount++;
                  competentCount = 0;
                  if (nonCompetentCount >= mandatoryTries) {
                    item.PanelClass = 'panel-border-left-pink';
                    nonCompetentItem = true;
                    break; // Exit if mandatory fails are reached
                  }
                }
              }
            }

            if (nonCompetentItem) {
              item.PanelClass = 'panel-border-left-pink';
            } else if (isCompetent) {
              item.PanelClass = 'panel-border-left-green';
            } else {
              item.PanelClass = 'panel-border-left-blue';
            }
            return;
          }
          if (!invalidItem && gradingType != "Outcome" && traineeSelectedTries.some(function (t) {
            return t.TryGrading.Grade === "Fail";
          })) {
            nonCompetentItem = true;
          }
        }
        if (completedItem && !nonCompetentItem) {
          item.PanelClass = 'panel-green panel-border-left-green ';
        } else if (completedItem && nonCompetentItem) {
          item.PanelClass = 'panel-border-left-pink';
        } else {
          item.PanelClass = 'panel-border-left-blue ';
        }
        if (invalidItem) {
          item.PanelClass = 'panel-border-left-orange ';
        }
      }
      function updateTraineesSyllabus(item, syllabus) {
        var crewIds = syllabus.TraineeIds;
        scope.trainees.filter(function (x) {
          return crewIds.includes(x.CrewId);
        }).forEach(function (trainee) {
          var sessionItem = trainee.Session.Items.find(function (sessionItem) {
            return item.Id == sessionItem.Id;
          });
          sessionItem.RepeatRequired = item.RepeatRequired;
          sessionItem.Selected = item.Selected;
          sessionItem.PhaseId = item.PhaseId;
          sessionItem.Tries = deepCopy(item.Tries);
          sessionItem.SyllabusItemId = item.Id;
          sessionItem.TriesPerformedCount = item.TriesPerformedCount;
        });
        updatePersonalizeRemarks(item);
      }
      function deepCopy(originalObject) {
        return JSON.parse(JSON.stringify(originalObject));
      }
      function addTry(item, syllabus) {
        var competences = deepCopy(item.Competences);
        var newTry = {
          Comments: null,
          ActionNo: item.Tries.length + 1,
          Selected: true,
          TryGrading: {
            Grade: null,
            Competences: competences,
            GradeType: item.GradeType
          }
        };
        item.Selected = true;
        item.Tries.push(newTry);
        setPanelStyle(item);
        updateTraineesSyllabus(item, syllabus);
      }
      function removeTry(item, syllabus) {
        item.Tries.pop();
        if (!item.Tries.filter(function (x) {
          return !x.isReadOnly;
        }).length) {
          item.Selected = false;
        }
        setPanelStyle(item);
        updateTraineesSyllabus(item, syllabus);
      }
      function updateSession() {
        if (isGround) {
          TrainingSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyId, console.log, function (e) {
            console.log(e);
          });
        } else {
          FlightSessionFactory.updateSession(scope.trainees, scope.course, courseId, date, dutyNo, dutyDay, console.log, function (e) {
            console.log(e);
          });
        }
      }

      // if syllabus is non-gradable instructor can add persomalized trainee remarks
      function addTraineeRemarksRow(syllabusItem, selectedTraineeId) {
        if (selectedTraineeId) {
          var selectedTrainee = scope.trainees.find(function (trainee) {
            return trainee.CrewId == selectedTraineeId;
          });
          if (selectedTrainee) {
            scope.selectedTraineeName = selectedTrainee.Name;
            var newTraineeRemarks = {
              id: selectedTrainee.CrewId,
              name: selectedTrainee.Name,
              remarks: "",
              // Add an empty remarks field for the new trainee
              syllabusItemId: syllabusItem.Id
            };
            syllabusItem.selectedTrainee = newTraineeRemarks;
            syllabusItem.traineesPersonalizedRemarks.push(newTraineeRemarks);
          }
        }
      }
      scope.getAvailableTrainees = function (allTrainees, item) {
        if (!item || !item.traineesPersonalizedRemarks) {
          return allTrainees;
        }

        // Get the IDs of already selected trainees
        var selectedTraineeIds = item.traineesPersonalizedRemarks.map(function (remark) {
          return remark.id;
        });

        // Filter out the selected trainees
        return allTrainees.filter(function (trainee) {
          return !selectedTraineeIds.includes(trainee.CrewId);
        });
      };
      function personalizedRemarksChanged(item) {
        if (item.usePersonalizedRemarks) {
          item.showPersonalizedRemarks = true;
          item.Tries.forEach(function (itemTry) {
            itemTry.Comments = ""; // Clear comments when enabling personalized remarks
          });
        } else {
          item.showPersonalizedRemarks = false;
          item.usePersonalizedRemarks = false;
          scope.traineesPersonalizedRemarks = [];
        }
      }
      function updatePersonalizeRemarks(item) {
        if (item.traineesPersonalizedRemarks && item.traineesPersonalizedRemarks.length > 0) {
          item.traineesPersonalizedRemarks.forEach(function (personalizedRemark) {
            var trainee = scope.trainees.find(function (x) {
              return x.CrewId == personalizedRemark.id;
            });
            if (trainee) {
              var sessionItem = trainee.Session.Items.find(function (item) {
                return item.SyllabusItemId == personalizedRemark.syllabusItemId;
              });
              if (sessionItem && sessionItem.Tries.length > 0) {
                sessionItem.Tries[0].Comments = personalizedRemark.remarks;
              }
            }
          });
        }
      }
      function deleteTraineeRemarks(traineeRemarks, item) {
        if (item) {
          // Remove the trainee remarks from the array
          var index = item.traineesPersonalizedRemarks.findIndex(function (remarks) {
            return remarks.id === traineeRemarks.id;
          });
          if (index !== -1) {
            item.traineesPersonalizedRemarks.splice(index, 1);

            // After deleting, sync the changes with the Session
            updatePersonalizeRemarks(item);

            // Enable the deleted trainee for the current item
            item.selectedTrainee = null;
          } else {
            console.error("Trainee remarks not found for deletion.");
          }
        } else {
          console.error("Syllabus item not found for the trainee remarks.");
        }
      }
      function isAddRemarksButtonDisabled(item) {
        return !scope.getAvailableTrainees(scope.trainees, item).length;
      }
      ;
      function traineeValueChanged(selectedTrainee) {
        if (selectedTrainee) {
          scope.hasSelectedTrainee = true;
        } else {
          scope.hasSelectedTrainee = false;
        }
      }
    }
    return {
      restrict: 'E',
      terminal: false,
      templateUrl: 'views/Training/syllabus.tpl.html',
      scope: false,
      link: link
    };
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.controller('TraineeSignatureModalCtrl', TraineeSignatureModalCtrl);
  /**
   * @memberof PilotReports
   * @ngdoc controller
   * @name TraineeSignatureModalCtrl
   * @description 
   * Shows Show Signature 
   * @ngInject
   */

  function TraineeSignatureModalCtrl($scope, $timeout, $uibModalInstance, trainee, TrainingSessionFactory, signatureSuccess) {
    $scope.close = close;
    $scope.confirmReset = confirmReset;
    $scope.traineeSign = traineeSign;
    $scope["continue"] = continueWarning;
    $scope.confirmation = false;
    initialiazeTrainee(trainee);
    function initialiazeTrainee(trainee) {
      var signatureTrainee = deepCopy(trainee);
      signatureTrainee.Session.Authorized = trainee.Session.Authorized ? trainee.Session.Authorized : false;
      signatureTrainee.errorMessage = "";
      signatureTrainee.successMessage = "";
      signatureTrainee.responseText = null;
      signatureTrainee.responseHasErrors = null;
      signatureTrainee.success = false;
      signatureTrainee.isLoading = false;
      signatureTrainee.password = "";
      signatureTrainee.username = trainee.AimsId;
      signatureTrainee.PositionCode = trainee.position ? trainee.position : trainee.PositionCode;
      $scope.signatureTrainee = signatureTrainee;
    }
    function deepCopy(originalObject) {
      return JSON.parse(JSON.stringify(originalObject));
    }
    function traineeSign(signatureTrainee) {
      if (!signatureTrainee.password || !signatureTrainee.username) {
        signatureTrainee.errorMessage = "Signature is required. Please enter your username and password.";
      } else {
        signatureTrainee.isLoading = true;
        //Individually authorize trainee
        var credentials = {
          CrewId: signatureTrainee.CrewId,
          Password: signatureTrainee.password,
          Username: signatureTrainee.username,
          PositionCode: signatureTrainee.PositionCode
        };
        if ($scope.isOffline) {
          $timeout(function () {
            signatureTrainee.isLoading = false;
          }, 100);
          signatureTrainee.errorMessage = "Online mode is required in order to sign. Please connect to the internet and try again.";
        } else {
          TrainingSessionFactory.authorizeTrainee(credentials, function (responseData) {
            signatureTrainee.isLoading = false;
            signatureTrainee.success = true;
            signatureTrainee.Session.Authorized = true;
            signatureTrainee.Session.Authorized = true;
            trainee.Session.Authorized = true;
            signatureSuccess();
          })["catch"](function (data) {
            signatureTrainee.isLoading = false;
            if (data.data && data.data.errorMessage) {
              signatureTrainee.errorMessage = data.data.errorMessage;
            } else {
              signatureTrainee.errorMessage = "An error occured during your authentication";
            }
          });
        }
      }
      // clear credentials
      trainee.username = "";
      trainee.password = "";
    }

    /**
     * Close the modal
     */
    function close() {
      $uibModalInstance.close(false);
    }

    /**
     * Confirm
     */
    function confirmReset() {
      $uibModalInstance.close(true);
    }
    function continueWarning() {
      $scope.confirmation = true;
    }
  }
})();
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
(function () {
  a3_pilot_reports.directive('trainingMenu', trainingMenu);

  /**
   * @memberof PilotReports
   * @ngdoc directive
   * @name ground Course List
   * @restrict E
   * @description
   *   Initialize navigation menu panel with with status indicators
   * @example
   *   Usage:
   *   <training-menu type="ground, crewroute, flight" id="groundDutyId, flightId" ></training-menu>
   * @ngInject
   */

  function trainingMenu(CourseFactory, GroundDutyFactory, FlightFactory, CrewRouteFactory, $location, TrainingSessionFactory, FlightSessionFactory, $filter, $routeParams) {
    function link($scope, attrs) {
      $scope.gotoCourse = gotoCourse;
      $scope.hasPendingTraining = false;
      $scope.hasUnsetTraining = false;
      var groundSessions = [];
      var flightSessions = [];
      TrainingSessionFactory.getAll(function (savedGroundSessions) {
        FlightSessionFactory.getAll(function (savedFlightSessions) {
          groundSessions = savedGroundSessions;
          flightSessions = savedFlightSessions;
          $scope.courses = [];
          var duty = null;
          var dutyCourses = [];
          if ($scope.type == 'ground') {
            duty = GroundDutyFactory.getGroundDutyFromStorage($scope.id);
            $scope.duty = duty;

            // if (duty && duty.RelatedGroundDuties) {
            //     dutyCourses = GroundDutyFactory.getGroundDutyActiveCourses($scope.id);
            //     if (dutyCourses) {

            //          // Retrieve saved courses by combining CourseId and PhaseId, representing the unique identifiers for each course phase.
            //         // This ensures that courses are fetched with their associated phases.
            //         CourseFactory.getCoursesFromStorageByIds(dutyCourses.map(function(course) { return course.CourseId+"_"+course.PhaseId }), function(savedCourses) {
            //             manageGroundCourseStatuses(duty, dutyCourses, savedCourses);

            //             //Overall panel color
            //             // "Draft" courses indicate an orange border, "Pending" or "Outdated" courses a blue border, and all others green.
            //             if(savedCourses.some(x => x.Status == "Draft")){
            //                 $scope.PanelClass="border-bottom-orange";
            //             }
            //             else if(savedCourses.some(x => x.Status == "Pending" || x.Status == "Outdated")){
            //                 $scope.PanelClass="border-bottom-blue";
            //             }
            //             else{
            //                 $scope.PanelClass="border-bottom-green";
            //             }

            //             $scope.courses.concat(savedCourses);
            //         });
            //         // Fetch saved courses only by CourseId (without PhaseId), which may be used for backward compatibility.
            //         CourseFactory.getCoursesFromStorageByIds(dutyCourses.map(function(course) { return course.CourseId }), function(savedCourses) {
            //             manageGroundCourseStatuses(duty, dutyCourses, savedCourses);

            //             //Overall panel color
            //             if(savedCourses.some(x => x.Status == "Draft")){
            //                 $scope.PanelClass="border-bottom-orange";
            //             }
            //             else if(savedCourses.some(x => x.Status == "Pending" || x.Status == "Outdated")){
            //                 $scope.PanelClass="border-bottom-blue";
            //             }
            //             else{
            //                 $scope.PanelClass="border-bottom-green";
            //             }

            //             $scope.courses.concat(savedCourses);
            //         });
            //     }
            // }

            if (duty && duty.RelatedGroundDuties) {
              dutyCourses = GroundDutyFactory.getGroundDutyActiveCourses($scope.id);
              if (dutyCourses && dutyCourses.length > 0) {
                var courseIdsWithPhase = dutyCourses.filter(function (course) {
                  return course.PhaseId !== null && course.PhaseId !== undefined;
                }) // Ensure PhaseId exists
                .map(function (course) {
                  return "".concat(course.CourseId, "_").concat(course.PhaseId);
                });
                var courseIdsWithoutPhase = dutyCourses.map(function (course) {
                  return course.CourseId;
                });

                // Fetch saved courses by CourseId & PhaseId
                CourseFactory.getCoursesFromStorageByIds(courseIdsWithPhase, function (savedCoursesWithPhase) {
                  savedCoursesWithPhase = savedCoursesWithPhase || [];

                  //  Fetch saved courses only by CourseId **if there are missing phase-based courses**
                  if (savedCoursesWithPhase.length === 0) {
                    CourseFactory.getCoursesFromStorageByIds(courseIdsWithoutPhase, function (savedCoursesWithoutPhase) {
                      savedCoursesWithoutPhase = savedCoursesWithoutPhase || [];
                      var combinedCourses = [].concat(_toConsumableArray(savedCoursesWithPhase), _toConsumableArray(savedCoursesWithoutPhase)).filter(function (value, index, self) {
                        return index === self.findIndex(function (c) {
                          return c.Id === value.Id;
                        });
                      });
                      manageGroundCourseStatuses(duty, dutyCourses, combinedCourses);

                      // Assign overall panel color based on course statuses
                      if (combinedCourses.some(function (x) {
                        return x.Status === "Draft";
                      })) {
                        $scope.PanelClass = "border-bottom-orange";
                      } else if (combinedCourses.some(function (x) {
                        return x.Status === "Pending" || x.Status === "Outdated";
                      })) {
                        $scope.PanelClass = "border-bottom-blue";
                      } else {
                        $scope.PanelClass = "border-bottom-green";
                      }
                      $scope.courses = combinedCourses;
                    });
                  } else {
                    //  If phase-based courses exist, **use only them** and skip the second fetch
                    manageGroundCourseStatuses(duty, dutyCourses, savedCoursesWithPhase);

                    // Assign panel color
                    if (savedCoursesWithPhase.some(function (x) {
                      return x.Status === "Draft";
                    })) {
                      $scope.PanelClass = "border-bottom-orange";
                    } else if (savedCoursesWithPhase.some(function (x) {
                      return x.Status === "Pending" || x.Status === "Outdated";
                    })) {
                      $scope.PanelClass = "border-bottom-blue";
                    } else {
                      $scope.PanelClass = "border-bottom-green";
                    }
                    $scope.courses = savedCoursesWithPhase;
                  }
                });
              }
            }
          } else if ($scope.type == 'crewroute' || $scope.type == 'flight') {
            if ($scope.type == 'crewroute') {
              duty = CrewRouteFactory.getCrewRouteFromStorage($scope.dutyNo, $scope.dutyDay);
            } else {
              duty = FlightFactory.getFlightFromTotalFlights($scope.id);
            }
            if (duty && duty.Courses) {
              dutyCourses = duty.Courses;

              // Retrieve courses using CourseId and optionally PhaseId (if present) for composite matching
              var courseIds = dutyCourses.map(function (course) {
                return course.PhaseId ? "".concat(course.CourseId, "_").concat(course.PhaseId) : course.CourseId;
              });
              CourseFactory.getCoursesFromStorageByIds(courseIds, function (savedCourses) {
                dutyCourses.forEach(function (dutyCourse) {
                  // Determine the saved course by matching on both CourseId and PhaseId, if PhaseId exists
                  var savedCourse = savedCourses.find(function (x) {
                    return x.Id === (dutyCourse.PhaseId ? "".concat(dutyCourse.CourseId, "_").concat(dutyCourse.PhaseId) : dutyCourse.CourseId);
                  });
                  if (savedCourse) {
                    // Build the course object with available details, handling cases without PhaseId
                    var course = {
                      Id: savedCourse.Id,
                      Title: savedCourse.Title,
                      Day: new moment(dutyCourse.Date)
                    };

                    // Include Phase details if they exist
                    if (savedCourse.PhaseId) {
                      var _savedCourse$CrewCour;
                      course.PhaseId = savedCourse.PhaseId;
                      course.PhaseTitle = savedCourse.PhaseTitle || ((_savedCourse$CrewCour = savedCourse.CrewCoursePhases.find(function (x) {
                        return x.PhaseId === savedCourse.PhaseId;
                      })) === null || _savedCourse$CrewCour === void 0 ? void 0 : _savedCourse$CrewCour.Title);
                    }
                    manageFlightCourseStatus(course, dutyCourse); // Update course status
                    $scope.courses.push(course); // Add to courses list
                  }
                });

                // Format date properties and detect multi-day courses
                $scope.courses.forEach(function (course) {
                  course.FullDate = course.Day.format("YYYY-MM-DD");
                  course.Day = course.Day.format("DD/MM");

                  // Check for multi-day courses, grouping by Id and PhaseId if PhaseId exists
                  if ($scope.courses.filter(function (x) {
                    return x.Id == course.Id && (!x.PhaseId || x.PhaseId == course.PhaseId);
                  }).length > 1) {
                    course.IsMultiday = true;
                  }
                });

                // Set overall panel color based on course statuses
                setPanelClassBasedOnStatus($scope.courses);
              });
            }
          }
        });
      });

      // Function to determine and set panel color class based on course statuses
      function setPanelClassBasedOnStatus(courses) {
        if (courses.some(function (x) {
          return x.Status == "Draft";
        })) {
          $scope.PanelClass = "border-bottom-orange";
        } else if (courses.some(function (x) {
          return x.Status == "Pending" || x.Status == "Outdated";
        })) {
          $scope.PanelClass = "border-bottom-blue";
        } else {
          $scope.PanelClass = "border-bottom-green";
        }
      }
      function manageFlightCourseStatus(course, crewRouteCourse) {
        var now = moment.utc();
        var flights = FlightFactory.getFlightsFromStorage().filter(function (x) {
          return crewRouteCourse.TrainingFlightIds.includes(x.FlightId);
        });
        flights = $filter('orderBy')(flights, 'ScheduledArrival');
        var dutyEnd = flights[flights.length - 1].ScheduledArrival;
        var dutyDate = new moment(crewRouteCourse.Date).format("YYYY-MM-DD");
        var status = "";
        if (crewRouteCourse.Status == "Pending") {
          //Pending
          course.Status = "Pending";
          course.StatusClass = "text-blue";
          course.StatusDesc = "pending";

          //Outdated
          dutyEnd = moment.utc(dutyEnd);
          var duration = moment.duration(now.diff(dutyEnd)).asHours();
          if (duration > 1) {
            course.Status = "Outdated";
          }

          //Draft
          if (flightSessions && flightSessions.length) {
            if (crewRouteCourse.PhaseId) {
              flightSessions.forEach(function (session) {
                // Parse the numeric part of courseId before the underscore
                if (typeof session.courseId === 'string' && session.courseId.split('_').length > 1) {
                  session.courseId = parseInt(session.courseId.split('_')[0], 10);
                } else {
                  // Handle cases where courseId doesn't have an underscore
                  session.courseId = parseInt(session.courseId, 10);
                }
              });
            }
            var existingSession = flightSessions.find(function (s) {
              return s.courseId == crewRouteCourse.CourseId && s.day == dutyDate && s.dutyDay == $scope.dutyDay && s.dutyNo == $scope.dutyNo;
            });
            if (existingSession && !existingSession.HasLimitedInfo && existingSession.trainees && existingSession.trainees.length) {
              //a training session with trainees exists
              course.Status = "Draft";
              course.StatusClass = "text-orange";
              course.StatusDesc = "draft";
            }
          }
        } else if (crewRouteCourse.Status == "Completed") {
          //Completed
          course.Status = "Completed";
          course.StatusClass = "text-green";
          course.StatusDesc = "synced";
        }
        return status;
      }
      function manageGroundCourseStatuses(duty, dutyCourses, courses) {
        var now = moment.utc();
        courses.forEach(function (course) {
          if (typeof course.Id === 'string' && course.Id.split('_').length > 1) {
            course.Id = parseInt(course.Id.split('_')[0], 10);
          } else {
            // Handle cases where courseId doesn't have an underscore
            course.Id = parseInt(course.Id, 10);
          }
          var dutyCourse = dutyCourses.find(function (x) {
            return x.CourseId == course.Id;
          });
          course.Status = dutyCourse.Status;

          /*Statuses
          	Completed : session has been sent
          	Outdated  :	session submission is overdue
          	Draft	  : session completion has started but not submitted
          	Pending   : session submission not yet due
          */

          if (course.Status == "Pending") {
            course.StatusClass = "text-blue";
            course.StatusDesc = "pending";

            //Outdated
            var dutyEnd = moment.utc(duty.DutyEnd);
            var duration = moment.duration(now.diff(dutyEnd)).asHours();
            if (duration > 1) {
              course.Status = "Outdated";
            }

            //Draft
            // if (groundSessions && groundSessions.length) {
            //     var existingSession = groundSessions.find(s => s.courseId == course.Id && s.day == duty.DutyDateS && s.dutyId == duty.Id);
            //     if (existingSession && !existingSession.HasLimitedInfo && existingSession.trainees && existingSession.trainees.length) {
            //         //a training session with trainees exists
            //         course.Status = "Draft"
            //         course.StatusClass = "text-orange";
            //         course.StatusDesc = "draft";
            //     }
            // }
            if (groundSessions && groundSessions.length) {
              if (dutyCourse.PhaseId) {
                groundSessions.forEach(function (session) {
                  // Ensure courseId is parsed correctly
                  if (typeof session.courseId === 'string' && session.courseId.split('_').length > 1) {
                    session.courseId = parseInt(session.courseId.split('_')[0], 10);
                  } else {
                    session.courseId = parseInt(session.courseId, 10);
                  }
                });
              }
              var existingSession = groundSessions.find(function (s) {
                return s.courseId == course.Id && s.day == duty.DutyDateS && s.dutyId == duty.Id;
              });
              if (existingSession && !existingSession.HasLimitedInfo && existingSession.trainees && existingSession.trainees.length) {
                course.Status = "Draft";
                course.StatusClass = "text-orange";
                course.StatusDesc = "draft";
              }
            }
          } else if (course.Status == "Completed") {
            //Completed
            course.Status = "Completed";
            course.StatusClass = "text-green";
            course.StatusDesc = "synced";
          }
        });
      }

      /**
       * Redirect to Course Session
       */
      // function gotoCourse(course) {
      //     if($scope.type=="ground"){
      //         $location.path('/groundcourse/' + course.Id + '/' + $scope.duty.Id + "/" + $scope.duty.DutyDateS);
      //     }
      //     else if($scope.type=="crewroute"){
      //         $location.path('/flightcourse/' + course.Id + '/' + $scope.dutyNo + '/' + $scope.dutyDay + '/' + course.FullDate);
      //     }
      //     else if($scope.type=="flight"){
      //         $location.path('/flightcourse/' + course.Id + '/' + $scope.dutyNo + '/' + $scope.dutyDay + '/' + course.FullDate + '/' + Number($routeParams.flightId) + '/' + course.PhaseId);
      //     }
      // }         

      function gotoCourse(course) {
        if ($scope.type === "ground") {
          // if (course.PhaseId != null && course.PhaseId != undefined) {
          //     course.Id = `${course.CourseId}_${course.PhaseId}`; // Combine CourseId & PhaseId
          // } 

          if (course.PhaseId != null && course.PhaseId != undefined) {
            var _course$CourseId;
            course.Id = "".concat((_course$CourseId = course.CourseId) !== null && _course$CourseId !== void 0 ? _course$CourseId : course.Id, "_").concat(course.PhaseId);
          } else {
            var _course$CourseId2;
            course.Id = (_course$CourseId2 = course.CourseId) !== null && _course$CourseId2 !== void 0 ? _course$CourseId2 : course.Id;
          }
          var path = '/groundcourse/' + course.Id + '/' + $scope.duty.Id + '/' + $scope.duty.DutyDateS;
          // Append phaseId if it exists
          if (course.PhaseId) {
            path += '/' + course.PhaseId;
          }
          $location.path(path);
        } else if ($scope.type === "crewroute") {
          $location.path('/flightcourse/' + course.Id + '/' + $scope.dutyNo + '/' + $scope.dutyDay + '/' + course.FullDate);
        } else if ($scope.type === "flight") {
          var path = '/flightcourse/' + course.Id + '/' + $scope.dutyNo + '/' + $scope.dutyDay + '/' + course.FullDate + '/' + Number($routeParams.flightId);

          // Append phaseId if it exists
          if (course.PhaseId) {
            path += '/' + course.PhaseId;
          }
          $location.path(path);
        }
      }
    }
    return {
      restrict: 'E',
      templateUrl: "views/Training/training-menu.tpl.html",
      scope: {
        type: '@',
        id: '=',
        dutyNo: '=',
        dutyDay: '='
      },
      terminal: true,
      link: link
    };
  }
})();
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
(function () {
  'use strict';

  a3_pilot_reports.factory('TrainingSessionFactory', TrainingSessionFactory);

  /**
   * @memberof PilotReports
   * @ngdoc factory
   * @name TrainingSessionFactory
   * @description 
   *   Add, Update, Delete and Get Training Courses.
   * @ngInject
   */
  function TrainingSessionFactory(IndexedDBService, CourseFactory, $http, apiUrl, GroundDutyFactory, $filter) {
    /**
     * Initialize Session
     * @memberof TrainingSessionFactory
     */
    function Session() {
      this.Id = null;
    }
    var objType = 'TrainingSessions';
    var objCallback = Session;
    var service = {
      getAll: getAll,
      getSession: getSession,
      setSession: setSession,
      updateSession: updateSession,
      getSessionTrainees: getSessionTrainees,
      submitSession: submitSession,
      remove: remove,
      authorizeTrainee: authorizeTrainee,
      getDutySessions: getDutySessions,
      applyTraineeInfoToSession: applyTraineeInfoToSession,
      releaseSession: releaseSession,
      createFlatHistorySullabusItem: createFlatHistorySullabusItem
    };

    /**
     * Get all ground training sessions
     * @memberof TrainingSessionFactory
     * @param {function} callback  
     */
    function getAll(callback) {
      IndexedDBService.getAll(objType).then(function (results) {
        callback(results);
      });
    }
    ;

    /**
     * Get session By day and courseId
     * @memberof TrainingSessionFactory
     * @param {function} callback  
     */
    function getSession(courseId, day, dutyId, afterRefresh, callback, errorCallback) {
      IndexedDBService.getById(objType, [day, courseId, dutyId]).then(function (session) {
        CourseFactory.getCourseFromStorage(courseId, function (course) {
          if (course && !course.HasLimitedInfo && course.CrewCoursePhases && course.CourseTrainees) {
            mergeCourseWithSession(course, session, dutyId, afterRefresh);
          }
          callback(course);
        }, errorCallback);
      })["catch"](errorCallback);
    }
    function applyTraineeInfoToSession(course, courseId, day, dutyId, callback, errorCallback) {
      IndexedDBService.getById(objType, [day, courseId, dutyId]).then(function (localSession) {
        var isNewSession = false;
        if (!localSession) {
          localSession = {
            courseId: courseId,
            day: day,
            dutyId: dutyId,
            trainees: [],
            TraineeEligibilty: course.TraineeEligibilty,
            CourseTrainees: course.CourseTrainees
          };
          isNewSession = true;
        } else {
          localSession.TraineeEligibilty = course.TraineeEligibilty;
          localSession.CourseTrainees = course.CourseTrainees;
        }
        if (isNewSession) {
          addSessionToStorage(localSession).then(callback)["catch"](errorCallback);
        } else {
          saveSessionToStorage(localSession).then(callback)["catch"](errorCallback);
        }
      })["catch"](errorCallback);
    }
    function getDutySessions(day, dutyId, callback) {
      IndexedDBService.getAll(objType).then(function (results) {
        results = results.filter(function (x) {
          return x.day == day && x.dutyId == dutyId;
        });
        callback(results);
      });
    }

    /**
     * Remove session By day,dutyID (Optional) and courseId
     * @memberof TrainingSessionFactory
     * @param {function} callback  
     */
    function remove(courseId, day, dutyId, callback, errorCallback) {
      IndexedDBService.remove(objType, [day, courseId, dutyId]).then(callback)["catch"](errorCallback);
    }
    ;

    /**
     * Get session Trainees By day and courseId
     * @memberof TrainingSessionFactory
     * @param {function} callback  
     */
    function getSessionTrainees(courseId, day, dutyId, callback, errorCallback) {
      IndexedDBService.getById(objType, [day, courseId, dutyId]).then(function (session) {
        var trainees = session && session.trainees ? session.trainees : [];
        callback(trainees);
      })["catch"](errorCallback);
    }
    ;

    /**
     * Set session
     * @memberof TrainingSessionFactory
     * @param {function} callback  
     */
    function setSession(session, callback, errorCallback) {
      IndexedDBService.getById(objType, [session.day, session.courseId, session.dutyId]).then(function (result) {
        if (result) {
          saveSessionToStorage(session).then(callback)["catch"](errorCallback);
          ;
        } else {
          addSessionToStorage(session).then(callback)["catch"](errorCallback);
        }
      })["catch"](errorCallback);
    }
    ;

    /**
     * Set session
     * @memberof TrainingSessionFactory
     * @param {function} callback  
     */
    function updateSession(trainees, session, courseId, day, dutyId, callback, errorCallback) {
      IndexedDBService.getById(objType, [day, courseId, dutyId]).then(function (localSession) {
        var isNewSession = false;
        if (!localSession) {
          localSession = {
            courseId: courseId,
            day: day,
            dutyId: dutyId,
            trainees: []
          };
          isNewSession = true;
        } else {
          localSession.trainees = [];
        }
        if (session) {
          localSession.Media = session.Media;
          localSession.ReleasedPhase = session.ReleasedPhase;
          localSession.TraineeEligibilty = session.TraineeEligibilty;
        }
        trainees.forEach(function (trainee) {
          localSession.trainees.push(trainee);
        });
        if (isNewSession) {
          addSessionToStorage(localSession).then(callback)["catch"](errorCallback);
        } else {
          saveSessionToStorage(localSession).then(callback)["catch"](errorCallback);
        }
      })["catch"](errorCallback);
    }
    function mergeCourseWithSession(course, session, dutyId, afterRefresh) {
      course.HasLimitedSession = session == undefined;
      var hasPreviousSessions = mergeSyllabusWithHistory(course.CourseTrainees, course.CrewCoursePhases);
      filterTraineesByEligibility(dutyId, course, session, afterRefresh);
      course.CrewCoursePhases.forEach(function (phase) {
        calculatePhaseStatus(phase, course);
      });
      course.selectedPhase = getSelectedPhase(course);

      // Calculate eligible trainees phase status
      course.CourseTrainees.forEach(function (trainee) {
        var traineePhase = trainee.Phases.find(function (x) {
          return x.PhaseId == course.selectedPhase.PhaseId;
        });
        if (traineePhase) {
          trainee.ActivePhaseStatus = traineePhase.PhaseStatus;
        } else {
          trainee.ActivePhaseStatus = "Pending";
        }
        trainee.Selectable = trainee.ActivePhaseStatus == "InProgress";
      });

      //Filter By Role: Filter out trainees that have a flight crew role
      if (course.selectedPhase.FilterByRole) {
        course.CourseTrainees.filter(function (x) {
          return x.Selectable && x.PositionCode != 'CP' && x.PositionCode != 'FO';
        }).forEach(function (flightCrewTrainee) {
          flightCrewTrainee.EligibilityStatus = false;
          flightCrewTrainee.EligibilityDesc = "InvalidRole";
          course.NonEligibleTrainees.push(flightCrewTrainee);
        });
      }

      // Non InProgress trainees will be marked as NonEligible (remove further ahead trainees on multiple InProgress phases)
      course.CourseTrainees.filter(function (x) {
        return !x.Selectable;
      }).forEach(function (invalidPhaseTrainee) {
        invalidPhaseTrainee.EligibilityStatus = false;
        invalidPhaseTrainee.EligibilityDesc = "AlreadySubmitted";
        course.NonEligibleTrainees.push(invalidPhaseTrainee);
      });
      course.CourseTrainees = course.CourseTrainees.filter(function (x) {
        return x.EligibilityStatus;
      });

      // Get trainee sessions
      course.CourseTrainees.forEach(function (trainee) {
        var sessionTrainee = session ? session.trainees.find(function (x) {
          return x.CrewId == trainee.CrewId;
        }) : null;
        if (sessionTrainee) {
          trainee.Session = sessionTrainee.Session;
        } else {
          trainee.Session = {
            Released: course.selectedPhase.ModuleType == "Training" ? false : true,
            CrewId: trainee.CrewId,
            Items: [],
            Absent: false,
            DayGrading: {
              Comments: null,
              Grade: null,
              Competences: []
            },
            ReleaseGrading: {
              Comments: null,
              Grade: null,
              Competences: []
            },
            NeedsAdditionalTraining: false,
            AdditionalTrainingRemarks: null,
            CompleteAdditionalTraining: false
          };
        }
      });

      /*  Set default values for release option
          Training Modules: 'No' release as default
          Check Module: 'Yes' release as default
      */
      course.ReleasedPhase = course.selectedPhase.ModuleType == "Training" ? false : true;
      if (session) {
        course.Media = session.Media;
        course.ReleasedPhase = session.ReleasedPhase;
        course.TraineeEligibilty = session.TraineeEligibilty;
      }
    }
    function getSelectedPhase(course) {
      var hasSelectedPhase = false;
      var phases = course.CrewCoursePhases;
      phases.forEach(function (phase, index, array) {
        phase.isFirst = index == 0;
        phase.isLast = index + 1 == array.length;
        // Select the first InProgress & selected phase
        if (!hasSelectedPhase && phase.Status == "InProgress" && phase.isSelected) {
          phase.Selected = true;
          hasSelectedPhase = true;
        }
      });

      // Select the first InProgress phase
      if (!hasSelectedPhase && phases.some(function (x) {
        return x.Status == "InProgress";
      })) {
        phases.find(function (x) {
          return x.Status == "InProgress";
        }).Selected = true;
        hasSelectedPhase = true;
      }
      if (!hasSelectedPhase) {
        phases.find(function (x) {
          return x.isFirst;
        }).Selected = true;
      }
      var selectedPhase = phases.find(function (x) {
        return x.Selected;
      });
      return selectedPhase;
    }
    function filterTraineesByEligibility(dutyId, course, session, afterRefresh) {
      var _course$CourseTrainee;
      var groundDuty = GroundDutyFactory.getGroundDutyFromStorage(dutyId);
      // Trainee Eligiblity cases
      // 1. After refresh - Save newly fetched eligibility in session
      // 2. No refresh & Session exists - Get last fetched eligibility from session
      // 3. No refresh & No session exists - Rely on previously fetched eligibility (different duty - same course)

      var traineeEligibility = course.TraineeEligibilty;
      if (!afterRefresh && session && session.TraineeEligibilty) {
        traineeEligibility = session.TraineeEligibilty;
      }
      if (session) session.TraineeEligibilty = traineeEligibility; //update session eligibility

      // Get ground duty trainees without any training records
      var trainees = getGroundCourseTrainees(groundDuty, course.Id);
      var inactiveTrainees = trainees.filter(function (x) {
        return !course.CourseTrainees.some(function (z) {
          return z.CrewId == x.CrewId;
        });
      });

      //Exclude Non valid trainees
      var eligibleTraineeIds = Object.keys(traineeEligibility).filter(function (x) {
        return traineeEligibility[x] == "NotStarted" || traineeEligibility[x] == "ValidPhase" || traineeEligibility[x] == "FailedCertificate";
      }).map(Number);
      var eligibleTrainees = inactiveTrainees.filter(function (x) {
        return eligibleTraineeIds.includes(x.CrewId);
      });
      eligibleTrainees.forEach(function (trainee) {
        trainee.EligibilityStatus = true;
      });
      createNewPhaseTrainees(groundDuty, course, eligibleTrainees);

      // Merge eligibleTrainees (inactive) with CourseTrainees (eligible & active)
      course.CourseTrainees.forEach(function (trainee) {
        trainee.EligibilityStatus = true;
      });
      (_course$CourseTrainee = course.CourseTrainees).push.apply(_course$CourseTrainee, _toConsumableArray(eligibleTrainees));

      // Non eligible trainees
      var nonEligibleTrainees = inactiveTrainees.filter(function (x) {
        return !eligibleTraineeIds.includes(x.CrewId);
      });
      course.NonEligibleTrainees = nonEligibleTrainees;
      nonEligibleTrainees.forEach(function (trainee) {
        trainee.EligibilityStatus = false;
        trainee.EligibilityDesc = traineeEligibility[trainee.CrewId];
      });

      // Result:
      // CourseTrainees = eligible trainees (active or new)
      // Non EligibleTrainees
    }

    /**
     * Create first phase foreach trainee
     * @param {object} groundDuty 
     * @param {object} course 
     * @param {array} trainees Eligible trainees that haven't yet started training
     */
    function createNewPhaseTrainees(groundDuty, course, trainees) {
      //Match GroundDutyNos with PhaseDutyNos
      var crewCoursePhaseDutyNos = [];
      var groundDutyTraineeDutyNos = [];
      course.CrewCoursePhases.forEach(function (coursePhase) {
        crewCoursePhaseDutyNos = crewCoursePhaseDutyNos.concat(coursePhase.GroundDutyCodes);
      });
      groundDuty.Trainees.forEach(function (relatedDuty) {
        groundDutyTraineeDutyNos.push(relatedDuty.GroundDutyNo.toString());
      });
      var relatedDutyNos = crewCoursePhaseDutyNos.filter(function (x) {
        return groundDutyTraineeDutyNos.includes(x);
      });
      var relatedPhases = course.CrewCoursePhases.filter(function (x) {
        return x.GroundDutyCodes.some(function (gdc) {
          return relatedDutyNos.includes(gdc);
        });
      });

      //From related phases, select first in order
      relatedPhases = $filter('orderBy')(relatedPhases, 'OrderNo');
      var firstPhase = relatedPhases[0];
      trainees.forEach(function (trainee) {
        trainee.Phases = [{
          PhaseId: firstPhase.PhaseId,
          PhaseStatus: "InProgress",
          RepeatRequestedItems: [],
          isSelected: true //selectedPhase
        }];
      });
    }

    function getGroundCourseTrainees(groundDuty, courseId) {
      var trainees = [];
      groundDuty.RelatedGroundDuties.filter(function (x) {
        return x.Courses && x.Courses.map(function (course) {
          return course.CourseId;
        }).includes(courseId);
      }).forEach(function (item) {
        item.CrewMembers.forEach(function (crewMember) {
          var trainee = {
            AimsId: crewMember.AIMS_ID,
            CrewId: crewMember.Id,
            Name: crewMember.Name,
            PositionCode: crewMember.PositionCode
          };
          trainees.push(trainee);
        });
      });
      return trainees;
    }
    function calculatePhaseStatus(phase, course) {
      course.CourseTrainees.forEach(function (trainee) {
        var traineePhase = trainee.Phases.find(function (x) {
          return x.PhaseId == phase.PhaseId;
        });
        if (traineePhase && traineePhase.PhaseStatus == "InProgress") {
          phase.Status = "InProgress";
        } else if (!traineePhase && phase.Status != "InProgress") {
          phase.Status = "Pending";
        } else if (traineePhase && traineePhase.PhaseStatus == "Completed" && phase.Status != "InProgress") {
          phase.Status = "Completed";
        }
        //Selected phase, If at least one trainee has it selected
        if (traineePhase && !phase.isSelected) {
          phase.isSelected = traineePhase.isSelected;
        }
      });
    }
    function mergeSyllabusWithHistory(trainees, phases) {
      var flatSullabusItems = [];
      trainees.forEach(function (trainee) {
        trainee.Phases.forEach(function (phase) {
          phase.Sessions.forEach(function (session) {
            session.Items.forEach(function (item) {
              var flatItem = createFlatHistorySullabusItem(trainee, phase, session, item);
              flatSullabusItems.push(flatItem);
            });
          });
        });
      });
      phases.filter(function (x) {
        return x.Syllabus;
      }).forEach(function (phase, index, array) {
        phase.Syllabus.SyllabusItems.forEach(function (syllabusItem) {
          syllabusItem.History = flatSullabusItems.filter(function (item) {
            return item.ItemId == syllabusItem.Id;
          });
        });
      });
      var hasPreviousSessions = flatSullabusItems.length > 0;
      return hasPreviousSessions;
    }
    function createFlatHistorySullabusItem(trainee, phase, session, item) {
      var flatItem = {
        CrewId: trainee.CrewId,
        PhaseId: phase.PhaseId,
        SessionId: session.SessionId,
        SessionComments: session.SessionComments,
        SubmissionDate: item.SubmissionDate,
        RepeatRequired: item.RepeatRequired,
        Tries: item.Tries,
        ItemId: item.SyllabusItemId,
        Grade: session.Grade,
        GradeType: session.GradeType,
        InstructorName: session.InstructorName,
        InstructorAimsId: session.InstructorAimsId
      };
      return flatItem;
    }

    /**
     * Add Session to Storage
     * @memberof TrainingSessionFactory
     * @param {object} Session
     */
    function addSessionToStorage(session) {
      return IndexedDBService.add(objType, session);
    }
    ;

    /**
     * Update Session to Storage
     * @memberof TrainingSessionFactory
     * @param {object} Session
     */
    function saveSessionToStorage(session) {
      return IndexedDBService.put(objType, session);
    }
    ;
    function submitSession(submittedSession, callback) {
      var traingingApiURL = apiUrl + '/Training/SubmitTraining';
      return $http.post(traingingApiURL, submittedSession, {
        'Content-Type': 'application/json'
      }).then(callback);
    }

    /**
     * Authorize Trainee for submission
     * @param {string} credentials Trainee's password, username, crewId, position
     * @param {function} callback 
     * @param {function} errorCallback 
     */
    function authorizeTrainee(credentials, callback, errorCallback) {
      return $http.post(apiUrl + '/Training/AuthorizeTrainee', credentials, {
        'Content-Type': 'application/json'
      }).then(callback)["catch"](errorCallback);
    }
    function releaseSession(submittedSessions, callback, errorCallback) {
      var traingingApiURL = apiUrl + '/Training/ReleaseSession';
      return $http.post(traingingApiURL, submittedSessions, {
        'Content-Type': 'application/json'
      }).then(callback)["catch"](errorCallback);
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  a3_pilot_reports.directive('reportItems', reportItems);

  /**
  * @memberof PilotReports
  * @ngdoc directive
  * @name reportItems
  * @restrict EA
  * @description
  *   Implementation of items
  *
  *   Initialize the telplate items for the pilot report form according to their type
  * @attr {String} type The name of the type to initialize the according Issue template.
  * @example
  *   Usage:
  *   <div report-items type="acuProvision"></div>
  * @ngInject
  */
  function reportItems() {
    function _templateUrl(type) {
      var template = 'views/Report/empty.html';
      if (type == 'acuProvision') {
        template = 'views/Report/acuProvision.tpl.html';
      }
      // else if(type=='somethingElse'){
      // 	template='views/Report/somethingElse.tpl.html';
      // }
      // ...
      return template;
    }
    return {
      restrict: 'EA',
      terminal: false,
      templateUrl: function templateUrl(element, attrs) {
        return _templateUrl(attrs.type);
      },
      scope: false
    };
  }
})();